import * as a$z from "react";
import a__default, { createElement, useMemo, useEffect, useLayoutEffect, useRef, useState, forwardRef, Fragment, isValidElement, cloneElement, useCallback, useContext, createContext, useReducer, createRef, useImperativeHandle, Children } from "react";
import * as ReactDOM from "react-dom";
import { createPortal } from "react-dom";
import { Link as Link$1, useLocation } from "react-router-dom";
import { get as get$1, useWatch, useFormState, useController, useFormContext } from "react-hook-form";
import * as yup from "yup";
import { object, string as string$2, array } from "yup";
import { parseISO, isValid, format, subYears } from "date-fns";
const rem = (px2) => `${px2 / 16}rem`;
const remPair = (px2, prefix = "") => ({ [`${prefix}${px2}`]: rem(px2) });
const px = (px2) => `${px2}px`;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      if (this instanceof a3) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var colors$2 = {};
var log = {};
var picocolors_browser = { exports: {} };
var x$5 = String;
var create$2 = function() {
  return { isColorSupported: false, reset: x$5, bold: x$5, dim: x$5, italic: x$5, underline: x$5, inverse: x$5, hidden: x$5, strikethrough: x$5, black: x$5, red: x$5, green: x$5, yellow: x$5, blue: x$5, magenta: x$5, cyan: x$5, white: x$5, gray: x$5, bgBlack: x$5, bgRed: x$5, bgGreen: x$5, bgYellow: x$5, bgBlue: x$5, bgMagenta: x$5, bgCyan: x$5, bgWhite: x$5 };
};
picocolors_browser.exports = create$2();
picocolors_browser.exports.createColors = create$2;
var picocolors_browserExports = picocolors_browser.exports;
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  function _export(target, all2) {
    for (var name in all2) Object.defineProperty(target, name, {
      enumerable: true,
      get: all2[name]
    });
  }
  _export(exports2, {
    dim: function() {
      return dim;
    },
    default: function() {
      return _default;
    }
  });
  const _picocolors = /* @__PURE__ */ _interop_require_default(picocolors_browserExports);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  let alreadyShown = /* @__PURE__ */ new Set();
  function log2(type, messages, key) {
    if (typeof process !== "undefined" && process.env.JEST_WORKER_ID) return;
    if (key && alreadyShown.has(key)) return;
    if (key) alreadyShown.add(key);
    console.warn("");
    messages.forEach((message2) => console.warn(type, "-", message2));
  }
  function dim(input) {
    return _picocolors.default.dim(input);
  }
  const _default = {
    info(key, messages) {
      log2(_picocolors.default.bold(_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
        key
      ] : [
        messages,
        key
      ]);
    },
    warn(key, messages) {
      log2(_picocolors.default.bold(_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
        key
      ] : [
        messages,
        key
      ]);
    },
    risk(key, messages) {
      log2(_picocolors.default.bold(_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
        key
      ] : [
        messages,
        key
      ]);
    }
  };
})(log);
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  Object.defineProperty(exports2, "default", {
    enumerable: true,
    get: function() {
      return _default;
    }
  });
  const _log = /* @__PURE__ */ _interop_require_default(log);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function warn({ version, from, to }) {
    _log.default.warn(`${from}-color-renamed`, [
      `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const _default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      warn({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      });
      return this.sky;
    },
    get warmGray() {
      warn({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      });
      return this.stone;
    },
    get trueGray() {
      warn({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      });
      return this.neutral;
    },
    get coolGray() {
      warn({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      });
      return this.gray;
    },
    get blueGray() {
      warn({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      });
      return this.slate;
    }
  };
})(colors$2);
let colors = colors$2;
var colors_1 = (colors.__esModule ? colors : { default: colors }).default;
const colors$1 = /* @__PURE__ */ getDefaultExportFromCjs(colors_1);
var createPlugin$2 = {};
var createPlugin$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  Object.defineProperty(exports2, "default", {
    enumerable: true,
    get: function() {
      return _default;
    }
  });
  function createPlugin2(plugin2, config2) {
    return {
      handler: plugin2,
      config: config2
    };
  }
  createPlugin2.withOptions = function(pluginFunction, configFunction = () => ({})) {
    const optionsFunction = function(options) {
      return {
        __options: options,
        handler: pluginFunction(options),
        config: configFunction(options)
      };
    };
    optionsFunction.__isOptionsFunction = true;
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
  };
  const _default = createPlugin2;
})(createPlugin$1);
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  Object.defineProperty(exports2, "default", {
    enumerable: true,
    get: function() {
      return _default;
    }
  });
  const _createPlugin = /* @__PURE__ */ _interop_require_default(createPlugin$1);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  const _default = _createPlugin.default;
})(createPlugin$2);
let createPlugin = createPlugin$2;
var plugin = (createPlugin.__esModule ? createPlugin : { default: createPlugin }).default;
const plugin$1 = /* @__PURE__ */ getDefaultExportFromCjs(plugin);
var o$f = plugin$1.withOptions(({ prefix: s2 = "ui" } = {}) => ({ addVariant: t2 }) => {
  for (let e3 of ["open", "checked", "selected", "active", "disabled"]) t2(`${s2}-${e3}`, [`&[data-headlessui-state~="${e3}"]`, `:where([data-headlessui-state~="${e3}"]) &`]), t2(`${s2}-not-${e3}`, [`&[data-headlessui-state]:not([data-headlessui-state~="${e3}"])`, `:where([data-headlessui-state]:not([data-headlessui-state~="${e3}"])) &:not([data-headlessui-state])`]);
  t2(`${s2}-focus-visible`, ":where([data-headlessui-focus-visible]) &:focus"), t2(`${s2}-not-focus-visible`, "&:focus:where(:not([data-headlessui-focus-visible] &))");
});
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root.Symbol;
var objectProto$g = Object.prototype;
var hasOwnProperty$f = objectProto$g.hasOwnProperty;
var nativeObjectToString$1 = objectProto$g.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$f.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$f = Object.prototype;
var nativeObjectToString = objectProto$f.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$3;
}
function arrayMap(array2, iteratee) {
  var index2 = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var isArray$1 = Array.isArray;
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$1(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
function identity$2(value) {
  return value;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$e = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$e = objectProto$e.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$e).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var WeakMap$1 = getNative(root, "WeakMap");
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
  function object2() {
  }
  return function(proto2) {
    if (!isObject(proto2)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto2);
    }
    object2.prototype = proto2;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function noop$1() {
}
function copyArray(source, array2) {
  var index2 = -1, length = source.length;
  array2 || (array2 = Array(length));
  while (++index2 < length) {
    array2[index2] = source[index2];
  }
  return array2;
}
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count2 = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count2 >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count2 = 0;
    }
    return func.apply(void 0, arguments);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var defineProperty$1 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e3) {
  }
}();
var baseSetToString = !defineProperty$1 ? identity$2 : function(func, string2) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string2),
    "writable": true
  });
};
var setToString = shortOut(baseSetToString);
function arrayEach(array2, iteratee) {
  var index2 = -1, length = array2 == null ? 0 : array2.length;
  while (++index2 < length) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
function baseAssignValue(object2, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var objectProto$d = Object.prototype;
var hasOwnProperty$d = objectProto$d.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$d.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length = props.length;
  while (++index2 < length) {
    var key = props[index2];
    var newValue = void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
var nativeMax = Math.max;
function overRest(func, start, transform) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array2 = Array(length);
    while (++index2 < length) {
      array2[index2] = args[start + index2];
    }
    index2 = -1;
    var otherArgs = Array(start + 1);
    while (++index2 < start) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start] = transform(array2);
    return apply(func, this, otherArgs);
  };
}
function baseRest(func, start) {
  return setToString(overRest(func, start, identity$2), func + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$1(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}
function isIterateeCall(value, index2, object2) {
  if (!isObject(object2)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) {
    return eq(object2[index2], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object2, sources) {
    var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object2 = Object(object2);
    while (++index2 < length) {
      var source = sources[index2];
      if (source) {
        assigner(object2, source, index2, customizer);
      }
    }
    return object2;
  });
}
var objectProto$c = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$c;
  return value === proto2;
}
function baseTimes(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$b = Object.prototype;
var hasOwnProperty$c = objectProto$b.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$c.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer$1 = nativeIsBuffer || stubFalse;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$6 = "[object Map]", numberTag$4 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$6 = "[object Set]", stringTag$4 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$4] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = function() {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e3) {
  }
}();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$a = Object.prototype;
var hasOwnProperty$b = objectProto$a.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$b.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$9 = Object.prototype;
var hasOwnProperty$a = objectProto$9.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$a.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys$1(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$8 = Object.prototype;
var hasOwnProperty$9 = objectProto$8.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$9.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object2) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$7 = Object.prototype;
var hasOwnProperty$8 = objectProto$7.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : void 0;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$7 = objectProto$6.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$7.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array2, key) {
  var length = array2.length;
  while (length--) {
    if (eq(array2[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice$3 = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice$3.call(data, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root, "Map");
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size2 = data.size;
  data.set(key, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver2) {
  if (typeof func != "function" || resolver2 != null && typeof resolver2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName, function(match2, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
  });
  return result;
});
function toString$3(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object2) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object2) ? [value] : stringToPath(toString$3(value));
}
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function baseGet(object2, path2) {
  path2 = castPath(path2, object2);
  var index2 = 0, length = path2.length;
  while (object2 != null && index2 < length) {
    object2 = object2[toKey(path2[index2++])];
  }
  return index2 && index2 == length ? object2 : void 0;
}
function get(object2, path2, defaultValue) {
  var result = object2 == null ? void 0 : baseGet(object2, path2);
  return result === void 0 ? defaultValue : result;
}
function arrayPush(array2, values) {
  var index2 = -1, length = values.length, offset2 = array2.length;
  while (++index2 < length) {
    array2[offset2 + index2] = values[index2];
  }
  return array2;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(value) {
  return isArray$1(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function baseFlatten(array2, depth, predicate, isStrict, result) {
  var index2 = -1, length = array2.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length) {
    var value = array2[index2];
    if (predicate(value)) {
      {
        arrayPush(result, value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}
function flatten(array2) {
  var length = array2 == null ? 0 : array2.length;
  return length ? baseFlatten(array2) : [];
}
function flatRest(func) {
  return setToString(overRest(func, void 0, flatten), func + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectTag$3 = "[object Object]";
var funcProto = Function.prototype, objectProto$5 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$6 = objectProto$5.hasOwnProperty;
var objectCtorString$1 = funcToString.call(Object);
function isPlainObject$2(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto2 = getPrototype(value);
  if (proto2 === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto2, "constructor") && proto2.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString$1;
}
function baseSlice(array2, start, end) {
  var index2 = -1, length = array2.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index2 < length) {
    result[index2] = array2[index2 + start];
  }
  return result;
}
function arrayReduce(array2, iteratee, accumulator, initAccum) {
  var index2 = -1, length = array2 == null ? 0 : array2.length;
  while (++index2 < length) {
    accumulator = iteratee(accumulator, array2[index2], index2, array2);
  }
  return accumulator;
}
function basePropertyOf(object2) {
  return function(key) {
    return object2 == null ? void 0 : object2[key];
  };
}
var deburredLetters = {
  // Latin-1 Supplement block.
  "À": "A",
  "Á": "A",
  "Â": "A",
  "Ã": "A",
  "Ä": "A",
  "Å": "A",
  "à": "a",
  "á": "a",
  "â": "a",
  "ã": "a",
  "ä": "a",
  "å": "a",
  "Ç": "C",
  "ç": "c",
  "Ð": "D",
  "ð": "d",
  "È": "E",
  "É": "E",
  "Ê": "E",
  "Ë": "E",
  "è": "e",
  "é": "e",
  "ê": "e",
  "ë": "e",
  "Ì": "I",
  "Í": "I",
  "Î": "I",
  "Ï": "I",
  "ì": "i",
  "í": "i",
  "î": "i",
  "ï": "i",
  "Ñ": "N",
  "ñ": "n",
  "Ò": "O",
  "Ó": "O",
  "Ô": "O",
  "Õ": "O",
  "Ö": "O",
  "Ø": "O",
  "ò": "o",
  "ó": "o",
  "ô": "o",
  "õ": "o",
  "ö": "o",
  "ø": "o",
  "Ù": "U",
  "Ú": "U",
  "Û": "U",
  "Ü": "U",
  "ù": "u",
  "ú": "u",
  "û": "u",
  "ü": "u",
  "Ý": "Y",
  "ý": "y",
  "ÿ": "y",
  "Æ": "Ae",
  "æ": "ae",
  "Þ": "Th",
  "þ": "th",
  "ß": "ss",
  // Latin Extended-A block.
  "Ā": "A",
  "Ă": "A",
  "Ą": "A",
  "ā": "a",
  "ă": "a",
  "ą": "a",
  "Ć": "C",
  "Ĉ": "C",
  "Ċ": "C",
  "Č": "C",
  "ć": "c",
  "ĉ": "c",
  "ċ": "c",
  "č": "c",
  "Ď": "D",
  "Đ": "D",
  "ď": "d",
  "đ": "d",
  "Ē": "E",
  "Ĕ": "E",
  "Ė": "E",
  "Ę": "E",
  "Ě": "E",
  "ē": "e",
  "ĕ": "e",
  "ė": "e",
  "ę": "e",
  "ě": "e",
  "Ĝ": "G",
  "Ğ": "G",
  "Ġ": "G",
  "Ģ": "G",
  "ĝ": "g",
  "ğ": "g",
  "ġ": "g",
  "ģ": "g",
  "Ĥ": "H",
  "Ħ": "H",
  "ĥ": "h",
  "ħ": "h",
  "Ĩ": "I",
  "Ī": "I",
  "Ĭ": "I",
  "Į": "I",
  "İ": "I",
  "ĩ": "i",
  "ī": "i",
  "ĭ": "i",
  "į": "i",
  "ı": "i",
  "Ĵ": "J",
  "ĵ": "j",
  "Ķ": "K",
  "ķ": "k",
  "ĸ": "k",
  "Ĺ": "L",
  "Ļ": "L",
  "Ľ": "L",
  "Ŀ": "L",
  "Ł": "L",
  "ĺ": "l",
  "ļ": "l",
  "ľ": "l",
  "ŀ": "l",
  "ł": "l",
  "Ń": "N",
  "Ņ": "N",
  "Ň": "N",
  "Ŋ": "N",
  "ń": "n",
  "ņ": "n",
  "ň": "n",
  "ŋ": "n",
  "Ō": "O",
  "Ŏ": "O",
  "Ő": "O",
  "ō": "o",
  "ŏ": "o",
  "ő": "o",
  "Ŕ": "R",
  "Ŗ": "R",
  "Ř": "R",
  "ŕ": "r",
  "ŗ": "r",
  "ř": "r",
  "Ś": "S",
  "Ŝ": "S",
  "Ş": "S",
  "Š": "S",
  "ś": "s",
  "ŝ": "s",
  "ş": "s",
  "š": "s",
  "Ţ": "T",
  "Ť": "T",
  "Ŧ": "T",
  "ţ": "t",
  "ť": "t",
  "ŧ": "t",
  "Ũ": "U",
  "Ū": "U",
  "Ŭ": "U",
  "Ů": "U",
  "Ű": "U",
  "Ų": "U",
  "ũ": "u",
  "ū": "u",
  "ŭ": "u",
  "ů": "u",
  "ű": "u",
  "ų": "u",
  "Ŵ": "W",
  "ŵ": "w",
  "Ŷ": "Y",
  "ŷ": "y",
  "Ÿ": "Y",
  "Ź": "Z",
  "Ż": "Z",
  "Ž": "Z",
  "ź": "z",
  "ż": "z",
  "ž": "z",
  "Ĳ": "IJ",
  "ĳ": "ij",
  "Œ": "Oe",
  "œ": "oe",
  "ŉ": "'n",
  "ſ": "s"
};
var deburrLetter = basePropertyOf(deburredLetters);
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");
function deburr(string2) {
  string2 = toString$3(string2);
  return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords(string2) {
  return string2.match(reAsciiWord) || [];
}
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord(string2) {
  return reHasUnicodeWord.test(string2);
}
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['’]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords(string2) {
  return string2.match(reUnicodeWord) || [];
}
function words(string2, pattern, guard) {
  string2 = toString$3(string2);
  pattern = pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
  }
  return string2.match(pattern) || [];
}
var rsApos = "['’]";
var reApos = RegExp(rsApos, "g");
function createCompounder(callback) {
  return function(string2) {
    return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
  };
}
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
function cloneBuffer(buffer2, isDeep) {
  if (isDeep) {
    return buffer2.slice();
  }
  var length = buffer2.length, result = allocUnsafe ? allocUnsafe(length) : new buffer2.constructor(length);
  buffer2.copy(result);
  return result;
}
function arrayFilter(array2, predicate) {
  var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$4 = Object.prototype;
var propertyIsEnumerable = objectProto$4.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols$1(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
  var result = [];
  while (object2) {
    arrayPush(result, getSymbols(object2));
    object2 = getPrototype(object2);
  }
  return result;
};
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$1(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys$1, getSymbols);
}
function getAllKeysIn(object2) {
  return baseGetAllKeys(object2, keysIn, getSymbolsIn);
}
var DataView = getNative(root, "DataView");
var Promise$1 = getNative(root, "Promise");
var Set$1 = getNative(root, "Set");
var mapTag$5 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$5 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$3 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$5 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$5 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$5;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$5;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var objectProto$3 = Object.prototype;
var hasOwnProperty$5 = objectProto$3.hasOwnProperty;
function initCloneArray(array2) {
  var length = array2.length, result = new array2.constructor(length);
  if (length && typeof array2[0] == "string" && hasOwnProperty$5.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
var Uint8Array = root.Uint8Array;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer2 = cloneArrayBuffer(dataView.buffer);
  return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$4 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$3 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object2, tag, isDeep) {
  var Ctor = object2.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object2);
    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object2);
    case dataViewTag$2:
      return cloneDataView(object2);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object2, isDeep);
    case mapTag$4:
      return new Ctor();
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object2);
    case regexpTag$2:
      return cloneRegExp(object2);
    case setTag$4:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object2);
  }
}
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
}
var mapTag$3 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag$3;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap$1 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var setTag$3 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag$3;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var CLONE_DEEP_FLAG$1 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$2 = "[object Map]", numberTag$2 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$2 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$2] = cloneableTags[numberTag$2] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$2] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key, object2, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1;
  if (customizer) {
    result = object2 ? customizer(value, key, object2, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
  } else {
    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object2) {
      result = {};
    } else {
      if (!cloneableTags[tag]) {
        return object2 ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = getAllKeysIn;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array2, predicate) {
  var index2 = -1, length = array2 == null ? 0 : array2.length;
  while (++index2 < length) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array2);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array2, other);
  stack.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array2);
  stack["delete"](other);
  return result;
}
function mapToArray(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array(object2), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag$1:
      return eq(+object2, +other);
    case errorTag:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag:
    case stringTag$1:
      return object2 == other + "";
    case mapTag$1:
      var convert2 = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert2 || (convert2 = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays(convert2(object2), convert2(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$4 = objectProto$2.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$4.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$3 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object2), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object2)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$3.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$3.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer) {
  var index2 = matchData.length, length = index2;
  if (object2 == null) {
    return !length;
  }
  object2 = Object(object2);
  while (index2--) {
    var data = matchData[index2];
    if (data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length) {
    data = matchData[index2];
    var key = data[0], objValue = object2[key], srcValue = data[1];
    if (data[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      var result;
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject(value);
}
function getMatchData(object2) {
  var result = keys$1(object2), length = result.length;
  while (length--) {
    var key = result[length], value = object2[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
function baseHasIn(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath(object2, path2, hasFunc) {
  path2 = castPath(path2, object2);
  var index2 = -1, length = path2.length, result = false;
  while (++index2 < length) {
    var key = toKey(path2[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length) {
    return result;
  }
  length = object2 == null ? 0 : object2.length;
  return !!length && isLength$1(length) && isIndex(key, length) && (isArray$1(object2) || isArguments(object2));
}
function hasIn(object2, path2) {
  return object2 != null && hasPath(object2, path2, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path2, srcValue) {
  if (isKey(path2) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path2), srcValue);
  }
  return function(object2) {
    var objValue = get(object2, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
function basePropertyDeep(path2) {
  return function(object2) {
    return baseGet(object2, path2);
  };
}
function property(path2) {
  return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$2;
  }
  if (typeof value == "object") {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function createBaseFor(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
    while (length--) {
      var key = props[++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor = createBaseFor();
function baseForOwn(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys$1);
}
function assignMergeValue(object2, key, value) {
  if (value !== void 0 && !eq(object2[key], value) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$1(srcValue), isBuff = !isArr && isBuffer$1(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$2(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack) {
  if (object2 === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn);
}
function last(array2) {
  var length = array2 == null ? 0 : array2.length;
  return length ? array2[length - 1] : void 0;
}
var stringTag = "[object String]";
function isString(value) {
  return typeof value == "string" || !isArray$1(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
function parent(object2, path2) {
  return path2.length < 2 ? object2 : baseGet(object2, baseSlice(path2, 0, -1));
}
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty$2 = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$2.call(value, key)) {
      return false;
    }
  }
  return true;
}
var numberTag = "[object Number]";
function isNumber$2(value) {
  return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
function isNil(value) {
  return value == null;
}
function isNull(value) {
  return value === null;
}
function isUndefined(value) {
  return value === void 0;
}
var kebabCase = createCompounder(function(result, word, index2) {
  return result + (index2 ? "-" : "") + word.toLowerCase();
});
function mapValues(object2, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object2, function(value, key, object3) {
    baseAssignValue(result, key, iteratee(value, key, object3));
  });
  return result;
}
var merge = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
function baseUnset(object2, path2) {
  path2 = castPath(path2, object2);
  object2 = parent(object2, path2);
  return object2 == null || delete object2[toKey(last(path2))];
}
function customOmitClone(value) {
  return isPlainObject$2(value) ? void 0 : value;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
var omit = flatRest(function(object2, paths) {
  var result = {};
  if (object2 == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path2) {
    path2 = castPath(path2, object2);
    isDeep || (isDeep = path2.length > 1);
    return path2;
  });
  copyObject(object2, getAllKeysIn(object2), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
function baseSet(object2, path2, value, customizer) {
  if (!isObject(object2)) {
    return object2;
  }
  path2 = castPath(path2, object2);
  var index2 = -1, length = path2.length, lastIndex = length - 1, nested = object2;
  while (nested != null && ++index2 < length) {
    var key = toKey(path2[index2]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object2;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key];
      newValue = void 0;
      if (newValue === void 0) {
        newValue = isObject(objValue) ? objValue : isIndex(path2[index2 + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object2;
}
function basePickBy(object2, paths, predicate) {
  var index2 = -1, length = paths.length, result = {};
  while (++index2 < length) {
    var path2 = paths[index2], value = baseGet(object2, path2);
    if (predicate(value, path2)) {
      baseSet(result, castPath(path2, object2), value);
    }
  }
  return result;
}
function basePick(object2, paths) {
  return basePickBy(object2, paths, function(value, path2) {
    return hasIn(object2, path2);
  });
}
var pick = flatRest(function(object2, paths) {
  return object2 == null ? {} : basePick(object2, paths);
});
const BASE_VIEWPORTS_CONFIG = {
  "desktop-lg": 1440,
  desktop: 1024,
  tablet: 768,
  mobile: 640,
  "mobile-sm": 390,
  "mobile-xs": 320
};
const TwBreakpointsConfig = mapValues(BASE_VIEWPORTS_CONFIG, (value) => px(value));
const TwBreakpointsConfigMax = {
  // From breakpoint and down
  "desktop-lg-d": {
    max: px(99999)
  },
  "desktop-d": {
    max: px(BASE_VIEWPORTS_CONFIG["desktop-lg"] - 1)
  },
  "tablet-d": {
    max: px(BASE_VIEWPORTS_CONFIG.desktop - 1)
  },
  "mobile-d": {
    max: px(BASE_VIEWPORTS_CONFIG.tablet - 1)
  },
  "mobile-sm-d": {
    max: px(BASE_VIEWPORTS_CONFIG.mobile - 1)
  },
  "mobile-xs-d": {
    max: px(BASE_VIEWPORTS_CONFIG["mobile-sm"] - 1)
  },
  // From breakpoint and up
  "desktop-lg-u": {
    min: px(BASE_VIEWPORTS_CONFIG["desktop-lg"])
  },
  "desktop-u": {
    min: px(BASE_VIEWPORTS_CONFIG.desktop)
  },
  "tablet-u": {
    min: px(BASE_VIEWPORTS_CONFIG.tablet)
  },
  "mobile-u": {
    min: px(BASE_VIEWPORTS_CONFIG.mobile)
  },
  "mobile-sm-u": {
    min: px(BASE_VIEWPORTS_CONFIG["mobile-sm"])
  },
  "mobile-xs-u": {
    min: px(BASE_VIEWPORTS_CONFIG["mobile-xs"])
  }
};
const SyntaxDateInput = {
  ".syntax-date-input": {
    // Hides date input native icons in Webkit based browsers
    "> input::-webkit-inner-spin-button, input::-webkit-calendar-picker-indicator, input::-webkit-mask": {
      display: "none"
    },
    // Hides date input native icons in Firefox
    "> input": {
      "mask-image": "linear-gradient(#000000ff, #000000ff)",
      "mask-size": "calc(100% - 21px) calc(100% - 0px)",
      "mask-repeat": "no-repeat",
      "mask-position": "0px 0px",
      "mask-clip": "content-box"
    }
  }
};
const SyntaxLoadingDots = ({ theme }) => ({
  "@keyframes animation-translate-1": theme("keyframes.animation-translate-1"),
  "@keyframes animation-translate-2": theme("keyframes.animation-translate-2"),
  "@keyframes animation-translate-3": theme("keyframes.animation-translate-3"),
  "@keyframes animation-scale-1": theme("keyframes.animation-scale-1"),
  "@keyframes animation-scale-2": theme("keyframes.animation-scale-2"),
  "@keyframes animation-scale-3": theme("keyframes.animation-scale-3"),
  ".syntax-loading-dots": {
    ".spinner-circle1Translate": {
      animation: theme("animation.animation-translate-1")
    },
    ".spinner-circle2Translate": {
      animation: theme("animation.animation-translate-2")
    },
    ".spinner-circle3Translate": {
      animation: theme("animation.animation-translate-3")
    },
    ".spinner-circle1Scale": {
      animation: theme("animation.animation-scale-1")
    },
    ".spinner-circle2Scale": {
      animation: theme("animation.animation-scale-2")
    },
    ".spinner-circle3Scale": {
      animation: theme("animation.animation-scale-3")
    }
  }
});
const AppearKeyframes = {
  appear: {
    "0%": {
      opacity: "0"
    },
    "100%": {
      opacity: "1"
    }
  }
};
const SlideInLeftKeyframes = {
  slideInLeft: {
    "0%": { transform: "translateX(-100%)", opacity: "0" },
    "100%": { transform: "translateX(0)", opacity: "1" }
  }
};
const SlideInBottomKeyframes = {
  slideInBottom: {
    "0%": { transform: "translateY(100%)", opacity: "0" },
    "100%": { transform: "translateY(0)", opacity: "1" }
  }
};
const LoadingDotsKeyframes = {
  "animation-scale-1": {
    "0%": {
      transform: "scale(1,1)"
    },
    "6.666667%": {
      transform: "scale(1.2,.8)"
    },
    "13.333333%": {
      transform: "scale(1,1)"
    },
    "26.666667%": {
      transform: "scale(1,1)"
    },
    "33.333333%": {
      transform: "scale(1,1)"
    },
    "40%": {
      transform: "scale(1,1)"
    },
    "53.333333%": {
      transform: "scale(1,1)"
    },
    "60%": {
      transform: "scale(1.2,.8)"
    },
    "66.666667%": {
      transform: "scale(1,1)"
    },
    "100%": {
      transform: "scale(1,1)"
    }
  },
  "animation-scale-2": {
    "0%": {
      transform: "scale(1,1)"
    },
    "13.333333%": {
      transform: "scale(1,1)"
    },
    "20%": {
      transform: "scale(1.2,.8)"
    },
    "26.666667%": {
      transform: "scale(1,1)"
    },
    "40%": {
      transform: "scale(1,1)"
    },
    "46.666667%": {
      transform: "scale(1,1)"
    },
    "53.333333%": {
      transform: "scale(1,1)"
    },
    "66.666667%": {
      transform: "scale(1,1)"
    },
    "73.333333%": {
      transform: "scale(1.2,.8)"
    },
    "80%": {
      transform: "scale(1,1)"
    },
    "100%": {
      transform: "scale(1,1)"
    }
  },
  "animation-scale-3": {
    "0%": {
      transform: "scale(1,1)"
    },
    "26.666667%": {
      transform: "scale(1,1)"
    },
    "33.333333%": {
      transform: "scale(1.2,.8)"
    },
    "40%": {
      transform: "scale(1,1)"
    },
    "53.333333%": {
      transform: "scale(1,1)"
    },
    "60%": {
      transform: "scale(1,1)"
    },
    "66.666667%": {
      transform: "scale(1,1)"
    },
    "80%": {
      transform: "scale(1,1)"
    },
    "86.666667%": {
      transform: "scale(1.2,.8)"
    },
    "93.333333%": {
      transform: "scale(1,1)"
    },
    "100%": {
      transform: "scale(1,1)"
    }
  },
  "animation-translate-1": {
    "0%": {
      transform: "translate(10px,33.528168px)"
    },
    "6.666667%": {
      transform: "translate(10px,41.764084px)"
    },
    "13.333333%": {
      transform: "translate(10px,33.528168px)"
    },
    "26.666667%": {
      transform: "translate(10px,-2.651608px)"
    },
    "33.333333%": {
      transform: "translate(10px,-4.471832px)"
    },
    "40%": {
      transform: "translate(10px,-2.651608px)"
    },
    "53.333333%": {
      transform: "translate(10px,33.528168px)"
    },
    "60%": {
      transform: "translate(10px,41.764084px)"
    },
    "66.666667%": {
      transform: "translate(10px,33.528168px)"
    },
    "100%": {
      transform: "translate(10px,33.528168px)"
    }
  },
  "animation-translate-2": {
    "0%": {
      transform: "translate(30px,33.528168px)"
    },
    "13.333333%": {
      transform: "translate(30px,33.528168px)"
    },
    "20%": {
      transform: "translate(30px,41.764084px)"
    },
    "26.666667%": {
      transform: "translate(30px,33.528168px)"
    },
    "40%": {
      transform: "translate(30px,-2.651608px)"
    },
    "46.666667%": {
      transform: "translate(30px,-4.471832px)"
    },
    "53.333333%": {
      transform: "translate(30px,-2.651608px)"
    },
    "66.666667%": {
      transform: "translate(30px,33.528168px)"
    },
    "73.333333%": {
      transform: "translate(30px,41.764084px)"
    },
    "80%": {
      transform: "translate(30px,33.528168px)"
    },
    "100%": {
      transform: "translate(30px,33.528168px)"
    }
  },
  "animation-translate-3": {
    "0%": {
      transform: "translate(50px,33.528168px)"
    },
    "26.666667%": {
      transform: "translate(50px,33.528168px)"
    },
    "33.333333%": {
      transform: "translate(50px,41.764084px)"
    },
    "40%": {
      transform: "translate(50px,33.528168px)"
    },
    "53.333333%": {
      transform: "translate(50px,-2.651608px)"
    },
    "60%": {
      transform: "translate(50px,-4.471832px)"
    },
    "66.666667%": {
      transform: "translate(50px,-2.651608px)"
    },
    "80%": {
      transform: "translate(50px,33.528168px)"
    },
    "86.666667%": {
      transform: "translate(50px,41.764084px)"
    },
    "93.333333%": {
      transform: "translate(50px,33.528168px)"
    },
    "100%": {
      transform: "translate(50px,33.528168px)"
    }
  }
};
const LoadingDotsAnimations = {
  "animation-translate-1": "animation-translate-1 1s linear infinite normal forwards",
  "animation-scale-1": "animation-scale-1 1s linear infinite normal forwards",
  "animation-translate-2": "animation-translate-2 1s linear infinite normal forwards",
  "animation-scale-2": "animation-scale-2 1s linear infinite normal forwards",
  "animation-translate-3": "animation-translate-3 1s linear infinite normal forwards",
  "animation-scale-3": "animation-scale-3 1s linear infinite normal forwards"
};
const ScrollbarUtilities = {
  // scrollbar-thin
  ".scrollbar-thin::-webkit-scrollbar": {
    maxWidth: "4px",
    maxHeight: "4px",
    "-webkit-appearance": "none"
  },
  ".scrollbar-thin::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
    marginRight: "8px"
  },
  ".scrollbar-thin::-webkit-scrollbar-thumb": {
    backgroundColor: "#d4d3cb",
    borderRadius: "4px",
    marginRight: "8px"
  },
  // scrollbar-medium
  ".scrollbar-medium::-webkit-scrollbar": {
    height: "8px",
    width: "8px",
    "-webkit-appearance": "none"
  },
  ".scrollbar-medium::-webkit-scrollbar-track": {
    backgroundColor: "#f5f5f4",
    borderRadius: "4px",
    marginRight: "8px"
  },
  ".scrollbar-medium::-webkit-scrollbar-thumb": {
    backgroundColor: "#d4d3cb",
    borderRadius: "4px",
    marginRight: "8px",
    "&:hover": {
      backgroundColor: "#a8a29e"
    }
  },
  // scrollbar-hidden
  ".scrollbar-hidden::-webkit-scrollbar": {
    display: "none"
  }
};
const FullTailwindConfig = {
  content: ["./lib/**/*.{tsx,ts}"],
  theme: {
    screens: {
      ...TwBreakpointsConfig,
      ...TwBreakpointsConfigMax
    },
    fontFamily: {
      sans: ["Inter", "sans-serif"],
      serif: ["Inter", '"Times New Roman"', "Times", "serif"],
      mono: ["Dazzed", "ui-monospace"],
      signature: ["DancingScript"],
      dazzed: ["Dazzed"]
    },
    fontSize: {
      h1: [rem(29), "44px"],
      h2: [rem(24), "36px"],
      h3: [rem(20), "32px"],
      h4: [rem(18), "28px"],
      h5: [rem(16), "24px"],
      h6: [rem(14), "20px"],
      "h1-sm": [rem(24), "36px"],
      "h2-sm": [rem(20), "32px"],
      "h3-sm": [rem(18), "28px"],
      "h4-sm": [rem(16), "28px"],
      "h5-sm": [rem(16), "24px"],
      "h6-sm": [rem(14), "20px"],
      "body-lg": [rem(16), "24px"],
      "body-md": [rem(14), "20px"],
      "body-sm": [rem(13), "20px"],
      "body-xs": [rem(12), "16px"],
      overline: [rem(12), "16px"],
      label: [rem(13), "20px"],
      display: [rem(32), "48px"],
      "display-sm": [rem(29), "44px"],
      "button-lg": [rem(16), "20px"],
      "button-md": [rem(14), "16px"],
      "button-sm": [rem(12), "12px"],
      "button-xs": [rem(12), "12px"]
    },
    borderRadius: {
      none: "0",
      xxs: rem(2),
      xs: rem(4),
      sm: rem(6),
      md: rem(8),
      lg: rem(10),
      xl: rem(12),
      "2xl": rem(14),
      "3xl": rem(16),
      30: rem(30),
      40: rem(40),
      full: "9999px",
      2.5: rem(2.5),
      3: rem(3),
      100: "100px",
      /** Deprecated - To be removed */
      xxl: rem(14),
      xxxl: rem(16)
    },
    colors: {
      myColor: "green",
      current: "currentColor",
      transparent: colors$1.transparent,
      white: colors$1.white,
      gray: {
        50: "#F9FBFD",
        100: "#EFF2F5",
        200: "#E7EAED",
        300: "#D3D6DB",
        400: "#B2B4B7",
        500: "#929497",
        600: "#6A6C6E",
        700: "#4D4F52",
        800: "#383A3C",
        900: "#181A1C"
      },
      purple: {
        50: "#F3EDFE",
        100: "#E0D2FE",
        200: "#CDB4FE",
        300: "#C09FFF",
        400: "#A579F6",
        500: "#9464F1",
        600: "#895BE9",
        700: "#7B51DF",
        800: "#6F4BD6",
        900: "#5C3EC8"
      },
      amber: {
        50: "#FFFBEB",
        100: "#FEF3C7",
        200: "#FDE68A",
        300: "#FCD34D",
        400: "#FBBF24",
        500: "#F59E0B",
        600: "#D97706",
        700: "#B45309",
        800: "#92400E",
        900: "#78350F"
      },
      marigold: {
        50: "#FFF7E3",
        100: "#FFEAB7",
        200: "#FBE17E",
        300: "#FFD15D",
        400: "#FEC641",
        500: "#FEBC2F",
        600: "#FDAF2C",
        700: "#FB9D29",
        800: "#FA8D27",
        900: "#FE7000"
      },
      red: {
        50: "#FCE8EA",
        100: "#F7C6C8",
        200: "#E18F8A",
        300: "#D1655E",
        400: "#D54438",
        500: "#D53218",
        600: "#C82819",
        700: "#B71D15",
        800: "#AA150D",
        900: "#9B0600"
      },
      green: {
        50: "#F0FDF4",
        100: "#DCFCE7",
        200: "#BBF7D0",
        300: "#86EFAC",
        400: "#4ADE80",
        500: "#22C55E",
        600: "#16A34A",
        700: "#15803D",
        800: "#166534",
        900: "#14532D"
      },
      teal: {
        50: "#DAF8F7",
        100: "#A0EDE9",
        200: "#49E2DA",
        300: "#00D3C8",
        400: "#00C6B8",
        500: "#00B9A7",
        600: "#00B9A7",
        700: "#009986",
        800: "#008876",
        900: "#006A56"
      },
      violet: {
        50: "#FCE9FB",
        100: "#F8C7F5",
        200: "#F4A0F0",
        300: "#EC78E7",
        400: "#E357DE",
        500: "#DA39D5",
        600: "#CA35CF",
        700: "#B52EC7",
        800: "#A42AC0",
        900: "#8323B3"
      },
      blue: {
        50: "#E1F2FE",
        100: "#B6DDFE",
        200: "#86C8FE",
        300: "#4EB2FE",
        400: "#00A3FF",
        500: "#538EFC",
        600: "#0084F0",
        700: "#0072DD",
        800: "#0060CB",
        900: "#0042AB"
      },
      cream: {
        50: "#F9F8F0",
        100: "#F0EFE7",
        500: "#8E8D86"
      },
      black: {
        DEFAULT: "black",
        50: "#FAFAFA",
        100: "#F5F5F5",
        200: "#D9D9D9",
        300: "#C4C4C4",
        400: "#9D9D9D",
        500: "#7B7B7B",
        600: "#555555",
        700: "#434343",
        800: "#262626",
        900: "#000000",
        "4%": "rgb(0, 0, 0, 0.04)",
        "8%": "rgb(0, 0, 0, 0.08)",
        "12%": "rgb(0, 0, 0, 0.12)",
        "16%": "rgb(0, 0, 0, 0.16)",
        "24%": "rgb(0, 0, 0, 0.24)",
        "38%": "rgb(0, 0, 0, 0.38)",
        "60%": "rgb(0, 0, 0, 0.60)",
        "87%": "rgb(0, 0, 0, 0.87)",
        "100%": "rgb(0, 0, 0, 1)"
      },
      yellow: {
        100: "#F6FDC2",
        200: "#EEFB97",
        300: "#EBFF6E",
        500: "#DEF819",
        900: "#9A9000"
      },
      orange: {
        50: "#FAE9E8",
        100: "#FFCDBF",
        200: "#FFAC96",
        300: "#FF8D6C",
        400: "#FF724C",
        500: "#FF592E",
        700: "#E74C25",
        800: "#D94521",
        900: "#C03918"
      },
      orchid: {
        50: "#F7EFFD",
        100: "#EBD7FB",
        200: "#DFBCFA",
        300: "#D29EF7",
        400: "#C684F1",
        500: "#BB6BED",
        600: "#B164E5",
        700: "#A35ADA",
        800: "#9853D2",
        900: "#8746C3"
      },
      // New colors are still pending in Figma.
      // Introducing these as needed until final colors are confirmed.
      utility: {
        error: "#9B0600",
        link: "#5C3EC8",
        disabled: "#67665F",
        success: {
          DEFAULT: "#DCFCE7",
          dark: "#166534"
        }
      },
      "warm-gray": {
        DEFAULT: "#16150E",
        50: "#F9F8F0",
        100: "#F0EFE7",
        200: "#E5E4DC",
        300: "#D4D3CB",
        400: "#AFAEA7",
        500: "#8E8D86",
        600: "#67665F",
        700: "#53534C",
        800: "#35352F",
        900: "#16150E",
        "4%": "rgba(22, 21, 14, 0.04)",
        "8%": "rgba(22, 21, 14, 0.08)",
        "12%": "rgba(22, 21, 14, 0.12)",
        "16%": "rgba(22, 21, 14, 0.16)"
      }
    },
    spacing: {
      unset: "unset",
      px: "1px",
      0: "0",
      ...remPair(2, "e"),
      ...remPair(4, "e"),
      ...remPair(5, "e"),
      ...remPair(6, "e"),
      ...remPair(8, "e"),
      ...remPair(10, "e"),
      ...remPair(12, "e"),
      ...remPair(14, "e"),
      ...remPair(16, "e"),
      ...remPair(18, "e"),
      ...remPair(20, "e"),
      ...remPair(24, "e"),
      ...remPair(26, "e"),
      ...remPair(28, "e"),
      ...remPair(32, "e"),
      ...remPair(40, "e"),
      ...remPair(48, "e"),
      ...remPair(56, "e"),
      ...remPair(64, "e"),
      ...remPair(80, "e"),
      ...remPair(96, "e"),
      ...remPair(112, "e"),
      ...remPair(120, "e"),
      ...remPair(128, "e"),
      ...remPair(144, "e"),
      ...remPair(160, "e"),
      // Special spacings, not meant to be used as paddings, margins, etc. But instead for precise size of components
      ...remPair(11, "es"),
      ...remPair(22, "es"),
      ...remPair(36, "es"),
      ...remPair(52, "es"),
      ...remPair(72, "es"),
      ...remPair(78, "es"),
      ...remPair(108, "es"),
      ...remPair(112, "es"),
      ...remPair(120, "es"),
      ...remPair(200, "es"),
      ...remPair(288, "es"),
      ...remPair(330, "es"),
      ...remPair(344, "es"),
      ...remPair(360, "es"),
      ...remPair(500, "es"),
      ...remPair(598, "es"),
      ...remPair(808, "es")
    },
    extend: {
      animation: {
        appear: "appear 0.25s ease-in-out",
        "spin-slow": "spin 1.5s linear infinite",
        "slide-in-left": "slideInLeft 0.3s ease-out",
        "slide-in-bottom": "slideInBottom 0.3s ease-out",
        ...LoadingDotsAnimations
      },
      boxShadow: {
        "drop-1": "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
      },
      gridTemplateColumns: {
        "auto-min-e100": "repeat(auto-fit, minmax(100px, max-content))"
      },
      keyframes: {
        ...AppearKeyframes,
        ...LoadingDotsKeyframes,
        ...SlideInLeftKeyframes,
        ...SlideInBottomKeyframes
      },
      lineClamp: {
        7: "7"
      },
      lineHeight: {
        15: rem(15)
      },
      maxHeight: {
        dialog: "calc(100vh - 80px)",
        "dialog-sm": "calc(100dvh - 44px)"
      },
      maxWidth: {
        "90vw": "90vw"
      },
      opacity: {
        4: "0.04",
        6: "0.06"
      },
      outlineWidth: {
        3: px(3)
      },
      textDecorationThickness: {
        1.5: "1.5px"
      },
      transitionProperty: {
        bg: "background-color",
        height: "height",
        padding: "padding"
      },
      width: {
        "dialog-xl": "1224px",
        "dialog-lg": "1016px",
        "dialog-md": "808px",
        "dialog-sm": "600px",
        "dialog-xs": "392px",
        "select-chips": "calc(100% - 32px)"
      }
    }
  },
  plugins: [
    plugin$1(({ addUtilities, addVariant, addComponents, theme }) => {
      addUtilities(ScrollbarUtilities);
      addUtilities({
        ".after-blank": {
          "&:after": {
            content: '""'
          }
        },
        ".before-blank": {
          "&:before": {
            content: '""'
          }
        }
      });
      addVariant("link", "& > a");
      addVariant("svg", "& > svg");
      addVariant("not-last", "&:not(:last-child)");
      addVariant("not-first", "&:not(:first-child)");
      addVariant("not-hover", "&:not(:hover)");
      addComponents({
        ...SyntaxDateInput,
        ...SyntaxLoadingDots({ theme })
      });
    }),
    /** Width clamp utility */
    plugin$1(function({ matchUtilities, theme }) {
      matchUtilities(
        {
          "w-clamp": (value) => ({
            width: `max-content`,
            minWidth: `min(100%, ${value})`,
            maxWidth: "100%"
          })
        },
        { values: theme("spacing") }
      );
    }),
    /* THIRD PARTY PLUGINS */
    o$f({ prefix: "hui" })
  ]
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f2 = a__default, k2 = Symbol.for("react.element"), l2 = Symbol.for("react.fragment"), m2 = Object.prototype.hasOwnProperty, n2 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p2 = { key: true, ref: true, __self: true, __source: true };
  function q2(c2, a2, g2) {
    var b2, d2 = {}, e3 = null, h2 = null;
    void 0 !== g2 && (e3 = "" + g2);
    void 0 !== a2.key && (e3 = "" + a2.key);
    void 0 !== a2.ref && (h2 = a2.ref);
    for (b2 in a2) m2.call(a2, b2) && !p2.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
    if (c2 && c2.defaultProps) for (b2 in a2 = c2.defaultProps, a2) void 0 === d2[b2] && (d2[b2] = a2[b2]);
    return { $$typeof: k2, type: c2, key: e3, ref: h2, props: d2, _owner: n2.current };
  }
  reactJsxRuntime_production_min.Fragment = l2;
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = a__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format2 += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x2) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign2 = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign2({}, props, {
                value: prevLog
              }),
              info: assign2({}, props, {
                value: prevInfo
              }),
              warn: assign2({}, props, {
                value: prevWarn
              }),
              error: assign2({}, props, {
                value: prevError
              }),
              group: assign2({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign2({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign2({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match2 = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match2 && match2[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;
            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }
            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;
                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x2) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error2("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray3(a2) {
        return isArrayImpl(a2);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e3) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config2) {
        {
          if (hasOwnProperty2.call(config2, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.ref !== void 0;
      }
      function hasValidKey(config2) {
        {
          if (hasOwnProperty2.call(config2, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config2, self2) {
        {
          if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config2, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config2)) {
            {
              checkKeyStringCoercion(config2.key);
            }
            key = "" + config2.key;
          }
          if (hasValidRef(config2)) {
            ref = config2.ref;
            warnIfStringRefCannotBeAutoConverted(config2, self2);
          }
          for (propName in config2) {
            if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config2[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement2(object2) {
        {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info2 = getDeclarationErrorAddendum();
          if (!info2) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info2 = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info2;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray3(node)) {
            for (var i2 = 0; i2 < node.length; i2++) {
              var child = node[i2];
              if (isValidElement2(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement2(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement2(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys2 = Object.keys(fragment.props);
          for (var i2 = 0; i2 < keys2.length; i2++) {
            var key = keys2[i2];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error2("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info2 = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info2 += sourceInfo;
            } else {
              info2 += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray3(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info2 = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info2);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray3(children)) {
                  for (var i2 = 0; i2 < children.length; i2++) {
                    validateChildKeys(children[i2], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys2 = Object.keys(props).filter(function(k2) {
                return k2 !== "key";
              });
              var beforeExample = keys2.length > 0 ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys2.length > 0 ? "{" + keys2.join(": ..., ") + ": ...}" : "{}";
                error2('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const CLASS_PART_SEPARATOR$1 = "-";
function createClassUtils(config2) {
  const classMap = createClassMap$1(config2);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config2;
  function getClassGroupId(className) {
    const classParts = className.split(CLASS_PART_SEPARATOR$1);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive$1(classParts, classMap) || getGroupIdForArbitraryProperty$1(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive$1(classParts, classPartObject) {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive$1(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR$1);
  return classPartObject.validators.find(({
    validator
  }) => validator(classRest))?.classGroupId;
}
const arbitraryPropertyRegex$1 = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty$1(className) {
  if (arbitraryPropertyRegex$1.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex$1.exec(className)[1];
    const property2 = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property2) {
      return "arbitrary.." + property2;
    }
  }
}
function createClassMap$1(config2) {
  const {
    theme,
    prefix
  } = config2;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config2.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively$1(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively$1(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart$1(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter$1(classDefinition)) {
        processClassesRecursively$1(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively$1(classGroup2, getPart$1(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart$1(classPartObject, path2) {
  let currentClassPartObject = classPartObject;
  path2.split(CLASS_PART_SEPARATOR$1).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter$1(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}
function createLruCache$1(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache2 = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  function update(key, value) {
    cache2.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache2;
      cache2 = /* @__PURE__ */ new Map();
    }
  }
  return {
    get(key) {
      let value = cache2.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache2.has(key)) {
        cache2.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}
const IMPORTANT_MODIFIER$1 = "!";
function createSplitModifiers(config2) {
  const separator = config2.separator;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  return function splitModifiers(className) {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index2 = 0; index2 < className.length; index2++) {
      let currentCharacter = className[index2];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index2, index2 + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER$1);
    const baseClassName2 = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName: baseClassName2,
      maybePostfixModifierPosition
    };
  };
}
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
}
function createConfigUtils$1(config2) {
  return {
    cache: createLruCache$1(config2.cacheSize),
    splitModifiers: createSplitModifiers(config2),
    ...createClassUtils(config2)
  };
}
const SPLIT_CLASSES_REGEX$1 = /\s+/;
function mergeClassList$1(classList, configUtils) {
  const {
    splitModifiers,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = /* @__PURE__ */ new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX$1).map((originalClassName) => {
    const {
      modifiers,
      hasImportantModifier,
      baseClassName: baseClassName2,
      maybePostfixModifierPosition
    } = splitModifiers(originalClassName);
    let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName2.substring(0, maybePostfixModifierPosition) : baseClassName2);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName2);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER$1 : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName,
      hasPostfixModifier
    };
  }).reverse().filter((parsed) => {
    if (!parsed.isTailwindClass) {
      return true;
    }
    const {
      modifierId,
      classGroupId,
      hasPostfixModifier
    } = parsed;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group) => classGroupsInConflict.add(modifierId + group));
    return true;
  }).reverse().map((parsed) => parsed.originalClassName).join(" ");
}
function twJoin$1() {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string2 = "";
  while (index2 < arguments.length) {
    if (argument = arguments[index2++]) {
      if (resolvedValue = toValue$1(argument)) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
}
function toValue$1(mix) {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string2 = "";
  for (let k2 = 0; k2 < mix.length; k2++) {
    if (mix[k2]) {
      if (resolvedValue = toValue$1(mix[k2])) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
}
function createTailwindMerge$1(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config2 = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils$1(config2);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList$1(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin$1.apply(null, arguments));
  };
}
function fromTheme$1(key) {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
}
const arbitraryValueRegex$1 = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex$1 = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex$1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex$1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex$1 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex$1 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex$1 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function isLength(value) {
  return isNumber$1(value) || stringLengths.has(value) || fractionRegex$1.test(value);
}
function isArbitraryLength$1(value) {
  return getIsArbitraryValue$1(value, "length", isLengthOnly$1);
}
function isNumber$1(value) {
  return Boolean(value) && !Number.isNaN(Number(value));
}
function isArbitraryNumber$1(value) {
  return getIsArbitraryValue$1(value, "number", isNumber$1);
}
function isInteger$1(value) {
  return Boolean(value) && Number.isInteger(Number(value));
}
function isPercent$1(value) {
  return value.endsWith("%") && isNumber$1(value.slice(0, -1));
}
function isArbitraryValue$1(value) {
  return arbitraryValueRegex$1.test(value);
}
function isTshirtSize$1(value) {
  return tshirtUnitRegex$1.test(value);
}
const sizeLabels$1 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function isArbitrarySize$1(value) {
  return getIsArbitraryValue$1(value, sizeLabels$1, isNever$1);
}
function isArbitraryPosition$1(value) {
  return getIsArbitraryValue$1(value, "position", isNever$1);
}
const imageLabels$1 = /* @__PURE__ */ new Set(["image", "url"]);
function isArbitraryImage$1(value) {
  return getIsArbitraryValue$1(value, imageLabels$1, isImage$1);
}
function isArbitraryShadow$1(value) {
  return getIsArbitraryValue$1(value, "", isShadow$1);
}
function isAny$1() {
  return true;
}
function getIsArbitraryValue$1(value, label, testValue) {
  const result = arbitraryValueRegex$1.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly$1(value) {
  return lengthUnitRegex$1.test(value) && !colorFunctionRegex$1.test(value);
}
function isNever$1() {
  return false;
}
function isShadow$1(value) {
  return shadowRegex$1.test(value);
}
function isImage$1(value) {
  return imageRegex$1.test(value);
}
function getDefaultConfig$1() {
  const colors2 = fromTheme$1("colors");
  const spacing = fromTheme$1("spacing");
  const blur = fromTheme$1("blur");
  const brightness = fromTheme$1("brightness");
  const borderColor = fromTheme$1("borderColor");
  const borderRadius = fromTheme$1("borderRadius");
  const borderSpacing = fromTheme$1("borderSpacing");
  const borderWidth = fromTheme$1("borderWidth");
  const contrast = fromTheme$1("contrast");
  const grayscale = fromTheme$1("grayscale");
  const hueRotate = fromTheme$1("hueRotate");
  const invert = fromTheme$1("invert");
  const gap = fromTheme$1("gap");
  const gradientColorStops = fromTheme$1("gradientColorStops");
  const gradientColorStopPositions = fromTheme$1("gradientColorStopPositions");
  const inset = fromTheme$1("inset");
  const margin = fromTheme$1("margin");
  const opacity = fromTheme$1("opacity");
  const padding = fromTheme$1("padding");
  const saturate = fromTheme$1("saturate");
  const scale = fromTheme$1("scale");
  const sepia = fromTheme$1("sepia");
  const skew = fromTheme$1("skew");
  const space2 = fromTheme$1("space");
  const translate = fromTheme$1("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue$1, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue$1, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength$1];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber$1, isArbitraryValue$1];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue$1];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumber = () => [isNumber$1, isArbitraryNumber$1];
  const getNumberAndArbitrary = () => [isNumber$1, isArbitraryValue$1];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny$1],
      spacing: [isLength, isArbitraryLength$1],
      blur: ["none", "", isTshirtSize$1, isArbitraryValue$1],
      brightness: getNumber(),
      borderColor: [colors2],
      borderRadius: ["none", "", "full", isTshirtSize$1, isArbitraryValue$1],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors2],
      gradientColorStopPositions: [isPercent$1, isArbitraryLength$1],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue$1]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize$1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue$1]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger$1, isArbitraryValue$1]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue$1]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger$1, isArbitraryValue$1]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny$1]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger$1, isArbitraryValue$1]
        }, isArbitraryValue$1]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny$1]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger$1, isArbitraryValue$1]
        }, isArbitraryValue$1]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue$1]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue$1]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space2]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space2]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue$1, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue$1, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue$1, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize$1]
        }, isTshirtSize$1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue$1, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue$1, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue$1, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue$1, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize$1, isArbitraryLength$1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber$1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny$1]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue$1]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber$1, isArbitraryNumber$1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue$1]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue$1]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue$1]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors2]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors2]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength$1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue$1]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors2]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue$1]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue$1]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition$1]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize$1]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage$1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors2]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue$1]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength$1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors2]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors2]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength$1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors2]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize$1, isArbitraryShadow$1]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny$1]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize$1, isArbitraryValue$1]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue$1]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue$1]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue$1]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger$1, isArbitraryValue$1]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue$1]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors2]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue$1]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors2]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue$1]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors2, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength$1, isArbitraryNumber$1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors2, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function mergeConfigs$1(baseConfig, {
  cacheSize,
  prefix,
  separator,
  extend: extend3 = {},
  override = {}
}) {
  overrideProperty$1(baseConfig, "cacheSize", cacheSize);
  overrideProperty$1(baseConfig, "prefix", prefix);
  overrideProperty$1(baseConfig, "separator", separator);
  for (const configKey in override) {
    overrideConfigProperties$1(baseConfig[configKey], override[configKey]);
  }
  for (const key in extend3) {
    mergeConfigProperties$1(baseConfig[key], extend3[key]);
  }
  return baseConfig;
}
function overrideProperty$1(baseObject, overrideKey, overrideValue) {
  if (overrideValue !== void 0) {
    baseObject[overrideKey] = overrideValue;
  }
}
function overrideConfigProperties$1(baseObject, overrideObject) {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty$1(baseObject, key, overrideObject[key]);
    }
  }
}
function mergeConfigProperties$1(baseObject, mergeObject) {
  if (mergeObject) {
    for (const key in mergeObject) {
      const mergeValue = mergeObject[key];
      if (mergeValue !== void 0) {
        baseObject[key] = (baseObject[key] || []).concat(mergeValue);
      }
    }
  }
}
function extendTailwindMerge$1(configExtension, ...createConfig) {
  return typeof configExtension === "function" ? createTailwindMerge$1(getDefaultConfig$1, configExtension, ...createConfig) : createTailwindMerge$1(() => mergeConfigs$1(getDefaultConfig$1(), configExtension), ...createConfig);
}
const twMerge$2 = /* @__PURE__ */ createTailwindMerge$1(getDefaultConfig$1);
var l$n = (e3) => typeof e3 == "boolean" ? `${e3}` : e3 === 0 ? "0" : e3, u$b = (e3) => !e3 || typeof e3 != "object" || Object.keys(e3).length === 0, x$4 = (e3, o3) => JSON.stringify(e3) === JSON.stringify(o3);
function i$t(e3, o3) {
  e3.forEach(function(r2) {
    Array.isArray(r2) ? i$t(r2, o3) : o3.push(r2);
  });
}
function y$8(e3) {
  let o3 = [];
  return i$t(e3, o3), o3;
}
var a$y = (...e3) => y$8(e3).filter(Boolean), p$u = (e3, o3) => {
  let r2 = {}, c2 = Object.keys(e3), f2 = Object.keys(o3);
  for (let t2 of c2) if (f2.includes(t2)) {
    let s2 = e3[t2], n2 = o3[t2];
    Array.isArray(s2) || Array.isArray(n2) ? r2[t2] = a$y(n2, s2) : typeof s2 == "object" && typeof n2 == "object" ? r2[t2] = p$u(s2, n2) : r2[t2] = n2 + " " + s2;
  } else r2[t2] = e3[t2];
  for (let t2 of f2) c2.includes(t2) || (r2[t2] = o3[t2]);
  return r2;
}, g$5 = (e3) => !e3 || typeof e3 != "string" ? e3 : e3.replace(/\s+/g, " ").trim();
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config2) => {
  const classMap = createClassMap(config2);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config2;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return classPartObject.validators.find(({
    validator
  }) => validator(classRest))?.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property2 = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property2) {
      return "arbitrary.." + property2;
    }
  }
};
const createClassMap = (config2) => {
  const {
    theme,
    classGroups
  } = config2;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const classGroupId in classGroups) {
    processClassesRecursively(classGroups[classGroupId], classMap, classGroupId, theme);
  }
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path2) => {
  let currentClassPartObject = classPartObject;
  path2.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache2 = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache2.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache2;
      cache2 = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache2.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache2.has(key)) {
        cache2.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const MODIFIER_SEPARATOR = ":";
const MODIFIER_SEPARATOR_LENGTH = MODIFIER_SEPARATOR.length;
const createParseClassName = (config2) => {
  const {
    prefix,
    experimentalParseClassName
  } = config2;
  let parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index2 = 0; index2 < className.length; index2++) {
      let currentCharacter = className[index2];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + MODIFIER_SEPARATOR_LENGTH;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      } else if (currentCharacter === "(") {
        parenDepth++;
      } else if (currentCharacter === ")") {
        parenDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const baseClassName2 = stripImportantModifier(baseClassNameWithImportantModifier);
    const hasImportantModifier = baseClassName2 !== baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName: baseClassName2,
      maybePostfixModifierPosition
    };
  };
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.substring(fullPrefix.length)) : {
      isExternal: true,
      modifiers: [],
      hasImportantModifier: false,
      baseClassName: className,
      maybePostfixModifierPosition: void 0
    };
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    });
  }
  return parseClassName;
};
const stripImportantModifier = (baseClassName2) => {
  if (baseClassName2.endsWith(IMPORTANT_MODIFIER)) {
    return baseClassName2.substring(0, baseClassName2.length - 1);
  }
  if (baseClassName2.startsWith(IMPORTANT_MODIFIER)) {
    return baseClassName2.substring(1);
  }
  return baseClassName2;
};
const createSortModifiers = (config2) => {
  const orderSensitiveModifiers = Object.fromEntries(config2.orderSensitiveModifiers.map((modifier) => [modifier, true]));
  const sortModifiers2 = (modifiers) => {
    if (modifiers.length <= 1) {
      return modifiers;
    }
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier) => {
      const isPositionSensitive = modifier[0] === "[" || orderSensitiveModifiers[modifier];
      if (isPositionSensitive) {
        sortedModifiers.push(...unsortedModifiers.sort(), modifier);
        unsortedModifiers = [];
      } else {
        unsortedModifiers.push(modifier);
      }
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
  };
  return sortModifiers2;
};
const createConfigUtils = (config2) => ({
  cache: createLruCache(config2.cacheSize),
  parseClassName: createParseClassName(config2),
  sortModifiers: createSortModifiers(config2),
  ...createClassGroupUtils(config2)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers: sortModifiers2
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index2 = classNames.length - 1; index2 >= 0; index2 -= 1) {
    const originalClassName = classNames[index2];
    const {
      isExternal,
      modifiers,
      hasImportantModifier,
      baseClassName: baseClassName2,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName2.substring(0, maybePostfixModifierPosition) : baseClassName2);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName2);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers2(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i2 = 0; i2 < conflictGroups.length; ++i2) {
      const group = conflictGroups[i2];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string2 = "";
  while (index2 < arguments.length) {
    if (argument = arguments[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string2 = "";
  for (let k2 = 0; k2 < mix.length; k2++) {
    if (mix[k2]) {
      if (resolvedValue = toValue(mix[k2])) {
        string2 && (string2 += " ");
        string2 += resolvedValue;
      }
    }
  }
  return string2;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config2 = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config2);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const fractionRegex = /^\d+\/\d+$/;
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isFraction = (value) => fractionRegex.test(value);
const isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
const isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const isAny = () => true;
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage = (value) => imageRegex.test(value);
const isAnyNonArbitrary = (value) => !isArbitraryValue(value) && !isArbitraryVariable(value);
const isArbitrarySize = (value) => getIsArbitraryValue(value, isLabelSize, isNever);
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, isLabelLength, isLengthOnly);
const isArbitraryNumber = (value) => getIsArbitraryValue(value, isLabelNumber, isNumber);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, isLabelPosition, isNever);
const isArbitraryImage = (value) => getIsArbitraryValue(value, isLabelImage, isImage);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, isNever, isShadow);
const isArbitraryVariable = (value) => arbitraryVariableRegex.test(value);
const isArbitraryVariableLength = (value) => getIsArbitraryVariable(value, isLabelLength);
const isArbitraryVariableFamilyName = (value) => getIsArbitraryVariable(value, isLabelFamilyName);
const isArbitraryVariablePosition = (value) => getIsArbitraryVariable(value, isLabelPosition);
const isArbitraryVariableSize = (value) => getIsArbitraryVariable(value, isLabelSize);
const isArbitraryVariableImage = (value) => getIsArbitraryVariable(value, isLabelImage);
const isArbitraryVariableShadow = (value) => getIsArbitraryVariable(value, isLabelShadow, true);
const getIsArbitraryValue = (value, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
};
const isLabelPosition = (label) => label === "position";
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
const isLabelImage = (label) => imageLabels.has(label);
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
const isLabelSize = (label) => sizeLabels.has(label);
const isLabelLength = (label) => label === "length";
const isLabelNumber = (label) => label === "number";
const isLabelFamilyName = (label) => label === "family-name";
const isLabelShadow = (label) => label === "shadow";
const getDefaultConfig = () => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const scalePosition = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const scaleOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const scaleOverscroll = () => ["auto", "contain", "none"];
  const scaleUnambiguousSpacing = () => [isArbitraryVariable, isArbitraryValue, themeSpacing];
  const scaleInset = () => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()];
  const scaleGridTemplateColsRows = () => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartAndEnd = () => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartOrEnd = () => [isInteger, "auto", isArbitraryVariable, isArbitraryValue];
  const scaleGridAutoColsRows = () => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue];
  const scaleAlignPrimaryAxis = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline"];
  const scaleAlignSecondaryAxis = () => ["start", "end", "center", "stretch"];
  const scaleMargin = () => ["auto", ...scaleUnambiguousSpacing()];
  const scaleSizing = () => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleColor = () => [themeColor, isArbitraryVariable, isArbitraryValue];
  const scaleGradientStopPosition = () => [isPercent, isArbitraryLength];
  const scaleRadius = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleBorderWidth = () => ["", isNumber, isArbitraryVariableLength, isArbitraryLength];
  const scaleLineStyle = () => ["solid", "dashed", "dotted", "double"];
  const scaleBlendMode = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const scaleBlur = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleOrigin = () => ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryVariable, isArbitraryValue];
  const scaleRotate = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleScale = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleSkew = () => [isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleTranslate = () => [isFraction, "full", ...scaleUnambiguousSpacing()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...scalePosition(), isArbitraryValue, isArbitraryVariable]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: scaleInset()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryValue, themeFont]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "space", "round"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: [isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [themeColor]
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", isArbitraryVariable, isArbitraryValue, themeInsetShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scaleOrigin()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scaleOrigin()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["before", "after", "placeholder", "file", "marker", "selection", "first-line", "first-letter", "backdrop", "*", "**"]
  };
};
const mergeConfigs = (baseConfig, {
  cacheSize,
  prefix,
  experimentalParseClassName,
  extend: extend3 = {},
  override = {}
}) => {
  overrideProperty(baseConfig, "cacheSize", cacheSize);
  overrideProperty(baseConfig, "prefix", prefix);
  overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
  overrideConfigProperties(baseConfig.theme, override.theme);
  overrideConfigProperties(baseConfig.classGroups, override.classGroups);
  overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
  overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
  overrideProperty(baseConfig, "orderSensitiveModifiers", override.orderSensitiveModifiers);
  mergeConfigProperties(baseConfig.theme, extend3.theme);
  mergeConfigProperties(baseConfig.classGroups, extend3.classGroups);
  mergeConfigProperties(baseConfig.conflictingClassGroups, extend3.conflictingClassGroups);
  mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend3.conflictingClassGroupModifiers);
  mergeArrayProperties(baseConfig, extend3, "orderSensitiveModifiers");
  return baseConfig;
};
const overrideProperty = (baseObject, overrideKey, overrideValue) => {
  if (overrideValue !== void 0) {
    baseObject[overrideKey] = overrideValue;
  }
};
const overrideConfigProperties = (baseObject, overrideObject) => {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
};
const mergeConfigProperties = (baseObject, mergeObject) => {
  if (mergeObject) {
    for (const key in mergeObject) {
      mergeArrayProperties(baseObject, mergeObject, key);
    }
  }
};
const mergeArrayProperties = (baseObject, mergeObject, key) => {
  const mergeValue = mergeObject[key];
  if (mergeValue !== void 0) {
    baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
  }
};
const extendTailwindMerge = (configExtension, ...createConfig) => typeof configExtension === "function" ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
const twMerge$1 = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
var ie$1 = { twMerge: true, twMergeConfig: {}, responsiveVariants: false }, x$3 = (s2) => s2 || void 0, N$3 = (...s2) => x$3(y$8(s2).filter(Boolean).join(" ")), R$5 = null, v$5 = {}, q$2 = false, M$4 = (...s2) => (b$12) => b$12.twMerge ? ((!R$5 || q$2) && (q$2 = false, R$5 = u$b(v$5) ? twMerge$1 : extendTailwindMerge({ ...v$5, extend: { theme: v$5.theme, classGroups: v$5.classGroups, conflictingClassGroupModifiers: v$5.conflictingClassGroupModifiers, conflictingClassGroups: v$5.conflictingClassGroups, ...v$5.extend } })), x$3(R$5(N$3(s2)))) : N$3(s2), _$5 = (s2, b2) => {
  for (let e3 in b2) s2.hasOwnProperty(e3) ? s2[e3] = N$3(s2[e3], b2[e3]) : s2[e3] = b2[e3];
  return s2;
}, ce$1 = (s2, b$12) => {
  let { extend: e3 = null, slots: O2 = {}, variants: U2 = {}, compoundVariants: W = [], compoundSlots: C2 = [], defaultVariants: z2 = {} } = s2, m2 = { ...ie$1, ...b$12 }, k2 = e3 != null && e3.base ? N$3(e3.base, s2 == null ? void 0 : s2.base) : s2 == null ? void 0 : s2.base, g$12 = e3 != null && e3.variants && !u$b(e3.variants) ? p$u(U2, e3.variants) : U2, w2 = e3 != null && e3.defaultVariants && !u$b(e3.defaultVariants) ? { ...e3.defaultVariants, ...z2 } : z2;
  !u$b(m2.twMergeConfig) && !x$4(m2.twMergeConfig, v$5) && (q$2 = true, v$5 = m2.twMergeConfig);
  let S2 = u$b(e3 == null ? void 0 : e3.slots), T2 = u$b(O2) ? {} : { base: N$3(s2 == null ? void 0 : s2.base, S2 && (e3 == null ? void 0 : e3.base)), ...O2 }, j2 = S2 ? T2 : _$5({ ...e3 == null ? void 0 : e3.slots }, u$b(T2) ? { base: s2 == null ? void 0 : s2.base } : T2), h$12 = u$b(e3 == null ? void 0 : e3.compoundVariants) ? W : a$y(e3 == null ? void 0 : e3.compoundVariants, W), V2 = (l2) => {
    if (u$b(g$12) && u$b(O2) && S2) return M$4(k2, l2 == null ? void 0 : l2.class, l2 == null ? void 0 : l2.className)(m2);
    if (h$12 && !Array.isArray(h$12)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof h$12}`);
    if (C2 && !Array.isArray(C2)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof C2}`);
    let P2 = (a2, n2, t2 = [], i2) => {
      let r2 = t2;
      if (typeof n2 == "string") r2 = r2.concat(g$5(n2).split(" ").map((o3) => `${a2}:${o3}`));
      else if (Array.isArray(n2)) r2 = r2.concat(n2.reduce((o3, c2) => o3.concat(`${a2}:${c2}`), []));
      else if (typeof n2 == "object" && typeof i2 == "string") {
        for (let o3 in n2) if (n2.hasOwnProperty(o3) && o3 === i2) {
          let c2 = n2[o3];
          if (c2 && typeof c2 == "string") {
            let u2 = g$5(c2);
            r2[i2] ? r2[i2] = r2[i2].concat(u2.split(" ").map((f2) => `${a2}:${f2}`)) : r2[i2] = u2.split(" ").map((f2) => `${a2}:${f2}`);
          } else Array.isArray(c2) && c2.length > 0 && (r2[i2] = c2.reduce((u2, f2) => u2.concat(`${a2}:${f2}`), []));
        }
      }
      return r2;
    }, D2 = (a$12, n2 = g$12, t2 = null, i2 = null) => {
      var L2;
      let r2 = n2[a$12];
      if (!r2 || u$b(r2)) return null;
      let o3 = (L2 = i2 == null ? void 0 : i2[a$12]) != null ? L2 : l2 == null ? void 0 : l2[a$12];
      if (o3 === null) return null;
      let c2 = l$n(o3), u2 = Array.isArray(m2.responsiveVariants) && m2.responsiveVariants.length > 0 || m2.responsiveVariants === true, f2 = w2 == null ? void 0 : w2[a$12], d2 = [];
      if (typeof c2 == "object" && u2) for (let [E2, Q2] of Object.entries(c2)) {
        let ne2 = r2[Q2];
        if (E2 === "initial") {
          f2 = Q2;
          continue;
        }
        Array.isArray(m2.responsiveVariants) && !m2.responsiveVariants.includes(E2) || (d2 = P2(E2, ne2, d2, t2));
      }
      let $2 = c2 != null && typeof c2 != "object" ? c2 : l$n(f2), A2 = r2[$2 || "false"];
      return typeof d2 == "object" && typeof t2 == "string" && d2[t2] ? _$5(d2, A2) : d2.length > 0 ? (d2.push(A2), t2 === "base" ? d2.join(" ") : d2) : A2;
    }, p2 = () => g$12 ? Object.keys(g$12).map((a2) => D2(a2, g$12)) : null, ee2 = (a2, n2) => {
      if (!g$12 || typeof g$12 != "object") return null;
      let t2 = new Array();
      for (let i2 in g$12) {
        let r2 = D2(i2, g$12, a2, n2), o3 = a2 === "base" && typeof r2 == "string" ? r2 : r2 && r2[a2];
        o3 && (t2[t2.length] = o3);
      }
      return t2;
    }, H2 = {};
    for (let a2 in l2) l2[a2] !== void 0 && (H2[a2] = l2[a2]);
    let I2 = (a2, n2) => {
      var i2;
      let t2 = typeof (l2 == null ? void 0 : l2[a2]) == "object" ? { [a2]: (i2 = l2[a2]) == null ? void 0 : i2.initial } : {};
      return { ...w2, ...H2, ...t2, ...n2 };
    }, J = (a2 = [], n2) => {
      let t2 = [];
      for (let { class: i2, className: r2, ...o3 } of a2) {
        let c2 = true;
        for (let [u2, f2] of Object.entries(o3)) {
          let d2 = I2(u2, n2)[u2];
          if (Array.isArray(f2)) {
            if (!f2.includes(d2)) {
              c2 = false;
              break;
            }
          } else {
            let $2 = (A2) => A2 == null || A2 === false;
            if ($2(f2) && $2(d2)) continue;
            if (d2 !== f2) {
              c2 = false;
              break;
            }
          }
        }
        c2 && (i2 && t2.push(i2), r2 && t2.push(r2));
      }
      return t2;
    }, te2 = (a2) => {
      let n2 = J(h$12, a2);
      if (!Array.isArray(n2)) return n2;
      let t2 = {};
      for (let i2 of n2) if (typeof i2 == "string" && (t2.base = M$4(t2.base, i2)(m2)), typeof i2 == "object") for (let [r2, o3] of Object.entries(i2)) t2[r2] = M$4(t2[r2], o3)(m2);
      return t2;
    }, ae2 = (a2) => {
      if (C2.length < 1) return null;
      let n2 = {};
      for (let { slots: t2 = [], class: i2, className: r2, ...o3 } of C2) {
        if (!u$b(o3)) {
          let c2 = true;
          for (let u2 of Object.keys(o3)) {
            let f2 = I2(u2, a2)[u2];
            if (f2 === void 0 || (Array.isArray(o3[u2]) ? !o3[u2].includes(f2) : o3[u2] !== f2)) {
              c2 = false;
              break;
            }
          }
          if (!c2) continue;
        }
        for (let c2 of t2) n2[c2] = n2[c2] || [], n2[c2].push([i2, r2]);
      }
      return n2;
    };
    if (!u$b(O2) || !S2) {
      let a2 = {};
      if (typeof j2 == "object" && !u$b(j2)) for (let n2 of Object.keys(j2)) a2[n2] = (t2) => {
        var i2, r2;
        return M$4(j2[n2], ee2(n2, t2), ((i2 = te2(t2)) != null ? i2 : [])[n2], ((r2 = ae2(t2)) != null ? r2 : [])[n2], t2 == null ? void 0 : t2.class, t2 == null ? void 0 : t2.className)(m2);
      };
      return a2;
    }
    return M$4(k2, p2(), J(h$12), l2 == null ? void 0 : l2.class, l2 == null ? void 0 : l2.className)(m2);
  }, K2 = () => {
    if (!(!g$12 || typeof g$12 != "object")) return Object.keys(g$12);
  };
  return V2.variantKeys = K2(), V2.extend = e3, V2.base = k2, V2.slots = j2, V2.variants = g$12, V2.defaultVariants = w2, V2.compoundSlots = C2, V2.compoundVariants = h$12, V2;
}, fe$2 = (s2) => (b2, e3) => ce$1(b2, e3 ? p$u(s2, e3) : s2);
const twMergeConfig = {
  extend: {
    theme: {
      spacing: Object.keys(FullTailwindConfig.theme?.spacing || {})
    },
    classGroups: {
      "font-size": Object.keys(FullTailwindConfig.theme?.fontSize || {}).map((v2) => `text-${v2}`),
      "text-color": Object.keys(FullTailwindConfig.theme?.colors || {}).map((v2) => `text-${v2}`)
    }
  }
};
const twMerge = extendTailwindMerge$1(twMergeConfig);
const tv = fe$2({
  twMergeConfig
});
function r$d(e3) {
  var t2, f2, n2 = "";
  if ("string" == typeof e3 || "number" == typeof e3) n2 += e3;
  else if ("object" == typeof e3) if (Array.isArray(e3)) {
    var o3 = e3.length;
    for (t2 = 0; t2 < o3; t2++) e3[t2] && (f2 = r$d(e3[t2])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e3) e3[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e3, t2, f2 = 0, n2 = "", o3 = arguments.length; f2 < o3; f2++) (e3 = arguments[f2]) && (t2 = r$d(e3)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const baseClasses$3 = "text-warm-gray-900";
const headingClasses$1 = {
  h1: "text-h1 mobile-d:text-h1-sm font-dazzed font-bold",
  h2: "text-h2 mobile-d:text-h2-sm font-dazzed font-bold",
  h3: "text-h3 mobile-d:text-h3-sm font-dazzed font-bold",
  h4: "text-h4 mobile-d:text-h4-sm font-dazzed font-semibold",
  h5: "text-h5 mobile-d:text-h5-sm font-medium",
  h6: "text-h6 mobile-d:text-h6-sm font-medium"
};
const defaultMarginClasses$1 = {
  h1: "mb-e12",
  h2: "mb-e16",
  h3: "mb-e16",
  h4: "mb-e16",
  h5: "mb-e8",
  h6: "mb-e16"
};
const breakWordsClasses = "inline-block overflow-hidden break-words";
const Heading = ({
  level = "h1",
  as,
  className,
  children,
  noDefaultMargins = false,
  breakWords,
  ...props
}) => {
  const asElement = as || level;
  return createElement(
    asElement,
    {
      className: twMerge(
        clsx(
          baseClasses$3,
          headingClasses$1[level],
          {
            [defaultMarginClasses$1[level]]: !noDefaultMargins,
            // @TODO(juan): these are still not confirmed with kim
            [breakWordsClasses]: breakWords
          },
          className
        )
      ),
      ...props
    },
    children
  );
};
const rootClasses$2 = clsx(
  "w-full",
  "flex flex-col",
  "rounded-xxxl border border-warm-gray-200 bg-white",
  "divide-y divide-warm-gray-200"
);
const headingClasses = clsx("m-e32");
const NO_ID_FALLBACK = "NO_ID_PROVIDED";
const getTestingId = (componentConfig, componentPart, ids) => {
  const finalId = ids["data-testid"] ?? ids.id ?? NO_ID_FALLBACK;
  const baseId = componentConfig.BASE ? `-${componentConfig.BASE}` : "";
  const componentId = componentConfig[componentPart] ? `-${componentConfig[componentPart]}` : "";
  return componentPart === "BASE" ? `${finalId}${baseId}` : `${finalId}${baseId}${componentId}`;
};
const getDataTestIdProps = (...params) => {
  return {
    "data-testid": getTestingId(...params)
  };
};
const useDataTestIds = ({
  componentConfig,
  ids
}) => {
  const idData = useMemo(() => {
    return Object.keys(componentConfig).reduce((acc, key) => {
      acc[key] = getDataTestIdProps(componentConfig, key, ids);
      return acc;
    }, {});
  }, [componentConfig, ids]);
  return idData;
};
const TEST_IDS_CONFIG$m = {
  BASE: "",
  TITLE: "title"
};
const Accordion = ({
  title,
  className,
  titleClassName,
  children,
  ...props
}) => {
  const rootClassName = clsx(rootClasses$2, className);
  const headingClassName = clsx(headingClasses, titleClassName);
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$m,
    ids: props
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ...props,
      ...testIds.BASE,
      className: rootClassName,
      children: [
        title && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Heading,
          {
            level: "h3",
            className: headingClassName,
            breakWords: true,
            ...testIds.TITLE,
            children: title
          }
        ),
        children
      ]
    }
  );
};
var i$s = Object.defineProperty;
var d$b = (t2, e3, n2) => e3 in t2 ? i$s(t2, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t2[e3] = n2;
var r$c = (t2, e3, n2) => (d$b(t2, typeof e3 != "symbol" ? e3 + "" : e3, n2), n2);
let o$e = class o {
  constructor() {
    r$c(this, "current", this.detect());
    r$c(this, "handoffState", "pending");
    r$c(this, "currentId", 0);
  }
  set(e3) {
    this.current !== e3 && (this.handoffState = "pending", this.currentId = 0, this.current = e3);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
};
let s$x = new o$e();
let l$m = (e3, f2) => {
  s$x.isServer ? useEffect(e3, f2) : useLayoutEffect(e3, f2);
};
function s$w(e3) {
  let r2 = useRef(e3);
  return l$m(() => {
    r2.current = e3;
  }, [e3]), r2;
}
let o$d = function(t2) {
  let e3 = s$w(t2);
  return a__default.useCallback((...r2) => e3.current(...r2), [e3]);
};
function T$3(l2, r2, c2) {
  let [i2, s2] = useState(c2), e3 = l2 !== void 0, t2 = useRef(e3), u2 = useRef(false), d2 = useRef(false);
  return e3 && !t2.current && !u2.current ? (u2.current = true, t2.current = e3, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e3 && t2.current && !d2.current && (d2.current = true, t2.current = e3, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [e3 ? l2 : i2, o$d((n2) => (e3 || s2(n2), r2 == null ? void 0 : r2(n2)))];
}
function t$F(e3) {
  typeof queueMicrotask == "function" ? queueMicrotask(e3) : Promise.resolve().then(e3).catch((o3) => setTimeout(() => {
    throw o3;
  }));
}
function o$c() {
  let n2 = [], r2 = { addEventListener(e3, t2, s2, a2) {
    return e3.addEventListener(t2, s2, a2), r2.add(() => e3.removeEventListener(t2, s2, a2));
  }, requestAnimationFrame(...e3) {
    let t2 = requestAnimationFrame(...e3);
    return r2.add(() => cancelAnimationFrame(t2));
  }, nextFrame(...e3) {
    return r2.requestAnimationFrame(() => r2.requestAnimationFrame(...e3));
  }, setTimeout(...e3) {
    let t2 = setTimeout(...e3);
    return r2.add(() => clearTimeout(t2));
  }, microTask(...e3) {
    let t2 = { current: true };
    return t$F(() => {
      t2.current && e3[0]();
    }), r2.add(() => {
      t2.current = false;
    });
  }, style(e3, t2, s2) {
    let a2 = e3.style.getPropertyValue(t2);
    return Object.assign(e3.style, { [t2]: s2 }), this.add(() => {
      Object.assign(e3.style, { [t2]: a2 });
    });
  }, group(e3) {
    let t2 = o$c();
    return e3(t2), this.add(() => t2.dispose());
  }, add(e3) {
    return n2.push(e3), () => {
      let t2 = n2.indexOf(e3);
      if (t2 >= 0) for (let s2 of n2.splice(t2, 1)) s2();
    };
  }, dispose() {
    for (let e3 of n2.splice(0)) e3();
  } };
  return r2;
}
function p$t() {
  let [e3] = useState(o$c);
  return useEffect(() => () => e3.dispose(), [e3]), e3;
}
function s$v() {
  let r2 = typeof document == "undefined";
  return "useSyncExternalStore" in a$z ? ((o3) => o3.useSyncExternalStore)(a$z)(() => () => {
  }, () => false, () => !r2) : false;
}
function l$l() {
  let r2 = s$v(), [e3, n2] = a$z.useState(s$x.isHandoffComplete);
  return e3 && s$x.isHandoffComplete === false && n2(false), a$z.useEffect(() => {
    e3 !== true && n2(true);
  }, [e3]), a$z.useEffect(() => s$x.handoff(), []), r2 ? false : e3;
}
var o$b;
let I$b = (o$b = a__default.useId) != null ? o$b : function() {
  let n2 = l$l(), [e3, u2] = a__default.useState(n2 ? () => s$x.nextId() : null);
  return l$m(() => {
    e3 === null && u2(s$x.nextId());
  }, [e3]), e3 != null ? "" + e3 : void 0;
};
function u$a(r2, n2, ...a2) {
  if (r2 in n2) {
    let e3 = n2[r2];
    return typeof e3 == "function" ? e3(...a2) : e3;
  }
  let t2 = new Error(`Tried to handle "${r2}" but there is no handler defined. Only defined handlers are: ${Object.keys(n2).map((e3) => `"${e3}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t2, u$a), t2;
}
function o$a(r2) {
  return s$x.isServer ? null : r2 instanceof Node ? r2.ownerDocument : r2 != null && r2.hasOwnProperty("current") && r2.current instanceof Node ? r2.current.ownerDocument : document;
}
let c$s = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e3) => `${e3}:not([tabindex='-1'])`).join(",");
var M$3 = ((n2) => (n2[n2.First = 1] = "First", n2[n2.Previous = 2] = "Previous", n2[n2.Next = 4] = "Next", n2[n2.Last = 8] = "Last", n2[n2.WrapAround = 16] = "WrapAround", n2[n2.NoScroll = 32] = "NoScroll", n2))(M$3 || {}), N$2 = ((o3) => (o3[o3.Error = 0] = "Error", o3[o3.Overflow = 1] = "Overflow", o3[o3.Success = 2] = "Success", o3[o3.Underflow = 3] = "Underflow", o3))(N$2 || {}), F$6 = ((t2) => (t2[t2.Previous = -1] = "Previous", t2[t2.Next = 1] = "Next", t2))(F$6 || {});
function f$v(e3 = document.body) {
  return e3 == null ? [] : Array.from(e3.querySelectorAll(c$s)).sort((r2, t2) => Math.sign((r2.tabIndex || Number.MAX_SAFE_INTEGER) - (t2.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var T$2 = ((t2) => (t2[t2.Strict = 0] = "Strict", t2[t2.Loose = 1] = "Loose", t2))(T$2 || {});
function h$6(e3, r2 = 0) {
  var t2;
  return e3 === ((t2 = o$a(e3)) == null ? void 0 : t2.body) ? false : u$a(r2, { [0]() {
    return e3.matches(c$s);
  }, [1]() {
    let l2 = e3;
    for (; l2 !== null; ) {
      if (l2.matches(c$s)) return true;
      l2 = l2.parentElement;
    }
    return false;
  } });
}
function D$5(e3) {
  let r2 = o$a(e3);
  o$c().nextFrame(() => {
    r2 && !h$6(r2.activeElement, 0) && y$7(e3);
  });
}
var w$a = ((t2) => (t2[t2.Keyboard = 0] = "Keyboard", t2[t2.Mouse = 1] = "Mouse", t2))(w$a || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e3) => {
  e3.metaKey || e3.altKey || e3.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true), document.addEventListener("click", (e3) => {
  e3.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e3.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true));
function y$7(e3) {
  e3 == null || e3.focus({ preventScroll: true });
}
let S$5 = ["textarea", "input"].join(",");
function H(e3) {
  var r2, t2;
  return (t2 = (r2 = e3 == null ? void 0 : e3.matches) == null ? void 0 : r2.call(e3, S$5)) != null ? t2 : false;
}
function I$a(e3, r2 = (t2) => t2) {
  return e3.slice().sort((t2, l2) => {
    let o3 = r2(t2), i2 = r2(l2);
    if (o3 === null || i2 === null) return 0;
    let n2 = o3.compareDocumentPosition(i2);
    return n2 & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n2 & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function _$4(e3, r2) {
  return O$2(f$v(), r2, { relativeTo: e3 });
}
function O$2(e3, r2, { sorted: t2 = true, relativeTo: l2 = null, skipElements: o3 = [] } = {}) {
  let i2 = Array.isArray(e3) ? e3.length > 0 ? e3[0].ownerDocument : document : e3.ownerDocument, n2 = Array.isArray(e3) ? t2 ? I$a(e3) : e3 : f$v(e3);
  o3.length > 0 && n2.length > 1 && (n2 = n2.filter((s2) => !o3.includes(s2))), l2 = l2 != null ? l2 : i2.activeElement;
  let E2 = (() => {
    if (r2 & 5) return 1;
    if (r2 & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), x2 = (() => {
    if (r2 & 1) return 0;
    if (r2 & 2) return Math.max(0, n2.indexOf(l2)) - 1;
    if (r2 & 4) return Math.max(0, n2.indexOf(l2)) + 1;
    if (r2 & 8) return n2.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p2 = r2 & 32 ? { preventScroll: true } : {}, d2 = 0, a2 = n2.length, u2;
  do {
    if (d2 >= a2 || d2 + a2 <= 0) return 0;
    let s2 = x2 + d2;
    if (r2 & 16) s2 = (s2 + a2) % a2;
    else {
      if (s2 < 0) return 3;
      if (s2 >= a2) return 1;
    }
    u2 = n2[s2], u2 == null || u2.focus(p2), d2 += E2;
  } while (u2 !== i2.activeElement);
  return r2 & 6 && H(u2) && u2.select(), 2;
}
function t$E() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i$r() {
  return /Android/gi.test(window.navigator.userAgent);
}
function n$k() {
  return t$E() || i$r();
}
function d$a(e3, r2, n2) {
  let o3 = s$w(r2);
  useEffect(() => {
    function t2(u2) {
      o3.current(u2);
    }
    return document.addEventListener(e3, t2, n2), () => document.removeEventListener(e3, t2, n2);
  }, [e3, n2]);
}
function s$u(e3, r2, n2) {
  let o3 = s$w(r2);
  useEffect(() => {
    function t2(i2) {
      o3.current(i2);
    }
    return window.addEventListener(e3, t2, n2), () => window.removeEventListener(e3, t2, n2);
  }, [e3, n2]);
}
function y$6(s2, m2, a2 = true) {
  let i2 = useRef(false);
  useEffect(() => {
    requestAnimationFrame(() => {
      i2.current = a2;
    });
  }, [a2]);
  function c2(e3, r2) {
    if (!i2.current || e3.defaultPrevented) return;
    let t2 = r2(e3);
    if (t2 === null || !t2.getRootNode().contains(t2) || !t2.isConnected) return;
    let E2 = function u2(n2) {
      return typeof n2 == "function" ? u2(n2()) : Array.isArray(n2) || n2 instanceof Set ? n2 : [n2];
    }(s2);
    for (let u2 of E2) {
      if (u2 === null) continue;
      let n2 = u2 instanceof HTMLElement ? u2 : u2.current;
      if (n2 != null && n2.contains(t2) || e3.composed && e3.composedPath().includes(n2)) return;
    }
    return !h$6(t2, T$2.Loose) && t2.tabIndex !== -1 && e3.preventDefault(), m2(e3, t2);
  }
  let o3 = useRef(null);
  d$a("pointerdown", (e3) => {
    var r2, t2;
    i2.current && (o3.current = ((t2 = (r2 = e3.composedPath) == null ? void 0 : r2.call(e3)) == null ? void 0 : t2[0]) || e3.target);
  }, true), d$a("mousedown", (e3) => {
    var r2, t2;
    i2.current && (o3.current = ((t2 = (r2 = e3.composedPath) == null ? void 0 : r2.call(e3)) == null ? void 0 : t2[0]) || e3.target);
  }, true), d$a("click", (e3) => {
    n$k() || o3.current && (c2(e3, () => o3.current), o3.current = null);
  }, true), d$a("touchend", (e3) => c2(e3, () => e3.target instanceof HTMLElement ? e3.target : null), true), s$u("blur", (e3) => c2(e3, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), true);
}
function n$j(...e3) {
  return useMemo(() => o$a(...e3), [...e3]);
}
function i$q(t2) {
  var n2;
  if (t2.type) return t2.type;
  let e3 = (n2 = t2.as) != null ? n2 : "button";
  if (typeof e3 == "string" && e3.toLowerCase() === "button") return "button";
}
function T$1(t2, e3) {
  let [n2, u2] = useState(() => i$q(t2));
  return l$m(() => {
    u2(i$q(t2));
  }, [t2.type, t2.as]), l$m(() => {
    n2 || e3.current && e3.current instanceof HTMLButtonElement && !e3.current.hasAttribute("type") && u2("button");
  }, [n2, e3]), n2;
}
let u$9 = Symbol();
function T(t2, n2 = true) {
  return Object.assign(t2, { [u$9]: n2 });
}
function y$5(...t2) {
  let n2 = useRef(t2);
  useEffect(() => {
    n2.current = t2;
  }, [t2]);
  let c2 = o$d((e3) => {
    for (let o3 of n2.current) o3 != null && (typeof o3 == "function" ? o3(e3) : o3.current = e3);
  });
  return t2.every((e3) => e3 == null || (e3 == null ? void 0 : e3[u$9])) ? void 0 : c2;
}
function t$D(e3) {
  return [e3.screenX, e3.screenY];
}
function u$8() {
  let e3 = useRef([-1, -1]);
  return { wasMoved(r2) {
    let n2 = t$D(r2);
    return e3.current[0] === n2[0] && e3.current[1] === n2[1] ? false : (e3.current = n2, true);
  }, update(r2) {
    e3.current = t$D(r2);
  } };
}
function F$5({ container: e3, accept: t2, walk: r2, enabled: c2 = true }) {
  let o3 = useRef(t2), l2 = useRef(r2);
  useEffect(() => {
    o3.current = t2, l2.current = r2;
  }, [t2, r2]), l$m(() => {
    if (!e3 || !c2) return;
    let n2 = o$a(e3);
    if (!n2) return;
    let f2 = o3.current, p2 = l2.current, d2 = Object.assign((i2) => f2(i2), { acceptNode: f2 }), u2 = n2.createTreeWalker(e3, NodeFilter.SHOW_ELEMENT, d2, false);
    for (; u2.nextNode(); ) p2(u2.currentNode);
  }, [e3, c2, o3, l2]);
}
function m$m(u2, t2) {
  let e3 = useRef([]), r2 = o$d(u2);
  useEffect(() => {
    let o3 = [...e3.current];
    for (let [n2, a2] of t2.entries()) if (e3.current[n2] !== a2) {
      let l2 = r2(t2, o3);
      return e3.current = t2, l2;
    }
  }, [r2, ...t2]);
}
function t$C(...r2) {
  return Array.from(new Set(r2.flatMap((n2) => typeof n2 == "string" ? n2.split(" ") : []))).filter(Boolean).join(" ");
}
var O$1 = ((n2) => (n2[n2.None = 0] = "None", n2[n2.RenderStrategy = 1] = "RenderStrategy", n2[n2.Static = 2] = "Static", n2))(O$1 || {}), v$4 = ((e3) => (e3[e3.Unmount = 0] = "Unmount", e3[e3.Hidden = 1] = "Hidden", e3))(v$4 || {});
function C$4({ ourProps: r2, theirProps: t2, slot: e3, defaultTag: n2, features: o3, visible: a2 = true, name: f2, mergeRefs: l2 }) {
  l2 = l2 != null ? l2 : k$3;
  let s2 = R$4(t2, r2);
  if (a2) return m$l(s2, e3, n2, f2, l2);
  let y2 = o3 != null ? o3 : 0;
  if (y2 & 2) {
    let { static: u2 = false, ...d2 } = s2;
    if (u2) return m$l(d2, e3, n2, f2, l2);
  }
  if (y2 & 1) {
    let { unmount: u2 = true, ...d2 } = s2;
    return u$a(u2 ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return m$l({ ...d2, hidden: true, style: { display: "none" } }, e3, n2, f2, l2);
    } });
  }
  return m$l(s2, e3, n2, f2, l2);
}
function m$l(r2, t2 = {}, e3, n2, o3) {
  let { as: a2 = e3, children: f2, refName: l2 = "ref", ...s2 } = F$4(r2, ["unmount", "static"]), y2 = r2.ref !== void 0 ? { [l2]: r2.ref } : {}, u2 = typeof f2 == "function" ? f2(t2) : f2;
  "className" in s2 && s2.className && typeof s2.className == "function" && (s2.className = s2.className(t2));
  let d2 = {};
  if (t2) {
    let i2 = false, c2 = [];
    for (let [T2, p2] of Object.entries(t2)) typeof p2 == "boolean" && (i2 = true), p2 === true && c2.push(T2);
    i2 && (d2["data-headlessui-state"] = c2.join(" "));
  }
  if (a2 === Fragment && Object.keys(x$2(s2)).length > 0) {
    if (!isValidElement(u2) || Array.isArray(u2) && u2.length > 1) throw new Error(['Passing props on "Fragment"!', "", `The current component <${n2} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s2).map((p2) => `  - ${p2}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p2) => `  - ${p2}`).join(`
`)].join(`
`));
    let i2 = u2.props, c2 = typeof (i2 == null ? void 0 : i2.className) == "function" ? (...p2) => t$C(i2 == null ? void 0 : i2.className(...p2), s2.className) : t$C(i2 == null ? void 0 : i2.className, s2.className), T2 = c2 ? { className: c2 } : {};
    return cloneElement(u2, Object.assign({}, R$4(u2.props, x$2(F$4(s2, ["ref"]))), d2, y2, { ref: o3(u2.ref, y2.ref) }, T2));
  }
  return createElement(a2, Object.assign({}, F$4(s2, ["ref"]), a2 !== Fragment && y2, a2 !== Fragment && d2), u2);
}
function I$9() {
  let r2 = useRef([]), t2 = useCallback((e3) => {
    for (let n2 of r2.current) n2 != null && (typeof n2 == "function" ? n2(e3) : n2.current = e3);
  }, []);
  return (...e3) => {
    if (!e3.every((n2) => n2 == null)) return r2.current = e3, t2;
  };
}
function k$3(...r2) {
  return r2.every((t2) => t2 == null) ? void 0 : (t2) => {
    for (let e3 of r2) e3 != null && (typeof e3 == "function" ? e3(t2) : e3.current = t2);
  };
}
function R$4(...r2) {
  if (r2.length === 0) return {};
  if (r2.length === 1) return r2[0];
  let t2 = {}, e3 = {};
  for (let o3 of r2) for (let a2 in o3) a2.startsWith("on") && typeof o3[a2] == "function" ? (e3[a2] != null || (e3[a2] = []), e3[a2].push(o3[a2])) : t2[a2] = o3[a2];
  if (t2.disabled || t2["aria-disabled"]) return Object.assign(t2, Object.fromEntries(Object.keys(e3).map((o3) => [o3, void 0])));
  for (let o3 in e3) Object.assign(t2, { [o3](a2, ...f2) {
    let l2 = e3[o3];
    for (let s2 of l2) {
      if ((a2 instanceof Event || (a2 == null ? void 0 : a2.nativeEvent) instanceof Event) && a2.defaultPrevented) return;
      s2(a2, ...f2);
    }
  } });
  return t2;
}
function U$3(r2) {
  var t2;
  return Object.assign(forwardRef(r2), { displayName: (t2 = r2.displayName) != null ? t2 : r2.name });
}
function x$2(r2) {
  let t2 = Object.assign({}, r2);
  for (let e3 in t2) t2[e3] === void 0 && delete t2[e3];
  return t2;
}
function F$4(r2, t2 = []) {
  let e3 = Object.assign({}, r2);
  for (let n2 of t2) n2 in e3 && delete e3[n2];
  return e3;
}
let p$s = "div";
var s$t = ((e3) => (e3[e3.None = 1] = "None", e3[e3.Focusable = 2] = "Focusable", e3[e3.Hidden = 4] = "Hidden", e3))(s$t || {});
function l$k(d2, o3) {
  var n2;
  let { features: t2 = 1, ...e3 } = d2, r2 = { ref: o3, "aria-hidden": (t2 & 2) === 2 ? true : (n2 = e3["aria-hidden"]) != null ? n2 : void 0, hidden: (t2 & 4) === 4 ? true : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(t2 & 4) === 4 && (t2 & 2) !== 2 && { display: "none" } } };
  return C$4({ ourProps: r2, theirProps: e3, slot: {}, defaultTag: p$s, name: "Hidden" });
}
let u$7 = U$3(l$k);
let n$i = createContext(null);
n$i.displayName = "OpenClosedContext";
var d$9 = ((e3) => (e3[e3.Open = 1] = "Open", e3[e3.Closed = 2] = "Closed", e3[e3.Closing = 4] = "Closing", e3[e3.Opening = 8] = "Opening", e3))(d$9 || {});
function u$6() {
  return useContext(n$i);
}
function s$s({ value: o3, children: r2 }) {
  return a__default.createElement(n$i.Provider, { value: o3 }, r2);
}
function t$B(n2) {
  function e3() {
    document.readyState !== "loading" && (n2(), document.removeEventListener("DOMContentLoaded", e3));
  }
  typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e3), e3());
}
let t$A = [];
t$B(() => {
  function e3(n2) {
    n2.target instanceof HTMLElement && n2.target !== document.body && t$A[0] !== n2.target && (t$A.unshift(n2.target), t$A = t$A.filter((r2) => r2 != null && r2.isConnected), t$A.splice(10));
  }
  window.addEventListener("click", e3, { capture: true }), window.addEventListener("mousedown", e3, { capture: true }), window.addEventListener("focus", e3, { capture: true }), document.body.addEventListener("click", e3, { capture: true }), document.body.addEventListener("mousedown", e3, { capture: true }), document.body.addEventListener("focus", e3, { capture: true });
});
function r$b(n2) {
  let e3 = n2.parentElement, l2 = null;
  for (; e3 && !(e3 instanceof HTMLFieldSetElement); ) e3 instanceof HTMLLegendElement && (l2 = e3), e3 = e3.parentElement;
  let t2 = (e3 == null ? void 0 : e3.getAttribute("disabled")) === "";
  return t2 && i$p(l2) ? false : t2;
}
function i$p(n2) {
  if (!n2) return false;
  let e3 = n2.previousElementSibling;
  for (; e3 !== null; ) {
    if (e3 instanceof HTMLLegendElement) return false;
    e3 = e3.previousElementSibling;
  }
  return true;
}
function u$5(l2) {
  throw new Error("Unexpected object: " + l2);
}
var c$r = ((i2) => (i2[i2.First = 0] = "First", i2[i2.Previous = 1] = "Previous", i2[i2.Next = 2] = "Next", i2[i2.Last = 3] = "Last", i2[i2.Specific = 4] = "Specific", i2[i2.Nothing = 5] = "Nothing", i2))(c$r || {});
function f$u(l2, n2) {
  let t2 = n2.resolveItems();
  if (t2.length <= 0) return null;
  let r2 = n2.resolveActiveIndex(), s2 = r2 != null ? r2 : -1;
  switch (l2.focus) {
    case 0: {
      for (let e3 = 0; e3 < t2.length; ++e3) if (!n2.resolveDisabled(t2[e3], e3, t2)) return e3;
      return r2;
    }
    case 1: {
      for (let e3 = s2 - 1; e3 >= 0; --e3) if (!n2.resolveDisabled(t2[e3], e3, t2)) return e3;
      return r2;
    }
    case 2: {
      for (let e3 = s2 + 1; e3 < t2.length; ++e3) if (!n2.resolveDisabled(t2[e3], e3, t2)) return e3;
      return r2;
    }
    case 3: {
      for (let e3 = t2.length - 1; e3 >= 0; --e3) if (!n2.resolveDisabled(t2[e3], e3, t2)) return e3;
      return r2;
    }
    case 4: {
      for (let e3 = 0; e3 < t2.length; ++e3) if (n2.resolveId(t2[e3], e3, t2) === l2.id) return e3;
      return r2;
    }
    case 5:
      return null;
    default:
      u$5(l2);
  }
}
function e$5(i2 = {}, s2 = null, t2 = []) {
  for (let [r2, n2] of Object.entries(i2)) o$9(t2, f$t(s2, r2), n2);
  return t2;
}
function f$t(i2, s2) {
  return i2 ? i2 + "[" + s2 + "]" : s2;
}
function o$9(i2, s2, t2) {
  if (Array.isArray(t2)) for (let [r2, n2] of t2.entries()) o$9(i2, f$t(s2, r2.toString()), n2);
  else t2 instanceof Date ? i2.push([s2, t2.toISOString()]) : typeof t2 == "boolean" ? i2.push([s2, t2 ? "1" : "0"]) : typeof t2 == "string" ? i2.push([s2, t2]) : typeof t2 == "number" ? i2.push([s2, `${t2}`]) : t2 == null ? i2.push([s2, ""]) : e$5(t2, s2, i2);
}
function p$r(i2) {
  var t2, r2;
  let s2 = (t2 = i2 == null ? void 0 : i2.form) != null ? t2 : i2.closest("form");
  if (s2) {
    for (let n2 of s2.elements) if (n2 !== i2 && (n2.tagName === "INPUT" && n2.type === "submit" || n2.tagName === "BUTTON" && n2.type === "submit" || n2.nodeName === "INPUT" && n2.type === "image")) {
      n2.click();
      return;
    }
    (r2 = s2.requestSubmit) == null || r2.call(s2);
  }
}
var o$8 = ((r2) => (r2.Space = " ", r2.Enter = "Enter", r2.Escape = "Escape", r2.Backspace = "Backspace", r2.Delete = "Delete", r2.ArrowLeft = "ArrowLeft", r2.ArrowUp = "ArrowUp", r2.ArrowRight = "ArrowRight", r2.ArrowDown = "ArrowDown", r2.Home = "Home", r2.End = "End", r2.PageUp = "PageUp", r2.PageDown = "PageDown", r2.Tab = "Tab", r2))(o$8 || {});
function E(n2, e3, a2, t2) {
  let i2 = s$w(a2);
  useEffect(() => {
    n2 = n2 != null ? n2 : window;
    function r2(o3) {
      i2.current(o3);
    }
    return n2.addEventListener(e3, r2, t2), () => n2.removeEventListener(e3, r2, t2);
  }, [n2, e3, t2]);
}
function f$s() {
  let e3 = useRef(false);
  return l$m(() => (e3.current = true, () => {
    e3.current = false;
  }), []), e3;
}
function c$q(t2) {
  let r2 = o$d(t2), e3 = useRef(false);
  useEffect(() => (e3.current = false, () => {
    e3.current = true, t$F(() => {
      e3.current && r2();
    });
  }), [r2]);
}
var s$r = ((r2) => (r2[r2.Forwards = 0] = "Forwards", r2[r2.Backwards = 1] = "Backwards", r2))(s$r || {});
function n$h() {
  let e3 = useRef(0);
  return s$u("keydown", (o3) => {
    o3.key === "Tab" && (e3.current = o3.shiftKey ? 1 : 0);
  }, true), e3;
}
function P$3(t2) {
  if (!t2) return /* @__PURE__ */ new Set();
  if (typeof t2 == "function") return new Set(t2());
  let n2 = /* @__PURE__ */ new Set();
  for (let e3 of t2.current) e3.current instanceof HTMLElement && n2.add(e3.current);
  return n2;
}
let X$1 = "div";
var _$3 = ((r2) => (r2[r2.None = 1] = "None", r2[r2.InitialFocus = 2] = "InitialFocus", r2[r2.TabLock = 4] = "TabLock", r2[r2.FocusLock = 8] = "FocusLock", r2[r2.RestoreFocus = 16] = "RestoreFocus", r2[r2.All = 30] = "All", r2))(_$3 || {});
function z(t2, n2) {
  let e3 = useRef(null), o3 = y$5(e3, n2), { initialFocus: l2, containers: c2, features: r2 = 30, ...s2 } = t2;
  l$l() || (r2 = 1);
  let i2 = n$j(e3);
  Y$1({ ownerDocument: i2 }, Boolean(r2 & 16));
  let u2 = Z$1({ ownerDocument: i2, container: e3, initialFocus: l2 }, Boolean(r2 & 2));
  $$2({ ownerDocument: i2, container: e3, containers: c2, previousActiveElement: u2 }, Boolean(r2 & 8));
  let y2 = n$h(), R2 = o$d((a2) => {
    let m2 = e3.current;
    if (!m2) return;
    ((B2) => B2())(() => {
      u$a(y2.current, { [s$r.Forwards]: () => {
        O$2(m2, M$3.First, { skipElements: [a2.relatedTarget] });
      }, [s$r.Backwards]: () => {
        O$2(m2, M$3.Last, { skipElements: [a2.relatedTarget] });
      } });
    });
  }), h2 = p$t(), H2 = useRef(false), j2 = { ref: o3, onKeyDown(a2) {
    a2.key == "Tab" && (H2.current = true, h2.requestAnimationFrame(() => {
      H2.current = false;
    }));
  }, onBlur(a2) {
    let m2 = P$3(c2);
    e3.current instanceof HTMLElement && m2.add(e3.current);
    let T2 = a2.relatedTarget;
    T2 instanceof HTMLElement && T2.dataset.headlessuiFocusGuard !== "true" && (S$4(m2, T2) || (H2.current ? O$2(e3.current, u$a(y2.current, { [s$r.Forwards]: () => M$3.Next, [s$r.Backwards]: () => M$3.Previous }) | M$3.WrapAround, { relativeTo: a2.target }) : a2.target instanceof HTMLElement && y$7(a2.target)));
  } };
  return a__default.createElement(a__default.Fragment, null, Boolean(r2 & 4) && a__default.createElement(u$7, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R2, features: s$t.Focusable }), C$4({ ourProps: j2, theirProps: s2, defaultTag: X$1, name: "FocusTrap" }), Boolean(r2 & 4) && a__default.createElement(u$7, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R2, features: s$t.Focusable }));
}
let D$4 = U$3(z), de$2 = Object.assign(D$4, { features: _$3 });
function Q$1(t2 = true) {
  let n2 = useRef(t$A.slice());
  return m$m(([e3], [o3]) => {
    o3 === true && e3 === false && t$F(() => {
      n2.current.splice(0);
    }), o3 === false && e3 === true && (n2.current = t$A.slice());
  }, [t2, t$A, n2]), o$d(() => {
    var e3;
    return (e3 = n2.current.find((o3) => o3 != null && o3.isConnected)) != null ? e3 : null;
  });
}
function Y$1({ ownerDocument: t2 }, n2) {
  let e3 = Q$1(n2);
  m$m(() => {
    n2 || (t2 == null ? void 0 : t2.activeElement) === (t2 == null ? void 0 : t2.body) && y$7(e3());
  }, [n2]), c$q(() => {
    n2 && y$7(e3());
  });
}
function Z$1({ ownerDocument: t2, container: n2, initialFocus: e3 }, o3) {
  let l2 = useRef(null), c2 = f$s();
  return m$m(() => {
    if (!o3) return;
    let r2 = n2.current;
    r2 && t$F(() => {
      if (!c2.current) return;
      let s2 = t2 == null ? void 0 : t2.activeElement;
      if (e3 != null && e3.current) {
        if ((e3 == null ? void 0 : e3.current) === s2) {
          l2.current = s2;
          return;
        }
      } else if (r2.contains(s2)) {
        l2.current = s2;
        return;
      }
      e3 != null && e3.current ? y$7(e3.current) : O$2(r2, M$3.First) === N$2.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l2.current = t2 == null ? void 0 : t2.activeElement;
    });
  }, [o3]), l2;
}
function $$2({ ownerDocument: t2, container: n2, containers: e3, previousActiveElement: o3 }, l2) {
  let c2 = f$s();
  E(t2 == null ? void 0 : t2.defaultView, "focus", (r2) => {
    if (!l2 || !c2.current) return;
    let s2 = P$3(e3);
    n2.current instanceof HTMLElement && s2.add(n2.current);
    let i2 = o3.current;
    if (!i2) return;
    let u2 = r2.target;
    u2 && u2 instanceof HTMLElement ? S$4(s2, u2) ? (o3.current = u2, y$7(u2)) : (r2.preventDefault(), r2.stopPropagation(), y$7(i2)) : y$7(o3.current);
  }, true);
}
function S$4(t2, n2) {
  for (let e3 of t2) if (e3.contains(n2)) return true;
  return false;
}
let e$4 = createContext(false);
function a$x() {
  return useContext(e$4);
}
function l$j(o3) {
  return a__default.createElement(e$4.Provider, { value: o3.force }, o3.children);
}
function F$3(p2) {
  let n2 = a$x(), l2 = useContext(_$2), e3 = n$j(p2), [a2, o3] = useState(() => {
    if (!n2 && l2 !== null || s$x.isServer) return null;
    let t2 = e3 == null ? void 0 : e3.getElementById("headlessui-portal-root");
    if (t2) return t2;
    if (e3 === null) return null;
    let r2 = e3.createElement("div");
    return r2.setAttribute("id", "headlessui-portal-root"), e3.body.appendChild(r2);
  });
  return useEffect(() => {
    a2 !== null && (e3 != null && e3.body.contains(a2) || e3 == null || e3.body.appendChild(a2));
  }, [a2, e3]), useEffect(() => {
    n2 || l2 !== null && o3(l2.current);
  }, [l2, o3, n2]), a2;
}
let U$2 = Fragment;
function N$1(p2, n2) {
  let l2 = p2, e3 = useRef(null), a2 = y$5(T((u2) => {
    e3.current = u2;
  }), n2), o3 = n$j(e3), t2 = F$3(e3), [r2] = useState(() => {
    var u2;
    return s$x.isServer ? null : (u2 = o3 == null ? void 0 : o3.createElement("div")) != null ? u2 : null;
  }), i2 = useContext(f$r), v2 = l$l();
  return l$m(() => {
    !t2 || !r2 || t2.contains(r2) || (r2.setAttribute("data-headlessui-portal", ""), t2.appendChild(r2));
  }, [t2, r2]), l$m(() => {
    if (r2 && i2) return i2.register(r2);
  }, [i2, r2]), c$q(() => {
    var u2;
    !t2 || !r2 || (r2 instanceof Node && t2.contains(r2) && t2.removeChild(r2), t2.childNodes.length <= 0 && ((u2 = t2.parentElement) == null || u2.removeChild(t2)));
  }), v2 ? !t2 || !r2 ? null : createPortal(C$4({ ourProps: { ref: a2 }, theirProps: l2, defaultTag: U$2, name: "Portal" }), r2) : null;
}
let S$3 = Fragment, _$2 = createContext(null);
function j$1(p2, n2) {
  let { target: l2, ...e3 } = p2, o3 = { ref: y$5(n2) };
  return a__default.createElement(_$2.Provider, { value: l2 }, C$4({ ourProps: o3, theirProps: e3, defaultTag: S$3, name: "Popover.Group" }));
}
let f$r = createContext(null);
function ee$1() {
  let p2 = useContext(f$r), n2 = useRef([]), l2 = o$d((o3) => (n2.current.push(o3), p2 && p2.register(o3), () => e3(o3))), e3 = o$d((o3) => {
    let t2 = n2.current.indexOf(o3);
    t2 !== -1 && n2.current.splice(t2, 1), p2 && p2.unregister(o3);
  }), a2 = useMemo(() => ({ register: l2, unregister: e3, portals: n2 }), [l2, e3, n2]);
  return [n2, useMemo(() => function({ children: t2 }) {
    return a__default.createElement(f$r.Provider, { value: a2 }, t2);
  }, [a2])];
}
let D$3 = U$3(N$1), I$8 = U$3(j$1), te$1 = Object.assign(D$3, { Group: I$8 });
function i$o(e3, t2) {
  return e3 === t2 && (e3 !== 0 || 1 / e3 === 1 / t2) || e3 !== e3 && t2 !== t2;
}
const d$8 = typeof Object.is == "function" ? Object.is : i$o, { useState: u$4, useEffect: h$5, useLayoutEffect: f$q, useDebugValue: p$q } = a$z;
function y$4(e3, t2, c2) {
  const a2 = t2(), [{ inst: n2 }, o3] = u$4({ inst: { value: a2, getSnapshot: t2 } });
  return f$q(() => {
    n2.value = a2, n2.getSnapshot = t2, r$a(n2) && o3({ inst: n2 });
  }, [e3, a2, t2]), h$5(() => (r$a(n2) && o3({ inst: n2 }), e3(() => {
    r$a(n2) && o3({ inst: n2 });
  })), [e3]), p$q(a2), a2;
}
function r$a(e3) {
  const t2 = e3.getSnapshot, c2 = e3.value;
  try {
    const a2 = t2();
    return !d$8(c2, a2);
  } catch {
    return true;
  }
}
function t$z(r2, e3, n2) {
  return e3();
}
const r$9 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", s$q = !r$9, c$p = s$q ? t$z : y$4, a$w = "useSyncExternalStore" in a$z ? ((n2) => n2.useSyncExternalStore)(a$z) : c$p;
function S$2(t2) {
  return a$w(t2.subscribe, t2.getSnapshot, t2.getSnapshot);
}
function a$v(o3, r2) {
  let t2 = o3(), n2 = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t2;
  }, subscribe(e3) {
    return n2.add(e3), () => n2.delete(e3);
  }, dispatch(e3, ...s2) {
    let i2 = r2[e3].call(t2, ...s2);
    i2 && (t2 = i2, n2.forEach((c2) => c2()));
  } };
}
function c$o() {
  let o3;
  return { before({ doc: e3 }) {
    var l2;
    let n2 = e3.documentElement;
    o3 = ((l2 = e3.defaultView) != null ? l2 : window).innerWidth - n2.clientWidth;
  }, after({ doc: e3, d: n2 }) {
    let t2 = e3.documentElement, l2 = t2.clientWidth - t2.offsetWidth, r2 = o3 - l2;
    n2.style(t2, "paddingRight", `${r2}px`);
  } };
}
function d$7() {
  return t$E() ? { before({ doc: r2, d: l2, meta: c2 }) {
    function o3(a2) {
      return c2.containers.flatMap((n2) => n2()).some((n2) => n2.contains(a2));
    }
    l2.microTask(() => {
      var s2;
      if (window.getComputedStyle(r2.documentElement).scrollBehavior !== "auto") {
        let t2 = o$c();
        t2.style(r2.documentElement, "scrollBehavior", "auto"), l2.add(() => l2.microTask(() => t2.dispose()));
      }
      let a2 = (s2 = window.scrollY) != null ? s2 : window.pageYOffset, n2 = null;
      l2.addEventListener(r2, "click", (t2) => {
        if (t2.target instanceof HTMLElement) try {
          let e3 = t2.target.closest("a");
          if (!e3) return;
          let { hash: f2 } = new URL(e3.href), i2 = r2.querySelector(f2);
          i2 && !o3(i2) && (n2 = i2);
        } catch {
        }
      }, true), l2.addEventListener(r2, "touchstart", (t2) => {
        if (t2.target instanceof HTMLElement) if (o3(t2.target)) {
          let e3 = t2.target;
          for (; e3.parentElement && o3(e3.parentElement); ) e3 = e3.parentElement;
          l2.style(e3, "overscrollBehavior", "contain");
        } else l2.style(t2.target, "touchAction", "none");
      }), l2.addEventListener(r2, "touchmove", (t2) => {
        if (t2.target instanceof HTMLElement) if (o3(t2.target)) {
          let e3 = t2.target;
          for (; e3.parentElement && e3.dataset.headlessuiPortal !== "" && !(e3.scrollHeight > e3.clientHeight || e3.scrollWidth > e3.clientWidth); ) e3 = e3.parentElement;
          e3.dataset.headlessuiPortal === "" && t2.preventDefault();
        } else t2.preventDefault();
      }, { passive: false }), l2.add(() => {
        var e3;
        let t2 = (e3 = window.scrollY) != null ? e3 : window.pageYOffset;
        a2 !== t2 && window.scrollTo(0, a2), n2 && n2.isConnected && (n2.scrollIntoView({ block: "nearest" }), n2 = null);
      });
    });
  } } : {};
}
function l$i() {
  return { before({ doc: e3, d: o3 }) {
    o3.style(e3.documentElement, "overflow", "hidden");
  } };
}
function m$k(e3) {
  let n2 = {};
  for (let t2 of e3) Object.assign(n2, t2(n2));
  return n2;
}
let a$u = a$v(() => /* @__PURE__ */ new Map(), { PUSH(e3, n2) {
  var o3;
  let t2 = (o3 = this.get(e3)) != null ? o3 : { doc: e3, count: 0, d: o$c(), meta: /* @__PURE__ */ new Set() };
  return t2.count++, t2.meta.add(n2), this.set(e3, t2), this;
}, POP(e3, n2) {
  let t2 = this.get(e3);
  return t2 && (t2.count--, t2.meta.delete(n2)), this;
}, SCROLL_PREVENT({ doc: e3, d: n2, meta: t2 }) {
  let o3 = { doc: e3, d: n2, meta: m$k(t2) }, c2 = [d$7(), c$o(), l$i()];
  c2.forEach(({ before: r2 }) => r2 == null ? void 0 : r2(o3)), c2.forEach(({ after: r2 }) => r2 == null ? void 0 : r2(o3));
}, SCROLL_ALLOW({ d: e3 }) {
  e3.dispose();
}, TEARDOWN({ doc: e3 }) {
  this.delete(e3);
} });
a$u.subscribe(() => {
  let e3 = a$u.getSnapshot(), n2 = /* @__PURE__ */ new Map();
  for (let [t2] of e3) n2.set(t2, t2.documentElement.style.overflow);
  for (let t2 of e3.values()) {
    let o3 = n2.get(t2.doc) === "hidden", c2 = t2.count !== 0;
    (c2 && !o3 || !c2 && o3) && a$u.dispatch(t2.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t2), t2.count === 0 && a$u.dispatch("TEARDOWN", t2);
  }
});
function p$p(e3, r2, n2) {
  let f2 = S$2(a$u), o3 = e3 ? f2.get(e3) : void 0, i2 = o3 ? o3.count > 0 : false;
  return l$m(() => {
    if (!(!e3 || !r2)) return a$u.dispatch("PUSH", e3, n2), () => a$u.dispatch("POP", e3, n2);
  }, [r2, e3]), i2;
}
let u$3 = /* @__PURE__ */ new Map(), t$y = /* @__PURE__ */ new Map();
function b$7(r2, l2 = true) {
  l$m(() => {
    var o3;
    if (!l2) return;
    let e3 = typeof r2 == "function" ? r2() : r2.current;
    if (!e3) return;
    function a2() {
      var d2;
      if (!e3) return;
      let i2 = (d2 = t$y.get(e3)) != null ? d2 : 1;
      if (i2 === 1 ? t$y.delete(e3) : t$y.set(e3, i2 - 1), i2 !== 1) return;
      let n2 = u$3.get(e3);
      n2 && (n2["aria-hidden"] === null ? e3.removeAttribute("aria-hidden") : e3.setAttribute("aria-hidden", n2["aria-hidden"]), e3.inert = n2.inert, u$3.delete(e3));
    }
    let f2 = (o3 = t$y.get(e3)) != null ? o3 : 0;
    return t$y.set(e3, f2 + 1), f2 !== 0 || (u$3.set(e3, { "aria-hidden": e3.getAttribute("aria-hidden"), inert: e3.inert }), e3.setAttribute("aria-hidden", "true"), e3.inert = true), a2;
  }, [r2, l2]);
}
function N({ defaultContainers: o3 = [], portals: r2, mainTreeNodeRef: u2 } = {}) {
  var f2;
  let t2 = useRef((f2 = u2 == null ? void 0 : u2.current) != null ? f2 : null), l2 = n$j(t2), c2 = o$d(() => {
    var i2, s2, a2;
    let n2 = [];
    for (let e3 of o3) e3 !== null && (e3 instanceof HTMLElement ? n2.push(e3) : "current" in e3 && e3.current instanceof HTMLElement && n2.push(e3.current));
    if (r2 != null && r2.current) for (let e3 of r2.current) n2.push(e3);
    for (let e3 of (i2 = l2 == null ? void 0 : l2.querySelectorAll("html > *, body > *")) != null ? i2 : []) e3 !== document.body && e3 !== document.head && e3 instanceof HTMLElement && e3.id !== "headlessui-portal-root" && (e3.contains(t2.current) || e3.contains((a2 = (s2 = t2.current) == null ? void 0 : s2.getRootNode()) == null ? void 0 : a2.host) || n2.some((L2) => e3.contains(L2)) || n2.push(e3));
    return n2;
  });
  return { resolveContainers: c2, contains: o$d((n2) => c2().some((i2) => i2.contains(n2))), mainTreeNodeRef: t2, MainTreeNode: useMemo(() => function() {
    return u2 != null ? null : a__default.createElement(u$7, { features: s$t.Hidden, ref: t2 });
  }, [t2, u2]) };
}
let a$t = createContext(() => {
});
a$t.displayName = "StackContext";
var s$p = ((e3) => (e3[e3.Add = 0] = "Add", e3[e3.Remove = 1] = "Remove", e3))(s$p || {});
function x$1() {
  return useContext(a$t);
}
function b$6({ children: i2, onUpdate: r2, type: e3, element: n2, enabled: u2 }) {
  let l2 = x$1(), o3 = o$d((...t2) => {
    r2 == null || r2(...t2), l2(...t2);
  });
  return l$m(() => {
    let t2 = u2 === void 0 || u2 === true;
    return t2 && o3(0, e3, n2), () => {
      t2 && o3(1, e3, n2);
    };
  }, [o3, e3, n2, u2]), a__default.createElement(a$t.Provider, { value: o3 }, i2);
}
let d$6 = createContext(null);
function f$p() {
  let r2 = useContext(d$6);
  if (r2 === null) {
    let t2 = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t2, f$p), t2;
  }
  return r2;
}
function w$9() {
  let [r2, t2] = useState([]);
  return [r2.length > 0 ? r2.join(" ") : void 0, useMemo(() => function(e3) {
    let i2 = o$d((s2) => (t2((o3) => [...o3, s2]), () => t2((o3) => {
      let p2 = o3.slice(), c2 = p2.indexOf(s2);
      return c2 !== -1 && p2.splice(c2, 1), p2;
    }))), n2 = useMemo(() => ({ register: i2, slot: e3.slot, name: e3.name, props: e3.props }), [i2, e3.slot, e3.name, e3.props]);
    return a__default.createElement(d$6.Provider, { value: n2 }, e3.children);
  }, [t2])];
}
let I$7 = "p";
function S$1(r2, t2) {
  let a2 = I$b(), { id: e3 = `headlessui-description-${a2}`, ...i2 } = r2, n2 = f$p(), s2 = y$5(t2);
  l$m(() => n2.register(e3), [e3, n2.register]);
  let o3 = { ref: s2, ...n2.props, id: e3 };
  return C$4({ ourProps: o3, theirProps: i2, slot: n2.slot || {}, defaultTag: I$7, name: n2.name || "Description" });
}
let h$4 = U$3(S$1), G = Object.assign(h$4, {});
var Me$1 = ((r2) => (r2[r2.Open = 0] = "Open", r2[r2.Closed = 1] = "Closed", r2))(Me$1 || {}), we$1 = ((e3) => (e3[e3.SetTitleId = 0] = "SetTitleId", e3))(we$1 || {});
let He$1 = { [0](o3, e3) {
  return o3.titleId === e3.id ? o3 : { ...o3, titleId: e3.id };
} }, I$6 = createContext(null);
I$6.displayName = "DialogContext";
function b$5(o3) {
  let e3 = useContext(I$6);
  if (e3 === null) {
    let r2 = new Error(`<${o3} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r2, b$5), r2;
  }
  return e3;
}
function Be(o3, e3, r2 = () => [document.body]) {
  p$p(o3, e3, (i2) => {
    var n2;
    return { containers: [...(n2 = i2.containers) != null ? n2 : [], r2] };
  });
}
function Ge$1(o3, e3) {
  return u$a(e3.type, He$1, o3, e3);
}
let Ne$1 = "div", Ue = O$1.RenderStrategy | O$1.Static;
function We(o3, e3) {
  let r2 = I$b(), { id: i2 = `headlessui-dialog-${r2}`, open: n2, onClose: l2, initialFocus: s2, role: a2 = "dialog", __demoMode: T2 = false, ...m2 } = o3, [M2, f2] = useState(0), U2 = useRef(false);
  a2 = function() {
    return a2 === "dialog" || a2 === "alertdialog" ? a2 : (U2.current || (U2.current = true, console.warn(`Invalid role [${a2}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let E$1 = u$6();
  n2 === void 0 && E$1 !== null && (n2 = (E$1 & d$9.Open) === d$9.Open);
  let D2 = useRef(null), ee2 = y$5(D2, e3), g2 = n$j(D2), W = o3.hasOwnProperty("open") || E$1 !== null, $2 = o3.hasOwnProperty("onClose");
  if (!W && !$2) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!$2) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof n2 != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n2}`);
  if (typeof l2 != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l2}`);
  let p2 = n2 ? 0 : 1, [h2, te2] = useReducer(Ge$1, { titleId: null, descriptionId: null, panelRef: createRef() }), P2 = o$d(() => l2(false)), Y2 = o$d((t2) => te2({ type: 0, id: t2 })), S2 = l$l() ? T2 ? false : p2 === 0 : false, x2 = M2 > 1, j2 = useContext(I$6) !== null, [oe2, re2] = ee$1(), ne2 = { get current() {
    var t2;
    return (t2 = h2.panelRef.current) != null ? t2 : D2.current;
  } }, { resolveContainers: w2, mainTreeNodeRef: L2, MainTreeNode: le2 } = N({ portals: oe2, defaultContainers: [ne2] }), ae2 = x2 ? "parent" : "leaf", J = E$1 !== null ? (E$1 & d$9.Closing) === d$9.Closing : false, ie2 = /* @__PURE__ */ (() => j2 || J ? false : S2)(), se2 = useCallback(() => {
    var t2, c2;
    return (c2 = Array.from((t2 = g2 == null ? void 0 : g2.querySelectorAll("body > *")) != null ? t2 : []).find((d2) => d2.id === "headlessui-portal-root" ? false : d2.contains(L2.current) && d2 instanceof HTMLElement)) != null ? c2 : null;
  }, [L2]);
  b$7(se2, ie2);
  let pe2 = /* @__PURE__ */ (() => x2 ? true : S2)(), de2 = useCallback(() => {
    var t2, c2;
    return (c2 = Array.from((t2 = g2 == null ? void 0 : g2.querySelectorAll("[data-headlessui-portal]")) != null ? t2 : []).find((d2) => d2.contains(L2.current) && d2 instanceof HTMLElement)) != null ? c2 : null;
  }, [L2]);
  b$7(de2, pe2);
  let ue2 = /* @__PURE__ */ (() => !(!S2 || x2))();
  y$6(w2, (t2) => {
    t2.preventDefault(), P2();
  }, ue2);
  let fe2 = /* @__PURE__ */ (() => !(x2 || p2 !== 0))();
  E(g2 == null ? void 0 : g2.defaultView, "keydown", (t2) => {
    fe2 && (t2.defaultPrevented || t2.key === o$8.Escape && (t2.preventDefault(), t2.stopPropagation(), P2()));
  });
  let ge2 = /* @__PURE__ */ (() => !(J || p2 !== 0 || j2))();
  Be(g2, ge2, w2), useEffect(() => {
    if (p2 !== 0 || !D2.current) return;
    let t2 = new ResizeObserver((c2) => {
      for (let d2 of c2) {
        let F2 = d2.target.getBoundingClientRect();
        F2.x === 0 && F2.y === 0 && F2.width === 0 && F2.height === 0 && P2();
      }
    });
    return t2.observe(D2.current), () => t2.disconnect();
  }, [p2, D2, P2]);
  let [Te2, ce2] = w$9(), De2 = useMemo(() => [{ dialogState: p2, close: P2, setTitleId: Y2 }, h2], [p2, h2, P2, Y2]), X2 = useMemo(() => ({ open: p2 === 0 }), [p2]), me2 = { ref: ee2, id: i2, role: a2, "aria-modal": p2 === 0 ? true : void 0, "aria-labelledby": h2.titleId, "aria-describedby": Te2 };
  return a__default.createElement(b$6, { type: "Dialog", enabled: p2 === 0, element: D2, onUpdate: o$d((t2, c2) => {
    c2 === "Dialog" && u$a(t2, { [s$p.Add]: () => f2((d2) => d2 + 1), [s$p.Remove]: () => f2((d2) => d2 - 1) });
  }) }, a__default.createElement(l$j, { force: true }, a__default.createElement(te$1, null, a__default.createElement(I$6.Provider, { value: De2 }, a__default.createElement(te$1.Group, { target: D2 }, a__default.createElement(l$j, { force: false }, a__default.createElement(ce2, { slot: X2, name: "Dialog.Description" }, a__default.createElement(de$2, { initialFocus: s2, containers: w2, features: S2 ? u$a(ae2, { parent: de$2.features.RestoreFocus, leaf: de$2.features.All & ~de$2.features.FocusLock }) : de$2.features.None }, a__default.createElement(re2, null, C$4({ ourProps: me2, theirProps: m2, slot: X2, defaultTag: Ne$1, features: Ue, visible: p2 === 0, name: "Dialog" }))))))))), a__default.createElement(le2, null));
}
let $e$1 = "div";
function Ye(o3, e3) {
  let r2 = I$b(), { id: i2 = `headlessui-dialog-overlay-${r2}`, ...n2 } = o3, [{ dialogState: l2, close: s2 }] = b$5("Dialog.Overlay"), a2 = y$5(e3), T2 = o$d((f2) => {
    if (f2.target === f2.currentTarget) {
      if (r$b(f2.currentTarget)) return f2.preventDefault();
      f2.preventDefault(), f2.stopPropagation(), s2();
    }
  }), m2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return C$4({ ourProps: { ref: a2, id: i2, "aria-hidden": true, onClick: T2 }, theirProps: n2, slot: m2, defaultTag: $e$1, name: "Dialog.Overlay" });
}
let je = "div";
function Je(o3, e3) {
  let r2 = I$b(), { id: i2 = `headlessui-dialog-backdrop-${r2}`, ...n2 } = o3, [{ dialogState: l2 }, s2] = b$5("Dialog.Backdrop"), a2 = y$5(e3);
  useEffect(() => {
    if (s2.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [s2.panelRef]);
  let T2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return a__default.createElement(l$j, { force: true }, a__default.createElement(te$1, null, C$4({ ourProps: { ref: a2, id: i2, "aria-hidden": true }, theirProps: n2, slot: T2, defaultTag: je, name: "Dialog.Backdrop" })));
}
let Xe = "div";
function Ke(o3, e3) {
  let r2 = I$b(), { id: i2 = `headlessui-dialog-panel-${r2}`, ...n2 } = o3, [{ dialogState: l2 }, s2] = b$5("Dialog.Panel"), a2 = y$5(e3, s2.panelRef), T2 = useMemo(() => ({ open: l2 === 0 }), [l2]), m2 = o$d((f2) => {
    f2.stopPropagation();
  });
  return C$4({ ourProps: { ref: a2, id: i2, onClick: m2 }, theirProps: n2, slot: T2, defaultTag: Xe, name: "Dialog.Panel" });
}
let Ve = "h2";
function qe$2(o3, e3) {
  let r2 = I$b(), { id: i2 = `headlessui-dialog-title-${r2}`, ...n2 } = o3, [{ dialogState: l2, setTitleId: s2 }] = b$5("Dialog.Title"), a2 = y$5(e3);
  useEffect(() => (s2(i2), () => s2(null)), [i2, s2]);
  let T2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return C$4({ ourProps: { ref: a2, id: i2 }, theirProps: n2, slot: T2, defaultTag: Ve, name: "Dialog.Title" });
}
let ze = U$3(We), Qe = U$3(Je), Ze = U$3(Ke), et = U$3(Ye), tt = U$3(qe$2), _t = Object.assign(ze, { Backdrop: Qe, Panel: Ze, Overlay: et, Title: tt, Description: G });
var t$x;
let a$s = (t$x = a__default.startTransition) != null ? t$x : function(i2) {
  i2();
};
var Q = ((o3) => (o3[o3.Open = 0] = "Open", o3[o3.Closed = 1] = "Closed", o3))(Q || {}), V$1 = ((t2) => (t2[t2.ToggleDisclosure = 0] = "ToggleDisclosure", t2[t2.CloseDisclosure = 1] = "CloseDisclosure", t2[t2.SetButtonId = 2] = "SetButtonId", t2[t2.SetPanelId = 3] = "SetPanelId", t2[t2.LinkPanel = 4] = "LinkPanel", t2[t2.UnlinkPanel = 5] = "UnlinkPanel", t2))(V$1 || {});
let Y = { [0]: (e3) => ({ ...e3, disclosureState: u$a(e3.disclosureState, { [0]: 1, [1]: 0 }) }), [1]: (e3) => e3.disclosureState === 1 ? e3 : { ...e3, disclosureState: 1 }, [4](e3) {
  return e3.linkedPanel === true ? e3 : { ...e3, linkedPanel: true };
}, [5](e3) {
  return e3.linkedPanel === false ? e3 : { ...e3, linkedPanel: false };
}, [2](e3, n2) {
  return e3.buttonId === n2.buttonId ? e3 : { ...e3, buttonId: n2.buttonId };
}, [3](e3, n2) {
  return e3.panelId === n2.panelId ? e3 : { ...e3, panelId: n2.panelId };
} }, M$2 = createContext(null);
M$2.displayName = "DisclosureContext";
function _$1(e3) {
  let n2 = useContext(M$2);
  if (n2 === null) {
    let o3 = new Error(`<${e3} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o3, _$1), o3;
  }
  return n2;
}
let v$3 = createContext(null);
v$3.displayName = "DisclosureAPIContext";
function K(e3) {
  let n2 = useContext(v$3);
  if (n2 === null) {
    let o3 = new Error(`<${e3} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o3, K), o3;
  }
  return n2;
}
let F$2 = createContext(null);
F$2.displayName = "DisclosurePanelContext";
function Z() {
  return useContext(F$2);
}
function ee(e3, n2) {
  return u$a(n2.type, Y, e3, n2);
}
let te = Fragment;
function ne$1(e3, n2) {
  let { defaultOpen: o3 = false, ...i2 } = e3, f2 = useRef(null), l2 = y$5(n2, T((u2) => {
    f2.current = u2;
  }, e3.as === void 0 || e3.as === Fragment)), t2 = useRef(null), d2 = useRef(null), s2 = useReducer(ee, { disclosureState: o3 ? 0 : 1, linkedPanel: false, buttonRef: d2, panelRef: t2, buttonId: null, panelId: null }), [{ disclosureState: c2, buttonId: a2 }, D2] = s2, p2 = o$d((u2) => {
    D2({ type: 1 });
    let y2 = o$a(f2);
    if (!y2 || !a2) return;
    let r2 = (() => u2 ? u2 instanceof HTMLElement ? u2 : u2.current instanceof HTMLElement ? u2.current : y2.getElementById(a2) : y2.getElementById(a2))();
    r2 == null || r2.focus();
  }), P2 = useMemo(() => ({ close: p2 }), [p2]), T$12 = useMemo(() => ({ open: c2 === 0, close: p2 }), [c2, p2]), C2 = { ref: l2 };
  return a__default.createElement(M$2.Provider, { value: s2 }, a__default.createElement(v$3.Provider, { value: P2 }, a__default.createElement(s$s, { value: u$a(c2, { [0]: d$9.Open, [1]: d$9.Closed }) }, C$4({ ourProps: C2, theirProps: i2, slot: T$12, defaultTag: te, name: "Disclosure" }))));
}
let le$1 = "button";
function oe$1(e3, n2) {
  let o3 = I$b(), { id: i2 = `headlessui-disclosure-button-${o3}`, ...f2 } = e3, [l2, t2] = _$1("Disclosure.Button"), d2 = Z(), s2 = d2 === null ? false : d2 === l2.panelId, c2 = useRef(null), a2 = y$5(c2, n2, s2 ? null : l2.buttonRef), D2 = I$9();
  useEffect(() => {
    if (!s2) return t2({ type: 2, buttonId: i2 }), () => {
      t2({ type: 2, buttonId: null });
    };
  }, [i2, t2, s2]);
  let p2 = o$d((r2) => {
    var m2;
    if (s2) {
      if (l2.disclosureState === 1) return;
      switch (r2.key) {
        case o$8.Space:
        case o$8.Enter:
          r2.preventDefault(), r2.stopPropagation(), t2({ type: 0 }), (m2 = l2.buttonRef.current) == null || m2.focus();
          break;
      }
    } else switch (r2.key) {
      case o$8.Space:
      case o$8.Enter:
        r2.preventDefault(), r2.stopPropagation(), t2({ type: 0 });
        break;
    }
  }), P2 = o$d((r2) => {
    switch (r2.key) {
      case o$8.Space:
        r2.preventDefault();
        break;
    }
  }), T2 = o$d((r2) => {
    var m2;
    r$b(r2.currentTarget) || e3.disabled || (s2 ? (t2({ type: 0 }), (m2 = l2.buttonRef.current) == null || m2.focus()) : t2({ type: 0 }));
  }), C2 = useMemo(() => ({ open: l2.disclosureState === 0 }), [l2]), u2 = T$1(e3, c2), y2 = s2 ? { ref: a2, type: u2, onKeyDown: p2, onClick: T2 } : { ref: a2, id: i2, type: u2, "aria-expanded": l2.disclosureState === 0, "aria-controls": l2.linkedPanel ? l2.panelId : void 0, onKeyDown: p2, onKeyUp: P2, onClick: T2 };
  return C$4({ mergeRefs: D2, ourProps: y2, theirProps: f2, slot: C2, defaultTag: le$1, name: "Disclosure.Button" });
}
let re = "div", se$1 = O$1.RenderStrategy | O$1.Static;
function ue$2(e3, n2) {
  let o3 = I$b(), { id: i2 = `headlessui-disclosure-panel-${o3}`, ...f2 } = e3, [l2, t2] = _$1("Disclosure.Panel"), { close: d2 } = K("Disclosure.Panel"), s2 = I$9(), c2 = y$5(n2, l2.panelRef, (T2) => {
    a$s(() => t2({ type: T2 ? 4 : 5 }));
  });
  useEffect(() => (t2({ type: 3, panelId: i2 }), () => {
    t2({ type: 3, panelId: null });
  }), [i2, t2]);
  let a2 = u$6(), D2 = (() => a2 !== null ? (a2 & d$9.Open) === d$9.Open : l2.disclosureState === 0)(), p2 = useMemo(() => ({ open: l2.disclosureState === 0, close: d2 }), [l2, d2]), P2 = { ref: c2, id: i2 };
  return a__default.createElement(F$2.Provider, { value: l2.panelId }, C$4({ mergeRefs: s2, ourProps: P2, theirProps: f2, slot: p2, defaultTag: re, features: se$1, visible: D2, name: "Disclosure.Panel" }));
}
let ie = U$3(ne$1), ae$1 = U$3(oe$1), pe = U$3(ue$2), Ae$2 = Object.assign(ie, { Button: ae$1, Panel: pe });
let a$r = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function o$7(e3) {
  var r2, i2;
  let n2 = (r2 = e3.innerText) != null ? r2 : "", t2 = e3.cloneNode(true);
  if (!(t2 instanceof HTMLElement)) return n2;
  let u2 = false;
  for (let f2 of t2.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) f2.remove(), u2 = true;
  let l2 = u2 ? (i2 = t2.innerText) != null ? i2 : "" : n2;
  return a$r.test(l2) && (l2 = l2.replace(a$r, "")), l2;
}
function g$4(e3) {
  let n2 = e3.getAttribute("aria-label");
  if (typeof n2 == "string") return n2.trim();
  let t2 = e3.getAttribute("aria-labelledby");
  if (t2) {
    let u2 = t2.split(" ").map((l2) => {
      let r2 = document.getElementById(l2);
      if (r2) {
        let i2 = r2.getAttribute("aria-label");
        return typeof i2 == "string" ? i2.trim() : o$7(r2).trim();
      }
      return null;
    }).filter(Boolean);
    if (u2.length > 0) return u2.join(", ");
  }
  return o$7(e3).trim();
}
function s$o(c2) {
  let t2 = useRef(""), r2 = useRef("");
  return o$d(() => {
    let e3 = c2.current;
    if (!e3) return "";
    let u2 = e3.innerText;
    if (t2.current === u2) return r2.current;
    let n2 = g$4(e3).trim().toLowerCase();
    return t2.current = u2, r2.current = n2, n2;
  });
}
var me$1 = ((r2) => (r2[r2.Open = 0] = "Open", r2[r2.Closed = 1] = "Closed", r2))(me$1 || {}), de$1 = ((r2) => (r2[r2.Pointer = 0] = "Pointer", r2[r2.Other = 1] = "Other", r2))(de$1 || {}), fe$1 = ((a2) => (a2[a2.OpenMenu = 0] = "OpenMenu", a2[a2.CloseMenu = 1] = "CloseMenu", a2[a2.GoToItem = 2] = "GoToItem", a2[a2.Search = 3] = "Search", a2[a2.ClearSearch = 4] = "ClearSearch", a2[a2.RegisterItem = 5] = "RegisterItem", a2[a2.UnregisterItem = 6] = "UnregisterItem", a2))(fe$1 || {});
function w$8(e3, u2 = (r2) => r2) {
  let r2 = e3.activeItemIndex !== null ? e3.items[e3.activeItemIndex] : null, s2 = I$a(u2(e3.items.slice()), (t2) => t2.dataRef.current.domRef.current), i2 = r2 ? s2.indexOf(r2) : null;
  return i2 === -1 && (i2 = null), { items: s2, activeItemIndex: i2 };
}
let Te$1 = { [1](e3) {
  return e3.menuState === 1 ? e3 : { ...e3, activeItemIndex: null, menuState: 1 };
}, [0](e3) {
  return e3.menuState === 0 ? e3 : { ...e3, __demoMode: false, menuState: 0 };
}, [2]: (e3, u2) => {
  var i2;
  let r2 = w$8(e3), s2 = f$u(u2, { resolveItems: () => r2.items, resolveActiveIndex: () => r2.activeItemIndex, resolveId: (t2) => t2.id, resolveDisabled: (t2) => t2.dataRef.current.disabled });
  return { ...e3, ...r2, searchQuery: "", activeItemIndex: s2, activationTrigger: (i2 = u2.trigger) != null ? i2 : 1 };
}, [3]: (e3, u2) => {
  let s2 = e3.searchQuery !== "" ? 0 : 1, i2 = e3.searchQuery + u2.value.toLowerCase(), o3 = (e3.activeItemIndex !== null ? e3.items.slice(e3.activeItemIndex + s2).concat(e3.items.slice(0, e3.activeItemIndex + s2)) : e3.items).find((l2) => {
    var m2;
    return ((m2 = l2.dataRef.current.textValue) == null ? void 0 : m2.startsWith(i2)) && !l2.dataRef.current.disabled;
  }), a2 = o3 ? e3.items.indexOf(o3) : -1;
  return a2 === -1 || a2 === e3.activeItemIndex ? { ...e3, searchQuery: i2 } : { ...e3, searchQuery: i2, activeItemIndex: a2, activationTrigger: 1 };
}, [4](e3) {
  return e3.searchQuery === "" ? e3 : { ...e3, searchQuery: "", searchActiveItemIndex: null };
}, [5]: (e3, u2) => {
  let r2 = w$8(e3, (s2) => [...s2, { id: u2.id, dataRef: u2.dataRef }]);
  return { ...e3, ...r2 };
}, [6]: (e3, u2) => {
  let r2 = w$8(e3, (s2) => {
    let i2 = s2.findIndex((t2) => t2.id === u2.id);
    return i2 !== -1 && s2.splice(i2, 1), s2;
  });
  return { ...e3, ...r2, activationTrigger: 1 };
} }, U$1 = createContext(null);
U$1.displayName = "MenuContext";
function C$3(e3) {
  let u2 = useContext(U$1);
  if (u2 === null) {
    let r2 = new Error(`<${e3} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r2, C$3), r2;
  }
  return u2;
}
function ye$2(e3, u2) {
  return u$a(u2.type, Te$1, e3, u2);
}
let Ie$2 = Fragment;
function Me(e3, u2) {
  let { __demoMode: r2 = false, ...s2 } = e3, i2 = useReducer(ye$2, { __demoMode: r2, menuState: r2 ? 0 : 1, buttonRef: createRef(), itemsRef: createRef(), items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: t2, itemsRef: o3, buttonRef: a2 }, l2] = i2, m2 = y$5(u2);
  y$6([a2, o3], (g2, R2) => {
    var p2;
    l2({ type: 1 }), h$6(R2, T$2.Loose) || (g2.preventDefault(), (p2 = a2.current) == null || p2.focus());
  }, t2 === 0);
  let I2 = o$d(() => {
    l2({ type: 1 });
  }), A2 = useMemo(() => ({ open: t2 === 0, close: I2 }), [t2, I2]), f2 = { ref: m2 };
  return a__default.createElement(U$1.Provider, { value: i2 }, a__default.createElement(s$s, { value: u$a(t2, { [0]: d$9.Open, [1]: d$9.Closed }) }, C$4({ ourProps: f2, theirProps: s2, slot: A2, defaultTag: Ie$2, name: "Menu" })));
}
let ge$1 = "button";
function Re$2(e3, u2) {
  var R2;
  let r2 = I$b(), { id: s2 = `headlessui-menu-button-${r2}`, ...i2 } = e3, [t2, o3] = C$3("Menu.Button"), a2 = y$5(t2.buttonRef, u2), l2 = p$t(), m2 = o$d((p2) => {
    switch (p2.key) {
      case o$8.Space:
      case o$8.Enter:
      case o$8.ArrowDown:
        p2.preventDefault(), p2.stopPropagation(), o3({ type: 0 }), l2.nextFrame(() => o3({ type: 2, focus: c$r.First }));
        break;
      case o$8.ArrowUp:
        p2.preventDefault(), p2.stopPropagation(), o3({ type: 0 }), l2.nextFrame(() => o3({ type: 2, focus: c$r.Last }));
        break;
    }
  }), I2 = o$d((p2) => {
    switch (p2.key) {
      case o$8.Space:
        p2.preventDefault();
        break;
    }
  }), A2 = o$d((p2) => {
    if (r$b(p2.currentTarget)) return p2.preventDefault();
    e3.disabled || (t2.menuState === 0 ? (o3({ type: 1 }), l2.nextFrame(() => {
      var M2;
      return (M2 = t2.buttonRef.current) == null ? void 0 : M2.focus({ preventScroll: true });
    })) : (p2.preventDefault(), o3({ type: 0 })));
  }), f2 = useMemo(() => ({ open: t2.menuState === 0 }), [t2]), g2 = { ref: a2, id: s2, type: T$1(e3, t2.buttonRef), "aria-haspopup": "menu", "aria-controls": (R2 = t2.itemsRef.current) == null ? void 0 : R2.id, "aria-expanded": t2.menuState === 0, onKeyDown: m2, onKeyUp: I2, onClick: A2 };
  return C$4({ ourProps: g2, theirProps: i2, slot: f2, defaultTag: ge$1, name: "Menu.Button" });
}
let Ae$1 = "div", be$1 = O$1.RenderStrategy | O$1.Static;
function Ee$1(e3, u2) {
  var M2, b2;
  let r2 = I$b(), { id: s2 = `headlessui-menu-items-${r2}`, ...i2 } = e3, [t2, o3] = C$3("Menu.Items"), a2 = y$5(t2.itemsRef, u2), l2 = n$j(t2.itemsRef), m2 = p$t(), I2 = u$6(), A2 = (() => I2 !== null ? (I2 & d$9.Open) === d$9.Open : t2.menuState === 0)();
  useEffect(() => {
    let n2 = t2.itemsRef.current;
    n2 && t2.menuState === 0 && n2 !== (l2 == null ? void 0 : l2.activeElement) && n2.focus({ preventScroll: true });
  }, [t2.menuState, t2.itemsRef, l2]), F$5({ container: t2.itemsRef.current, enabled: t2.menuState === 0, accept(n2) {
    return n2.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n2.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(n2) {
    n2.setAttribute("role", "none");
  } });
  let f2 = o$d((n2) => {
    var E2, x2;
    switch (m2.dispose(), n2.key) {
      case o$8.Space:
        if (t2.searchQuery !== "") return n2.preventDefault(), n2.stopPropagation(), o3({ type: 3, value: n2.key });
      case o$8.Enter:
        if (n2.preventDefault(), n2.stopPropagation(), o3({ type: 1 }), t2.activeItemIndex !== null) {
          let { dataRef: S2 } = t2.items[t2.activeItemIndex];
          (x2 = (E2 = S2.current) == null ? void 0 : E2.domRef.current) == null || x2.click();
        }
        D$5(t2.buttonRef.current);
        break;
      case o$8.ArrowDown:
        return n2.preventDefault(), n2.stopPropagation(), o3({ type: 2, focus: c$r.Next });
      case o$8.ArrowUp:
        return n2.preventDefault(), n2.stopPropagation(), o3({ type: 2, focus: c$r.Previous });
      case o$8.Home:
      case o$8.PageUp:
        return n2.preventDefault(), n2.stopPropagation(), o3({ type: 2, focus: c$r.First });
      case o$8.End:
      case o$8.PageDown:
        return n2.preventDefault(), n2.stopPropagation(), o3({ type: 2, focus: c$r.Last });
      case o$8.Escape:
        n2.preventDefault(), n2.stopPropagation(), o3({ type: 1 }), o$c().nextFrame(() => {
          var S2;
          return (S2 = t2.buttonRef.current) == null ? void 0 : S2.focus({ preventScroll: true });
        });
        break;
      case o$8.Tab:
        n2.preventDefault(), n2.stopPropagation(), o3({ type: 1 }), o$c().nextFrame(() => {
          _$4(t2.buttonRef.current, n2.shiftKey ? M$3.Previous : M$3.Next);
        });
        break;
      default:
        n2.key.length === 1 && (o3({ type: 3, value: n2.key }), m2.setTimeout(() => o3({ type: 4 }), 350));
        break;
    }
  }), g2 = o$d((n2) => {
    switch (n2.key) {
      case o$8.Space:
        n2.preventDefault();
        break;
    }
  }), R2 = useMemo(() => ({ open: t2.menuState === 0 }), [t2]), p2 = { "aria-activedescendant": t2.activeItemIndex === null || (M2 = t2.items[t2.activeItemIndex]) == null ? void 0 : M2.id, "aria-labelledby": (b2 = t2.buttonRef.current) == null ? void 0 : b2.id, id: s2, onKeyDown: f2, onKeyUp: g2, role: "menu", tabIndex: 0, ref: a2 };
  return C$4({ ourProps: p2, theirProps: i2, slot: R2, defaultTag: Ae$1, features: be$1, visible: A2, name: "Menu.Items" });
}
let Se$3 = Fragment;
function xe$3(e3, u2) {
  let r2 = I$b(), { id: s2 = `headlessui-menu-item-${r2}`, disabled: i2 = false, ...t2 } = e3, [o3, a2] = C$3("Menu.Item"), l2 = o3.activeItemIndex !== null ? o3.items[o3.activeItemIndex].id === s2 : false, m2 = useRef(null), I2 = y$5(u2, m2);
  l$m(() => {
    if (o3.__demoMode || o3.menuState !== 0 || !l2 || o3.activationTrigger === 0) return;
    let T2 = o$c();
    return T2.requestAnimationFrame(() => {
      var P2, B2;
      (B2 = (P2 = m2.current) == null ? void 0 : P2.scrollIntoView) == null || B2.call(P2, { block: "nearest" });
    }), T2.dispose;
  }, [o3.__demoMode, m2, l2, o3.menuState, o3.activationTrigger, o3.activeItemIndex]);
  let A2 = s$o(m2), f2 = useRef({ disabled: i2, domRef: m2, get textValue() {
    return A2();
  } });
  l$m(() => {
    f2.current.disabled = i2;
  }, [f2, i2]), l$m(() => (a2({ type: 5, id: s2, dataRef: f2 }), () => a2({ type: 6, id: s2 })), [f2, s2]);
  let g2 = o$d(() => {
    a2({ type: 1 });
  }), R2 = o$d((T2) => {
    if (i2) return T2.preventDefault();
    a2({ type: 1 }), D$5(o3.buttonRef.current);
  }), p2 = o$d(() => {
    if (i2) return a2({ type: 2, focus: c$r.Nothing });
    a2({ type: 2, focus: c$r.Specific, id: s2 });
  }), M2 = u$8(), b2 = o$d((T2) => M2.update(T2)), n2 = o$d((T2) => {
    M2.wasMoved(T2) && (i2 || l2 || a2({ type: 2, focus: c$r.Specific, id: s2, trigger: 0 }));
  }), E2 = o$d((T2) => {
    M2.wasMoved(T2) && (i2 || l2 && a2({ type: 2, focus: c$r.Nothing }));
  }), x2 = useMemo(() => ({ active: l2, disabled: i2, close: g2 }), [l2, i2, g2]);
  return C$4({ ourProps: { id: s2, ref: I2, role: "menuitem", tabIndex: i2 === true ? void 0 : -1, "aria-disabled": i2 === true ? true : void 0, disabled: void 0, onClick: R2, onFocus: p2, onPointerEnter: b2, onMouseEnter: b2, onPointerMove: n2, onMouseMove: n2, onPointerLeave: E2, onMouseLeave: E2 }, theirProps: t2, slot: x2, defaultTag: Se$3, name: "Menu.Item" });
}
let Pe$2 = U$3(Me), ve = U$3(Re$2), he$2 = U$3(Ee$1), De$2 = U$3(xe$3), qe$1 = Object.assign(Pe$2, { Button: ve, Items: he$2, Item: De$2 });
let d$5 = createContext(null);
function u$2() {
  let a2 = useContext(d$5);
  if (a2 === null) {
    let t2 = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t2, u$2), t2;
  }
  return a2;
}
function F$1() {
  let [a2, t2] = useState([]);
  return [a2.length > 0 ? a2.join(" ") : void 0, useMemo(() => function(e3) {
    let s2 = o$d((r2) => (t2((l2) => [...l2, r2]), () => t2((l2) => {
      let n2 = l2.slice(), p2 = n2.indexOf(r2);
      return p2 !== -1 && n2.splice(p2, 1), n2;
    }))), o3 = useMemo(() => ({ register: s2, slot: e3.slot, name: e3.name, props: e3.props }), [s2, e3.slot, e3.name, e3.props]);
    return a__default.createElement(d$5.Provider, { value: o3 }, e3.children);
  }, [t2])];
}
let A = "label";
function h$3(a2, t2) {
  let i2 = I$b(), { id: e3 = `headlessui-label-${i2}`, passive: s2 = false, ...o3 } = a2, r2 = u$2(), l2 = y$5(t2);
  l$m(() => r2.register(e3), [e3, r2.register]);
  let n2 = { ref: l2, ...r2.props, id: e3 };
  return s2 && ("onClick" in n2 && (delete n2.htmlFor, delete n2.onClick), "onClick" in o3 && delete o3.onClick), C$4({ ourProps: n2, theirProps: o3, slot: r2.slot || {}, defaultTag: A, name: r2.name || "Label" });
}
let v$2 = U$3(h$3), B$1 = Object.assign(v$2, {});
function c$n(a2 = 0) {
  let [l2, r2] = useState(a2), t2 = f$s(), o3 = useCallback((e3) => {
    t2.current && r2((u2) => u2 | e3);
  }, [l2, t2]), m2 = useCallback((e3) => Boolean(l2 & e3), [l2]), s2 = useCallback((e3) => {
    t2.current && r2((u2) => u2 & ~e3);
  }, [r2, t2]), g2 = useCallback((e3) => {
    t2.current && r2((u2) => u2 ^ e3);
  }, [r2]);
  return { flags: l2, addFlag: o3, hasFlag: m2, removeFlag: s2, toggleFlag: g2 };
}
var Ge = ((t2) => (t2[t2.RegisterOption = 0] = "RegisterOption", t2[t2.UnregisterOption = 1] = "UnregisterOption", t2))(Ge || {});
let Ce = { [0](o3, r2) {
  let t2 = [...o3.options, { id: r2.id, element: r2.element, propsRef: r2.propsRef }];
  return { ...o3, options: I$a(t2, (p2) => p2.element.current) };
}, [1](o3, r2) {
  let t2 = o3.options.slice(), p2 = o3.options.findIndex((T2) => T2.id === r2.id);
  return p2 === -1 ? o3 : (t2.splice(p2, 1), { ...o3, options: t2 });
} }, B = createContext(null);
B.displayName = "RadioGroupDataContext";
function oe(o3) {
  let r2 = useContext(B);
  if (r2 === null) {
    let t2 = new Error(`<${o3} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t2, oe), t2;
  }
  return r2;
}
let $$1 = createContext(null);
$$1.displayName = "RadioGroupActionsContext";
function ne(o3) {
  let r2 = useContext($$1);
  if (r2 === null) {
    let t2 = new Error(`<${o3} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t2, ne), t2;
  }
  return r2;
}
function ke(o3, r2) {
  return u$a(r2.type, Ce, o3, r2);
}
let Le$2 = "div";
function he$1(o3, r2) {
  let t2 = I$b(), { id: p2 = `headlessui-radiogroup-${t2}`, value: T2, defaultValue: v2, form: M2, name: m2, onChange: H2, by: G2 = (e3, i2) => e3 === i2, disabled: P2 = false, ...N2 } = o3, y2 = o$d(typeof G2 == "string" ? (e3, i2) => {
    let n2 = G2;
    return (e3 == null ? void 0 : e3[n2]) === (i2 == null ? void 0 : i2[n2]);
  } : G2), [A2, L2] = useReducer(ke, { options: [] }), a2 = A2.options, [h2, R2] = F$1(), [C2, U2] = w$9(), k2 = useRef(null), W = y$5(k2, r2), [l2, s2] = T$3(T2, H2, v2), b2 = useMemo(() => a2.find((e3) => !e3.propsRef.current.disabled), [a2]), x2 = useMemo(() => a2.some((e3) => y2(e3.propsRef.current.value, l2)), [a2, l2]), d2 = o$d((e3) => {
    var n2;
    if (P2 || y2(e3, l2)) return false;
    let i2 = (n2 = a2.find((f2) => y2(f2.propsRef.current.value, e3))) == null ? void 0 : n2.propsRef.current;
    return i2 != null && i2.disabled ? false : (s2 == null || s2(e3), true);
  });
  F$5({ container: k2.current, accept(e3) {
    return e3.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e3.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(e3) {
    e3.setAttribute("role", "none");
  } });
  let F2 = o$d((e3) => {
    let i2 = k2.current;
    if (!i2) return;
    let n2 = o$a(i2), f2 = a2.filter((u2) => u2.propsRef.current.disabled === false).map((u2) => u2.element.current);
    switch (e3.key) {
      case o$8.Enter:
        p$r(e3.currentTarget);
        break;
      case o$8.ArrowLeft:
      case o$8.ArrowUp:
        if (e3.preventDefault(), e3.stopPropagation(), O$2(f2, M$3.Previous | M$3.WrapAround) === N$2.Success) {
          let g2 = a2.find((K2) => K2.element.current === (n2 == null ? void 0 : n2.activeElement));
          g2 && d2(g2.propsRef.current.value);
        }
        break;
      case o$8.ArrowRight:
      case o$8.ArrowDown:
        if (e3.preventDefault(), e3.stopPropagation(), O$2(f2, M$3.Next | M$3.WrapAround) === N$2.Success) {
          let g2 = a2.find((K2) => K2.element.current === (n2 == null ? void 0 : n2.activeElement));
          g2 && d2(g2.propsRef.current.value);
        }
        break;
      case o$8.Space:
        {
          e3.preventDefault(), e3.stopPropagation();
          let u2 = a2.find((g2) => g2.element.current === (n2 == null ? void 0 : n2.activeElement));
          u2 && d2(u2.propsRef.current.value);
        }
        break;
    }
  }), c2 = o$d((e3) => (L2({ type: 0, ...e3 }), () => L2({ type: 1, id: e3.id }))), w2 = useMemo(() => ({ value: l2, firstOption: b2, containsCheckedOption: x2, disabled: P2, compare: y2, ...A2 }), [l2, b2, x2, P2, y2, A2]), ie2 = useMemo(() => ({ registerOption: c2, change: d2 }), [c2, d2]), ae2 = { ref: W, id: p2, role: "radiogroup", "aria-labelledby": h2, "aria-describedby": C2, onKeyDown: F2 }, pe2 = useMemo(() => ({ value: l2 }), [l2]), I2 = useRef(null), le2 = p$t();
  return useEffect(() => {
    I2.current && v2 !== void 0 && le2.addEventListener(I2.current, "reset", () => {
      d2(v2);
    });
  }, [I2, d2]), a__default.createElement(U2, { name: "RadioGroup.Description" }, a__default.createElement(R2, { name: "RadioGroup.Label" }, a__default.createElement($$1.Provider, { value: ie2 }, a__default.createElement(B.Provider, { value: w2 }, m2 != null && l2 != null && e$5({ [m2]: l2 }).map(([e3, i2], n2) => a__default.createElement(u$7, { features: s$t.Hidden, ref: n2 === 0 ? (f2) => {
    var u2;
    I2.current = (u2 = f2 == null ? void 0 : f2.closest("form")) != null ? u2 : null;
  } : void 0, ...x$2({ key: e3, as: "input", type: "radio", checked: i2 != null, hidden: true, readOnly: true, form: M2, disabled: P2, name: e3, value: i2 }) })), C$4({ ourProps: ae2, theirProps: N2, slot: pe2, defaultTag: Le$2, name: "RadioGroup" })))));
}
var xe$2 = ((t2) => (t2[t2.Empty = 1] = "Empty", t2[t2.Active = 2] = "Active", t2))(xe$2 || {});
let Fe$2 = "div";
function we(o3, r2) {
  var F2;
  let t2 = I$b(), { id: p2 = `headlessui-radiogroup-option-${t2}`, value: T2, disabled: v2 = false, ...M2 } = o3, m2 = useRef(null), H2 = y$5(m2, r2), [G2, P2] = F$1(), [N2, y2] = w$9(), { addFlag: A2, removeFlag: L2, hasFlag: a2 } = c$n(1), h2 = s$w({ value: T2, disabled: v2 }), R2 = oe("RadioGroup.Option"), C2 = ne("RadioGroup.Option");
  l$m(() => C2.registerOption({ id: p2, element: m2, propsRef: h2 }), [p2, C2, m2, h2]);
  let U2 = o$d((c2) => {
    var w2;
    if (r$b(c2.currentTarget)) return c2.preventDefault();
    C2.change(T2) && (A2(2), (w2 = m2.current) == null || w2.focus());
  }), k2 = o$d((c2) => {
    if (r$b(c2.currentTarget)) return c2.preventDefault();
    A2(2);
  }), W = o$d(() => L2(2)), l2 = ((F2 = R2.firstOption) == null ? void 0 : F2.id) === p2, s2 = R2.disabled || v2, b2 = R2.compare(R2.value, T2), x2 = { ref: H2, id: p2, role: "radio", "aria-checked": b2 ? "true" : "false", "aria-labelledby": G2, "aria-describedby": N2, "aria-disabled": s2 ? true : void 0, tabIndex: (() => s2 ? -1 : b2 || !R2.containsCheckedOption && l2 ? 0 : -1)(), onClick: s2 ? void 0 : U2, onFocus: s2 ? void 0 : k2, onBlur: s2 ? void 0 : W }, d2 = useMemo(() => ({ checked: b2, disabled: s2, active: a2(2) }), [b2, s2, a2]);
  return a__default.createElement(y2, { name: "RadioGroup.Description" }, a__default.createElement(P2, { name: "RadioGroup.Label" }, C$4({ ourProps: x2, theirProps: M2, slot: d2, defaultTag: Fe$2, name: "RadioGroup.Option" })));
}
let Ie$1 = U$3(he$1), Se$2 = U$3(we), it = Object.assign(Ie$1, { Option: Se$2, Label: B$1, Description: G });
function b$4({ onFocus: n2 }) {
  let [r2, o3] = useState(true), u2 = f$s();
  return r2 ? a__default.createElement(u$7, { as: "button", type: "button", features: s$t.Focusable, onFocus: (a2) => {
    a2.preventDefault();
    let e3, i2 = 50;
    function t2() {
      if (i2-- <= 0) {
        e3 && cancelAnimationFrame(e3);
        return;
      }
      if (n2()) {
        if (cancelAnimationFrame(e3), !u2.current) return;
        o3(false);
        return;
      }
      e3 = requestAnimationFrame(t2);
    }
    e3 = requestAnimationFrame(t2);
  } }) : null;
}
const s$n = a$z.createContext(null);
function a$q() {
  return { groups: /* @__PURE__ */ new Map(), get(n2, t2) {
    var c2;
    let e3 = this.groups.get(n2);
    e3 || (e3 = /* @__PURE__ */ new Map(), this.groups.set(n2, e3));
    let l2 = (c2 = e3.get(t2)) != null ? c2 : 0;
    e3.set(t2, l2 + 1);
    let o3 = Array.from(e3.keys()).indexOf(t2);
    function i2() {
      let u2 = e3.get(t2);
      u2 > 1 ? e3.set(t2, u2 - 1) : e3.delete(t2);
    }
    return [o3, i2];
  } };
}
function C$2({ children: n2 }) {
  let t2 = a$z.useRef(a$q());
  return a$z.createElement(s$n.Provider, { value: t2 }, n2);
}
function d$4(n2) {
  let t2 = a$z.useContext(s$n);
  if (!t2) throw new Error("You must wrap your component in a <StableCollection>");
  let e3 = f$o(), [l2, o3] = t2.current.get(n2, e3);
  return a$z.useEffect(() => o3, []), l2;
}
function f$o() {
  var l2, o3, i2;
  let n2 = (i2 = (o3 = (l2 = a$z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : l2.ReactCurrentOwner) == null ? void 0 : o3.current) != null ? i2 : null;
  if (!n2) return Symbol();
  let t2 = [], e3 = n2;
  for (; e3; ) t2.push(e3.index), e3 = e3.return;
  return "$." + t2.join(".");
}
var ue$1 = ((t2) => (t2[t2.Forwards = 0] = "Forwards", t2[t2.Backwards = 1] = "Backwards", t2))(ue$1 || {}), Te = ((l2) => (l2[l2.Less = -1] = "Less", l2[l2.Equal = 0] = "Equal", l2[l2.Greater = 1] = "Greater", l2))(Te || {}), de = ((a2) => (a2[a2.SetSelectedIndex = 0] = "SetSelectedIndex", a2[a2.RegisterTab = 1] = "RegisterTab", a2[a2.UnregisterTab = 2] = "UnregisterTab", a2[a2.RegisterPanel = 3] = "RegisterPanel", a2[a2.UnregisterPanel = 4] = "UnregisterPanel", a2))(de || {});
let ce = { [0](e3, n2) {
  var i2;
  let t2 = I$a(e3.tabs, (c2) => c2.current), l2 = I$a(e3.panels, (c2) => c2.current), o3 = t2.filter((c2) => {
    var p2;
    return !((p2 = c2.current) != null && p2.hasAttribute("disabled"));
  }), a2 = { ...e3, tabs: t2, panels: l2 };
  if (n2.index < 0 || n2.index > t2.length - 1) {
    let c2 = u$a(Math.sign(n2.index - e3.selectedIndex), { [-1]: () => 1, [0]: () => u$a(Math.sign(n2.index), { [-1]: () => 0, [0]: () => 0, [1]: () => 1 }), [1]: () => 0 });
    if (o3.length === 0) return a2;
    let p2 = u$a(c2, { [0]: () => t2.indexOf(o3[0]), [1]: () => t2.indexOf(o3[o3.length - 1]) });
    return { ...a2, selectedIndex: p2 === -1 ? e3.selectedIndex : p2 };
  }
  let T2 = t2.slice(0, n2.index), m2 = [...t2.slice(n2.index), ...T2].find((c2) => o3.includes(c2));
  if (!m2) return a2;
  let b2 = (i2 = t2.indexOf(m2)) != null ? i2 : e3.selectedIndex;
  return b2 === -1 && (b2 = e3.selectedIndex), { ...a2, selectedIndex: b2 };
}, [1](e3, n2) {
  if (e3.tabs.includes(n2.tab)) return e3;
  let t2 = e3.tabs[e3.selectedIndex], l2 = I$a([...e3.tabs, n2.tab], (a2) => a2.current), o3 = e3.selectedIndex;
  return e3.info.current.isControlled || (o3 = l2.indexOf(t2), o3 === -1 && (o3 = e3.selectedIndex)), { ...e3, tabs: l2, selectedIndex: o3 };
}, [2](e3, n2) {
  return { ...e3, tabs: e3.tabs.filter((t2) => t2 !== n2.tab) };
}, [3](e3, n2) {
  return e3.panels.includes(n2.panel) ? e3 : { ...e3, panels: I$a([...e3.panels, n2.panel], (t2) => t2.current) };
}, [4](e3, n2) {
  return { ...e3, panels: e3.panels.filter((t2) => t2 !== n2.panel) };
} }, X = createContext(null);
X.displayName = "TabsDataContext";
function F(e3) {
  let n2 = useContext(X);
  if (n2 === null) {
    let t2 = new Error(`<${e3} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t2, F), t2;
  }
  return n2;
}
let $ = createContext(null);
$.displayName = "TabsActionsContext";
function q$1(e3) {
  let n2 = useContext($);
  if (n2 === null) {
    let t2 = new Error(`<${e3} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t2, q$1), t2;
  }
  return n2;
}
function fe(e3, n2) {
  return u$a(n2.type, ce, e3, n2);
}
let be = Fragment;
function me(e3, n2) {
  let { defaultIndex: t2 = 0, vertical: l2 = false, manual: o3 = false, onChange: a2, selectedIndex: T2 = null, ...R2 } = e3;
  const m2 = l2 ? "vertical" : "horizontal", b2 = o3 ? "manual" : "auto";
  let i2 = T2 !== null, c2 = s$w({ isControlled: i2 }), p2 = y$5(n2), [u2, f2] = useReducer(fe, { info: c2, selectedIndex: T2 != null ? T2 : t2, tabs: [], panels: [] }), P2 = useMemo(() => ({ selectedIndex: u2.selectedIndex }), [u2.selectedIndex]), g2 = s$w(a2 || (() => {
  })), E2 = s$w(u2.tabs), L2 = useMemo(() => ({ orientation: m2, activation: b2, ...u2 }), [m2, b2, u2]), A2 = o$d((s2) => (f2({ type: 1, tab: s2 }), () => f2({ type: 2, tab: s2 }))), S2 = o$d((s2) => (f2({ type: 3, panel: s2 }), () => f2({ type: 4, panel: s2 }))), k2 = o$d((s2) => {
    h2.current !== s2 && g2.current(s2), i2 || f2({ type: 0, index: s2 });
  }), h2 = s$w(i2 ? e3.selectedIndex : u2.selectedIndex), W = useMemo(() => ({ registerTab: A2, registerPanel: S2, change: k2 }), []);
  l$m(() => {
    f2({ type: 0, index: T2 != null ? T2 : t2 });
  }, [T2]), l$m(() => {
    if (h2.current === void 0 || u2.tabs.length <= 0) return;
    let s2 = I$a(u2.tabs, (d2) => d2.current);
    s2.some((d2, M2) => u2.tabs[M2] !== d2) && k2(s2.indexOf(u2.tabs[h2.current]));
  });
  let O2 = { ref: p2 };
  return a__default.createElement(C$2, null, a__default.createElement($.Provider, { value: W }, a__default.createElement(X.Provider, { value: L2 }, L2.tabs.length <= 0 && a__default.createElement(b$4, { onFocus: () => {
    var s2, r2;
    for (let d2 of E2.current) if (((s2 = d2.current) == null ? void 0 : s2.tabIndex) === 0) return (r2 = d2.current) == null || r2.focus(), true;
    return false;
  } }), C$4({ ourProps: O2, theirProps: R2, slot: P2, defaultTag: be, name: "Tabs" }))));
}
let Pe$1 = "div";
function ye$1(e3, n2) {
  let { orientation: t2, selectedIndex: l2 } = F("Tab.List"), o3 = y$5(n2);
  return C$4({ ourProps: { ref: o3, role: "tablist", "aria-orientation": t2 }, theirProps: e3, slot: { selectedIndex: l2 }, defaultTag: Pe$1, name: "Tabs.List" });
}
let xe$1 = "button";
function ge(e3, n2) {
  var O2, s2;
  let t2 = I$b(), { id: l2 = `headlessui-tabs-tab-${t2}`, ...o3 } = e3, { orientation: a2, activation: T2, selectedIndex: R2, tabs: m2, panels: b2 } = F("Tab"), i2 = q$1("Tab"), c2 = F("Tab"), p2 = useRef(null), u2 = y$5(p2, n2);
  l$m(() => i2.registerTab(p2), [i2, p2]);
  let f2 = d$4("tabs"), P2 = m2.indexOf(p2);
  P2 === -1 && (P2 = f2);
  let g2 = P2 === R2, E2 = o$d((r2) => {
    var M2;
    let d2 = r2();
    if (d2 === N$2.Success && T2 === "auto") {
      let K2 = (M2 = o$a(p2)) == null ? void 0 : M2.activeElement, z2 = c2.tabs.findIndex((te2) => te2.current === K2);
      z2 !== -1 && i2.change(z2);
    }
    return d2;
  }), L2 = o$d((r2) => {
    let d2 = m2.map((K2) => K2.current).filter(Boolean);
    if (r2.key === o$8.Space || r2.key === o$8.Enter) {
      r2.preventDefault(), r2.stopPropagation(), i2.change(P2);
      return;
    }
    switch (r2.key) {
      case o$8.Home:
      case o$8.PageUp:
        return r2.preventDefault(), r2.stopPropagation(), E2(() => O$2(d2, M$3.First));
      case o$8.End:
      case o$8.PageDown:
        return r2.preventDefault(), r2.stopPropagation(), E2(() => O$2(d2, M$3.Last));
    }
    if (E2(() => u$a(a2, { vertical() {
      return r2.key === o$8.ArrowUp ? O$2(d2, M$3.Previous | M$3.WrapAround) : r2.key === o$8.ArrowDown ? O$2(d2, M$3.Next | M$3.WrapAround) : N$2.Error;
    }, horizontal() {
      return r2.key === o$8.ArrowLeft ? O$2(d2, M$3.Previous | M$3.WrapAround) : r2.key === o$8.ArrowRight ? O$2(d2, M$3.Next | M$3.WrapAround) : N$2.Error;
    } })) === N$2.Success) return r2.preventDefault();
  }), A2 = useRef(false), S2 = o$d(() => {
    var r2;
    A2.current || (A2.current = true, (r2 = p2.current) == null || r2.focus({ preventScroll: true }), i2.change(P2), t$F(() => {
      A2.current = false;
    }));
  }), k2 = o$d((r2) => {
    r2.preventDefault();
  }), h2 = useMemo(() => {
    var r2;
    return { selected: g2, disabled: (r2 = e3.disabled) != null ? r2 : false };
  }, [g2, e3.disabled]), W = { ref: u2, onKeyDown: L2, onMouseDown: k2, onClick: S2, id: l2, role: "tab", type: T$1(e3, p2), "aria-controls": (s2 = (O2 = b2[P2]) == null ? void 0 : O2.current) == null ? void 0 : s2.id, "aria-selected": g2, tabIndex: g2 ? 0 : -1 };
  return C$4({ ourProps: W, theirProps: o3, slot: h2, defaultTag: xe$1, name: "Tabs.Tab" });
}
let Ee = "div";
function Ae(e3, n2) {
  let { selectedIndex: t2 } = F("Tab.Panels"), l2 = y$5(n2), o3 = useMemo(() => ({ selectedIndex: t2 }), [t2]);
  return C$4({ ourProps: { ref: l2 }, theirProps: e3, slot: o3, defaultTag: Ee, name: "Tabs.Panels" });
}
let Re$1 = "div", Le$1 = O$1.RenderStrategy | O$1.Static;
function _e$1(e3, n2) {
  var E2, L2, A2, S2;
  let t2 = I$b(), { id: l2 = `headlessui-tabs-panel-${t2}`, tabIndex: o3 = 0, ...a2 } = e3, { selectedIndex: T2, tabs: R2, panels: m2 } = F("Tab.Panel"), b2 = q$1("Tab.Panel"), i2 = useRef(null), c2 = y$5(i2, n2);
  l$m(() => b2.registerPanel(i2), [b2, i2, l2]);
  let p2 = d$4("panels"), u2 = m2.indexOf(i2);
  u2 === -1 && (u2 = p2);
  let f2 = u2 === T2, P2 = useMemo(() => ({ selected: f2 }), [f2]), g2 = { ref: c2, id: l2, role: "tabpanel", "aria-labelledby": (L2 = (E2 = R2[u2]) == null ? void 0 : E2.current) == null ? void 0 : L2.id, tabIndex: f2 ? o3 : -1 };
  return !f2 && ((A2 = a2.unmount) == null || A2) && !((S2 = a2.static) != null && S2) ? a__default.createElement(u$7, { as: "span", "aria-hidden": "true", ...g2 }) : C$4({ ourProps: g2, theirProps: a2, slot: P2, defaultTag: Re$1, features: Le$1, visible: f2, name: "Tabs.Panel" });
}
let Se$1 = U$3(ge), Ie = U$3(me), De$1 = U$3(ye$1), Fe$1 = U$3(Ae), he = U$3(_e$1), $e = Object.assign(Se$1, { Group: Ie, List: De$1, Panels: Fe$1, Panel: he });
function l$h(r2) {
  let e3 = { called: false };
  return (...t2) => {
    if (!e3.called) return e3.called = true, r2(...t2);
  };
}
function g$3(t2, ...e3) {
  t2 && e3.length > 0 && t2.classList.add(...e3);
}
function v$1(t2, ...e3) {
  t2 && e3.length > 0 && t2.classList.remove(...e3);
}
function b$3(t2, e3) {
  let n2 = o$c();
  if (!t2) return n2.dispose;
  let { transitionDuration: m2, transitionDelay: a2 } = getComputedStyle(t2), [u2, p2] = [m2, a2].map((l2) => {
    let [r2 = 0] = l2.split(",").filter(Boolean).map((i2) => i2.includes("ms") ? parseFloat(i2) : parseFloat(i2) * 1e3).sort((i2, T2) => T2 - i2);
    return r2;
  }), o3 = u2 + p2;
  if (o3 !== 0) {
    n2.group((r2) => {
      r2.setTimeout(() => {
        e3(), r2.dispose();
      }, o3), r2.addEventListener(t2, "transitionrun", (i2) => {
        i2.target === i2.currentTarget && r2.dispose();
      });
    });
    let l2 = n2.addEventListener(t2, "transitionend", (r2) => {
      r2.target === r2.currentTarget && (e3(), l2());
    });
  } else e3();
  return n2.add(() => e3()), n2.dispose;
}
function M$1(t2, e3, n2, m2) {
  let a2 = n2 ? "enter" : "leave", u2 = o$c(), p2 = m2 !== void 0 ? l$h(m2) : () => {
  };
  a2 === "enter" && (t2.removeAttribute("hidden"), t2.style.display = "");
  let o3 = u$a(a2, { enter: () => e3.enter, leave: () => e3.leave }), l2 = u$a(a2, { enter: () => e3.enterTo, leave: () => e3.leaveTo }), r2 = u$a(a2, { enter: () => e3.enterFrom, leave: () => e3.leaveFrom });
  return v$1(t2, ...e3.base, ...e3.enter, ...e3.enterTo, ...e3.enterFrom, ...e3.leave, ...e3.leaveFrom, ...e3.leaveTo, ...e3.entered), g$3(t2, ...e3.base, ...o3, ...r2), u2.nextFrame(() => {
    v$1(t2, ...e3.base, ...o3, ...r2), g$3(t2, ...e3.base, ...o3, ...l2), b$3(t2, () => (v$1(t2, ...e3.base, ...o3), g$3(t2, ...e3.base, ...e3.entered), p2()));
  }), u2.dispose;
}
function D$2({ immediate: t2, container: s2, direction: n2, classes: u2, onStart: a2, onStop: c2 }) {
  let l2 = f$s(), d2 = p$t(), e3 = s$w(n2);
  l$m(() => {
    t2 && (e3.current = "enter");
  }, [t2]), l$m(() => {
    let r2 = o$c();
    d2.add(r2.dispose);
    let i2 = s2.current;
    if (i2 && e3.current !== "idle" && l2.current) return r2.dispose(), a2.current(e3.current), r2.add(M$1(i2, u2.current, e3.current === "enter", () => {
      r2.dispose(), c2.current(e3.current);
    })), r2.dispose;
  }, [n2]);
}
function S(t2 = "") {
  return t2.split(/\s+/).filter((n2) => n2.length > 1);
}
let I$5 = createContext(null);
I$5.displayName = "TransitionContext";
var Se = ((r2) => (r2.Visible = "visible", r2.Hidden = "hidden", r2))(Se || {});
function ye() {
  let t2 = useContext(I$5);
  if (t2 === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t2;
}
function xe() {
  let t2 = useContext(M);
  if (t2 === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t2;
}
let M = createContext(null);
M.displayName = "NestingContext";
function U(t2) {
  return "children" in t2 ? U(t2.children) : t2.current.filter(({ el: n2 }) => n2.current !== null).filter(({ state: n2 }) => n2 === "visible").length > 0;
}
function se(t2, n2) {
  let r2 = s$w(t2), s2 = useRef([]), R2 = f$s(), D2 = p$t(), p2 = o$d((i2, e3 = v$4.Hidden) => {
    let a2 = s2.current.findIndex(({ el: o3 }) => o3 === i2);
    a2 !== -1 && (u$a(e3, { [v$4.Unmount]() {
      s2.current.splice(a2, 1);
    }, [v$4.Hidden]() {
      s2.current[a2].state = "hidden";
    } }), D2.microTask(() => {
      var o3;
      !U(s2) && R2.current && ((o3 = r2.current) == null || o3.call(r2));
    }));
  }), x2 = o$d((i2) => {
    let e3 = s2.current.find(({ el: a2 }) => a2 === i2);
    return e3 ? e3.state !== "visible" && (e3.state = "visible") : s2.current.push({ el: i2, state: "visible" }), () => p2(i2, v$4.Unmount);
  }), h2 = useRef([]), v2 = useRef(Promise.resolve()), u2 = useRef({ enter: [], leave: [], idle: [] }), g2 = o$d((i2, e3, a2) => {
    h2.current.splice(0), n2 && (n2.chains.current[e3] = n2.chains.current[e3].filter(([o3]) => o3 !== i2)), n2 == null || n2.chains.current[e3].push([i2, new Promise((o3) => {
      h2.current.push(o3);
    })]), n2 == null || n2.chains.current[e3].push([i2, new Promise((o3) => {
      Promise.all(u2.current[e3].map(([f2, N2]) => N2)).then(() => o3());
    })]), e3 === "enter" ? v2.current = v2.current.then(() => n2 == null ? void 0 : n2.wait.current).then(() => a2(e3)) : a2(e3);
  }), d2 = o$d((i2, e3, a2) => {
    Promise.all(u2.current[e3].splice(0).map(([o3, f2]) => f2)).then(() => {
      var o3;
      (o3 = h2.current.shift()) == null || o3();
    }).then(() => a2(e3));
  });
  return useMemo(() => ({ children: s2, register: x2, unregister: p2, onStart: g2, onStop: d2, wait: v2, chains: u2 }), [x2, p2, s2, g2, d2, u2, v2]);
}
function Ne() {
}
let Pe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ae(t2) {
  var r2;
  let n2 = {};
  for (let s2 of Pe) n2[s2] = (r2 = t2[s2]) != null ? r2 : Ne;
  return n2;
}
function Re(t2) {
  let n2 = useRef(ae(t2));
  return useEffect(() => {
    n2.current = ae(t2);
  }, [t2]), n2;
}
let De = "div", le = O$1.RenderStrategy;
function He(t2, n2) {
  var Q2, Y2;
  let { beforeEnter: r2, afterEnter: s2, beforeLeave: R2, afterLeave: D2, enter: p2, enterFrom: x2, enterTo: h2, entered: v2, leave: u2, leaveFrom: g2, leaveTo: d2, ...i2 } = t2, e3 = useRef(null), a2 = y$5(e3, n2), o3 = (Q2 = i2.unmount) == null || Q2 ? v$4.Unmount : v$4.Hidden, { show: f2, appear: N2, initial: T2 } = ye(), [l2, j2] = useState(f2 ? "visible" : "hidden"), z2 = xe(), { register: L2, unregister: O2 } = z2;
  useEffect(() => L2(e3), [L2, e3]), useEffect(() => {
    if (o3 === v$4.Hidden && e3.current) {
      if (f2 && l2 !== "visible") {
        j2("visible");
        return;
      }
      return u$a(l2, { ["hidden"]: () => O2(e3), ["visible"]: () => L2(e3) });
    }
  }, [l2, e3, L2, O2, f2, o3]);
  let k2 = s$w({ base: S(i2.className), enter: S(p2), enterFrom: S(x2), enterTo: S(h2), entered: S(v2), leave: S(u2), leaveFrom: S(g2), leaveTo: S(d2) }), V2 = Re({ beforeEnter: r2, afterEnter: s2, beforeLeave: R2, afterLeave: D2 }), G2 = l$l();
  useEffect(() => {
    if (G2 && l2 === "visible" && e3.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e3, l2, G2]);
  let Te2 = T2 && !N2, K2 = N2 && f2 && T2, de2 = /* @__PURE__ */ (() => !G2 || Te2 ? "idle" : f2 ? "enter" : "leave")(), H2 = c$n(0), fe2 = o$d((C2) => u$a(C2, { enter: () => {
    H2.addFlag(d$9.Opening), V2.current.beforeEnter();
  }, leave: () => {
    H2.addFlag(d$9.Closing), V2.current.beforeLeave();
  }, idle: () => {
  } })), me2 = o$d((C2) => u$a(C2, { enter: () => {
    H2.removeFlag(d$9.Opening), V2.current.afterEnter();
  }, leave: () => {
    H2.removeFlag(d$9.Closing), V2.current.afterLeave();
  }, idle: () => {
  } })), w2 = se(() => {
    j2("hidden"), O2(e3);
  }, z2), B2 = useRef(false);
  D$2({ immediate: K2, container: e3, classes: k2, direction: de2, onStart: s$w((C2) => {
    B2.current = true, w2.onStart(e3, C2, fe2);
  }), onStop: s$w((C2) => {
    B2.current = false, w2.onStop(e3, C2, me2), C2 === "leave" && !U(w2) && (j2("hidden"), O2(e3));
  }) });
  let P2 = i2, ce2 = { ref: a2 };
  return K2 ? P2 = { ...P2, className: t$C(i2.className, ...k2.current.enter, ...k2.current.enterFrom) } : B2.current && (P2.className = t$C(i2.className, (Y2 = e3.current) == null ? void 0 : Y2.className), P2.className === "" && delete P2.className), a__default.createElement(M.Provider, { value: w2 }, a__default.createElement(s$s, { value: u$a(l2, { ["visible"]: d$9.Open, ["hidden"]: d$9.Closed }) | H2.flags }, C$4({ ourProps: ce2, theirProps: P2, defaultTag: De, features: le, visible: l2 === "visible", name: "Transition.Child" })));
}
function Fe(t2, n2) {
  let { show: r2, appear: s2 = false, unmount: R2 = true, ...D2 } = t2, p2 = useRef(null), x2 = y$5(p2, n2);
  l$l();
  let h2 = u$6();
  if (r2 === void 0 && h2 !== null && (r2 = (h2 & d$9.Open) === d$9.Open), ![true, false].includes(r2)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [v2, u2] = useState(r2 ? "visible" : "hidden"), g2 = se(() => {
    u2("hidden");
  }), [d2, i2] = useState(true), e3 = useRef([r2]);
  l$m(() => {
    d2 !== false && e3.current[e3.current.length - 1] !== r2 && (e3.current.push(r2), i2(false));
  }, [e3, r2]);
  let a2 = useMemo(() => ({ show: r2, appear: s2, initial: d2 }), [r2, s2, d2]);
  useEffect(() => {
    if (r2) u2("visible");
    else if (!U(g2)) u2("hidden");
    else {
      let T2 = p2.current;
      if (!T2) return;
      let l2 = T2.getBoundingClientRect();
      l2.x === 0 && l2.y === 0 && l2.width === 0 && l2.height === 0 && u2("hidden");
    }
  }, [r2, g2]);
  let o3 = { unmount: R2 }, f2 = o$d(() => {
    var T2;
    d2 && i2(false), (T2 = t2.beforeEnter) == null || T2.call(t2);
  }), N2 = o$d(() => {
    var T2;
    d2 && i2(false), (T2 = t2.beforeLeave) == null || T2.call(t2);
  });
  return a__default.createElement(M.Provider, { value: g2 }, a__default.createElement(I$5.Provider, { value: a2 }, C$4({ ourProps: { ...o3, as: Fragment, children: a__default.createElement(ue, { ref: x2, ...o3, ...D2, beforeEnter: f2, beforeLeave: N2 }) }, theirProps: {}, defaultTag: Fragment, features: le, visible: v2 === "visible", name: "Transition" })));
}
function _e(t2, n2) {
  let r2 = useContext(I$5) !== null, s2 = u$6() !== null;
  return a__default.createElement(a__default.Fragment, null, !r2 && s2 ? a__default.createElement(q, { ref: n2, ...t2 }) : a__default.createElement(ue, { ref: n2, ...t2 }));
}
let q = U$3(Fe), ue = U$3(He), Le = U$3(_e), qe = Object.assign(q, { Child: Le, Root: q });
const variantClasses$4 = {
  base: clsx(
    "flex max-w-fit items-center justify-center gap-e8",
    "font-medium text-warm-gray",
    "disabled:online-black-12% disabled:pointer-events-none disabled:text-warm-gray-600",
    "mobile-d:max-w-none"
  ),
  primary: clsx(
    "bg-purple-200 hover:bg-purple-300",
    "border border-warm-gray-4%",
    "active:border-warm-gray-700 active:bg-purple-300",
    "disabled:bg-warm-gray-300"
  ),
  secondary: clsx(
    "bg-transparent hover:bg-warm-gray-8%",
    "border border-warm-gray-700",
    "active:border-warm-gray-700 active:bg-warm-gray-16%",
    "disabled:border-warm-gray-500"
  ),
  ghost: clsx("hover:bg-warm-gray-8%", "active:bg-warm-gray-16%"),
  link: clsx(
    "inline-flex h-auto p-0 text-purple-900",
    "underline underline-offset-2",
    "hover:text-warm-gray-900",
    "active:text-warm-gray-900 active:underline",
    "disabled:text-warm-gray-600"
  ),
  destructive: clsx(
    "bg-orange-300 hover:bg-orange-400",
    "border border-warm-gray-4%",
    "active:border-warm-gray-700 active:bg-orange-400",
    "disabled:bg-warm-gray-300"
  )
};
const sizeVariantClasses = {
  lg: "text-button-lg px-e24 svg:size-e20 h-e48 mobile-d:w-full",
  md: "text-button-md px-e20 svg:size-e16 h-e40",
  sm: "text-button-sm px-e16 svg:size-e16 h-e32",
  xs: "text-button-xs px-e12 svg:size-e12 h-e24"
};
const iconOnlySizeVariantClasses = {
  lg: "size-e48 mobile-d:w-e48",
  md: "size-e40",
  sm: "size-e32",
  xs: "size-e24"
};
const iconOnlyBaseClasses = clsx("max-w-none shrink-0 p-0");
const baseClasses$2 = clsx("rounded-full font-semibold");
const fullWidthClasses = "w-full max-w-none";
const Button = ({
  className,
  children,
  variant = "primary",
  iconOnly,
  fullWidth,
  size: size2 = "lg",
  type = "button",
  as,
  buttonRef,
  ...rest
}) => {
  const asElement = as ?? "button";
  return createElement(
    asElement,
    {
      type,
      ref: buttonRef,
      className: twMerge(
        clsx(
          baseClasses$2,
          variantClasses$4.base,
          sizeVariantClasses[size2],
          variantClasses$4[variant],
          {
            // Mind the order of these classes.
            [iconOnlyBaseClasses]: iconOnly,
            [iconOnlySizeVariantClasses[size2]]: iconOnly,
            [fullWidthClasses]: fullWidth
          },
          className
        )
      ),
      ...rest
    },
    children
  );
};
const rootClasses$1 = clsx(
  "font-medium text-warm-gray-900",
  "flex w-full items-center justify-between px-e32 py-e24",
  "mobile-d:gap-e24"
);
const buttonClasses = clsx("transition-transform duration-300");
const disabledClasses = clsx("cursor-not-allowed text-warm-gray-600");
const getRootClasses = (disabled) => twMerge(
  clsx(rootClasses$1, {
    [disabledClasses]: disabled,
    "group cursor-pointer": !disabled
  })
);
const getButtonClasses = (open) => twMerge(
  clsx(buttonClasses, {
    "-rotate-180": open
  })
);
const SvgCheck = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", fill: "none", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("path", { d: "M14 20.5L17.6522 24L26 16", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }));
const SvgCirclesTarget = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("circle", { cx: 12, cy: 12, r: 9, strokeWidth: 2, fill: "currentColor" }), /* @__PURE__ */ a$z.createElement("circle", { cx: 12, cy: 12, r: 4, fill: "currentColor" }));
const SvgGradientSpinner = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("rect", { width: 256, height: 256, fill: "none" }), /* @__PURE__ */ a$z.createElement("line", { x1: 128, y1: 32, x2: 128, y2: 64, fill: "none", stroke: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 195.88, y1: 60.12, x2: 173.25, y2: 82.75, fill: "none", stroke: "#F9F8F0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 224, y1: 128, x2: 192, y2: 128, fill: "none", stroke: "#F0EFE7", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 195.88, y1: 195.88, x2: 173.25, y2: 173.25, fill: "none", stroke: "#E5E4DC", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 128, y1: 224, x2: 128, y2: 192, fill: "none", stroke: "#D4D3CB", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 60.12, y1: 195.88, x2: 82.75, y2: 173.25, fill: "none", stroke: "#AFAEA7", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 32, y1: 128, x2: 64, y2: 128, fill: "none", stroke: "#8E8D86", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }), /* @__PURE__ */ a$z.createElement("line", { x1: 60.12, y1: 60.12, x2: 82.75, y2: 82.75, fill: "none", stroke: "#67665F", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 16 }));
const SvgPerson = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 14, viewBox: "0 0 15 14", fill: "none", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("path", { d: "M7.74967 6.99967C7.10801 6.99967 6.5587 6.7712 6.10176 6.31426C5.64481 5.85731 5.41634 5.30801 5.41634 4.66634C5.41634 4.02467 5.64481 3.47537 6.10176 3.01842C6.5587 2.56148 7.10801 2.33301 7.74967 2.33301C8.39134 2.33301 8.94065 2.56148 9.39759 3.01842C9.85454 3.47537 10.083 4.02467 10.083 4.66634C10.083 5.30801 9.85454 5.85731 9.39759 6.31426C8.94065 6.7712 8.39134 6.99967 7.74967 6.99967ZM3.08301 11.6663V10.033C3.08301 9.70245 3.16808 9.39863 3.33822 9.12155C3.50836 8.84447 3.7344 8.63301 4.01634 8.48717C4.61912 8.18579 5.23162 7.95974 5.85384 7.80905C6.47606 7.65835 7.10801 7.58301 7.74967 7.58301C8.39134 7.58301 9.02329 7.65835 9.64551 7.80905C10.2677 7.95974 10.8802 8.18579 11.483 8.48717C11.765 8.63301 11.991 8.84447 12.1611 9.12155C12.3313 9.39863 12.4163 9.70245 12.4163 10.033V11.6663H3.08301Z", fill: "currentColor" }));
const SYNTAX_ICONS = {
  Check: SvgCheck,
  CirclesTarget: SvgCirclesTarget,
  Person: SvgPerson,
  SpinnerGradient: SvgGradientSpinner
};
const iconSizeClasses = {
  xl: "size-e24",
  lg: "size-e20",
  md: "size-e16",
  sm: "size-e12"
};
const SyntaxIcon = forwardRef(
  ({ icon, title, className, weight = "bold", size: size2 = "md", ...rest }, ref) => {
    const IconComponent = useMemo(() => {
      if (typeof icon === "string") {
        return SYNTAX_ICONS[icon];
      }
      return icon;
    }, [icon]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconComponent,
      {
        ...rest,
        ref,
        weight,
        className: twMerge(iconSizeClasses[size2], className),
        title,
        children: title && /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title })
      }
    );
  }
);
const t$w = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,152.49l-72,72a12,12,0,0,1-17,0l-72-72a12,12,0,0,1,17-17L116,187V40a12,12,0,0,1,24,0V187l51.51-51.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M200,144l-72,72L56,144Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M207.39,140.94A8,8,0,0,0,200,136H136V40a8,8,0,0,0-16,0v96H56a8,8,0,0,0-5.66,13.66l72,72a8,8,0,0,0,11.32,0l72-72A8,8,0,0,0,207.39,140.94ZM128,204.69,75.31,152H180.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72A8,8,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,148.24l-72,72a6,6,0,0,1-8.48,0l-72-72a6,6,0,0,1,8.48-8.48L122,201.51V40a6,6,0,0,1,12,0V201.51l61.76-61.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,146.83l-72,72a4,4,0,0,1-5.66,0l-72-72a4,4,0,0,1,5.66-5.66L124,206.34V40a4,4,0,0,1,8,0V206.34l65.17-65.17a4,4,0,0,1,5.66,5.66Z" }))
  ]
]);
const a$p = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,128l-72,72V56Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,122.34l-72-72A8,8,0,0,0,136,56v64H40a8,8,0,0,0,0,16h96v64a8,8,0,0,0,13.66,5.66l72-72A8,8,0,0,0,221.66,122.34ZM152,180.69V75.31L204.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,133.66l-72,72A8,8,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8,8,0,0,1,13.66-5.66l72,72A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220.24,132.24l-72,72a6,6,0,0,1-8.48-8.48L201.51,134H40a6,6,0,0,1,0-12H201.51L139.76,60.24a6,6,0,0,1,8.48-8.48l72,72A6,6,0,0,1,220.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M218.83,130.83l-72,72a4,4,0,0,1-5.66-5.66L206.34,132H40a4,4,0,0,1,0-8H206.34L141.17,58.83a4,4,0,0,1,5.66-5.66l72,72A4,4,0,0,1,218.83,130.83Z" }))
  ]
]);
const V = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,28H188V24a12,12,0,0,0-24,0v4H92V24a12,12,0,0,0-24,0v4H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM68,52a12,12,0,0,0,24,0h72a12,12,0,0,0,24,0h16V76H52V52ZM52,204V100H204V204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,48H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212Z" }))
  ]
]);
const l$g = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]);
const a$o = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M160,48V208L80,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }))
  ]
]);
const l$f = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]);
const t$v = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]);
const t$u = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]);
const t$t = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm68-84a12,12,0,0,1-12,12H128a12,12,0,0,1-12-12V72a12,12,0,0,1,24,0v44h44A12,12,0,0,1,196,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm56,112H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm62-90a6,6,0,0,1-6,6H128a6,6,0,0,1-6-6V72a6,6,0,0,1,12,0v50h50A6,6,0,0,1,190,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm60-92a4,4,0,0,1-4,4H128a4,4,0,0,1-4-4V72a4,4,0,0,1,8,0v52h52A4,4,0,0,1,188,128Z" }))
  ]
]);
const t$s = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,128,136Zm80-40a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,208,136ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,48,136Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M152,128a24,24,0,1,1-24-24A24,24,0,0,1,152,128ZM48,104a24,24,0,1,0,24,24A24,24,0,0,0,48,104Zm160,0a24,24,0,1,0,24,24A24,24,0,0,0,208,104Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28,28,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28,28,0,0,0,208,100Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,98a30,30,0,1,0,30,30A30,30,0,0,0,128,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,146ZM48,98a30,30,0,1,0,30,30A30,30,0,0,0,48,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,48,146ZM208,98a30,30,0,1,0,30,30A30,30,0,0,0,208,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,208,146Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,100a28,28,0,1,0,28,28A28,28,0,0,0,128,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,128,148ZM48,100a28,28,0,1,0,28,28A28,28,0,0,0,48,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,48,148Zm160-48a28,28,0,1,0,28,28A28,28,0,0,0,208,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,208,148Z" }))
  ]
]);
const t$r = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0Zm-108.49,8.49a12,12,0,0,0,17,0l40-40a12,12,0,0,0-17-17L140,115V32a12,12,0,0,0-24,0v83L96.49,95.51a12,12,0,0,0-17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,168,96H136V32a8,8,0,0,0-16,0V96H88a8,8,0,0,0-5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0Zm-98.24,4.24a6,6,0,0,0,8.48,0l40-40a6,6,0,0,0-8.48-8.48L134,129.51V32a6,6,0,0,0-12,0v97.51L92.24,99.76a6,6,0,0,0-8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0Zm-94.83,2.83a4,4,0,0,0,5.66,0l40-40a4,4,0,1,0-5.66-5.66L132,134.34V32a4,4,0,0,0-8,0V134.34L90.83,101.17a4,4,0,0,0-5.66,5.66Z" }))
  ]
]);
const t$q = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M251,123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63,57.67,164,44,128,44S59.37,57.67,33.51,83.52C14.16,102.87,5.4,122.32,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212s68.63-13.66,94.48-39.51c19.36-19.35,28.12-38.79,28.49-39.61A12.08,12.08,0,0,0,251,123.13Zm-46.06,33C183.47,177.27,157.59,188,128,188s-55.47-10.73-76.91-31.88A130.36,130.36,0,0,1,29.52,128,130.45,130.45,0,0,1,51.09,99.89C72.54,78.73,98.41,68,128,68s55.46,10.73,76.91,31.89A130.36,130.36,0,0,1,226.48,128,130.45,130.45,0,0,1,204.91,156.12ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M245.48,125.57c-.34-.78-8.66-19.23-27.24-37.81C201,70.54,171.38,50,128,50S55,70.54,37.76,87.76c-18.58,18.58-26.9,37-27.24,37.81a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206s73-20.53,90.24-37.75c18.58-18.58,26.9-37,27.24-37.8A6,6,0,0,0,245.48,125.57ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.77,134.77,0,0,1,22.69,128,134.56,134.56,0,0,1,46.55,95.94C69.22,73.42,96.62,62,128,62s58.78,11.42,81.45,33.94A134.56,134.56,0,0,1,233.31,128C226.94,140.21,195,194,128,194Zm0-112a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M243.66,126.38c-.34-.76-8.52-18.89-26.83-37.2C199.87,72.22,170.7,52,128,52S56.13,72.22,39.17,89.18c-18.31,18.31-26.49,36.44-26.83,37.2a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17s71.87-20.21,88.83-37.17c18.31-18.31,26.49-36.43,26.83-37.2A4.08,4.08,0,0,0,243.66,126.38Zm-32.7,35c-23.07,23-51,34.62-83,34.62s-59.89-11.65-83-34.62A135.71,135.71,0,0,1,20.44,128,135.69,135.69,0,0,1,45,94.62C68.11,71.65,96,60,128,60s59.89,11.65,83,34.62A135.79,135.79,0,0,1,235.56,128,135.71,135.71,0,0,1,211,161.38ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z" }))
  ]
]);
const t$p = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M56.88,31.93A12,12,0,1,0,39.12,48.07l16,17.65C20.67,88.66,5.72,121.58,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212a131.34,131.34,0,0,0,51-10l20.09,22.1a12,12,0,0,0,17.76-16.14ZM128,188c-29.59,0-55.47-10.73-76.91-31.88A130.69,130.69,0,0,1,29.52,128c5.27-9.31,18.79-29.9,42-44.29l90.09,99.11A109.33,109.33,0,0,1,128,188Zm123-55.12c-.36.81-9,20-28,39.16a12,12,0,1,1-17-16.9A130.48,130.48,0,0,0,226.48,128a130.36,130.36,0,0,0-21.57-28.12C183.46,78.73,157.59,68,128,68c-3.35,0-6.7.14-10,.42a12,12,0,1,1-2-23.91c3.93-.34,8-.51,12-.51,36,0,68.63,13.67,94.49,39.52,19.35,19.35,28.11,38.8,28.48,39.61A12.08,12.08,0,0,1,251,132.88Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M96.68,57.87a4,4,0,0,1,2.08-6.6A130.13,130.13,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41a8,8,0,0,1,0,6.5c-.35.79-8.82,19.57-27.65,38.4q-4.28,4.26-8.79,8.07a4,4,0,0,1-5.55-.36ZM213.92,210.62a8,8,0,1,1-11.84,10.76L180,197.13A127.21,127.21,0,0,1,128,208c-34.88,0-66.57-13.26-91.66-38.34C17.51,150.83,9,132.05,8.69,131.26a8,8,0,0,1,0-6.5C9,124,17.51,105.18,36.34,86.35a135,135,0,0,1,25-19.78L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-65.49-48.25-52.69-58a40,40,0,0,0,52.69,58Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M52.44,36A6,6,0,0,0,43.56,44L64.44,67c-37.28,21.9-53.23,57-53.92,58.57a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206a124.91,124.91,0,0,0,52.57-11.25l23,25.29a6,6,0,0,0,8.88-8.08Zm48.62,71.32,45,49.52a34,34,0,0,1-45-49.52ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.57,134.57,0,0,1,22.69,128c4.29-8.2,20.1-35.18,50-51.91L92.89,98.3a46,46,0,0,0,61.35,67.48l17.81,19.6A113.47,113.47,0,0,1,128,194Zm6.4-99.4a6,6,0,0,1,2.25-11.79,46.17,46.17,0,0,1,37.15,40.87,6,6,0,0,1-5.42,6.53l-.56,0a6,6,0,0,1-6-5.45A34.1,34.1,0,0,0,134.4,94.6Zm111.08,35.85c-.41.92-10.37,23-32.86,43.12a6,6,0,1,1-8-8.94A134.07,134.07,0,0,0,233.31,128a134.67,134.67,0,0,0-23.86-32.07C186.78,73.42,159.38,62,128,62a120.19,120.19,0,0,0-19.69,1.6,6,6,0,1,1-2-11.83A131.12,131.12,0,0,1,128,50c43.38,0,73,20.54,90.24,37.76,18.58,18.58,26.9,37,27.24,37.81A6,6,0,0,1,245.48,130.45Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M51,37.31A4,4,0,0,0,45,42.69L67.59,67.5C29.34,89,13,124.81,12.34,126.38a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17a122.59,122.59,0,0,0,53.06-11.69l24,26.38a4,4,0,1,0,5.92-5.38ZM149.1,157.16A36,36,0,0,1,101,104.22ZM128,196c-32,0-59.89-11.65-83-34.62A135.81,135.81,0,0,1,20.44,128c3.65-7.23,20.09-36.81,52.68-54.43l22.45,24.7a44,44,0,0,0,59,64.83l20.89,23A114.94,114.94,0,0,1,128,196Zm6.78-103.36a4,4,0,0,1,1.49-7.86,44.15,44.15,0,0,1,35.54,39.09,4,4,0,0,1-3.61,4.35l-.38,0a4,4,0,0,1-4-3.63A36.1,36.1,0,0,0,134.78,92.64Zm108.88,37c-.41.91-10.2,22.58-32.38,42.45a4,4,0,0,1-2.67,1,4,4,0,0,1-2.67-7A136.71,136.71,0,0,0,235.56,128,136.07,136.07,0,0,0,211,94.62C187.89,71.65,160,60,128,60a122,122,0,0,0-20,1.63,4,4,0,0,1-1.32-7.89A129.3,129.3,0,0,1,128,52c42.7,0,71.87,20.22,88.83,37.18,18.31,18.31,26.49,36.44,26.83,37.2A4.08,4.08,0,0,1,243.66,129.63Z" }))
  ]
]);
const t$o = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]);
const t$n = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]);
const l$e = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.48,136.49l-82.06,82a60,60,0,0,1-84.85-84.88l98.16-97.89a40,40,0,0,1,56.56,56.59l-.17.16-95.8,92.22a12,12,0,1,1-16.64-17.3l95.71-92.12a16,16,0,0,0-22.7-22.56L62.53,150.57a36,36,0,0,0,50.93,50.91l82.06-82a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M180.75,104.75,204,128l-82.06,81.94a48,48,0,0,1-67.88-67.88L153.37,41.37a32,32,0,0,1,45.26,45.26Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,50.34a8,8,0,0,0-11.32,0L87.09,143A24,24,0,1,0,121,177l49.32-50.32a8,8,0,1,1,11.42,11.2l-49.37,50.38a40,40,0,1,1-56.62-56.51L143,63.09A24,24,0,1,1,177,97L109.71,165.6a8,8,0,1,1-11.42-11.2L165.6,85.71a8,8,0,0,0,.06-11.37Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.25,123.76a6,6,0,0,1,0,8.49l-82.06,82a54,54,0,0,1-76.36-76.39L149.1,37.14a38,38,0,1,1,53.77,53.72L103.59,191.54a22,22,0,1,1-31.15-31.09l83.28-84.67a6,6,0,0,1,8.56,8.42L81,168.91a10,10,0,1,0,14.11,14.18L194.35,82.4a26,26,0,1,0-36.74-36.8L58.33,146.28a42,42,0,1,0,59.37,59.44l82.06-82A6,6,0,0,1,208.25,123.76Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M206.83,125.17a4,4,0,0,1,0,5.66l-82.06,82a52,52,0,0,1-73.54-73.55L150.52,38.55a36,36,0,1,1,50.94,50.9l-99.3,100.69a20,20,0,1,1-28.3-28.27l83.29-84.68a4,4,0,1,1,5.7,5.61L79.54,167.5a12,12,0,1,0,16.95,17L195.78,83.81A28,28,0,1,0,156.2,44.18L56.91,144.87a44,44,0,1,0,62.21,62.26l82-82A4,4,0,0,1,206.83,125.17Z" }))
  ]
]);
const t$m = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M230.14,70.54,185.46,25.85a20,20,0,0,0-28.29,0L33.86,149.17A19.85,19.85,0,0,0,28,163.31V208a20,20,0,0,0,20,20H92.69a19.86,19.86,0,0,0,14.14-5.86L230.14,98.82a20,20,0,0,0,0-28.28ZM91,204H52V165l84-84,39,39ZM192,103,153,64l18.34-18.34,39,39Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M221.66,90.34,192,120,136,64l29.66-29.66a8,8,0,0,1,11.31,0L221.66,79A8,8,0,0,1,221.66,90.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM192,108.68,147.31,64l24-24L216,84.68Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M225.9,74.78,181.21,30.09a14,14,0,0,0-19.8,0L38.1,153.41a13.94,13.94,0,0,0-4.1,9.9V208a14,14,0,0,0,14,14H92.69a13.94,13.94,0,0,0,9.9-4.1L225.9,94.58a14,14,0,0,0,0-19.8ZM94.1,209.41a2,2,0,0,1-1.41.59H48a2,2,0,0,1-2-2V163.31a2,2,0,0,1,.59-1.41L136,72.48,183.51,120ZM217.41,86.1,192,111.51,144.49,64,169.9,38.58a2,2,0,0,1,2.83,0l44.68,44.69a2,2,0,0,1,0,2.83Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224.49,76.2,179.8,31.51a12,12,0,0,0-17,0L133.17,61.17h0L39.52,154.83A11.9,11.9,0,0,0,36,163.31V208a12,12,0,0,0,12,12H92.69a12,12,0,0,0,8.48-3.51L224.48,93.17a12,12,0,0,0,0-17Zm-129,134.63A4,4,0,0,1,92.69,212H48a4,4,0,0,1-4-4V163.31a4,4,0,0,1,1.17-2.83L136,69.65,186.34,120ZM218.83,87.51,192,114.34,141.66,64l26.82-26.83a4,4,0,0,1,5.66,0l44.69,44.68a4,4,0,0,1,0,5.66Z" }))
  ]
]);
const t$l = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,136H136v48a8,8,0,0,1-16,0V136H72a8,8,0,0,1,0-16h48V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H134v82a6,6,0,0,1-12,0V134H40a6,6,0,0,1,0-12h82V40a6,6,0,0,1,12,0v82h82A6,6,0,0,1,222,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H132v84a4,4,0,0,1-8,0V132H40a4,4,0,0,1,0-8h84V40a4,4,0,0,1,8,0v84h84A4,4,0,0,1,220,128Z" }))
  ]
]);
const t$k = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,32V64a12,12,0,0,1-24,0V32a12,12,0,0,1,24,0Zm84,84H192a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24Zm-42.26,48.77a12,12,0,1,0-17,17l22.63,22.63a12,12,0,0,0,17-17ZM128,180a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V192A12,12,0,0,0,128,180ZM74.26,164.77,51.63,187.4a12,12,0,0,0,17,17l22.63-22.63a12,12,0,1,0-17-17ZM76,128a12,12,0,0,0-12-12H32a12,12,0,0,0,0,24H64A12,12,0,0,0,76,128ZM68.6,51.63a12,12,0,1,0-17,17L74.26,91.23a12,12,0,0,0,17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM48,136a8,8,0,0,1,0-16H72a8,8,0,0,1,0,16Zm46.06,37.25-17,17a8,8,0,0,1-11.32-11.32l17-17a8,8,0,0,1,11.31,11.31Zm0-79.19a8,8,0,0,1-11.31,0l-17-17A8,8,0,0,1,77.09,65.77l17,17A8,8,0,0,1,94.06,94.06ZM136,208a8,8,0,0,1-16,0V184a8,8,0,0,1,16,0Zm0-136a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Zm54.23,118.23a8,8,0,0,1-11.32,0l-17-17a8,8,0,0,1,11.31-11.31l17,17A8,8,0,0,1,190.23,190.23ZM208,136H184a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M134,32V64a6,6,0,0,1-12,0V32a6,6,0,0,1,12,0Zm90,90H192a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12Zm-46.5,47A6,6,0,0,0,169,177.5l22.63,22.62a6,6,0,0,0,8.48-8.48ZM128,186a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V192A6,6,0,0,0,128,186ZM78.5,169,55.88,191.64a6,6,0,1,0,8.48,8.48L87,177.5A6,6,0,1,0,78.5,169ZM70,128a6,6,0,0,0-6-6H32a6,6,0,0,0,0,12H64A6,6,0,0,0,70,128ZM64.36,55.88a6,6,0,0,0-8.48,8.48L78.5,87A6,6,0,1,0,87,78.5Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm92,92H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z" }))
  ]
]);
const t$j = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]);
const t$i = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]);
const o$6 = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: false
});
var y$3 = Object.defineProperty;
var c$m = Object.getOwnPropertySymbols;
var f$n = Object.prototype.hasOwnProperty, g$2 = Object.prototype.propertyIsEnumerable;
var d$3 = (t2, o3, e3) => o3 in t2 ? y$3(t2, o3, { enumerable: true, configurable: true, writable: true, value: e3 }) : t2[o3] = e3, l$d = (t2, o3) => {
  for (var e3 in o3 || (o3 = {}))
    f$n.call(o3, e3) && d$3(t2, e3, o3[e3]);
  if (c$m)
    for (var e3 of c$m(o3))
      g$2.call(o3, e3) && d$3(t2, e3, o3[e3]);
  return t2;
};
var a$n = (t2, o3) => {
  var e3 = {};
  for (var r2 in t2)
    f$n.call(t2, r2) && o3.indexOf(r2) < 0 && (e3[r2] = t2[r2]);
  if (t2 != null && c$m)
    for (var r2 of c$m(t2))
      o3.indexOf(r2) < 0 && g$2.call(t2, r2) && (e3[r2] = t2[r2]);
  return e3;
};
const h$2 = forwardRef((t2, o3) => {
  const m2 = t2, {
    alt: e3,
    color: r2,
    size: n2,
    weight: s2,
    mirrored: p2,
    children: u2,
    weights: C2
  } = m2, v2 = a$n(m2, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), x2 = useContext(o$6), {
    color: B2 = "currentColor",
    size: i2,
    weight: I2 = "regular",
    mirrored: E2 = false
  } = x2, R2 = a$n(x2, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    l$d(l$d({
      ref: o3,
      xmlns: "http://www.w3.org/2000/svg",
      width: n2 != null ? n2 : i2,
      height: n2 != null ? n2 : i2,
      fill: r2 != null ? r2 : B2,
      viewBox: "0 0 256 256",
      transform: p2 || E2 ? "scale(-1, 1)" : void 0
    }, R2), v2),
    !!e3 && /* @__PURE__ */ a__default.createElement("title", null, e3),
    u2,
    C2.get(s2 != null ? s2 : I2)
  );
});
h$2.displayName = "IconBase";
const b$2 = h$2;
var f$m = Object.defineProperty, i$n = Object.defineProperties;
var n$g = Object.getOwnPropertyDescriptors;
var t$h = Object.getOwnPropertySymbols;
var p$o = Object.prototype.hasOwnProperty, s$m = Object.prototype.propertyIsEnumerable;
var m$j = (r2, o3, e3) => o3 in r2 ? f$m(r2, o3, { enumerable: true, configurable: true, writable: true, value: e3 }) : r2[o3] = e3, a$m = (r2, o3) => {
  for (var e3 in o3 || (o3 = {}))
    p$o.call(o3, e3) && m$j(r2, e3, o3[e3]);
  if (t$h)
    for (var e3 of t$h(o3))
      s$m.call(o3, e3) && m$j(r2, e3, o3[e3]);
  return r2;
}, w$7 = (r2, o3) => i$n(r2, n$g(o3));
const D$1 = forwardRef((r2, o3) => /* @__PURE__ */ a__default.createElement(b$2, w$7(a$m({ ref: o3 }, r2), { weights: t$w })));
D$1.displayName = "ArrowDown";
var f$l = Object.defineProperty, p$n = Object.defineProperties;
var s$l = Object.getOwnPropertyDescriptors;
var e$3 = Object.getOwnPropertySymbols;
var c$l = Object.prototype.hasOwnProperty, w$6 = Object.prototype.propertyIsEnumerable;
var m$i = (o3, r2, t2) => r2 in o3 ? f$l(o3, r2, { enumerable: true, configurable: true, writable: true, value: t2 }) : o3[r2] = t2, a$l = (o3, r2) => {
  for (var t2 in r2 || (r2 = {}))
    c$l.call(r2, t2) && m$i(o3, t2, r2[t2]);
  if (e$3)
    for (var t2 of e$3(r2))
      w$6.call(r2, t2) && m$i(o3, t2, r2[t2]);
  return o3;
}, i$m = (o3, r2) => p$n(o3, s$l(r2));
const d$2 = forwardRef((o3, r2) => /* @__PURE__ */ a__default.createElement(b$2, i$m(a$l({ ref: r2 }, o3), { weights: a$p })));
d$2.displayName = "ArrowRight";
var l$c = Object.defineProperty, f$k = Object.defineProperties;
var i$l = Object.getOwnPropertyDescriptors;
var o$5 = Object.getOwnPropertySymbols;
var p$m = Object.prototype.hasOwnProperty, s$k = Object.prototype.propertyIsEnumerable;
var t$g = (e3, a2, r2) => a2 in e3 ? l$c(e3, a2, { enumerable: true, configurable: true, writable: true, value: r2 }) : e3[a2] = r2, m$h = (e3, a2) => {
  for (var r2 in a2 || (a2 = {}))
    p$m.call(a2, r2) && t$g(e3, r2, a2[r2]);
  if (o$5)
    for (var r2 of o$5(a2))
      s$k.call(a2, r2) && t$g(e3, r2, a2[r2]);
  return e3;
}, n$f = (e3, a2) => f$k(e3, i$l(a2));
const w$5 = forwardRef((e3, a2) => /* @__PURE__ */ a__default.createElement(b$2, n$f(m$h({ ref: a2 }, e3), { weights: V })));
w$5.displayName = "CalendarBlank";
var i$k = Object.defineProperty, n$e = Object.defineProperties;
var p$l = Object.getOwnPropertyDescriptors;
var t$f = Object.getOwnPropertySymbols;
var s$j = Object.prototype.hasOwnProperty, c$k = Object.prototype.propertyIsEnumerable;
var a$k = (o3, e3, r2) => e3 in o3 ? i$k(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, m$g = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    s$j.call(e3, r2) && a$k(o3, r2, e3[r2]);
  if (t$f)
    for (var r2 of t$f(e3))
      c$k.call(e3, r2) && a$k(o3, r2, e3[r2]);
  return o3;
}, f$j = (o3, e3) => n$e(o3, p$l(e3));
const D = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, f$j(m$g({ ref: e3 }, o3), { weights: l$g })));
D.displayName = "CaretDown";
var i$j = Object.defineProperty, p$k = Object.defineProperties;
var s$i = Object.getOwnPropertyDescriptors;
var o$4 = Object.getOwnPropertySymbols;
var c$j = Object.prototype.hasOwnProperty, n$d = Object.prototype.propertyIsEnumerable;
var a$j = (t2, e3, r2) => e3 in t2 ? i$j(t2, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : t2[e3] = r2, m$f = (t2, e3) => {
  for (var r2 in e3 || (e3 = {}))
    c$j.call(e3, r2) && a$j(t2, r2, e3[r2]);
  if (o$4)
    for (var r2 of o$4(e3))
      n$d.call(e3, r2) && a$j(t2, r2, e3[r2]);
  return t2;
}, f$i = (t2, e3) => p$k(t2, s$i(e3));
const I$4 = forwardRef((t2, e3) => /* @__PURE__ */ a__default.createElement(b$2, f$i(m$f({ ref: e3 }, t2), { weights: a$o })));
I$4.displayName = "CaretLeft";
var f$h = Object.defineProperty, p$j = Object.defineProperties;
var s$h = Object.getOwnPropertyDescriptors;
var o$3 = Object.getOwnPropertySymbols;
var c$i = Object.prototype.hasOwnProperty, R$3 = Object.prototype.propertyIsEnumerable;
var a$i = (e3, t2, r2) => t2 in e3 ? f$h(e3, t2, { enumerable: true, configurable: true, writable: true, value: r2 }) : e3[t2] = r2, m$e = (e3, t2) => {
  for (var r2 in t2 || (t2 = {}))
    c$i.call(t2, r2) && a$i(e3, r2, t2[r2]);
  if (o$3)
    for (var r2 of o$3(t2))
      R$3.call(t2, r2) && a$i(e3, r2, t2[r2]);
  return e3;
}, i$i = (e3, t2) => p$j(e3, s$h(t2));
const l$b = forwardRef((e3, t2) => /* @__PURE__ */ a__default.createElement(b$2, i$i(m$e({ ref: t2 }, e3), { weights: l$f })));
l$b.displayName = "CaretRight";
var f$g = Object.defineProperty, i$h = Object.defineProperties;
var p$i = Object.getOwnPropertyDescriptors;
var t$e = Object.getOwnPropertySymbols;
var s$g = Object.prototype.hasOwnProperty, h$1 = Object.prototype.propertyIsEnumerable;
var m$d = (o3, e3, r2) => e3 in o3 ? f$g(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, a$h = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    s$g.call(e3, r2) && m$d(o3, r2, e3[r2]);
  if (t$e)
    for (var r2 of t$e(e3))
      h$1.call(e3, r2) && m$d(o3, r2, e3[r2]);
  return o3;
}, c$h = (o3, e3) => i$h(o3, p$i(e3));
const w$4 = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, c$h(a$h({ ref: e3 }, o3), { weights: t$v })));
w$4.displayName = "Check";
var i$g = Object.defineProperty, f$f = Object.defineProperties;
var p$h = Object.getOwnPropertyDescriptors;
var t$d = Object.getOwnPropertySymbols;
var s$f = Object.prototype.hasOwnProperty, l$a = Object.prototype.propertyIsEnumerable;
var c$g = (r2, e3, o3) => e3 in r2 ? i$g(r2, e3, { enumerable: true, configurable: true, writable: true, value: o3 }) : r2[e3] = o3, m$c = (r2, e3) => {
  for (var o3 in e3 || (e3 = {}))
    s$f.call(e3, o3) && c$g(r2, o3, e3[o3]);
  if (t$d)
    for (var o3 of t$d(e3))
      l$a.call(e3, o3) && c$g(r2, o3, e3[o3]);
  return r2;
}, a$g = (r2, e3) => f$f(r2, p$h(e3));
const k$2 = forwardRef((r2, e3) => /* @__PURE__ */ a__default.createElement(b$2, a$g(m$c({ ref: e3 }, r2), { weights: t$u })));
k$2.displayName = "CheckCircle";
var f$e = Object.defineProperty, i$f = Object.defineProperties;
var p$g = Object.getOwnPropertyDescriptors;
var t$c = Object.getOwnPropertySymbols;
var s$e = Object.prototype.hasOwnProperty, l$9 = Object.prototype.propertyIsEnumerable;
var m$b = (e3, o3, r2) => o3 in e3 ? f$e(e3, o3, { enumerable: true, configurable: true, writable: true, value: r2 }) : e3[o3] = r2, a$f = (e3, o3) => {
  for (var r2 in o3 || (o3 = {}))
    s$e.call(o3, r2) && m$b(e3, r2, o3[r2]);
  if (t$c)
    for (var r2 of t$c(o3))
      l$9.call(o3, r2) && m$b(e3, r2, o3[r2]);
  return e3;
}, c$f = (e3, o3) => i$f(e3, p$g(o3));
const C$1 = forwardRef((e3, o3) => /* @__PURE__ */ a__default.createElement(b$2, c$f(a$f({ ref: o3 }, e3), { weights: t$t })));
C$1.displayName = "Clock";
var s$d = Object.defineProperty, f$d = Object.defineProperties;
var n$c = Object.getOwnPropertyDescriptors;
var r$8 = Object.getOwnPropertySymbols;
var p$f = Object.prototype.hasOwnProperty, c$e = Object.prototype.propertyIsEnumerable;
var m$a = (t2, e3, o3) => e3 in t2 ? s$d(t2, e3, { enumerable: true, configurable: true, writable: true, value: o3 }) : t2[e3] = o3, a$e = (t2, e3) => {
  for (var o3 in e3 || (e3 = {}))
    p$f.call(e3, o3) && m$a(t2, o3, e3[o3]);
  if (r$8)
    for (var o3 of r$8(e3))
      c$e.call(e3, o3) && m$a(t2, o3, e3[o3]);
  return t2;
}, i$e = (t2, e3) => f$d(t2, n$c(e3));
const w$3 = forwardRef((t2, e3) => /* @__PURE__ */ a__default.createElement(b$2, i$e(a$e({ ref: e3 }, t2), { weights: t$s })));
w$3.displayName = "DotsThreeOutline";
var p$e = Object.defineProperty, l$8 = Object.defineProperties;
var f$c = Object.getOwnPropertyDescriptors;
var r$7 = Object.getOwnPropertySymbols;
var n$b = Object.prototype.hasOwnProperty, s$c = Object.prototype.propertyIsEnumerable;
var a$d = (e3, o3, m2) => o3 in e3 ? p$e(e3, o3, { enumerable: true, configurable: true, writable: true, value: m2 }) : e3[o3] = m2, t$b = (e3, o3) => {
  for (var m2 in o3 || (o3 = {}))
    n$b.call(o3, m2) && a$d(e3, m2, o3[m2]);
  if (r$7)
    for (var m2 of r$7(o3))
      s$c.call(o3, m2) && a$d(e3, m2, o3[m2]);
  return e3;
}, i$d = (e3, o3) => l$8(e3, f$c(o3));
const I$3 = forwardRef((e3, o3) => /* @__PURE__ */ a__default.createElement(b$2, i$d(t$b({ ref: o3 }, e3), { weights: t$r })));
I$3.displayName = "DownloadSimple";
var i$c = Object.defineProperty, p$d = Object.defineProperties;
var s$b = Object.getOwnPropertyDescriptors;
var t$a = Object.getOwnPropertySymbols;
var c$d = Object.prototype.hasOwnProperty, n$a = Object.prototype.propertyIsEnumerable;
var m$9 = (o3, e3, r2) => e3 in o3 ? i$c(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, a$c = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    c$d.call(e3, r2) && m$9(o3, r2, e3[r2]);
  if (t$a)
    for (var r2 of t$a(e3))
      n$a.call(e3, r2) && m$9(o3, r2, e3[r2]);
  return o3;
}, f$b = (o3, e3) => p$d(o3, s$b(e3));
const w$2 = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, f$b(a$c({ ref: e3 }, o3), { weights: t$q })));
w$2.displayName = "Eye";
var f$a = Object.defineProperty, i$b = Object.defineProperties;
var p$c = Object.getOwnPropertyDescriptors;
var a$b = Object.getOwnPropertySymbols;
var c$c = Object.prototype.hasOwnProperty, l$7 = Object.prototype.propertyIsEnumerable;
var t$9 = (o3, e3, r2) => e3 in o3 ? f$a(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, m$8 = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    c$c.call(e3, r2) && t$9(o3, r2, e3[r2]);
  if (a$b)
    for (var r2 of a$b(e3))
      l$7.call(e3, r2) && t$9(o3, r2, e3[r2]);
  return o3;
}, s$a = (o3, e3) => i$b(o3, p$c(e3));
const d$1 = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, s$a(m$8({ ref: e3 }, o3), { weights: t$p })));
d$1.displayName = "EyeSlash";
var i$a = Object.defineProperty, n$9 = Object.defineProperties;
var p$b = Object.getOwnPropertyDescriptors;
var t$8 = Object.getOwnPropertySymbols;
var s$9 = Object.prototype.hasOwnProperty, c$b = Object.prototype.propertyIsEnumerable;
var m$7 = (e3, o3, r2) => o3 in e3 ? i$a(e3, o3, { enumerable: true, configurable: true, writable: true, value: r2 }) : e3[o3] = r2, a$a = (e3, o3) => {
  for (var r2 in o3 || (o3 = {}))
    s$9.call(o3, r2) && m$7(e3, r2, o3[r2]);
  if (t$8)
    for (var r2 of t$8(o3))
      c$b.call(o3, r2) && m$7(e3, r2, o3[r2]);
  return e3;
}, f$9 = (e3, o3) => n$9(e3, p$b(o3));
const R$2 = forwardRef((e3, o3) => /* @__PURE__ */ a__default.createElement(b$2, f$9(a$a({ ref: o3 }, e3), { weights: t$o })));
R$2.displayName = "Info";
var s$8 = Object.defineProperty, f$8 = Object.defineProperties;
var p$a = Object.getOwnPropertyDescriptors;
var r$6 = Object.getOwnPropertySymbols;
var c$a = Object.prototype.hasOwnProperty, n$8 = Object.prototype.propertyIsEnumerable;
var m$6 = (e3, t2, o3) => t2 in e3 ? s$8(e3, t2, { enumerable: true, configurable: true, writable: true, value: o3 }) : e3[t2] = o3, a$9 = (e3, t2) => {
  for (var o3 in t2 || (t2 = {}))
    c$a.call(t2, o3) && m$6(e3, o3, t2[o3]);
  if (r$6)
    for (var o3 of r$6(t2))
      n$8.call(t2, o3) && m$6(e3, o3, t2[o3]);
  return e3;
}, i$9 = (e3, t2) => f$8(e3, p$a(t2));
const L$1 = forwardRef((e3, t2) => /* @__PURE__ */ a__default.createElement(b$2, i$9(a$9({ ref: t2 }, e3), { weights: t$n })));
L$1.displayName = "List";
var i$8 = Object.defineProperty, c$9 = Object.defineProperties;
var f$7 = Object.getOwnPropertyDescriptors;
var a$8 = Object.getOwnPropertySymbols;
var s$7 = Object.prototype.hasOwnProperty, l$6 = Object.prototype.propertyIsEnumerable;
var p$9 = (r2, e3, o3) => e3 in r2 ? i$8(r2, e3, { enumerable: true, configurable: true, writable: true, value: o3 }) : r2[e3] = o3, t$7 = (r2, e3) => {
  for (var o3 in e3 || (e3 = {}))
    s$7.call(e3, o3) && p$9(r2, o3, e3[o3]);
  if (a$8)
    for (var o3 of a$8(e3))
      l$6.call(e3, o3) && p$9(r2, o3, e3[o3]);
  return r2;
}, m$5 = (r2, e3) => c$9(r2, f$7(e3));
const P$2 = forwardRef((r2, e3) => /* @__PURE__ */ a__default.createElement(b$2, m$5(t$7({ ref: e3 }, r2), { weights: l$e })));
P$2.displayName = "Paperclip";
var p$8 = Object.defineProperty, c$8 = Object.defineProperties;
var l$5 = Object.getOwnPropertyDescriptors;
var r$5 = Object.getOwnPropertySymbols;
var f$6 = Object.prototype.hasOwnProperty, n$7 = Object.prototype.propertyIsEnumerable;
var i$7 = (m2, e3, o3) => e3 in m2 ? p$8(m2, e3, { enumerable: true, configurable: true, writable: true, value: o3 }) : m2[e3] = o3, t$6 = (m2, e3) => {
  for (var o3 in e3 || (e3 = {}))
    f$6.call(e3, o3) && i$7(m2, o3, e3[o3]);
  if (r$5)
    for (var o3 of r$5(e3))
      n$7.call(e3, o3) && i$7(m2, o3, e3[o3]);
  return m2;
}, a$7 = (m2, e3) => c$8(m2, l$5(e3));
const P$1 = forwardRef((m2, e3) => /* @__PURE__ */ a__default.createElement(b$2, a$7(t$6({ ref: e3 }, m2), { weights: t$m })));
P$1.displayName = "PencilSimple";
var f$5 = Object.defineProperty, i$6 = Object.defineProperties;
var p$7 = Object.getOwnPropertyDescriptors;
var t$5 = Object.getOwnPropertySymbols;
var c$7 = Object.prototype.hasOwnProperty, l$4 = Object.prototype.propertyIsEnumerable;
var m$4 = (o3, e3, r2) => e3 in o3 ? f$5(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, a$6 = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    c$7.call(e3, r2) && m$4(o3, r2, e3[r2]);
  if (t$5)
    for (var r2 of t$5(e3))
      l$4.call(e3, r2) && m$4(o3, r2, e3[r2]);
  return o3;
}, s$6 = (o3, e3) => i$6(o3, p$7(e3));
const I$2 = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, s$6(a$6({ ref: e3 }, o3), { weights: t$l })));
I$2.displayName = "Plus";
var i$5 = Object.defineProperty, n$6 = Object.defineProperties;
var f$4 = Object.getOwnPropertyDescriptors;
var a$5 = Object.getOwnPropertySymbols;
var s$5 = Object.prototype.hasOwnProperty, c$6 = Object.prototype.propertyIsEnumerable;
var p$6 = (r2, e3, o3) => e3 in r2 ? i$5(r2, e3, { enumerable: true, configurable: true, writable: true, value: o3 }) : r2[e3] = o3, t$4 = (r2, e3) => {
  for (var o3 in e3 || (e3 = {}))
    s$5.call(e3, o3) && p$6(r2, o3, e3[o3]);
  if (a$5)
    for (var o3 of a$5(e3))
      c$6.call(e3, o3) && p$6(r2, o3, e3[o3]);
  return r2;
}, m$3 = (r2, e3) => n$6(r2, f$4(e3));
const I$1 = forwardRef((r2, e3) => /* @__PURE__ */ a__default.createElement(b$2, m$3(t$4({ ref: e3 }, r2), { weights: t$k })));
I$1.displayName = "SpinnerGap";
var n$5 = Object.defineProperty, f$3 = Object.defineProperties;
var p$5 = Object.getOwnPropertyDescriptors;
var a$4 = Object.getOwnPropertySymbols;
var s$4 = Object.prototype.hasOwnProperty, c$5 = Object.prototype.propertyIsEnumerable;
var t$3 = (e3, r2, o3) => r2 in e3 ? n$5(e3, r2, { enumerable: true, configurable: true, writable: true, value: o3 }) : e3[r2] = o3, m$2 = (e3, r2) => {
  for (var o3 in r2 || (r2 = {}))
    s$4.call(r2, o3) && t$3(e3, o3, r2[o3]);
  if (a$4)
    for (var o3 of a$4(r2))
      c$5.call(r2, o3) && t$3(e3, o3, r2[o3]);
  return e3;
}, i$4 = (e3, r2) => f$3(e3, p$5(r2));
const I = forwardRef((e3, r2) => /* @__PURE__ */ a__default.createElement(b$2, i$4(m$2({ ref: r2 }, e3), { weights: t$j })));
I.displayName = "Warning";
var i$3 = Object.defineProperty, p$4 = Object.defineProperties;
var s$3 = Object.getOwnPropertyDescriptors;
var t$2 = Object.getOwnPropertySymbols;
var c$4 = Object.prototype.hasOwnProperty, n$4 = Object.prototype.propertyIsEnumerable;
var m$1 = (o3, e3, r2) => e3 in o3 ? i$3(o3, e3, { enumerable: true, configurable: true, writable: true, value: r2 }) : o3[e3] = r2, a$3 = (o3, e3) => {
  for (var r2 in e3 || (e3 = {}))
    c$4.call(e3, r2) && m$1(o3, r2, e3[r2]);
  if (t$2)
    for (var r2 of t$2(e3))
      n$4.call(e3, r2) && m$1(o3, r2, e3[r2]);
  return o3;
}, f$2 = (o3, e3) => p$4(o3, s$3(e3));
const R$1 = forwardRef((o3, e3) => /* @__PURE__ */ a__default.createElement(b$2, f$2(a$3({ ref: e3 }, o3), { weights: t$i })));
R$1.displayName = "X";
const TEST_IDS_CONFIG$l = {
  BASE: "",
  TITLE: "title",
  BUTTON: "toggle-expand-button"
};
const _InternalAccordionItemHeader = ({
  title,
  disabled,
  open,
  onToggleExpand,
  ...props
}) => {
  const rootClasses2 = getRootClasses(disabled);
  const buttonClasses2 = getButtonClasses(open);
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$l,
    ids: props
  });
  const handleOnClick = () => {
    if (!disabled) {
      onToggleExpand?.(open);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Ae$2.Button,
    {
      as: "div",
      className: rootClasses2,
      onClick: handleOnClick,
      disabled,
      ...testIds.BASE,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Heading,
          {
            level: "h5",
            noDefaultMargins: true,
            breakWords: true,
            ...testIds.TITLE,
            children: title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            size: "md",
            iconOnly: true,
            disabled,
            className: buttonClasses2,
            variant: "ghost",
            ...testIds.BUTTON,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: D })
          }
        )
      ]
    }
  );
};
const panelClasses = clsx(
  "pb-e32 pl-e32 pr-e96",
  "text-body-lg text-warm-gray-800",
  "mobile-d:pr-e32"
);
const _InternalAccordionItemContent = ({
  disabled,
  children,
  close,
  ...props
}) => {
  useEffect(() => {
    if (disabled) {
      close();
    }
  }, [disabled, close]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Ae$2.Panel,
    {
      className: panelClasses,
      static: true,
      ...props,
      children
    }
  );
};
const transitionClasses = {
  enter: "transition-all duration-300 ease-out",
  enterFrom: "opacity-0",
  enterTo: "opacity-100",
  leave: "transition-all duration-300 ease-out",
  leaveFrom: "opacity-100",
  leaveTo: "opacity-0"
};
const rootClasses = "transition-all duration-300 ease-out";
const TEST_IDS_CONFIG$k = {
  BASE: "",
  HEADER: "header",
  CONTENT: "content"
};
const AccordionItem = ({ ...rest }) => {
  const { disabled, defaultOpen, className, children, ...props } = rest;
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$k,
    ids: props
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Ae$2, { defaultOpen, children: ({ open, close }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${rootClasses} ${className ?? ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      _InternalAccordionItemHeader,
      {
        disabled,
        open,
        ...props,
        ...testIds.HEADER
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(qe, { ...transitionClasses, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      _InternalAccordionItemContent,
      {
        disabled,
        close,
        ...testIds.CONTENT,
        children
      }
    ) })
  ] }) });
};
const CalloutIcon = {
  info: R$2,
  warning: I,
  success: k$2
};
const baseClassName = clsx(
  "flex items-start gap-e12 p-e16",
  "rounded-md border border-warm-gray-300",
  "text-h6 text-warm-gray-900"
);
const variantClassName = {
  default: "bg-warm-gray-100",
  info: "svg:text-purple-500 bg-orchid-50",
  warning: "svg:text-utility-error bg-orange-50",
  success: "svg:text-utility-success-dark bg-utility-success"
};
const TEST_IDS_CONFIG$j = {
  BASE: "",
  ICON: "icon",
  CONTENT: "content"
};
const Callout = ({
  type = "default",
  className,
  children,
  ...props
}) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$j,
    ids: props
  });
  const classNameMerged = twMerge(baseClassName, variantClassName[type], className);
  const iconName = CalloutIcon[type];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classNameMerged,
      ...props,
      ...testIds.BASE,
      children: [
        iconName && /* @__PURE__ */ jsxRuntimeExports.jsx(
          SyntaxIcon,
          {
            icon: iconName,
            weight: "fill",
            className: "size-e20 shrink-0",
            ...testIds.ICON
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...testIds.CONTENT, children })
      ]
    }
  );
};
const defaultPaddings = "p-e32 mobile-d:p-e24";
const variantClasses$3 = {
  base: "rounded-xxxl",
  default: "bg-white border border-warm-gray-200",
  primary: "bg-orchid-100"
};
const Card = ({
  variant = "default",
  as,
  className,
  children,
  noDefaultPaddings,
  cardRef,
  ...props
}) => {
  const asElement = as || "div";
  return createElement(
    asElement,
    {
      className: twMerge(
        clsx(
          { [defaultPaddings]: !noDefaultPaddings },
          variantClasses$3.base,
          variantClasses$3[variant],
          className
        )
      ),
      ref: cardRef,
      ...props
    },
    children
  );
};
const bgColorClassName = {
  primary: "bg-purple-50",
  secondary: "bg-warm-gray-200",
  warning: "bg-blue-50",
  "warning-2": "bg-marigold-200",
  "warning-3": "bg-orange-100",
  ready: "bg-green-200"
};
const getChipClassName$1 = ({
  size: size2,
  color: color2,
  hasDeleteButton,
  hasAdornment,
  className
}) => {
  const spacingClassName = {
    xs: clsx("py-e4 pl-e8 pr-e8", {
      "pl-e6": hasAdornment && !hasDeleteButton,
      "pl-e10": hasDeleteButton && !hasAdornment
    }),
    sm: clsx("pl-e12 pr-e12", {
      "pl-e8": hasAdornment
    }),
    md: clsx("pl-e12 pr-e12", {
      "pl-e10": hasAdornment
    }),
    lg: clsx("pl-e16 pr-e16", {
      "pl-e12": hasAdornment
    })
  };
  return twMerge(
    clsx(
      // Layout
      "inline-flex items-center gap-e8",
      // Padding
      "py-e10",
      spacingClassName[size2],
      {
        "py-e4 pr-e4": hasDeleteButton
      },
      // Max width
      "max-w-fit",
      // Truncate
      "overflow-hidden",
      // Border
      "rounded-100",
      // Cursor
      "cursor-default",
      // Select
      "select-none",
      // Variants
      bgColorClassName[color2],
      // Custom
      className
    )
  );
};
const chipContentClassName = clsx("flex items-center gap-e4");
const ChipContext = createContext(void 0);
const useChipContext = () => {
  const context = useContext(ChipContext);
  if (!context) {
    throw new Error("useChipContext must be used within a ChipProvider");
  }
  return context;
};
const ChipProvider = ({ children, size: size2, color: color2, testIds }) => {
  const contextValue = useMemo(() => ({ size: size2, color: color2, testIds }), [size2, color2, testIds]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChipContext.Provider, { value: contextValue, children });
};
const buttonSizeMap = {
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "md"
};
const TEST_IDS_CONFIG$i = {
  REMOVE_BUTTON: "remove-button",
  LABEL: "label"
};
const Chip$1 = forwardRef(
  ({ className, value, size: size2 = "md", color: color2 = "primary", icon, children, onRemove, ...rest }, ref) => {
    const testIds = useDataTestIds({
      componentConfig: TEST_IDS_CONFIG$i,
      ids: rest
    });
    const chipClassName2 = getChipClassName$1({
      size: size2,
      color: color2,
      hasDeleteButton: !!onRemove,
      hasAdornment: !!icon,
      className
    });
    const handleDeleteButtonClick = (e3) => {
      e3.stopPropagation();
      onRemove?.(value || "");
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChipProvider,
      {
        size: size2,
        color: color2,
        testIds,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ref,
            className: chipClassName2,
            ...rest,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: chipContentClassName, children: [
                icon,
                children
              ] }),
              onRemove && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  iconOnly: true,
                  variant: "ghost",
                  size: buttonSizeMap[size2],
                  onClick: handleDeleteButtonClick,
                  ...testIds.REMOVE_BUTTON,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: R$1 })
                }
              )
            ]
          }
        )
      }
    );
  }
);
const iconColorMap = {
  primary: "text-purple-500",
  secondary: "text-warm-gray-600",
  warning: "text-blue-500",
  "warning-2": "text-marigold-900",
  "warning-3": "text-orange-900",
  ready: "text-green-800"
};
const getIconClassName = ({ color: color2, className }) => {
  return twMerge(iconColorMap[color2], className);
};
const iconSizeMap$1 = {
  xs: "sm",
  sm: "sm",
  md: "md",
  lg: "lg"
};
const ChipIcon = ({ className, weight = "fill", ...props }) => {
  const { size: size2, color: color2 } = useChipContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SyntaxIcon,
    {
      ...props,
      weight,
      size: iconSizeMap$1[size2],
      className: getIconClassName({ color: color2, className })
    }
  );
};
const AsElement = ({ as, ...props }) => {
  return createElement(as, {
    ...props
  });
};
const variantClasses$2 = {
  h1: "text-h1 mobile-d:text-h1-sm font-dazzed font-bold",
  h2: "text-h2 mobile-d:text-h2-sm font-dazzed font-bold",
  h3: "text-h3 mobile-d:text-h3-sm font-dazzed font-bold",
  h4: "text-h4 mobile-d:text-h4-sm font-dazzed font-semibold",
  h5: "text-h5 mobile-d:text-h5-sm font-medium",
  h6: "text-h6 mobile-d:text-h6-sm font-medium",
  "body-lg": "text-body-lg",
  "body-md": "text-body-md",
  "body-sm": "text-body-sm",
  "body-xs": "text-body-xs",
  overline: "text-overline font-semibold uppercase",
  label: "text-label font-medium",
  error: "text-body-xs text-utility-error",
  hint: "text-body-xs text-warm-gray-600",
  display: "text-display mobile-d:text-display-sm font-medium"
};
const asElementByVariantMap = {
  overline: "span",
  label: "label"
};
const Text = ({ className, as = "p", variant = "body-lg", ...props }) => {
  const element = asElementByVariantMap[variant] || as;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AsElement,
    {
      as: element,
      className: twMerge(clsx(variantClasses$2[variant], className)),
      ...props
    }
  );
};
const baseClasses$1 = "whitespace-pre-line";
const defaultMarginClasses = "not-last:mb-e16";
const sizeTextVariants = {
  xs: "body-xs",
  sm: "body-sm",
  md: "body-md",
  lg: "body-lg"
};
const variantClasses$1 = {
  primary: "text-warm-gray-800",
  secondary: "text-warm-gray-600"
};
const Paragraph = ({
  as = "p",
  size: size2 = "lg",
  className,
  noDefaultMargins = false,
  children,
  variant = "primary",
  ...props
}) => {
  const classNames = twMerge(
    clsx(
      baseClasses$1,
      variantClasses$1[variant],
      { [defaultMarginClasses]: !noDefaultMargins },
      className
    )
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      ...props,
      as,
      variant: sizeTextVariants[size2],
      className: classNames,
      children
    }
  );
};
const StableSizeText = ({
  children,
  containerClassName: containerClassName2,
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: twMerge("relative block", containerClassName2), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text,
      {
        ...omit(props, ["id", "data-testid"]),
        className: twMerge(className, "font-extrabold opacity-0"),
        children
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text,
      {
        ...props,
        className: twMerge(
          "absolute left-1/2 top-0 w-full min-w-full -translate-x-1/2 transform",
          className
        ),
        children
      }
    )
  ] });
};
const labelVariantClassName = {
  default: {},
  bold: {
    xs: "font-semibold",
    sm: "font-semibold",
    md: "font-medium",
    lg: "font-medium"
  }
};
const getLabelClassName$1 = ({ size: size2, variant }) => {
  return twMerge("text-warm-gray-800", labelVariantClassName[variant][size2]);
};
const chipSizeTextVariantMap = {
  xs: "body-xs",
  sm: "body-sm",
  md: "body-md",
  lg: "body-lg"
};
const ChipLabel = ({ variant = "default", children, ...props }) => {
  const { size: size2, testIds } = useChipContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      variant: chipSizeTextVariantMap[size2],
      className: getLabelClassName$1({ size: size2, variant }),
      ...props,
      ...testIds.LABEL,
      children
    }
  );
};
const sizeClassName = {
  xl: "w-dialog-xl",
  lg: "w-dialog-lg",
  md: "w-dialog-md",
  sm: "w-dialog-sm",
  xs: "w-dialog-xs"
};
const overlayClassName$2 = clsx(
  // Positioning
  "fixed left-0 top-0 z-40",
  // Size
  "size-full",
  // Layout
  "flex items-center justify-center",
  // Spacing
  "px-e32 mobile-d:px-e24",
  // Background
  "bg-warm-gray bg-opacity-60"
);
const getDialogContainerClassName = ({
  isDismissible,
  variant,
  size: size2,
  scrollable,
  isMobile,
  className
}) => {
  const baseClassName2 = clsx(
    // Border
    "border border-warm-gray-200",
    // Border radius
    "rounded-xxxl",
    // Shadow
    "shadow-drop-1",
    // Layout
    "flex flex-col",
    // Padding
    "pb-e32",
    // Scrollable
    { "min-h-es360 pb-e24": scrollable && !isMobile },
    // Dismissible
    { "pt-e32": !isDismissible }
  );
  const variantClassName2 = {
    default: clsx(
      // Background
      "bg-white",
      // Size
      "mobile-d:max-w-es344"
    ),
    modal: clsx(
      // Background
      "bg-warm-gray-50",
      // Padding
      "mobile-d:pb-e8",
      // Height
      "max-h-dialog mobile-d:max-h-dialog-sm"
    )
  };
  return twMerge(
    baseClassName2,
    sizeClassName[size2 || "md"],
    variantClassName2[variant || "default"],
    className
  );
};
const getChildrenContainerClassName = ({ variant, isMobile }) => {
  const baseClassName2 = clsx(
    // Layout
    "flex flex-col"
  );
  const variantClassName2 = {
    default: "",
    modal: clsx(
      // Overflow
      {
        "overflow-hidden": !isMobile,
        "overflow-y-auto": isMobile
      },
      // Padding
      "mobile-d:pb-e16",
      // Scrollbar
      "scroll-smooth scrollbar-thin"
    )
  };
  return twMerge(baseClassName2, variantClassName2[variant || "default"]);
};
const dismissBtnContainerClassName = clsx(
  // Layout
  "flex justify-end",
  // Spacing
  "p-e16 pb-0",
  // Z-index
  "z-20"
);
const dismissBtnClassName = clsx(
  // Accessibility
  "mobile-d:focus:outline-none mobile-d:focus:ring-0"
);
const defaultContext = {
  variant: "default",
  isScrollable: false,
  setIsScrollable: () => {
  },
  testIds: void 0
};
const DialogContext = createContext(defaultContext);
const useDialogContext = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useDialogContext must be used within a DialogContext.Provider");
  }
  return context;
};
const useIsScrollable = (ref) => {
  const [scrollInfo, setScrollInfo] = useState({
    isScrollableX: false,
    isScrollableY: false
  });
  const checkScrollable = useCallback(() => {
    if (!ref.current) return;
    const element = ref.current;
    const isScrollableX = element.scrollWidth > element.clientWidth;
    const isScrollableY = element.scrollHeight > element.clientHeight;
    setScrollInfo({
      isScrollableX,
      isScrollableY
    });
  }, [ref]);
  useEffect(() => {
    checkScrollable();
    const resizeObserver = new ResizeObserver(() => {
      checkScrollable();
    });
    const currentElement = ref.current;
    if (currentElement) {
      resizeObserver.observe(currentElement);
    }
    return () => {
      if (currentElement) {
        resizeObserver.unobserve(currentElement);
      }
      resizeObserver.disconnect();
    };
  }, [checkScrollable, ref]);
  return {
    isScrollable: scrollInfo.isScrollableX || scrollInfo.isScrollableY,
    scrollInfo
  };
};
var extendStatics = function(d2, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3) if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
  };
  return extendStatics(d2, b2);
};
function __extends(d2, b2) {
  if (typeof b2 !== "function" && b2 !== null)
    throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
function __values(o3) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o3[s2], i2 = 0;
  if (m2) return m2.call(o3);
  if (o3 && typeof o3.length === "number") return {
    next: function() {
      if (o3 && i2 >= o3.length) o3 = void 0;
      return { value: o3 && o3[i2++], done: !o3 };
    }
  };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o3, n2) {
  var m2 = typeof Symbol === "function" && o3[Symbol.iterator];
  if (!m2) return o3;
  var i2 = m2.call(o3), r2, ar = [], e3;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done) ar.push(r2.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"])) m2.call(i2);
    } finally {
      if (e3) throw e3.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
    if (ar || !(i2 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
      ar[i2] = from[i2];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
var isBrowser = typeof window !== "undefined";
var toggleReducer = function(state, nextValue) {
  return typeof nextValue === "boolean" ? nextValue : !state;
};
var useToggle = function(initialValue) {
  return useReducer(toggleReducer, initialValue);
};
function useTimeoutFn(fn, ms) {
  if (ms === void 0) {
    ms = 0;
  }
  var ready = useRef(false);
  var timeout = useRef();
  var callback = useRef(fn);
  var isReady = useCallback(function() {
    return ready.current;
  }, []);
  var set2 = useCallback(function() {
    ready.current = false;
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(function() {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);
  var clear = useCallback(function() {
    ready.current = null;
    timeout.current && clearTimeout(timeout.current);
  }, []);
  useEffect(function() {
    callback.current = fn;
  }, [fn]);
  useEffect(function() {
    set2();
    return clear;
  }, [ms]);
  return [isReady, clear, set2];
}
function useDebounce(fn, ms, deps) {
  if (ms === void 0) {
    ms = 0;
  }
  if (deps === void 0) {
    deps = [];
  }
  var _a2 = useTimeoutFn(fn, ms), isReady = _a2[0], cancel = _a2[1], reset = _a2[2];
  useEffect(reset, deps);
  return [isReady, cancel];
}
var useEffectOnce = function(effect) {
  useEffect(effect, []);
};
var getInitialState = function(query, defaultState) {
  if (isBrowser) {
    return window.matchMedia(query).matches;
  }
  if (process.env.NODE_ENV !== "production") {
    console.warn("`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches.");
  }
  return false;
};
var useMedia = function(query, defaultState) {
  var _a2 = useState(getInitialState(query)), state = _a2[0], setState = _a2[1];
  useEffect(function() {
    var mounted = true;
    var mql = window.matchMedia(query);
    var onChange = function() {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };
    mql.addEventListener("change", onChange);
    setState(mql.matches);
    return function() {
      mounted = false;
      mql.removeEventListener("change", onChange);
    };
  }, [query]);
  return state;
};
const useViewport = () => {
  const isDesktopLG = useMedia(`(min-width: ${BASE_VIEWPORTS_CONFIG["desktop-lg"]}px)`);
  const isDesktop = useMedia(`(min-width: ${BASE_VIEWPORTS_CONFIG.desktop}px)`);
  const isTablet = useMedia(`(min-width: ${BASE_VIEWPORTS_CONFIG.tablet}px)`);
  const isMobile = useMedia(`(min-width: ${BASE_VIEWPORTS_CONFIG.mobile}px)`);
  const isMobileSM = useMedia(`(min-width: ${BASE_VIEWPORTS_CONFIG["mobile-sm"]}px)`);
  const currentViewport = useMemo(() => {
    if (isDesktopLG) return "desktop-lg";
    if (isDesktop) return "desktop";
    if (isTablet) return "tablet";
    if (isMobile) return "mobile";
    if (isMobileSM) return "mobile-sm";
    return "mobile-xs";
  }, [isDesktopLG, isDesktop, isTablet, isMobile, isMobileSM]);
  const biggerOrEqual = (viewport) => {
    return BASE_VIEWPORTS_CONFIG[currentViewport] >= BASE_VIEWPORTS_CONFIG[viewport];
  };
  const smallerOrEqual = (viewport) => {
    return BASE_VIEWPORTS_CONFIG[currentViewport] <= BASE_VIEWPORTS_CONFIG[viewport];
  };
  return { currentViewport, biggerOrEqual, smallerOrEqual };
};
const getDialogBodyClassName = ({ variant, scrollable, isMobile }) => {
  const baseClassName2 = clsx(
    // Layout
    "flex flex-col",
    // Padding
    "px-e32"
  );
  const variantClassName2 = {
    default: clsx(
      // Padding
      "not-last:pb-e32"
    ),
    modal: clsx(
      // Padding
      "pb-e40 pt-e32",
      // Overflow
      { "overflow-y-auto": !isMobile },
      // Scrollable
      {
        // Border
        "border-y border-warm-gray-200": scrollable && !isMobile
      },
      // Scrollbar
      "scroll-smooth scrollbar-thin"
    )
  };
  return twMerge(baseClassName2, variantClassName2[variant ?? "default"]);
};
const _InternalDialogBody = ({
  children,
  ...props
}) => {
  const scrollableRef = useRef(null);
  const { isScrollable: elementIsScrollable } = useIsScrollable(scrollableRef);
  const { variant, isScrollable, setIsScrollable } = useDialogContext();
  const { smallerOrEqual } = useViewport();
  const { testIds } = useDialogContext();
  useEffect(() => {
    setIsScrollable(elementIsScrollable);
  }, [elementIsScrollable, setIsScrollable]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ...props,
      ...testIds?.BODY,
      ref: scrollableRef,
      className: getDialogBodyClassName({
        variant,
        scrollable: isScrollable,
        isMobile: smallerOrEqual("mobile")
      }),
      children
    }
  );
};
const getDialogHeaderClassName = ({ variant, scrollable }) => {
  const baseClassName2 = clsx(
    // Layout
    "flex flex-col gap-e8",
    "shrink-0",
    // Padding
    "px-e32 pb-e8"
  );
  const variantClassName2 = {
    default: "",
    modal: clsx(
      // Padding
      { "pb-e32": scrollable }
    )
  };
  return twMerge(baseClassName2, variantClassName2[variant ?? "default"]);
};
const _InternalDialogHeader = ({ children }) => {
  const { variant, isScrollable } = useDialogContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: getDialogHeaderClassName({ variant, scrollable: isScrollable }), children });
};
const _InternalDialogTitle = ({
  children,
  ...props
}) => {
  const { testIds } = useDialogContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Heading,
    {
      level: "h3",
      noDefaultMargins: true,
      ...props,
      ...testIds?.TITLE,
      children
    }
  );
};
const _InternalDialogDescription = ({
  children,
  ...props
}) => {
  const { testIds } = useDialogContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paragraph,
    {
      noDefaultMargins: true,
      ...props,
      ...testIds?.DESCRIPTION,
      children
    }
  );
};
const getDialogCtasClassName = ({
  variant,
  size: size2
}) => {
  const baseClassName2 = clsx(
    // Layout
    "flex gap-e24 mobile-d:flex-col",
    "shrink-0",
    { "flex-col": size2 === "xs" },
    // Padding
    "px-e32"
  );
  const variantClassName2 = {
    default: clsx(
      // Padding
      "pt-e8"
    ),
    modal: clsx(
      // Padding
      "pt-e24"
    )
  };
  return twMerge(baseClassName2, variantClassName2[variant ?? "default"]);
};
const _InternalDialogCTAs = ({ children }) => {
  const { variant, size: size2 } = useDialogContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: getDialogCtasClassName({ variant, size: size2 }), children });
};
const DialogProvider = ({
  variant,
  size: size2,
  testIds,
  children
}) => {
  const [isScrollable, setIsScrollable] = useState(false);
  const contextValue = useMemo(
    () => ({
      variant,
      size: size2,
      isScrollable,
      setIsScrollable,
      testIds
    }),
    [variant, size2, isScrollable, testIds]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext.Provider, { value: contextValue, children });
};
const TEST_IDS_CONFIG$h = {
  BASE: "",
  DISMISS_BUTTON: "dismiss-button",
  TITLE: "title",
  DESCRIPTION: "description",
  BODY: "body"
};
const ContextualizedDialog = ({
  isOpen,
  isDismissible,
  variant,
  size: size2,
  className,
  initialFocus,
  children,
  onDismiss,
  ...props
}) => {
  const { isScrollable } = useDialogContext();
  const { smallerOrEqual } = useViewport();
  const isMobile = smallerOrEqual("mobile");
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$h,
    ids: props
  });
  const dialogContainerClassName = getDialogContainerClassName({
    isDismissible,
    variant,
    size: size2,
    scrollable: isScrollable,
    isMobile,
    className
  });
  const childrenContainerClassName = getChildrenContainerClassName({
    variant,
    isMobile
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    _t,
    {
      open: isOpen,
      initialFocus,
      onClose: noop$1,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: overlayClassName$2,
          ...testIds.BASE,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(_t.Panel, { className: dialogContainerClassName, children: [
            isDismissible && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: dismissBtnContainerClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button,
              {
                ...testIds.DISMISS_BUTTON,
                iconOnly: true,
                variant: "ghost",
                size: "md",
                className: dismissBtnClassName,
                onClick: onDismiss,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: R$1 })
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: childrenContainerClassName, children })
          ] })
        }
      )
    }
  );
};
const Dialog = ({ isOpen, isDismissible, ...props }) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$h,
    ids: props
  });
  if (!isOpen) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DialogProvider,
    {
      ...pick(props, ["variant", "size"]),
      testIds,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ContextualizedDialog,
        {
          ...props,
          isOpen,
          isDismissible
        }
      )
    }
  );
};
Dialog.Body = _InternalDialogBody;
Dialog.Header = _InternalDialogHeader;
Dialog.Title = _InternalDialogTitle;
Dialog.Description = _InternalDialogDescription;
Dialog.CTAs = _InternalDialogCTAs;
const DEFAULT_CONFIG$1 = {
  isDismissible: true,
  defaultOpen: false,
  onOpenCallback: noop$1,
  onDismissCallback: noop$1
};
const useDialog = (configProp) => {
  const config2 = useMemo(
    () => merge({}, DEFAULT_CONFIG$1, configProp),
    [configProp]
  );
  const [isOpen, setIsOpen] = useToggle(config2.defaultOpen ?? false);
  const openDialog = useCallback(() => {
    config2.onOpenCallback();
    setIsOpen(true);
  }, [config2, setIsOpen]);
  const closeDialog = useCallback(() => {
    config2.onDismissCallback();
    setIsOpen(false);
  }, [config2, setIsOpen]);
  const dialogStateProps = useMemo(
    () => ({
      isOpen,
      isDismissible: config2.isDismissible,
      onDismiss: closeDialog
    }),
    [isOpen, closeDialog, config2]
  );
  return {
    dialogStateProps,
    onOpen: openDialog,
    onClose: closeDialog
  };
};
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x2,
        y: y2,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const size$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply: apply2 = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply2({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e3) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y2 = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y2 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y2 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y2 = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache2) {
  const cachedResult = cache2.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el2) => isElement(el2) && getNodeName(el2) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache2.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement(element);
  function cleanup2() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup2();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root2.clientWidth - (left + width));
    const insetBottom = floor(root2.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (e3) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup2;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const computePosition = (reference, floating, options) => {
  const cache2 = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache2
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var index$2 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length;
  let i2;
  let keys2;
  if (a2 && b2 && typeof a2 === "object") {
    if (Array.isArray(a2)) {
      length = a2.length;
      if (length !== b2.length) return false;
      for (i2 = length; i2-- !== 0; ) {
        if (!deepEqual(a2[i2], b2[i2])) {
          return false;
        }
      }
      return true;
    }
    keys2 = Object.keys(a2);
    length = keys2.length;
    if (length !== Object.keys(b2).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b2, keys2[i2])) {
        return false;
      }
    }
    for (i2 = length; i2-- !== 0; ) {
      const key = keys2[i2];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef$1(value) {
  const ref = a$z.useRef(value);
  index$2(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = a$z.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = a$z.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = a$z.useState(null);
  const [_floating, _setFloating] = a$z.useState(null);
  const setReference = a$z.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = a$z.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = a$z.useRef(null);
  const floatingRef = a$z.useRef(null);
  const dataRef = a$z.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
  const platformRef = useLatestRef$1(platform2);
  const openRef = useLatestRef$1(open);
  const update = a$z.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$2(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = a$z.useRef(false);
  index$2(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$2(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = a$z.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = a$z.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = a$z.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements.floating, data.x);
    const y2 = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x2 + "px, " + y2 + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x2,
      top: y2
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return a$z.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const offset = (options, deps) => ({
  ...offset$1(options),
  options: [options, deps]
});
const shift = (options, deps) => ({
  ...shift$1(options),
  options: [options, deps]
});
const flip = (options, deps) => ({
  ...flip$1(options),
  options: [options, deps]
});
const size = (options, deps) => ({
  ...size$1(options),
  options: [options, deps]
});
function activeElement(doc) {
  let activeElement2 = doc.activeElement;
  while (((_activeElement = activeElement2) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement2 = activeElement2.shadowRoot.activeElement;
  }
  return activeElement2;
}
function contains(parent2, child) {
  if (!parent2 || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
  if (parent2.contains(child)) {
    return true;
  }
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent2 === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map((_ref) => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === "click" && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isSafari() {
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re2 = /android/i;
  return re2.test(getPlatform()) || re2.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes("jsdom/");
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0];
  }
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node && isInert2(node.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node) {
  var _node$getAttribute2;
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el2, includeContainer, filter) {
  if (isInert(el2)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el2.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el2, candidateSelector)) {
    candidates.unshift(el2);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content2 = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content2, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
  return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
  if (!node) {
    throw new Error("No node provided");
  }
  if (node.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a2, b2) {
  return a2.tabIndex === b2.tabIndex ? a2.documentOrder - b2.documentOrder : a2.tabIndex - b2.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r2 = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r2;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i2 = 0; i2 < nodes.length; i2++) {
    if (nodes[i2].checked && nodes[i2].form === form) {
      return nodes[i2];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
  var _nodeRoot;
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (isNodeAttached(node)) {
      return !node.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i2 = 0; i2 < parentNode.children.length; i2++) {
          var child = parentNode.children.item(i2);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i2) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i2,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
const SafeReact = {
  ...a$z
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = a$z.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return a$z.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
var index$1 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = a$z.useState(() => serverHandoffComplete ? genId() : void 0);
  index$1(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  a$z.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message2 = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message2))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message2);
    console.error(message2);
  }
}
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l2) => l2 !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ a$z.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ a$z.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = a$z.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => a$z.useContext(FloatingTreeContext);
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function clearTimeoutIfSet(timeoutRef) {
  if (timeoutRef.current !== -1) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = -1;
  }
}
function useLatestRef(value) {
  const ref = useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
let rafId = 0;
function enqueueFocus(el2, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el2 == null ? void 0 : el2.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}
function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find((node) => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find((node) => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}
function getChildren(nodes, id) {
  let allChildren = nodes.filter((node) => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter((node) => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n2) => {
        var _node$context2;
        return node.parentId === n2.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
let counterMap = /* @__PURE__ */ new WeakMap();
let uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const unwrapHost = (node) => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent2, targets) => targets.map((target) => {
  if (parent2.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent2.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter((x2) => x2 != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = "data-floating-ui-inert";
  const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = /* @__PURE__ */ new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el2) {
    if (!el2 || elementsToKeep.has(el2)) {
      return;
    }
    elementsToKeep.add(el2);
    el2.parentNode && keep(el2.parentNode);
  }
  function deep(parent2) {
    if (!parent2 || elementsToStop.has(parent2)) {
      return;
    }
    [].forEach.call(parent2.children, (node) => {
      if (getNodeName(node) === "script") return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr2 = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr2 !== null && attr2 !== "false";
        const currentCounterValue = counterMap.get(node) || 0;
        const counterValue = controlAttribute ? currentCounterValue + 1 : currentCounterValue;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, "");
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, "true");
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach((element) => {
      const currentCounterValue = counterMap.get(element) || 0;
      const counterValue = controlAttribute ? currentCounterValue - 1 : currentCounterValue;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === "prev") {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach((element) => {
    element.dataset.tabindex = element.getAttribute("tabindex") || "";
    element.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll("[data-tabindex]");
  elements.forEach((element) => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute("tabindex", tabindex);
    } else {
      element.removeAttribute("tabindex");
    }
  });
}
const HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
const FocusGuard = /* @__PURE__ */ a$z.forwardRef(function FocusGuard2(props, ref) {
  const [role, setRole] = a$z.useState();
  index$1(() => {
    if (isSafari()) {
      setRole("button");
    }
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    "aria-hidden": role ? void 0 : true,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    ...props,
    ...restProps
  });
});
const PortalContext = /* @__PURE__ */ a$z.createContext(null);
const attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root: root2
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = a$z.useState(null);
  const portalNodeRef = a$z.useRef(null);
  index$1(() => {
    return () => {
      portalNode == null || portalNode.remove();
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  index$1(() => {
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement("div");
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, "");
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  index$1(() => {
    if (root2 === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root2 || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement("div");
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement("div");
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, "");
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root2, uniqueId, portalContext]);
  return portalNode;
}
function FloatingPortal(props) {
  const {
    children,
    id,
    root: root2,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root: root2
  });
  const [focusManagerState, setFocusManagerState] = a$z.useState(null);
  const beforeOutsideRef = a$z.useRef(null);
  const afterOutsideRef = a$z.useRef(null);
  const beforeInsideRef = a$z.useRef(null);
  const afterInsideRef = a$z.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root2 || portalNode)
  );
  a$z.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === "focusin";
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    portalNode.addEventListener("focusin", onFocus, true);
    portalNode.addEventListener("focusout", onFocus, true);
    return () => {
      portalNode.removeEventListener("focusin", onFocus, true);
      portalNode.removeEventListener("focusout", onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  a$z.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalContext.Provider, {
    value: a$z.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode]),
    children: [shouldRenderGuards && portalNode && /* @__PURE__ */ jsxRuntimeExports.jsx(FocusGuard, {
      "data-type": "outside",
      ref: beforeOutsideRef,
      onFocus: (event) => {
        if (isOutsideEvent(event, portalNode)) {
          var _beforeInsideRef$curr;
          (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
        } else {
          const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.domReference);
          prevTabbable == null || prevTabbable.focus();
        }
      }
    }), shouldRenderGuards && portalNode && /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      "aria-owns": portalNode.id,
      style: HIDDEN_STYLES
    }), portalNode && /* @__PURE__ */ ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /* @__PURE__ */ jsxRuntimeExports.jsx(FocusGuard, {
      "data-type": "outside",
      ref: afterOutsideRef,
      onFocus: (event) => {
        if (isOutsideEvent(event, portalNode)) {
          var _afterInsideRef$curre;
          (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
        } else {
          const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.domReference);
          nextTabbable == null || nextTabbable.focus();
          (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const usePortalContext = () => a$z.useContext(PortalContext);
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function useLiteMergeRefs(refs) {
  return a$z.useMemo(() => {
    return (value) => {
      refs.forEach((ref) => {
        if (ref) {
          ref.current = value;
        }
      });
    };
  }, refs);
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter((el2) => el2.isConnected);
  if (element && getNodeName(element) !== "body") {
    previouslyFocusedElements.push(element);
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-20);
    }
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find((el2) => el2.isConnected);
}
function getFirstTabbableElement(container) {
  const tabbableOptions = getTabbableOptions();
  if (isTabbable(container, tabbableOptions)) {
    return container;
  }
  return tabbable(container, tabbableOptions)[0] || container;
}
const VisuallyHiddenDismiss = /* @__PURE__ */ a$z.forwardRef(function VisuallyHiddenDismiss2(props, ref) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("button", {
    ...props,
    type: "button",
    ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
});
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order: order2 = ["content"],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true,
    outsideElementsInert = false
  } = props;
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const getNodeId = useEffectEvent(() => {
    var _dataRef$current$floa;
    return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
  });
  const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;
  const inertSupported = supportsInert();
  const guards = inertSupported ? _guards : true;
  const useInert = !guards || inertSupported && outsideElementsInert;
  const orderRef = useLatestRef(order2);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = a$z.useRef(null);
  const endDismissButtonRef = a$z.useRef(null);
  const preventReturnFocusRef = a$z.useRef(false);
  const isPointerDownRef = a$z.useRef(false);
  const tabbableIndexRef = a$z.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function(container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent((container) => {
    const content2 = getTabbableContent(container);
    return orderRef.current.map((type) => {
      if (domReference && type === "reference") {
        return domReference;
      }
      if (floatingFocusElement && type === "floating") {
        return floatingFocusElement;
      }
      return content2;
    }).filter(Boolean).flat();
  });
  a$z.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === "Tab") {
        if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === "reference" && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floatingFocusElement);
    doc.addEventListener("keydown", onKeyDown);
    return () => {
      doc.removeEventListener("keydown", onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  a$z.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener("focusin", handleFocusIn);
    return () => {
      floating.removeEventListener("focusin", handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  a$z.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const nodeId = getNodeId();
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context3, _node$context4, _node$context5;
          return [(_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating, getFloatingFocusElement((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
        })));
        if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, "focus-out");
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener("focusout", handleFocusOutside);
      domReference.addEventListener("pointerdown", handlePointerDown);
      floating.addEventListener("focusout", handleFocusOutside);
      return () => {
        domReference.removeEventListener("focusout", handleFocusOutside);
        domReference.removeEventListener("pointerdown", handlePointerDown);
        floating.removeEventListener("focusout", handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox, getNodeId]);
  const beforeGuardRef = a$z.useRef(null);
  const afterGuardRef = a$z.useRef(null);
  const mergedBeforeGuardRef = useLiteMergeRefs([beforeGuardRef, portalContext == null ? void 0 : portalContext.beforeInsideRef]);
  const mergedAfterGuardRef = useLiteMergeRefs([afterGuardRef, portalContext == null ? void 0 : portalContext.afterInsideRef]);
  a$z.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;
    if (!floating) return;
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
    const ancestorFloatingNodes = tree && !modal ? getAncestors(tree == null ? void 0 : tree.nodesRef.current, getNodeId()).map((node) => {
      var _node$context6;
      return (_node$context6 = node.context) == null ? void 0 : _node$context6.elements.floating;
    }) : [];
    const insideElements = [floating, ...portalNodes, ...ancestorFloatingNodes, startDismissButtonRef.current, endDismissButtonRef.current, beforeGuardRef.current, afterGuardRef.current, portalContext == null ? void 0 : portalContext.beforeOutsideRef.current, portalContext == null ? void 0 : portalContext.afterOutsideRef.current, orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null].filter((x2) => x2 != null);
    const cleanup2 = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, !useInert, useInert) : markOthers(insideElements);
    return () => {
      cleanup2();
    };
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards, useInert, tree, getNodeId]);
  index$1(() => {
    if (disabled || !isHTMLElement(floatingFocusElement)) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index$1(() => {
    if (disabled || !floatingFocusElement) return;
    let preventReturnFocusScroll = false;
    let focusReference = false;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    let openEvent = contextData.openEvent;
    addPreviouslyFocusedElement(previouslyFocusedElement);
    function onOpenChange2(_ref) {
      let {
        open: open2,
        reason,
        event,
        nested
      } = _ref;
      if (open2) {
        openEvent = event;
      }
      if (reason === "escape-key") {
        focusReference = true;
      }
      if (["hover", "safe-polygon"].includes(reason) && event.type === "mouseleave") {
        preventReturnFocusRef.current = true;
      }
      if (reason !== "outside-press") return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else if (isVirtualClick(event) || isVirtualPointerEvent(event)) {
        preventReturnFocusRef.current = false;
      } else {
        let isPreventScrollSupported = false;
        document.createElement("div").focus({
          get preventScroll() {
            isPreventScrollSupported = true;
            return false;
          }
        });
        if (isPreventScrollSupported) {
          preventReturnFocusRef.current = false;
          preventReturnFocusScroll = true;
        } else {
          preventReturnFocusRef.current = true;
        }
      }
    }
    events.on("openchange", onOpenChange2);
    const fallbackEl = doc.createElement("span");
    fallbackEl.setAttribute("tabindex", "-1");
    fallbackEl.setAttribute("aria-hidden", "true");
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement("afterend", fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === "boolean") {
        return focusReference && domReference ? domReference : getPreviouslyFocusedElement() || fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off("openchange", onOpenChange2);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, getNodeId()).some((node) => {
        var _node$context7;
        return contains((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
      });
      if (isFocusInsideFloatingTree || !!openEvent && ["click", "mousedown"].includes(openEvent.type)) {
        focusReference = true;
      }
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        const tabbableReturnElement = getFirstTabbableElement(returnElement);
        if (
          // eslint-disable-next-line react-hooks/exhaustive-deps
          returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
          // since it likely entered a different element which should be
          // respected: https://github.com/floating-ui/floating-ui/issues/2607
          (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)
        ) {
          tabbableReturnElement.focus({
            preventScroll: preventReturnFocusScroll
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, events, tree, isInsidePortal, domReference, getNodeId]);
  a$z.useEffect(() => {
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
  }, [disabled]);
  index$1(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      domReference
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, closeOnFocusOut, domReference]);
  index$1(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    if (typeof MutationObserver !== "function") return;
    if (ignoreInitialFocus) return;
    const handleMutation = () => {
      const tabIndex = floatingFocusElement.getAttribute("tabindex");
      const tabbableContent = getTabbableContent();
      const activeEl = activeElement(getDocument(floating));
      const tabbableIndex = tabbableContent.indexOf(activeEl);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
      if (orderRef.current.includes("floating") || activeEl !== domReference && tabbableContent.length === 0) {
        if (tabIndex !== "0") {
          floatingFocusElement.setAttribute("tabindex", "0");
        }
      } else if (tabIndex !== "-1") {
        floatingFocusElement.setAttribute("tabindex", "-1");
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floatingFocusElement, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, floatingFocusElement, domReference, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHiddenDismiss, {
      ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
      onClick: (event) => onOpenChange(false, event.nativeEvent),
      children: typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss"
    });
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [shouldRenderGuards && /* @__PURE__ */ jsxRuntimeExports.jsx(FocusGuard, {
      "data-type": "inside",
      ref: mergedBeforeGuardRef,
      onFocus: (event) => {
        if (modal) {
          const els = getTabbableElements();
          enqueueFocus(order2[0] === "reference" ? els[0] : els[els.length - 1]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          preventReturnFocusRef.current = false;
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const nextTabbable = getNextTabbable() || domReference;
            nextTabbable == null || nextTabbable.focus();
          } else {
            var _portalContext$before;
            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
          }
        }
      }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /* @__PURE__ */ jsxRuntimeExports.jsx(FocusGuard, {
      "data-type": "inside",
      ref: mergedAfterGuardRef,
      onFocus: (event) => {
        if (modal) {
          enqueueFocus(getTabbableElements()[0]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          if (closeOnFocusOut) {
            preventReturnFocusRef.current = true;
          }
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const prevTabbable = getPreviousTabbable() || domReference;
            prevTabbable == null || prevTabbable.focus();
          } else {
            var _portalContext$afterO;
            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
          }
        }
      }
    })]
  });
}
let lockCount = 0;
function enableScrollLock() {
  const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
  const bodyStyle = document.body.style;
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = "hidden";
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: "fixed",
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: "",
      [paddingProp]: ""
    });
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: "",
        top: "",
        left: "",
        right: ""
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
let cleanup = () => {
};
const FloatingOverlay = /* @__PURE__ */ a$z.forwardRef(function FloatingOverlay2(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  index$1(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref,
    ...rest,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  });
});
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = a$z.useRef({});
  const [events] = a$z.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = a$z.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = a$z.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = a$z.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return a$z.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = a$z.useState(null);
  const [positionReference, _setPositionReference] = a$z.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = a$z.useRef(null);
  const tree = useFloatingTree();
  index$1(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position2 = useFloating$1({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = a$z.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    _setPositionReference(computedPositionReference);
    position2.refs.setReference(computedPositionReference);
  }, [position2.refs]);
  const setReference = a$z.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position2.refs.reference.current) || position2.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position2.refs.setReference(node);
    }
  }, [position2.refs]);
  const refs = a$z.useMemo(() => ({
    ...position2.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position2.refs, setReference, setPositionReference]);
  const elements = a$z.useMemo(() => ({
    ...position2.elements,
    domReference
  }), [position2.elements, domReference]);
  const context = a$z.useMemo(() => ({
    ...position2,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position2, refs, elements, nodeId, rootContext]);
  index$1(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return a$z.useMemo(() => ({
    ...position2,
    context,
    refs,
    elements
  }), [position2, refs, elements, context]);
}
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = a$z.useRef(false);
  const timeoutRef = a$z.useRef(-1);
  const keyboardModalityRef = a$z.useRef(true);
  a$z.useEffect(() => {
    if (!enabled) return;
    const win = getWindow(elements.domReference);
    function onBlur() {
      if (!open && isHTMLElement(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener("blur", onBlur);
    win.addEventListener("keydown", onKeyDown, true);
    return () => {
      win.removeEventListener("blur", onBlur);
      win.removeEventListener("keydown", onKeyDown, true);
    };
  }, [elements.domReference, open, enabled]);
  a$z.useEffect(() => {
    if (!enabled) return;
    function onOpenChange2(_ref) {
      let {
        reason
      } = _ref;
      if (reason === "reference-press" || reason === "escape-key") {
        blockFocusRef.current = true;
      }
    }
    events.on("openchange", onOpenChange2);
    return () => {
      events.off("openchange", onOpenChange2);
    };
  }, [events, enabled]);
  a$z.useEffect(() => {
    return () => {
      clearTimeoutIfSet(timeoutRef);
    };
  }, []);
  const reference = a$z.useMemo(() => ({
    onPointerDown(event) {
      if (isVirtualPointerEvent(event.nativeEvent)) return;
      keyboardModalityRef.current = false;
    },
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = getTarget(event.nativeEvent);
      if (visibleOnly && isElement(target)) {
        try {
          if (isSafari() && isMac()) throw Error();
          if (!target.matches(":focus-visible")) return;
        } catch (_e2) {
          if (!keyboardModalityRef.current && !isTypeableElement(target)) {
            return;
          }
        }
      }
      onOpenChange(true, event.nativeEvent, "focus");
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;
      const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);
        if (!relatedTarget && activeEl === elements.domReference) return;
        if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, "focus");
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return a$z.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
const ACTIVE_KEY = "active";
const SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  const isItem = elementKey === "item";
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _2,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...elementKey === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...domUserProps,
    ...propsList.map((value) => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === "function") {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn) => fn(...args)).find((val) => val !== void 0);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map((key) => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map((key) => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map((key) => key == null ? void 0 : key.item);
  const getReferenceProps = a$z.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps
  );
  const getFloatingProps = a$z.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps
  );
  const getItemProps = a$z.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps
  );
  return a$z.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
const applyStyles = ({
  floatingElement,
  floatingStyles
}) => {
  const baseFloatingStyles = {
    maxHeight: "",
    width: "",
    top: "",
    bottom: ""
  };
  Object.assign(floatingElement.style, {
    ...baseFloatingStyles,
    ...floatingStyles
  });
};
const createDefaultPositioningStrategy = (config2 = {}) => {
  const {
    referenceOffset,
    parentContainerOffset,
    minDropdownHeight,
    maxDropdownHeight,
    matchReferenceWidth
  } = config2;
  return {
    placement: "bottom",
    middleware: [
      offset(referenceOffset),
      flip(),
      shift(),
      size({
        apply({ availableHeight, rects, elements }) {
          const minAvailableHeight = Math.max(
            minDropdownHeight ?? availableHeight,
            availableHeight
          );
          applyStyles({
            floatingElement: elements.floating,
            floatingStyles: {
              maxHeight: `${Math.min(maxDropdownHeight ?? availableHeight, minAvailableHeight)}px`,
              width: matchReferenceWidth ? `${rects.reference.width}px` : "",
              top: "0"
            }
          });
        },
        padding: parentContainerOffset
      })
    ]
  };
};
const createFullscreenPositioningStrategy = (config2 = {}) => {
  const { parentContainerOffset = 0 } = config2;
  return {
    strategy: "fixed",
    middleware: [
      size({
        apply({ elements }) {
          const viewportHeight = window.innerHeight;
          applyStyles({
            floatingElement: elements.floating,
            floatingStyles: {
              transform: "translate(0,0)",
              bottom: "0",
              maxHeight: `${viewportHeight - parentContainerOffset}px`
            }
          });
        }
      })
    ]
  };
};
const DEFAULT_CONFIG = {
  referenceOffset: 4,
  parentContainerOffset: 10
};
const FULLSCREEN_CONFIG = {
  parentContainerOffset: 40
};
const PositioningStrategyConfigMap = {
  default: DEFAULT_CONFIG,
  fullscreen: FULLSCREEN_CONFIG
};
const PositioningStrategyFnMap = {
  default: createDefaultPositioningStrategy,
  fullscreen: createFullscreenPositioningStrategy
};
const useFloatingDropdown = ({
  isOpen,
  options,
  config: config2,
  positioningStrategy = "default"
}) => {
  const {
    parentContainerOffset,
    referenceOffset,
    minDropdownHeight,
    maxDropdownHeight,
    matchReferenceWidth
  } = {
    ...PositioningStrategyConfigMap[positioningStrategy],
    ...config2
  };
  const floatingOptions = useMemo(() => {
    const positioningStrategyProps = PositioningStrategyFnMap[positioningStrategy]({
      parentContainerOffset,
      referenceOffset,
      minDropdownHeight,
      maxDropdownHeight,
      matchReferenceWidth
    });
    return {
      whileElementsMounted: autoUpdate,
      open: isOpen,
      ...positioningStrategyProps,
      ...options
    };
  }, [
    isOpen,
    options,
    positioningStrategy,
    parentContainerOffset,
    referenceOffset,
    minDropdownHeight,
    maxDropdownHeight,
    matchReferenceWidth
  ]);
  const { refs, floatingStyles, context } = useFloating({ ...floatingOptions });
  const focus = useFocus(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([focus]);
  return { refs, floatingStyles, context, getReferenceProps, getFloatingProps };
};
const DropdownMenuContext = createContext(null);
const useDropdownMenuContext = () => {
  const context = useContext(DropdownMenuContext);
  if (!context) {
    throw new Error("useDropdownMenuContext must be used within a DropdownMenuProvider");
  }
  return context;
};
const DropdownMenuProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownMenuContext.Provider, { value: props, children });
};
const _InternalButton = a__default.forwardRef(
  ({ variant = "secondary", iconOnly = false, active, className, children, ...buttonProps }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        ...buttonProps,
        variant,
        iconOnly,
        buttonRef: ref,
        className: twMerge("mobile-d:w-fit", className),
        children: iconOnly ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          SyntaxIcon,
          {
            icon: w$3,
            weight: "fill"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          children,
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            SyntaxIcon,
            {
              icon: D,
              className: clsx("transition-transform duration-300", { "-rotate-180": active })
            }
          )
        ] })
      }
    );
  }
);
const MenuButton$1 = ({ component, children, ...buttonProps }) => {
  const { refs, getReferenceProps } = useDropdownMenuContext();
  const Component2 = component ?? _InternalButton;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(qe$1.Button, { as: Fragment, children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Component2,
    {
      ...buttonProps,
      ...getReferenceProps(),
      ref: refs.setReference,
      active: open,
      children
    }
  ) });
};
MenuButton$1.displayName = "DropdownMenu.Button";
const menuItemClasses = twMerge(
  clsx(
    // Layout
    "flex items-center gap-e8",
    // Spacing
    "p-e16",
    // Size
    "w-full",
    // Border
    "first:rounded-t-sm last:rounded-b-sm",
    // Background
    "bg-transparent",
    "hui-active:bg-warm-gray/6",
    // Disabled
    "hui-disabled:cursor-not-allowed hui-disabled:text-warm-gray-400",
    "cursor-pointer",
    // Focus
    "focus:outline-none",
    // Utils
    "select-none",
    // Transitions
    "transition-colors",
    // Text
    "text-left"
  )
);
const MenuItem = ({
  className,
  as = "button",
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    qe$1.Item,
    {
      ...props,
      as,
      className: twMerge(menuItemClasses, className),
      children
    }
  );
};
MenuItem.displayName = "DropdownMenu.Item";
const MenuItemLabel = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paragraph,
    {
      className: twMerge(clsx("text-inherit flex grow", className)),
      noDefaultMargins: true,
      children
    }
  );
};
MenuItemLabel.displayName = "DropdownMenu.ItemLabel";
const getMenuItemsClasses = ({ fullWidth, positioningStrategy, className }) => {
  const FullWidthClassNames = clsx(
    // Positioning
    "left-0 right-0",
    // Sizing
    "max-w-none",
    // Border radius
    "rounded-none"
  );
  const PositioningStrategyClassNamesMap = {
    default: clsx(
      // Sizing
      "max-w-90vw",
      // Focus
      "focus:outline-none",
      // Animation
      "transition-opacity duration-200 ease-in-out",
      // Full width
      { [FullWidthClassNames]: fullWidth }
    ),
    fullscreen: clsx(
      // Positioning
      "left-0 right-0"
    )
  };
  const base = clsx(
    // Positioning
    "absolute z-20",
    // Layout
    "flex grow flex-col",
    // Border
    "rounded-sm",
    // Background
    "bg-white",
    // Shadow
    "shadow-drop-1",
    // Overflow
    "overflow-y-hidden hover:overflow-y-auto mobile-d:overflow-y-auto",
    // Scrollbar
    "scrollbar-thin"
  );
  return twMerge(base, PositioningStrategyClassNamesMap[positioningStrategy], className);
};
const FullscreenOverlay = ({ enabled, children }) => {
  return enabled ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    FloatingOverlay,
    {
      lockScroll: true,
      className: "bg-warm-gray-16%",
      children
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
const MenuItems = ({ className, children, fullWidth, ...props }) => {
  const { open, refs, getFloatingProps, floatingStyles, positioningStrategy } = useDropdownMenuContext();
  const isFullscreen = positioningStrategy === "fullscreen";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FloatingPortal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FullscreenOverlay, { enabled: isFullscreen && open, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    qe$1.Items,
    {
      ...props,
      ...getFloatingProps(),
      ref: refs.setFloating,
      className: getMenuItemsClasses({ fullWidth, positioningStrategy, className }),
      style: { ...floatingStyles },
      children
    }
  ) }) });
};
MenuItems.displayName = "DropdownMenu.Items";
const containerClassNames = clsx(
  // Layout
  "flex items-center",
  // Spacing
  "px-e16 pb-e8 pt-e16"
);
const textClassNames = "text-warm-gray-600";
const SectionTitle = ({
  className,
  textClassName,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ...props,
      className: twMerge(containerClassNames, className),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text,
        {
          variant: "label",
          className: twMerge(textClassNames, textClassName),
          children
        }
      )
    }
  );
};
SectionTitle.displayName = "DropdownMenu.SectionTitle";
var dist$2 = {};
function lexer(str) {
  var tokens = [];
  var i2 = 0;
  while (i2 < str.length) {
    var char = str[i2];
    if (char === "*" || char === "+" || char === "?") {
      tokens.push({ type: "MODIFIER", index: i2, value: str[i2++] });
      continue;
    }
    if (char === "\\") {
      tokens.push({ type: "ESCAPED_CHAR", index: i2++, value: str[i2++] });
      continue;
    }
    if (char === "{") {
      tokens.push({ type: "OPEN", index: i2, value: str[i2++] });
      continue;
    }
    if (char === "}") {
      tokens.push({ type: "CLOSE", index: i2, value: str[i2++] });
      continue;
    }
    if (char === ":") {
      var name = "";
      var j2 = i2 + 1;
      while (j2 < str.length) {
        var code2 = str.charCodeAt(j2);
        if (
          // `0-9`
          code2 >= 48 && code2 <= 57 || // `A-Z`
          code2 >= 65 && code2 <= 90 || // `a-z`
          code2 >= 97 && code2 <= 122 || // `_`
          code2 === 95
        ) {
          name += str[j2++];
          continue;
        }
        break;
      }
      if (!name)
        throw new TypeError("Missing parameter name at ".concat(i2));
      tokens.push({ type: "NAME", index: i2, value: name });
      i2 = j2;
      continue;
    }
    if (char === "(") {
      var count2 = 1;
      var pattern = "";
      var j2 = i2 + 1;
      if (str[j2] === "?") {
        throw new TypeError('Pattern cannot start with "?" at '.concat(j2));
      }
      while (j2 < str.length) {
        if (str[j2] === "\\") {
          pattern += str[j2++] + str[j2++];
          continue;
        }
        if (str[j2] === ")") {
          count2--;
          if (count2 === 0) {
            j2++;
            break;
          }
        } else if (str[j2] === "(") {
          count2++;
          if (str[j2 + 1] !== "?") {
            throw new TypeError("Capturing groups are not allowed at ".concat(j2));
          }
        }
        pattern += str[j2++];
      }
      if (count2)
        throw new TypeError("Unbalanced pattern at ".concat(i2));
      if (!pattern)
        throw new TypeError("Missing pattern at ".concat(i2));
      tokens.push({ type: "PATTERN", index: i2, value: pattern });
      i2 = j2;
      continue;
    }
    tokens.push({ type: "CHAR", index: i2, value: str[i2++] });
  }
  tokens.push({ type: "END", index: i2, value: "" });
  return tokens;
}
function parse$2(str, options) {
  if (options === void 0) {
    options = {};
  }
  var tokens = lexer(str);
  var _a2 = options.prefixes, prefixes = _a2 === void 0 ? "./" : _a2, _b2 = options.delimiter, delimiter = _b2 === void 0 ? "/#?" : _b2;
  var result = [];
  var key = 0;
  var i2 = 0;
  var path2 = "";
  var tryConsume = function(type) {
    if (i2 < tokens.length && tokens[i2].type === type)
      return tokens[i2++].value;
  };
  var mustConsume = function(type) {
    var value2 = tryConsume(type);
    if (value2 !== void 0)
      return value2;
    var _a3 = tokens[i2], nextType = _a3.type, index2 = _a3.index;
    throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index2, ", expected ").concat(type));
  };
  var consumeText = function() {
    var result2 = "";
    var value2;
    while (value2 = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR")) {
      result2 += value2;
    }
    return result2;
  };
  var isSafe = function(value2) {
    for (var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++) {
      var char2 = delimiter_1[_i];
      if (value2.indexOf(char2) > -1)
        return true;
    }
    return false;
  };
  var safePattern = function(prefix2) {
    var prev = result[result.length - 1];
    var prevText = prefix2 || (prev && typeof prev === "string" ? prev : "");
    if (prev && !prevText) {
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(prev.name, '"'));
    }
    if (!prevText || isSafe(prevText))
      return "[^".concat(escapeString(delimiter), "]+?");
    return "(?:(?!".concat(escapeString(prevText), ")[^").concat(escapeString(delimiter), "])+?");
  };
  while (i2 < tokens.length) {
    var char = tryConsume("CHAR");
    var name = tryConsume("NAME");
    var pattern = tryConsume("PATTERN");
    if (name || pattern) {
      var prefix = char || "";
      if (prefixes.indexOf(prefix) === -1) {
        path2 += prefix;
        prefix = "";
      }
      if (path2) {
        result.push(path2);
        path2 = "";
      }
      result.push({
        name: name || key++,
        prefix,
        suffix: "",
        pattern: pattern || safePattern(prefix),
        modifier: tryConsume("MODIFIER") || ""
      });
      continue;
    }
    var value = char || tryConsume("ESCAPED_CHAR");
    if (value) {
      path2 += value;
      continue;
    }
    if (path2) {
      result.push(path2);
      path2 = "";
    }
    var open = tryConsume("OPEN");
    if (open) {
      var prefix = consumeText();
      var name_1 = tryConsume("NAME") || "";
      var pattern_1 = tryConsume("PATTERN") || "";
      var suffix = consumeText();
      mustConsume("CLOSE");
      result.push({
        name: name_1 || (pattern_1 ? key++ : ""),
        pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
        prefix,
        suffix,
        modifier: tryConsume("MODIFIER") || ""
      });
      continue;
    }
    mustConsume("END");
  }
  return result;
}
function compile(str, options) {
  return tokensToFunction(parse$2(str, options), options);
}
function tokensToFunction(tokens, options) {
  if (options === void 0) {
    options = {};
  }
  var reFlags2 = flags(options);
  var _a2 = options.encode, encode = _a2 === void 0 ? function(x2) {
    return x2;
  } : _a2, _b2 = options.validate, validate = _b2 === void 0 ? true : _b2;
  var matches2 = tokens.map(function(token) {
    if (typeof token === "object") {
      return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags2);
    }
  });
  return function(data) {
    var path2 = "";
    for (var i2 = 0; i2 < tokens.length; i2++) {
      var token = tokens[i2];
      if (typeof token === "string") {
        path2 += token;
        continue;
      }
      var value = data ? data[token.name] : void 0;
      var optional = token.modifier === "?" || token.modifier === "*";
      var repeat2 = token.modifier === "*" || token.modifier === "+";
      if (Array.isArray(value)) {
        if (!repeat2) {
          throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
        }
        if (value.length === 0) {
          if (optional)
            continue;
          throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
        }
        for (var j2 = 0; j2 < value.length; j2++) {
          var segment = encode(value[j2], token);
          if (validate && !matches2[i2].test(segment)) {
            throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
          }
          path2 += token.prefix + segment + token.suffix;
        }
        continue;
      }
      if (typeof value === "string" || typeof value === "number") {
        var segment = encode(String(value), token);
        if (validate && !matches2[i2].test(segment)) {
          throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
        }
        path2 += token.prefix + segment + token.suffix;
        continue;
      }
      if (optional)
        continue;
      var typeOfMessage = repeat2 ? "an array" : "a string";
      throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
    }
    return path2;
  };
}
function match(str, options) {
  var keys2 = [];
  var re2 = pathToRegexp$1(str, keys2, options);
  return regexpToFunction(re2, keys2, options);
}
function regexpToFunction(re2, keys2, options) {
  if (options === void 0) {
    options = {};
  }
  var _a2 = options.decode, decode2 = _a2 === void 0 ? function(x2) {
    return x2;
  } : _a2;
  return function(pathname) {
    var m2 = re2.exec(pathname);
    if (!m2)
      return false;
    var path2 = m2[0], index2 = m2.index;
    var params = /* @__PURE__ */ Object.create(null);
    var _loop_1 = function(i3) {
      if (m2[i3] === void 0)
        return "continue";
      var key = keys2[i3 - 1];
      if (key.modifier === "*" || key.modifier === "+") {
        params[key.name] = m2[i3].split(key.prefix + key.suffix).map(function(value) {
          return decode2(value, key);
        });
      } else {
        params[key.name] = decode2(m2[i3], key);
      }
    };
    for (var i2 = 1; i2 < m2.length; i2++) {
      _loop_1(i2);
    }
    return { path: path2, index: index2, params };
  };
}
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function flags(options) {
  return options && options.sensitive ? "" : "i";
}
function regexpToRegexp(path2, keys2) {
  if (!keys2)
    return path2;
  var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
  var index2 = 0;
  var execResult = groupsRegex.exec(path2.source);
  while (execResult) {
    keys2.push({
      // Use parenthesized substring match if available, index otherwise
      name: execResult[1] || index2++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    });
    execResult = groupsRegex.exec(path2.source);
  }
  return path2;
}
function arrayToRegexp(paths, keys2, options) {
  var parts = paths.map(function(path2) {
    return pathToRegexp$1(path2, keys2, options).source;
  });
  return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
function stringToRegexp(path2, keys2, options) {
  return tokensToRegexp(parse$2(path2, options), keys2, options);
}
function tokensToRegexp(tokens, keys2, options) {
  if (options === void 0) {
    options = {};
  }
  var _a2 = options.strict, strict = _a2 === void 0 ? false : _a2, _b2 = options.start, start = _b2 === void 0 ? true : _b2, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x2) {
    return x2;
  } : _d, _e2 = options.delimiter, delimiter = _e2 === void 0 ? "/#?" : _e2, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
  var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
  var delimiterRe = "[".concat(escapeString(delimiter), "]");
  var route = start ? "^" : "";
  for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
    var token = tokens_1[_i];
    if (typeof token === "string") {
      route += escapeString(encode(token));
    } else {
      var prefix = escapeString(encode(token.prefix));
      var suffix = escapeString(encode(token.suffix));
      if (token.pattern) {
        if (keys2)
          keys2.push(token);
        if (prefix || suffix) {
          if (token.modifier === "+" || token.modifier === "*") {
            var mod = token.modifier === "*" ? "?" : "";
            route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
          } else {
            route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
          }
        } else {
          if (token.modifier === "+" || token.modifier === "*") {
            throw new TypeError('Can not repeat "'.concat(token.name, '" without a prefix and suffix'));
          }
          route += "(".concat(token.pattern, ")").concat(token.modifier);
        }
      } else {
        route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
      }
    }
  }
  if (end) {
    if (!strict)
      route += "".concat(delimiterRe, "?");
    route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
  } else {
    var endToken = tokens[tokens.length - 1];
    var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === void 0;
    if (!strict) {
      route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
    }
    if (!isEndDelimited) {
      route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
  }
  return new RegExp(route, flags(options));
}
function pathToRegexp$1(path2, keys2, options) {
  if (path2 instanceof RegExp)
    return regexpToRegexp(path2, keys2);
  if (Array.isArray(path2))
    return arrayToRegexp(path2, keys2, options);
  return stringToRegexp(path2, keys2, options);
}
const dist_es2015 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compile,
  match,
  parse: parse$2,
  pathToRegexp: pathToRegexp$1,
  regexpToFunction,
  tokensToFunction,
  tokensToRegexp
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(dist_es2015);
Object.defineProperty(dist$2, "__esModule", { value: true });
var pathToRegexp = require$$0$1;
var include = function include2(base, routes) {
  var mappedRoutes = {
    toString: function toString2() {
      return base;
    }
  };
  Object.keys(routes).forEach(function(route) {
    var url = routes[route];
    if (typeof url === "function" && route === "toString") {
      mappedRoutes.toString = function() {
        return base + routes.toString();
      };
    } else if (typeof url === "object") {
      mappedRoutes[route] = include2(base, url);
    } else if (typeof url === "string") {
      mappedRoutes[route] = url.indexOf("/") === 0 ? url : [base, url].join("/").replace("//", "/");
    } else {
      throw new TypeError('"' + route + '" is not valid. A routes object can only contain a string, an object or the "toString" method as values.');
    }
  });
  return mappedRoutes;
};
function compileWithParams(pattern, params) {
  var reversed = pathToRegexp.compile(pattern);
  return reversed(params);
}
var reverse = function reverse2(pattern, params) {
  if (params === void 0) {
    params = {};
  }
  try {
    return compileWithParams(pattern, params);
  } catch (err) {
    return pattern;
  }
};
var reverseForce = function reverseForce2(pattern, params) {
  if (params === void 0) {
    params = {};
  }
  try {
    return compileWithParams(pattern, params);
  } catch (err) {
    var tokens = pathToRegexp.parse(pattern);
    return tokens.filter(function(token) {
      return typeof token === "string";
    }).join("");
  }
};
dist$2.include = include;
var reverse_1 = dist$2.reverse = reverse;
dist$2.reverseForce = reverseForce;
const getBaseClassName = ({ disabled, className, unstyled }) => {
  if (unstyled) return className;
  return twMerge(
    clsx("text-utility-link underline", {
      "pointer-events-none text-warm-gray-600": disabled
    }),
    className
  );
};
const Link = forwardRef(
  ({
    to,
    external = false,
    params,
    openInNewTab: openInNewTabProp,
    className,
    disabled,
    children,
    unstyled,
    ...props
  }, ref) => {
    const classNameMerged = getBaseClassName({ disabled, className, unstyled });
    const openInNewTab = useMemo(() => {
      if (!isUndefined(openInNewTabProp)) return openInNewTabProp;
      if (external) return true;
      return false;
    }, [external, openInNewTabProp]);
    const target = openInNewTab ? "_blank" : "_self";
    if (external) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          ...props,
          ref,
          href: to,
          rel: "nofollow noreferrer",
          target,
          className: classNameMerged,
          children
        }
      );
    }
    const internalPath = params ? reverse_1(to, params) : to;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link$1,
      {
        ...props,
        ref,
        to: internalPath,
        target,
        className: classNameMerged,
        children
      }
    );
  }
);
const useIsLinkActive = ({
  to,
  includeSubRoutes = true,
  detectActive = true,
  isActiveProp = false
}) => {
  const { pathname } = useLocation();
  return useMemo(() => {
    if (!detectActive) {
      return isActiveProp;
    }
    if (pathname === to) return true;
    if (includeSubRoutes) {
      if (to.replace("/", "").length === 0) return false;
      return pathname.startsWith(to);
    }
    return false;
  }, [detectActive, isActiveProp, includeSubRoutes, pathname, to]);
};
const MenuItemContent = ({
  hideArrow,
  active,
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  children,
  !hideArrow && !active && /* @__PURE__ */ jsxRuntimeExports.jsx(
    SyntaxIcon,
    {
      icon: d$2,
      className: "shrink-0"
    }
  )
] });
const linkClassName = (active) => clsx("text-warm-gray-900 no-underline", {
  "bg-orchid-50 font-medium text-warm-gray-900 hui-disabled:cursor-default hui-disabled:text-warm-gray-900": active
});
const LinkItem = ({
  to,
  external,
  openInNewTab,
  params,
  children,
  className,
  disabled,
  hideArrow,
  active: activeProp,
  includeSubRoutes,
  detectActive,
  ...props
}) => {
  const isActive = useIsLinkActive({
    to,
    includeSubRoutes,
    detectActive,
    isActiveProp: activeProp
  });
  if (disabled) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      DropdownMenu.Item,
      {
        ...props,
        className: twMerge(linkClassName(isActive), className),
        disabled: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemContent, { hideArrow, children })
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    qe$1.Item,
    {
      ...props,
      as: Link,
      className: twMerge(menuItemClasses, linkClassName(isActive), className),
      to,
      external,
      openInNewTab,
      params,
      disabled,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        MenuItemContent,
        {
          hideArrow,
          active: isActive,
          children: [
            children,
            isActive && /* @__PURE__ */ jsxRuntimeExports.jsx(
              SyntaxIcon,
              {
                icon: w$4,
                className: "shrink-0"
              }
            )
          ]
        }
      )
    }
  );
};
LinkItem.displayName = "DropdownMenu.LinkItem";
const usePositioningStrategy = ({
  displayMode,
  fullscreenBreakpoint
}) => {
  const { smallerOrEqual } = useViewport();
  const isFullscreenBreakpoint = smallerOrEqual(fullscreenBreakpoint);
  const shouldUseFullscreen = isFullscreenBreakpoint && displayMode === "mobile-fullscreen";
  return {
    positioningStrategy: shouldUseFullscreen ? "fullscreen" : "default"
  };
};
const _InternalMenuContent = ({
  open,
  close,
  children,
  placement,
  displayMode = "default",
  fullscreenBreakpoint = "mobile",
  matchButtonWidth
}) => {
  const { positioningStrategy: dropdownPositioningStrategy } = usePositioningStrategy({
    displayMode,
    fullscreenBreakpoint
  });
  const floatingDropdownProps = useFloatingDropdown({
    isOpen: open,
    options: { placement: placement ?? "bottom-start" },
    positioningStrategy: dropdownPositioningStrategy,
    config: { matchReferenceWidth: matchButtonWidth }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DropdownMenuProvider,
    {
      ...floatingDropdownProps,
      open,
      positioningStrategy: dropdownPositioningStrategy,
      children: typeof children === "function" ? children({ open, close }) : children
    }
  );
};
const SelectionGroupContext = createContext(null);
const useSelectionGroupContext = () => {
  const context = useContext(SelectionGroupContext);
  if (!context) {
    throw new Error("useSelectionGroupContext must be used within a SelectionGroup");
  }
  return context;
};
const SelectionGroupProvider = ({ variant, children }) => {
  const value = a__default.useMemo(() => ({ variant }), [variant]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SelectionGroupContext.Provider, { value, children });
};
const SelectionGroup = ({
  variant = "default",
  children,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(SelectionGroupProvider, { variant, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  it,
  {
    ...props,
    className: "group",
    children
  }
) });
const DefaultSelectionItem = ({
  checked,
  children,
  ...props
}) => {
  if (props.variant !== "default") {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    MenuItem,
    {
      className: "first:rounded-t-none last:rounded-b-none hui-checked:bg-orchid-50",
      ...props,
      children: [
        children,
        !props.hideCheckmark && checked && /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: w$4 })
      ]
    }
  );
};
const ComponentVariantMap = {
  default: DefaultSelectionItem
};
const SelectionItem = ({ className, children, ...props }) => {
  const { variant } = useSelectionGroupContext();
  const Component2 = ComponentVariantMap[variant];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    it.Option,
    {
      ...props,
      className: twMerge("first:rounded-t-sm last:rounded-b-sm", className),
      children: ({ checked }) => {
        const componentProps = {
          ...props,
          variant,
          checked,
          children
        };
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...componentProps });
      }
    }
  );
};
const DropdownMenuBase = ({
  placement,
  displayMode,
  fullscreenBreakpoint,
  matchButtonWidth,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(qe$1, { ...props, children: (renderProps) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    _InternalMenuContent,
    {
      ...renderProps,
      placement,
      displayMode,
      fullscreenBreakpoint,
      matchButtonWidth,
      children
    }
  ) });
};
DropdownMenuBase.displayName = "DropdownMenu";
const DropdownMenu = Object.assign(DropdownMenuBase, {
  Button: MenuButton$1,
  Item: MenuItem,
  ItemLabel: MenuItemLabel,
  Items: MenuItems,
  SectionTitle,
  LinkItem,
  SelectionGroup,
  SelectionItem
});
const SvgExpressableLogo = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { width: 908, height: 140, viewBox: "0 0 908 140", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("g", { clipPath: "url(#clip0_59_22208)" }, /* @__PURE__ */ a$z.createElement("path", { d: "M186.363 25.4941H162.489L146.092 50.9006L129.694 25.4941H105.359L133.924 69.6664L105.508 113.542H129.694L145.943 88.2987L162.191 113.542H186.527L158.111 69.5181L186.363 25.4941Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M260.695 29.4958C254.798 25.6315 247.872 23.6171 240.813 23.7143C236.001 23.6954 231.256 24.8377 226.984 27.0422C222.712 29.2468 219.041 32.4481 216.283 36.3731L215.211 25.4933H196.877V140H217.579V104.322C219.94 107.218 222.818 109.655 226.068 111.51C230.551 114.08 235.639 115.421 240.813 115.394C247.834 115.495 254.726 113.507 260.606 109.687C266.566 105.663 271.272 100.055 274.189 93.5006C277.398 85.9471 279.051 77.8294 279.051 69.6284C279.051 61.4273 277.398 53.3096 274.189 45.7561C271.309 39.1856 266.634 33.552 260.695 29.4958V29.4958ZM258.387 69.5176C258.387 77.7592 256.421 84.3406 252.563 89.2173C250.812 91.5134 248.534 93.3582 245.92 94.5986C243.306 95.839 240.431 96.4383 237.536 96.3465C234.734 96.4137 231.958 95.7931 229.454 94.5392C226.95 93.2854 224.795 91.4375 223.179 89.158C219.456 84.296 217.579 77.685 217.579 69.5176C217.579 61.3502 219.456 54.5904 223.179 49.7137C224.796 47.436 226.951 45.5903 229.456 44.339C231.96 43.0877 234.735 42.4695 237.536 42.5397C240.437 42.451 243.316 43.0581 245.931 44.3093C248.547 45.5605 250.821 47.4192 252.563 49.7289C256.421 54.6056 258.387 61.2613 258.387 69.5176Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M333.792 24.8597C328.328 25.6813 322.956 27.0265 317.752 28.8766C315.12 29.9278 312.695 31.4332 310.588 33.3235C310.282 33.6079 309.999 33.9153 309.74 34.2427C309.576 34.4651 309.025 35.0431 309.025 35.3248L308.057 25.5415H289.872V113.59H310.574V67.4907C310.501 63.6109 311.044 59.7441 312.182 56.0327C312.84 54.2968 313.855 52.7168 315.161 51.3933C316.248 50.1607 317.531 49.1137 318.958 48.2948C321.022 47.2734 323.225 46.5597 325.497 46.1756L342.698 42.5878L339.72 23.7632" }), /* @__PURE__ */ a$z.createElement("path", { d: "M494.043 63.2915C488.689 61.445 483.216 59.9594 477.661 58.8446C472.78 58.053 468.014 56.6743 463.467 54.7387C462.258 54.2398 461.232 53.3844 460.526 52.2872C459.821 51.19 459.47 49.9035 459.521 48.6018C459.519 47.4637 459.815 46.345 460.379 45.3549C460.943 44.3649 461.756 43.5373 462.738 42.9542C465.476 41.2659 468.665 40.4444 471.882 40.5976C475.802 40.5202 479.635 41.7516 482.769 44.0956C485.84 46.4448 488.006 49.7737 488.905 53.5234L489.203 54.6945L509.919 51.6554L509.696 50.307C508.864 45.1486 506.558 40.3374 503.054 36.4474C499.355 32.3527 494.772 29.1447 489.65 27.0644C484.252 24.8096 478.451 23.665 472.597 23.6996C466.599 23.5968 460.644 24.7163 455.097 26.9899C450.225 28.9639 446.005 32.2553 442.915 36.4916C439.967 40.5804 438.402 45.4968 438.447 50.5292C438.447 56.7548 439.936 61.7205 443.004 65.3521C445.852 68.7919 449.576 71.4075 453.787 72.9264C458.856 74.6663 464.041 76.0483 469.306 77.062C473.997 78.0255 477.735 78.9446 480.431 79.7747C482.785 80.458 484.951 81.6695 486.761 83.3169C487.548 84.0847 488.162 85.011 488.563 86.0332C488.964 87.0554 489.141 88.1503 489.084 89.246C489.103 90.5112 488.802 91.7611 488.208 92.8801C487.615 93.9991 486.748 94.9516 485.688 95.65C482.818 97.5408 479.415 98.4653 475.978 98.2882C471.592 98.3359 467.318 96.9164 463.84 94.2567C460.271 91.4946 457.806 87.559 456.885 83.154L456.602 81.9982L436.019 84.5328L436.242 85.8964C437.124 91.5473 439.51 96.8599 443.153 101.282C446.888 105.793 451.652 109.351 457.048 111.658C462.787 114.131 468.981 115.383 475.233 115.334C481.367 115.429 487.453 114.252 493.105 111.881C498.121 109.807 502.465 106.396 505.66 102.024C508.68 97.7696 510.275 92.6761 510.217 87.4677C510.217 80.753 508.594 75.387 505.377 71.5034C502.402 67.8093 498.489 64.9741 494.043 63.2915V63.2915Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M575.853 63.2915C570.498 61.445 565.025 59.9594 559.47 58.8446C554.589 58.053 549.823 56.6743 545.277 54.7387C544.068 54.2398 543.041 53.3844 542.336 52.2872C541.63 51.19 541.279 49.9035 541.33 48.6018C541.329 47.4637 541.624 46.345 542.188 45.3549C542.752 44.3649 543.565 43.5373 544.547 42.9542C547.286 41.2659 550.474 40.4444 553.692 40.5976C557.611 40.5202 561.444 41.7516 564.579 44.0956C567.65 46.4448 569.816 49.7737 570.715 53.5234L571.012 54.6945L591.729 51.6554L591.506 50.307C590.673 45.1486 588.368 40.3374 584.863 36.4474C581.164 32.3527 576.582 29.1447 571.459 27.0644C566.061 24.8096 560.261 23.665 554.406 23.6996C548.409 23.5968 542.453 24.7163 536.907 26.9899C532.032 28.9597 527.812 32.252 524.724 36.4916C521.776 40.5804 520.211 45.4968 520.256 50.5292C520.256 56.7548 521.745 61.7205 524.813 65.3521C527.662 68.7919 531.386 71.4075 535.596 72.9264C540.665 74.6663 545.851 76.0483 551.115 77.062C555.806 78.0255 559.545 78.9446 562.24 79.7747C564.592 80.4547 566.753 81.6667 568.555 83.3169C569.348 84.0817 569.966 85.0069 570.37 86.0296C570.773 87.0523 570.952 88.1489 570.893 89.246C570.912 90.5112 570.611 91.7611 570.018 92.8801C569.424 93.9991 568.558 94.9516 567.498 95.65C564.628 97.5408 561.224 98.4653 557.787 98.2882C553.402 98.3359 549.127 96.9164 545.649 94.2567C542.081 91.4946 539.615 87.559 538.694 83.154L538.411 81.9982L517.829 84.5328L518.037 85.8964C518.931 91.5465 521.321 96.8574 524.963 101.282C528.698 105.793 533.462 109.351 538.858 111.658C544.596 114.131 550.79 115.383 557.043 115.334C563.176 115.429 569.262 114.252 574.915 111.881C579.931 109.807 584.275 106.396 587.47 102.024C590.49 97.7696 592.084 92.6761 592.027 87.4677C592.027 80.753 590.404 75.387 587.187 71.5034C584.212 67.8093 580.299 64.9741 575.853 63.2915V63.2915Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M663.829 36.3731C661.057 32.4273 657.362 29.213 653.062 27.0075C648.762 24.8019 643.987 23.6714 639.15 23.7143C632.091 23.6171 625.165 25.6315 619.268 29.4958C613.309 33.5174 608.607 39.1266 605.7 45.6823C602.491 53.2358 600.837 61.3534 600.837 69.5545C600.837 77.7556 602.491 85.8733 605.7 93.4268C608.617 99.981 613.323 105.589 619.283 109.613C625.162 113.435 632.055 115.423 639.076 115.32C644.607 115.364 650.037 113.854 654.744 110.962C658.278 108.792 661.32 105.914 663.68 102.513L664.752 113.541H683.101V25.4933H664.767L663.829 36.3731ZM662.533 69.5176C662.533 77.774 660.656 84.3402 656.933 89.2318C655.284 91.5075 653.099 93.3459 650.57 94.5863C648.041 95.8267 645.245 96.431 642.427 96.3465C639.551 96.439 636.695 95.8392 634.103 94.5979C631.51 93.3565 629.256 91.5112 627.534 89.2173C623.721 84.3999 621.785 77.7592 621.785 69.5176C621.785 61.2761 623.751 54.6056 627.608 49.7289C629.324 47.4242 631.575 45.5669 634.168 44.3151C636.761 43.0633 639.621 42.4539 642.501 42.5397C645.324 42.4565 648.123 43.0679 650.65 44.3194C653.178 45.5709 655.357 47.4235 656.993 49.7137C660.641 54.5904 662.533 61.2613 662.533 69.5176Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M761.573 29.4978C755.676 25.6335 748.75 23.6191 741.69 23.7163C736.517 23.6896 731.429 25.0299 726.946 27.6C723.695 29.4549 720.817 31.8924 718.457 34.7893V0H697.755V113.543H716.104L717.161 102.663C719.521 106.044 722.565 108.896 726.097 111.038C730.789 113.891 736.192 115.376 741.69 115.322C748.716 115.422 755.612 113.435 761.498 109.615C767.45 105.582 772.153 99.9762 775.081 93.4288C778.28 85.8728 779.929 77.7561 779.929 69.5565C779.929 61.3569 778.28 53.2403 775.081 45.6843C772.189 39.1369 767.509 33.5289 761.573 29.4978V29.4978ZM759.264 69.5196C759.264 77.7611 757.313 84.3426 753.456 89.2193C751.702 91.5156 749.421 93.361 746.804 94.6013C744.187 95.8416 741.311 96.4402 738.414 96.3485C735.613 96.4171 732.839 95.7974 730.337 94.5434C727.835 93.2893 725.683 91.4402 724.071 89.1599C720.348 84.298 718.457 77.687 718.457 69.5196C718.457 61.3522 720.348 54.5924 724.071 49.7157C725.684 47.4372 727.837 45.5903 730.339 44.3388C732.841 43.0872 735.614 42.47 738.414 42.5416C741.314 42.4504 744.195 43.0563 746.81 44.3076C749.426 45.559 751.701 47.4193 753.441 49.7309C757.313 54.6076 759.264 61.2632 759.264 69.5196V69.5196Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M42.4342 45.8027V19.1215H95.0075V0H21.1368V113.543H95.0075V94.4218H42.4342V65.0725V45.8027Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M91.6909 39.9305L0 58.8906L3.94042 77.7571L95.6313 58.797L91.6909 39.9305Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M813.267 0H792.565V113.543H813.267V0Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M408.168 82.3993C407.324 86.4913 404.983 90.1255 401.6 92.5973C397.94 95.1578 393.546 96.4729 389.074 96.3471C383.117 96.3471 377.16 94.3761 373.317 89.7514C371.61 87.6071 370.418 85.1024 369.832 82.429L426.278 70.8073C426.856 68.1344 427.116 65.4034 427.052 62.6699C426.979 56.0033 425.315 49.4496 422.197 43.5485C419.049 37.6045 414.326 32.6316 408.54 29.17C402.15 25.4376 394.843 23.5486 387.436 23.7149C379.779 23.5937 372.252 25.7013 365.781 29.778C359.449 33.845 354.363 39.5676 351.082 46.3199C347.56 53.5449 345.78 61.4886 345.884 69.5183C345.785 77.569 347.618 85.5264 351.231 92.7304C354.672 99.5384 359.947 105.26 366.466 109.258C373.865 113.509 382.317 115.6 390.854 115.29C399.391 114.981 407.667 112.284 414.736 107.509C418.276 104.986 421.282 101.793 423.582 98.1124C425.882 94.4321 427.431 90.3365 428.14 86.0601L428.378 84.7414L408.525 81.1689L408.168 82.3993ZM366.585 64.4931C365.454 56.5629 371.232 48.8254 374.419 46.4241C378.038 43.6967 383.489 42.5403 388.33 42.5403C392.699 42.4071 396.957 43.9274 400.244 46.7947C403.078 49.2954 404.904 52.7344 405.383 56.4737L366.585 64.4931Z" }), /* @__PURE__ */ a$z.createElement("path", { d: "M887.854 82.3995C887.01 86.4915 884.669 90.1256 881.286 92.5974C877.628 95.1619 873.233 96.4773 868.76 96.3473C862.803 96.3473 856.771 94.3763 853.003 89.7516C851.303 87.6029 850.111 85.0999 849.518 82.4291L905.964 70.8075C906.549 68.1356 906.809 65.4038 906.738 62.6701C906.67 56.0046 905.011 49.4509 901.898 43.5487C898.745 37.6036 894.017 32.6309 888.226 29.1702C881.837 25.4363 874.529 23.5472 867.122 23.7151C859.465 23.5939 851.938 25.7015 845.467 29.7782C839.135 33.8452 834.049 39.5678 830.768 46.32C827.246 53.5451 825.466 61.4887 825.57 69.5185C825.468 77.5712 827.307 85.5306 830.932 92.7306C834.373 99.5386 839.648 105.261 846.167 109.258C853.563 113.509 862.012 115.6 870.547 115.291C879.082 114.981 887.356 112.285 894.422 107.509C897.962 104.986 900.967 101.792 903.267 98.1119C905.567 94.4317 907.116 90.3364 907.826 86.0603L908.064 84.7416L888.211 81.1691L887.854 82.3995ZM846.272 64.4933C845.14 56.563 850.918 48.8256 854.106 46.4243C857.725 43.6969 863.175 42.5405 868.016 42.5405C872.385 42.4102 876.641 43.9302 879.93 46.7948C882.755 49.3013 884.574 52.7383 885.054 56.4739L846.272 64.4933Z" })), /* @__PURE__ */ a$z.createElement("defs", null, /* @__PURE__ */ a$z.createElement("clipPath", { id: "clip0_59_22208" }, /* @__PURE__ */ a$z.createElement("rect", { width: 908, height: 140 }))));
const ExpressableLogo = ({ className, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SvgExpressableLogo,
    {
      ...props,
      className: twMerge("h-e26 w-auto fill-current text-black", className),
      title: "Expressable"
    }
  );
};
const SvgCueLogo = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { width: 48, height: 24, viewBox: "0 0 48 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("path", { d: "M15.5616 13.3495C15.3365 14.4261 14.8164 15.2966 14.0157 15.9371C13.2151 16.5776 12.2612 16.9002 11.1768 16.9002C10.1854 16.9002 9.29022 16.6591 8.51404 16.1815C7.73787 15.7039 7.12476 15.0299 6.69265 14.1769C6.25727 13.3176 6.03714 12.3193 6.03714 11.2092C6.03714 10.0991 6.25401 9.12158 6.68286 8.26225C7.10845 7.40932 7.70689 6.73527 8.46186 6.25769C9.21358 5.78171 10.068 5.54052 10.9991 5.54052C12.0215 5.54052 12.9118 5.8456 13.6456 6.44777C14.381 7.05153 14.8685 7.85495 15.0936 8.83407L15.1458 9.05929L18.451 8.44754L18.4102 8.21434C18.2097 7.08507 17.758 6.08039 17.065 5.22905C16.3736 4.37931 15.5061 3.71166 14.487 3.24685C13.4679 2.78205 12.3541 2.54565 11.1785 2.54565C9.56253 2.54565 8.09008 2.92101 6.80027 3.66214C5.50882 4.40327 4.48643 5.44309 3.7608 6.75284C3.03681 8.0594 2.66992 9.55923 2.66992 11.2108C2.66992 12.8624 3.04007 14.367 3.77222 15.6799C4.50436 16.9961 5.52676 18.0423 6.81005 18.7898C8.09335 19.5373 9.56253 19.9175 11.1801 19.9175C12.4618 19.9175 13.6635 19.6507 14.7511 19.1268C15.8388 18.6013 16.7535 17.8602 17.4743 16.9226C18.1934 15.985 18.6679 14.9021 18.8815 13.7025L18.9271 13.447L15.6072 13.1403L15.5632 13.3511L15.5616 13.3495Z", fill: "black" }), /* @__PURE__ */ a$z.createElement("path", { d: "M28.6451 13.9677C28.6451 14.8558 28.4038 15.6001 27.9277 16.1815C27.4581 16.7549 26.8384 17.0328 26.0296 17.0328C25.273 17.0328 24.6876 16.8124 24.2392 16.362C23.7957 15.9147 23.5707 15.279 23.5707 14.4724V6.57395H20.3779V15.0187C20.3779 16.0026 20.5834 16.8731 20.9878 17.6046C21.3954 18.3426 21.9776 18.9192 22.7146 19.3201C23.4484 19.7178 24.2996 19.9191 25.2453 19.9191C26.1226 19.9191 26.9151 19.7003 27.5999 19.269C28.0858 18.9623 28.5049 18.563 28.8539 18.0758L29.0234 19.6571H31.833V6.57236H28.6402V13.9677H28.6451Z", fill: "black" }), /* @__PURE__ */ a$z.createElement("path", { d: "M42.9555 15.0059C42.8283 15.6129 42.4761 16.1511 41.9657 16.5185C41.4146 16.8987 40.7526 17.0935 40.0791 17.0744C39.1823 17.0744 38.2724 16.7821 37.7049 16.0968C37.4489 15.7774 37.2696 15.4068 37.1799 15.0107L45.6835 13.2873C45.7716 12.8911 45.8107 12.4854 45.8009 12.0797C45.7912 11.091 45.54 10.1183 45.0721 9.24299C44.5975 8.3613 43.885 7.62336 43.0126 7.11064C42.0505 6.55639 40.9482 6.27687 39.8329 6.30083C38.6784 6.28326 37.5451 6.59472 36.57 7.20009C35.6161 7.80385 34.8497 8.652 34.3557 9.65348C33.8257 10.7252 33.5567 11.9024 33.573 13.094C33.5583 14.2887 33.8339 15.4691 34.3801 16.5361C34.8987 17.5456 35.6928 18.3953 36.676 18.9879C37.7897 19.6188 39.0632 19.9287 40.3498 19.8823C41.6364 19.836 42.8821 19.4367 43.9469 18.7275C44.4801 18.3538 44.9335 17.8794 45.2791 17.3331C45.6248 16.7869 45.8596 16.1799 45.9656 15.5458L46.0015 15.3509L43.011 14.8206L42.9572 15.0027L42.9555 15.0059ZM36.6907 12.3497C36.5195 11.1741 37.3902 10.0256 37.8713 9.66945C38.4159 9.26535 39.2377 9.09284 39.9666 9.09284C40.6254 9.07368 41.2662 9.29889 41.7619 9.72376C42.1875 10.0959 42.4614 10.6054 42.5332 11.1597L36.6907 12.3497Z", fill: "black" }));
const CueLogo = ({ className, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SvgCueLogo,
    {
      ...props,
      className: twMerge("h-e26 w-auto fill-current text-black", className),
      title: "Cue"
    }
  );
};
const useFieldErrors = (fieldName, formErrors) => {
  const fieldErrors = get$1(formErrors, fieldName);
  const errorMessages = useMemo(() => {
    const errorMessages2 = [];
    if (isArray$1(fieldErrors)) {
      fieldErrors.filter((f2) => !isUndefined(f2)).map((e3) => {
        if (!e3) {
          return;
        }
        const error2 = Object.values(e3)[0];
        const message2 = get$1(error2, "message");
        if (isString(message2)) {
          errorMessages2.push(message2);
        }
      });
    } else if (isObject(fieldErrors)) {
      const message2 = get$1(fieldErrors, "message");
      if (isString(message2)) {
        errorMessages2.push(message2);
      }
    }
    if (!errorMessages2.length) {
      return null;
    }
    return errorMessages2;
  }, [fieldErrors]);
  return errorMessages;
};
const FieldErrors = ({
  displayAllErrors = false,
  className,
  "data-testid": dataTestID,
  ...props
}) => {
  const errors2 = props.errorMessages;
  if (!errors2 || isEmpty(errors2)) {
    return null;
  }
  if (displayAllErrors) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: errors2.map((error2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      ErrorText,
      {
        className,
        "data-testid": `${dataTestID}-${index2}`,
        children: error2
      },
      `${error2}-${index2}`
    )) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ErrorText,
    {
      className,
      "data-testid": dataTestID,
      children: errors2[0]
    }
  );
};
const ErrorText = ({ children, className, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      variant: "error",
      className,
      ...rest,
      children
    }
  );
};
const FieldHints = ({ hint, className, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      variant: "hint",
      className,
      ...rest,
      children: hint
    }
  );
};
const FieldLabel = ({
  label,
  disabled,
  viewMode,
  error: error2,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      variant: "label",
      as: "label",
      className: twMerge(
        clsx(
          "text-warm-gray-900",
          {
            "text-warm-gray-600": disabled || viewMode,
            "text-utility-error": !disabled && error2
          },
          className
        )
      ),
      ...rest,
      children: label
    }
  );
};
const ViewModeText = ({ className, children, error: error2, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paragraph,
    {
      noDefaultMargins: true,
      className: twMerge(
        "cursor-default text-warm-gray-900",
        clsx({
          "text-utility-error": error2
        }),
        className
      ),
      ...props,
      children
    }
  );
};
const toKebabCase = (str) => {
  return str ? kebabCase(str) : str;
};
const INPUT_TEST_IDS_CONFIG = {
  BASE: "input"
};
const useInputDataTestIds = ({
  name,
  "data-testid": dataTestId,
  componentIdConfig = INPUT_TEST_IDS_CONFIG
}) => {
  const parsedConfig = useMemo(() => {
    return dataTestId ? { ...componentIdConfig, BASE: "" } : componentIdConfig;
  }, [dataTestId, componentIdConfig]);
  return useDataTestIds({
    componentConfig: parsedConfig,
    ids: {
      "data-testid": dataTestId || toKebabCase(name)
    }
  });
};
const DefaultViewModeText = ({
  value,
  defaultValue,
  viewModePlaceholder,
  inputRef,
  name
}) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  const rawValue = value ?? defaultValue ?? inputRef?.current?.value;
  const displayValue = rawValue || viewModePlaceholder;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: displayValue });
};
const ViewModeContext = createContext(void 0);
const ViewModeProvider = ({ children, viewMode }) => {
  const contextValue = useMemo(
    () => ({
      viewMode
    }),
    [viewMode]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeContext.Provider, { value: contextValue, children });
};
const useViewModeContext = () => {
  const context = useContext(ViewModeContext);
  if (context === void 0) {
    return {};
  }
  return context;
};
const DEFAULT_VIEW_MODE_TEXT = "--";
const withViewMode = (Component2, options = {}) => {
  const { viewModeComponent: ViewModeComponent2 = DefaultViewModeText, ...restOptions } = options;
  return forwardRef(
    (props, ref) => {
      const { viewMode, viewModePlaceholder = DEFAULT_VIEW_MODE_TEXT } = props;
      const { viewMode: contextViewMode } = useViewModeContext();
      const inputRef = useRef(null);
      useImperativeHandle(ref, () => inputRef.current);
      if (viewMode || contextViewMode) {
        if (isString(props.name)) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ControllerWrapper,
            {
              ...props,
              ...restOptions,
              name: props.name,
              componentProps: { inputRef, viewModePlaceholder, ...props },
              Component: ViewModeComponent2
            }
          );
        } else {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ViewModeComponent2,
            {
              ...props,
              viewModePlaceholder,
              inputRef
            }
          );
        }
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Component2,
        {
          ...props,
          ref: inputRef
        }
      );
    }
  );
};
const ControllerWrapper = forwardRef(
  ({ name, componentProps, Component: Component2, options }, ref) => {
    const value = useWatch({ name });
    const resolvedValue = options?.preventValueWatch ? componentProps.value : value;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...componentProps,
        ref,
        value: resolvedValue,
        name
      }
    );
  }
);
const FORM_FIELD_TEST_IDS_CONFIG = {
  BASE: "form-field",
  CONTAINER: "container",
  LABEL: "label",
  HINT: "hint",
  ERROR: "error"
};
const DEFAULT_FIELD_CONFIG = {
  order: {
    error: "bottom",
    hint: "bottom"
  },
  labelSpacing: "sm",
  viewModeLabelSpacing: "sm"
};
const labelSpacingClassNameMap = {
  sm: "gap-e8",
  lg: "gap-e16"
};
const _FormFieldInternal = ({
  className,
  label,
  hint,
  displayAllErrors,
  error: error2,
  errorMessages,
  disabled,
  viewMode,
  config: configProp,
  children,
  name,
  "data-testid": dataTestID
}) => {
  const testIds = useDataTestIds({
    componentConfig: FORM_FIELD_TEST_IDS_CONFIG,
    ids: {
      "data-testid": dataTestID || toKebabCase(name)
    }
  });
  const { labelSpacing, order: order2, viewModeLabelSpacing } = useMemo(
    () => merge({}, DEFAULT_FIELD_CONFIG, configProp),
    [configProp]
  );
  const isError = error2 || errorMessages && errorMessages?.length > 0;
  const hintBlock = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: hint && /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldHints,
      {
        hint,
        ...testIds.HINT
      }
    ) }),
    [hint, testIds]
  );
  const errorBlock = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: !disabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldErrors,
      {
        displayAllErrors,
        errorMessages,
        ...testIds.ERROR
      }
    ) }),
    [displayAllErrors, errorMessages, disabled, testIds]
  );
  const labelSpacingClassName = clsx(
    // Default spacing
    labelSpacingClassNameMap[labelSpacing],
    {
      // View mode spacing
      [labelSpacingClassNameMap[viewModeLabelSpacing]]: viewMode
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: twMerge(
        clsx(
          labelSpacingClassName,
          "flex flex-col",
          "w-full",
          {
            "after-blank": viewMode
          },
          className
        )
      ),
      ...testIds.CONTAINER,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            "data-field-section": "label",
            className: clsx("flex flex-col gap-e8"),
            children: [
              label && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FieldLabel,
                {
                  label,
                  disabled,
                  viewMode,
                  error: isError,
                  ...testIds.LABEL
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col gap-e4 empty:hidden", children: [
                order2.hint === "top" && hintBlock,
                order2.error === "top" && errorBlock
              ] })
            ]
          }
        ),
        children,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            "data-field-section": "bottom-hint",
            className: "flex flex-col gap-e4 empty:hidden",
            children: [
              order2.hint === "bottom" && hintBlock,
              order2.error === "bottom" && errorBlock
            ]
          }
        )
      ]
    }
  );
};
const FormField = (props) => {
  if (props.name) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      WithRHF,
      {
        ...props,
        name: props.name
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(_FormFieldInternal, { ...props });
};
const WithRHF = (props) => {
  const { disabled, errors: errors2 } = useFormState();
  const { viewMode } = useViewModeContext();
  const errorMessages = useFieldErrors(props.name, errors2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    _FormFieldInternal,
    {
      disabled,
      errorMessages: errorMessages ?? void 0,
      viewMode,
      ...props
    }
  );
};
const onPreventDefaultEvent = (e3) => {
  e3.preventDefault?.();
};
const onPreventDefaultEventVanilla = (e3) => {
  e3.preventDefault?.();
};
const animationClassName = "animate-spin-step animate-spin";
const containerClassName$8 = clsx(
  "flex h-full items-center justify-center gap-e8",
  "text-warm-gray-600"
);
const overlayClassName$1 = clsx("absolute inset-0 rounded-[inherit] bg-white bg-opacity-50");
const LoadingSpinner = ({
  size: size2 = "lg",
  message: message2,
  overlay,
  className,
  iconClassName: iconClassName2,
  ...rest
}) => {
  const classNameMerged = twMerge(
    clsx(containerClassName$8, { [overlayClassName$1]: overlay }, className)
  );
  const iconClassNameMerged = twMerge(clsx(animationClassName, iconClassName2));
  const testIds = useDataTestIds({
    componentConfig: {
      MESSAGE: "message"
    },
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classNameMerged,
      ...rest,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SyntaxIcon,
          {
            icon: I$1,
            weight: "regular",
            className: iconClassNameMerged,
            size: size2
          }
        ),
        message2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Heading,
          {
            level: "h6",
            noDefaultMargins: true,
            ...testIds.MESSAGE,
            children: message2
          }
        )
      ]
    }
  );
};
const defaultStatusHints = {
  inProgress: "Uploading",
  success: "Upload successful!",
  failed: "Upload failed unexpectedly."
};
const TEST_IDS_CONFIG$g = {
  BASE: "",
  FILE_NAME: "file-name",
  STATUS_TEXT: "status-text",
  RETRY_BUTTON: "retry-button",
  REMOVE_BUTTON: "remove-button"
};
const FileStatus = ({
  name,
  uploadStatus,
  statusHints,
  retryButtonText = "Retry",
  onCancel,
  onRetryFileUpload,
  ...rest
}) => {
  const [uploadProgress, setUploadProgress] = useState(null);
  const progressSubscription = useRef(null);
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$g,
    ids: rest
  });
  const status = isString(uploadStatus) ? uploadStatus : uploadStatus?.status;
  const hint = status && (statusHints?.[status] || defaultStatusHints[status]);
  const progressPercentage = useMemo(
    () => status === "inProgress" && uploadProgress ? ` (${uploadProgress}%)` : "",
    [status, uploadProgress]
  );
  useEffect(() => {
    if (typeof uploadStatus === "object") {
      if (uploadStatus.progressSubject && isNull(progressSubscription.current)) {
        progressSubscription.current = uploadStatus.progressSubject.asObservable().subscribe((p2) => {
          setUploadProgress(p2);
        });
      }
    }
    return () => {
      progressSubscription.current?.unsubscribe();
    };
  }, [uploadStatus]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "li",
    {
      className: clsx(
        "flex w-full items-center gap-e8 rounded-sm p-e16 pr-e8",
        "mobile-d:gap-e16",
        {
          "bg-warm-gray-4%": status === "inProgress",
          "bg-white": status !== "inProgress",
          "border border-warm-gray-300": !status || status === "inProgress" || status === "success",
          "border border-utility-error": status === "failed",
          "hover:border-warm-gray-500": status === "success"
        }
      ),
      ...testIds.BASE,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex grow flex-col gap-e8 self-stretch overflow-hidden", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: clsx("flex gap-e8", {
                "text-warm-gray-600": status === "inProgress",
                "text-warm-gray-900": !status || status === "success",
                "text-utility-error": status === "failed"
              }),
              children: [
                status === "inProgress" ? /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSpinner, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SyntaxIcon,
                  {
                    size: "lg",
                    icon: P$2
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Heading,
                  {
                    level: "h6",
                    noDefaultMargins: true,
                    breakWords: true,
                    ...testIds.FILE_NAME,
                    children: name
                  }
                )
              ]
            }
          ),
          status && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Text,
            {
              variant: status === "failed" ? "error" : "hint",
              ...testIds.STATUS_TEXT,
              children: `${hint}${progressPercentage}`
            }
          )
        ] }),
        status === "failed" && onRetryFileUpload && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            variant: "ghost",
            size: "xs",
            onClick: () => onRetryFileUpload(name),
            ...testIds.RETRY_BUTTON,
            children: retryButtonText
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            iconOnly: true,
            variant: "ghost",
            size: "sm",
            onClick: () => onCancel?.(name),
            className: "shrink-0",
            ...testIds.REMOVE_BUTTON,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: R$1 })
          }
        )
      ]
    }
  );
};
const require$$0 = {
  "application/1d-interleaved-parityfec": {
    source: "iana"
  },
  "application/3gpdash-qoe-report+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/3gpp-ims+xml": {
    source: "iana",
    compressible: true
  },
  "application/3gpphal+json": {
    source: "iana",
    compressible: true
  },
  "application/3gpphalforms+json": {
    source: "iana",
    compressible: true
  },
  "application/a2l": {
    source: "iana"
  },
  "application/ace+cbor": {
    source: "iana"
  },
  "application/ace+json": {
    source: "iana",
    compressible: true
  },
  "application/ace-groupcomm+cbor": {
    source: "iana"
  },
  "application/activemessage": {
    source: "iana"
  },
  "application/activity+json": {
    source: "iana",
    compressible: true
  },
  "application/aif+cbor": {
    source: "iana"
  },
  "application/aif+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-cdni+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-cdnifilter+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-costmap+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-costmapfilter+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-directory+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointcost+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointcostparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointprop+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointpropparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-error+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-networkmap+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-networkmapfilter+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-propmap+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-propmapparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-tips+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-tipsparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-updatestreamcontrol+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-updatestreamparams+json": {
    source: "iana",
    compressible: true
  },
  "application/aml": {
    source: "iana"
  },
  "application/andrew-inset": {
    source: "iana",
    extensions: [
      "ez"
    ]
  },
  "application/appinstaller": {
    compressible: false,
    extensions: [
      "appinstaller"
    ]
  },
  "application/applefile": {
    source: "iana"
  },
  "application/applixware": {
    source: "apache",
    extensions: [
      "aw"
    ]
  },
  "application/appx": {
    compressible: false,
    extensions: [
      "appx"
    ]
  },
  "application/appxbundle": {
    compressible: false,
    extensions: [
      "appxbundle"
    ]
  },
  "application/at+jwt": {
    source: "iana"
  },
  "application/atf": {
    source: "iana"
  },
  "application/atfx": {
    source: "iana"
  },
  "application/atom+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atom"
    ]
  },
  "application/atomcat+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomcat"
    ]
  },
  "application/atomdeleted+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomdeleted"
    ]
  },
  "application/atomicmail": {
    source: "iana"
  },
  "application/atomsvc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomsvc"
    ]
  },
  "application/atsc-dwd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dwd"
    ]
  },
  "application/atsc-dynamic-event-message": {
    source: "iana"
  },
  "application/atsc-held+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "held"
    ]
  },
  "application/atsc-rdt+json": {
    source: "iana",
    compressible: true
  },
  "application/atsc-rsat+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rsat"
    ]
  },
  "application/atxml": {
    source: "iana"
  },
  "application/auth-policy+xml": {
    source: "iana",
    compressible: true
  },
  "application/automationml-aml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "aml"
    ]
  },
  "application/automationml-amlx+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "amlx"
    ]
  },
  "application/bacnet-xdd+zip": {
    source: "iana",
    compressible: false
  },
  "application/batch-smtp": {
    source: "iana"
  },
  "application/bdoc": {
    compressible: false,
    extensions: [
      "bdoc"
    ]
  },
  "application/beep+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/bufr": {
    source: "iana"
  },
  "application/c2pa": {
    source: "iana"
  },
  "application/calendar+json": {
    source: "iana",
    compressible: true
  },
  "application/calendar+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xcs"
    ]
  },
  "application/call-completion": {
    source: "iana"
  },
  "application/cals-1840": {
    source: "iana"
  },
  "application/captive+json": {
    source: "iana",
    compressible: true
  },
  "application/cbor": {
    source: "iana"
  },
  "application/cbor-seq": {
    source: "iana"
  },
  "application/cccex": {
    source: "iana"
  },
  "application/ccmp+xml": {
    source: "iana",
    compressible: true
  },
  "application/ccxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ccxml"
    ]
  },
  "application/cda+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/cdfx+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cdfx"
    ]
  },
  "application/cdmi-capability": {
    source: "iana",
    extensions: [
      "cdmia"
    ]
  },
  "application/cdmi-container": {
    source: "iana",
    extensions: [
      "cdmic"
    ]
  },
  "application/cdmi-domain": {
    source: "iana",
    extensions: [
      "cdmid"
    ]
  },
  "application/cdmi-object": {
    source: "iana",
    extensions: [
      "cdmio"
    ]
  },
  "application/cdmi-queue": {
    source: "iana",
    extensions: [
      "cdmiq"
    ]
  },
  "application/cdni": {
    source: "iana"
  },
  "application/cea": {
    source: "iana"
  },
  "application/cea-2018+xml": {
    source: "iana",
    compressible: true
  },
  "application/cellml+xml": {
    source: "iana",
    compressible: true
  },
  "application/cfw": {
    source: "iana"
  },
  "application/cid-edhoc+cbor-seq": {
    source: "iana"
  },
  "application/city+json": {
    source: "iana",
    compressible: true
  },
  "application/clr": {
    source: "iana"
  },
  "application/clue+xml": {
    source: "iana",
    compressible: true
  },
  "application/clue_info+xml": {
    source: "iana",
    compressible: true
  },
  "application/cms": {
    source: "iana"
  },
  "application/cnrp+xml": {
    source: "iana",
    compressible: true
  },
  "application/coap-group+json": {
    source: "iana",
    compressible: true
  },
  "application/coap-payload": {
    source: "iana"
  },
  "application/commonground": {
    source: "iana"
  },
  "application/concise-problem-details+cbor": {
    source: "iana"
  },
  "application/conference-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/cose": {
    source: "iana"
  },
  "application/cose-key": {
    source: "iana"
  },
  "application/cose-key-set": {
    source: "iana"
  },
  "application/cose-x509": {
    source: "iana"
  },
  "application/cpl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cpl"
    ]
  },
  "application/csrattrs": {
    source: "iana"
  },
  "application/csta+xml": {
    source: "iana",
    compressible: true
  },
  "application/cstadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/csvm+json": {
    source: "iana",
    compressible: true
  },
  "application/cu-seeme": {
    source: "apache",
    extensions: [
      "cu"
    ]
  },
  "application/cwl": {
    source: "iana",
    extensions: [
      "cwl"
    ]
  },
  "application/cwl+json": {
    source: "iana",
    compressible: true
  },
  "application/cwl+yaml": {
    source: "iana"
  },
  "application/cwt": {
    source: "iana"
  },
  "application/cybercash": {
    source: "iana"
  },
  "application/dart": {
    compressible: true
  },
  "application/dash+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpd"
    ]
  },
  "application/dash-patch+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpp"
    ]
  },
  "application/dashdelta": {
    source: "iana"
  },
  "application/davmount+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "davmount"
    ]
  },
  "application/dca-rft": {
    source: "iana"
  },
  "application/dcd": {
    source: "iana"
  },
  "application/dec-dx": {
    source: "iana"
  },
  "application/dialog-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/dicom": {
    source: "iana"
  },
  "application/dicom+json": {
    source: "iana",
    compressible: true
  },
  "application/dicom+xml": {
    source: "iana",
    compressible: true
  },
  "application/dii": {
    source: "iana"
  },
  "application/dit": {
    source: "iana"
  },
  "application/dns": {
    source: "iana"
  },
  "application/dns+json": {
    source: "iana",
    compressible: true
  },
  "application/dns-message": {
    source: "iana"
  },
  "application/docbook+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "dbk"
    ]
  },
  "application/dots+cbor": {
    source: "iana"
  },
  "application/dpop+jwt": {
    source: "iana"
  },
  "application/dskpp+xml": {
    source: "iana",
    compressible: true
  },
  "application/dssc+der": {
    source: "iana",
    extensions: [
      "dssc"
    ]
  },
  "application/dssc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdssc"
    ]
  },
  "application/dvcs": {
    source: "iana"
  },
  "application/ecmascript": {
    source: "apache",
    compressible: true,
    extensions: [
      "ecma"
    ]
  },
  "application/edhoc+cbor-seq": {
    source: "iana"
  },
  "application/edi-consent": {
    source: "iana"
  },
  "application/edi-x12": {
    source: "iana",
    compressible: false
  },
  "application/edifact": {
    source: "iana",
    compressible: false
  },
  "application/efi": {
    source: "iana"
  },
  "application/elm+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/elm+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.cap+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/emergencycalldata.comment+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.control+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.deviceinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.ecall.msd": {
    source: "iana"
  },
  "application/emergencycalldata.legacyesn+json": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.providerinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.serviceinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.subscriberinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.veds+xml": {
    source: "iana",
    compressible: true
  },
  "application/emma+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "emma"
    ]
  },
  "application/emotionml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "emotionml"
    ]
  },
  "application/encaprtp": {
    source: "iana"
  },
  "application/epp+xml": {
    source: "iana",
    compressible: true
  },
  "application/epub+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "epub"
    ]
  },
  "application/eshop": {
    source: "iana"
  },
  "application/exi": {
    source: "iana",
    extensions: [
      "exi"
    ]
  },
  "application/expect-ct-report+json": {
    source: "iana",
    compressible: true
  },
  "application/express": {
    source: "iana",
    extensions: [
      "exp"
    ]
  },
  "application/fastinfoset": {
    source: "iana"
  },
  "application/fastsoap": {
    source: "iana"
  },
  "application/fdf": {
    source: "iana",
    extensions: [
      "fdf"
    ]
  },
  "application/fdt+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "fdt"
    ]
  },
  "application/fhir+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/fhir+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/fido.trusted-apps+json": {
    compressible: true
  },
  "application/fits": {
    source: "iana"
  },
  "application/flexfec": {
    source: "iana"
  },
  "application/font-sfnt": {
    source: "iana"
  },
  "application/font-tdpfr": {
    source: "iana",
    extensions: [
      "pfr"
    ]
  },
  "application/font-woff": {
    source: "iana",
    compressible: false
  },
  "application/framework-attributes+xml": {
    source: "iana",
    compressible: true
  },
  "application/geo+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "geojson"
    ]
  },
  "application/geo+json-seq": {
    source: "iana"
  },
  "application/geopackage+sqlite3": {
    source: "iana"
  },
  "application/geoxacml+json": {
    source: "iana",
    compressible: true
  },
  "application/geoxacml+xml": {
    source: "iana",
    compressible: true
  },
  "application/gltf-buffer": {
    source: "iana"
  },
  "application/gml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "gml"
    ]
  },
  "application/gnap-binding-jws": {
    source: "iana"
  },
  "application/gnap-binding-jwsd": {
    source: "iana"
  },
  "application/gnap-binding-rotation-jws": {
    source: "iana"
  },
  "application/gnap-binding-rotation-jwsd": {
    source: "iana"
  },
  "application/gpx+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "gpx"
    ]
  },
  "application/grib": {
    source: "iana"
  },
  "application/gxf": {
    source: "apache",
    extensions: [
      "gxf"
    ]
  },
  "application/gzip": {
    source: "iana",
    compressible: false,
    extensions: [
      "gz"
    ]
  },
  "application/h224": {
    source: "iana"
  },
  "application/held+xml": {
    source: "iana",
    compressible: true
  },
  "application/hjson": {
    extensions: [
      "hjson"
    ]
  },
  "application/hl7v2+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/http": {
    source: "iana"
  },
  "application/hyperstudio": {
    source: "iana",
    extensions: [
      "stk"
    ]
  },
  "application/ibe-key-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/ibe-pkg-reply+xml": {
    source: "iana",
    compressible: true
  },
  "application/ibe-pp-data": {
    source: "iana"
  },
  "application/iges": {
    source: "iana"
  },
  "application/im-iscomposing+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/index": {
    source: "iana"
  },
  "application/index.cmd": {
    source: "iana"
  },
  "application/index.obj": {
    source: "iana"
  },
  "application/index.response": {
    source: "iana"
  },
  "application/index.vnd": {
    source: "iana"
  },
  "application/inkml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ink",
      "inkml"
    ]
  },
  "application/iotp": {
    source: "iana"
  },
  "application/ipfix": {
    source: "iana",
    extensions: [
      "ipfix"
    ]
  },
  "application/ipp": {
    source: "iana"
  },
  "application/isup": {
    source: "iana"
  },
  "application/its+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "its"
    ]
  },
  "application/java-archive": {
    source: "iana",
    compressible: false,
    extensions: [
      "jar",
      "war",
      "ear"
    ]
  },
  "application/java-serialized-object": {
    source: "apache",
    compressible: false,
    extensions: [
      "ser"
    ]
  },
  "application/java-vm": {
    source: "apache",
    compressible: false,
    extensions: [
      "class"
    ]
  },
  "application/javascript": {
    source: "apache",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "js"
    ]
  },
  "application/jf2feed+json": {
    source: "iana",
    compressible: true
  },
  "application/jose": {
    source: "iana"
  },
  "application/jose+json": {
    source: "iana",
    compressible: true
  },
  "application/jrd+json": {
    source: "iana",
    compressible: true
  },
  "application/jscalendar+json": {
    source: "iana",
    compressible: true
  },
  "application/jscontact+json": {
    source: "iana",
    compressible: true
  },
  "application/json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "json",
      "map"
    ]
  },
  "application/json-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/json-seq": {
    source: "iana"
  },
  "application/json5": {
    extensions: [
      "json5"
    ]
  },
  "application/jsonml+json": {
    source: "apache",
    compressible: true,
    extensions: [
      "jsonml"
    ]
  },
  "application/jsonpath": {
    source: "iana"
  },
  "application/jwk+json": {
    source: "iana",
    compressible: true
  },
  "application/jwk-set+json": {
    source: "iana",
    compressible: true
  },
  "application/jwt": {
    source: "iana"
  },
  "application/kpml-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/kpml-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/ld+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "jsonld"
    ]
  },
  "application/lgr+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lgr"
    ]
  },
  "application/link-format": {
    source: "iana"
  },
  "application/linkset": {
    source: "iana"
  },
  "application/linkset+json": {
    source: "iana",
    compressible: true
  },
  "application/load-control+xml": {
    source: "iana",
    compressible: true
  },
  "application/logout+jwt": {
    source: "iana"
  },
  "application/lost+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lostxml"
    ]
  },
  "application/lostsync+xml": {
    source: "iana",
    compressible: true
  },
  "application/lpf+zip": {
    source: "iana",
    compressible: false
  },
  "application/lxf": {
    source: "iana"
  },
  "application/mac-binhex40": {
    source: "iana",
    extensions: [
      "hqx"
    ]
  },
  "application/mac-compactpro": {
    source: "apache",
    extensions: [
      "cpt"
    ]
  },
  "application/macwriteii": {
    source: "iana"
  },
  "application/mads+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mads"
    ]
  },
  "application/manifest+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "webmanifest"
    ]
  },
  "application/marc": {
    source: "iana",
    extensions: [
      "mrc"
    ]
  },
  "application/marcxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mrcx"
    ]
  },
  "application/mathematica": {
    source: "iana",
    extensions: [
      "ma",
      "nb",
      "mb"
    ]
  },
  "application/mathml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mathml"
    ]
  },
  "application/mathml-content+xml": {
    source: "iana",
    compressible: true
  },
  "application/mathml-presentation+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-associated-procedure-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-deregister+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-envelope+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-msk+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-msk-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-protection-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-reception-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-register+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-register-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-schedule+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-user-service-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbox": {
    source: "iana",
    extensions: [
      "mbox"
    ]
  },
  "application/media-policy-dataset+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpf"
    ]
  },
  "application/media_control+xml": {
    source: "iana",
    compressible: true
  },
  "application/mediaservercontrol+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mscml"
    ]
  },
  "application/merge-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/metalink+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "metalink"
    ]
  },
  "application/metalink4+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "meta4"
    ]
  },
  "application/mets+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mets"
    ]
  },
  "application/mf4": {
    source: "iana"
  },
  "application/mikey": {
    source: "iana"
  },
  "application/mipc": {
    source: "iana"
  },
  "application/missing-blocks+cbor-seq": {
    source: "iana"
  },
  "application/mmt-aei+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "maei"
    ]
  },
  "application/mmt-usd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "musd"
    ]
  },
  "application/mods+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mods"
    ]
  },
  "application/moss-keys": {
    source: "iana"
  },
  "application/moss-signature": {
    source: "iana"
  },
  "application/mosskey-data": {
    source: "iana"
  },
  "application/mosskey-request": {
    source: "iana"
  },
  "application/mp21": {
    source: "iana",
    extensions: [
      "m21",
      "mp21"
    ]
  },
  "application/mp4": {
    source: "iana",
    extensions: [
      "mp4",
      "mpg4",
      "mp4s",
      "m4p"
    ]
  },
  "application/mpeg4-generic": {
    source: "iana"
  },
  "application/mpeg4-iod": {
    source: "iana"
  },
  "application/mpeg4-iod-xmt": {
    source: "iana"
  },
  "application/mrb-consumer+xml": {
    source: "iana",
    compressible: true
  },
  "application/mrb-publish+xml": {
    source: "iana",
    compressible: true
  },
  "application/msc-ivr+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/msc-mixer+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/msix": {
    compressible: false,
    extensions: [
      "msix"
    ]
  },
  "application/msixbundle": {
    compressible: false,
    extensions: [
      "msixbundle"
    ]
  },
  "application/msword": {
    source: "iana",
    compressible: false,
    extensions: [
      "doc",
      "dot"
    ]
  },
  "application/mud+json": {
    source: "iana",
    compressible: true
  },
  "application/multipart-core": {
    source: "iana"
  },
  "application/mxf": {
    source: "iana",
    extensions: [
      "mxf"
    ]
  },
  "application/n-quads": {
    source: "iana",
    extensions: [
      "nq"
    ]
  },
  "application/n-triples": {
    source: "iana",
    extensions: [
      "nt"
    ]
  },
  "application/nasdata": {
    source: "iana"
  },
  "application/news-checkgroups": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-groupinfo": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-transmission": {
    source: "iana"
  },
  "application/nlsml+xml": {
    source: "iana",
    compressible: true
  },
  "application/node": {
    source: "iana",
    extensions: [
      "cjs"
    ]
  },
  "application/nss": {
    source: "iana"
  },
  "application/oauth-authz-req+jwt": {
    source: "iana"
  },
  "application/oblivious-dns-message": {
    source: "iana"
  },
  "application/ocsp-request": {
    source: "iana"
  },
  "application/ocsp-response": {
    source: "iana"
  },
  "application/octet-stream": {
    source: "iana",
    compressible: false,
    extensions: [
      "bin",
      "dms",
      "lrf",
      "mar",
      "so",
      "dist",
      "distz",
      "pkg",
      "bpk",
      "dump",
      "elc",
      "deploy",
      "exe",
      "dll",
      "deb",
      "dmg",
      "iso",
      "img",
      "msi",
      "msp",
      "msm",
      "buffer"
    ]
  },
  "application/oda": {
    source: "iana",
    extensions: [
      "oda"
    ]
  },
  "application/odm+xml": {
    source: "iana",
    compressible: true
  },
  "application/odx": {
    source: "iana"
  },
  "application/oebps-package+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "opf"
    ]
  },
  "application/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "ogx"
    ]
  },
  "application/ohttp-keys": {
    source: "iana"
  },
  "application/omdoc+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "omdoc"
    ]
  },
  "application/onenote": {
    source: "apache",
    extensions: [
      "onetoc",
      "onetoc2",
      "onetmp",
      "onepkg"
    ]
  },
  "application/opc-nodeset+xml": {
    source: "iana",
    compressible: true
  },
  "application/oscore": {
    source: "iana"
  },
  "application/oxps": {
    source: "iana",
    extensions: [
      "oxps"
    ]
  },
  "application/p21": {
    source: "iana"
  },
  "application/p21+zip": {
    source: "iana",
    compressible: false
  },
  "application/p2p-overlay+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "relo"
    ]
  },
  "application/parityfec": {
    source: "iana"
  },
  "application/passport": {
    source: "iana"
  },
  "application/patch-ops-error+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xer"
    ]
  },
  "application/pdf": {
    source: "iana",
    compressible: false,
    extensions: [
      "pdf"
    ]
  },
  "application/pdx": {
    source: "iana"
  },
  "application/pem-certificate-chain": {
    source: "iana"
  },
  "application/pgp-encrypted": {
    source: "iana",
    compressible: false,
    extensions: [
      "pgp"
    ]
  },
  "application/pgp-keys": {
    source: "iana",
    extensions: [
      "asc"
    ]
  },
  "application/pgp-signature": {
    source: "iana",
    extensions: [
      "sig",
      "asc"
    ]
  },
  "application/pics-rules": {
    source: "apache",
    extensions: [
      "prf"
    ]
  },
  "application/pidf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/pidf-diff+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/pkcs10": {
    source: "iana",
    extensions: [
      "p10"
    ]
  },
  "application/pkcs12": {
    source: "iana"
  },
  "application/pkcs7-mime": {
    source: "iana",
    extensions: [
      "p7m",
      "p7c"
    ]
  },
  "application/pkcs7-signature": {
    source: "iana",
    extensions: [
      "p7s"
    ]
  },
  "application/pkcs8": {
    source: "iana",
    extensions: [
      "p8"
    ]
  },
  "application/pkcs8-encrypted": {
    source: "iana"
  },
  "application/pkix-attr-cert": {
    source: "iana",
    extensions: [
      "ac"
    ]
  },
  "application/pkix-cert": {
    source: "iana",
    extensions: [
      "cer"
    ]
  },
  "application/pkix-crl": {
    source: "iana",
    extensions: [
      "crl"
    ]
  },
  "application/pkix-pkipath": {
    source: "iana",
    extensions: [
      "pkipath"
    ]
  },
  "application/pkixcmp": {
    source: "iana",
    extensions: [
      "pki"
    ]
  },
  "application/pls+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "pls"
    ]
  },
  "application/poc-settings+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/postscript": {
    source: "iana",
    compressible: true,
    extensions: [
      "ai",
      "eps",
      "ps"
    ]
  },
  "application/ppsp-tracker+json": {
    source: "iana",
    compressible: true
  },
  "application/private-token-issuer-directory": {
    source: "iana"
  },
  "application/private-token-request": {
    source: "iana"
  },
  "application/private-token-response": {
    source: "iana"
  },
  "application/problem+json": {
    source: "iana",
    compressible: true
  },
  "application/problem+xml": {
    source: "iana",
    compressible: true
  },
  "application/provenance+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "provx"
    ]
  },
  "application/prs.alvestrand.titrax-sheet": {
    source: "iana"
  },
  "application/prs.cww": {
    source: "iana",
    extensions: [
      "cww"
    ]
  },
  "application/prs.cyn": {
    source: "iana",
    charset: "7-BIT"
  },
  "application/prs.hpub+zip": {
    source: "iana",
    compressible: false
  },
  "application/prs.implied-document+xml": {
    source: "iana",
    compressible: true
  },
  "application/prs.implied-executable": {
    source: "iana"
  },
  "application/prs.implied-object+json": {
    source: "iana",
    compressible: true
  },
  "application/prs.implied-object+json-seq": {
    source: "iana"
  },
  "application/prs.implied-object+yaml": {
    source: "iana"
  },
  "application/prs.implied-structure": {
    source: "iana"
  },
  "application/prs.nprend": {
    source: "iana"
  },
  "application/prs.plucker": {
    source: "iana"
  },
  "application/prs.rdf-xml-crypt": {
    source: "iana"
  },
  "application/prs.vcfbzip2": {
    source: "iana"
  },
  "application/prs.xsf+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xsf"
    ]
  },
  "application/pskc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "pskcxml"
    ]
  },
  "application/pvd+json": {
    source: "iana",
    compressible: true
  },
  "application/qsig": {
    source: "iana"
  },
  "application/raml+yaml": {
    compressible: true,
    extensions: [
      "raml"
    ]
  },
  "application/raptorfec": {
    source: "iana"
  },
  "application/rdap+json": {
    source: "iana",
    compressible: true
  },
  "application/rdf+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rdf",
      "owl"
    ]
  },
  "application/reginfo+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rif"
    ]
  },
  "application/relax-ng-compact-syntax": {
    source: "iana",
    extensions: [
      "rnc"
    ]
  },
  "application/remote-printing": {
    source: "apache"
  },
  "application/reputon+json": {
    source: "iana",
    compressible: true
  },
  "application/resource-lists+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rl"
    ]
  },
  "application/resource-lists-diff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rld"
    ]
  },
  "application/rfc+xml": {
    source: "iana",
    compressible: true
  },
  "application/riscos": {
    source: "iana"
  },
  "application/rlmi+xml": {
    source: "iana",
    compressible: true
  },
  "application/rls-services+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rs"
    ]
  },
  "application/route-apd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rapd"
    ]
  },
  "application/route-s-tsid+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sls"
    ]
  },
  "application/route-usd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rusd"
    ]
  },
  "application/rpki-checklist": {
    source: "iana"
  },
  "application/rpki-ghostbusters": {
    source: "iana",
    extensions: [
      "gbr"
    ]
  },
  "application/rpki-manifest": {
    source: "iana",
    extensions: [
      "mft"
    ]
  },
  "application/rpki-publication": {
    source: "iana"
  },
  "application/rpki-roa": {
    source: "iana",
    extensions: [
      "roa"
    ]
  },
  "application/rpki-signed-tal": {
    source: "iana"
  },
  "application/rpki-updown": {
    source: "iana"
  },
  "application/rsd+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "rsd"
    ]
  },
  "application/rss+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "rss"
    ]
  },
  "application/rtf": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtf"
    ]
  },
  "application/rtploopback": {
    source: "iana"
  },
  "application/rtx": {
    source: "iana"
  },
  "application/samlassertion+xml": {
    source: "iana",
    compressible: true
  },
  "application/samlmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/sarif+json": {
    source: "iana",
    compressible: true
  },
  "application/sarif-external-properties+json": {
    source: "iana",
    compressible: true
  },
  "application/sbe": {
    source: "iana"
  },
  "application/sbml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sbml"
    ]
  },
  "application/scaip+xml": {
    source: "iana",
    compressible: true
  },
  "application/scim+json": {
    source: "iana",
    compressible: true
  },
  "application/scvp-cv-request": {
    source: "iana",
    extensions: [
      "scq"
    ]
  },
  "application/scvp-cv-response": {
    source: "iana",
    extensions: [
      "scs"
    ]
  },
  "application/scvp-vp-request": {
    source: "iana",
    extensions: [
      "spq"
    ]
  },
  "application/scvp-vp-response": {
    source: "iana",
    extensions: [
      "spp"
    ]
  },
  "application/sdp": {
    source: "iana",
    extensions: [
      "sdp"
    ]
  },
  "application/secevent+jwt": {
    source: "iana"
  },
  "application/senml+cbor": {
    source: "iana"
  },
  "application/senml+json": {
    source: "iana",
    compressible: true
  },
  "application/senml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "senmlx"
    ]
  },
  "application/senml-etch+cbor": {
    source: "iana"
  },
  "application/senml-etch+json": {
    source: "iana",
    compressible: true
  },
  "application/senml-exi": {
    source: "iana"
  },
  "application/sensml+cbor": {
    source: "iana"
  },
  "application/sensml+json": {
    source: "iana",
    compressible: true
  },
  "application/sensml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sensmlx"
    ]
  },
  "application/sensml-exi": {
    source: "iana"
  },
  "application/sep+xml": {
    source: "iana",
    compressible: true
  },
  "application/sep-exi": {
    source: "iana"
  },
  "application/session-info": {
    source: "iana"
  },
  "application/set-payment": {
    source: "iana"
  },
  "application/set-payment-initiation": {
    source: "iana",
    extensions: [
      "setpay"
    ]
  },
  "application/set-registration": {
    source: "iana"
  },
  "application/set-registration-initiation": {
    source: "iana",
    extensions: [
      "setreg"
    ]
  },
  "application/sgml": {
    source: "iana"
  },
  "application/sgml-open-catalog": {
    source: "iana"
  },
  "application/shf+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "shf"
    ]
  },
  "application/sieve": {
    source: "iana",
    extensions: [
      "siv",
      "sieve"
    ]
  },
  "application/simple-filter+xml": {
    source: "iana",
    compressible: true
  },
  "application/simple-message-summary": {
    source: "iana"
  },
  "application/simplesymbolcontainer": {
    source: "iana"
  },
  "application/sipc": {
    source: "iana"
  },
  "application/slate": {
    source: "iana"
  },
  "application/smil": {
    source: "apache"
  },
  "application/smil+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "smi",
      "smil"
    ]
  },
  "application/smpte336m": {
    source: "iana"
  },
  "application/soap+fastinfoset": {
    source: "iana"
  },
  "application/soap+xml": {
    source: "iana",
    compressible: true
  },
  "application/sparql-query": {
    source: "iana",
    extensions: [
      "rq"
    ]
  },
  "application/sparql-results+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "srx"
    ]
  },
  "application/spdx+json": {
    source: "iana",
    compressible: true
  },
  "application/spirits-event+xml": {
    source: "iana",
    compressible: true
  },
  "application/sql": {
    source: "iana",
    extensions: [
      "sql"
    ]
  },
  "application/srgs": {
    source: "iana",
    extensions: [
      "gram"
    ]
  },
  "application/srgs+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "grxml"
    ]
  },
  "application/sru+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sru"
    ]
  },
  "application/ssdl+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "ssdl"
    ]
  },
  "application/ssml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ssml"
    ]
  },
  "application/st2110-41": {
    source: "iana"
  },
  "application/stix+json": {
    source: "iana",
    compressible: true
  },
  "application/stratum": {
    source: "iana"
  },
  "application/swid+cbor": {
    source: "iana"
  },
  "application/swid+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "swidtag"
    ]
  },
  "application/tamp-apex-update": {
    source: "iana"
  },
  "application/tamp-apex-update-confirm": {
    source: "iana"
  },
  "application/tamp-community-update": {
    source: "iana"
  },
  "application/tamp-community-update-confirm": {
    source: "iana"
  },
  "application/tamp-error": {
    source: "iana"
  },
  "application/tamp-sequence-adjust": {
    source: "iana"
  },
  "application/tamp-sequence-adjust-confirm": {
    source: "iana"
  },
  "application/tamp-status-query": {
    source: "iana"
  },
  "application/tamp-status-response": {
    source: "iana"
  },
  "application/tamp-update": {
    source: "iana"
  },
  "application/tamp-update-confirm": {
    source: "iana"
  },
  "application/tar": {
    compressible: true
  },
  "application/taxii+json": {
    source: "iana",
    compressible: true
  },
  "application/td+json": {
    source: "iana",
    compressible: true
  },
  "application/tei+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "tei",
      "teicorpus"
    ]
  },
  "application/tetra_isi": {
    source: "iana"
  },
  "application/thraud+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "tfi"
    ]
  },
  "application/timestamp-query": {
    source: "iana"
  },
  "application/timestamp-reply": {
    source: "iana"
  },
  "application/timestamped-data": {
    source: "iana",
    extensions: [
      "tsd"
    ]
  },
  "application/tlsrpt+gzip": {
    source: "iana"
  },
  "application/tlsrpt+json": {
    source: "iana",
    compressible: true
  },
  "application/tm+json": {
    source: "iana",
    compressible: true
  },
  "application/tnauthlist": {
    source: "iana"
  },
  "application/token-introspection+jwt": {
    source: "iana"
  },
  "application/toml": {
    compressible: true,
    extensions: [
      "toml"
    ]
  },
  "application/trickle-ice-sdpfrag": {
    source: "iana"
  },
  "application/trig": {
    source: "iana",
    extensions: [
      "trig"
    ]
  },
  "application/ttml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ttml"
    ]
  },
  "application/tve-trigger": {
    source: "iana"
  },
  "application/tzif": {
    source: "iana"
  },
  "application/tzif-leap": {
    source: "iana"
  },
  "application/ubjson": {
    compressible: false,
    extensions: [
      "ubj"
    ]
  },
  "application/ulpfec": {
    source: "iana"
  },
  "application/urc-grpsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/urc-ressheet+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rsheet"
    ]
  },
  "application/urc-targetdesc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "td"
    ]
  },
  "application/urc-uisocketdesc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vc": {
    source: "iana"
  },
  "application/vcard+json": {
    source: "iana",
    compressible: true
  },
  "application/vcard+xml": {
    source: "iana",
    compressible: true
  },
  "application/vemmi": {
    source: "iana"
  },
  "application/vividence.scriptfile": {
    source: "apache"
  },
  "application/vnd.1000minds.decision-model+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "1km"
    ]
  },
  "application/vnd.1ob": {
    source: "iana"
  },
  "application/vnd.3gpp-prose+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-prose-pc3a+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-prose-pc3ach+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-prose-pc3ch+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-prose-pc8+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-v2x-local-service-information": {
    source: "iana"
  },
  "application/vnd.3gpp.5gnas": {
    source: "iana"
  },
  "application/vnd.3gpp.5gsa2x": {
    source: "iana"
  },
  "application/vnd.3gpp.5gsa2x-local-service-information": {
    source: "iana"
  },
  "application/vnd.3gpp.access-transfer-events+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.bsf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.crs+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.current-location-discovery+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.gmop+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.gtpc": {
    source: "iana"
  },
  "application/vnd.3gpp.interworking-data": {
    source: "iana"
  },
  "application/vnd.3gpp.lpp": {
    source: "iana"
  },
  "application/vnd.3gpp.mc-signalling-ear": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-msgstore-ctrl-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-payload": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-regroup+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-signalling": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-floor-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-location-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-regroup+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-signed+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-location-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-regroup+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mid-call+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.ngap": {
    source: "iana"
  },
  "application/vnd.3gpp.pfcp": {
    source: "iana"
  },
  "application/vnd.3gpp.pic-bw-large": {
    source: "iana",
    extensions: [
      "plb"
    ]
  },
  "application/vnd.3gpp.pic-bw-small": {
    source: "iana",
    extensions: [
      "psb"
    ]
  },
  "application/vnd.3gpp.pic-bw-var": {
    source: "iana",
    extensions: [
      "pvb"
    ]
  },
  "application/vnd.3gpp.pinapp-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.s1ap": {
    source: "iana"
  },
  "application/vnd.3gpp.seal-group-doc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-location-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-mbms-usage-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-network-qos-management-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-ue-config-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-unicast-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.seal-user-profile-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.sms": {
    source: "iana"
  },
  "application/vnd.3gpp.sms+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.srvcc-ext+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.srvcc-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.state-and-event-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.ussd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.v2x": {
    source: "iana"
  },
  "application/vnd.3gpp.vae-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp2.bcmcsinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp2.sms": {
    source: "iana"
  },
  "application/vnd.3gpp2.tcap": {
    source: "iana",
    extensions: [
      "tcap"
    ]
  },
  "application/vnd.3lightssoftware.imagescal": {
    source: "iana"
  },
  "application/vnd.3m.post-it-notes": {
    source: "iana",
    extensions: [
      "pwn"
    ]
  },
  "application/vnd.accpac.simply.aso": {
    source: "iana",
    extensions: [
      "aso"
    ]
  },
  "application/vnd.accpac.simply.imp": {
    source: "iana",
    extensions: [
      "imp"
    ]
  },
  "application/vnd.acm.addressxfer+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.acm.chatbot+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.acucobol": {
    source: "iana",
    extensions: [
      "acu"
    ]
  },
  "application/vnd.acucorp": {
    source: "iana",
    extensions: [
      "atc",
      "acutc"
    ]
  },
  "application/vnd.adobe.air-application-installer-package+zip": {
    source: "apache",
    compressible: false,
    extensions: [
      "air"
    ]
  },
  "application/vnd.adobe.flash.movie": {
    source: "iana"
  },
  "application/vnd.adobe.formscentral.fcdt": {
    source: "iana",
    extensions: [
      "fcdt"
    ]
  },
  "application/vnd.adobe.fxp": {
    source: "iana",
    extensions: [
      "fxp",
      "fxpl"
    ]
  },
  "application/vnd.adobe.partial-upload": {
    source: "iana"
  },
  "application/vnd.adobe.xdp+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdp"
    ]
  },
  "application/vnd.adobe.xfdf": {
    source: "apache",
    extensions: [
      "xfdf"
    ]
  },
  "application/vnd.aether.imp": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata-pagedef": {
    source: "iana"
  },
  "application/vnd.afpc.cmoca-cmresource": {
    source: "iana"
  },
  "application/vnd.afpc.foca-charset": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codedfont": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codepage": {
    source: "iana"
  },
  "application/vnd.afpc.modca": {
    source: "iana"
  },
  "application/vnd.afpc.modca-cmtable": {
    source: "iana"
  },
  "application/vnd.afpc.modca-formdef": {
    source: "iana"
  },
  "application/vnd.afpc.modca-mediummap": {
    source: "iana"
  },
  "application/vnd.afpc.modca-objectcontainer": {
    source: "iana"
  },
  "application/vnd.afpc.modca-overlay": {
    source: "iana"
  },
  "application/vnd.afpc.modca-pagesegment": {
    source: "iana"
  },
  "application/vnd.age": {
    source: "iana",
    extensions: [
      "age"
    ]
  },
  "application/vnd.ah-barcode": {
    source: "apache"
  },
  "application/vnd.ahead.space": {
    source: "iana",
    extensions: [
      "ahead"
    ]
  },
  "application/vnd.airzip.filesecure.azf": {
    source: "iana",
    extensions: [
      "azf"
    ]
  },
  "application/vnd.airzip.filesecure.azs": {
    source: "iana",
    extensions: [
      "azs"
    ]
  },
  "application/vnd.amadeus+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.amazon.ebook": {
    source: "apache",
    extensions: [
      "azw"
    ]
  },
  "application/vnd.amazon.mobi8-ebook": {
    source: "iana"
  },
  "application/vnd.americandynamics.acc": {
    source: "iana",
    extensions: [
      "acc"
    ]
  },
  "application/vnd.amiga.ami": {
    source: "iana",
    extensions: [
      "ami"
    ]
  },
  "application/vnd.amundsen.maze+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.android.ota": {
    source: "iana"
  },
  "application/vnd.android.package-archive": {
    source: "apache",
    compressible: false,
    extensions: [
      "apk"
    ]
  },
  "application/vnd.anki": {
    source: "iana"
  },
  "application/vnd.anser-web-certificate-issue-initiation": {
    source: "iana",
    extensions: [
      "cii"
    ]
  },
  "application/vnd.anser-web-funds-transfer-initiation": {
    source: "apache",
    extensions: [
      "fti"
    ]
  },
  "application/vnd.antix.game-component": {
    source: "iana",
    extensions: [
      "atx"
    ]
  },
  "application/vnd.apache.arrow.file": {
    source: "iana"
  },
  "application/vnd.apache.arrow.stream": {
    source: "iana"
  },
  "application/vnd.apache.parquet": {
    source: "iana"
  },
  "application/vnd.apache.thrift.binary": {
    source: "iana"
  },
  "application/vnd.apache.thrift.compact": {
    source: "iana"
  },
  "application/vnd.apache.thrift.json": {
    source: "iana"
  },
  "application/vnd.apexlang": {
    source: "iana"
  },
  "application/vnd.api+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.aplextor.warrp+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.apothekende.reservation+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.apple.installer+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpkg"
    ]
  },
  "application/vnd.apple.keynote": {
    source: "iana",
    extensions: [
      "key"
    ]
  },
  "application/vnd.apple.mpegurl": {
    source: "iana",
    extensions: [
      "m3u8"
    ]
  },
  "application/vnd.apple.numbers": {
    source: "iana",
    extensions: [
      "numbers"
    ]
  },
  "application/vnd.apple.pages": {
    source: "iana",
    extensions: [
      "pages"
    ]
  },
  "application/vnd.apple.pkpass": {
    compressible: false,
    extensions: [
      "pkpass"
    ]
  },
  "application/vnd.arastra.swi": {
    source: "apache"
  },
  "application/vnd.aristanetworks.swi": {
    source: "iana",
    extensions: [
      "swi"
    ]
  },
  "application/vnd.artisan+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.artsquare": {
    source: "iana"
  },
  "application/vnd.astraea-software.iota": {
    source: "iana",
    extensions: [
      "iota"
    ]
  },
  "application/vnd.audiograph": {
    source: "iana",
    extensions: [
      "aep"
    ]
  },
  "application/vnd.autopackage": {
    source: "iana"
  },
  "application/vnd.avalon+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.avistar+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.balsamiq.bmml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "bmml"
    ]
  },
  "application/vnd.balsamiq.bmpr": {
    source: "iana"
  },
  "application/vnd.banana-accounting": {
    source: "iana"
  },
  "application/vnd.bbf.usp.error": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.bekitzur-stech+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.belightsoft.lhzd+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.belightsoft.lhzl+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.bint.med-content": {
    source: "iana"
  },
  "application/vnd.biopax.rdf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.blink-idb-value-wrapper": {
    source: "iana"
  },
  "application/vnd.blueice.multipass": {
    source: "iana",
    extensions: [
      "mpm"
    ]
  },
  "application/vnd.bluetooth.ep.oob": {
    source: "iana"
  },
  "application/vnd.bluetooth.le.oob": {
    source: "iana"
  },
  "application/vnd.bmi": {
    source: "iana",
    extensions: [
      "bmi"
    ]
  },
  "application/vnd.bpf": {
    source: "iana"
  },
  "application/vnd.bpf3": {
    source: "iana"
  },
  "application/vnd.businessobjects": {
    source: "iana",
    extensions: [
      "rep"
    ]
  },
  "application/vnd.byu.uapi+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.bzip3": {
    source: "iana"
  },
  "application/vnd.c3voc.schedule+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cab-jscript": {
    source: "iana"
  },
  "application/vnd.canon-cpdl": {
    source: "iana"
  },
  "application/vnd.canon-lips": {
    source: "iana"
  },
  "application/vnd.capasystems-pg+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cendio.thinlinc.clientconf": {
    source: "iana"
  },
  "application/vnd.century-systems.tcp_stream": {
    source: "iana"
  },
  "application/vnd.chemdraw+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cdxml"
    ]
  },
  "application/vnd.chess-pgn": {
    source: "iana"
  },
  "application/vnd.chipnuts.karaoke-mmd": {
    source: "iana",
    extensions: [
      "mmd"
    ]
  },
  "application/vnd.ciedi": {
    source: "iana"
  },
  "application/vnd.cinderella": {
    source: "iana",
    extensions: [
      "cdy"
    ]
  },
  "application/vnd.cirpack.isdn-ext": {
    source: "iana"
  },
  "application/vnd.citationstyles.style+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "csl"
    ]
  },
  "application/vnd.claymore": {
    source: "iana",
    extensions: [
      "cla"
    ]
  },
  "application/vnd.cloanto.rp9": {
    source: "iana",
    extensions: [
      "rp9"
    ]
  },
  "application/vnd.clonk.c4group": {
    source: "iana",
    extensions: [
      "c4g",
      "c4d",
      "c4f",
      "c4p",
      "c4u"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config": {
    source: "iana",
    extensions: [
      "c11amc"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config-pkg": {
    source: "iana",
    extensions: [
      "c11amz"
    ]
  },
  "application/vnd.cncf.helm.chart.content.v1.tar+gzip": {
    source: "iana"
  },
  "application/vnd.cncf.helm.chart.provenance.v1.prov": {
    source: "iana"
  },
  "application/vnd.cncf.helm.config.v1+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.coffeescript": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet-template": {
    source: "iana"
  },
  "application/vnd.collection+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.collection.doc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.collection.next+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.comicbook+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.comicbook-rar": {
    source: "iana"
  },
  "application/vnd.commerce-battelle": {
    source: "iana"
  },
  "application/vnd.commonspace": {
    source: "iana",
    extensions: [
      "csp"
    ]
  },
  "application/vnd.contact.cmsg": {
    source: "iana",
    extensions: [
      "cdbcmsg"
    ]
  },
  "application/vnd.coreos.ignition+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cosmocaller": {
    source: "iana",
    extensions: [
      "cmc"
    ]
  },
  "application/vnd.crick.clicker": {
    source: "iana",
    extensions: [
      "clkx"
    ]
  },
  "application/vnd.crick.clicker.keyboard": {
    source: "iana",
    extensions: [
      "clkk"
    ]
  },
  "application/vnd.crick.clicker.palette": {
    source: "iana",
    extensions: [
      "clkp"
    ]
  },
  "application/vnd.crick.clicker.template": {
    source: "iana",
    extensions: [
      "clkt"
    ]
  },
  "application/vnd.crick.clicker.wordbank": {
    source: "iana",
    extensions: [
      "clkw"
    ]
  },
  "application/vnd.criticaltools.wbs+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wbs"
    ]
  },
  "application/vnd.cryptii.pipe+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.crypto-shade-file": {
    source: "iana"
  },
  "application/vnd.cryptomator.encrypted": {
    source: "iana"
  },
  "application/vnd.cryptomator.vault": {
    source: "iana"
  },
  "application/vnd.ctc-posml": {
    source: "iana",
    extensions: [
      "pml"
    ]
  },
  "application/vnd.ctct.ws+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cups-pdf": {
    source: "iana"
  },
  "application/vnd.cups-postscript": {
    source: "iana"
  },
  "application/vnd.cups-ppd": {
    source: "iana",
    extensions: [
      "ppd"
    ]
  },
  "application/vnd.cups-raster": {
    source: "iana"
  },
  "application/vnd.cups-raw": {
    source: "iana"
  },
  "application/vnd.curl": {
    source: "iana"
  },
  "application/vnd.curl.car": {
    source: "apache",
    extensions: [
      "car"
    ]
  },
  "application/vnd.curl.pcurl": {
    source: "apache",
    extensions: [
      "pcurl"
    ]
  },
  "application/vnd.cyan.dean.root+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cybank": {
    source: "iana"
  },
  "application/vnd.cyclonedx+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cyclonedx+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.d2l.coursepackage1p0+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.d3m-dataset": {
    source: "iana"
  },
  "application/vnd.d3m-problem": {
    source: "iana"
  },
  "application/vnd.dart": {
    source: "iana",
    compressible: true,
    extensions: [
      "dart"
    ]
  },
  "application/vnd.data-vision.rdz": {
    source: "iana",
    extensions: [
      "rdz"
    ]
  },
  "application/vnd.datalog": {
    source: "iana"
  },
  "application/vnd.datapackage+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dataresource+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dbf": {
    source: "iana",
    extensions: [
      "dbf"
    ]
  },
  "application/vnd.debian.binary-package": {
    source: "iana"
  },
  "application/vnd.dece.data": {
    source: "iana",
    extensions: [
      "uvf",
      "uvvf",
      "uvd",
      "uvvd"
    ]
  },
  "application/vnd.dece.ttml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "uvt",
      "uvvt"
    ]
  },
  "application/vnd.dece.unspecified": {
    source: "iana",
    extensions: [
      "uvx",
      "uvvx"
    ]
  },
  "application/vnd.dece.zip": {
    source: "iana",
    extensions: [
      "uvz",
      "uvvz"
    ]
  },
  "application/vnd.denovo.fcselayout-link": {
    source: "iana",
    extensions: [
      "fe_launch"
    ]
  },
  "application/vnd.desmume.movie": {
    source: "iana"
  },
  "application/vnd.dir-bi.plate-dl-nosuffix": {
    source: "iana"
  },
  "application/vnd.dm.delegation+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dna": {
    source: "iana",
    extensions: [
      "dna"
    ]
  },
  "application/vnd.document+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dolby.mlp": {
    source: "apache",
    extensions: [
      "mlp"
    ]
  },
  "application/vnd.dolby.mobile.1": {
    source: "iana"
  },
  "application/vnd.dolby.mobile.2": {
    source: "iana"
  },
  "application/vnd.doremir.scorecloud-binary-document": {
    source: "iana"
  },
  "application/vnd.dpgraph": {
    source: "iana",
    extensions: [
      "dpg"
    ]
  },
  "application/vnd.dreamfactory": {
    source: "iana",
    extensions: [
      "dfac"
    ]
  },
  "application/vnd.drive+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ds-keypoint": {
    source: "apache",
    extensions: [
      "kpxx"
    ]
  },
  "application/vnd.dtg.local": {
    source: "iana"
  },
  "application/vnd.dtg.local.flash": {
    source: "iana"
  },
  "application/vnd.dtg.local.html": {
    source: "iana"
  },
  "application/vnd.dvb.ait": {
    source: "iana",
    extensions: [
      "ait"
    ]
  },
  "application/vnd.dvb.dvbisl+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.dvbj": {
    source: "iana"
  },
  "application/vnd.dvb.esgcontainer": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcdftnotifaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess2": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgpdd": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcroaming": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-base": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-enhancement": {
    source: "iana"
  },
  "application/vnd.dvb.notif-aggregate-root+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-container+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-generic+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-msglist+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-registration-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-registration-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-init+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.pfr": {
    source: "iana"
  },
  "application/vnd.dvb.service": {
    source: "iana",
    extensions: [
      "svc"
    ]
  },
  "application/vnd.dxr": {
    source: "iana"
  },
  "application/vnd.dynageo": {
    source: "iana",
    extensions: [
      "geo"
    ]
  },
  "application/vnd.dzr": {
    source: "iana"
  },
  "application/vnd.easykaraoke.cdgdownload": {
    source: "iana"
  },
  "application/vnd.ecdis-update": {
    source: "iana"
  },
  "application/vnd.ecip.rlp": {
    source: "iana"
  },
  "application/vnd.eclipse.ditto+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ecowin.chart": {
    source: "iana",
    extensions: [
      "mag"
    ]
  },
  "application/vnd.ecowin.filerequest": {
    source: "iana"
  },
  "application/vnd.ecowin.fileupdate": {
    source: "iana"
  },
  "application/vnd.ecowin.series": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesrequest": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesupdate": {
    source: "iana"
  },
  "application/vnd.efi.img": {
    source: "iana"
  },
  "application/vnd.efi.iso": {
    source: "iana"
  },
  "application/vnd.eln+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.emclient.accessrequest+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.enliven": {
    source: "iana",
    extensions: [
      "nml"
    ]
  },
  "application/vnd.enphase.envoy": {
    source: "iana"
  },
  "application/vnd.eprints.data+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.epson.esf": {
    source: "iana",
    extensions: [
      "esf"
    ]
  },
  "application/vnd.epson.msf": {
    source: "iana",
    extensions: [
      "msf"
    ]
  },
  "application/vnd.epson.quickanime": {
    source: "iana",
    extensions: [
      "qam"
    ]
  },
  "application/vnd.epson.salt": {
    source: "iana",
    extensions: [
      "slt"
    ]
  },
  "application/vnd.epson.ssf": {
    source: "iana",
    extensions: [
      "ssf"
    ]
  },
  "application/vnd.ericsson.quickcall": {
    source: "iana"
  },
  "application/vnd.erofs": {
    source: "iana"
  },
  "application/vnd.espass-espass+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.eszigno3+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "es3",
      "et3"
    ]
  },
  "application/vnd.etsi.aoc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.asic-e+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.etsi.asic-s+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.etsi.cug+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvcommand+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvdiscovery+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-bc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-cod+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-npvr+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvservice+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsync+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvueprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.mcid+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.mheg5": {
    source: "iana"
  },
  "application/vnd.etsi.overload-control-policy-dataset+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.pstn+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.sci+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.simservs+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.timestamp-token": {
    source: "iana"
  },
  "application/vnd.etsi.tsl+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.tsl.der": {
    source: "iana"
  },
  "application/vnd.eu.kasparian.car+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.eudora.data": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.profile": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.settings": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.theme": {
    source: "iana"
  },
  "application/vnd.exstream-empower+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.exstream-package": {
    source: "iana"
  },
  "application/vnd.ezpix-album": {
    source: "iana",
    extensions: [
      "ez2"
    ]
  },
  "application/vnd.ezpix-package": {
    source: "iana",
    extensions: [
      "ez3"
    ]
  },
  "application/vnd.f-secure.mobile": {
    source: "iana"
  },
  "application/vnd.familysearch.gedcom+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.fastcopy-disk-image": {
    source: "iana"
  },
  "application/vnd.fdf": {
    source: "apache",
    extensions: [
      "fdf"
    ]
  },
  "application/vnd.fdsn.mseed": {
    source: "iana",
    extensions: [
      "mseed"
    ]
  },
  "application/vnd.fdsn.seed": {
    source: "iana",
    extensions: [
      "seed",
      "dataless"
    ]
  },
  "application/vnd.ffsns": {
    source: "iana"
  },
  "application/vnd.ficlab.flb+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.filmit.zfc": {
    source: "iana"
  },
  "application/vnd.fints": {
    source: "iana"
  },
  "application/vnd.firemonkeys.cloudcell": {
    source: "iana"
  },
  "application/vnd.flographit": {
    source: "iana",
    extensions: [
      "gph"
    ]
  },
  "application/vnd.fluxtime.clip": {
    source: "iana",
    extensions: [
      "ftc"
    ]
  },
  "application/vnd.font-fontforge-sfd": {
    source: "iana"
  },
  "application/vnd.framemaker": {
    source: "iana",
    extensions: [
      "fm",
      "frame",
      "maker",
      "book"
    ]
  },
  "application/vnd.freelog.comic": {
    source: "iana"
  },
  "application/vnd.frogans.fnc": {
    source: "apache",
    extensions: [
      "fnc"
    ]
  },
  "application/vnd.frogans.ltf": {
    source: "apache",
    extensions: [
      "ltf"
    ]
  },
  "application/vnd.fsc.weblaunch": {
    source: "iana",
    extensions: [
      "fsc"
    ]
  },
  "application/vnd.fujifilm.fb.docuworks": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.binder": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.jfi+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.fujitsu.oasys": {
    source: "iana",
    extensions: [
      "oas"
    ]
  },
  "application/vnd.fujitsu.oasys2": {
    source: "iana",
    extensions: [
      "oa2"
    ]
  },
  "application/vnd.fujitsu.oasys3": {
    source: "iana",
    extensions: [
      "oa3"
    ]
  },
  "application/vnd.fujitsu.oasysgp": {
    source: "iana",
    extensions: [
      "fg5"
    ]
  },
  "application/vnd.fujitsu.oasysprs": {
    source: "iana",
    extensions: [
      "bh2"
    ]
  },
  "application/vnd.fujixerox.art-ex": {
    source: "iana"
  },
  "application/vnd.fujixerox.art4": {
    source: "iana"
  },
  "application/vnd.fujixerox.ddd": {
    source: "iana",
    extensions: [
      "ddd"
    ]
  },
  "application/vnd.fujixerox.docuworks": {
    source: "iana",
    extensions: [
      "xdw"
    ]
  },
  "application/vnd.fujixerox.docuworks.binder": {
    source: "iana",
    extensions: [
      "xbd"
    ]
  },
  "application/vnd.fujixerox.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujixerox.hbpl": {
    source: "iana"
  },
  "application/vnd.fut-misnet": {
    source: "iana"
  },
  "application/vnd.futoin+cbor": {
    source: "iana"
  },
  "application/vnd.futoin+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.fuzzysheet": {
    source: "iana",
    extensions: [
      "fzs"
    ]
  },
  "application/vnd.ga4gh.passport+jwt": {
    source: "iana"
  },
  "application/vnd.genomatix.tuxedo": {
    source: "iana",
    extensions: [
      "txd"
    ]
  },
  "application/vnd.genozip": {
    source: "iana"
  },
  "application/vnd.gentics.grd+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.gentoo.catmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.gentoo.ebuild": {
    source: "iana"
  },
  "application/vnd.gentoo.eclass": {
    source: "iana"
  },
  "application/vnd.gentoo.gpkg": {
    source: "iana"
  },
  "application/vnd.gentoo.manifest": {
    source: "iana"
  },
  "application/vnd.gentoo.pkgmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.gentoo.xpak": {
    source: "iana"
  },
  "application/vnd.geo+json": {
    source: "apache",
    compressible: true
  },
  "application/vnd.geocube+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.geogebra.file": {
    source: "iana",
    extensions: [
      "ggb"
    ]
  },
  "application/vnd.geogebra.slides": {
    source: "iana",
    extensions: [
      "ggs"
    ]
  },
  "application/vnd.geogebra.tool": {
    source: "iana",
    extensions: [
      "ggt"
    ]
  },
  "application/vnd.geometry-explorer": {
    source: "iana",
    extensions: [
      "gex",
      "gre"
    ]
  },
  "application/vnd.geonext": {
    source: "iana",
    extensions: [
      "gxt"
    ]
  },
  "application/vnd.geoplan": {
    source: "iana",
    extensions: [
      "g2w"
    ]
  },
  "application/vnd.geospace": {
    source: "iana",
    extensions: [
      "g3w"
    ]
  },
  "application/vnd.gerber": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt-response": {
    source: "iana"
  },
  "application/vnd.gmx": {
    source: "iana",
    extensions: [
      "gmx"
    ]
  },
  "application/vnd.gnu.taler.exchange+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.gnu.taler.merchant+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.google-apps.document": {
    compressible: false,
    extensions: [
      "gdoc"
    ]
  },
  "application/vnd.google-apps.presentation": {
    compressible: false,
    extensions: [
      "gslides"
    ]
  },
  "application/vnd.google-apps.spreadsheet": {
    compressible: false,
    extensions: [
      "gsheet"
    ]
  },
  "application/vnd.google-earth.kml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "kml"
    ]
  },
  "application/vnd.google-earth.kmz": {
    source: "iana",
    compressible: false,
    extensions: [
      "kmz"
    ]
  },
  "application/vnd.gov.sk.e-form+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.gov.sk.e-form+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.gov.sk.xmldatacontainer+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdcf"
    ]
  },
  "application/vnd.gpxsee.map+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.grafeq": {
    source: "iana",
    extensions: [
      "gqf",
      "gqs"
    ]
  },
  "application/vnd.gridmp": {
    source: "iana"
  },
  "application/vnd.groove-account": {
    source: "iana",
    extensions: [
      "gac"
    ]
  },
  "application/vnd.groove-help": {
    source: "iana",
    extensions: [
      "ghf"
    ]
  },
  "application/vnd.groove-identity-message": {
    source: "iana",
    extensions: [
      "gim"
    ]
  },
  "application/vnd.groove-injector": {
    source: "iana",
    extensions: [
      "grv"
    ]
  },
  "application/vnd.groove-tool-message": {
    source: "iana",
    extensions: [
      "gtm"
    ]
  },
  "application/vnd.groove-tool-template": {
    source: "iana",
    extensions: [
      "tpl"
    ]
  },
  "application/vnd.groove-vcard": {
    source: "iana",
    extensions: [
      "vcg"
    ]
  },
  "application/vnd.hal+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hal+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "hal"
    ]
  },
  "application/vnd.handheld-entertainment+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "zmm"
    ]
  },
  "application/vnd.hbci": {
    source: "iana",
    extensions: [
      "hbci"
    ]
  },
  "application/vnd.hc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hcl-bireports": {
    source: "iana"
  },
  "application/vnd.hdt": {
    source: "iana"
  },
  "application/vnd.heroku+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hhe.lesson-player": {
    source: "iana",
    extensions: [
      "les"
    ]
  },
  "application/vnd.hp-hpgl": {
    source: "iana",
    extensions: [
      "hpgl"
    ]
  },
  "application/vnd.hp-hpid": {
    source: "iana",
    extensions: [
      "hpid"
    ]
  },
  "application/vnd.hp-hps": {
    source: "iana",
    extensions: [
      "hps"
    ]
  },
  "application/vnd.hp-jlyt": {
    source: "iana",
    extensions: [
      "jlt"
    ]
  },
  "application/vnd.hp-pcl": {
    source: "iana",
    extensions: [
      "pcl"
    ]
  },
  "application/vnd.hp-pclxl": {
    source: "iana",
    extensions: [
      "pclxl"
    ]
  },
  "application/vnd.hsl": {
    source: "iana"
  },
  "application/vnd.httphone": {
    source: "iana"
  },
  "application/vnd.hydrostatix.sof-data": {
    source: "iana",
    extensions: [
      "sfd-hdstx"
    ]
  },
  "application/vnd.hyper+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hyper-item+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hyperdrive+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hzn-3d-crossword": {
    source: "iana"
  },
  "application/vnd.ibm.afplinedata": {
    source: "apache"
  },
  "application/vnd.ibm.electronic-media": {
    source: "iana"
  },
  "application/vnd.ibm.minipay": {
    source: "iana",
    extensions: [
      "mpy"
    ]
  },
  "application/vnd.ibm.modcap": {
    source: "apache",
    extensions: [
      "afp",
      "listafp",
      "list3820"
    ]
  },
  "application/vnd.ibm.rights-management": {
    source: "iana",
    extensions: [
      "irm"
    ]
  },
  "application/vnd.ibm.secure-container": {
    source: "iana",
    extensions: [
      "sc"
    ]
  },
  "application/vnd.iccprofile": {
    source: "iana",
    extensions: [
      "icc",
      "icm"
    ]
  },
  "application/vnd.ieee.1905": {
    source: "iana"
  },
  "application/vnd.igloader": {
    source: "iana",
    extensions: [
      "igl"
    ]
  },
  "application/vnd.imagemeter.folder+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.imagemeter.image+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.immervision-ivp": {
    source: "iana",
    extensions: [
      "ivp"
    ]
  },
  "application/vnd.immervision-ivu": {
    source: "iana",
    extensions: [
      "ivu"
    ]
  },
  "application/vnd.ims.imsccv1p1": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p2": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p3": {
    source: "iana"
  },
  "application/vnd.ims.lis.v2.result+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolproxy+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolproxy.id+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolsettings+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.informedcontrol.rms+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.informix-visionary": {
    source: "apache"
  },
  "application/vnd.infotech.project": {
    source: "iana"
  },
  "application/vnd.infotech.project+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.innopath.wamp.notification": {
    source: "iana"
  },
  "application/vnd.insors.igm": {
    source: "iana",
    extensions: [
      "igm"
    ]
  },
  "application/vnd.intercon.formnet": {
    source: "iana",
    extensions: [
      "xpw",
      "xpx"
    ]
  },
  "application/vnd.intergeo": {
    source: "iana",
    extensions: [
      "i2g"
    ]
  },
  "application/vnd.intertrust.digibox": {
    source: "iana"
  },
  "application/vnd.intertrust.nncp": {
    source: "iana"
  },
  "application/vnd.intu.qbo": {
    source: "iana",
    extensions: [
      "qbo"
    ]
  },
  "application/vnd.intu.qfx": {
    source: "iana",
    extensions: [
      "qfx"
    ]
  },
  "application/vnd.ipfs.ipns-record": {
    source: "iana"
  },
  "application/vnd.ipld.car": {
    source: "iana"
  },
  "application/vnd.ipld.dag-cbor": {
    source: "iana"
  },
  "application/vnd.ipld.dag-json": {
    source: "iana"
  },
  "application/vnd.ipld.raw": {
    source: "iana"
  },
  "application/vnd.iptc.g2.catalogitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.conceptitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.knowledgeitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.newsitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.newsmessage+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.packageitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.planningitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ipunplugged.rcprofile": {
    source: "iana",
    extensions: [
      "rcprofile"
    ]
  },
  "application/vnd.irepository.package+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "irp"
    ]
  },
  "application/vnd.is-xpr": {
    source: "iana",
    extensions: [
      "xpr"
    ]
  },
  "application/vnd.isac.fcs": {
    source: "iana",
    extensions: [
      "fcs"
    ]
  },
  "application/vnd.iso11783-10+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.jam": {
    source: "iana",
    extensions: [
      "jam"
    ]
  },
  "application/vnd.japannet-directory-service": {
    source: "iana"
  },
  "application/vnd.japannet-jpnstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-payment-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-registration": {
    source: "iana"
  },
  "application/vnd.japannet-registration-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-setstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-verification": {
    source: "iana"
  },
  "application/vnd.japannet-verification-wakeup": {
    source: "iana"
  },
  "application/vnd.jcp.javame.midlet-rms": {
    source: "iana",
    extensions: [
      "rms"
    ]
  },
  "application/vnd.jisp": {
    source: "iana",
    extensions: [
      "jisp"
    ]
  },
  "application/vnd.joost.joda-archive": {
    source: "iana",
    extensions: [
      "joda"
    ]
  },
  "application/vnd.jsk.isdn-ngn": {
    source: "iana"
  },
  "application/vnd.kahootz": {
    source: "iana",
    extensions: [
      "ktz",
      "ktr"
    ]
  },
  "application/vnd.kde.karbon": {
    source: "iana",
    extensions: [
      "karbon"
    ]
  },
  "application/vnd.kde.kchart": {
    source: "iana",
    extensions: [
      "chrt"
    ]
  },
  "application/vnd.kde.kformula": {
    source: "iana",
    extensions: [
      "kfo"
    ]
  },
  "application/vnd.kde.kivio": {
    source: "iana",
    extensions: [
      "flw"
    ]
  },
  "application/vnd.kde.kontour": {
    source: "iana",
    extensions: [
      "kon"
    ]
  },
  "application/vnd.kde.kpresenter": {
    source: "iana",
    extensions: [
      "kpr",
      "kpt"
    ]
  },
  "application/vnd.kde.kspread": {
    source: "iana",
    extensions: [
      "ksp"
    ]
  },
  "application/vnd.kde.kword": {
    source: "iana",
    extensions: [
      "kwd",
      "kwt"
    ]
  },
  "application/vnd.kenameaapp": {
    source: "iana",
    extensions: [
      "htke"
    ]
  },
  "application/vnd.kidspiration": {
    source: "iana",
    extensions: [
      "kia"
    ]
  },
  "application/vnd.kinar": {
    source: "iana",
    extensions: [
      "kne",
      "knp"
    ]
  },
  "application/vnd.koan": {
    source: "iana",
    extensions: [
      "skp",
      "skd",
      "skt",
      "skm"
    ]
  },
  "application/vnd.kodak-descriptor": {
    source: "iana",
    extensions: [
      "sse"
    ]
  },
  "application/vnd.las": {
    source: "iana"
  },
  "application/vnd.las.las+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.las.las+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lasxml"
    ]
  },
  "application/vnd.laszip": {
    source: "iana"
  },
  "application/vnd.ldev.productlicensing": {
    source: "iana"
  },
  "application/vnd.leap+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.liberty-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.llamagraphics.life-balance.desktop": {
    source: "iana",
    extensions: [
      "lbd"
    ]
  },
  "application/vnd.llamagraphics.life-balance.exchange+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lbe"
    ]
  },
  "application/vnd.logipipe.circuit+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.loom": {
    source: "iana"
  },
  "application/vnd.lotus-1-2-3": {
    source: "iana",
    extensions: [
      "123"
    ]
  },
  "application/vnd.lotus-approach": {
    source: "iana",
    extensions: [
      "apr"
    ]
  },
  "application/vnd.lotus-freelance": {
    source: "iana",
    extensions: [
      "pre"
    ]
  },
  "application/vnd.lotus-notes": {
    source: "iana",
    extensions: [
      "nsf"
    ]
  },
  "application/vnd.lotus-organizer": {
    source: "iana",
    extensions: [
      "org"
    ]
  },
  "application/vnd.lotus-screencam": {
    source: "iana",
    extensions: [
      "scm"
    ]
  },
  "application/vnd.lotus-wordpro": {
    source: "iana",
    extensions: [
      "lwp"
    ]
  },
  "application/vnd.macports.portpkg": {
    source: "iana",
    extensions: [
      "portpkg"
    ]
  },
  "application/vnd.mapbox-vector-tile": {
    source: "iana",
    extensions: [
      "mvt"
    ]
  },
  "application/vnd.marlin.drm.actiontoken+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.conftoken+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.license+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.mdcf": {
    source: "iana"
  },
  "application/vnd.mason+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.maxar.archive.3tz+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.maxmind.maxmind-db": {
    source: "iana"
  },
  "application/vnd.mcd": {
    source: "iana",
    extensions: [
      "mcd"
    ]
  },
  "application/vnd.mdl": {
    source: "iana"
  },
  "application/vnd.mdl-mbsdf": {
    source: "iana"
  },
  "application/vnd.medcalcdata": {
    source: "iana",
    extensions: [
      "mc1"
    ]
  },
  "application/vnd.mediastation.cdkey": {
    source: "iana",
    extensions: [
      "cdkey"
    ]
  },
  "application/vnd.medicalholodeck.recordxr": {
    source: "iana"
  },
  "application/vnd.meridian-slingshot": {
    source: "iana"
  },
  "application/vnd.mermaid": {
    source: "iana"
  },
  "application/vnd.mfer": {
    source: "iana",
    extensions: [
      "mwf"
    ]
  },
  "application/vnd.mfmp": {
    source: "iana",
    extensions: [
      "mfm"
    ]
  },
  "application/vnd.micro+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.micrografx.flo": {
    source: "iana",
    extensions: [
      "flo"
    ]
  },
  "application/vnd.micrografx.igx": {
    source: "iana",
    extensions: [
      "igx"
    ]
  },
  "application/vnd.microsoft.portable-executable": {
    source: "iana"
  },
  "application/vnd.microsoft.windows.thumbnail-cache": {
    source: "iana"
  },
  "application/vnd.miele+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.mif": {
    source: "iana",
    extensions: [
      "mif"
    ]
  },
  "application/vnd.minisoft-hp3000-save": {
    source: "iana"
  },
  "application/vnd.mitsubishi.misty-guard.trustweb": {
    source: "iana"
  },
  "application/vnd.mobius.daf": {
    source: "iana",
    extensions: [
      "daf"
    ]
  },
  "application/vnd.mobius.dis": {
    source: "iana",
    extensions: [
      "dis"
    ]
  },
  "application/vnd.mobius.mbk": {
    source: "iana",
    extensions: [
      "mbk"
    ]
  },
  "application/vnd.mobius.mqy": {
    source: "iana",
    extensions: [
      "mqy"
    ]
  },
  "application/vnd.mobius.msl": {
    source: "iana",
    extensions: [
      "msl"
    ]
  },
  "application/vnd.mobius.plc": {
    source: "iana",
    extensions: [
      "plc"
    ]
  },
  "application/vnd.mobius.txf": {
    source: "iana",
    extensions: [
      "txf"
    ]
  },
  "application/vnd.modl": {
    source: "iana"
  },
  "application/vnd.mophun.application": {
    source: "iana",
    extensions: [
      "mpn"
    ]
  },
  "application/vnd.mophun.certificate": {
    source: "iana",
    extensions: [
      "mpc"
    ]
  },
  "application/vnd.motorola.flexsuite": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.adsi": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.fis": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.gotap": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.kmr": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.ttc": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.wem": {
    source: "iana"
  },
  "application/vnd.motorola.iprm": {
    source: "iana"
  },
  "application/vnd.mozilla.xul+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xul"
    ]
  },
  "application/vnd.ms-3mfdocument": {
    source: "iana"
  },
  "application/vnd.ms-artgalry": {
    source: "iana",
    extensions: [
      "cil"
    ]
  },
  "application/vnd.ms-asf": {
    source: "iana"
  },
  "application/vnd.ms-cab-compressed": {
    source: "iana",
    extensions: [
      "cab"
    ]
  },
  "application/vnd.ms-color.iccprofile": {
    source: "apache"
  },
  "application/vnd.ms-excel": {
    source: "iana",
    compressible: false,
    extensions: [
      "xls",
      "xlm",
      "xla",
      "xlc",
      "xlt",
      "xlw"
    ]
  },
  "application/vnd.ms-excel.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlam"
    ]
  },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsb"
    ]
  },
  "application/vnd.ms-excel.sheet.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsm"
    ]
  },
  "application/vnd.ms-excel.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "xltm"
    ]
  },
  "application/vnd.ms-fontobject": {
    source: "iana",
    compressible: true,
    extensions: [
      "eot"
    ]
  },
  "application/vnd.ms-htmlhelp": {
    source: "iana",
    extensions: [
      "chm"
    ]
  },
  "application/vnd.ms-ims": {
    source: "iana",
    extensions: [
      "ims"
    ]
  },
  "application/vnd.ms-lrm": {
    source: "iana",
    extensions: [
      "lrm"
    ]
  },
  "application/vnd.ms-office.activex+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-officetheme": {
    source: "iana",
    extensions: [
      "thmx"
    ]
  },
  "application/vnd.ms-opentype": {
    source: "apache",
    compressible: true
  },
  "application/vnd.ms-outlook": {
    compressible: false,
    extensions: [
      "msg"
    ]
  },
  "application/vnd.ms-package.obfuscated-opentype": {
    source: "apache"
  },
  "application/vnd.ms-pki.seccat": {
    source: "apache",
    extensions: [
      "cat"
    ]
  },
  "application/vnd.ms-pki.stl": {
    source: "apache",
    extensions: [
      "stl"
    ]
  },
  "application/vnd.ms-playready.initiator+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-powerpoint": {
    source: "iana",
    compressible: false,
    extensions: [
      "ppt",
      "pps",
      "pot"
    ]
  },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppam"
    ]
  },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
    source: "iana",
    extensions: [
      "pptm"
    ]
  },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
    source: "iana",
    extensions: [
      "sldm"
    ]
  },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppsm"
    ]
  },
  "application/vnd.ms-powerpoint.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "potm"
    ]
  },
  "application/vnd.ms-printdevicecapabilities+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-printing.printticket+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.ms-printschematicket+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-project": {
    source: "iana",
    extensions: [
      "mpp",
      "mpt"
    ]
  },
  "application/vnd.ms-tnef": {
    source: "iana"
  },
  "application/vnd.ms-windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.nwprinting.oob": {
    source: "iana"
  },
  "application/vnd.ms-windows.printerpairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.wsd.oob": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-resp": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-resp": {
    source: "iana"
  },
  "application/vnd.ms-word.document.macroenabled.12": {
    source: "iana",
    extensions: [
      "docm"
    ]
  },
  "application/vnd.ms-word.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "dotm"
    ]
  },
  "application/vnd.ms-works": {
    source: "iana",
    extensions: [
      "wps",
      "wks",
      "wcm",
      "wdb"
    ]
  },
  "application/vnd.ms-wpl": {
    source: "iana",
    extensions: [
      "wpl"
    ]
  },
  "application/vnd.ms-xpsdocument": {
    source: "iana",
    compressible: false,
    extensions: [
      "xps"
    ]
  },
  "application/vnd.msa-disk-image": {
    source: "iana"
  },
  "application/vnd.mseq": {
    source: "iana",
    extensions: [
      "mseq"
    ]
  },
  "application/vnd.msgpack": {
    source: "iana"
  },
  "application/vnd.msign": {
    source: "iana"
  },
  "application/vnd.multiad.creator": {
    source: "iana"
  },
  "application/vnd.multiad.creator.cif": {
    source: "iana"
  },
  "application/vnd.music-niff": {
    source: "iana"
  },
  "application/vnd.musician": {
    source: "iana",
    extensions: [
      "mus"
    ]
  },
  "application/vnd.muvee.style": {
    source: "iana",
    extensions: [
      "msty"
    ]
  },
  "application/vnd.mynfc": {
    source: "iana",
    extensions: [
      "taglet"
    ]
  },
  "application/vnd.nacamar.ybrid+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nato.bindingdataobject+cbor": {
    source: "iana"
  },
  "application/vnd.nato.bindingdataobject+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nato.bindingdataobject+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "bdo"
    ]
  },
  "application/vnd.nato.openxmlformats-package.iepd+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.ncd.control": {
    source: "iana"
  },
  "application/vnd.ncd.reference": {
    source: "iana"
  },
  "application/vnd.nearst.inv+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nebumind.line": {
    source: "iana"
  },
  "application/vnd.nervana": {
    source: "iana"
  },
  "application/vnd.netfpx": {
    source: "iana"
  },
  "application/vnd.neurolanguage.nlu": {
    source: "iana",
    extensions: [
      "nlu"
    ]
  },
  "application/vnd.nimn": {
    source: "iana"
  },
  "application/vnd.nintendo.nitro.rom": {
    source: "iana"
  },
  "application/vnd.nintendo.snes.rom": {
    source: "iana"
  },
  "application/vnd.nitf": {
    source: "iana",
    extensions: [
      "ntf",
      "nitf"
    ]
  },
  "application/vnd.noblenet-directory": {
    source: "iana",
    extensions: [
      "nnd"
    ]
  },
  "application/vnd.noblenet-sealer": {
    source: "iana",
    extensions: [
      "nns"
    ]
  },
  "application/vnd.noblenet-web": {
    source: "iana",
    extensions: [
      "nnw"
    ]
  },
  "application/vnd.nokia.catalogs": {
    source: "iana"
  },
  "application/vnd.nokia.conml+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.conml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.iptv.config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.isds-radio-presets": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.landmarkcollection+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.n-gage.ac+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ac"
    ]
  },
  "application/vnd.nokia.n-gage.data": {
    source: "iana",
    extensions: [
      "ngdat"
    ]
  },
  "application/vnd.nokia.n-gage.symbian.install": {
    source: "apache",
    extensions: [
      "n-gage"
    ]
  },
  "application/vnd.nokia.ncd": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.radio-preset": {
    source: "iana",
    extensions: [
      "rpst"
    ]
  },
  "application/vnd.nokia.radio-presets": {
    source: "iana",
    extensions: [
      "rpss"
    ]
  },
  "application/vnd.novadigm.edm": {
    source: "iana",
    extensions: [
      "edm"
    ]
  },
  "application/vnd.novadigm.edx": {
    source: "iana",
    extensions: [
      "edx"
    ]
  },
  "application/vnd.novadigm.ext": {
    source: "iana",
    extensions: [
      "ext"
    ]
  },
  "application/vnd.ntt-local.content-share": {
    source: "iana"
  },
  "application/vnd.ntt-local.file-transfer": {
    source: "iana"
  },
  "application/vnd.ntt-local.ogw_remote-access": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_remote": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_tcp_stream": {
    source: "iana"
  },
  "application/vnd.oai.workflows": {
    source: "iana"
  },
  "application/vnd.oai.workflows+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oai.workflows+yaml": {
    source: "iana"
  },
  "application/vnd.oasis.opendocument.base": {
    source: "iana"
  },
  "application/vnd.oasis.opendocument.chart": {
    source: "iana",
    extensions: [
      "odc"
    ]
  },
  "application/vnd.oasis.opendocument.chart-template": {
    source: "iana",
    extensions: [
      "otc"
    ]
  },
  "application/vnd.oasis.opendocument.database": {
    source: "apache",
    extensions: [
      "odb"
    ]
  },
  "application/vnd.oasis.opendocument.formula": {
    source: "iana",
    extensions: [
      "odf"
    ]
  },
  "application/vnd.oasis.opendocument.formula-template": {
    source: "iana",
    extensions: [
      "odft"
    ]
  },
  "application/vnd.oasis.opendocument.graphics": {
    source: "iana",
    compressible: false,
    extensions: [
      "odg"
    ]
  },
  "application/vnd.oasis.opendocument.graphics-template": {
    source: "iana",
    extensions: [
      "otg"
    ]
  },
  "application/vnd.oasis.opendocument.image": {
    source: "iana",
    extensions: [
      "odi"
    ]
  },
  "application/vnd.oasis.opendocument.image-template": {
    source: "iana",
    extensions: [
      "oti"
    ]
  },
  "application/vnd.oasis.opendocument.presentation": {
    source: "iana",
    compressible: false,
    extensions: [
      "odp"
    ]
  },
  "application/vnd.oasis.opendocument.presentation-template": {
    source: "iana",
    extensions: [
      "otp"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet": {
    source: "iana",
    compressible: false,
    extensions: [
      "ods"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet-template": {
    source: "iana",
    extensions: [
      "ots"
    ]
  },
  "application/vnd.oasis.opendocument.text": {
    source: "iana",
    compressible: false,
    extensions: [
      "odt"
    ]
  },
  "application/vnd.oasis.opendocument.text-master": {
    source: "iana",
    extensions: [
      "odm"
    ]
  },
  "application/vnd.oasis.opendocument.text-master-template": {
    source: "iana"
  },
  "application/vnd.oasis.opendocument.text-template": {
    source: "iana",
    extensions: [
      "ott"
    ]
  },
  "application/vnd.oasis.opendocument.text-web": {
    source: "iana",
    extensions: [
      "oth"
    ]
  },
  "application/vnd.obn": {
    source: "iana"
  },
  "application/vnd.ocf+cbor": {
    source: "iana"
  },
  "application/vnd.oci.image.manifest.v1+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oftn.l10n+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.contentaccessdownload+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.contentaccessstreaming+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.cspg-hexbinary": {
    source: "iana"
  },
  "application/vnd.oipf.dae.svg+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.dae.xhtml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.mippvcontrolmessage+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.pae.gem": {
    source: "iana"
  },
  "application/vnd.oipf.spdiscovery+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.spdlist+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.ueprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.userprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.olpc-sugar": {
    source: "iana",
    extensions: [
      "xo"
    ]
  },
  "application/vnd.oma-scws-config": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-request": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-response": {
    source: "iana"
  },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.drm-trigger+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.oma.bcast.imd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.ltkm": {
    source: "iana"
  },
  "application/vnd.oma.bcast.notification+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.provisioningtrigger": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgboot": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgdd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.sgdu": {
    source: "iana"
  },
  "application/vnd.oma.bcast.simple-symbol-container": {
    source: "iana"
  },
  "application/vnd.oma.bcast.smartcard-trigger+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.oma.bcast.sprov+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.stkm": {
    source: "iana"
  },
  "application/vnd.oma.cab-address-book+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-feature-handler+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-pcc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-subs-invite+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-user-prefs+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.dcd": {
    source: "iana"
  },
  "application/vnd.oma.dcdc": {
    source: "iana"
  },
  "application/vnd.oma.dd2+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dd2"
    ]
  },
  "application/vnd.oma.drm.risd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.group-usage-list+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.lwm2m+cbor": {
    source: "iana"
  },
  "application/vnd.oma.lwm2m+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.lwm2m+tlv": {
    source: "iana"
  },
  "application/vnd.oma.pal+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.detailed-progress-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.final-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.groups+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.invocation-descriptor+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.optimized-progress-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.push": {
    source: "iana"
  },
  "application/vnd.oma.scidm.messages+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.xcap-directory+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.omads-email+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omads-file+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omads-folder+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omaloc-supl-init": {
    source: "iana"
  },
  "application/vnd.onepager": {
    source: "iana"
  },
  "application/vnd.onepagertamp": {
    source: "iana"
  },
  "application/vnd.onepagertamx": {
    source: "iana"
  },
  "application/vnd.onepagertat": {
    source: "iana"
  },
  "application/vnd.onepagertatp": {
    source: "iana"
  },
  "application/vnd.onepagertatx": {
    source: "iana"
  },
  "application/vnd.onvif.metadata": {
    source: "iana"
  },
  "application/vnd.openblox.game+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "obgx"
    ]
  },
  "application/vnd.openblox.game-binary": {
    source: "iana"
  },
  "application/vnd.openeye.oeb": {
    source: "iana"
  },
  "application/vnd.openofficeorg.extension": {
    source: "apache",
    extensions: [
      "oxt"
    ]
  },
  "application/vnd.openstreetmap.data+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "osm"
    ]
  },
  "application/vnd.opentimestamps.ots": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawing+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
    source: "iana",
    compressible: false,
    extensions: [
      "pptx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
    source: "iana",
    extensions: [
      "sldx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
    source: "iana",
    extensions: [
      "ppsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template": {
    source: "iana",
    extensions: [
      "potx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    source: "iana",
    compressible: false,
    extensions: [
      "xlsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
    source: "iana",
    extensions: [
      "xltx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.theme+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.vmldrawing": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    source: "iana",
    compressible: false,
    extensions: [
      "docx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
    source: "iana",
    extensions: [
      "dotx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.core-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.relationships+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oracle.resource+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.orange.indata": {
    source: "iana"
  },
  "application/vnd.osa.netdeploy": {
    source: "iana"
  },
  "application/vnd.osgeo.mapguide.package": {
    source: "iana",
    extensions: [
      "mgp"
    ]
  },
  "application/vnd.osgi.bundle": {
    source: "iana"
  },
  "application/vnd.osgi.dp": {
    source: "iana",
    extensions: [
      "dp"
    ]
  },
  "application/vnd.osgi.subsystem": {
    source: "iana",
    extensions: [
      "esa"
    ]
  },
  "application/vnd.otps.ct-kip+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oxli.countgraph": {
    source: "iana"
  },
  "application/vnd.pagerduty+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.palm": {
    source: "iana",
    extensions: [
      "pdb",
      "pqa",
      "oprc"
    ]
  },
  "application/vnd.panoply": {
    source: "iana"
  },
  "application/vnd.paos.xml": {
    source: "iana"
  },
  "application/vnd.patentdive": {
    source: "iana"
  },
  "application/vnd.patientecommsdoc": {
    source: "iana"
  },
  "application/vnd.pawaafile": {
    source: "iana",
    extensions: [
      "paw"
    ]
  },
  "application/vnd.pcos": {
    source: "iana"
  },
  "application/vnd.pg.format": {
    source: "iana",
    extensions: [
      "str"
    ]
  },
  "application/vnd.pg.osasli": {
    source: "iana",
    extensions: [
      "ei6"
    ]
  },
  "application/vnd.piaccess.application-licence": {
    source: "iana"
  },
  "application/vnd.picsel": {
    source: "iana",
    extensions: [
      "efif"
    ]
  },
  "application/vnd.pmi.widget": {
    source: "iana",
    extensions: [
      "wg"
    ]
  },
  "application/vnd.poc.group-advertisement+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.pocketlearn": {
    source: "iana",
    extensions: [
      "plf"
    ]
  },
  "application/vnd.powerbuilder6": {
    source: "iana",
    extensions: [
      "pbd"
    ]
  },
  "application/vnd.powerbuilder6-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder7": {
    source: "iana"
  },
  "application/vnd.powerbuilder7-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder75": {
    source: "iana"
  },
  "application/vnd.powerbuilder75-s": {
    source: "iana"
  },
  "application/vnd.preminet": {
    source: "iana"
  },
  "application/vnd.previewsystems.box": {
    source: "iana",
    extensions: [
      "box"
    ]
  },
  "application/vnd.proteus.magazine": {
    source: "iana",
    extensions: [
      "mgz"
    ]
  },
  "application/vnd.psfs": {
    source: "iana"
  },
  "application/vnd.pt.mundusmundi": {
    source: "iana"
  },
  "application/vnd.publishare-delta-tree": {
    source: "iana",
    extensions: [
      "qps"
    ]
  },
  "application/vnd.pvi.ptid1": {
    source: "iana",
    extensions: [
      "ptid"
    ]
  },
  "application/vnd.pwg-multiplexed": {
    source: "iana"
  },
  "application/vnd.pwg-xhtml-print+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xhtm"
    ]
  },
  "application/vnd.qualcomm.brew-app-res": {
    source: "iana"
  },
  "application/vnd.quarantainenet": {
    source: "iana"
  },
  "application/vnd.quark.quarkxpress": {
    source: "iana",
    extensions: [
      "qxd",
      "qxt",
      "qwd",
      "qwt",
      "qxl",
      "qxb"
    ]
  },
  "application/vnd.quobject-quoxdocument": {
    source: "iana"
  },
  "application/vnd.radisys.moml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-conf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-conn+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-dialog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-stream+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-conf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-base+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-group+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-speech+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-transform+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.rainstor.data": {
    source: "iana"
  },
  "application/vnd.rapid": {
    source: "iana"
  },
  "application/vnd.rar": {
    source: "iana",
    extensions: [
      "rar"
    ]
  },
  "application/vnd.realvnc.bed": {
    source: "iana",
    extensions: [
      "bed"
    ]
  },
  "application/vnd.recordare.musicxml": {
    source: "iana",
    extensions: [
      "mxl"
    ]
  },
  "application/vnd.recordare.musicxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "musicxml"
    ]
  },
  "application/vnd.relpipe": {
    source: "iana"
  },
  "application/vnd.renlearn.rlprint": {
    source: "iana"
  },
  "application/vnd.resilient.logic": {
    source: "iana"
  },
  "application/vnd.restful+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.rig.cryptonote": {
    source: "iana",
    extensions: [
      "cryptonote"
    ]
  },
  "application/vnd.rim.cod": {
    source: "apache",
    extensions: [
      "cod"
    ]
  },
  "application/vnd.rn-realmedia": {
    source: "apache",
    extensions: [
      "rm"
    ]
  },
  "application/vnd.rn-realmedia-vbr": {
    source: "apache",
    extensions: [
      "rmvb"
    ]
  },
  "application/vnd.route66.link66+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "link66"
    ]
  },
  "application/vnd.rs-274x": {
    source: "iana"
  },
  "application/vnd.ruckus.download": {
    source: "iana"
  },
  "application/vnd.s3sms": {
    source: "iana"
  },
  "application/vnd.sailingtracker.track": {
    source: "iana",
    extensions: [
      "st"
    ]
  },
  "application/vnd.sar": {
    source: "iana"
  },
  "application/vnd.sbm.cid": {
    source: "iana"
  },
  "application/vnd.sbm.mid2": {
    source: "iana"
  },
  "application/vnd.scribus": {
    source: "iana"
  },
  "application/vnd.sealed.3df": {
    source: "iana"
  },
  "application/vnd.sealed.csf": {
    source: "iana"
  },
  "application/vnd.sealed.doc": {
    source: "iana"
  },
  "application/vnd.sealed.eml": {
    source: "iana"
  },
  "application/vnd.sealed.mht": {
    source: "iana"
  },
  "application/vnd.sealed.net": {
    source: "iana"
  },
  "application/vnd.sealed.ppt": {
    source: "iana"
  },
  "application/vnd.sealed.tiff": {
    source: "iana"
  },
  "application/vnd.sealed.xls": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.html": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.pdf": {
    source: "iana"
  },
  "application/vnd.seemail": {
    source: "iana",
    extensions: [
      "see"
    ]
  },
  "application/vnd.seis+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.sema": {
    source: "iana",
    extensions: [
      "sema"
    ]
  },
  "application/vnd.semd": {
    source: "iana",
    extensions: [
      "semd"
    ]
  },
  "application/vnd.semf": {
    source: "iana",
    extensions: [
      "semf"
    ]
  },
  "application/vnd.shade-save-file": {
    source: "iana"
  },
  "application/vnd.shana.informed.formdata": {
    source: "iana",
    extensions: [
      "ifm"
    ]
  },
  "application/vnd.shana.informed.formtemplate": {
    source: "iana",
    extensions: [
      "itp"
    ]
  },
  "application/vnd.shana.informed.interchange": {
    source: "iana",
    extensions: [
      "iif"
    ]
  },
  "application/vnd.shana.informed.package": {
    source: "iana",
    extensions: [
      "ipk"
    ]
  },
  "application/vnd.shootproof+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.shopkick+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.shp": {
    source: "iana"
  },
  "application/vnd.shx": {
    source: "iana"
  },
  "application/vnd.sigrok.session": {
    source: "iana"
  },
  "application/vnd.simtech-mindmapper": {
    source: "iana",
    extensions: [
      "twd",
      "twds"
    ]
  },
  "application/vnd.siren+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.smaf": {
    source: "iana",
    extensions: [
      "mmf"
    ]
  },
  "application/vnd.smart.notebook": {
    source: "iana"
  },
  "application/vnd.smart.teacher": {
    source: "iana",
    extensions: [
      "teacher"
    ]
  },
  "application/vnd.smintio.portals.archive": {
    source: "iana"
  },
  "application/vnd.snesdev-page-table": {
    source: "iana"
  },
  "application/vnd.software602.filler.form+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "fo"
    ]
  },
  "application/vnd.software602.filler.form-xml-zip": {
    source: "iana"
  },
  "application/vnd.solent.sdkm+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sdkm",
      "sdkd"
    ]
  },
  "application/vnd.spotfire.dxp": {
    source: "iana",
    extensions: [
      "dxp"
    ]
  },
  "application/vnd.spotfire.sfs": {
    source: "iana",
    extensions: [
      "sfs"
    ]
  },
  "application/vnd.sqlite3": {
    source: "iana"
  },
  "application/vnd.sss-cod": {
    source: "iana"
  },
  "application/vnd.sss-dtf": {
    source: "iana"
  },
  "application/vnd.sss-ntf": {
    source: "iana"
  },
  "application/vnd.stardivision.calc": {
    source: "apache",
    extensions: [
      "sdc"
    ]
  },
  "application/vnd.stardivision.draw": {
    source: "apache",
    extensions: [
      "sda"
    ]
  },
  "application/vnd.stardivision.impress": {
    source: "apache",
    extensions: [
      "sdd"
    ]
  },
  "application/vnd.stardivision.math": {
    source: "apache",
    extensions: [
      "smf"
    ]
  },
  "application/vnd.stardivision.writer": {
    source: "apache",
    extensions: [
      "sdw",
      "vor"
    ]
  },
  "application/vnd.stardivision.writer-global": {
    source: "apache",
    extensions: [
      "sgl"
    ]
  },
  "application/vnd.stepmania.package": {
    source: "iana",
    extensions: [
      "smzip"
    ]
  },
  "application/vnd.stepmania.stepchart": {
    source: "iana",
    extensions: [
      "sm"
    ]
  },
  "application/vnd.street-stream": {
    source: "iana"
  },
  "application/vnd.sun.wadl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wadl"
    ]
  },
  "application/vnd.sun.xml.calc": {
    source: "apache",
    extensions: [
      "sxc"
    ]
  },
  "application/vnd.sun.xml.calc.template": {
    source: "apache",
    extensions: [
      "stc"
    ]
  },
  "application/vnd.sun.xml.draw": {
    source: "apache",
    extensions: [
      "sxd"
    ]
  },
  "application/vnd.sun.xml.draw.template": {
    source: "apache",
    extensions: [
      "std"
    ]
  },
  "application/vnd.sun.xml.impress": {
    source: "apache",
    extensions: [
      "sxi"
    ]
  },
  "application/vnd.sun.xml.impress.template": {
    source: "apache",
    extensions: [
      "sti"
    ]
  },
  "application/vnd.sun.xml.math": {
    source: "apache",
    extensions: [
      "sxm"
    ]
  },
  "application/vnd.sun.xml.writer": {
    source: "apache",
    extensions: [
      "sxw"
    ]
  },
  "application/vnd.sun.xml.writer.global": {
    source: "apache",
    extensions: [
      "sxg"
    ]
  },
  "application/vnd.sun.xml.writer.template": {
    source: "apache",
    extensions: [
      "stw"
    ]
  },
  "application/vnd.sus-calendar": {
    source: "iana",
    extensions: [
      "sus",
      "susp"
    ]
  },
  "application/vnd.svd": {
    source: "iana",
    extensions: [
      "svd"
    ]
  },
  "application/vnd.swiftview-ics": {
    source: "iana"
  },
  "application/vnd.sybyl.mol2": {
    source: "iana"
  },
  "application/vnd.sycle+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.syft+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.symbian.install": {
    source: "apache",
    extensions: [
      "sis",
      "sisx"
    ]
  },
  "application/vnd.syncml+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "xsm"
    ]
  },
  "application/vnd.syncml.dm+wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "bdm"
    ]
  },
  "application/vnd.syncml.dm+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "xdm"
    ]
  },
  "application/vnd.syncml.dm.notification": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "ddf"
    ]
  },
  "application/vnd.syncml.dmtnds+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmtnds+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.syncml.ds.notification": {
    source: "iana"
  },
  "application/vnd.tableschema+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tao.intent-module-archive": {
    source: "iana",
    extensions: [
      "tao"
    ]
  },
  "application/vnd.tcpdump.pcap": {
    source: "iana",
    extensions: [
      "pcap",
      "cap",
      "dmp"
    ]
  },
  "application/vnd.think-cell.ppttc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tmd.mediaflex.api+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tml": {
    source: "iana"
  },
  "application/vnd.tmobile-livetv": {
    source: "iana",
    extensions: [
      "tmo"
    ]
  },
  "application/vnd.tri.onesource": {
    source: "iana"
  },
  "application/vnd.trid.tpt": {
    source: "iana",
    extensions: [
      "tpt"
    ]
  },
  "application/vnd.triscape.mxs": {
    source: "iana",
    extensions: [
      "mxs"
    ]
  },
  "application/vnd.trueapp": {
    source: "iana",
    extensions: [
      "tra"
    ]
  },
  "application/vnd.truedoc": {
    source: "iana"
  },
  "application/vnd.ubisoft.webplayer": {
    source: "iana"
  },
  "application/vnd.ufdl": {
    source: "iana",
    extensions: [
      "ufd",
      "ufdl"
    ]
  },
  "application/vnd.uiq.theme": {
    source: "iana",
    extensions: [
      "utz"
    ]
  },
  "application/vnd.umajin": {
    source: "iana",
    extensions: [
      "umj"
    ]
  },
  "application/vnd.unity": {
    source: "iana",
    extensions: [
      "unityweb"
    ]
  },
  "application/vnd.uoml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "uoml",
      "uo"
    ]
  },
  "application/vnd.uplanet.alert": {
    source: "iana"
  },
  "application/vnd.uplanet.alert-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.channel": {
    source: "iana"
  },
  "application/vnd.uplanet.channel-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.list": {
    source: "iana"
  },
  "application/vnd.uplanet.list-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.signal": {
    source: "iana"
  },
  "application/vnd.uri-map": {
    source: "iana"
  },
  "application/vnd.valve.source.material": {
    source: "iana"
  },
  "application/vnd.vcx": {
    source: "iana",
    extensions: [
      "vcx"
    ]
  },
  "application/vnd.vd-study": {
    source: "iana"
  },
  "application/vnd.vectorworks": {
    source: "iana"
  },
  "application/vnd.vel+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.verimatrix.vcas": {
    source: "iana"
  },
  "application/vnd.veritone.aion+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.veryant.thin": {
    source: "iana"
  },
  "application/vnd.ves.encrypted": {
    source: "iana"
  },
  "application/vnd.vidsoft.vidconference": {
    source: "iana"
  },
  "application/vnd.visio": {
    source: "iana",
    extensions: [
      "vsd",
      "vst",
      "vss",
      "vsw"
    ]
  },
  "application/vnd.visionary": {
    source: "iana",
    extensions: [
      "vis"
    ]
  },
  "application/vnd.vividence.scriptfile": {
    source: "iana"
  },
  "application/vnd.vsf": {
    source: "iana",
    extensions: [
      "vsf"
    ]
  },
  "application/vnd.wap.sic": {
    source: "iana"
  },
  "application/vnd.wap.slc": {
    source: "iana"
  },
  "application/vnd.wap.wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "wbxml"
    ]
  },
  "application/vnd.wap.wmlc": {
    source: "iana",
    extensions: [
      "wmlc"
    ]
  },
  "application/vnd.wap.wmlscriptc": {
    source: "iana",
    extensions: [
      "wmlsc"
    ]
  },
  "application/vnd.wasmflow.wafl": {
    source: "iana"
  },
  "application/vnd.webturbo": {
    source: "iana",
    extensions: [
      "wtb"
    ]
  },
  "application/vnd.wfa.dpp": {
    source: "iana"
  },
  "application/vnd.wfa.p2p": {
    source: "iana"
  },
  "application/vnd.wfa.wsc": {
    source: "iana"
  },
  "application/vnd.windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.wmc": {
    source: "iana"
  },
  "application/vnd.wmf.bootstrap": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica.package": {
    source: "iana"
  },
  "application/vnd.wolfram.player": {
    source: "iana",
    extensions: [
      "nbp"
    ]
  },
  "application/vnd.wordlift": {
    source: "iana"
  },
  "application/vnd.wordperfect": {
    source: "iana",
    extensions: [
      "wpd"
    ]
  },
  "application/vnd.wqd": {
    source: "iana",
    extensions: [
      "wqd"
    ]
  },
  "application/vnd.wrq-hp3000-labelled": {
    source: "iana"
  },
  "application/vnd.wt.stf": {
    source: "iana",
    extensions: [
      "stf"
    ]
  },
  "application/vnd.wv.csp+wbxml": {
    source: "iana"
  },
  "application/vnd.wv.csp+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.wv.ssp+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xacml+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xara": {
    source: "iana",
    extensions: [
      "xar"
    ]
  },
  "application/vnd.xecrets-encrypted": {
    source: "iana"
  },
  "application/vnd.xfdl": {
    source: "iana",
    extensions: [
      "xfdl"
    ]
  },
  "application/vnd.xfdl.webform": {
    source: "iana"
  },
  "application/vnd.xmi+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xmpie.cpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.dpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.plan": {
    source: "iana"
  },
  "application/vnd.xmpie.ppkg": {
    source: "iana"
  },
  "application/vnd.xmpie.xlim": {
    source: "iana"
  },
  "application/vnd.yamaha.hv-dic": {
    source: "iana",
    extensions: [
      "hvd"
    ]
  },
  "application/vnd.yamaha.hv-script": {
    source: "iana",
    extensions: [
      "hvs"
    ]
  },
  "application/vnd.yamaha.hv-voice": {
    source: "iana",
    extensions: [
      "hvp"
    ]
  },
  "application/vnd.yamaha.openscoreformat": {
    source: "iana",
    extensions: [
      "osf"
    ]
  },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "osfpvg"
    ]
  },
  "application/vnd.yamaha.remote-setup": {
    source: "iana"
  },
  "application/vnd.yamaha.smaf-audio": {
    source: "iana",
    extensions: [
      "saf"
    ]
  },
  "application/vnd.yamaha.smaf-phrase": {
    source: "iana",
    extensions: [
      "spf"
    ]
  },
  "application/vnd.yamaha.through-ngn": {
    source: "iana"
  },
  "application/vnd.yamaha.tunnel-udpencap": {
    source: "iana"
  },
  "application/vnd.yaoweme": {
    source: "iana"
  },
  "application/vnd.yellowriver-custom-menu": {
    source: "iana",
    extensions: [
      "cmp"
    ]
  },
  "application/vnd.zul": {
    source: "iana",
    extensions: [
      "zir",
      "zirz"
    ]
  },
  "application/vnd.zzazz.deck+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "zaz"
    ]
  },
  "application/voicexml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "vxml"
    ]
  },
  "application/voucher-cms+json": {
    source: "iana",
    compressible: true
  },
  "application/vp": {
    source: "iana"
  },
  "application/vq-rtcpxr": {
    source: "iana"
  },
  "application/wasm": {
    source: "iana",
    compressible: true,
    extensions: [
      "wasm"
    ]
  },
  "application/watcherinfo+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wif"
    ]
  },
  "application/webpush-options+json": {
    source: "iana",
    compressible: true
  },
  "application/whoispp-query": {
    source: "iana"
  },
  "application/whoispp-response": {
    source: "iana"
  },
  "application/widget": {
    source: "iana",
    extensions: [
      "wgt"
    ]
  },
  "application/winhlp": {
    source: "apache",
    extensions: [
      "hlp"
    ]
  },
  "application/wita": {
    source: "iana"
  },
  "application/wordperfect5.1": {
    source: "iana"
  },
  "application/wsdl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wsdl"
    ]
  },
  "application/wspolicy+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wspolicy"
    ]
  },
  "application/x-7z-compressed": {
    source: "apache",
    compressible: false,
    extensions: [
      "7z"
    ]
  },
  "application/x-abiword": {
    source: "apache",
    extensions: [
      "abw"
    ]
  },
  "application/x-ace-compressed": {
    source: "apache",
    extensions: [
      "ace"
    ]
  },
  "application/x-amf": {
    source: "apache"
  },
  "application/x-apple-diskimage": {
    source: "apache",
    extensions: [
      "dmg"
    ]
  },
  "application/x-arj": {
    compressible: false,
    extensions: [
      "arj"
    ]
  },
  "application/x-authorware-bin": {
    source: "apache",
    extensions: [
      "aab",
      "x32",
      "u32",
      "vox"
    ]
  },
  "application/x-authorware-map": {
    source: "apache",
    extensions: [
      "aam"
    ]
  },
  "application/x-authorware-seg": {
    source: "apache",
    extensions: [
      "aas"
    ]
  },
  "application/x-bcpio": {
    source: "apache",
    extensions: [
      "bcpio"
    ]
  },
  "application/x-bdoc": {
    compressible: false,
    extensions: [
      "bdoc"
    ]
  },
  "application/x-bittorrent": {
    source: "apache",
    extensions: [
      "torrent"
    ]
  },
  "application/x-blorb": {
    source: "apache",
    extensions: [
      "blb",
      "blorb"
    ]
  },
  "application/x-bzip": {
    source: "apache",
    compressible: false,
    extensions: [
      "bz"
    ]
  },
  "application/x-bzip2": {
    source: "apache",
    compressible: false,
    extensions: [
      "bz2",
      "boz"
    ]
  },
  "application/x-cbr": {
    source: "apache",
    extensions: [
      "cbr",
      "cba",
      "cbt",
      "cbz",
      "cb7"
    ]
  },
  "application/x-cdlink": {
    source: "apache",
    extensions: [
      "vcd"
    ]
  },
  "application/x-cfs-compressed": {
    source: "apache",
    extensions: [
      "cfs"
    ]
  },
  "application/x-chat": {
    source: "apache",
    extensions: [
      "chat"
    ]
  },
  "application/x-chess-pgn": {
    source: "apache",
    extensions: [
      "pgn"
    ]
  },
  "application/x-chrome-extension": {
    extensions: [
      "crx"
    ]
  },
  "application/x-cocoa": {
    source: "nginx",
    extensions: [
      "cco"
    ]
  },
  "application/x-compress": {
    source: "apache"
  },
  "application/x-conference": {
    source: "apache",
    extensions: [
      "nsc"
    ]
  },
  "application/x-cpio": {
    source: "apache",
    extensions: [
      "cpio"
    ]
  },
  "application/x-csh": {
    source: "apache",
    extensions: [
      "csh"
    ]
  },
  "application/x-deb": {
    compressible: false
  },
  "application/x-debian-package": {
    source: "apache",
    extensions: [
      "deb",
      "udeb"
    ]
  },
  "application/x-dgc-compressed": {
    source: "apache",
    extensions: [
      "dgc"
    ]
  },
  "application/x-director": {
    source: "apache",
    extensions: [
      "dir",
      "dcr",
      "dxr",
      "cst",
      "cct",
      "cxt",
      "w3d",
      "fgd",
      "swa"
    ]
  },
  "application/x-doom": {
    source: "apache",
    extensions: [
      "wad"
    ]
  },
  "application/x-dtbncx+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "ncx"
    ]
  },
  "application/x-dtbook+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "dtb"
    ]
  },
  "application/x-dtbresource+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "res"
    ]
  },
  "application/x-dvi": {
    source: "apache",
    compressible: false,
    extensions: [
      "dvi"
    ]
  },
  "application/x-envoy": {
    source: "apache",
    extensions: [
      "evy"
    ]
  },
  "application/x-eva": {
    source: "apache",
    extensions: [
      "eva"
    ]
  },
  "application/x-font-bdf": {
    source: "apache",
    extensions: [
      "bdf"
    ]
  },
  "application/x-font-dos": {
    source: "apache"
  },
  "application/x-font-framemaker": {
    source: "apache"
  },
  "application/x-font-ghostscript": {
    source: "apache",
    extensions: [
      "gsf"
    ]
  },
  "application/x-font-libgrx": {
    source: "apache"
  },
  "application/x-font-linux-psf": {
    source: "apache",
    extensions: [
      "psf"
    ]
  },
  "application/x-font-pcf": {
    source: "apache",
    extensions: [
      "pcf"
    ]
  },
  "application/x-font-snf": {
    source: "apache",
    extensions: [
      "snf"
    ]
  },
  "application/x-font-speedo": {
    source: "apache"
  },
  "application/x-font-sunos-news": {
    source: "apache"
  },
  "application/x-font-type1": {
    source: "apache",
    extensions: [
      "pfa",
      "pfb",
      "pfm",
      "afm"
    ]
  },
  "application/x-font-vfont": {
    source: "apache"
  },
  "application/x-freearc": {
    source: "apache",
    extensions: [
      "arc"
    ]
  },
  "application/x-futuresplash": {
    source: "apache",
    extensions: [
      "spl"
    ]
  },
  "application/x-gca-compressed": {
    source: "apache",
    extensions: [
      "gca"
    ]
  },
  "application/x-glulx": {
    source: "apache",
    extensions: [
      "ulx"
    ]
  },
  "application/x-gnumeric": {
    source: "apache",
    extensions: [
      "gnumeric"
    ]
  },
  "application/x-gramps-xml": {
    source: "apache",
    extensions: [
      "gramps"
    ]
  },
  "application/x-gtar": {
    source: "apache",
    extensions: [
      "gtar"
    ]
  },
  "application/x-gzip": {
    source: "apache"
  },
  "application/x-hdf": {
    source: "apache",
    extensions: [
      "hdf"
    ]
  },
  "application/x-httpd-php": {
    compressible: true,
    extensions: [
      "php"
    ]
  },
  "application/x-install-instructions": {
    source: "apache",
    extensions: [
      "install"
    ]
  },
  "application/x-iso9660-image": {
    source: "apache",
    extensions: [
      "iso"
    ]
  },
  "application/x-iwork-keynote-sffkey": {
    extensions: [
      "key"
    ]
  },
  "application/x-iwork-numbers-sffnumbers": {
    extensions: [
      "numbers"
    ]
  },
  "application/x-iwork-pages-sffpages": {
    extensions: [
      "pages"
    ]
  },
  "application/x-java-archive-diff": {
    source: "nginx",
    extensions: [
      "jardiff"
    ]
  },
  "application/x-java-jnlp-file": {
    source: "apache",
    compressible: false,
    extensions: [
      "jnlp"
    ]
  },
  "application/x-javascript": {
    compressible: true
  },
  "application/x-keepass2": {
    extensions: [
      "kdbx"
    ]
  },
  "application/x-latex": {
    source: "apache",
    compressible: false,
    extensions: [
      "latex"
    ]
  },
  "application/x-lua-bytecode": {
    extensions: [
      "luac"
    ]
  },
  "application/x-lzh-compressed": {
    source: "apache",
    extensions: [
      "lzh",
      "lha"
    ]
  },
  "application/x-makeself": {
    source: "nginx",
    extensions: [
      "run"
    ]
  },
  "application/x-mie": {
    source: "apache",
    extensions: [
      "mie"
    ]
  },
  "application/x-mobipocket-ebook": {
    source: "apache",
    extensions: [
      "prc",
      "mobi"
    ]
  },
  "application/x-mpegurl": {
    compressible: false
  },
  "application/x-ms-application": {
    source: "apache",
    extensions: [
      "application"
    ]
  },
  "application/x-ms-shortcut": {
    source: "apache",
    extensions: [
      "lnk"
    ]
  },
  "application/x-ms-wmd": {
    source: "apache",
    extensions: [
      "wmd"
    ]
  },
  "application/x-ms-wmz": {
    source: "apache",
    extensions: [
      "wmz"
    ]
  },
  "application/x-ms-xbap": {
    source: "apache",
    extensions: [
      "xbap"
    ]
  },
  "application/x-msaccess": {
    source: "apache",
    extensions: [
      "mdb"
    ]
  },
  "application/x-msbinder": {
    source: "apache",
    extensions: [
      "obd"
    ]
  },
  "application/x-mscardfile": {
    source: "apache",
    extensions: [
      "crd"
    ]
  },
  "application/x-msclip": {
    source: "apache",
    extensions: [
      "clp"
    ]
  },
  "application/x-msdos-program": {
    extensions: [
      "exe"
    ]
  },
  "application/x-msdownload": {
    source: "apache",
    extensions: [
      "exe",
      "dll",
      "com",
      "bat",
      "msi"
    ]
  },
  "application/x-msmediaview": {
    source: "apache",
    extensions: [
      "mvb",
      "m13",
      "m14"
    ]
  },
  "application/x-msmetafile": {
    source: "apache",
    extensions: [
      "wmf",
      "wmz",
      "emf",
      "emz"
    ]
  },
  "application/x-msmoney": {
    source: "apache",
    extensions: [
      "mny"
    ]
  },
  "application/x-mspublisher": {
    source: "apache",
    extensions: [
      "pub"
    ]
  },
  "application/x-msschedule": {
    source: "apache",
    extensions: [
      "scd"
    ]
  },
  "application/x-msterminal": {
    source: "apache",
    extensions: [
      "trm"
    ]
  },
  "application/x-mswrite": {
    source: "apache",
    extensions: [
      "wri"
    ]
  },
  "application/x-netcdf": {
    source: "apache",
    extensions: [
      "nc",
      "cdf"
    ]
  },
  "application/x-ns-proxy-autoconfig": {
    compressible: true,
    extensions: [
      "pac"
    ]
  },
  "application/x-nzb": {
    source: "apache",
    extensions: [
      "nzb"
    ]
  },
  "application/x-perl": {
    source: "nginx",
    extensions: [
      "pl",
      "pm"
    ]
  },
  "application/x-pilot": {
    source: "nginx",
    extensions: [
      "prc",
      "pdb"
    ]
  },
  "application/x-pkcs12": {
    source: "apache",
    compressible: false,
    extensions: [
      "p12",
      "pfx"
    ]
  },
  "application/x-pkcs7-certificates": {
    source: "apache",
    extensions: [
      "p7b",
      "spc"
    ]
  },
  "application/x-pkcs7-certreqresp": {
    source: "apache",
    extensions: [
      "p7r"
    ]
  },
  "application/x-pki-message": {
    source: "iana"
  },
  "application/x-rar-compressed": {
    source: "apache",
    compressible: false,
    extensions: [
      "rar"
    ]
  },
  "application/x-redhat-package-manager": {
    source: "nginx",
    extensions: [
      "rpm"
    ]
  },
  "application/x-research-info-systems": {
    source: "apache",
    extensions: [
      "ris"
    ]
  },
  "application/x-sea": {
    source: "nginx",
    extensions: [
      "sea"
    ]
  },
  "application/x-sh": {
    source: "apache",
    compressible: true,
    extensions: [
      "sh"
    ]
  },
  "application/x-shar": {
    source: "apache",
    extensions: [
      "shar"
    ]
  },
  "application/x-shockwave-flash": {
    source: "apache",
    compressible: false,
    extensions: [
      "swf"
    ]
  },
  "application/x-silverlight-app": {
    source: "apache",
    extensions: [
      "xap"
    ]
  },
  "application/x-sql": {
    source: "apache",
    extensions: [
      "sql"
    ]
  },
  "application/x-stuffit": {
    source: "apache",
    compressible: false,
    extensions: [
      "sit"
    ]
  },
  "application/x-stuffitx": {
    source: "apache",
    extensions: [
      "sitx"
    ]
  },
  "application/x-subrip": {
    source: "apache",
    extensions: [
      "srt"
    ]
  },
  "application/x-sv4cpio": {
    source: "apache",
    extensions: [
      "sv4cpio"
    ]
  },
  "application/x-sv4crc": {
    source: "apache",
    extensions: [
      "sv4crc"
    ]
  },
  "application/x-t3vm-image": {
    source: "apache",
    extensions: [
      "t3"
    ]
  },
  "application/x-tads": {
    source: "apache",
    extensions: [
      "gam"
    ]
  },
  "application/x-tar": {
    source: "apache",
    compressible: true,
    extensions: [
      "tar"
    ]
  },
  "application/x-tcl": {
    source: "apache",
    extensions: [
      "tcl",
      "tk"
    ]
  },
  "application/x-tex": {
    source: "apache",
    extensions: [
      "tex"
    ]
  },
  "application/x-tex-tfm": {
    source: "apache",
    extensions: [
      "tfm"
    ]
  },
  "application/x-texinfo": {
    source: "apache",
    extensions: [
      "texinfo",
      "texi"
    ]
  },
  "application/x-tgif": {
    source: "apache",
    extensions: [
      "obj"
    ]
  },
  "application/x-ustar": {
    source: "apache",
    extensions: [
      "ustar"
    ]
  },
  "application/x-virtualbox-hdd": {
    compressible: true,
    extensions: [
      "hdd"
    ]
  },
  "application/x-virtualbox-ova": {
    compressible: true,
    extensions: [
      "ova"
    ]
  },
  "application/x-virtualbox-ovf": {
    compressible: true,
    extensions: [
      "ovf"
    ]
  },
  "application/x-virtualbox-vbox": {
    compressible: true,
    extensions: [
      "vbox"
    ]
  },
  "application/x-virtualbox-vbox-extpack": {
    compressible: false,
    extensions: [
      "vbox-extpack"
    ]
  },
  "application/x-virtualbox-vdi": {
    compressible: true,
    extensions: [
      "vdi"
    ]
  },
  "application/x-virtualbox-vhd": {
    compressible: true,
    extensions: [
      "vhd"
    ]
  },
  "application/x-virtualbox-vmdk": {
    compressible: true,
    extensions: [
      "vmdk"
    ]
  },
  "application/x-wais-source": {
    source: "apache",
    extensions: [
      "src"
    ]
  },
  "application/x-web-app-manifest+json": {
    compressible: true,
    extensions: [
      "webapp"
    ]
  },
  "application/x-www-form-urlencoded": {
    source: "iana",
    compressible: true
  },
  "application/x-x509-ca-cert": {
    source: "iana",
    extensions: [
      "der",
      "crt",
      "pem"
    ]
  },
  "application/x-x509-ca-ra-cert": {
    source: "iana"
  },
  "application/x-x509-next-ca-cert": {
    source: "iana"
  },
  "application/x-xfig": {
    source: "apache",
    extensions: [
      "fig"
    ]
  },
  "application/x-xliff+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xlf"
    ]
  },
  "application/x-xpinstall": {
    source: "apache",
    compressible: false,
    extensions: [
      "xpi"
    ]
  },
  "application/x-xz": {
    source: "apache",
    extensions: [
      "xz"
    ]
  },
  "application/x-zmachine": {
    source: "apache",
    extensions: [
      "z1",
      "z2",
      "z3",
      "z4",
      "z5",
      "z6",
      "z7",
      "z8"
    ]
  },
  "application/x400-bp": {
    source: "iana"
  },
  "application/xacml+xml": {
    source: "iana",
    compressible: true
  },
  "application/xaml+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xaml"
    ]
  },
  "application/xcap-att+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xav"
    ]
  },
  "application/xcap-caps+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xca"
    ]
  },
  "application/xcap-diff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdf"
    ]
  },
  "application/xcap-el+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xel"
    ]
  },
  "application/xcap-error+xml": {
    source: "iana",
    compressible: true
  },
  "application/xcap-ns+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xns"
    ]
  },
  "application/xcon-conference-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/xcon-conference-info-diff+xml": {
    source: "iana",
    compressible: true
  },
  "application/xenc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xenc"
    ]
  },
  "application/xfdf": {
    source: "iana",
    extensions: [
      "xfdf"
    ]
  },
  "application/xhtml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xhtml",
      "xht"
    ]
  },
  "application/xhtml-voice+xml": {
    source: "apache",
    compressible: true
  },
  "application/xliff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xlf"
    ]
  },
  "application/xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xml",
      "xsl",
      "xsd",
      "rng"
    ]
  },
  "application/xml-dtd": {
    source: "iana",
    compressible: true,
    extensions: [
      "dtd"
    ]
  },
  "application/xml-external-parsed-entity": {
    source: "iana"
  },
  "application/xml-patch+xml": {
    source: "iana",
    compressible: true
  },
  "application/xmpp+xml": {
    source: "iana",
    compressible: true
  },
  "application/xop+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xop"
    ]
  },
  "application/xproc+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xpl"
    ]
  },
  "application/xslt+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xsl",
      "xslt"
    ]
  },
  "application/xspf+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xspf"
    ]
  },
  "application/xv+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mxml",
      "xhvml",
      "xvml",
      "xvm"
    ]
  },
  "application/yaml": {
    source: "iana"
  },
  "application/yang": {
    source: "iana",
    extensions: [
      "yang"
    ]
  },
  "application/yang-data+cbor": {
    source: "iana"
  },
  "application/yang-data+json": {
    source: "iana",
    compressible: true
  },
  "application/yang-data+xml": {
    source: "iana",
    compressible: true
  },
  "application/yang-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/yang-patch+xml": {
    source: "iana",
    compressible: true
  },
  "application/yang-sid+json": {
    source: "iana",
    compressible: true
  },
  "application/yin+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "yin"
    ]
  },
  "application/zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "zip"
    ]
  },
  "application/zlib": {
    source: "iana"
  },
  "application/zstd": {
    source: "iana"
  },
  "audio/1d-interleaved-parityfec": {
    source: "iana"
  },
  "audio/32kadpcm": {
    source: "iana"
  },
  "audio/3gpp": {
    source: "iana",
    compressible: false,
    extensions: [
      "3gpp"
    ]
  },
  "audio/3gpp2": {
    source: "iana"
  },
  "audio/aac": {
    source: "iana",
    extensions: [
      "adts",
      "aac"
    ]
  },
  "audio/ac3": {
    source: "iana"
  },
  "audio/adpcm": {
    source: "apache",
    extensions: [
      "adp"
    ]
  },
  "audio/amr": {
    source: "iana",
    extensions: [
      "amr"
    ]
  },
  "audio/amr-wb": {
    source: "iana"
  },
  "audio/amr-wb+": {
    source: "iana"
  },
  "audio/aptx": {
    source: "iana"
  },
  "audio/asc": {
    source: "iana"
  },
  "audio/atrac-advanced-lossless": {
    source: "iana"
  },
  "audio/atrac-x": {
    source: "iana"
  },
  "audio/atrac3": {
    source: "iana"
  },
  "audio/basic": {
    source: "iana",
    compressible: false,
    extensions: [
      "au",
      "snd"
    ]
  },
  "audio/bv16": {
    source: "iana"
  },
  "audio/bv32": {
    source: "iana"
  },
  "audio/clearmode": {
    source: "iana"
  },
  "audio/cn": {
    source: "iana"
  },
  "audio/dat12": {
    source: "iana"
  },
  "audio/dls": {
    source: "iana"
  },
  "audio/dsr-es201108": {
    source: "iana"
  },
  "audio/dsr-es202050": {
    source: "iana"
  },
  "audio/dsr-es202211": {
    source: "iana"
  },
  "audio/dsr-es202212": {
    source: "iana"
  },
  "audio/dv": {
    source: "iana"
  },
  "audio/dvi4": {
    source: "iana"
  },
  "audio/eac3": {
    source: "iana"
  },
  "audio/encaprtp": {
    source: "iana"
  },
  "audio/evrc": {
    source: "iana"
  },
  "audio/evrc-qcp": {
    source: "iana"
  },
  "audio/evrc0": {
    source: "iana"
  },
  "audio/evrc1": {
    source: "iana"
  },
  "audio/evrcb": {
    source: "iana"
  },
  "audio/evrcb0": {
    source: "iana"
  },
  "audio/evrcb1": {
    source: "iana"
  },
  "audio/evrcnw": {
    source: "iana"
  },
  "audio/evrcnw0": {
    source: "iana"
  },
  "audio/evrcnw1": {
    source: "iana"
  },
  "audio/evrcwb": {
    source: "iana"
  },
  "audio/evrcwb0": {
    source: "iana"
  },
  "audio/evrcwb1": {
    source: "iana"
  },
  "audio/evs": {
    source: "iana"
  },
  "audio/flac": {
    source: "iana"
  },
  "audio/flexfec": {
    source: "iana"
  },
  "audio/fwdred": {
    source: "iana"
  },
  "audio/g711-0": {
    source: "iana"
  },
  "audio/g719": {
    source: "iana"
  },
  "audio/g722": {
    source: "iana"
  },
  "audio/g7221": {
    source: "iana"
  },
  "audio/g723": {
    source: "iana"
  },
  "audio/g726-16": {
    source: "iana"
  },
  "audio/g726-24": {
    source: "iana"
  },
  "audio/g726-32": {
    source: "iana"
  },
  "audio/g726-40": {
    source: "iana"
  },
  "audio/g728": {
    source: "iana"
  },
  "audio/g729": {
    source: "iana"
  },
  "audio/g7291": {
    source: "iana"
  },
  "audio/g729d": {
    source: "iana"
  },
  "audio/g729e": {
    source: "iana"
  },
  "audio/gsm": {
    source: "iana"
  },
  "audio/gsm-efr": {
    source: "iana"
  },
  "audio/gsm-hr-08": {
    source: "iana"
  },
  "audio/ilbc": {
    source: "iana"
  },
  "audio/ip-mr_v2.5": {
    source: "iana"
  },
  "audio/isac": {
    source: "apache"
  },
  "audio/l16": {
    source: "iana"
  },
  "audio/l20": {
    source: "iana"
  },
  "audio/l24": {
    source: "iana",
    compressible: false
  },
  "audio/l8": {
    source: "iana"
  },
  "audio/lpc": {
    source: "iana"
  },
  "audio/matroska": {
    source: "iana"
  },
  "audio/melp": {
    source: "iana"
  },
  "audio/melp1200": {
    source: "iana"
  },
  "audio/melp2400": {
    source: "iana"
  },
  "audio/melp600": {
    source: "iana"
  },
  "audio/mhas": {
    source: "iana"
  },
  "audio/midi": {
    source: "apache",
    extensions: [
      "mid",
      "midi",
      "kar",
      "rmi"
    ]
  },
  "audio/midi-clip": {
    source: "iana"
  },
  "audio/mobile-xmf": {
    source: "iana",
    extensions: [
      "mxmf"
    ]
  },
  "audio/mp3": {
    compressible: false,
    extensions: [
      "mp3"
    ]
  },
  "audio/mp4": {
    source: "iana",
    compressible: false,
    extensions: [
      "m4a",
      "mp4a"
    ]
  },
  "audio/mp4a-latm": {
    source: "iana"
  },
  "audio/mpa": {
    source: "iana"
  },
  "audio/mpa-robust": {
    source: "iana"
  },
  "audio/mpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "mpga",
      "mp2",
      "mp2a",
      "mp3",
      "m2a",
      "m3a"
    ]
  },
  "audio/mpeg4-generic": {
    source: "iana"
  },
  "audio/musepack": {
    source: "apache"
  },
  "audio/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "oga",
      "ogg",
      "spx",
      "opus"
    ]
  },
  "audio/opus": {
    source: "iana"
  },
  "audio/parityfec": {
    source: "iana"
  },
  "audio/pcma": {
    source: "iana"
  },
  "audio/pcma-wb": {
    source: "iana"
  },
  "audio/pcmu": {
    source: "iana"
  },
  "audio/pcmu-wb": {
    source: "iana"
  },
  "audio/prs.sid": {
    source: "iana"
  },
  "audio/qcelp": {
    source: "iana"
  },
  "audio/raptorfec": {
    source: "iana"
  },
  "audio/red": {
    source: "iana"
  },
  "audio/rtp-enc-aescm128": {
    source: "iana"
  },
  "audio/rtp-midi": {
    source: "iana"
  },
  "audio/rtploopback": {
    source: "iana"
  },
  "audio/rtx": {
    source: "iana"
  },
  "audio/s3m": {
    source: "apache",
    extensions: [
      "s3m"
    ]
  },
  "audio/scip": {
    source: "iana"
  },
  "audio/silk": {
    source: "apache",
    extensions: [
      "sil"
    ]
  },
  "audio/smv": {
    source: "iana"
  },
  "audio/smv-qcp": {
    source: "iana"
  },
  "audio/smv0": {
    source: "iana"
  },
  "audio/sofa": {
    source: "iana"
  },
  "audio/sp-midi": {
    source: "iana"
  },
  "audio/speex": {
    source: "iana"
  },
  "audio/t140c": {
    source: "iana"
  },
  "audio/t38": {
    source: "iana"
  },
  "audio/telephone-event": {
    source: "iana"
  },
  "audio/tetra_acelp": {
    source: "iana"
  },
  "audio/tetra_acelp_bb": {
    source: "iana"
  },
  "audio/tone": {
    source: "iana"
  },
  "audio/tsvcis": {
    source: "iana"
  },
  "audio/uemclip": {
    source: "iana"
  },
  "audio/ulpfec": {
    source: "iana"
  },
  "audio/usac": {
    source: "iana"
  },
  "audio/vdvi": {
    source: "iana"
  },
  "audio/vmr-wb": {
    source: "iana"
  },
  "audio/vnd.3gpp.iufp": {
    source: "iana"
  },
  "audio/vnd.4sb": {
    source: "iana"
  },
  "audio/vnd.audiokoz": {
    source: "iana"
  },
  "audio/vnd.celp": {
    source: "iana"
  },
  "audio/vnd.cisco.nse": {
    source: "iana"
  },
  "audio/vnd.cmles.radio-events": {
    source: "iana"
  },
  "audio/vnd.cns.anp1": {
    source: "iana"
  },
  "audio/vnd.cns.inf1": {
    source: "iana"
  },
  "audio/vnd.dece.audio": {
    source: "iana",
    extensions: [
      "uva",
      "uvva"
    ]
  },
  "audio/vnd.digital-winds": {
    source: "iana",
    extensions: [
      "eol"
    ]
  },
  "audio/vnd.dlna.adts": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.1": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.2": {
    source: "iana"
  },
  "audio/vnd.dolby.mlp": {
    source: "iana"
  },
  "audio/vnd.dolby.mps": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2x": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2z": {
    source: "iana"
  },
  "audio/vnd.dolby.pulse.1": {
    source: "iana"
  },
  "audio/vnd.dra": {
    source: "iana",
    extensions: [
      "dra"
    ]
  },
  "audio/vnd.dts": {
    source: "iana",
    extensions: [
      "dts"
    ]
  },
  "audio/vnd.dts.hd": {
    source: "iana",
    extensions: [
      "dtshd"
    ]
  },
  "audio/vnd.dts.uhd": {
    source: "iana"
  },
  "audio/vnd.dvb.file": {
    source: "iana"
  },
  "audio/vnd.everad.plj": {
    source: "iana"
  },
  "audio/vnd.hns.audio": {
    source: "iana"
  },
  "audio/vnd.lucent.voice": {
    source: "iana",
    extensions: [
      "lvp"
    ]
  },
  "audio/vnd.ms-playready.media.pya": {
    source: "iana",
    extensions: [
      "pya"
    ]
  },
  "audio/vnd.nokia.mobile-xmf": {
    source: "iana"
  },
  "audio/vnd.nortel.vbk": {
    source: "iana"
  },
  "audio/vnd.nuera.ecelp4800": {
    source: "iana",
    extensions: [
      "ecelp4800"
    ]
  },
  "audio/vnd.nuera.ecelp7470": {
    source: "iana",
    extensions: [
      "ecelp7470"
    ]
  },
  "audio/vnd.nuera.ecelp9600": {
    source: "iana",
    extensions: [
      "ecelp9600"
    ]
  },
  "audio/vnd.octel.sbc": {
    source: "iana"
  },
  "audio/vnd.presonus.multitrack": {
    source: "iana"
  },
  "audio/vnd.qcelp": {
    source: "apache"
  },
  "audio/vnd.rhetorex.32kadpcm": {
    source: "iana"
  },
  "audio/vnd.rip": {
    source: "iana",
    extensions: [
      "rip"
    ]
  },
  "audio/vnd.rn-realaudio": {
    compressible: false
  },
  "audio/vnd.sealedmedia.softseal.mpeg": {
    source: "iana"
  },
  "audio/vnd.vmx.cvsd": {
    source: "iana"
  },
  "audio/vnd.wave": {
    compressible: false
  },
  "audio/vorbis": {
    source: "iana",
    compressible: false
  },
  "audio/vorbis-config": {
    source: "iana"
  },
  "audio/wav": {
    compressible: false,
    extensions: [
      "wav"
    ]
  },
  "audio/wave": {
    compressible: false,
    extensions: [
      "wav"
    ]
  },
  "audio/webm": {
    source: "apache",
    compressible: false,
    extensions: [
      "weba"
    ]
  },
  "audio/x-aac": {
    source: "apache",
    compressible: false,
    extensions: [
      "aac"
    ]
  },
  "audio/x-aiff": {
    source: "apache",
    extensions: [
      "aif",
      "aiff",
      "aifc"
    ]
  },
  "audio/x-caf": {
    source: "apache",
    compressible: false,
    extensions: [
      "caf"
    ]
  },
  "audio/x-flac": {
    source: "apache",
    extensions: [
      "flac"
    ]
  },
  "audio/x-m4a": {
    source: "nginx",
    extensions: [
      "m4a"
    ]
  },
  "audio/x-matroska": {
    source: "apache",
    extensions: [
      "mka"
    ]
  },
  "audio/x-mpegurl": {
    source: "apache",
    extensions: [
      "m3u"
    ]
  },
  "audio/x-ms-wax": {
    source: "apache",
    extensions: [
      "wax"
    ]
  },
  "audio/x-ms-wma": {
    source: "apache",
    extensions: [
      "wma"
    ]
  },
  "audio/x-pn-realaudio": {
    source: "apache",
    extensions: [
      "ram",
      "ra"
    ]
  },
  "audio/x-pn-realaudio-plugin": {
    source: "apache",
    extensions: [
      "rmp"
    ]
  },
  "audio/x-realaudio": {
    source: "nginx",
    extensions: [
      "ra"
    ]
  },
  "audio/x-tta": {
    source: "apache"
  },
  "audio/x-wav": {
    source: "apache",
    extensions: [
      "wav"
    ]
  },
  "audio/xm": {
    source: "apache",
    extensions: [
      "xm"
    ]
  },
  "chemical/x-cdx": {
    source: "apache",
    extensions: [
      "cdx"
    ]
  },
  "chemical/x-cif": {
    source: "apache",
    extensions: [
      "cif"
    ]
  },
  "chemical/x-cmdf": {
    source: "apache",
    extensions: [
      "cmdf"
    ]
  },
  "chemical/x-cml": {
    source: "apache",
    extensions: [
      "cml"
    ]
  },
  "chemical/x-csml": {
    source: "apache",
    extensions: [
      "csml"
    ]
  },
  "chemical/x-pdb": {
    source: "apache"
  },
  "chemical/x-xyz": {
    source: "apache",
    extensions: [
      "xyz"
    ]
  },
  "font/collection": {
    source: "iana",
    extensions: [
      "ttc"
    ]
  },
  "font/otf": {
    source: "iana",
    compressible: true,
    extensions: [
      "otf"
    ]
  },
  "font/sfnt": {
    source: "iana"
  },
  "font/ttf": {
    source: "iana",
    compressible: true,
    extensions: [
      "ttf"
    ]
  },
  "font/woff": {
    source: "iana",
    extensions: [
      "woff"
    ]
  },
  "font/woff2": {
    source: "iana",
    extensions: [
      "woff2"
    ]
  },
  "image/aces": {
    source: "iana",
    extensions: [
      "exr"
    ]
  },
  "image/apng": {
    source: "iana",
    compressible: false,
    extensions: [
      "apng"
    ]
  },
  "image/avci": {
    source: "iana",
    extensions: [
      "avci"
    ]
  },
  "image/avcs": {
    source: "iana",
    extensions: [
      "avcs"
    ]
  },
  "image/avif": {
    source: "iana",
    compressible: false,
    extensions: [
      "avif"
    ]
  },
  "image/bmp": {
    source: "iana",
    compressible: true,
    extensions: [
      "bmp",
      "dib"
    ]
  },
  "image/cgm": {
    source: "iana",
    extensions: [
      "cgm"
    ]
  },
  "image/dicom-rle": {
    source: "iana",
    extensions: [
      "drle"
    ]
  },
  "image/dpx": {
    source: "iana",
    extensions: [
      "dpx"
    ]
  },
  "image/emf": {
    source: "iana",
    extensions: [
      "emf"
    ]
  },
  "image/fits": {
    source: "iana",
    extensions: [
      "fits"
    ]
  },
  "image/g3fax": {
    source: "iana",
    extensions: [
      "g3"
    ]
  },
  "image/gif": {
    source: "iana",
    compressible: false,
    extensions: [
      "gif"
    ]
  },
  "image/heic": {
    source: "iana",
    extensions: [
      "heic"
    ]
  },
  "image/heic-sequence": {
    source: "iana",
    extensions: [
      "heics"
    ]
  },
  "image/heif": {
    source: "iana",
    extensions: [
      "heif"
    ]
  },
  "image/heif-sequence": {
    source: "iana",
    extensions: [
      "heifs"
    ]
  },
  "image/hej2k": {
    source: "iana",
    extensions: [
      "hej2"
    ]
  },
  "image/hsj2": {
    source: "iana",
    extensions: [
      "hsj2"
    ]
  },
  "image/ief": {
    source: "iana",
    extensions: [
      "ief"
    ]
  },
  "image/j2c": {
    source: "iana"
  },
  "image/jls": {
    source: "iana",
    extensions: [
      "jls"
    ]
  },
  "image/jp2": {
    source: "iana",
    compressible: false,
    extensions: [
      "jp2",
      "jpg2"
    ]
  },
  "image/jpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpeg",
      "jpg",
      "jpe"
    ]
  },
  "image/jph": {
    source: "iana",
    extensions: [
      "jph"
    ]
  },
  "image/jphc": {
    source: "iana",
    extensions: [
      "jhc"
    ]
  },
  "image/jpm": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpm",
      "jpgm"
    ]
  },
  "image/jpx": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpx",
      "jpf"
    ]
  },
  "image/jxl": {
    source: "iana",
    extensions: [
      "jxl"
    ]
  },
  "image/jxr": {
    source: "iana",
    extensions: [
      "jxr"
    ]
  },
  "image/jxra": {
    source: "iana",
    extensions: [
      "jxra"
    ]
  },
  "image/jxrs": {
    source: "iana",
    extensions: [
      "jxrs"
    ]
  },
  "image/jxs": {
    source: "iana",
    extensions: [
      "jxs"
    ]
  },
  "image/jxsc": {
    source: "iana",
    extensions: [
      "jxsc"
    ]
  },
  "image/jxsi": {
    source: "iana",
    extensions: [
      "jxsi"
    ]
  },
  "image/jxss": {
    source: "iana",
    extensions: [
      "jxss"
    ]
  },
  "image/ktx": {
    source: "iana",
    extensions: [
      "ktx"
    ]
  },
  "image/ktx2": {
    source: "iana",
    extensions: [
      "ktx2"
    ]
  },
  "image/naplps": {
    source: "iana"
  },
  "image/pjpeg": {
    compressible: false
  },
  "image/png": {
    source: "iana",
    compressible: false,
    extensions: [
      "png"
    ]
  },
  "image/prs.btif": {
    source: "iana",
    extensions: [
      "btif",
      "btf"
    ]
  },
  "image/prs.pti": {
    source: "iana",
    extensions: [
      "pti"
    ]
  },
  "image/pwg-raster": {
    source: "iana"
  },
  "image/sgi": {
    source: "apache",
    extensions: [
      "sgi"
    ]
  },
  "image/svg+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "svg",
      "svgz"
    ]
  },
  "image/t38": {
    source: "iana",
    extensions: [
      "t38"
    ]
  },
  "image/tiff": {
    source: "iana",
    compressible: false,
    extensions: [
      "tif",
      "tiff"
    ]
  },
  "image/tiff-fx": {
    source: "iana",
    extensions: [
      "tfx"
    ]
  },
  "image/vnd.adobe.photoshop": {
    source: "iana",
    compressible: true,
    extensions: [
      "psd"
    ]
  },
  "image/vnd.airzip.accelerator.azv": {
    source: "iana",
    extensions: [
      "azv"
    ]
  },
  "image/vnd.cns.inf2": {
    source: "iana"
  },
  "image/vnd.dece.graphic": {
    source: "iana",
    extensions: [
      "uvi",
      "uvvi",
      "uvg",
      "uvvg"
    ]
  },
  "image/vnd.djvu": {
    source: "iana",
    extensions: [
      "djvu",
      "djv"
    ]
  },
  "image/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "image/vnd.dwg": {
    source: "iana",
    extensions: [
      "dwg"
    ]
  },
  "image/vnd.dxf": {
    source: "iana",
    extensions: [
      "dxf"
    ]
  },
  "image/vnd.fastbidsheet": {
    source: "iana",
    extensions: [
      "fbs"
    ]
  },
  "image/vnd.fpx": {
    source: "iana",
    extensions: [
      "fpx"
    ]
  },
  "image/vnd.fst": {
    source: "iana",
    extensions: [
      "fst"
    ]
  },
  "image/vnd.fujixerox.edmics-mmr": {
    source: "iana",
    extensions: [
      "mmr"
    ]
  },
  "image/vnd.fujixerox.edmics-rlc": {
    source: "iana",
    extensions: [
      "rlc"
    ]
  },
  "image/vnd.globalgraphics.pgb": {
    source: "iana"
  },
  "image/vnd.microsoft.icon": {
    source: "iana",
    compressible: true,
    extensions: [
      "ico"
    ]
  },
  "image/vnd.mix": {
    source: "iana"
  },
  "image/vnd.mozilla.apng": {
    source: "iana"
  },
  "image/vnd.ms-dds": {
    compressible: true,
    extensions: [
      "dds"
    ]
  },
  "image/vnd.ms-modi": {
    source: "iana",
    extensions: [
      "mdi"
    ]
  },
  "image/vnd.ms-photo": {
    source: "apache",
    extensions: [
      "wdp"
    ]
  },
  "image/vnd.net-fpx": {
    source: "iana",
    extensions: [
      "npx"
    ]
  },
  "image/vnd.pco.b16": {
    source: "iana",
    extensions: [
      "b16"
    ]
  },
  "image/vnd.radiance": {
    source: "iana"
  },
  "image/vnd.sealed.png": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.gif": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.jpg": {
    source: "iana"
  },
  "image/vnd.svf": {
    source: "iana"
  },
  "image/vnd.tencent.tap": {
    source: "iana",
    extensions: [
      "tap"
    ]
  },
  "image/vnd.valve.source.texture": {
    source: "iana",
    extensions: [
      "vtf"
    ]
  },
  "image/vnd.wap.wbmp": {
    source: "iana",
    extensions: [
      "wbmp"
    ]
  },
  "image/vnd.xiff": {
    source: "iana",
    extensions: [
      "xif"
    ]
  },
  "image/vnd.zbrush.pcx": {
    source: "iana",
    extensions: [
      "pcx"
    ]
  },
  "image/webp": {
    source: "iana",
    extensions: [
      "webp"
    ]
  },
  "image/wmf": {
    source: "iana",
    extensions: [
      "wmf"
    ]
  },
  "image/x-3ds": {
    source: "apache",
    extensions: [
      "3ds"
    ]
  },
  "image/x-cmu-raster": {
    source: "apache",
    extensions: [
      "ras"
    ]
  },
  "image/x-cmx": {
    source: "apache",
    extensions: [
      "cmx"
    ]
  },
  "image/x-freehand": {
    source: "apache",
    extensions: [
      "fh",
      "fhc",
      "fh4",
      "fh5",
      "fh7"
    ]
  },
  "image/x-icon": {
    source: "apache",
    compressible: true,
    extensions: [
      "ico"
    ]
  },
  "image/x-jng": {
    source: "nginx",
    extensions: [
      "jng"
    ]
  },
  "image/x-mrsid-image": {
    source: "apache",
    extensions: [
      "sid"
    ]
  },
  "image/x-ms-bmp": {
    source: "nginx",
    compressible: true,
    extensions: [
      "bmp"
    ]
  },
  "image/x-pcx": {
    source: "apache",
    extensions: [
      "pcx"
    ]
  },
  "image/x-pict": {
    source: "apache",
    extensions: [
      "pic",
      "pct"
    ]
  },
  "image/x-portable-anymap": {
    source: "apache",
    extensions: [
      "pnm"
    ]
  },
  "image/x-portable-bitmap": {
    source: "apache",
    extensions: [
      "pbm"
    ]
  },
  "image/x-portable-graymap": {
    source: "apache",
    extensions: [
      "pgm"
    ]
  },
  "image/x-portable-pixmap": {
    source: "apache",
    extensions: [
      "ppm"
    ]
  },
  "image/x-rgb": {
    source: "apache",
    extensions: [
      "rgb"
    ]
  },
  "image/x-tga": {
    source: "apache",
    extensions: [
      "tga"
    ]
  },
  "image/x-xbitmap": {
    source: "apache",
    extensions: [
      "xbm"
    ]
  },
  "image/x-xcf": {
    compressible: false
  },
  "image/x-xpixmap": {
    source: "apache",
    extensions: [
      "xpm"
    ]
  },
  "image/x-xwindowdump": {
    source: "apache",
    extensions: [
      "xwd"
    ]
  },
  "message/bhttp": {
    source: "iana"
  },
  "message/cpim": {
    source: "iana"
  },
  "message/delivery-status": {
    source: "iana"
  },
  "message/disposition-notification": {
    source: "iana",
    extensions: [
      "disposition-notification"
    ]
  },
  "message/external-body": {
    source: "iana"
  },
  "message/feedback-report": {
    source: "iana"
  },
  "message/global": {
    source: "iana",
    extensions: [
      "u8msg"
    ]
  },
  "message/global-delivery-status": {
    source: "iana",
    extensions: [
      "u8dsn"
    ]
  },
  "message/global-disposition-notification": {
    source: "iana",
    extensions: [
      "u8mdn"
    ]
  },
  "message/global-headers": {
    source: "iana",
    extensions: [
      "u8hdr"
    ]
  },
  "message/http": {
    source: "iana",
    compressible: false
  },
  "message/imdn+xml": {
    source: "iana",
    compressible: true
  },
  "message/mls": {
    source: "iana"
  },
  "message/news": {
    source: "apache"
  },
  "message/ohttp-req": {
    source: "iana"
  },
  "message/ohttp-res": {
    source: "iana"
  },
  "message/partial": {
    source: "iana",
    compressible: false
  },
  "message/rfc822": {
    source: "iana",
    compressible: true,
    extensions: [
      "eml",
      "mime"
    ]
  },
  "message/s-http": {
    source: "apache"
  },
  "message/sip": {
    source: "iana"
  },
  "message/sipfrag": {
    source: "iana"
  },
  "message/tracking-status": {
    source: "iana"
  },
  "message/vnd.si.simp": {
    source: "apache"
  },
  "message/vnd.wfa.wsc": {
    source: "iana",
    extensions: [
      "wsc"
    ]
  },
  "model/3mf": {
    source: "iana",
    extensions: [
      "3mf"
    ]
  },
  "model/e57": {
    source: "iana"
  },
  "model/gltf+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "gltf"
    ]
  },
  "model/gltf-binary": {
    source: "iana",
    compressible: true,
    extensions: [
      "glb"
    ]
  },
  "model/iges": {
    source: "iana",
    compressible: false,
    extensions: [
      "igs",
      "iges"
    ]
  },
  "model/jt": {
    source: "iana",
    extensions: [
      "jt"
    ]
  },
  "model/mesh": {
    source: "iana",
    compressible: false,
    extensions: [
      "msh",
      "mesh",
      "silo"
    ]
  },
  "model/mtl": {
    source: "iana",
    extensions: [
      "mtl"
    ]
  },
  "model/obj": {
    source: "iana",
    extensions: [
      "obj"
    ]
  },
  "model/prc": {
    source: "iana",
    extensions: [
      "prc"
    ]
  },
  "model/step": {
    source: "iana"
  },
  "model/step+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "stpx"
    ]
  },
  "model/step+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "stpz"
    ]
  },
  "model/step-xml+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "stpxz"
    ]
  },
  "model/stl": {
    source: "iana",
    extensions: [
      "stl"
    ]
  },
  "model/u3d": {
    source: "iana",
    extensions: [
      "u3d"
    ]
  },
  "model/vnd.bary": {
    source: "iana",
    extensions: [
      "bary"
    ]
  },
  "model/vnd.cld": {
    source: "iana",
    extensions: [
      "cld"
    ]
  },
  "model/vnd.collada+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dae"
    ]
  },
  "model/vnd.dwf": {
    source: "iana",
    extensions: [
      "dwf"
    ]
  },
  "model/vnd.flatland.3dml": {
    source: "iana"
  },
  "model/vnd.gdl": {
    source: "iana",
    extensions: [
      "gdl"
    ]
  },
  "model/vnd.gs-gdl": {
    source: "apache"
  },
  "model/vnd.gs.gdl": {
    source: "iana"
  },
  "model/vnd.gtw": {
    source: "iana",
    extensions: [
      "gtw"
    ]
  },
  "model/vnd.moml+xml": {
    source: "iana",
    compressible: true
  },
  "model/vnd.mts": {
    source: "iana",
    extensions: [
      "mts"
    ]
  },
  "model/vnd.opengex": {
    source: "iana",
    extensions: [
      "ogex"
    ]
  },
  "model/vnd.parasolid.transmit.binary": {
    source: "iana",
    extensions: [
      "x_b"
    ]
  },
  "model/vnd.parasolid.transmit.text": {
    source: "iana",
    extensions: [
      "x_t"
    ]
  },
  "model/vnd.pytha.pyox": {
    source: "iana",
    extensions: [
      "pyo",
      "pyox"
    ]
  },
  "model/vnd.rosette.annotated-data-model": {
    source: "iana"
  },
  "model/vnd.sap.vds": {
    source: "iana",
    extensions: [
      "vds"
    ]
  },
  "model/vnd.usda": {
    source: "iana",
    extensions: [
      "usda"
    ]
  },
  "model/vnd.usdz+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "usdz"
    ]
  },
  "model/vnd.valve.source.compiled-map": {
    source: "iana",
    extensions: [
      "bsp"
    ]
  },
  "model/vnd.vtu": {
    source: "iana",
    extensions: [
      "vtu"
    ]
  },
  "model/vrml": {
    source: "iana",
    compressible: false,
    extensions: [
      "wrl",
      "vrml"
    ]
  },
  "model/x3d+binary": {
    source: "apache",
    compressible: false,
    extensions: [
      "x3db",
      "x3dbz"
    ]
  },
  "model/x3d+fastinfoset": {
    source: "iana",
    extensions: [
      "x3db"
    ]
  },
  "model/x3d+vrml": {
    source: "apache",
    compressible: false,
    extensions: [
      "x3dv",
      "x3dvz"
    ]
  },
  "model/x3d+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "x3d",
      "x3dz"
    ]
  },
  "model/x3d-vrml": {
    source: "iana",
    extensions: [
      "x3dv"
    ]
  },
  "multipart/alternative": {
    source: "iana",
    compressible: false
  },
  "multipart/appledouble": {
    source: "iana"
  },
  "multipart/byteranges": {
    source: "iana"
  },
  "multipart/digest": {
    source: "iana"
  },
  "multipart/encrypted": {
    source: "iana",
    compressible: false
  },
  "multipart/form-data": {
    source: "iana",
    compressible: false
  },
  "multipart/header-set": {
    source: "iana"
  },
  "multipart/mixed": {
    source: "iana"
  },
  "multipart/multilingual": {
    source: "iana"
  },
  "multipart/parallel": {
    source: "iana"
  },
  "multipart/related": {
    source: "iana",
    compressible: false
  },
  "multipart/report": {
    source: "iana"
  },
  "multipart/signed": {
    source: "iana",
    compressible: false
  },
  "multipart/vnd.bint.med-plus": {
    source: "iana"
  },
  "multipart/voice-message": {
    source: "iana"
  },
  "multipart/x-mixed-replace": {
    source: "iana"
  },
  "text/1d-interleaved-parityfec": {
    source: "iana"
  },
  "text/cache-manifest": {
    source: "iana",
    compressible: true,
    extensions: [
      "appcache",
      "manifest"
    ]
  },
  "text/calendar": {
    source: "iana",
    extensions: [
      "ics",
      "ifb"
    ]
  },
  "text/calender": {
    compressible: true
  },
  "text/cmd": {
    compressible: true
  },
  "text/coffeescript": {
    extensions: [
      "coffee",
      "litcoffee"
    ]
  },
  "text/cql": {
    source: "iana"
  },
  "text/cql-expression": {
    source: "iana"
  },
  "text/cql-identifier": {
    source: "iana"
  },
  "text/css": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "css"
    ]
  },
  "text/csv": {
    source: "iana",
    compressible: true,
    extensions: [
      "csv"
    ]
  },
  "text/csv-schema": {
    source: "iana"
  },
  "text/directory": {
    source: "iana"
  },
  "text/dns": {
    source: "iana"
  },
  "text/ecmascript": {
    source: "apache"
  },
  "text/encaprtp": {
    source: "iana"
  },
  "text/enriched": {
    source: "iana"
  },
  "text/fhirpath": {
    source: "iana"
  },
  "text/flexfec": {
    source: "iana"
  },
  "text/fwdred": {
    source: "iana"
  },
  "text/gff3": {
    source: "iana"
  },
  "text/grammar-ref-list": {
    source: "iana"
  },
  "text/hl7v2": {
    source: "iana"
  },
  "text/html": {
    source: "iana",
    compressible: true,
    extensions: [
      "html",
      "htm",
      "shtml"
    ]
  },
  "text/jade": {
    extensions: [
      "jade"
    ]
  },
  "text/javascript": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "js",
      "mjs"
    ]
  },
  "text/jcr-cnd": {
    source: "iana"
  },
  "text/jsx": {
    compressible: true,
    extensions: [
      "jsx"
    ]
  },
  "text/less": {
    compressible: true,
    extensions: [
      "less"
    ]
  },
  "text/markdown": {
    source: "iana",
    compressible: true,
    extensions: [
      "md",
      "markdown"
    ]
  },
  "text/mathml": {
    source: "nginx",
    extensions: [
      "mml"
    ]
  },
  "text/mdx": {
    compressible: true,
    extensions: [
      "mdx"
    ]
  },
  "text/mizar": {
    source: "iana"
  },
  "text/n3": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "n3"
    ]
  },
  "text/parameters": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/parityfec": {
    source: "iana"
  },
  "text/plain": {
    source: "iana",
    compressible: true,
    extensions: [
      "txt",
      "text",
      "conf",
      "def",
      "list",
      "log",
      "in",
      "ini"
    ]
  },
  "text/provenance-notation": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/prs.fallenstein.rst": {
    source: "iana"
  },
  "text/prs.lines.tag": {
    source: "iana",
    extensions: [
      "dsc"
    ]
  },
  "text/prs.prop.logic": {
    source: "iana"
  },
  "text/prs.texi": {
    source: "iana"
  },
  "text/raptorfec": {
    source: "iana"
  },
  "text/red": {
    source: "iana"
  },
  "text/rfc822-headers": {
    source: "iana"
  },
  "text/richtext": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtx"
    ]
  },
  "text/rtf": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtf"
    ]
  },
  "text/rtp-enc-aescm128": {
    source: "iana"
  },
  "text/rtploopback": {
    source: "iana"
  },
  "text/rtx": {
    source: "iana"
  },
  "text/sgml": {
    source: "iana",
    extensions: [
      "sgml",
      "sgm"
    ]
  },
  "text/shaclc": {
    source: "iana"
  },
  "text/shex": {
    source: "iana",
    extensions: [
      "shex"
    ]
  },
  "text/slim": {
    extensions: [
      "slim",
      "slm"
    ]
  },
  "text/spdx": {
    source: "iana",
    extensions: [
      "spdx"
    ]
  },
  "text/strings": {
    source: "iana"
  },
  "text/stylus": {
    extensions: [
      "stylus",
      "styl"
    ]
  },
  "text/t140": {
    source: "iana"
  },
  "text/tab-separated-values": {
    source: "iana",
    compressible: true,
    extensions: [
      "tsv"
    ]
  },
  "text/troff": {
    source: "iana",
    extensions: [
      "t",
      "tr",
      "roff",
      "man",
      "me",
      "ms"
    ]
  },
  "text/turtle": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "ttl"
    ]
  },
  "text/ulpfec": {
    source: "iana"
  },
  "text/uri-list": {
    source: "iana",
    compressible: true,
    extensions: [
      "uri",
      "uris",
      "urls"
    ]
  },
  "text/vcard": {
    source: "iana",
    compressible: true,
    extensions: [
      "vcard"
    ]
  },
  "text/vnd.a": {
    source: "iana"
  },
  "text/vnd.abc": {
    source: "iana"
  },
  "text/vnd.ascii-art": {
    source: "iana"
  },
  "text/vnd.curl": {
    source: "iana",
    extensions: [
      "curl"
    ]
  },
  "text/vnd.curl.dcurl": {
    source: "apache",
    extensions: [
      "dcurl"
    ]
  },
  "text/vnd.curl.mcurl": {
    source: "apache",
    extensions: [
      "mcurl"
    ]
  },
  "text/vnd.curl.scurl": {
    source: "apache",
    extensions: [
      "scurl"
    ]
  },
  "text/vnd.debian.copyright": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.dmclientscript": {
    source: "iana"
  },
  "text/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "text/vnd.esmertec.theme-descriptor": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.exchangeable": {
    source: "iana"
  },
  "text/vnd.familysearch.gedcom": {
    source: "iana",
    extensions: [
      "ged"
    ]
  },
  "text/vnd.ficlab.flt": {
    source: "iana"
  },
  "text/vnd.fly": {
    source: "iana",
    extensions: [
      "fly"
    ]
  },
  "text/vnd.fmi.flexstor": {
    source: "iana",
    extensions: [
      "flx"
    ]
  },
  "text/vnd.gml": {
    source: "iana"
  },
  "text/vnd.graphviz": {
    source: "iana",
    extensions: [
      "gv"
    ]
  },
  "text/vnd.hans": {
    source: "iana"
  },
  "text/vnd.hgl": {
    source: "iana"
  },
  "text/vnd.in3d.3dml": {
    source: "iana",
    extensions: [
      "3dml"
    ]
  },
  "text/vnd.in3d.spot": {
    source: "iana",
    extensions: [
      "spot"
    ]
  },
  "text/vnd.iptc.newsml": {
    source: "iana"
  },
  "text/vnd.iptc.nitf": {
    source: "iana"
  },
  "text/vnd.latex-z": {
    source: "iana"
  },
  "text/vnd.motorola.reflex": {
    source: "iana"
  },
  "text/vnd.ms-mediapackage": {
    source: "iana"
  },
  "text/vnd.net2phone.commcenter.command": {
    source: "iana"
  },
  "text/vnd.radisys.msml-basic-layout": {
    source: "iana"
  },
  "text/vnd.senx.warpscript": {
    source: "iana"
  },
  "text/vnd.si.uricatalogue": {
    source: "apache"
  },
  "text/vnd.sosi": {
    source: "iana"
  },
  "text/vnd.sun.j2me.app-descriptor": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "jad"
    ]
  },
  "text/vnd.trolltech.linguist": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.vcf": {
    source: "iana"
  },
  "text/vnd.wap.si": {
    source: "iana"
  },
  "text/vnd.wap.sl": {
    source: "iana"
  },
  "text/vnd.wap.wml": {
    source: "iana",
    extensions: [
      "wml"
    ]
  },
  "text/vnd.wap.wmlscript": {
    source: "iana",
    extensions: [
      "wmls"
    ]
  },
  "text/vnd.zoo.kcl": {
    source: "iana"
  },
  "text/vtt": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "vtt"
    ]
  },
  "text/wgsl": {
    source: "iana",
    extensions: [
      "wgsl"
    ]
  },
  "text/x-asm": {
    source: "apache",
    extensions: [
      "s",
      "asm"
    ]
  },
  "text/x-c": {
    source: "apache",
    extensions: [
      "c",
      "cc",
      "cxx",
      "cpp",
      "h",
      "hh",
      "dic"
    ]
  },
  "text/x-component": {
    source: "nginx",
    extensions: [
      "htc"
    ]
  },
  "text/x-fortran": {
    source: "apache",
    extensions: [
      "f",
      "for",
      "f77",
      "f90"
    ]
  },
  "text/x-gwt-rpc": {
    compressible: true
  },
  "text/x-handlebars-template": {
    extensions: [
      "hbs"
    ]
  },
  "text/x-java-source": {
    source: "apache",
    extensions: [
      "java"
    ]
  },
  "text/x-jquery-tmpl": {
    compressible: true
  },
  "text/x-lua": {
    extensions: [
      "lua"
    ]
  },
  "text/x-markdown": {
    compressible: true,
    extensions: [
      "mkd"
    ]
  },
  "text/x-nfo": {
    source: "apache",
    extensions: [
      "nfo"
    ]
  },
  "text/x-opml": {
    source: "apache",
    extensions: [
      "opml"
    ]
  },
  "text/x-org": {
    compressible: true,
    extensions: [
      "org"
    ]
  },
  "text/x-pascal": {
    source: "apache",
    extensions: [
      "p",
      "pas"
    ]
  },
  "text/x-processing": {
    compressible: true,
    extensions: [
      "pde"
    ]
  },
  "text/x-sass": {
    extensions: [
      "sass"
    ]
  },
  "text/x-scss": {
    extensions: [
      "scss"
    ]
  },
  "text/x-setext": {
    source: "apache",
    extensions: [
      "etx"
    ]
  },
  "text/x-sfv": {
    source: "apache",
    extensions: [
      "sfv"
    ]
  },
  "text/x-suse-ymp": {
    compressible: true,
    extensions: [
      "ymp"
    ]
  },
  "text/x-uuencode": {
    source: "apache",
    extensions: [
      "uu"
    ]
  },
  "text/x-vcalendar": {
    source: "apache",
    extensions: [
      "vcs"
    ]
  },
  "text/x-vcard": {
    source: "apache",
    extensions: [
      "vcf"
    ]
  },
  "text/xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xml"
    ]
  },
  "text/xml-external-parsed-entity": {
    source: "iana"
  },
  "text/yaml": {
    compressible: true,
    extensions: [
      "yaml",
      "yml"
    ]
  },
  "video/1d-interleaved-parityfec": {
    source: "iana"
  },
  "video/3gpp": {
    source: "iana",
    extensions: [
      "3gp",
      "3gpp"
    ]
  },
  "video/3gpp-tt": {
    source: "iana"
  },
  "video/3gpp2": {
    source: "iana",
    extensions: [
      "3g2"
    ]
  },
  "video/av1": {
    source: "iana"
  },
  "video/bmpeg": {
    source: "iana"
  },
  "video/bt656": {
    source: "iana"
  },
  "video/celb": {
    source: "iana"
  },
  "video/dv": {
    source: "iana"
  },
  "video/encaprtp": {
    source: "iana"
  },
  "video/evc": {
    source: "iana"
  },
  "video/ffv1": {
    source: "iana"
  },
  "video/flexfec": {
    source: "iana"
  },
  "video/h261": {
    source: "iana",
    extensions: [
      "h261"
    ]
  },
  "video/h263": {
    source: "iana",
    extensions: [
      "h263"
    ]
  },
  "video/h263-1998": {
    source: "iana"
  },
  "video/h263-2000": {
    source: "iana"
  },
  "video/h264": {
    source: "iana",
    extensions: [
      "h264"
    ]
  },
  "video/h264-rcdo": {
    source: "iana"
  },
  "video/h264-svc": {
    source: "iana"
  },
  "video/h265": {
    source: "iana"
  },
  "video/h266": {
    source: "iana"
  },
  "video/iso.segment": {
    source: "iana",
    extensions: [
      "m4s"
    ]
  },
  "video/jpeg": {
    source: "iana",
    extensions: [
      "jpgv"
    ]
  },
  "video/jpeg2000": {
    source: "iana"
  },
  "video/jpm": {
    source: "apache",
    extensions: [
      "jpm",
      "jpgm"
    ]
  },
  "video/jxsv": {
    source: "iana"
  },
  "video/matroska": {
    source: "iana"
  },
  "video/matroska-3d": {
    source: "iana"
  },
  "video/mj2": {
    source: "iana",
    extensions: [
      "mj2",
      "mjp2"
    ]
  },
  "video/mp1s": {
    source: "iana"
  },
  "video/mp2p": {
    source: "iana"
  },
  "video/mp2t": {
    source: "iana",
    extensions: [
      "ts",
      "m2t",
      "m2ts",
      "mts"
    ]
  },
  "video/mp4": {
    source: "iana",
    compressible: false,
    extensions: [
      "mp4",
      "mp4v",
      "mpg4"
    ]
  },
  "video/mp4v-es": {
    source: "iana"
  },
  "video/mpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "mpeg",
      "mpg",
      "mpe",
      "m1v",
      "m2v"
    ]
  },
  "video/mpeg4-generic": {
    source: "iana"
  },
  "video/mpv": {
    source: "iana"
  },
  "video/nv": {
    source: "iana"
  },
  "video/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "ogv"
    ]
  },
  "video/parityfec": {
    source: "iana"
  },
  "video/pointer": {
    source: "iana"
  },
  "video/quicktime": {
    source: "iana",
    compressible: false,
    extensions: [
      "qt",
      "mov"
    ]
  },
  "video/raptorfec": {
    source: "iana"
  },
  "video/raw": {
    source: "iana"
  },
  "video/rtp-enc-aescm128": {
    source: "iana"
  },
  "video/rtploopback": {
    source: "iana"
  },
  "video/rtx": {
    source: "iana"
  },
  "video/scip": {
    source: "iana"
  },
  "video/smpte291": {
    source: "iana"
  },
  "video/smpte292m": {
    source: "iana"
  },
  "video/ulpfec": {
    source: "iana"
  },
  "video/vc1": {
    source: "iana"
  },
  "video/vc2": {
    source: "iana"
  },
  "video/vnd.cctv": {
    source: "iana"
  },
  "video/vnd.dece.hd": {
    source: "iana",
    extensions: [
      "uvh",
      "uvvh"
    ]
  },
  "video/vnd.dece.mobile": {
    source: "iana",
    extensions: [
      "uvm",
      "uvvm"
    ]
  },
  "video/vnd.dece.mp4": {
    source: "iana"
  },
  "video/vnd.dece.pd": {
    source: "iana",
    extensions: [
      "uvp",
      "uvvp"
    ]
  },
  "video/vnd.dece.sd": {
    source: "iana",
    extensions: [
      "uvs",
      "uvvs"
    ]
  },
  "video/vnd.dece.video": {
    source: "iana",
    extensions: [
      "uvv",
      "uvvv"
    ]
  },
  "video/vnd.directv.mpeg": {
    source: "iana"
  },
  "video/vnd.directv.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dlna.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dvb.file": {
    source: "iana",
    extensions: [
      "dvb"
    ]
  },
  "video/vnd.fvt": {
    source: "iana",
    extensions: [
      "fvt"
    ]
  },
  "video/vnd.hns.video": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsavc": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsmpeg2": {
    source: "iana"
  },
  "video/vnd.motorola.video": {
    source: "iana"
  },
  "video/vnd.motorola.videop": {
    source: "iana"
  },
  "video/vnd.mpegurl": {
    source: "iana",
    extensions: [
      "mxu",
      "m4u"
    ]
  },
  "video/vnd.ms-playready.media.pyv": {
    source: "iana",
    extensions: [
      "pyv"
    ]
  },
  "video/vnd.nokia.interleaved-multimedia": {
    source: "iana"
  },
  "video/vnd.nokia.mp4vr": {
    source: "iana"
  },
  "video/vnd.nokia.videovoip": {
    source: "iana"
  },
  "video/vnd.objectvideo": {
    source: "iana"
  },
  "video/vnd.radgamettools.bink": {
    source: "iana"
  },
  "video/vnd.radgamettools.smacker": {
    source: "apache"
  },
  "video/vnd.sealed.mpeg1": {
    source: "iana"
  },
  "video/vnd.sealed.mpeg4": {
    source: "iana"
  },
  "video/vnd.sealed.swf": {
    source: "iana"
  },
  "video/vnd.sealedmedia.softseal.mov": {
    source: "iana"
  },
  "video/vnd.uvvu.mp4": {
    source: "iana",
    extensions: [
      "uvu",
      "uvvu"
    ]
  },
  "video/vnd.vivo": {
    source: "iana",
    extensions: [
      "viv"
    ]
  },
  "video/vnd.youtube.yt": {
    source: "iana"
  },
  "video/vp8": {
    source: "iana"
  },
  "video/vp9": {
    source: "iana"
  },
  "video/webm": {
    source: "apache",
    compressible: false,
    extensions: [
      "webm"
    ]
  },
  "video/x-f4v": {
    source: "apache",
    extensions: [
      "f4v"
    ]
  },
  "video/x-fli": {
    source: "apache",
    extensions: [
      "fli"
    ]
  },
  "video/x-flv": {
    source: "apache",
    compressible: false,
    extensions: [
      "flv"
    ]
  },
  "video/x-m4v": {
    source: "apache",
    extensions: [
      "m4v"
    ]
  },
  "video/x-matroska": {
    source: "apache",
    compressible: false,
    extensions: [
      "mkv",
      "mk3d",
      "mks"
    ]
  },
  "video/x-mng": {
    source: "apache",
    extensions: [
      "mng"
    ]
  },
  "video/x-ms-asf": {
    source: "apache",
    extensions: [
      "asf",
      "asx"
    ]
  },
  "video/x-ms-vob": {
    source: "apache",
    extensions: [
      "vob"
    ]
  },
  "video/x-ms-wm": {
    source: "apache",
    extensions: [
      "wm"
    ]
  },
  "video/x-ms-wmv": {
    source: "apache",
    compressible: false,
    extensions: [
      "wmv"
    ]
  },
  "video/x-ms-wmx": {
    source: "apache",
    extensions: [
      "wmx"
    ]
  },
  "video/x-ms-wvx": {
    source: "apache",
    extensions: [
      "wvx"
    ]
  },
  "video/x-msvideo": {
    source: "apache",
    extensions: [
      "avi"
    ]
  },
  "video/x-sgi-movie": {
    source: "apache",
    extensions: [
      "movie"
    ]
  },
  "video/x-smv": {
    source: "apache",
    extensions: [
      "smv"
    ]
  },
  "x-conference/x-cooltalk": {
    source: "apache",
    extensions: [
      "ice"
    ]
  },
  "x-shader/x-fragment": {
    compressible: true
  },
  "x-shader/x-vertex": {
    compressible: true
  }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var mimeDb = require$$0;
const mimeDb$1 = /* @__PURE__ */ getDefaultExportFromCjs(mimeDb);
const getMimeTypesByCategory = (category) => {
  return Object.keys(mimeDb$1).filter((key) => {
    const firstPart = key.split("/")[0] + "";
    return firstPart === category;
  });
};
const FILE_TYPE_CATEGORIES = {
  video: getMimeTypesByCategory("video"),
  image: getMimeTypesByCategory("image"),
  audio: getMimeTypesByCategory("audio"),
  text: ["text/plain"],
  document: [
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/xml"
  ]
};
const FILE_TYPE_CATEGORIES_ACCEPTS_MAP = {
  video: "video/*",
  image: "image/*",
  audio: "audio/*",
  text: "text/plain",
  document: `application/pdf, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/xml`
};
const isValidFileType = (file, acceptedCategories) => {
  for (const category of acceptedCategories) {
    if (FILE_TYPE_CATEGORIES[category].includes(file.type)) {
      return true;
    }
  }
  return false;
};
const baseClasses = clsx(
  "flex h-es112 w-full flex-col items-center rounded-lg py-e24",
  "relative flex flex-col items-center gap-e4 text-center",
  "border border-dashed border-warm-gray-300"
);
const TEST_IDS_CONFIG$f = {
  BASE: "input",
  DROP_ZONE: "drop-zone",
  ADD_BUTTON: "add-button",
  DRAG_TEXT: "drag-text",
  DROP_TEXT: "drop-text",
  FILE_LIST: "file-list"
};
const FilePicker = forwardRef(
  ({
    className,
    onChange,
    value,
    multiple,
    uploadStatus,
    statusHints,
    onAddFiles: parentOnAddFiles,
    onRemoveFile: parentOnRemoveFile,
    onRetryFileUpload,
    acceptedTypeCategories,
    disabled,
    error: error2,
    addButtonText = "Add file",
    dragAndDropText = "or drag and drop files here",
    dropFileText = "Drop file to upload",
    ...rest
  }, ref) => {
    const inputRef = useRef(null);
    const [isDragging, toggleIsDragging] = useToggle(false);
    const testIds = useInputDataTestIds({
      ...rest,
      componentIdConfig: TEST_IDS_CONFIG$f
    });
    const handleClick = () => {
      inputRef.current?.click();
    };
    if (isArray$1(uploadStatus) && isArray$1(value) && uploadStatus.length !== value.length) {
      throw new Error("Bad uploadStatus");
    }
    const onAddFiles = (files) => {
      toggleIsDragging(false);
      const newFilesArr = files.filter((f2) => !value?.some(({ name }) => name === f2.name)).filter(
        (f2) => isUndefined(acceptedTypeCategories) || isValidFileType(f2, acceptedTypeCategories)
      );
      parentOnAddFiles?.(newFilesArr);
      const mergedFiles = [...value || [], ...newFilesArr];
      onChange?.(mergedFiles);
    };
    const onFileInputChange = ({
      target: { files: newFiles }
    }) => {
      if (!newFiles || newFiles.length === 0) {
        return;
      }
      onAddFiles(Array.from(newFiles));
    };
    const onRemoveFile = (fileName) => {
      const newFilesArr = (value || []).filter((f2) => f2.name !== fileName);
      if (newFilesArr.length === value?.length) {
        throw new Error(`Tried to remove file with name ${fileName} but it didnt exist`);
      }
      parentOnRemoveFile?.(fileName);
      onChange?.(newFilesArr);
    };
    const onDrop = (e3) => {
      e3.preventDefault();
      if (disabled) return;
      const draggedFiles = [];
      if (e3.dataTransfer.items) {
        Array.from(e3.dataTransfer.items).forEach((item) => {
          if (item.kind === "file") {
            const file = item.getAsFile();
            if (file) {
              draggedFiles.push(file);
            }
          }
        });
      }
      onAddFiles(draggedFiles);
    };
    useEffect(() => {
      document.addEventListener("dragenter", onPreventDefaultEventVanilla);
      document.addEventListener("dragover", onPreventDefaultEventVanilla);
      document.addEventListener("drag", onPreventDefaultEventVanilla);
      return () => {
        document.removeEventListener("dragover", onPreventDefaultEventVanilla);
        document.removeEventListener("drag", onPreventDefaultEventVanilla);
      };
    }, []);
    const acceptList = useMemo(() => {
      if (!acceptedTypeCategories) return;
      return acceptedTypeCategories.map((c2) => FILE_TYPE_CATEGORIES_ACCEPTS_MAP[c2]).join(",");
    }, [acceptedTypeCategories]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "section",
        {
          className: twMerge$2(
            clsx(
              baseClasses,
              "group",
              {
                "justify-center border-warm-gray-500 bg-white": isDragging,
                "cursor-pointer hover:border-warm-gray-500": !disabled,
                "border-utility-error": error2
              },
              className
            )
          ),
          onDrop,
          onDragOver: onPreventDefaultEvent,
          onDragEnter: () => !disabled && toggleIsDragging(true),
          onDragLeave: () => !disabled && toggleIsDragging(false),
          onClick: disabled ? void 0 : handleClick,
          ...testIds.DROP_ZONE,
          children: [
            !isDragging && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Button,
                {
                  buttonRef: ref,
                  variant: "ghost",
                  size: "md",
                  className: clsx({
                    "group-hover:bg-warm-gray-8% group-active:bg-warm-gray-16%": !disabled
                  }),
                  disabled,
                  ...testIds.ADD_BUTTON,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: I$2 }),
                    addButtonText
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Paragraph,
                {
                  size: "sm",
                  className: "text-warm-gray-600",
                  noDefaultMargins: true,
                  ...testIds.DRAG_TEXT,
                  children: dragAndDropText
                }
              )
            ] }),
            isDragging && /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Button,
              {
                variant: "ghost",
                size: "md",
                className: "pointer-events-none bg-warm-gray-8%",
                ...testIds.DROP_TEXT,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: D$1 }),
                  dropFileText
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("section", { children: value && value.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "ul",
        {
          className: "flex flex-col gap-e16 py-e16 transition-height",
          ...testIds.FILE_LIST,
          children: value.map((f2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            FileStatus,
            {
              uploadStatus: uploadStatus?.[index2],
              statusHints,
              name: f2.name,
              onCancel: onRemoveFile,
              onRetryFileUpload,
              "data-testid": `${testIds.BASE["data-testid"]}-file-${index2}`
            },
            f2.name
          ))
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ref: inputRef,
          onChange: onFileInputChange,
          type: "file",
          className: "hidden",
          "aria-label": "add files",
          id: "test-file-uploader",
          multiple,
          accept: acceptList,
          disabled,
          ...omit(rest, "onClear"),
          ...testIds.BASE
        }
      )
    ] });
  }
);
FilePicker.displayName = "FilePicker";
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
var errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin2) {
    return `The plugin for '${plugin2}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin2}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error2, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const e3 = errors[error2];
    const msg = typeof e3 === "function" ? e3.apply(null, args) : e3;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error2}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject$1(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject$1(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto2 = getPrototypeOf(value);
  if (proto2 === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto2, "constructor") && proto2.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index2) => iter(index2, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 : isMap(thing) ? 2 : isSet(thing) ? 3 : 0;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t2 = getArchtype(thing);
  if (t2 === 2)
    thing.set(propOrOldValue, value);
  else if (t2 === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x2, y2) {
  if (x2 === y2) {
    return x2 !== 0 || 1 / x2 === 1 / y2;
  } else {
    return x2 !== x2 && y2 !== y2;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject$1(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys2 = Reflect.ownKeys(descriptors);
    for (let i2 = 0; i2 < keys2.length; i2++) {
      const key = keys2[i2];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto2 = getPrototypeOf(base);
    if (proto2 !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto2);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}
var plugins = {};
function getPlugin(pluginKey) {
  const plugin2 = plugins[pluginKey];
  if (!plugin2) {
    die(0, pluginKey);
  }
  return plugin2;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path2) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path2)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path2, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path2 && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path2,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (process.env.NODE_ENV !== "production" && childValue === targetObject)
    die(5);
  if (isDraft(childValue)) {
    const path2 = rootPath && parentState && parentState.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res2 = finalize(rootScope, childValue, path2);
    set(targetObject, prop, res2);
    if (isDraft(res2)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function createProxyProxy(base, parent2) {
  const isArray3 = Array.isArray(base);
  const state = {
    type_: isArray3 ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent2 ? parent2.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent2,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray3) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (process.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto2 = getPrototypeOf(source);
  while (proto2) {
    const desc = Object.getOwnPropertyDescriptor(proto2, prop);
    if (desc)
      return desc;
    proto2 = getPrototypeOf(proto2);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config2) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self2 = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self2.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p2 = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p2, ip);
          patchListener(p2, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p2, ip) => {
        patches = p2;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config2?.autoFreeze === "boolean")
      this.setAutoFreeze(config2.autoFreeze);
    if (typeof config2?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config2.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i2;
    for (i2 = patches.length - 1; i2 >= 0; i2--) {
      const patch = patches[i2];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i2 > -1) {
      patches = patches.slice(i2 + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent2) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent2) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent2) : createProxyProxy(value, parent2);
  const scope = parent2 ? parent2.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);
function i$2(f2) {
  var u2 = useState(function() {
    return freeze("function" == typeof f2 ? f2() : f2, true);
  }), i2 = u2[1];
  return [u2[0], useCallback(function(t2) {
    i2("function" == typeof t2 ? produce(t2) : freeze(t2));
  }, [])];
}
function isFunction(value) {
  return typeof value === "function";
}
function createErrorClass(createImpl) {
  var _super = function(instance) {
    Error.call(instance);
    instance.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}
var UnsubscriptionError = createErrorClass(function(_super) {
  return function UnsubscriptionErrorImpl(errors2) {
    _super(this);
    this.message = errors2 ? errors2.length + " errors occurred during unsubscription:\n" + errors2.map(function(err, i2) {
      return i2 + 1 + ") " + err.toString();
    }).join("\n  ") : "";
    this.name = "UnsubscriptionError";
    this.errors = errors2;
  };
});
function arrRemove(arr, item) {
  if (arr) {
    var index2 = arr.indexOf(item);
    0 <= index2 && arr.splice(index2, 1);
  }
}
var Subscription = function() {
  function Subscription2(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription2.prototype.unsubscribe = function() {
    var e_1, _a2, e_2, _b2;
    var errors2;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a2 = _parentage_1.return)) _a2.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e3) {
          errors2 = e3 instanceof UnsubscriptionError ? e3.errors : [e3];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err) {
              errors2 = errors2 !== null && errors2 !== void 0 ? errors2 : [];
              if (err instanceof UnsubscriptionError) {
                errors2 = __spreadArray(__spreadArray([], __read(errors2)), __read(err.errors));
              } else {
                errors2.push(err);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b2 = _finalizers_1.return)) _b2.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors2) {
        throw new UnsubscriptionError(errors2);
      }
    }
  };
  Subscription2.prototype.add = function(teardown) {
    var _a2;
    if (teardown && teardown !== this) {
      if (this.closed) {
        execFinalizer(teardown);
      } else {
        if (teardown instanceof Subscription2) {
          if (teardown.closed || teardown._hasParent(this)) {
            return;
          }
          teardown._addParent(this);
        }
        (this._finalizers = (_a2 = this._finalizers) !== null && _a2 !== void 0 ? _a2 : []).push(teardown);
      }
    }
  };
  Subscription2.prototype._hasParent = function(parent2) {
    var _parentage = this._parentage;
    return _parentage === parent2 || Array.isArray(_parentage) && _parentage.includes(parent2);
  };
  Subscription2.prototype._addParent = function(parent2) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent2), _parentage) : _parentage ? [_parentage, parent2] : parent2;
  };
  Subscription2.prototype._removeParent = function(parent2) {
    var _parentage = this._parentage;
    if (_parentage === parent2) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent2);
    }
  };
  Subscription2.prototype.remove = function(teardown) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown);
    if (teardown instanceof Subscription2) {
      teardown._removeParent(this);
    }
  };
  Subscription2.EMPTY = function() {
    var empty = new Subscription2();
    empty.closed = true;
    return empty;
  }();
  return Subscription2;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
  return value instanceof Subscription || value && "closed" in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}
var config = {
  Promise: void 0
};
var timeoutProvider = {
  setTimeout: function(handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
  },
  clearTimeout: function(handle) {
    return clearTimeout(handle);
  },
  delegate: void 0
};
function reportUnhandledError(err) {
  timeoutProvider.setTimeout(function() {
    {
      throw err;
    }
  });
}
function noop() {
}
function errorContext(cb) {
  {
    cb();
  }
}
var Subscriber = function(_super) {
  __extends(Subscriber2, _super);
  function Subscriber2(destination) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination) {
      _this.destination = destination;
      if (isSubscription(destination)) {
        destination.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber2.create = function(next, error2, complete) {
    return new SafeSubscriber(next, error2, complete);
  };
  Subscriber2.prototype.next = function(value) {
    if (this.isStopped) ;
    else {
      this._next(value);
    }
  };
  Subscriber2.prototype.error = function(err) {
    if (this.isStopped) ;
    else {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber2.prototype.complete = function() {
    if (this.isStopped) ;
    else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber2.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber2.prototype._next = function(value) {
    this.destination.next(value);
  };
  Subscriber2.prototype._error = function(err) {
    try {
      this.destination.error(err);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber2.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber2;
}(Subscription);
var ConsumerObserver = function() {
  function ConsumerObserver2(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver2.prototype.next = function(value) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value);
      } catch (error2) {
        handleUnhandledError(error2);
      }
    }
  };
  ConsumerObserver2.prototype.error = function(err) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err);
      } catch (error2) {
        handleUnhandledError(error2);
      }
    } else {
      handleUnhandledError(err);
    }
  };
  ConsumerObserver2.prototype.complete = function() {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error2) {
        handleUnhandledError(error2);
      }
    }
  };
  return ConsumerObserver2;
}();
var SafeSubscriber = function(_super) {
  __extends(SafeSubscriber2, _super);
  function SafeSubscriber2(observerOrNext, error2, complete) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : void 0,
        error: error2 !== null && error2 !== void 0 ? error2 : void 0,
        complete: complete !== null && complete !== void 0 ? complete : void 0
      };
    } else {
      {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber2;
}(Subscriber);
function handleUnhandledError(error2) {
  {
    reportUnhandledError(error2);
  }
}
function defaultErrorHandler(err) {
  throw err;
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
};
var observable = function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
function identity$1(x2) {
  return x2;
}
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity$1;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function(prev, fn) {
      return fn(prev);
    }, input);
  };
}
var Observable = function() {
  function Observable2(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable2.prototype.lift = function(operator) {
    var observable2 = new Observable2();
    observable2.source = this;
    observable2.operator = operator;
    return observable2;
  };
  Observable2.prototype.subscribe = function(observerOrNext, error2, complete) {
    var _this = this;
    var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error2, complete);
    errorContext(function() {
      var _a2 = _this, operator = _a2.operator, source = _a2.source;
      subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
    });
    return subscriber;
  };
  Observable2.prototype._trySubscribe = function(sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      sink.error(err);
    }
  };
  Observable2.prototype.forEach = function(next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var subscriber = new SafeSubscriber({
        next: function(value) {
          try {
            next(value);
          } catch (err) {
            reject(err);
            subscriber.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
      _this.subscribe(subscriber);
    });
  };
  Observable2.prototype._subscribe = function(subscriber) {
    var _a2;
    return (_a2 = this.source) === null || _a2 === void 0 ? void 0 : _a2.subscribe(subscriber);
  };
  Observable2.prototype[observable] = function() {
    return this;
  };
  Observable2.prototype.pipe = function() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    return pipeFromArray(operations)(this);
  };
  Observable2.prototype.toPromise = function(promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var value;
      _this.subscribe(function(x2) {
        return value = x2;
      }, function(err) {
        return reject(err);
      }, function() {
        return resolve(value);
      });
    });
  };
  Observable2.create = function(subscribe) {
    return new Observable2(subscribe);
  };
  return Observable2;
}();
function getPromiseCtor(promiseCtor) {
  var _a2;
  return (_a2 = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a2 !== void 0 ? _a2 : Promise;
}
function isObserver(value) {
  return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
  return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
}
var ObjectUnsubscribedError = createErrorClass(function(_super) {
  return function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = "ObjectUnsubscribedError";
    this.message = "object unsubscribed";
  };
});
var Subject = function(_super) {
  __extends(Subject2, _super);
  function Subject2() {
    var _this = _super.call(this) || this;
    _this.closed = false;
    _this.currentObservers = null;
    _this.observers = [];
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }
  Subject2.prototype.lift = function(operator) {
    var subject = new AnonymousSubject(this, this);
    subject.operator = operator;
    return subject;
  };
  Subject2.prototype._throwIfClosed = function() {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }
  };
  Subject2.prototype.next = function(value) {
    var _this = this;
    errorContext(function() {
      var e_1, _a2;
      _this._throwIfClosed();
      if (!_this.isStopped) {
        if (!_this.currentObservers) {
          _this.currentObservers = Array.from(_this.observers);
        }
        try {
          for (var _b2 = __values(_this.currentObservers), _c = _b2.next(); !_c.done; _c = _b2.next()) {
            var observer = _c.value;
            observer.next(value);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (_c && !_c.done && (_a2 = _b2.return)) _a2.call(_b2);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
    });
  };
  Subject2.prototype.error = function(err) {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.hasError = _this.isStopped = true;
        _this.thrownError = err;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().error(err);
        }
      }
    });
  };
  Subject2.prototype.complete = function() {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.isStopped = true;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().complete();
        }
      }
    });
  };
  Subject2.prototype.unsubscribe = function() {
    this.isStopped = this.closed = true;
    this.observers = this.currentObservers = null;
  };
  Object.defineProperty(Subject2.prototype, "observed", {
    get: function() {
      var _a2;
      return ((_a2 = this.observers) === null || _a2 === void 0 ? void 0 : _a2.length) > 0;
    },
    enumerable: false,
    configurable: true
  });
  Subject2.prototype._trySubscribe = function(subscriber) {
    this._throwIfClosed();
    return _super.prototype._trySubscribe.call(this, subscriber);
  };
  Subject2.prototype._subscribe = function(subscriber) {
    this._throwIfClosed();
    this._checkFinalizedStatuses(subscriber);
    return this._innerSubscribe(subscriber);
  };
  Subject2.prototype._innerSubscribe = function(subscriber) {
    var _this = this;
    var _a2 = this, hasError = _a2.hasError, isStopped = _a2.isStopped, observers = _a2.observers;
    if (hasError || isStopped) {
      return EMPTY_SUBSCRIPTION;
    }
    this.currentObservers = null;
    observers.push(subscriber);
    return new Subscription(function() {
      _this.currentObservers = null;
      arrRemove(observers, subscriber);
    });
  };
  Subject2.prototype._checkFinalizedStatuses = function(subscriber) {
    var _a2 = this, hasError = _a2.hasError, thrownError = _a2.thrownError, isStopped = _a2.isStopped;
    if (hasError) {
      subscriber.error(thrownError);
    } else if (isStopped) {
      subscriber.complete();
    }
  };
  Subject2.prototype.asObservable = function() {
    var observable2 = new Observable();
    observable2.source = this;
    return observable2;
  };
  Subject2.create = function(destination, source) {
    return new AnonymousSubject(destination, source);
  };
  return Subject2;
}(Observable);
var AnonymousSubject = function(_super) {
  __extends(AnonymousSubject2, _super);
  function AnonymousSubject2(destination, source) {
    var _this = _super.call(this) || this;
    _this.destination = destination;
    _this.source = source;
    return _this;
  }
  AnonymousSubject2.prototype.next = function(value) {
    var _a2, _b2;
    (_b2 = (_a2 = this.destination) === null || _a2 === void 0 ? void 0 : _a2.next) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, value);
  };
  AnonymousSubject2.prototype.error = function(err) {
    var _a2, _b2;
    (_b2 = (_a2 = this.destination) === null || _a2 === void 0 ? void 0 : _a2.error) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, err);
  };
  AnonymousSubject2.prototype.complete = function() {
    var _a2, _b2;
    (_b2 = (_a2 = this.destination) === null || _a2 === void 0 ? void 0 : _a2.complete) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
  };
  AnonymousSubject2.prototype._subscribe = function(subscriber) {
    var _a2, _b2;
    return (_b2 = (_a2 = this.source) === null || _a2 === void 0 ? void 0 : _a2.subscribe(subscriber)) !== null && _b2 !== void 0 ? _b2 : EMPTY_SUBSCRIPTION;
  };
  return AnonymousSubject2;
}(Subject);
const isUploadComplete = (upload) => {
  return upload.status === "success";
};
const completeUpload = (updater, fileName, uploadID) => {
  updater((draft) => {
    const upload = draft.find((u2) => u2.file.name === fileName);
    if (!upload) return;
    upload.status = "success";
    upload.uploadID = uploadID;
  });
};
const failUpload = (updater, fileName) => {
  updater((draft) => {
    const upload = draft.find((u2) => u2.file.name === fileName);
    if (!upload) return;
    upload.status = "failed";
  });
};
const useFileUploads = ({ uploadFn }) => {
  const [uploads, setUploads] = i$2([]);
  const files = useMemo(() => uploads.map(({ file }) => file), [uploads]);
  const runFn = useCallback(
    (file, options) => {
      const upload = uploadFn(file, options);
      upload.then((result) => {
        completeUpload(setUploads, file.name, result);
        return result;
      }).catch(() => failUpload(setUploads, file.name));
      return upload;
    },
    [setUploads, uploadFn]
  );
  const onAddFiles = useCallback(
    (files2) => {
      const newUploads = files2.map((f2) => {
        const progressSubject = new Subject();
        const abortController = new AbortController();
        const upload = runFn(f2, {
          abortSignal: abortController.signal,
          progressSubject
        });
        return {
          file: f2,
          promise: upload,
          status: "inProgress",
          progressSubject,
          abortController
        };
      });
      setUploads((draft) => {
        draft.push(...newUploads);
      });
    },
    [runFn, setUploads]
  );
  const onRemoveFile = useCallback(
    (fileName) => {
      setUploads(
        (draft) => draft.filter(({ file, progressSubject, abortController }) => {
          if (file.name === fileName) {
            progressSubject?.complete();
            abortController?.abort();
            return false;
          }
          return true;
        })
      );
    },
    [setUploads]
  );
  const onRetryFile = useCallback(
    (fileName) => {
      setUploads((draft) => {
        const upload = draft.find((u2) => u2.file.name === fileName);
        if (!upload) return;
        const newUpload = runFn(upload.file, {
          abortSignal: upload.abortController?.signal,
          progressSubject: upload.progressSubject
        });
        upload.status = "inProgress";
        upload.promise = newUpload;
      });
    },
    [runFn, setUploads]
  );
  useEffectOnce(() => {
    return () => {
      uploads.forEach((u2) => {
        u2.abortController?.abort();
        u2.progressSubject?.complete();
      });
    };
  });
  return {
    onAddFiles,
    onRemoveFile,
    onRetryFile,
    artifacts: uploads,
    files
  };
};
const withRHFVariantControlled = (Component2) => {
  return forwardRef((props, ref) => {
    const { name, ...rest } = props;
    if (isString(name)) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ControllerWrap$1,
        {
          name,
          componentProps: rest,
          Component: Component2
        }
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...props,
        ref
      }
    );
  });
};
const ControllerWrap$1 = ({
  name,
  componentProps,
  Component: Component2
}) => {
  const {
    field,
    fieldState: { error: error2 }
  } = useController({
    name
  });
  const {
    setValue,
    formState: { disabled, isSubmitting }
  } = useFormContext();
  const { onChange: onChangeProps } = componentProps;
  const { onChange: onChangeField, disabled: isFieldDisabled, ...fieldProps } = field;
  const onChangeMerged = useCallback(
    (...args) => {
      onChangeField(...args);
      if (isFunction$1(onChangeProps)) {
        onChangeProps(...args);
      }
    },
    [onChangeField, onChangeProps]
  );
  const onClear = useCallback(
    (defaultValue) => {
      setValue(name, defaultValue ?? "");
    },
    [name, setValue]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Component2,
    {
      ...componentProps,
      ...fieldProps,
      onChange: onChangeMerged,
      onClear,
      error: error2,
      disabled: disabled || isSubmitting || isFieldDisabled || componentProps.disabled
    }
  );
};
const withFormField = (Component2, config2) => {
  return forwardRef((props, ref) => {
    if (!props.standalone) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormField,
        {
          ...props,
          config: config2,
          className: props.containerClassName,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Component2,
            {
              ...props,
              ref
            }
          )
        }
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...props,
        ref
      }
    );
  });
};
const ViewModeComponent = () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
const Component$i = forwardRef(
  ({ statusHints, uploadFn, onChange, ...rest }, ref) => {
    const {
      files,
      onAddFiles,
      onRemoveFile,
      artifacts: uploads,
      onRetryFile
    } = useFileUploads({ uploadFn });
    useEffect(() => {
      onChange?.(uploads);
    }, [uploads]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilePicker,
      {
        multiple: true,
        value: files,
        statusHints,
        onAddFiles,
        onRemoveFile,
        uploadStatus: uploads,
        onRetryFileUpload: onRetryFile,
        ref,
        ...omit(rest, "value")
      }
    );
  }
);
Component$i.displayName = "FileUploader";
const WithViewMode = withViewMode(Component$i, { viewModeComponent: ViewModeComponent });
const FileUploader = withFormField(withRHFVariantControlled(WithViewMode), {
  labelSpacing: "lg",
  viewModeLabelSpacing: "lg",
  order: {
    error: "bottom",
    hint: "top"
  }
});
const uploadedFileSchema = object().shape({
  status: string$2().oneOf(["success", "failed", "inProgress"]).test("status", (value, { createError }) => {
    let errorMessage = void 0;
    switch (value) {
      case "failed":
        errorMessage = "Please clear or retry failed uploads";
        break;
      case "inProgress":
        errorMessage = "Please wait for ongoing uploads to finish or cancel them";
        break;
      case void 0:
        errorMessage = "Unexpected error";
    }
    if (errorMessage) {
      return createError({ message: errorMessage });
    }
    return true;
  })
});
const fileUploaderValidationSchema = array().of(uploadedFileSchema);
const FileViewerContext = createContext(void 0);
const useFileViewerContext = () => {
  const context = useContext(FileViewerContext);
  if (!context) {
    throw new Error("useFileViewerContext must be used within a FileViewerProvider.");
  }
  return context;
};
const FileViewerProvider = ({
  children,
  disabled,
  showDownloadButton
}) => {
  const contextValue = useMemo(
    () => ({ disabled, showDownloadButton }),
    [disabled, showDownloadButton]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FileViewerContext.Provider, { value: contextValue, children });
};
const FileViewer = ({
  children,
  disabled = false,
  showDownloadButton = true,
  className,
  ...props
}) => {
  const hasChildren = !isEmpty(children);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FileViewerProvider,
    {
      disabled,
      showDownloadButton,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: twMerge("flex flex-col gap-e8", className),
          ...props,
          children: hasChildren ? children : DEFAULT_VIEW_MODE_TEXT
        }
      )
    }
  );
};
const TEST_IDS_CONFIG$e = {
  BASE: "",
  BUTTON: "download-button",
  CONTENT: "content"
};
const FileLink = ({ children, ...props }) => {
  const { disabled, showDownloadButton } = useFileViewerContext();
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$e,
    ids: props
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Link,
    {
      ...props,
      disabled: disabled || props.disabled,
      className: "flex items-center gap-e12",
      children: [
        showDownloadButton && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            tabIndex: -1,
            variant: "ghost",
            size: "sm",
            disabled: disabled || props.disabled,
            iconOnly: true,
            ...testIds.BUTTON,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: I$3 })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "truncate",
            ...testIds.CONTENT,
            children
          }
        )
      ]
    }
  );
};
const DEFAULT_COLUMN_COUNT = 2;
const parseGridColumns = (gridTemplateColumns) => {
  if (!gridTemplateColumns || gridTemplateColumns === "none") {
    return DEFAULT_COLUMN_COUNT;
  }
  const repeatRegex = /repeat\((\d+),/;
  const repeatMatch = repeatRegex.exec(gridTemplateColumns);
  if (repeatMatch?.[1]) {
    return parseInt(repeatMatch[1]);
  }
  return gridTemplateColumns.split(" ").length;
};
const getColumnsPerRow = (container) => {
  const computedStyle = getComputedStyle(container);
  return parseGridColumns(computedStyle.gridTemplateColumns);
};
const groupFieldsIntoRows = (fields, columnsPerRow) => {
  const rows = [];
  for (let i2 = 0; i2 < fields.length; i2 += columnsPerRow) {
    rows.push(fields.slice(i2, i2 + columnsPerRow));
  }
  return rows;
};
const getFieldSection = (field, section) => {
  return field.querySelector(`[data-field-section="${section}"]`);
};
const resetFieldSectionHeights = (field) => {
  const sections = field.querySelectorAll("[data-field-section]");
  sections.forEach((section) => {
    section.style.minHeight = "";
  });
};
const measureFieldSectionHeights = (field) => {
  const labelSection = getFieldSection(field, "label");
  const bottomHintSection = getFieldSection(field, "bottom-hint");
  return {
    labelHeight: labelSection?.offsetHeight || 0,
    bottomHintHeight: bottomHintSection?.offsetHeight || 0
  };
};
const applyFieldSectionHeights = (field, alignmentData) => {
  const labelSection = getFieldSection(field, "label");
  const bottomHintSection = getFieldSection(field, "bottom-hint");
  if (labelSection && alignmentData.labelHeight > 0) {
    labelSection.style.minHeight = `${alignmentData.labelHeight}px`;
  }
  if (bottomHintSection && alignmentData.bottomHintHeight > 0) {
    bottomHintSection.style.minHeight = `${alignmentData.bottomHintHeight}px`;
  }
};
const calculateRowAlignmentData = (rowFields) => {
  const alignmentData = {
    labelHeight: 0,
    bottomHintHeight: 0
  };
  rowFields.forEach((field) => {
    const fieldHeights = measureFieldSectionHeights(field);
    alignmentData.labelHeight = Math.max(alignmentData.labelHeight, fieldHeights.labelHeight || 0);
    alignmentData.bottomHintHeight = Math.max(
      alignmentData.bottomHintHeight,
      fieldHeights.bottomHintHeight || 0
    );
  });
  return alignmentData;
};
const processRowAlignment = (rowFields) => {
  rowFields.forEach(resetFieldSectionHeights);
  const alignmentData = calculateRowAlignmentData(rowFields);
  rowFields.forEach((field) => {
    applyFieldSectionHeights(field, alignmentData);
  });
};
const useGridFieldAligner = ({
  containerRef
}) => {
  const alignFields = useCallback(() => {
    if (!containerRef.current) return;
    const fields = Array.from(containerRef.current.children);
    const columnsPerRow = getColumnsPerRow(containerRef.current);
    const rows = groupFieldsIntoRows(fields, columnsPerRow);
    rows.forEach(processRowAlignment);
  }, [containerRef]);
  return { alignFields };
};
const useResizeHandler = ({ onResize }) => {
  const animationFrameIdRef = useRef(null);
  const handleResize = useCallback(() => {
    if (animationFrameIdRef.current !== null) {
      cancelAnimationFrame(animationFrameIdRef.current);
    }
    animationFrameIdRef.current = requestAnimationFrame(() => {
      onResize();
      animationFrameIdRef.current = null;
    });
  }, [onResize]);
  const cancelPendingResize = useCallback(() => {
    if (animationFrameIdRef.current !== null) {
      cancelAnimationFrame(animationFrameIdRef.current);
      animationFrameIdRef.current = null;
    }
  }, []);
  return { handleResize, cancelPendingResize };
};
const useResizeObserver = ({
  ref,
  enabled = true,
  onResize,
  onDisconnect
}) => {
  useEffect(() => {
    if (!enabled || !ref.current) return;
    const resizeObserver = new ResizeObserver(() => {
      onResize();
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
      onDisconnect?.();
    };
  }, [enabled, onResize, onDisconnect, ref]);
};
const useGridFieldAlignment = () => {
  const containerRef = useRef(null);
  const { alignFields } = useGridFieldAligner({ containerRef });
  const { handleResize, cancelPendingResize } = useResizeHandler({ onResize: alignFields });
  useResizeObserver({
    ref: containerRef,
    onResize: handleResize,
    onDisconnect: cancelPendingResize
  });
  return { containerRef };
};
const fieldsetClassName = {
  default: "grid-cols-2",
  compact: "grid-cols-3 tablet-d:grid-cols-2"
};
const GridFieldGroup = ({
  children,
  className,
  variant = "default",
  ...rest
}) => {
  const { containerRef } = useGridFieldAlignment();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "fieldset",
    {
      ...rest,
      ref: containerRef,
      className: twMerge(
        clsx(
          "grid gap-x-e24 gap-y-e40 mobile-d:grid-cols-1",
          "mobile-d:grid-cols-1 mobile-d:gap-y-e24",
          fieldsetClassName[variant],
          className
        )
      ),
      children
    }
  );
};
const FormCard = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Card,
    {
      className: twMerge(clsx("flex flex-col gap-e40 mobile-d:gap-e32", className)),
      ...props,
      children
    }
  );
};
const getBadgeClassName = ({ className }) => {
  const base = clsx(
    // Layout
    "flex items-center gap-e4",
    // Size
    "max-w-fit",
    // Padding
    "px-e8 py-e4",
    // Background
    "bg-purple-50",
    // Border radius
    "rounded-100",
    // Icon color
    "svg:text-purple-500"
  );
  return twMerge(base, className);
};
const _InternalBadgeIcon = ({
  icon,
  ...rest
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SyntaxIcon,
    {
      ...rest,
      icon,
      weight: "fill",
      size: "sm"
    }
  );
};
const _InternalBadgeLabel = ({
  className,
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      ...rest,
      variant: "overline",
      className: twMerge("normal-case", className),
      children
    }
  );
};
const Badge = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: getBadgeClassName({ className }),
      ...rest,
      children
    }
  );
};
Badge.Icon = _InternalBadgeIcon;
Badge.Label = _InternalBadgeLabel;
const EditBadge = ({ label = "Editing", ...rest }) => {
  const ids = useDataTestIds({
    componentConfig: {
      ICON: "icon",
      LABEL: "label"
    },
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Badge.Icon,
      {
        icon: P$1,
        ...ids.ICON
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Badge.Label, { ...ids.LABEL, children: label })
  ] });
};
const TEST_IDS_CONFIG$d = {
  // TODO (SyntaxForm): Use SyntaxForm context to generate test ids on this component.
  BASE: "form",
  BUTTON: "edit-button",
  BADGE: "edit-badge"
};
const FormEditButton = ({
  viewMode,
  buttonLabel = "Edit",
  badgeLabel = "Editing",
  disabled,
  onClick,
  viewModeClassName,
  editModeClassName,
  ...rest
}) => {
  const ids = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$d,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: viewMode ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      variant: "link",
      size: "md",
      disabled,
      onClick,
      className: viewModeClassName,
      ...ids.BUTTON,
      children: buttonLabel
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    EditBadge,
    {
      label: badgeLabel,
      className: editModeClassName,
      ...ids.BADGE
    }
  ) });
};
const Accent = "data:image/png;base64,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";
const AccentedHeading = ({ className, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: twMerge(
        "flex w-min max-w-full flex-col items-center gap-e8 text-center",
        className
      ),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Heading,
          {
            level: "h3",
            className: "w-max max-w-full",
            noDefaultMargins: true,
            ...rest
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-e32 mobile-d:px-0", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Accent }) })
      ]
    }
  );
};
const useActiveElement = ({ disabled, onFocus, onBlur }) => {
  const [active, setActive] = useToggle(false);
  const activate = useCallback(() => setActive(true), [setActive]);
  const deactivate = useCallback(() => setActive(false), [setActive]);
  const handleOnFocus = useCallback(
    (event) => {
      onFocus?.(event);
      activate();
    },
    [onFocus, activate]
  );
  const handleOnBlur = useCallback(
    (event) => {
      onBlur?.(event);
      deactivate();
    },
    [onBlur, deactivate]
  );
  return { active: !disabled && active, handleOnFocus, handleOnBlur, activate, deactivate };
};
const getRootClassName = (props, active, error2) => twMerge(
  clsx(
    "flex min-h-e56 items-center gap-e4 overflow-hidden",
    "rounded-md bg-white py-0 pl-e16 pr-e4",
    "border border-warm-gray-300",
    {
      "bg-transparent": props.readOnly,
      "cursor-not-allowed bg-warm-gray-100": props.disabled,
      "hover:border-warm-gray-500": !props.disabled && !props.readOnly && !active && !error2,
      "border-warm-gray-700": active && !error2 && !props.readOnly,
      "border-utility-error": !props.disabled && !props.readOnly && !!error2
    },
    props.className
  )
);
const getInputClassName$1 = (className) => twMerge(
  clsx(
    "flex min-w-0 grow self-stretch",
    "text-body-lg text-warm-gray-900 placeholder:text-warm-gray-500",
    "bg-transparent outline-none",
    "disabled:cursor-not-allowed disabled:text-warm-gray-600"
  ),
  className
);
const inputClassName$1 = getInputClassName$1();
const useBaseInputRootClassName = (props, active, error2, containerClassName2) => {
  return useMemo(
    () => twMerge(getRootClassName(props, active, error2), containerClassName2),
    [props, active, error2, containerClassName2]
  );
};
const maskInputClassName = clsx(inputClassName$1, "relative w-full bg-transparent");
const placeholderInputClassName = twMerge(
  clsx(inputClassName$1, "pointer-events-none absolute inset-0 text-warm-gray-500")
);
const useMaskAsPlaceholder = ({
  value,
  mask
}) => {
  const maskPlaceholderText = useMemo(() => {
    if (!mask) return "";
    return !isNil(value) ? `${value}${mask.slice(value.toString().length)}` : mask;
  }, [mask, value]);
  return {
    maskPlaceholderText
  };
};
function e$2(e3, t2) {
  (null == t2 || t2 > e3.length) && (t2 = e3.length);
  for (var r2 = 0, n2 = Array(t2); r2 < t2; r2++) n2[r2] = e3[r2];
  return n2;
}
function t$1(e3, t2, r2) {
  return t2 = i$1(t2), function(e4, t3) {
    if (t3 && ("object" == typeof t3 || "function" == typeof t3)) return t3;
    if (void 0 !== t3) throw new TypeError("Derived constructors may only return object or undefined");
    return function(e5) {
      if (void 0 === e5) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e5;
    }(e4);
  }(e3, l$3() ? Reflect.construct(t2, r2 || [], i$1(e3).constructor) : t2.apply(e3, r2));
}
function r$4(e3, t2) {
  if (!(e3 instanceof t2)) throw new TypeError("Cannot call a class as a function");
}
function n$3(e3, t2, r2) {
  return Object.defineProperty(e3, "prototype", { writable: false }), e3;
}
function o$2(t2, r2) {
  var n2 = "undefined" != typeof Symbol && t2[Symbol.iterator] || t2["@@iterator"];
  if (!n2) {
    if (Array.isArray(t2) || (n2 = function(t3, r3) {
      if (t3) {
        if ("string" == typeof t3) return e$2(t3, r3);
        var n3 = {}.toString.call(t3).slice(8, -1);
        return "Object" === n3 && t3.constructor && (n3 = t3.constructor.name), "Map" === n3 || "Set" === n3 ? Array.from(t3) : "Arguments" === n3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? e$2(t3, r3) : void 0;
      }
    }(t2)) || r2) {
      n2 && (t2 = n2);
      var o3 = 0, a2 = function() {
      };
      return { s: a2, n: function() {
        return o3 >= t2.length ? { done: true } : { done: false, value: t2[o3++] };
      }, e: function(e3) {
        throw e3;
      }, f: a2 };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var c2, i2 = true, u2 = false;
  return { s: function() {
    n2 = n2.call(t2);
  }, n: function() {
    var e3 = n2.next();
    return i2 = e3.done, e3;
  }, e: function(e3) {
    u2 = true, c2 = e3;
  }, f: function() {
    try {
      i2 || null == n2.return || n2.return();
    } finally {
      if (u2) throw c2;
    }
  } };
}
function a$2(e3, t2, r2) {
  return (t2 = function(e4) {
    var t3 = function(e5, t4) {
      if ("object" != typeof e5 || !e5) return e5;
      var r3 = e5[Symbol.toPrimitive];
      if (void 0 !== r3) {
        var n2 = r3.call(e5, t4);
        if ("object" != typeof n2) return n2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t4 ? String : Number)(e5);
    }(e4, "string");
    return "symbol" == typeof t3 ? t3 : t3 + "";
  }(t2)) in e3 ? Object.defineProperty(e3, t2, { value: r2, enumerable: true, configurable: true, writable: true }) : e3[t2] = r2, e3;
}
function c$3() {
  return c$3 = Object.assign ? Object.assign.bind() : function(e3) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var r2 = arguments[t2];
      for (var n2 in r2) ({}).hasOwnProperty.call(r2, n2) && (e3[n2] = r2[n2]);
    }
    return e3;
  }, c$3.apply(null, arguments);
}
function i$1(e3) {
  return i$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
    return e4.__proto__ || Object.getPrototypeOf(e4);
  }, i$1(e3);
}
function u$1(e3, t2) {
  if ("function" != typeof t2 && null !== t2) throw new TypeError("Super expression must either be null or a function");
  e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, writable: true, configurable: true } }), Object.defineProperty(e3, "prototype", { writable: false }), t2 && y$2(e3, t2);
}
function l$3() {
  try {
    var e3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (e4) {
  }
  return (l$3 = function() {
    return !!e3;
  })();
}
function f$1(e3, t2) {
  var r2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e3);
    t2 && (n2 = n2.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e3, t3).enumerable;
    })), r2.push.apply(r2, n2);
  }
  return r2;
}
function s$2(e3) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? f$1(Object(r2), true).forEach(function(t3) {
      a$2(e3, t3, r2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r2)) : f$1(Object(r2)).forEach(function(t3) {
      Object.defineProperty(e3, t3, Object.getOwnPropertyDescriptor(r2, t3));
    });
  }
  return e3;
}
function p$3(e3, t2) {
  if (null == e3) return {};
  var r2, n2, o3 = function(e4, t3) {
    if (null == e4) return {};
    var r3 = {};
    for (var n3 in e4) if ({}.hasOwnProperty.call(e4, n3)) {
      if (t3.includes(n3)) continue;
      r3[n3] = e4[n3];
    }
    return r3;
  }(e3, t2);
  if (Object.getOwnPropertySymbols) {
    var a2 = Object.getOwnPropertySymbols(e3);
    for (n2 = 0; n2 < a2.length; n2++) r2 = a2[n2], t2.includes(r2) || {}.propertyIsEnumerable.call(e3, r2) && (o3[r2] = e3[r2]);
  }
  return o3;
}
function y$2(e3, t2) {
  return y$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t3) {
    return e4.__proto__ = t3, e4;
  }, y$2(e3, t2);
}
function b$1(e3, t2) {
  var r2, n2 = t2.replacementChars, a2 = t2.replacement, c2 = t2.separate, i2 = n2, u2 = "", l2 = o$2(e3);
  try {
    for (l2.s(); !(r2 = l2.n()).done; ) {
      var f2, s2 = r2.value, p2 = !Object.prototype.hasOwnProperty.call(a2, s2) && (null === (f2 = a2[i2[0]]) || void 0 === f2 ? void 0 : f2.test(s2));
      (c2 && s2 === i2[0] || p2) && (i2 = i2.slice(1), u2 += s2);
    }
  } catch (e4) {
    l2.e(e4);
  } finally {
    l2.f();
  }
  return u2;
}
function v(e3, t2) {
  var r2, n2 = t2.mask, a2 = t2.replacement, c2 = t2.separate, i2 = t2.showMask, u2 = 0, l2 = "", f2 = o$2(n2);
  try {
    for (f2.s(); !(r2 = f2.n()).done; ) {
      var s2 = r2.value;
      if (!i2 && void 0 === e3[u2]) break;
      Object.prototype.hasOwnProperty.call(a2, s2) && void 0 !== e3[u2] ? l2 += e3[u2++] : l2 += s2;
    }
  } catch (e4) {
    f2.e(e4);
  } finally {
    f2.f();
  }
  if (c2 && !i2) {
    for (var p2 = n2.length - 1; p2 >= 0 && l2[p2] === n2[p2]; p2--) ;
    l2 = l2.slice(0, p2 + 1);
  }
  return l2;
}
function m(e3, t2) {
  for (var r2 = t2.mask, n2 = t2.replacement, o3 = [], a2 = 0; a2 < r2.length; a2++) {
    var c2, i2 = null !== (c2 = e3[a2]) && void 0 !== c2 ? c2 : r2[a2], u2 = Object.prototype.hasOwnProperty.call(n2, i2) ? "replacement" : void 0 !== e3[a2] && e3[a2] !== r2[a2] ? "input" : "mask";
    o3.push({ type: u2, value: i2, index: a2 });
  }
  return o3;
}
function O(e3) {
  return e3.length > 0 ? a$2({}, e3, /./) : {};
}
function h(e3, t2) {
  for (var r2 = t2.start, n2 = void 0 === r2 ? 0 : r2, o3 = t2.end, a2 = t2.mask, c2 = t2.replacement, i2 = t2.separate, u2 = e3.slice(n2, o3), l2 = a2.slice(n2, o3), f2 = "", s2 = 0; s2 < l2.length; s2++) {
    var p2 = Object.prototype.hasOwnProperty.call(c2, l2[s2]);
    p2 && void 0 !== u2[s2] && u2[s2] !== l2[s2] ? f2 += u2[s2] : p2 && i2 && (f2 += l2[s2]);
  }
  return f2;
}
function d(e3, t2) {
  var r2 = t2.mask, n2 = t2.replacement, o3 = "string" == typeof n2 ? O(n2) : n2, a2 = RegExp("[^".concat(Object.keys(o3).join(""), "]"), "g");
  return v(b$1(e3, { replacementChars: r2.replace(a2, ""), replacement: o3, separate: false }), { mask: r2, replacement: o3, separate: false, showMask: false });
}
function g$1(e3, t2) {
  var r2 = t2.mask, n2 = t2.replacement, o3 = "string" == typeof n2 ? O(n2) : n2, a2 = h(e3, { mask: r2, replacement: o3, separate: false }), c2 = RegExp("[^".concat(Object.keys(o3).join(""), "]"), "g");
  return b$1(a2, { replacementChars: r2.replace(c2, ""), replacement: o3, separate: false });
}
function j(e3, t2) {
  var r2 = t2.mask, n2 = t2.replacement, o3 = "string" == typeof n2 ? O(n2) : n2;
  return m(d(e3, { mask: r2, replacement: o3 }), { mask: r2, replacement: o3 });
}
var w$1 = ["[", "]", "\\", "/", "^", "$", ".", "|", "?", "*", "+", "(", ")", "{", "}"];
function P(e3) {
  return w$1.includes(e3) ? "\\".concat(e3) : e3;
}
function k$1(e3, t2) {
  for (var r2 = t2.mask, n2 = t2.replacement, o3 = "string" == typeof n2 ? O(n2) : n2, a2 = "partial" === e3 || "partial-inexact" === e3, c2 = "full" === e3 || "partial" === e3, i2 = "", u2 = 0; u2 < r2.length; u2++) {
    var l2 = r2[u2];
    0 === u2 && (i2 = "^"), a2 && (i2 += "("), i2 += Object.prototype.hasOwnProperty.call(o3, l2) ? "".concat(c2 ? "(?!".concat(P(l2), ")") : "", "(").concat(o3[l2].source, ")") : P(l2), u2 === r2.length - 1 && (a2 && (i2 += ")?".repeat(r2.length)), i2 += "$");
  }
  return i2;
}
function r$3(r2, e3) {
  return new Proxy(r2, { set: function(n2, t2, u2) {
    return "current" === t2 && (u2 !== r2.current && (null !== r2.current && e3.unregister(r2.current), null !== u2 && e3.register(u2)), n2[t2] = u2, true);
  } });
}
function t(t2, e3, r2) {
  return e3 = o$1(e3), function(t3, e4) {
    if (e4 && ("object" == typeof e4 || "function" == typeof e4)) return e4;
    if (void 0 !== e4) throw new TypeError("Derived constructors may only return object or undefined");
    return function(t4) {
      if (void 0 === t4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t4;
    }(t3);
  }(t2, i() ? Reflect.construct(e3, r2 || [], o$1(t2).constructor) : e3.apply(t2, r2));
}
function e$1(t2, e3) {
  if (!(t2 instanceof e3)) throw new TypeError("Cannot call a class as a function");
}
function r$2(t2, e3, r2) {
  return Object.defineProperty(t2, "prototype", { writable: false }), t2;
}
function n$2(t2, e3, r2) {
  return (e3 = function(t3) {
    var e4 = function(t4, e5) {
      if ("object" != typeof t4 || !t4) return t4;
      var r3 = t4[Symbol.toPrimitive];
      if (void 0 !== r3) {
        var n2 = r3.call(t4, e5);
        if ("object" != typeof n2) return n2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e5 ? String : Number)(t4);
    }(t3, "string");
    return "symbol" == typeof e4 ? e4 : e4 + "";
  }(e3)) in t2 ? Object.defineProperty(t2, e3, { value: r2, enumerable: true, configurable: true, writable: true }) : t2[e3] = r2, t2;
}
function o$1(t2) {
  return o$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, o$1(t2);
}
function u(t2, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t2, writable: true, configurable: true } }), Object.defineProperty(t2, "prototype", { writable: false }), e3 && a$1(t2, e3);
}
function i() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (i = function() {
    return !!t2;
  })();
}
function c$2(t2, e3) {
  var r2 = Object.keys(t2);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(t2);
    e3 && (n2 = n2.filter(function(e4) {
      return Object.getOwnPropertyDescriptor(t2, e4).enumerable;
    })), r2.push.apply(r2, n2);
  }
  return r2;
}
function f(t2) {
  for (var e3 = 1; e3 < arguments.length; e3++) {
    var r2 = null != arguments[e3] ? arguments[e3] : {};
    e3 % 2 ? c$2(Object(r2), true).forEach(function(e4) {
      n$2(t2, e4, r2[e4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(r2)) : c$2(Object(r2)).forEach(function(e4) {
      Object.defineProperty(t2, e4, Object.getOwnPropertyDescriptor(r2, e4));
    });
  }
  return t2;
}
function p$2(t2, e3) {
  if (null == t2) return {};
  var r2, n2, o3 = function(t3, e4) {
    if (null == t3) return {};
    var r3 = {};
    for (var n3 in t3) if ({}.hasOwnProperty.call(t3, n3)) {
      if (e4.includes(n3)) continue;
      r3[n3] = t3[n3];
    }
    return r3;
  }(t2, e3);
  if (Object.getOwnPropertySymbols) {
    var u2 = Object.getOwnPropertySymbols(t2);
    for (n2 = 0; n2 < u2.length; n2++) r2 = u2[n2], e3.includes(r2) || {}.propertyIsEnumerable.call(t2, r2) && (o3[r2] = t2[r2]);
  }
  return o3;
}
function a$1(t2, e3) {
  return a$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e4) {
    return t3.__proto__ = e4, t3;
  }, a$1(t2, e3);
}
function l$2(t2) {
  return l$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
    return typeof t3;
  } : function(t3) {
    return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
  }, l$2(t2);
}
function y$1(t2) {
  var e3 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return y$1 = function(t3) {
    if (null === t3 || !function(t4) {
      try {
        return -1 !== Function.toString.call(t4).indexOf("[native code]");
      } catch (e4) {
        return "function" == typeof t4;
      }
    }(t3)) return t3;
    if ("function" != typeof t3) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== e3) {
      if (e3.has(t3)) return e3.get(t3);
      e3.set(t3, r2);
    }
    function r2() {
      return function(t4, e4, r3) {
        if (i()) return Reflect.construct.apply(null, arguments);
        var n2 = [null];
        n2.push.apply(n2, e4);
        var o3 = new (t4.bind.apply(t4, n2))();
        return r3 && a$1(o3, r3.prototype), o3;
      }(t3, arguments, o$1(this).constructor);
    }
    return r2.prototype = Object.create(t3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), a$1(r2, t3);
  }, y$1(t2);
}
var n$1 = function(t$12) {
  function n2(r2) {
    var a2;
    return e$1(this, n2), (a2 = t(this, n2, [r2])).name = "SyntheticChangeError", a2;
  }
  return u(n2, t$12), r$2(n2);
}(y$1(Error));
var l$1, a = ["options"], r$1 = ["text", "email", "tel", "search", "url"], s$1 = r$2(function e(l2) {
  var s2 = l2.init, c2 = l2.tracking;
  e$1(this, e);
  var u2 = /* @__PURE__ */ new WeakMap();
  this.register = function(e3) {
    var t2;
    if (r$1.includes(e3.type)) {
      var l3 = null !== (t2 = e3._wrapperState) && void 0 !== t2 ? t2 : {}, d2 = l3.initialValue, v2 = void 0 === d2 ? "" : d2, p2 = l3.controlled, h2 = void 0 !== p2 && p2, f$12 = s2({ initialValue: e3.value || v2, controlled: h2 }), E2 = f$12.value, g2 = f$12.options, w2 = { value: E2, options: g2, fallbackOptions: g2 }, S2 = { id: -1, cachedId: -1 }, m2 = { value: "", selectionStart: 0, selectionEnd: 0 }, b2 = Object.getOwnPropertyDescriptor("_valueTracker" in e3 ? e3 : HTMLInputElement.prototype, "value");
      Object.defineProperty(e3, "value", f(f({}, b2), {}, { set: function(t3) {
        var n2;
        m2.value = t3, null == b2 || null === (n2 = b2.set) || void 0 === n2 || n2.call(e3, t3);
      } })), e3.value = E2;
      var y2 = function() {
        var t3 = function() {
          var n2, o3;
          m2.selectionStart = null !== (n2 = e3.selectionStart) && void 0 !== n2 ? n2 : 0, m2.selectionEnd = null !== (o3 = e3.selectionEnd) && void 0 !== o3 ? o3 : 0, S2.id = window.setTimeout(t3);
        };
        S2.id = window.setTimeout(t3);
      }, T2 = function() {
        window.clearTimeout(S2.id), S2.id = -1, S2.cachedId = -1;
      }, k2 = function(t3) {
        try {
          var n2, l4;
          if (S2.cachedId === S2.id) throw new n$1("The input selection has not been updated.");
          S2.cachedId = S2.id;
          var r2 = e3.value, s3 = e3.selectionStart, u3 = e3.selectionEnd;
          if (null === s3 || null === u3) throw new n$1("The selection attributes have not been initialized.");
          var d3, v3 = m2.value;
          if (void 0 === t3.inputType && (m2.selectionStart = 0, m2.selectionEnd = v3.length), s3 > m2.selectionStart ? d3 = "insert" : s3 <= m2.selectionStart && s3 < m2.selectionEnd ? d3 = "deleteBackward" : s3 === m2.selectionEnd && r2.length < v3.length && (d3 = "deleteForward"), void 0 === d3 || ("deleteBackward" === d3 || "deleteForward" === d3) && r2.length > v3.length) throw new n$1("Input type detection error.");
          var p3 = "", h3 = m2.selectionStart, f2 = m2.selectionEnd;
          if ("insert" === d3) p3 = r2.slice(m2.selectionStart, s3);
          else {
            var E3 = v3.length - r2.length;
            h3 = s3, f2 = s3 + E3;
          }
          w2.value !== v3 ? w2.options = w2.fallbackOptions : w2.fallbackOptions = w2.options;
          var g3 = w2.options, b3 = c2({ inputType: d3, previousValue: v3, previousOptions: g3, value: r2, addedValue: p3, changeStart: h3, changeEnd: f2, selectionStart: s3, selectionEnd: u3 }), y3 = b3.options, T3 = p$2(b3, a);
          e3.value = T3.value, e3.setSelectionRange(T3.selectionStart, T3.selectionEnd), w2.value = T3.value, w2.options = y3, m2.selectionStart = T3.selectionStart, m2.selectionEnd = T3.selectionEnd, null === (n2 = e3._valueTracker) || void 0 === n2 || null === (l4 = n2.setValue) || void 0 === l4 || l4.call(n2, v3);
        } catch (n3) {
          if (e3.value = m2.value, e3.setSelectionRange(m2.selectionStart, m2.selectionEnd), t3.preventDefault(), t3.stopPropagation(), "SyntheticChangeError" !== n3.name) throw n3;
        }
      };
      document.activeElement === e3 && y2(), e3.addEventListener("focus", y2), e3.addEventListener("blur", T2), e3.addEventListener("input", k2), u2.set(e3, { onFocus: y2, onBlur: T2, onInput: k2 });
    } else "production" !== process.env.NODE_ENV && console.warn("Warn: The input element type does not match one of the types: ".concat(r$1.join(", "), "."));
  }, this.unregister = function(e3) {
    var t2 = u2.get(e3);
    void 0 !== t2 && (e3.removeEventListener("focus", t2.onFocus), e3.removeEventListener("blur", t2.onBlur), e3.removeEventListener("input", t2.onInput), u2.delete(e3));
  };
});
l$1 = s$1, Object.defineProperty(l$1.prototype, Symbol.toStringTag, { writable: false, enumerable: false, configurable: true, value: "Input" });
function e2(e3, n2) {
  return useCallback(function(t2) {
    e3.current = t2, "function" == typeof n2 ? n2(t2) : "object" === l$2(n2) && null !== n2 && (n2.current = t2);
  }, [e3, n2]);
}
var k = function(e3) {
  return function() {
    for (var t2 = arguments.length, a2 = new Array(t2), n2 = 0; n2 < t2; n2++) a2[n2] = arguments[n2];
    return new e3("".concat(a2.join("\n\n"), "\n"));
  };
};
var g, y = ["track", "modify"];
function w(e3) {
  var t2, a2, n2, r2;
  return { mask: null !== (t2 = e3.mask) && void 0 !== t2 ? t2 : "", replacement: "string" == typeof e3.replacement ? O(e3.replacement) : null !== (a2 = e3.replacement) && void 0 !== a2 ? a2 : {}, showMask: null !== (n2 = e3.showMask) && void 0 !== n2 && n2, separate: null !== (r2 = e3.separate) && void 0 !== r2 && r2, track: e3.track, modify: e3.modify };
}
var b = function(g2) {
  function b2() {
    var t2, a2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return r$4(this, b2), (t2 = t$1(this, b2, [{ init: function(e3) {
      var t3 = e3.initialValue, n2 = e3.controlled, r2 = w(a2), i2 = r2.mask, l2 = r2.replacement, o3 = r2.separate, s2 = r2.showMask;
      return t3 = n2 || t3 ? t3 : s2 ? i2 : "", "production" !== process.env.NODE_ENV && function(e4) {
        var t4 = e4.initialValue, a3 = e4.mask, n3 = e4.replacement;
        t4.length > a3.length && console.error(k(Error)("The initialized value of the `value` or `defaultValue` property is longer than the value specified in the `mask` property. Check the correctness of the initialized value in the specified property.", 'Invalid value: "'.concat(t4, '".'), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
        var r3 = Object.keys(n3).filter(function(e5) {
          return e5.length > 1;
        });
        r3.length > 0 && console.error(k(Error)("Object keys in the `replacement` property are longer than one character. Replacement keys must be one character long. Check the correctness of the value in the specified property.", "Invalid keys: ".concat(r3.join(", "), "."), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
        for (var i3 = a3.slice(0, t4.length), l3 = -1, o4 = 0; o4 < i3.length; o4++) {
          var s3 = Object.prototype.hasOwnProperty.call(n3, i3[o4]);
          if (!(i3[o4] === t4[o4] || s3 && n3[i3[o4]].test(t4[o4]))) {
            l3 = o4;
            break;
          }
        }
        -1 !== l3 && console.error(k(Error)("An invalid character was found in the initialized property value `value` or `defaultValue` (index: ".concat(l3, "). Check the correctness of the initialized value in the specified property."), 'Invalid value: "'.concat(t4, '".'), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
      }({ initialValue: t3, mask: i2, replacement: l2 }), { value: t3, options: { mask: i2, replacement: l2, separate: o3 } };
    }, tracking: function(t3) {
      var n2 = t3.inputType, r2 = t3.previousValue, i2 = t3.previousOptions, l2 = t3.addedValue, o3 = t3.changeStart, s2 = t3.changeEnd, m$12 = w(a2), k2 = m$12.track, g3 = m$12.modify, b3 = p$3(m$12, y), O$12 = b3.mask, j2 = b3.replacement, T2 = b3.showMask, V2 = b3.separate, M2 = s$2(s$2({}, "insert" === n2 ? { inputType: n2, data: l2 } : { inputType: n2, data: null }), {}, { value: r2, selectionStart: o3, selectionEnd: s2 }), z2 = null == k2 ? void 0 : k2(M2);
      if (false === z2) throw new n$1("Custom tracking stop.");
      null === z2 ? l2 = "" : true !== z2 && void 0 !== z2 && (l2 = z2);
      var C2 = null == g3 ? void 0 : g3(M2);
      void 0 !== (null == C2 ? void 0 : C2.mask) && (O$12 = C2.mask), void 0 !== (null == C2 ? void 0 : C2.replacement) && (j2 = "string" == typeof (null == C2 ? void 0 : C2.replacement) ? O(null == C2 ? void 0 : C2.replacement) : C2.replacement), void 0 !== (null == C2 ? void 0 : C2.showMask) && (T2 = C2.showMask), void 0 !== (null == C2 ? void 0 : C2.separate) && (V2 = C2.separate);
      var E2 = h(r2, s$2({ end: o3 }, i2)), x2 = h(r2, s$2({ start: s2 }, i2)), P2 = RegExp("[^".concat(Object.keys(j2).join(""), "]"), "g"), S2 = O$12.replace(P2, "");
      if (E2 && (E2 = b$1(E2, { replacementChars: S2, replacement: j2, separate: V2 }), S2 = S2.slice(E2.length)), l2 && (l2 = b$1(l2, { replacementChars: S2, replacement: j2, separate: false }), S2 = S2.slice(l2.length)), "insert" === n2 && "" === l2) throw new n$1("The character does not match the key value of the `replacement` object.");
      if (V2) {
        var I2 = O$12.slice(o3, s2).replace(P2, ""), G2 = I2.length - l2.length;
        G2 < 0 ? x2 = x2.slice(-G2) : G2 > 0 && (x2 = I2.slice(-G2) + x2);
      }
      x2 && (x2 = b$1(x2, { replacementChars: S2, replacement: j2, separate: V2 }));
      var A2 = v(E2 + l2 + x2, { mask: O$12, replacement: j2, separate: V2, showMask: T2 }), N2 = function(t4) {
        var a3, n3, r3, i3 = t4.inputType, l3 = t4.value, o4 = t4.addedValue, s3 = t4.beforeChangeValue, c2 = t4.mask, u2 = t4.replacement, p2 = t4.separate, d2 = m(l3, { mask: c2, replacement: u2 }).filter(function(e3) {
          var t5 = e3.type;
          return "input" === t5 || p2 && "replacement" === t5;
        }), h2 = null === (a3 = d2[s3.length + o4.length - 1]) || void 0 === a3 ? void 0 : a3.index, v2 = null === (n3 = d2[s3.length - 1]) || void 0 === n3 ? void 0 : n3.index, m$13 = null === (r3 = d2[s3.length + o4.length]) || void 0 === r3 ? void 0 : r3.index;
        if ("insert" === i3) {
          if (void 0 !== h2) return h2 + 1;
          if (void 0 !== m$13) return m$13;
          if (void 0 !== v2) return v2 + 1;
        }
        if ("deleteForward" === i3) {
          if (void 0 !== m$13) return m$13;
          if (void 0 !== v2) return v2 + 1;
        }
        if ("deleteBackward" === i3) {
          if (void 0 !== v2) return v2 + 1;
          if (void 0 !== m$13) return m$13;
        }
        var f2 = l3.split("").findIndex(function(e3) {
          return Object.prototype.hasOwnProperty.call(u2, e3);
        });
        return -1 !== f2 ? f2 : l3.length;
      }({ inputType: n2, value: A2, addedValue: l2, beforeChangeValue: E2, mask: O$12, replacement: j2, separate: V2 });
      return { value: A2, selectionStart: N2, selectionEnd: N2, options: { mask: O$12, replacement: j2, separate: V2 } };
    } }])).format = function(e3) {
      return d(e3, w(a2));
    }, t2.formatToParts = function(e3) {
      return j(e3, w(a2));
    }, t2.unformat = function(e3) {
      return g$1(e3, w(a2));
    }, t2.generatePattern = function(e3) {
      return k$1(e3, w(a2));
    }, t2;
  }
  return u$1(b2, s$1), n$3(b2);
}();
g = b, Object.defineProperty(g.prototype, Symbol.toStringTag, { writable: false, enumerable: false, configurable: true, value: "Mask" });
function n() {
  var n2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, c2 = n2.mask, o3 = n2.replacement, m2 = n2.showMask, s2 = n2.separate, u2 = n2.track, p2 = n2.modify, i2 = useRef(null), k2 = useRef({ mask: c2, replacement: o3, showMask: m2, separate: s2, track: u2, modify: p2 });
  return k2.current.mask = c2, k2.current.replacement = o3, k2.current.showMask = m2, k2.current.separate = s2, k2.current.track = u2, k2.current.modify = p2, useMemo(function() {
    return r$3(i2, new b(k2.current));
  }, []);
}
var s = ["component", "mask", "replacement", "showMask", "separate", "track", "modify"];
function p$1(t2, p2) {
  var c2 = t2.component, n$12 = t2.mask, f2 = t2.replacement, i2 = t2.showMask, k2 = t2.separate, l2 = t2.track, u2 = t2.modify, d2 = p$3(t2, s), h2 = n({ mask: n$12, replacement: f2, showMask: i2, separate: k2, track: l2, modify: u2 }), M2 = e2(h2, p2);
  return c2 ? a__default.createElement(c2, c$3({ ref: M2 }, d2)) : a__default.createElement("input", c$3({ ref: M2 }, d2));
}
var c$1 = forwardRef(p$1);
const Component$h = forwardRef(
  ({
    startAdornment,
    endAdornment,
    error: error2,
    className,
    containerClassName: containerClassName2,
    mask,
    onFocus,
    onBlur,
    ...props
  }, ref) => {
    const { active, handleOnFocus, handleOnBlur } = useActiveElement({ onFocus, onBlur });
    const placeholderRef = useRef(null);
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const rootClassName = twMerge(
      useBaseInputRootClassName(props, active, error2),
      containerClassName2
    );
    const inputClassName2 = twMerge(maskInputClassName, className);
    const testIds = useInputDataTestIds({
      ...props
    });
    const { maskPlaceholderText } = useMaskAsPlaceholder({
      value: props.value,
      mask
    });
    const handleScroll = (e3) => {
      if (placeholderRef.current && e3.currentTarget) {
        placeholderRef.current.scrollLeft = e3.currentTarget.scrollLeft;
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: rootClassName, children: [
      startAdornment,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex-grow overflow-hidden", children: [
        !props.readOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            ref: placeholderRef,
            readOnly: true,
            tabIndex: -1,
            value: maskPlaceholderText,
            className: placeholderInputClassName,
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          c$1,
          {
            ...props,
            ref: inputRef,
            mask,
            showMask: false,
            className: inputClassName2,
            onScroll: handleScroll,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            ...testIds.BASE
          }
        )
      ] }),
      endAdornment
    ] });
  }
);
Component$h.displayName = "BaseMaskedInput";
const BaseMaskedInput = withViewMode(Component$h);
const DATE_MASK = {
  mask: "MM/DD/YYYY",
  replacement: {
    M: /\d/,
    D: /\d/,
    Y: /\d/
  },
  autoComplete: "off",
  type: "tel"
};
const MaskVariantMap = {
  date: DATE_MASK
};
const Component$g = forwardRef(
  ({ ...props }, ref) => {
    const variantProps = props.variant ? MaskVariantMap[props.variant] : {};
    const fullProps = { ...variantProps, ...props };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseMaskedInput,
      {
        ...fullProps,
        ref
      }
    );
  }
);
const MaskedInput = withFormField(withRHFVariantControlled(Component$g));
const useInputTypeProps = ({ type, inputMode }) => {
  return useMemo(() => {
    if (type === "number") {
      return {
        type: "text",
        inputMode: inputMode ?? "numeric"
      };
    }
    return { type };
  }, [type, inputMode]);
};
const TextAdornment = ({ position: position2, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      variant: "body-lg",
      className: clsx(
        "text-warm-gray-500",
        position2 === "end" && "last:mr-e12",
        position2 === "start" && "mr-e12"
      ),
      children
    }
  );
};
const UnitAdornment = ({
  unit,
  unitPlacement,
  position: position2
}) => {
  if (unit && unitPlacement === position2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TextAdornment, { position: position2, children: unit });
  }
  return null;
};
const BaseInputViewModeText = ({
  value,
  defaultValue,
  unit,
  unitPlacement,
  viewModePlaceholder,
  inputRef,
  name
}) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  const unitPrefix = unit && unitPlacement === "start" ? `${unit} ` : "";
  const unitSuffix = unit && unitPlacement === "end" ? ` ${unit}` : "";
  const rawValue = value ?? defaultValue ?? inputRef.current?.value;
  const displayValue = rawValue || rawValue === 0 ? `${unitPrefix}${rawValue}${unitSuffix}` : viewModePlaceholder;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: displayValue });
};
const Component$f = forwardRef(
  ({
    type,
    startAdornment,
    endAdornment,
    unit,
    unitPlacement = "end",
    error: error2,
    className,
    containerClassName: containerClassName2,
    onFocus,
    onBlur,
    name,
    ...props
  }, ref) => {
    const { active, handleOnFocus, handleOnBlur } = useActiveElement({ onFocus, onBlur });
    const rootClassName = useBaseInputRootClassName(props, active, error2, containerClassName2);
    const inputClassName2 = getInputClassName$1(className);
    const typeProps = useInputTypeProps({ type, inputMode: props.inputMode });
    const inputTestIds = useInputDataTestIds({
      name,
      ...props
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: rootClassName, children: [
      startAdornment,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        UnitAdornment,
        {
          unit,
          unitPlacement,
          position: "start"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ...inputTestIds.BASE,
          ...props,
          ...typeProps,
          ref,
          className: inputClassName2,
          onFocus: handleOnFocus,
          onBlur: handleOnBlur,
          name
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        UnitAdornment,
        {
          unit,
          unitPlacement,
          position: "end"
        }
      ),
      endAdornment
    ] });
  }
);
Component$f.displayName = "BaseInput";
const BaseInput = withViewMode(Component$f, {
  viewModeComponent: BaseInputViewModeText
});
const useEmptyClassName = ({
  isEmpty: isEmpty2,
  hasInitialValue,
  getEmptyClassNameFn
}) => {
  const [emptyClassName, setEmptyClassName] = useState(
    getEmptyClassNameFn(!hasInitialValue)
  );
  useEffect(() => {
    if (isEmpty2 !== void 0) {
      setEmptyClassName(getEmptyClassNameFn(!!isEmpty2));
    }
  }, [isEmpty2, getEmptyClassNameFn]);
  const setIsValueEmpty = (isValueEmpty) => {
    setEmptyClassName(getEmptyClassNameFn(isValueEmpty));
  };
  return { emptyClassName, setIsValueEmpty };
};
const withRHFVariantUncontrolled = (Component2, options) => {
  return forwardRef((props, ref) => {
    if (isString(props.name)) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ControllerWrap,
        {
          name: props.name,
          componentProps: props,
          Component: Component2,
          options,
          ref
        }
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...props,
        ref
      }
    );
  });
};
const useIsEmpty = (name, control, options) => {
  const value = useWatch({
    control,
    name,
    ...options
  });
  const isValueEmpty = useMemo(() => {
    return isEmpty(value);
  }, [value]);
  return { isEmpty: options.disabled ? void 0 : isValueEmpty };
};
const ControllerWrap = forwardRef(
  ({ name, options, componentProps, Component: Component2 }, ref) => {
    const { trigger, setValue, control } = useFormContext();
    const { errors: errors2, disabled, isSubmitting } = useFormState();
    const { watchEmptyState } = options ?? {};
    const errorMessages = useFieldErrors(name, errors2);
    const { isEmpty: isEmpty2 } = useIsEmpty(name, control, { disabled: !watchEmptyState });
    const onClear = useCallback(
      (defaultValue) => {
        setValue(name, defaultValue ?? "");
        trigger(name);
      },
      [name, setValue, trigger]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...componentProps,
        onClear,
        ref,
        error: errorMessages,
        disabled: disabled || isSubmitting || componentProps.disabled,
        isEmpty: isEmpty2
      }
    );
  }
);
const showButtonClassName = "text-h9 leading-none disabled:hidden";
const _PasswordInput = forwardRef(
  (props, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const inputType = useMemo(() => showPassword ? "text" : "password", [showPassword]);
    const showButtonIconName = useMemo(() => showPassword ? d$1 : w$2, [showPassword]);
    const handleShowPassword = () => setShowPassword(!showPassword);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseInput,
      {
        ...props,
        ref,
        type: inputType,
        viewMode: false,
        endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            iconOnly: true,
            variant: "ghost",
            size: "md",
            className: showButtonClassName,
            disabled: props.disabled,
            onClick: handleShowPassword,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: showButtonIconName })
          }
        )
      }
    );
  }
);
const PasswordInput = withFormField(withRHFVariantUncontrolled(_PasswordInput));
const RadioInputContext = createContext(void 0);
const RadioInputContextProvider = ({
  children,
  "data-testid": dataTestId,
  isError,
  disabled,
  name
}) => {
  const contextValue = useMemo(
    () => ({ "data-testid": dataTestId, isError, disabled, name }),
    [dataTestId, isError, disabled, name]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RadioInputContext.Provider, { value: contextValue, children });
};
const containerSizeStylesMap = {
  lg: "size-e40 p-e10",
  sm: "size-e32 p-e8"
};
const getRadioContainerStyles = ({ disabled, size: size2 }) => clsx(
  // Border
  "rounded-full",
  // Sizing and spacing
  containerSizeStylesMap[size2],
  "flex items-center justify-center",
  // Backgrounds
  {
    "group-hover:bg-purple-200 group-hover:bg-opacity-25": !disabled
  }
);
const outerCircleSizeStylesMap = {
  lg: "size-e20",
  sm: "size-e16"
};
const getRadioCircleOuterStyles = ({ checked, disabled, error: error2, size: size2 }) => clsx(
  // Sizing
  outerCircleSizeStylesMap[size2],
  // Backgrounds
  "bg-transparent",
  // Borders
  "outline outline-1 outline-warm-gray-700",
  "rounded-full",
  "hui-checked:outline-2",
  {
    "outline-2 outline-purple-300": checked && !error2,
    "outline-2 outline-utility-error": checked && error2,
    "outline-warm-gray-400": disabled,
    "hui-checked:outline-purple-300": !disabled,
    "outline-1 outline-utility-error hui-checked:outline-utility-error": error2 && !disabled
  },
  // Flexbox
  "flex items-center justify-center",
  "shrink-0"
);
const innerCircleSizeStylesMap = {
  lg: "size-e10",
  sm: "size-e8"
};
const getRadioCircleInnerStyles = ({ checked, disabled, error: error2, size: size2 }) => clsx(
  // Sizing
  innerCircleSizeStylesMap[size2],
  // Backgrounds
  "bg-purple-300",
  {
    "bg-warm-gray-400": disabled,
    "group-hover:hui-not-checked:bg-black-600": !disabled && !checked,
    "bg-utility-error": error2 && !disabled
  },
  // Borders
  "rounded-full",
  "opacity-0 hui-checked:opacity-100",
  {
    "opacity-100": checked
  }
);
const RadioCircle = ({
  checked,
  className,
  disabled,
  error: error2,
  innerCircleClassName,
  size: size2 = "lg"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(getRadioContainerStyles({ disabled, size: size2 }), className),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: twMerge(getRadioCircleOuterStyles({ checked, disabled, error: error2, size: size2 })), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: twMerge(
            getRadioCircleInnerStyles({ checked, disabled, error: error2, size: size2 }),
            innerCircleClassName
          )
        }
      ) })
    }
  );
};
const RadioCardVariant = (props) => {
  const ctx = useContext(RadioInputContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RadioCircle,
    {
      disabled: props.disabled || props.readOnly,
      size: props.size,
      error: ctx?.isError
    }
  );
};
const RadioPlainVariant = (props) => {
  const ctx = useContext(RadioInputContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RadioCircle,
    {
      disabled: props.disabled || props.readOnly,
      size: props.size,
      error: ctx?.isError
    }
  );
};
const getInitials = (label, maxLength) => {
  const words2 = label.split(" ");
  return words2.map((word) => word.substring(0, 1)).join("").substring(0, maxLength);
};
const sizeStyles$2 = {
  lg: "size-e40",
  sm: "size-e32"
};
const styles$1 = clsx(
  // Borders
  "border border-black-12%",
  "rounded-full",
  // Backgrounds
  "bg-orange-400 hui-disabled:bg-black-8%",
  // Flexbox
  "flex items-center justify-center",
  // Typography
  "font-semibold uppercase",
  // Margins
  "mr-e4",
  "shrink-0"
);
const RadioAbbreviationVariant = ({ size: size2, ...props }) => {
  if (props.variant === "abbreviation") {
    const { abbreviationName } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Heading,
      {
        level: "h6",
        noDefaultMargins: true,
        className: clsx(styles$1, size2 && sizeStyles$2[size2]),
        children: getInitials(abbreviationName).substring(0, 2)
      }
    );
  }
  return null;
};
const sizeStyles$1 = {
  lg: "size-e40",
  sm: "size-e32"
};
const iconStyles = {
  lg: "size-e24",
  sm: "size-e16"
};
const styles = clsx(
  // Borders
  "border border-black-12%",
  "rounded-full",
  // Backgrounds
  "bg-orange-400 hui-disabled:bg-black-8%",
  // Flexbox
  "flex items-center justify-center",
  // Typography
  "font-semibold",
  // Margins
  "mr-e4",
  "shrink-0"
);
const RadioIconVariant = ({ size: size2, ...props }) => {
  if (props.variant === "icon") {
    const { icon } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx(styles, size2 && sizeStyles$1[size2]), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SyntaxIcon,
      {
        icon,
        className: size2 && iconStyles[size2]
      }
    ) });
  }
  return null;
};
const getRadioOptionStyles = ({
  variant,
  disabled,
  readOnly,
  isError
}) => clsx(
  "box-border",
  // Spacing
  {
    "not-last:mb-e16": variant !== "plain"
  },
  // Sizing
  "flex items-center p-e16",
  {
    "min-h-es72 gap-e12": variant !== "plain",
    "max-w-max gap-e4": variant === "plain"
  },
  // Backgrounds
  {
    "bg-white": !disabled && !readOnly,
    "bg-warm-gray-50": variant !== "plain" && readOnly,
    "bg-warm-gray-100": variant !== "plain" && disabled,
    "hui-checked:bg-orchid-50": variant !== "plain" && !disabled && !readOnly
  },
  // Cursors
  "cursor-pointer",
  {
    "cursor-default": disabled || readOnly
  },
  "group",
  // Borders
  "border border-warm-gray-300",
  "rounded-sm",
  {
    "hover:hui-not-checked:border-warm-gray-500": !isError && !disabled && !readOnly,
    "hui-checked:border-warm-gray-700": !isError && !disabled && !readOnly,
    "border-utility-error": isError && !disabled && !readOnly,
    "border-none bg-transparent p-0": variant === "plain"
  }
);
const containerStyles$1 = clsx(
  "flex flex-col justify-center gap-e4",
  "overflow-x-hidden break-words text-left",
  "select-none"
);
const labelBaseStyles = "text-warm-gray-900";
const variantStyles = {
  default: "pointer-events-none",
  plain: ""
};
const sizeStyles = {
  default: {
    lg: "text-body-md",
    sm: "text-body-sm"
  },
  plain: {
    lg: "text-body-lg",
    sm: "text-body-sm"
  }
};
const textVariantMap = {
  default: "label",
  plain: "body-md"
};
const OptionInputLabel = ({
  size: size2 = "sm",
  description,
  variant,
  className,
  children
}) => {
  const resolvedVariant = variant === "plain" ? variant : "default";
  const showDescription = variant !== "plain";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: containerStyles$1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text,
      {
        variant: textVariantMap[resolvedVariant],
        className: twMerge(
          clsx(
            labelBaseStyles,
            variantStyles[resolvedVariant],
            sizeStyles[resolvedVariant][size2],
            className
          )
        ),
        children
      }
    ),
    showDescription && description && /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "hint", children: description })
  ] });
};
const useInputOptionDataTestIds = ({
  value,
  name,
  "data-testid": dataTestId,
  componentIdConfig = { BASE: "option" }
}) => {
  const componentConfig = useMemo(
    () => ({
      OPTION: String(value).toLowerCase(),
      ...componentIdConfig
    }),
    [value, componentIdConfig]
  );
  return useDataTestIds({
    componentConfig,
    ids: {
      "data-testid": dataTestId || toKebabCase(name)
    }
  });
};
const _InternalRadioOption = (props) => {
  const {
    className,
    children,
    description,
    disabled,
    readOnly,
    variant = "card",
    size: size2 = "lg",
    ...restProps
  } = props;
  const ctx = useContext(RadioInputContext);
  const cleanProps = omit(restProps, "abbreviationName", "iconName");
  const isDisabled = disabled || ctx?.disabled;
  const testIds = useInputOptionDataTestIds({
    ...ctx,
    value: restProps.value
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    it.Option,
    {
      className: twMerge(
        getRadioOptionStyles({ variant, isError: ctx?.isError, disabled, readOnly }),
        className
      ),
      disabled: isDisabled || readOnly,
      ...cleanProps,
      ...testIds.OPTION,
      children: [
        variant === "card" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioCardVariant,
          {
            ...props,
            disabled: isDisabled,
            size: size2
          }
        ),
        variant === "plain" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioPlainVariant,
          {
            ...props,
            disabled: isDisabled,
            size: size2
          }
        ),
        variant === "abbreviation" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioAbbreviationVariant,
          {
            ...props,
            disabled: isDisabled,
            size: size2
          }
        ),
        variant === "icon" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioIconVariant,
          {
            ...props,
            disabled: isDisabled,
            size: size2
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          OptionInputLabel,
          {
            size: size2,
            description,
            variant,
            className: clsx({ "text-warm-gray-600": isDisabled }),
            children
          }
        )
      ]
    }
  );
};
_InternalRadioOption.displayName = "RadioInput.Option";
const RadioViewMode = ({
  value,
  viewModePlaceholder = DEFAULT_VIEW_MODE_TEXT,
  name,
  children
}) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  if (isNil(value) || !children) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: viewModePlaceholder });
  }
  let selectedOptionContent = viewModePlaceholder;
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.props.value === value) {
      selectedOptionContent = child.props.children;
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: selectedOptionContent });
};
const TEST_ID_CONFIG$4 = {
  BASE: "radio-group"
};
const BaseRadioGroup = forwardRef(
  ({ value, children, className, error: error2, onChange, ...props }, ref) => {
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_ID_CONFIG$4
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      RadioInputContextProvider,
      {
        ...props,
        isError: !!error2,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          it,
          {
            value,
            onChange,
            ref,
            className: twMerge(clsx("flex flex-col", className)),
            ...omit(props, "onClear"),
            ...testIds.BASE,
            children
          }
        )
      }
    );
  }
);
const RHFWrapped = withFormField(
  withRHFVariantControlled(withViewMode(BaseRadioGroup, { viewModeComponent: RadioViewMode })),
  {
    labelSpacing: "lg",
    order: {
      error: "top",
      hint: "top"
    }
  }
);
const RadioGroup = {
  ...RHFWrapped,
  Option: _InternalRadioOption
};
function o2(f2) {
  return (r2) => {
    f2.forEach((n2) => {
      typeof n2 == "function" ? n2(r2) : n2 != null && (n2.current = r2);
    });
  };
}
const containerClassName$7 = clsx("relative");
const BaseSelectContext = createContext(void 0);
const BaseSelectProvider = ({
  children,
  isOpen,
  floatingContext
}) => {
  const value = useMemo(() => ({ isOpen, floatingContext }), [isOpen, floatingContext]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseSelectContext.Provider, { value, children });
};
const useBaseSelectContext = () => {
  const context = useContext(BaseSelectContext);
  if (context === void 0) {
    throw new Error("useBaseSelectContext must be used within a BaseSelectProvider");
  }
  return context;
};
const getBaseInputContainerClassName = ({ readOnly, className }) => twMerge(
  clsx(
    "pr-e16",
    {
      "bg-white": readOnly === void 0
    },
    className
  )
);
const getBaseInputClassName = ({ readOnly, className }) => twMerge(
  clsx(
    "cursor-default",
    // Because of a known Chrome bug where the input's text is truncated but the user can still scroll right
    // to reveal blank space where the text would be if not truncated, we show the full text on hover.
    // https://stackoverflow.com/q/74845827
    "not-hover:text-ellipsis",
    {
      "caret-transparent": !readOnly,
      "read-only:text-warm-gray-900": readOnly !== false
    },
    className
  )
);
const getCaretDownClassName = ({ disabled, readOnly, isOpen }) => clsx("pointer-events-none", "shrink-0", "transition-transform", {
  "-rotate-180": isOpen,
  "text-warm-gray-600": disabled || readOnly
});
const TEST_IDS_CONFIG$c = {
  CARET: "caret"
};
const BaseSelectInput = forwardRef(
  ({
    disabled,
    placeholder,
    displayValue,
    readOnly,
    className,
    containerClassName: containerClassName2,
    inputComponent: InputComponent = BaseInput,
    handleInputClick,
    handleInputFocus,
    handleInputKeyDown,
    handleInputChange,
    ...props
  }, ref) => {
    const { isOpen } = useBaseSelectContext();
    const baseContainerClassName = getBaseInputContainerClassName({
      readOnly,
      className: containerClassName2
    });
    const inputClassName2 = getBaseInputClassName({ readOnly, className });
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$c
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputComponent,
      {
        ...props,
        ref,
        value: displayValue,
        placeholder,
        containerClassName: baseContainerClassName,
        className: inputClassName2,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onKeyDown: handleInputKeyDown,
        onChange: handleInputChange,
        readOnly,
        disabled,
        autoComplete: "off",
        endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SyntaxIcon,
          {
            ...testIds.CARET,
            icon: D,
            className: getCaretDownClassName({ disabled, readOnly, isOpen })
          }
        )
      }
    );
  }
);
const getOptionClassName = ({ selected, disabled, multiple }) => {
  return twMerge(
    clsx(
      "group",
      // Spacing
      "py-e12",
      {
        "px-e8": multiple,
        "px-e16": !multiple
      },
      // Layout
      "flex items-center text-left",
      // Background
      {
        // Disabled
        "cursor-not-allowed text-warm-gray-400": disabled,
        // Enabled
        "cursor-pointer hover:bg-warm-gray/4": !disabled
      },
      {
        // Selected
        "bg-orchid-50 hover:bg-orchid-100/55 focus:bg-orchid-100/55": selected && !disabled,
        // Default
        "bg-transparent focus:bg-warm-gray/6": !selected && !disabled
      },
      // Focus
      "focus:border-transparent focus:outline-none focus:ring-0",
      // Utils
      "select-none",
      // Transitions
      "transition-bg"
    )
  );
};
const baseOptionLabelClassName = "text-warm-gray-900";
const getOptionLabelClassName = ({ disabled }) => clsx(
  baseOptionLabelClassName,
  // Overflow
  "overflow-x-hidden break-words",
  // Text
  {
    "text-warm-gray-500": disabled
  }
);
const checkboxClassName = "max-w-full";
const getMultiOptionLabelClassName = ({ disabled }) => clsx(
  baseOptionLabelClassName,
  // Text
  "text-lg mobile-d:text-lg",
  {
    "peer-disabled:group-[]:text-warm-gray-500": disabled
  }
);
const useSelectedValue = (optionValue, selectedValue) => {
  const isSelected = useMemo(() => {
    if (!selectedValue) {
      return false;
    }
    if (Array.isArray(selectedValue)) {
      return selectedValue.includes(optionValue);
    }
    return selectedValue === optionValue;
  }, [optionValue, selectedValue]);
  return isSelected;
};
const BaseSelectOptionWrapper = forwardRef(
  ({ option, isSelected, className, children, onClick, ...props }, ref) => {
    const handleOptionClick = (e3) => {
      e3.stopPropagation();
      e3.preventDefault();
      if (!option.disabled) {
        onClick?.(e3);
      }
    };
    const handleFocus = (e3) => {
      e3.stopPropagation();
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        ...props,
        ref,
        "data-testid": `${props["data-testid"]}-${option.value}`,
        "data-selected": isSelected,
        className,
        onClick: handleOptionClick,
        onFocus: handleFocus,
        tabIndex: -1,
        children
      }
    );
  }
);
const BaseSingleSelectOption = forwardRef(
  ({ option, selectedValue, onClick, ...props }, ref) => {
    const isSelected = useSelectedValue(option.value, selectedValue);
    const handleOptionClick = () => {
      onClick?.(option.value);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectOptionWrapper,
      {
        ...props,
        ref,
        option,
        isSelected,
        className: getOptionClassName({ disabled: option.disabled, selected: isSelected }),
        onClick: handleOptionClick,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph,
          {
            size: "lg",
            className: getOptionLabelClassName({ disabled: option.disabled }),
            noDefaultMargins: true,
            children: option.label
          }
        )
      }
    );
  }
);
const getDropdownClassName = () => clsx(
  // Positioning
  "absolute left-0 right-0 z-50",
  // Layout
  "flex flex-col",
  // Border
  "rounded-sm border border-warm-gray-300",
  // Background
  "bg-white",
  // Focus
  "focus:outline-none",
  // Shadow
  "shadow-drop-1",
  // Overflow
  "overflow-x-hidden overflow-y-hidden hover:overflow-y-auto mobile-d:overflow-y-scroll",
  // Scrollbar
  "scrollbar-thin"
);
const DEFAULT_TIMEOUT = 750;
const useTypeAhead = ({
  timeout = DEFAULT_TIMEOUT,
  onChange
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [typeAheadTimeoutId, setTypeAheadTimeoutId] = useState(null);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchValue("");
    }, timeout);
    setTypeAheadTimeoutId(timeoutId);
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [searchValue, timeout]);
  const handleTypeAhead = useCallback(
    (char) => {
      if (typeAheadTimeoutId) {
        clearTimeout(typeAheadTimeoutId);
      }
      const newSearchValue = searchValue + char;
      onChange?.(newSearchValue);
      setSearchValue(newSearchValue);
    },
    [onChange, searchValue, typeAheadTimeoutId]
  );
  return {
    searchValue,
    handleTypeAhead
  };
};
const useDropdownTypeAhead = ({
  options,
  onFocusChange
}) => {
  const handleTypeAheadChange = (value) => {
    const matchingIndex = options.findIndex(
      (option) => !option.disabled && option.label.toLowerCase().startsWith(value.toLowerCase())
    );
    if (matchingIndex >= 0) {
      onFocusChange(matchingIndex);
    }
  };
  const { handleTypeAhead } = useTypeAhead({
    onChange: handleTypeAheadChange
  });
  return { handleTypeAhead };
};
const FORWARD_DIRECTION = 1;
const BACKWARD_DIRECTION = -1;
const useBaseSelectDropdown = ({
  isOpen,
  options,
  value,
  onCloseRequest
}) => {
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const optionRefs = useRef([]);
  const { handleTypeAhead } = useDropdownTypeAhead({
    options,
    onFocusChange: setFocusedIndex
  });
  useEffect(() => {
    if (!isOpen) {
      optionRefs.current = [];
      setFocusedIndex(-1);
    }
  }, [isOpen]);
  useEffect(() => {
    optionRefs.current = optionRefs.current.slice(0, options.length);
  }, [options]);
  useEffect(() => {
    if (focusedIndex >= 0 && optionRefs.current[focusedIndex]) {
      optionRefs.current[focusedIndex]?.focus();
    }
  }, [focusedIndex]);
  const getNextFocusedIndex = (direction = FORWARD_DIRECTION) => {
    let nextIndex = focusedIndex;
    do {
      nextIndex = (nextIndex + direction + options.length) % options.length;
    } while (options[nextIndex]?.disabled && nextIndex !== focusedIndex);
    return nextIndex;
  };
  const syncFocusedIndex = () => {
    const selectedValue = Array.isArray(value) ? value[0] : value;
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedValue
    );
    setFocusedIndex(selectedIndex >= 0 ? selectedIndex : getNextFocusedIndex());
  };
  const moveFocus = (direction) => {
    const nextIndex = getNextFocusedIndex(direction);
    setFocusedIndex(nextIndex);
  };
  const handleFocus = () => {
    if (focusedIndex === -1) {
      syncFocusedIndex();
    }
  };
  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFocusedIndex(-1);
    }
  };
  const handleKeyDown = (e3) => {
    if (options.length === 0) {
      return;
    }
    switch (e3.key) {
      case "ArrowDown":
      case "ArrowUp": {
        e3.preventDefault();
        moveFocus(e3.key === "ArrowDown" ? FORWARD_DIRECTION : BACKWARD_DIRECTION);
        break;
      }
      case "Tab": {
        e3.preventDefault();
        break;
      }
      case "Escape":
        onCloseRequest();
        break;
      default: {
        if (e3.key.length === 1) {
          handleTypeAhead(e3.key);
        }
      }
    }
  };
  return {
    focusedIndex,
    optionRefs,
    handleFocus,
    handleBlur,
    handleKeyDown
  };
};
const getMessageItemClassName = () => {
  return clsx(
    // Spacing
    "px-e16 py-e8",
    // Text
    "text-warm-gray-500"
  );
};
const BaseSelectMessageItem = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paragraph,
    {
      size: "lg",
      className: getMessageItemClassName(),
      noDefaultMargins: true,
      children
    }
  );
};
const FloatingSelectDropdown = ({
  isOpen,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FloatingPortal, { children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(FloatingFocusManager, { ...props, children }) });
};
const TEST_IDS_CONFIG$b = {
  OPTION: "option"
};
const BaseSelectDropdown = forwardRef(
  ({
    isOpen,
    value,
    options,
    loading,
    loadingText,
    placeholder,
    optionComponent: OptionComponent,
    initialFocus,
    onOptionClick,
    onCloseRequest,
    ...props
  }, ref) => {
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$b
    });
    const { optionRefs, handleFocus, handleBlur, handleKeyDown } = useBaseSelectDropdown({
      isOpen,
      value,
      options,
      onCloseRequest
    });
    const { floatingContext } = useBaseSelectContext();
    const createRefs = (element, index2) => {
      optionRefs.current[index2] = element;
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FloatingSelectDropdown,
      {
        isOpen,
        context: floatingContext,
        initialFocus,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ...props,
            ref,
            className: getDropdownClassName(),
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            children: [
              loading && /* @__PURE__ */ jsxRuntimeExports.jsx(BaseSelectMessageItem, { children: loadingText }),
              !loading && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                options.length === 0 && placeholder && /* @__PURE__ */ jsxRuntimeExports.jsx(BaseSelectMessageItem, { children: placeholder }),
                options.map((option, index2) => /* @__PURE__ */ createElement(
                  OptionComponent,
                  {
                    ...testIds.OPTION,
                    ref: (el2) => createRefs(el2, index2),
                    key: `${option.value}-${index2}`,
                    option,
                    selectedValue: value,
                    onClick: option.disabled ? void 0 : onOptionClick
                  }
                ))
              ] })
            ]
          }
        )
      }
    );
  }
);
const containerSizeMap = {
  lg: "size-e40 p-e10",
  sm: "size-e32 p-e8"
};
const getContainerStyles = ({
  disabled,
  className,
  size: size2
}) => twMerge(
  clsx(
    // Position
    "relative",
    // Size
    containerSizeMap[size2],
    "shrink-0",
    // Border
    "rounded-full",
    // Background
    "peer-focus-visible:group-[]:bg-purple-200 peer-focus-visible:group-[]:bg-opacity-25",
    {
      "group-hover:bg-purple-200 group-hover:bg-opacity-25": !disabled
    },
    className
  )
);
const inputSizeMap = {
  lg: "size-e20",
  sm: "size-e16"
};
const getInputStyles = ({ disabled, error: error2, size: size2 }) => twMerge(
  clsx(
    // Position
    "absolute",
    // Size
    inputSizeMap[size2],
    // Background
    "peer-checked:group-[]:bg-purple-300 peer-disabled:peer-checked:group-[]:bg-warm-gray-400",
    { "peer-checked:group-[]:bg-utility-error": error2 },
    // Cursor
    { "cursor-pointer": !disabled },
    // Border
    "rounded-2.5 peer-checked:group-[]:rounded-3",
    "border border-warm-gray-700",
    "peer-checked:group-[]:border-0 peer-disabled:group-[]:border-warm-gray-400",
    { "border-utility-error": error2 }
  )
);
const iconSizeMap = {
  lg: "size-e40",
  sm: "size-e32"
};
const getCheckIconStyles = ({ size: size2 }) => clsx(
  // Position
  "absolute left-0 top-0",
  // Size
  iconSizeMap[size2],
  // Color
  "text-white",
  // Display
  "hidden peer-checked:group-[]:block",
  // Mouse events
  "pointer-events-none"
);
const BaseCheckbox = ({ className, ...props }) => {
  const { disabled, error: error2, size: size2 } = props;
  const containerStyles2 = getContainerStyles({ disabled, size: size2, className });
  const inputStyles2 = getInputStyles({ disabled, size: size2, error: !!error2 });
  const checkIconStyles = getCheckIconStyles({ size: size2 });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: containerStyles2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: inputStyles2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SyntaxIcon,
      {
        icon: "Check",
        className: checkIconStyles
      }
    )
  ] });
};
const getBaseStyles = ({ disabled, readOnly }) => clsx("group", "flex", "peer-focus-visible:border-transparent peer-focus-visible:ring", {
  "cursor-pointer": !disabled && !readOnly
});
const getVariantStyles = ({
  disabled,
  readOnly,
  error: error2
}) => ({
  plain: clsx("gap-e4", "max-w-max"),
  card: clsx(
    // Spacing
    "gap-e12 p-e16",
    // Border
    "rounded-sm",
    "border border-warm-gray-300",
    {
      "border-utility-error": error2 && !disabled,
      "hover:border-warm-gray-500 peer-checked:border-warm-gray-700": !disabled && !readOnly && !error2
    },
    // Background
    "bg-white",
    {
      "bg-warm-gray-100": disabled,
      "bg-warm-gray-50": readOnly,
      "peer-checked:bg-orchid-50": !disabled && !readOnly
    }
  )
});
const getDefaultLabelStyles = ({ disabled }) => clsx({
  "text-warm-gray-600": disabled
});
const TEST_ID_CONFIG$3 = {
  BASE: "checkbox"
};
const Component$e = forwardRef(
  ({
    children,
    description,
    className,
    variant = "card",
    size: size2 = "lg",
    error: error2,
    labelClassName,
    ...props
  }, ref) => {
    const { disabled, readOnly, ...restProps } = props;
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_ID_CONFIG$3
    });
    const variantStyles2 = getVariantStyles({ disabled, readOnly, error: !!error2 });
    const baseStyles = getBaseStyles({ disabled, readOnly });
    const labelStyles = twMerge(getDefaultLabelStyles({ disabled }), labelClassName);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ref,
          ...restProps,
          className: "peer absolute size-0 appearance-none",
          type: "checkbox",
          disabled: disabled || readOnly,
          ...testIds.BASE
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "label",
        {
          htmlFor: props.id,
          className: twMerge(clsx(baseStyles, variantStyles2[variant]), className),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              BaseCheckbox,
              {
                disabled: disabled || readOnly,
                error: error2,
                size: size2
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              OptionInputLabel,
              {
                size: size2,
                description,
                variant,
                className: labelStyles,
                children
              }
            )
          ]
        }
      )
    ] });
  }
);
const Checkbox = withFormField(withRHFVariantUncontrolled(Component$e), {
  labelSpacing: "lg",
  order: {
    error: "top",
    hint: "top"
  }
});
const BaseMultiSelectOption = forwardRef(
  ({ option, selectedValue, onClick, ...props }, ref) => {
    const isSelected = useSelectedValue(option.value, selectedValue);
    const handleOptionClick = () => {
      const newValue = isSelected ? selectedValue.filter((value) => value !== option.value) : [...selectedValue || [], option.value];
      onClick?.(newValue);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectOptionWrapper,
      {
        ...props,
        ref,
        option,
        isSelected,
        className: getOptionClassName({
          disabled: option.disabled,
          selected: isSelected,
          multiple: true
        }),
        onClick: handleOptionClick,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox,
          {
            standalone: true,
            id: `option-${option.value}`,
            "data-testid": `${props["data-testid"]}-${option.value}-checkbox`,
            variant: "plain",
            checked: isSelected,
            disabled: option.disabled,
            className: checkboxClassName,
            labelClassName: getMultiOptionLabelClassName({ disabled: option.disabled }),
            children: option.label
          }
        )
      }
    );
  }
);
const OBSERVER_ID_ATTRIBUTE = "data-click-outside-observer-id";
function useClickOutside({
  ref,
  observerId,
  enabled = true,
  callback
}) {
  useEffect(() => {
    if (!enabled) return;
    const handleClickOutside = (event) => {
      const target = event.target;
      if (ref.current?.contains(target)) {
        return;
      }
      const componentId = ref.current?.getAttribute(OBSERVER_ID_ATTRIBUTE);
      if (componentId) {
        const relatedElement = target.closest(`[${OBSERVER_ID_ATTRIBUTE}="${componentId}"]`);
        if (relatedElement) {
          return;
        }
      }
      callback(event);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback, enabled]);
  return {
    [OBSERVER_ID_ATTRIBUTE]: observerId
  };
}
const TEST_IDS_CONFIG$a = {
  BASE: "select",
  INPUT: "input",
  DROPDOWN: "dropdown"
};
const BaseSelect = forwardRef(
  ({
    options,
    disabled,
    placeholder = "Select an option",
    displayValue,
    className,
    multiple = false,
    value,
    loading,
    loadingText = "Loading...",
    dropdownPlaceholder = "No options found",
    inputComponent: InputComponent = BaseSelectInput,
    dropdownComponent: DropdownComponent = BaseSelectDropdown,
    optionComponent,
    ...props
  }, ref) => {
    const {
      isOpen,
      containerRef,
      inputRef,
      dropdownRef,
      handleSelectClick,
      handleDropdownCloseRequest,
      handleOptionClick,
      ...restProps
    } = props;
    useImperativeHandle(ref, () => inputRef.current);
    const rootClassName = twMerge(containerClassName$7, className);
    const id = useId();
    const clickOutsideObserverProps = useClickOutside({
      ref: containerRef,
      observerId: id,
      enabled: isOpen,
      callback: handleDropdownCloseRequest
    });
    const { refs, floatingStyles, context, getReferenceProps, getFloatingProps } = useFloatingDropdown({
      isOpen,
      config: {
        minDropdownHeight: 144,
        maxDropdownHeight: 270,
        matchReferenceWidth: true
      }
    });
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$a
    });
    const OptionComponent = optionComponent || (multiple ? BaseMultiSelectOption : BaseSingleSelectOption);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectProvider,
      {
        isOpen,
        floatingContext: context,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ...testIds.BASE,
            ...getReferenceProps(),
            ...clickOutsideObserverProps,
            "data-value": value,
            ref: o2([containerRef, refs.setReference]),
            className: rootClassName,
            tabIndex: -1,
            onClick: handleSelectClick,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                InputComponent,
                {
                  ...restProps,
                  ...testIds.INPUT,
                  ref: inputRef,
                  disabled,
                  placeholder,
                  displayValue
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DropdownComponent,
                {
                  ...testIds.DROPDOWN,
                  ...getFloatingProps(),
                  ...clickOutsideObserverProps,
                  ref: o2([dropdownRef, refs.setFloating]),
                  style: floatingStyles,
                  isOpen,
                  loading,
                  loadingText,
                  placeholder: dropdownPlaceholder,
                  value,
                  options,
                  optionComponent: OptionComponent,
                  onOptionClick: handleOptionClick,
                  onCloseRequest: handleDropdownCloseRequest
                }
              )
            ]
          }
        )
      }
    );
  }
);
const BaseSelectViewModeText = ({
  value,
  viewModePlaceholder,
  options,
  name
}) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  const selectedOption = value ? options.find((option) => option.value === value) : null;
  const displayValue = selectedOption?.label ?? viewModePlaceholder;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: displayValue });
};
const useBaseSelect = ({
  disabled,
  readOnly,
  isOpen,
  onChange,
  toggleDropdown,
  openDropdown,
  closeDropdown
}) => {
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const focusDropdown = () => {
    openDropdown();
    dropdownRef.current?.focus();
  };
  const handleSelectClick = (e3) => {
    e3.preventDefault();
    if (disabled || readOnly) {
      return;
    }
    inputRef.current?.focus();
    toggleDropdown();
  };
  const handleInputClick = (e3) => {
    e3.stopPropagation();
    e3.preventDefault();
    if (disabled || readOnly) {
      return;
    }
    toggleDropdown();
  };
  const handleInputKeyDown = (e3) => {
    switch (e3.key) {
      case "Enter": {
        e3.preventDefault();
        focusDropdown();
        break;
      }
      case "Escape":
        closeDropdown();
        break;
      case "ArrowDown":
      case "ArrowUp": {
        e3.preventDefault();
        focusDropdown();
        break;
      }
    }
  };
  const handleDropdownCloseRequest = () => {
    inputRef.current?.focus();
    closeDropdown();
  };
  const handleOptionClick = (optionValue) => {
    onChange?.(optionValue);
    closeDropdown();
  };
  return {
    isOpen,
    containerRef,
    inputRef,
    dropdownRef,
    handleInputClick,
    handleInputKeyDown,
    handleSelectClick,
    handleOptionClick,
    handleDropdownCloseRequest
  };
};
const useBaseSelectState = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = useCallback(() => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  }, []);
  const openDropdown = useCallback(() => {
    setIsOpen(true);
  }, []);
  const closeDropdown = useCallback(() => {
    setIsOpen(false);
  }, []);
  return { isOpen, setIsOpen, toggleDropdown, openDropdown, closeDropdown };
};
const getDisplayValue = ({ options, value }) => {
  const selectedOption = options.find((option) => option.value === value);
  if (selectedOption) {
    return selectedOption.label;
  }
  return "";
};
const useDisplayValue$2 = ({
  options,
  value,
  formatterFn = getDisplayValue,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState("");
  useEffect(() => {
    if (!value || !options) {
      setDisplayValue("");
      return;
    }
    setDisplayValue(formatterFn({ options, value, ...props }));
  }, [value, options, props, formatterFn]);
  return { displayValue };
};
const useSelectInputTypeAhead = ({
  options,
  onChange
}) => {
  const handleTypeAheadChange = (value) => {
    const typeAheadValue = value.toLowerCase();
    const matchingOptions = options.filter(
      (option) => !option.disabled && option.label.toLowerCase().startsWith(typeAheadValue)
    );
    if (matchingOptions.length > 0) {
      const currentIndex = matchingOptions.findIndex((option) => option.value === value);
      const nextIndex = currentIndex >= 0 && currentIndex < matchingOptions.length - 1 ? currentIndex + 1 : 0;
      const nextOption = matchingOptions[nextIndex];
      if (nextOption) {
        onChange?.(nextOption.value);
      }
    }
  };
  const { handleTypeAhead } = useTypeAhead({
    onChange: handleTypeAheadChange
  });
  return { handleTypeAhead };
};
const useSelect = (props) => {
  const baseSelectState = useBaseSelectState();
  const handleChange = (value) => {
    props.onChange?.(value);
  };
  const { handleInputKeyDown: handleInputKeyDownBase, ...baseSelectOwnProps } = useBaseSelect({
    ...props,
    ...baseSelectState,
    onChange: handleChange
  });
  const { handleTypeAhead } = useSelectInputTypeAhead({
    options: props.options,
    onChange: props.onChange
  });
  const handleInputKeyDown = (e3) => {
    handleInputKeyDownBase(e3);
    if (e3.key.length === 1) {
      handleTypeAhead(e3.key);
    }
  };
  return {
    ...baseSelectOwnProps,
    handleInputKeyDown
  };
};
const Component$d = forwardRef((props, ref) => {
  const { onChange, ...restProps } = props;
  const baseSelectOwnProps = useSelect({
    ...props
  });
  const { displayValue } = useDisplayValue$2({
    ...props
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseSelect,
    {
      ...restProps,
      ...baseSelectOwnProps,
      ref,
      displayValue
    }
  );
});
Component$d.displayName = "Select";
const ComponentWithViewMode$3 = withViewMode(Component$d, {
  viewModeComponent: BaseSelectViewModeText
});
const Select = withFormField(withRHFVariantControlled(ComponentWithViewMode$3));
const getTextAreaClassName = ({ autoAdjustHeight }) => clsx("h-full min-h-es52 py-e16 pr-e12", "resize-none", "transition-height", {
  "overflow-hidden hover:overflow-auto": !autoAdjustHeight,
  "scrollbar-hidden": autoAdjustHeight
});
const defaultRootClassName = clsx("flex-col pb-e4");
const useAutoHeight = () => {
  const resize = (element) => {
    element.style.height = "inherit";
    element.style.height = `${element.scrollHeight}px`;
  };
  return { resize };
};
const useTextAreaResizeHandler = ({
  ref,
  autoAdjustHeight
}) => {
  const { resize } = useAutoHeight();
  const { handleResize, cancelPendingResize } = useResizeHandler({
    onResize: () => {
      if (ref.current) {
        resize(ref.current);
      }
    }
  });
  useResizeObserver({
    ref,
    enabled: autoAdjustHeight,
    onResize: () => {
      if (autoAdjustHeight) {
        handleResize();
      }
    },
    onDisconnect: cancelPendingResize
  });
  return { handleResize };
};
const TEST_ID_CONFIG$2 = {
  BASE: "textarea"
};
const Component$c = forwardRef(
  ({ className, error: error2, rows = 3, autoAdjustHeight = true, onFocus, onBlur, onChange, ...props }, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const { active, handleOnFocus, handleOnBlur } = useActiveElement({ onFocus, onBlur });
    const { handleResize } = useTextAreaResizeHandler({
      ref: inputRef,
      autoAdjustHeight
    });
    const baseInputRootClassName = useMemo(
      () => getRootClassName(props, active, error2),
      [props, active, error2]
    );
    const rootClassName = clsx(baseInputRootClassName, defaultRootClassName, className);
    const inputClassName2 = clsx(
      inputClassName$1,
      getTextAreaClassName({ autoAdjustHeight, ...props })
    );
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_ID_CONFIG$2
    });
    const handleChange = (e3) => {
      onChange?.(e3);
      if (autoAdjustHeight) {
        handleResize();
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: rootClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "textarea",
      {
        ...props,
        rows,
        ref: inputRef,
        className: inputClassName2,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        onChange: handleChange,
        ...testIds.BASE
      }
    ) });
  }
);
const TextArea = withFormField(withRHFVariantUncontrolled(withViewMode(Component$c)));
const useClearableTextInput = ({
  defaultValue,
  value,
  disabled,
  readOnly,
  showClearButton = true,
  onChange,
  onClear
}) => {
  const inputRef = useRef(null);
  const [isClearable, setIsClearable] = useToggle(!!defaultValue || !!value);
  useEffect(() => {
    setIsClearable(!!inputRef.current?.value);
  }, []);
  const handleOnChange = useCallback(
    (e3) => {
      onChange?.(e3);
      const target = e3.target;
      setIsClearable(!!target.value);
    },
    [onChange, setIsClearable]
  );
  const canBeCleared = useMemo(
    () => showClearButton && isClearable && !disabled && !readOnly,
    [showClearButton, isClearable, disabled, readOnly]
  );
  const handleOnClear = useCallback(() => {
    onClear?.("");
    setIsClearable(false);
    inputRef.current?.focus();
  }, [onClear, setIsClearable]);
  return {
    inputRef,
    isClearable,
    canBeCleared,
    handleOnChange,
    handleOnClear
  };
};
const TEST_ID_CONFIG$1 = {
  BASE: "input",
  CLEAR: "clear-button"
};
const Component$b = forwardRef(
  ({ error: error2, unit, showClearButton = !unit, endAdornment, onClear, onChange, ...props }, ref) => {
    const { inputRef, canBeCleared, handleOnChange, handleOnClear } = useClearableTextInput({
      showClearButton,
      onChange,
      onClear,
      ...props
    });
    useImperativeHandle(ref, () => inputRef.current);
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_ID_CONFIG$1
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseInput,
      {
        ...props,
        ref: inputRef,
        unit,
        error: error2,
        onChange: handleOnChange,
        endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          endAdornment && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: endAdornment }),
          canBeCleared && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              iconOnly: true,
              variant: "ghost",
              size: "md",
              onClick: handleOnClear,
              tabIndex: -1,
              ...testIds.CLEAR,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: R$1 })
            }
          )
        ] })
      }
    );
  }
);
const TextInput = withFormField(withRHFVariantUncontrolled(Component$b));
const getEmptyClassName = (isEmpty2) => clsx({
  "text-warm-gray-500": isEmpty2
});
const getInputClassName = ({ emptyClassName, className }) => twMerge(
  clsx(
    "peer",
    "uppercase",
    "relative content-center",
    // Since the input's text is being set to uppercase, Chrome is not calculating
    // the width of the "placeholder" text correctly and the mask used to hide the
    // native date input icon overlaps with the input's text.
    // Using display: block fixes this issue.
    "block",
    // Required for correcting the centering of the input's text in Safari when
    // using display: block.
    "leading-15",
    emptyClassName,
    className
  )
);
const dateInputTypeFormatMap = {
  date: "MM/dd/yyyy",
  "datetime-local": "MM/dd/yyyy HH:mm",
  time: "HH:mm"
};
const formatDateValue = ({
  inputType,
  rawValue,
  formatFn
}) => {
  const isTime = inputType === "time";
  const dateValue = isTime ? new Date(rawValue) : parseISO(rawValue);
  if (isValid(dateValue)) {
    return formatFn(dateValue, dateInputTypeFormatMap[inputType]);
  }
  return rawValue;
};
const DateInputViewModeText = ({
  value,
  defaultValue,
  viewModePlaceholder = DEFAULT_VIEW_MODE_TEXT,
  type = "date",
  inputRef,
  dateFormatFn = format,
  name
}) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  const rawValue = value ?? defaultValue ?? inputRef.current?.value;
  if (!rawValue) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: viewModePlaceholder });
  }
  const formattedValue = formatDateValue({
    inputType: type,
    rawValue,
    formatFn: dateFormatFn
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.VIEW_MODE_TEXT, children: formattedValue });
};
const Component$a = forwardRef(
  ({ type = "date", className, isEmpty: isEmpty2, onChange, ...props }, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const { emptyClassName, setIsValueEmpty } = useEmptyClassName({
      isEmpty: isEmpty2,
      hasInitialValue: !!props.defaultValue,
      getEmptyClassNameFn: getEmptyClassName
    });
    const inputClassName2 = getInputClassName({ emptyClassName, className });
    const handleOnChange = (e3) => {
      setIsValueEmpty(!e3.target.value);
      onChange?.(e3);
    };
    const handleOnIconClick = () => {
      inputRef.current?.focus();
      inputRef.current?.showPicker();
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseInput,
      {
        ...props,
        viewMode: false,
        type,
        ref: inputRef,
        containerClassName: "syntax-date-input",
        className: inputClassName2,
        onChange: handleOnChange,
        endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            iconOnly: true,
            tabIndex: 0,
            variant: "ghost",
            size: "md",
            disabled: props.disabled || props.readOnly,
            onClick: handleOnIconClick,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: type === "time" ? C$1 : w$5 })
          }
        )
      }
    );
  }
);
const ComponentWithViewMode$2 = withViewMode(Component$a, {
  viewModeComponent: DateInputViewModeText
});
const DateInput = withFormField(
  withRHFVariantUncontrolled(ComponentWithViewMode$2, { watchEmptyState: true })
);
const PHONE_NUMBER_MASKS = {
  US: {
    mask: "(###) ###-####",
    replacement: { "#": /\d/ }
  }
};
const _PhoneNumberInput = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskedInput,
    {
      ...props,
      standalone: true,
      ref,
      mask: PHONE_NUMBER_MASKS[props.phoneType].mask,
      replacement: PHONE_NUMBER_MASKS[props.phoneType].replacement
    }
  );
});
const PhoneNumberInput = withFormField(_PhoneNumberInput);
const CheckboxGroupOption = ({
  option,
  value,
  checked,
  onChange,
  ...props
}) => {
  const testIds = useInputOptionDataTestIds({
    value,
    ...props,
    componentIdConfig: {
      BASE: ""
    }
  });
  const id = testIds.OPTION?.["data-testid"] || "";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "w-full",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox,
        {
          ...props,
          standalone: true,
          value,
          id,
          "data-testid": id,
          description: option.hint,
          checked,
          onChange,
          children: option.label
        }
      )
    },
    option.label
  );
};
const TEST_ID_CONFIG = {
  BASE: "checkbox-group",
  OPTION: "option"
};
const Component$9 = forwardRef(
  ({ options, value: selectedValues = [], className, onChange, ...props }, ref) => {
    const isPlain = props.variant === "plain";
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_ID_CONFIG
    });
    const handleChange = (e3) => {
      const { value, checked, ...rest } = e3.target;
      const index2 = selectedValues.indexOf(value);
      const newValues = index2 === -1 ? [...selectedValues, value] : selectedValues.filter((_2, i2) => i2 !== index2);
      const event = {
        target: { ...rest, value: newValues }
      };
      onChange?.(event);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: twMerge(clsx("flex flex-col gap-e16", { "gap-0": isPlain }), className),
        ref,
        ...testIds.BASE,
        children: options.map((option) => {
          const value = option.value ?? option.label;
          const checked = selectedValues?.includes(value);
          return /* @__PURE__ */ createElement(
            CheckboxGroupOption,
            {
              ...props,
              key: option.label,
              option,
              value,
              checked,
              onChange: handleChange,
              ...testIds.OPTION
            }
          );
        })
      }
    );
  }
);
const CheckboxGroup = withFormField(withRHFVariantControlled(Component$9), {
  labelSpacing: "lg",
  order: {
    error: "top",
    hint: "top"
  }
});
const containerClassName$6 = "appearance-none";
const getChipClassName = ({ disabled, error: error2, className }) => clsx(
  // Layout
  "flex items-center justify-center gap-e8 text-center",
  // Size
  "h-full max-w-max",
  // Padding
  "p-e16 mobile-d:p-e12",
  // Text
  "text-warm-gray-900",
  "text-h6 font-medium mobile-d:text-label",
  {
    "text-warm-gray-600": disabled
  },
  // Border
  "rounded-sm",
  "border border-warm-gray-300",
  "hover:border-warm-gray-700",
  {
    "peer-checked:border-warm-gray-700": !error2 && !disabled,
    "border-utility-error": error2 && !disabled,
    "peer-focus:ring-2 peer-focus:peer-checked:ring-0": !disabled
  },
  // Background
  "bg-white",
  "hover:bg-orchid-50",
  { "peer-checked:bg-orchid-100": !disabled, "bg-warm-gray-100": disabled },
  // Cursor
  "cursor-pointer select-none",
  { "pointer-events-none cursor-default": disabled },
  // Icon
  "svg:size-e20 mobile-d:svg:size-e16",
  { "svg:text-utility-error": error2 && !disabled },
  // Animation
  "transition-all",
  // Custom class
  className
);
const inputClassName = "peer absolute size-0 appearance-none";
const BaseRadioChip = forwardRef((props, ref) => {
  const { id, disabled, error: error2, className, containerClassName: containerClassName2, children, ...restProps } = props;
  const classNameMerged = twMerge(getChipClassName({ disabled, error: error2, className }));
  const containerClassNameMerged = twMerge(containerClassName$6, containerClassName2);
  const testIds = useInputOptionDataTestIds({
    ...props,
    componentIdConfig: {
      BASE: ""
    }
  });
  const inputId = id ?? `chip-${props.name}-${props.value}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: containerClassNameMerged, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        ...restProps,
        ref,
        type: "radio",
        className: inputClassName,
        id: inputId,
        disabled,
        ...testIds.OPTION
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        htmlFor: inputId,
        className: classNameMerged,
        children
      }
    )
  ] });
});
const StandardChip = forwardRef(
  (props, ref) => {
    if (props.variant !== "standard") {
      throw new Error(
        `StandardChip component can only be used with standard variant. Current variant is: ${props.variant}`
      );
    }
    const { startAdornment, label, endAdornment, ...rest } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      BaseRadioChip,
      {
        ...rest,
        ref,
        children: [
          startAdornment,
          label,
          endAdornment
        ]
      }
    );
  }
);
const isValidDate = (value) => value && !isNaN(value.getTime());
const getDateChipLabels = (value, dateFormatFn) => {
  if (!isValidDate(value)) {
    throw new Error("DateChip component must be provided with a valid date prop");
  }
  const dayOfTheWeek = value && dateFormatFn(value, "E");
  const monthDate = value && dateFormatFn(value, "MMM d");
  return { dayOfTheWeek, monthDate };
};
const dateChipClassName = clsx(
  // Alignment
  "flex flex-col items-center",
  // Size
  "max-w-none",
  // Spacing
  "gap-0 px-e4"
);
const getMonthDateClassName = ({ disabled }) => clsx("font-normal mobile-d:text-body-sm", { "text-disabled": disabled });
const DateRadioChipGroupContext = createContext({
  dateFormatFn: format
});
const useDateRadioChipGroupContext = () => {
  const context = useContext(DateRadioChipGroupContext);
  if (!context) {
    throw new Error(
      "useDateRadioChipGroupContext must be used within a DateRadioChipGroupProvider"
    );
  }
  return context;
};
const DateRadioChipGroupProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DateRadioChipGroupContext.Provider, { value, children });
};
const DateChip = forwardRef(
  (props, ref) => {
    if (props.variant !== "date") {
      throw new Error(
        `DateChip component can only be used with date variant. Current variant is: ${props.variant}`
      );
    }
    const monthDateClassName = getMonthDateClassName({ disabled: props.disabled });
    const { dateFormatFn } = useDateRadioChipGroupContext();
    const { date, className } = props;
    const { dayOfTheWeek, monthDate } = getDateChipLabels(date, dateFormatFn);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      BaseRadioChip,
      {
        ...props,
        ref,
        className: twMerge(dateChipClassName, className),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Text,
            {
              variant: "label",
              className: "pointer-events-none",
              children: dayOfTheWeek
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Paragraph,
            {
              size: "md",
              className: monthDateClassName,
              noDefaultMargins: true,
              children: monthDate
            }
          ),
          props.adornment
        ]
      }
    );
  }
);
const RadioChip = forwardRef(
  (props, ref) => {
    const { variant = "standard" } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      variant === "standard" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        StandardChip,
        {
          ...props,
          ref
        }
      ),
      variant === "date" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        DateChip,
        {
          ...props,
          ref
        }
      )
    ] });
  }
);
const baseChipClassName = "max-w-full animate-appear";
const TEST_IDS_CONFIG$9 = {
  BASE: "radio-group",
  OPTION: "option"
};
const BaseChipGroup = forwardRef(
  ({
    chips,
    error: error2,
    htmlName,
    chipVariant = "standard",
    value: defaultValue = "",
    chipClassName: chipClassName2,
    onChange,
    ...props
  }, ref) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue);
    const name = props.name || htmlName;
    const mergedChipClassName = twMerge(baseChipClassName, chipClassName2);
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$9
    });
    useEffect(() => {
      setSelectedValue(defaultValue);
    }, [defaultValue]);
    const handleChipChange = (e3) => {
      setSelectedValue(e3.target.value);
      onChange?.(e3);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: chips.map((chip) => {
      const value = chip.value ?? chip.date?.toDateString();
      const disabled = chip.disabled || props.disabled;
      const checked = selectedValue?.toString() === value?.toString();
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(a__default.Fragment, { children: [
        chipVariant === "standard" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioChip,
          {
            ref,
            name,
            label: chip.label,
            variant: chipVariant,
            className: mergedChipClassName,
            error: !!error2,
            onChange: handleChipChange,
            ...{ value, disabled, checked },
            ...testIds.OPTION
          }
        ),
        chipVariant === "date" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          RadioChip,
          {
            ref,
            name,
            variant: chipVariant,
            date: chip.date,
            adornment: chip.adornment,
            className: mergedChipClassName,
            error: !!error2,
            onChange: handleChipChange,
            ...{ value, disabled, checked },
            ...testIds.OPTION
          }
        )
      ] }, value);
    }) });
  }
);
const chipsContainerClassName$2 = twMerge(
  clsx(
    "grid w-full grid-cols-6 gap-x-e12 gap-y-e16",
    "tablet-d:grid-cols-5",
    "mobile-d:grid-cols-4",
    "mobile-sm-d:grid-cols-3",
    "gap-e8 mobile-xs-d:grid-cols-3"
  )
);
const containerClassName$5 = "flex flex-col items-center";
const viewMoreButtonClassName = "mt-e16";
const TEST_IDS_CONFIG$8 = {
  BASE: "radio-group",
  VIEW_MORE_BUTTON: "view-more-button"
};
const ChipGroupStandard = forwardRef(({ chips, className, ...props }, ref) => {
  const classNameMerged = twMerge(containerClassName$5, className);
  const testIds = useInputDataTestIds({
    ...props,
    componentIdConfig: TEST_IDS_CONFIG$8
  });
  const maxChips = props.variant === "standard" ? props.maxChips : void 0;
  const [shouldShowAllChips, setShouldShowAllChips] = useState(false);
  const [visibleChips, hiddenChipsCount] = useMemo(() => {
    if (!maxChips || shouldShowAllChips) {
      return [chips, 0];
    }
    return [chips.slice(0, maxChips), chips.slice(maxChips).length];
  }, [maxChips, shouldShowAllChips, chips]);
  const handleViewMoreClick = () => {
    setShouldShowAllChips(true);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNameMerged, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: chipsContainerClassName$2,
        ...testIds.BASE,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BaseChipGroup,
          {
            ...props,
            ref,
            chips: visibleChips
          }
        )
      }
    ),
    !!hiddenChipsCount && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Button,
      {
        variant: "ghost",
        size: "sm",
        className: viewMoreButtonClassName,
        disabled: props.disabled,
        onClick: handleViewMoreClick,
        ...testIds.VIEW_MORE_BUTTON,
        children: [
          "View (",
          hiddenChipsCount,
          ") more",
          /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: D })
        ]
      }
    )
  ] });
});
const containerClassName$4 = "flex items-center gap-e16 mobile-xs-d:gap-e8";
const chipsContainerClassName$1 = clsx("grid auto-cols-fr grid-flow-col gap-e16", "grow");
const loadingSpinnerClassName = "max-w-full";
const DefaultPageSizeConfig = {
  default: 7,
  "mobile-sm": 3,
  "mobile-xs": 3
};
const useVisibleChipsCount = ({ pageSize }) => {
  const { currentViewport } = useViewport();
  return useMemo(() => {
    if (typeof pageSize === "number") {
      return pageSize;
    }
    if (typeof pageSize === "object") {
      return pageSize[currentViewport] || pageSize.default;
    }
    return DefaultPageSizeConfig[currentViewport] || DefaultPageSizeConfig.default;
  }, [pageSize, currentViewport]);
};
const useVisibleChips = ({
  chips,
  startIndex,
  loading,
  pageSize,
  onLoadMore
}) => {
  const visibleChipsCount = useVisibleChipsCount({ pageSize });
  useEffect(() => {
    const isLastPage = chips.length - startIndex < visibleChipsCount;
    if (isLastPage && !loading) {
      onLoadMore?.();
    }
  }, [startIndex, chips, visibleChipsCount, onLoadMore, loading]);
  const visibleRange = useMemo(() => {
    const loadingOffset = loading ? 1 : 0;
    return [startIndex, startIndex + visibleChipsCount - loadingOffset];
  }, [loading, startIndex, visibleChipsCount]);
  const visibleChips = useMemo(() => {
    return chips.slice(...visibleRange);
  }, [visibleRange, chips]);
  return { visibleChips, pageSize: visibleChipsCount };
};
const useCarouselScroll = ({
  startIndex,
  scrollBy,
  pageSize,
  chips
}) => {
  const getNextStartIndex = (direction) => {
    const actualPageSize = scrollBy === "page" ? pageSize : 1;
    if (direction === "left") {
      return actualPageSize < startIndex - 1 ? startIndex - actualPageSize : 0;
    } else {
      const willBeLastPage = startIndex + actualPageSize > chips.length - actualPageSize;
      const startIndexIncrement = willBeLastPage ? chips.length - (startIndex + actualPageSize) || 1 : actualPageSize;
      return startIndex + startIndexIncrement;
    }
  };
  return { getNextStartIndex };
};
const useCarousel = ({
  chips,
  disabled,
  loading = false,
  scrollBy = "page",
  pageSize: pageSizeConfig,
  startIndex = 0,
  onLoadMore
}) => {
  const [currentStartIndex, setCurrentStartIndex] = useState(0);
  const { visibleChips, pageSize } = useVisibleChips({
    chips,
    startIndex: currentStartIndex,
    loading,
    pageSize: pageSizeConfig,
    onLoadMore
  });
  const { getNextStartIndex } = useCarouselScroll({
    startIndex: currentStartIndex,
    scrollBy,
    pageSize,
    chips
  });
  useEffect(() => {
    if (startIndex !== currentStartIndex) {
      const lastPageStartIndex = Math.max(chips.length - pageSize, 0);
      const isValidStartIndex = startIndex <= lastPageStartIndex;
      setCurrentStartIndex(isValidStartIndex ? Math.max(startIndex, 0) : lastPageStartIndex);
    }
  }, [startIndex]);
  const scrollLeftDisabled = useMemo(
    () => disabled || currentStartIndex === 0,
    [disabled, currentStartIndex]
  );
  const scrollRightDisabled = useMemo(() => {
    const isDisabledState = disabled || loading;
    const isUnableToLoadMore = !onLoadMore;
    const isLastPage = visibleChips.length + currentStartIndex >= chips.length;
    return isDisabledState || isLastPage && isUnableToLoadMore;
  }, [disabled, loading, visibleChips, currentStartIndex, chips, onLoadMore]);
  const handleCaretClick = (e3) => {
    const direction = e3.currentTarget.dataset.direction;
    setCurrentStartIndex(getNextStartIndex(direction));
  };
  return { visibleChips, scrollLeftDisabled, scrollRightDisabled, handleCaretClick };
};
const TEST_IDS_CONFIG$7 = {
  BASE: "carousel-radio-group",
  LEFT_CARET: "left-caret",
  RIGHT_CARET: "right-caret",
  LOADING_SPINNER: "loading-spinner"
};
const ChipGroupCarousel = forwardRef(
  ({
    chips,
    disabled,
    loading = false,
    className,
    scrollBy = "page",
    pageSize: pageSizeConfig,
    startIndex: defaultStartIndex,
    onLoadMore,
    ...props
  }, ref) => {
    const classNameMerged = twMerge(chipsContainerClassName$1, className);
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$7
    });
    const { visibleChips, scrollLeftDisabled, scrollRightDisabled, handleCaretClick } = useCarousel(
      {
        chips,
        disabled,
        loading,
        scrollBy,
        pageSize: pageSizeConfig,
        startIndex: defaultStartIndex,
        onLoadMore
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: containerClassName$4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          iconOnly: true,
          variant: "ghost",
          size: "sm",
          "data-direction": "left",
          disabled: scrollLeftDisabled,
          onClick: handleCaretClick,
          ...testIds.LEFT_CARET,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: I$4 })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: classNameMerged,
          ...testIds.BASE,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              BaseChipGroup,
              {
                ...props,
                ref,
                chips: visibleChips,
                disabled
              }
            ),
            loading && /* @__PURE__ */ jsxRuntimeExports.jsx(
              LoadingSpinner,
              {
                className: loadingSpinnerClassName,
                ...testIds.LOADING_SPINNER
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          iconOnly: true,
          variant: "ghost",
          size: "sm",
          "data-direction": "right",
          disabled: scrollRightDisabled,
          onClick: handleCaretClick,
          ...testIds.RIGHT_CARET,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: l$b })
        }
      )
    ] });
  }
);
const Component$8 = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      props.variant === "standard" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChipGroupStandard,
        {
          ...props,
          ref
        }
      ),
      props.variant === "carousel" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChipGroupCarousel,
        {
          ...props,
          ref
        }
      )
    ] });
  }
);
const RadioChipGroup = withFormField(withRHFVariantUncontrolled(Component$8), {
  labelSpacing: "lg",
  order: {
    error: "top",
    hint: "top"
  }
});
const PageSizeConfig = {
  default: 8,
  tablet: 7,
  mobile: 5,
  "mobile-sm": 3,
  "mobile-xs": 3
};
const dateChipGroupClassName = "gap-e12 mobile-xs-d:gap-e8";
const DateRadioChipGroup = forwardRef(({ dateFormatFn, ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DateRadioChipGroupProvider, { value: { dateFormatFn: dateFormatFn ?? format }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    RadioChipGroup,
    {
      ...props,
      ref,
      variant: "carousel",
      chipVariant: "date",
      pageSize: props.pageSize || PageSizeConfig,
      className: dateChipGroupClassName
    }
  ) });
});
const useFilterableSelectState = () => {
  const [filterValue, setFilterValue] = useState("");
  const { isOpen, setIsOpen, toggleDropdown, openDropdown } = useBaseSelectState();
  const closeDropdown = useCallback(() => {
    setFilterValue("");
    setIsOpen(false);
  }, [setIsOpen]);
  return {
    isOpen,
    filterValue,
    setFilterValue,
    setIsOpen,
    toggleDropdown,
    openDropdown,
    closeDropdown
  };
};
const useFilterableSelect = ({
  disabled,
  readOnly,
  onChange
}) => {
  const {
    isOpen,
    filterValue,
    setFilterValue,
    openDropdown,
    closeDropdown,
    ...filterableSelectState
  } = useFilterableSelectState();
  const handleChange = (value) => {
    onChange?.(value);
  };
  const { handleInputClick, handleInputKeyDown, ...baseSelectProps } = useBaseSelect({
    disabled,
    readOnly,
    isOpen,
    onChange: handleChange,
    openDropdown,
    closeDropdown,
    ...filterableSelectState
  });
  useEffect(() => {
    if (filterValue && !isOpen) {
      openDropdown();
    }
  }, [filterValue, isOpen, openDropdown]);
  const resetFilterValue = () => {
    if (!isOpen) {
      setFilterValue("");
    }
  };
  const handleEditableInputClick = (e3) => {
    if (readOnly) {
      return;
    }
    handleInputClick(e3);
    resetFilterValue();
  };
  const handleEditableInputFocus = () => {
    resetFilterValue();
  };
  const handleEditableInputKeyDown = (e3) => {
    handleInputKeyDown(e3);
    if (e3.key === "Backspace") {
      if (!filterValue) {
        openDropdown();
      }
    }
  };
  const handleEditableInputChange = (e3) => {
    const newValue = e3.target.value;
    setFilterValue(newValue);
  };
  return {
    filterValue,
    onChange: handleChange,
    handleInputClick: handleEditableInputClick,
    handleInputFocus: handleEditableInputFocus,
    handleInputKeyDown: handleEditableInputKeyDown,
    handleInputChange: handleEditableInputChange,
    ...baseSelectProps
  };
};
const inputStyles$1 = "cursor-text caret-current";
const FilterableSelectInput = forwardRef(
  ({ ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectInput,
      {
        ...props,
        ref,
        className: inputStyles$1,
        readOnly: props.readOnly ?? false
      }
    );
  }
);
const FilterableSelectDropdown = forwardRef(
  ({ ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectDropdown,
      {
        ...props,
        ref,
        initialFocus: -1
      }
    );
  }
);
const DEFAULT_SEARCH_DELAY = 500;
const useFilteredOptions = ({
  options,
  filterValue,
  allowEmpty,
  placeholder,
  delegatesFilter
}) => {
  const filteredOptions = useMemo(() => {
    if (!filterValue || delegatesFilter) {
      return options;
    }
    return options.filter(
      (option) => option.label.toLowerCase().includes(filterValue.toLowerCase())
    );
  }, [options, filterValue, delegatesFilter]);
  const optionsWithPlaceholder = useMemo(() => {
    if (allowEmpty && options.length && !filterValue) {
      return [{ value: "", label: placeholder }, ...filteredOptions];
    }
    return filteredOptions;
  }, [filteredOptions, placeholder, allowEmpty, filterValue, options.length]);
  return { filteredOptions: optionsWithPlaceholder };
};
const useDelegateFilter = ({
  filterValue,
  searchDelay,
  onSearchTermChange
}) => {
  useDebounce(
    () => {
      onSearchTermChange?.(filterValue.trim());
    },
    filterValue ? searchDelay : 0,
    [filterValue]
  );
};
const useDisplayValue$1 = ({
  options,
  value,
  isOpen,
  filterValue
}) => {
  const { displayValue: selectionDisplayValue } = useDisplayValue$2({ options, value });
  const displayValue = useMemo(
    () => isOpen ? filterValue : selectionDisplayValue,
    [isOpen, filterValue, selectionDisplayValue]
  );
  return { displayValue };
};
const Component$7 = forwardRef(
  ({
    noResultsText = "No options found",
    noSearchTermText = "Start typing to search...",
    searchDelay = DEFAULT_SEARCH_DELAY,
    onSearchTermChange,
    onChange,
    ...props
  }, ref) => {
    const { filterValue, isOpen, ...useFilterableSelectValues } = useFilterableSelect({
      ...props,
      onChange
    });
    const { filteredOptions } = useFilteredOptions({
      ...props,
      filterValue,
      delegatesFilter: !!onSearchTermChange
    });
    const { displayValue } = useDisplayValue$1({
      ...props,
      filterValue,
      isOpen
    });
    useDelegateFilter({ filterValue, searchDelay, onSearchTermChange });
    const dropdownPlaceholder = useMemo(() => {
      return !displayValue ? noSearchTermText : noResultsText;
    }, [displayValue, noSearchTermText, noResultsText]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelect,
      {
        ...props,
        ...useFilterableSelectValues,
        ref,
        isOpen,
        options: filteredOptions,
        displayValue,
        dropdownPlaceholder,
        inputComponent: FilterableSelectInput,
        dropdownComponent: FilterableSelectDropdown
      }
    );
  }
);
Component$7.displayName = "FilterableSelect";
const ComponentWithViewMode$1 = withViewMode(Component$7, {
  viewModeComponent: BaseSelectViewModeText
});
const FilterableSelect = withFormField(withRHFVariantControlled(ComponentWithViewMode$1));
const useSelectAll = ({
  options,
  value,
  onChange
}) => {
  const enabledOptions = useMemo(() => {
    return options.filter((option) => !option.disabled);
  }, [options]);
  const areAllOptionsSelected = useMemo(() => {
    return value?.length === enabledOptions.length;
  }, [value, enabledOptions]);
  const handleSelectAll = useCallback(() => {
    onChange?.(
      areAllOptionsSelected ? [] : options.filter((option) => !option.disabled).map((option) => option.value)
    );
  }, [options, areAllOptionsSelected, onChange]);
  return {
    areAllOptionsSelected,
    handleSelectAll
  };
};
const SelectAllValue = "select-all";
const focusInputCursorAtEnd = (inputElement) => {
  setTimeout(() => {
    if (inputElement) {
      inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
      inputElement.scrollLeft = inputElement.scrollWidth;
    }
  });
};
const useMultiSelect = (props) => {
  const { disabled, readOnly, showSelectAll, onChange } = props;
  const { areAllOptionsSelected, handleSelectAll } = useSelectAll({
    ...props,
    onChange
  });
  const {
    isOpen,
    filterValue,
    setFilterValue,
    openDropdown,
    closeDropdown,
    ...filterableSelectState
  } = useFilterableSelectState();
  const handleChange = (value) => {
    onChange?.(value);
  };
  const { inputRef, handleInputKeyDown, ...baseSelectProps } = useBaseSelect({
    disabled,
    readOnly,
    isOpen,
    onChange: handleChange,
    openDropdown,
    closeDropdown,
    ...filterableSelectState
  });
  useEffect(() => {
    if (filterValue && !isOpen) {
      openDropdown();
    }
  }, [filterValue, isOpen, openDropdown]);
  const handleOptionClick = useCallback(
    (newValue) => {
      if (showSelectAll && newValue[newValue.length - 1] === SelectAllValue) {
        handleSelectAll();
        return;
      }
      onChange?.(newValue);
    },
    [showSelectAll, handleSelectAll, onChange]
  );
  const handleEditableInputClick = (e3) => {
    e3.stopPropagation();
    if (readOnly) {
      return;
    }
    openDropdown();
    focusInputCursorAtEnd(inputRef.current);
  };
  const handleEditableInputKeyDown = (e3) => {
    handleInputKeyDown(e3);
    if (e3.key === "Backspace") {
      if (!filterValue) {
        openDropdown();
      }
    }
  };
  const handleEditableInputChange = (e3) => {
    const newValue = e3.target.value;
    const displayValues = newValue.split(",");
    const newFilterValue = displayValues.pop() || "";
    setFilterValue(newFilterValue.trimStart());
  };
  return {
    ...baseSelectProps,
    filterValue,
    isOpen,
    areAllOptionsSelected,
    inputRef,
    onChange: handleChange,
    handleOptionClick,
    handleInputClick: handleEditableInputClick,
    handleInputKeyDown: handleEditableInputKeyDown,
    handleInputChange: handleEditableInputChange
  };
};
const getCommaSeparatedDisplayValue = ({ options, value }) => {
  const selectedOptions = value.map(
    (item) => options.find((option) => option.value === item)
  );
  return selectedOptions.map((option) => option?.label).join(", ");
};
const getCounterDisplayValue = ({ value, label }) => {
  return value?.length ? `${label} (${value?.length})` : "";
};
const variantFormatterMap = {
  default: getCommaSeparatedDisplayValue,
  counter: getCounterDisplayValue
};
const useDisplayValue = ({
  options,
  value,
  variant,
  counterLabel,
  isOpen,
  filterValue
}) => {
  const { displayValue: selectionDisplayValue } = useDisplayValue$2({
    options,
    value,
    label: counterLabel,
    formatterFn: variantFormatterMap[variant]
  });
  const displayValue = useMemo(() => {
    const displayValueWithFilter = selectionDisplayValue ? `${selectionDisplayValue}, ${filterValue}` : filterValue;
    return isOpen ? displayValueWithFilter : selectionDisplayValue;
  }, [isOpen, filterValue, selectionDisplayValue]);
  return { displayValue };
};
const _InternalOptionViewModeText = ({
  children,
  ...props
}) => {
  const testIds = useInputOptionDataTestIds({
    ...props
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...testIds.OPTION, children });
};
const _InternalViewModeText = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { ...props, children });
};
const ViewModeList = ({ value, options, viewModePlaceholder, name }) => {
  const testIds = useInputDataTestIds({
    name,
    componentIdConfig: {
      VIEW_MODE_TEXT: "view-mode-text"
    }
  });
  if (!value?.length) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(_InternalViewModeText, { ...testIds.VIEW_MODE_TEXT, children: viewModePlaceholder });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: value.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    _InternalOptionViewModeText,
    {
      value: item,
      ...testIds.VIEW_MODE_TEXT,
      children: options.find((option) => option.value === item)?.label
    },
    item
  )) });
};
const MultiSelectContext = createContext(void 0);
const useMultiSelectContext = () => {
  const context = useContext(MultiSelectContext);
  if (!context) {
    throw new Error("useMultiSelectContext must be used within a MultiSelectProvider");
  }
  return context;
};
const MultiSelectProvider = ({
  showSelectAll = false,
  selectAllLabel = "Select all",
  areAllOptionsSelected = false,
  children
}) => {
  const contextValue = useMemo(
    () => ({
      showSelectAll,
      selectAllLabel,
      areAllOptionsSelected
    }),
    [showSelectAll, selectAllLabel, areAllOptionsSelected]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSelectContext.Provider, { value: contextValue, children });
};
const SelectAllOption = forwardRef(
  ({ optionComponent: OptionComponent, onOptionClick, ...props }, ref) => {
    const { areAllOptionsSelected, showSelectAll, selectAllLabel } = useMultiSelectContext();
    const selectAllOption = useMemo(
      () => ({
        label: selectAllLabel,
        value: SelectAllValue
      }),
      [selectAllLabel]
    );
    const selectAllOptionValue = useMemo(
      () => areAllOptionsSelected ? [SelectAllValue] : [],
      [areAllOptionsSelected]
    );
    if (!showSelectAll) {
      return null;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      OptionComponent,
      {
        ...props,
        ref,
        option: selectAllOption,
        selectedValue: selectAllOptionValue,
        onClick: onOptionClick
      }
    );
  }
);
const TEST_IDS_CONFIG$6 = {
  OPTION: "option"
};
const MultiSelectDropdown = forwardRef(
  ({
    isOpen,
    value,
    options,
    loading,
    loadingText,
    placeholder,
    optionComponent: OptionComponent = BaseMultiSelectOption,
    onOptionClick,
    onCloseRequest,
    ...props
  }, ref) => {
    const testIds = useInputDataTestIds({
      ...props,
      componentIdConfig: TEST_IDS_CONFIG$6
    });
    const { optionRefs, handleFocus, handleBlur, handleKeyDown } = useBaseSelectDropdown({
      isOpen,
      value,
      options,
      onCloseRequest
    });
    const { floatingContext } = useBaseSelectContext();
    const createRefs = (element, index2) => {
      optionRefs.current[index2] = element;
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FloatingSelectDropdown,
      {
        isOpen: isOpen && options.length > 0,
        context: floatingContext,
        initialFocus: -1,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ...props,
            ref,
            className: getDropdownClassName(),
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            children: [
              loading && /* @__PURE__ */ jsxRuntimeExports.jsx(BaseSelectMessageItem, { children: loadingText }),
              !loading && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SelectAllOption,
                  {
                    ...testIds.OPTION,
                    optionComponent: OptionComponent,
                    onOptionClick
                  }
                ),
                options.length === 0 && placeholder && /* @__PURE__ */ jsxRuntimeExports.jsx(BaseSelectMessageItem, { children: placeholder }),
                options.map((option, index2) => /* @__PURE__ */ createElement(
                  OptionComponent,
                  {
                    ...testIds.OPTION,
                    ref: (el2) => createRefs(el2, index2),
                    key: `${option.value}-${index2}`,
                    option,
                    selectedValue: value,
                    onClick: option.disabled ? void 0 : onOptionClick
                  }
                ))
              ] })
            ]
          }
        )
      }
    );
  }
);
const inputStyles = "caret-current";
const MultiSelectInput = forwardRef(
  ({ ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectInput,
      {
        ...props,
        ref,
        className: inputStyles,
        readOnly: props.readOnly ?? false
      }
    );
  }
);
const Component$6 = forwardRef(
  ({
    variant = "default",
    label = "",
    counterLabel,
    showSelectAll = false,
    selectAllLabel = "Select all",
    onSearchTermChange,
    onChange,
    ...props
  }, ref) => {
    const { areAllOptionsSelected, filterValue, isOpen, ...baseSelectOwnProps } = useMultiSelect({
      ...props,
      showSelectAll,
      onChange
    });
    const { filteredOptions } = useFilteredOptions({
      ...props,
      filterValue,
      delegatesFilter: !!onSearchTermChange
    });
    const { displayValue } = useDisplayValue({
      ...props,
      variant,
      isOpen,
      filterValue,
      counterLabel: counterLabel || label
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      MultiSelectProvider,
      {
        selectAllLabel,
        showSelectAll: showSelectAll && !filterValue,
        areAllOptionsSelected,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BaseSelect,
          {
            ...props,
            ...baseSelectOwnProps,
            ref,
            isOpen,
            options: filteredOptions,
            displayValue,
            inputComponent: MultiSelectInput,
            dropdownComponent: MultiSelectDropdown,
            multiple: true
          }
        )
      }
    );
  }
);
Component$6.displayName = "MultiSelect";
const WithViewModeList$1 = withViewMode(Component$6, { viewModeComponent: ViewModeList });
const MultiSelect = withFormField(withRHFVariantControlled(WithViewModeList$1));
const useChipMultiSelect = (props) => {
  const multiSelectProps = useMultiSelect(props);
  const { value, onChange } = props;
  const handleRemoveChip = useCallback(
    (targetValue) => {
      if (value && onChange) {
        const newValue = value.filter((val) => val !== targetValue);
        onChange?.(newValue);
      }
    },
    [value, onChange]
  );
  return {
    ...multiSelectProps,
    handleRemoveChip
  };
};
const ChipMultiSelectContext = createContext({
  options: [],
  value: [],
  readOnly: false,
  filterValue: "",
  handleRemoveChip: void 0
});
const useChipMultiSelectContext = () => {
  const context = useContext(ChipMultiSelectContext);
  if (!context) {
    throw new Error("useChipMultiSelectContext must be used within a ChipMultiSelectProvider");
  }
  return context;
};
const ChipMultiSelectProvider = (props) => {
  const { children, options, value, readOnly, filterValue, handleRemoveChip, ...multiSelectProps } = props;
  const contextValue = useMemo(
    () => ({ options, value, readOnly, filterValue, handleRemoveChip }),
    [options, value, readOnly, filterValue, handleRemoveChip]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChipMultiSelectContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSelectProvider, { ...multiSelectProps, children }) });
};
const chipClassName = twMerge(
  clsx(
    // Layout
    "inline-flex items-center justify-between gap-e8",
    // Padding
    "px-e8 py-e4",
    // Max width
    "max-w-fit",
    // Truncate
    "overflow-hidden",
    // Border
    "rounded-sm",
    // Background
    "bg-warm-gray-8%",
    // Cursor
    "cursor-default",
    // Select
    "select-none"
  )
);
const getLabelClassName = ({ multiline }) => clsx("max-w-full", "overflow-hidden", {
  "text-ellipsis text-nowrap": !multiline
});
const getCloseButtonClassName = ({ disabled }) => clsx(
  // Layout
  "flex items-center justify-center",
  // Cursor
  { "cursor-pointer": !disabled },
  // Background
  {
    "hover:bg-warm-gray-8%": !disabled,
    "hover:outline hover:outline-4 hover:outline-warm-gray-8%": !disabled
  },
  // Border
  "rounded-full"
);
const Chip = forwardRef(
  ({ className, label, readOnly = false, disabled = false, value, onDelete, ...rest }, ref) => {
    const testIds = useInputDataTestIds({
      ...rest,
      componentIdConfig: {
        LABEL: "label",
        REMOVE_BUTTON: "remove-button"
      }
    });
    const handleRemove = useCallback(
      (e3) => {
        e3.stopPropagation();
        if (disabled) {
          return;
        }
        onDelete?.(value);
      },
      [disabled, onDelete, value]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ...rest,
        ref,
        className: twMerge(chipClassName, className),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Text,
            {
              ...testIds.LABEL,
              variant: "body-lg",
              className: getLabelClassName({ multiline: readOnly }),
              children: label
            }
          ),
          !readOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              ...testIds.REMOVE_BUTTON,
              className: getCloseButtonClassName({ disabled }),
              disabled,
              onClick: handleRemove,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                SyntaxIcon,
                {
                  icon: R$1,
                  size: "sm"
                }
              )
            }
          )
        ]
      }
    );
  }
);
const chipInputRootClassName = clsx(
  // Transitions
  "transition-all"
);
const getChipInputClassName = ({ readOnly, visible }) => twMerge(
  clsx(
    // Size
    "h-e32 grow",
    // Caret
    "caret-current",
    // Focus
    "focus:outline-none",
    // Visibility
    {
      flex: visible && !readOnly,
      hidden: !visible || readOnly
    }
  )
);
const chipsContainerClassName = clsx(
  // Layout
  "flex flex-wrap",
  // Spacing
  "my-e12 mr-e12 gap-e8",
  // Size
  "min-h-e32 w-select-chips",
  // Focus
  "focus:outline-none"
);
const ChipInput = forwardRef(
  ({ startAdornment, endAdornment, error: error2, containerClassName: containerClassName2, onFocus, onBlur, ...props }, ref) => {
    const { options, value, readOnly, filterValue, handleRemoveChip } = useChipMultiSelectContext();
    const { active, activate, handleOnFocus, handleOnBlur } = useActiveElement({
      disabled: props.disabled,
      onFocus,
      onBlur
    });
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const rootClassName = twMerge(
      useBaseInputRootClassName(props, active, error2),
      chipInputRootClassName,
      containerClassName2
    );
    const chipInputClassName = useMemo(
      () => getChipInputClassName({ visible: active || !!filterValue || !value?.length, readOnly }),
      [active, readOnly, filterValue, value]
    );
    const chips = useMemo(() => {
      const selectedOptions = value?.map(
        (item) => options.find((option) => option.value === item) || { label: item, value: item }
      );
      return selectedOptions || [];
    }, [options, value]);
    useEffect(() => {
      if (active) {
        inputRef.current?.focus();
      }
    }, [active]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: rootClassName,
        onClick: props.disabled ? void 0 : activate,
        children: [
          startAdornment,
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              tabIndex: 0,
              className: chipsContainerClassName,
              onFocus: handleOnFocus,
              onBlur: handleOnBlur,
              children: [
                chips.map((chip) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Chip,
                  {
                    "data-testid": `${props["data-testid"]}-chip`,
                    label: chip.label,
                    value: chip.value,
                    readOnly,
                    disabled: props.disabled,
                    onDelete: handleRemoveChip
                  },
                  chip.value
                )),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "input",
                  {
                    ...props,
                    ref: inputRef,
                    className: chipInputClassName,
                    value: filterValue
                  }
                )
              ]
            }
          ),
          endAdornment
        ]
      }
    );
  }
);
const ChipMultiSelectInput = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseSelectInput,
      {
        ...props,
        ref,
        inputComponent: ChipInput
      }
    );
  }
);
const Component$5 = forwardRef(
  ({
    showSelectAll = false,
    selectAllLabel = "Select all",
    onChange,
    onSearchTermChange,
    ...props
  }, ref) => {
    const { filterValue, ...multiSelectOwnProps } = useChipMultiSelect({
      ...props,
      showSelectAll,
      onChange
    });
    const { filteredOptions } = useFilteredOptions({
      ...props,
      filterValue,
      delegatesFilter: !!onSearchTermChange
    });
    const { options, value, readOnly } = props;
    const { areAllOptionsSelected, handleRemoveChip, ...restSelectProps } = multiSelectOwnProps;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChipMultiSelectProvider,
      {
        options,
        value,
        readOnly,
        filterValue,
        handleRemoveChip,
        showSelectAll: showSelectAll && !filterValue,
        selectAllLabel,
        areAllOptionsSelected,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BaseSelect,
          {
            ...props,
            ...restSelectProps,
            ref,
            options: filteredOptions,
            inputComponent: ChipMultiSelectInput,
            dropdownComponent: MultiSelectDropdown,
            multiple: true
          }
        )
      }
    );
  }
);
Component$5.displayName = "ChipMultiSelect";
const WithViewModeList = withViewMode(Component$5, { viewModeComponent: ViewModeList });
const ChipMultiSelect = withFormField(withRHFVariantControlled(WithViewModeList));
const _InternalCTA = ({
  className,
  children,
  sticky,
  column,
  rowOnMobile,
  ...rest
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(
        clsx(
          "flex w-full justify-center",
          {
            "fixed bottom-0 left-0 border-t border-warm-gray-200 bg-cream-50 p-e24": sticky
          },
          className
        )
      ),
      ...rest,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: twMerge(
            clsx("flex w-full items-center gap-e24", "mobile-d:flex-col mobile-d:gap-e16", {
              "max-w-es808": sticky,
              "flex-col": column,
              "mobile-d:flex-row mobile-d:gap-e24": rowOnMobile
            })
          ),
          children
        }
      )
    }
  );
};
const FormLayoutContext = createContext(void 0);
const FormLayoutProvider = ({
  children,
  variant = "default",
  viewMode = false
}) => {
  const contextValue = useMemo(() => ({ variant, viewMode }), [variant, viewMode]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormLayoutContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeProvider, { viewMode, children }) });
};
const useFormLayoutContext = () => {
  const context = useContext(FormLayoutContext);
  if (context === void 0) {
    throw new Error("useFormLayout must be used within a FormLayoutProvider");
  }
  return context;
};
const variantClassNameMap$2 = {
  default: "gap-e40 mobile-d:gap-e24",
  compact: "gap-e32 mobile-d:gap-e24"
};
const _InternalFields = ({ className, children, ...rest }) => {
  const { variant } = useFormLayoutContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(
        clsx(
          // Alignment
          "flex flex-col self-center",
          // Size
          "w-full",
          // Variants
          variantClassNameMap$2[variant],
          // Custom
          className
        )
      ),
      ...rest,
      children
    }
  );
};
const _InternalFieldsHeader = ({ title, subtitle, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Heading,
      {
        level: "h5",
        noDefaultMargins: !subtitle,
        children: title
      }
    ),
    subtitle && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paragraph,
      {
        size: "md",
        className: "text-warm-gray-600",
        noDefaultMargins: true,
        children: subtitle
      }
    )
  ] });
};
const useGlobalErrorMessage = (message2) => {
  const { errors: errors2 } = useFormState();
  const rootLevelErrorMessage = get$1(errors2, "root.message");
  const errorMessage = useMemo(() => {
    if (rootLevelErrorMessage) {
      return rootLevelErrorMessage;
    }
    return Object.keys(errors2).length > 0 ? message2 : null;
  }, [rootLevelErrorMessage, errors2, message2]);
  return errorMessage;
};
const _InternalGlobalErrors = ({
  message: message2 = "Please check and resolve all form errors to continue.",
  ...rest
}) => {
  const errorMessage = useGlobalErrorMessage(message2);
  const testIds = useDataTestIds({
    // TODO (SyntaxForm): Use SyntaxForm context to generate test ids on this component.
    componentConfig: {
      BASE: "",
      CALLOUT: "callout"
    },
    ids: rest
  });
  if (!errorMessage) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    _InternalFields,
    {
      ...rest,
      ...testIds.BASE,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Callout,
        {
          type: "warning",
          ...testIds.CALLOUT,
          children: errorMessage
        }
      )
    }
  );
};
const _InternalFormDivider = ({ className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: twMerge(clsx("w-full border-t border-gray-200"), className) });
};
const headingLevelMap = {
  main: "h3",
  section: "h5"
};
const subtitleSizeMap = {
  main: "lg",
  section: "md"
};
const subtitleClassName = {
  main: "",
  section: "text-warm-gray-600"
};
const containerClassName$3 = {
  main: "gap-e12",
  section: "gap-e8"
};
const TEST_IDS_CONFIG$5 = {
  // TODO (SyntaxForm): Once FormLayout.Header variant='main' is taken out of the FormLayout,
  // and FormLayout becomes SyntaxForm, we should have the testid on SyntaxForm
  // and spread the testid to the SyntaxForm composed components through context.
  BASE: "form-header",
  TITLE: "title",
  SUBTITLE: "subtitle"
};
const _InternalHeader = ({
  title,
  subtitle,
  variant = "main",
  cta,
  className,
  ...rest
}) => {
  const ids = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$5,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "flex items-center justify-between",
      ...rest,
      ...ids.BASE,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: clsx("flex flex-col", containerClassName$3[variant], className), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-e12", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Heading,
            {
              level: headingLevelMap[variant],
              noDefaultMargins: true,
              ...ids.TITLE,
              children: title
            }
          ),
          cta && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: cta })
        ] }),
        subtitle && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph,
          {
            size: subtitleSizeMap[variant],
            className: subtitleClassName[variant],
            noDefaultMargins: true,
            ...ids.SUBTITLE,
            children: subtitle
          }
        )
      ] })
    }
  );
};
const variantClassNameMap$1 = {
  default: "gap-e64 mobile-d:gap-e40",
  compact: "gap-e40 mobile-d:gap-e32"
};
const FormLayout = ({
  children,
  className,
  variant = "default",
  viewMode,
  submitOnEnter = false,
  ...rest
}) => {
  const handleKeyDown = (e3) => {
    rest.onKeyDown?.(e3);
    if (e3.key === "Enter" && !submitOnEnter) {
      const target = e3.target;
      if (target.tagName !== "TEXTAREA" && target.type !== "submit") {
        e3.preventDefault();
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormLayoutProvider,
    {
      variant,
      viewMode,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "form",
        {
          ...rest,
          className: twMerge(
            clsx(
              // Alignment
              "flex flex-col items-start self-stretch",
              // Size
              "w-full",
              // Variants
              variantClassNameMap$1[variant],
              // Custom
              className
            )
          ),
          onKeyDown: handleKeyDown,
          children
        }
      )
    }
  );
};
FormLayout.Fields = _InternalFields;
FormLayout.CTA = _InternalCTA;
FormLayout.GlobalErrors = _InternalGlobalErrors;
FormLayout.FieldsHeader = _InternalFieldsHeader;
FormLayout.Header = _InternalHeader;
FormLayout.Divider = _InternalFormDivider;
const MultiFormContext = createContext(void 0);
const useMultiFormContext = () => {
  const context = useContext(MultiFormContext);
  if (context === void 0) {
    throw new Error("useMultiFormContext must be used within a MultiFormProvider");
  }
  return context;
};
const MultiFormProvider = ({ children }) => {
  const [activeFormId, setActiveFormId] = useState(null);
  const [registeredForms, setRegisteredForms] = useState(/* @__PURE__ */ new Set());
  const registerForm = useCallback((id) => {
    setRegisteredForms((prev) => new Set(prev).add(id));
  }, []);
  const unregisterForm = useCallback(
    (id) => {
      setRegisteredForms((prev) => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
      if (activeFormId === id) {
        setActiveFormId(null);
      }
    },
    [activeFormId, setActiveFormId]
  );
  const isFormActive = (id) => {
    return activeFormId === id;
  };
  const isAnyFormActive = () => {
    return activeFormId !== null && registeredForms.size > 0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MultiFormContext.Provider,
    {
      value: {
        activeFormId,
        setActiveFormId,
        registerForm,
        unregisterForm,
        isFormActive,
        isAnyFormActive
      },
      children
    }
  );
};
const useMultiFormState = ({
  formId,
  initialViewMode = true
}) => {
  const [viewMode, setViewMode] = useState(initialViewMode);
  const { activeFormId, setActiveFormId, registerForm, unregisterForm, isAnyFormActive } = useMultiFormContext();
  useEffect(() => {
    registerForm(formId);
    return () => unregisterForm(formId);
  }, [formId, registerForm, unregisterForm]);
  const updateViewMode = useCallback(
    (newViewMode) => {
      if (!newViewMode) {
        setActiveFormId(formId);
      } else if (activeFormId === formId) {
        setActiveFormId(null);
      }
      setViewMode(newViewMode);
    },
    [activeFormId, formId, setActiveFormId]
  );
  const toggleViewMode = useCallback(() => {
    updateViewMode(!viewMode);
  }, [viewMode, updateViewMode]);
  const isDisabled = viewMode && isAnyFormActive() && activeFormId !== formId;
  return {
    viewMode,
    isDisabled,
    toggleViewMode,
    setViewMode: updateViewMode
  };
};
const formPageLayoutVariants = tv({
  base: [
    // Size
    "flex flex-col w-full items-center self-center",
    // Spacing
    "tablet-d:px-e24",
    // Alignment
    "items-start gap-e64",
    "mobile-d:gap-e40"
  ],
  variants: {
    variant: {
      full: [
        // Size
        "max-w-es808",
        // Spacing
        "mb-e160 mt-e40",
        "mobile-d:mb-e80 mobile-d:mt-e24"
      ],
      compact: [
        // Size
        "max-w-es598",
        // Spacing
        "my-e80",
        "mobile-d:my-e48"
      ]
    }
  },
  defaultVariants: {
    variant: "full"
  }
});
const FormPageLayout = ({ variant, className, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(
        clsx(
          formPageLayoutVariants({
            variant
          }),
          className
        )
      ),
      ...rest
    }
  );
};
const _twoPanelPageLayoutVariants = tv({
  base: ["w-full h-full grow", "grid grid-cols-2", "tablet-d:grid-cols-1"],
  slots: {
    left: ["col-span-1 tablet-d:py-e40"],
    right: [`col-span-1 tablet-d:py-e80`, "bg-cover bg-top bg-no-repeat"]
  },
  variants: {
    noDefaultMargins: {
      true: ""
    }
  },
  compoundSlots: [
    {
      slots: ["left", "right"],
      class: "px-es108 flex flex-col items-stretch justify-center text-left gap-e64 tablet-d:px-e24 tablet-d:gap-e40"
    },
    {
      slots: ["left", "right"],
      noDefaultMargins: true,
      class: "px-unset py-unset tablet-d:py-unset tablet-d:px-unset"
    }
  ]
});
const spray = "data:image/png;base64,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";
const LayoutContext = createContext({});
const LeftPanel = ({ className, ...rest }) => {
  const { variants } = useContext(LayoutContext);
  const { left } = variants;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: left({ className }),
      ...rest
    }
  );
};
const RightPanel = ({ className, ...rest }) => {
  const { variants } = useContext(LayoutContext);
  const { right } = variants;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: right({ className }),
      style: { backgroundImage: `url(${spray})` },
      ...rest
    }
  );
};
const TwoPanelsPageLayout = ({
  className,
  noDefaultMargins,
  ...rest
}) => {
  const variants = _twoPanelPageLayoutVariants({ className, noDefaultMargins });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LayoutContext.Provider, { value: { variants }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: variants.base(),
      ...rest
    }
  ) });
};
TwoPanelsPageLayout.LeftPanel = LeftPanel;
TwoPanelsPageLayout.RightPanel = RightPanel;
const containerStyles = twMerge(
  clsx(
    // Layout
    "grid grid-cols-3 desktop-lg:grid-cols-4 tablet-d:grid-cols-1",
    // Spacing
    "gap-e24 px-e24 py-e40",
    // Sizing
    "w-full"
  )
);
const mainStyles = twMerge(
  clsx(
    // Layout
    "col-span-2 desktop-lg:col-span-3 tablet-d:col-span-1",
    // Sizing
    "w-full"
  )
);
const sidebarStyles = twMerge(
  clsx(
    // Layout
    "flex flex-col",
    // Spacing
    "gap-e24",
    // Sizing
    "w-full"
  )
);
const _InternalMain = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(mainStyles, className),
      ...rest,
      children
    }
  );
};
const _InternalSidebar = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(sidebarStyles, className),
      ...rest,
      children
    }
  );
};
const PageSidebarLayout = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(containerStyles, className),
      ...rest,
      children
    }
  );
};
PageSidebarLayout.Main = _InternalMain;
PageSidebarLayout.Sidebar = _InternalSidebar;
const PageContainer = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FormPageLayout,
  {
    ...props,
    variant: props.variant === "small-form" ? "compact" : "full"
  }
);
const SvgLoadingDots = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ a$z.createElement("svg", { className: "spinner-root", viewBox: "0 0 60 51", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ a$z.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle1Translate", transform: "translate(10,33.528168)" }, /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle1Scale" }, /* @__PURE__ */ a$z.createElement("circle", { r: 6, transform: "translate(0,10.471832)", fill: "currentColor" }))), /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle2Translate", transform: "translate(30,33.528168)" }, /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle2Scale" }, /* @__PURE__ */ a$z.createElement("circle", { r: 6, transform: "translate(0,10.471832)", fill: "currentColor" }))), /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle3Translate", transform: "translate(50,33.528168)" }, /* @__PURE__ */ a$z.createElement("g", { className: "spinner-circle3Scale" }, /* @__PURE__ */ a$z.createElement("circle", { r: 6, transform: "translate(0,10.471832)", fill: "currentColor" }))));
const containerClassName$2 = clsx(
  "syntax-loading-dots",
  "flex size-full flex-col items-center justify-center gap-e24",
  "absolute z-10",
  "bg-warm-gray-50",
  "text-warm-gray-600"
);
const overlayClassName = clsx("bg-opacity-85");
const iconClassName$1 = clsx("size-e48 text-purple-200");
const LoadingDots = ({ message: message2, overlay, className, ...rest }) => {
  const classNameMerged = twMerge(
    clsx(containerClassName$2, { [overlayClassName]: overlay }, className)
  );
  const testIds = useDataTestIds({
    componentConfig: {
      MESSAGE: "message"
    },
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classNameMerged,
      ...rest,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SvgLoadingDots, { className: iconClassName$1 }),
        message2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Heading,
          {
            level: "h5",
            ...testIds.MESSAGE,
            children: message2
          }
        )
      ]
    }
  );
};
var dist$1 = {};
var isPlainObj$1 = (value) => {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};
(function(exports2) {
  var isPlainObject3 = isPlainObj$1;
  exports2.BLOCKS = void 0;
  (function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
  })(exports2.BLOCKS || (exports2.BLOCKS = {}));
  exports2.INLINES = void 0;
  (function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
  })(exports2.INLINES || (exports2.INLINES = {}));
  exports2.MARKS = void 0;
  (function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
  })(exports2.MARKS || (exports2.MARKS = {}));
  var extendStatics2 = function(d2, b2) {
    extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
      d3.__proto__ = b3;
    } || function(d3, b3) {
      for (var p2 in b3) if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
    };
    return extendStatics2(d2, b2);
  };
  function __extends2(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null)
      throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics2(d2, b2);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  }
  function __spreadArray2(to, from, pack) {
    if (pack || arguments.length === 2) for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }
  typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
    var e3 = new Error(message2);
    return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
  };
  var _a$1;
  var TOP_LEVEL_BLOCKS = [
    exports2.BLOCKS.PARAGRAPH,
    exports2.BLOCKS.HEADING_1,
    exports2.BLOCKS.HEADING_2,
    exports2.BLOCKS.HEADING_3,
    exports2.BLOCKS.HEADING_4,
    exports2.BLOCKS.HEADING_5,
    exports2.BLOCKS.HEADING_6,
    exports2.BLOCKS.OL_LIST,
    exports2.BLOCKS.UL_LIST,
    exports2.BLOCKS.HR,
    exports2.BLOCKS.QUOTE,
    exports2.BLOCKS.EMBEDDED_ENTRY,
    exports2.BLOCKS.EMBEDDED_ASSET,
    exports2.BLOCKS.EMBEDDED_RESOURCE,
    exports2.BLOCKS.TABLE
  ];
  var LIST_ITEM_BLOCKS = [
    exports2.BLOCKS.PARAGRAPH,
    exports2.BLOCKS.HEADING_1,
    exports2.BLOCKS.HEADING_2,
    exports2.BLOCKS.HEADING_3,
    exports2.BLOCKS.HEADING_4,
    exports2.BLOCKS.HEADING_5,
    exports2.BLOCKS.HEADING_6,
    exports2.BLOCKS.OL_LIST,
    exports2.BLOCKS.UL_LIST,
    exports2.BLOCKS.HR,
    exports2.BLOCKS.QUOTE,
    exports2.BLOCKS.EMBEDDED_ENTRY,
    exports2.BLOCKS.EMBEDDED_ASSET,
    exports2.BLOCKS.EMBEDDED_RESOURCE
  ];
  var TABLE_BLOCKS = [
    exports2.BLOCKS.TABLE,
    exports2.BLOCKS.TABLE_ROW,
    exports2.BLOCKS.TABLE_CELL,
    exports2.BLOCKS.TABLE_HEADER_CELL
  ];
  var VOID_BLOCKS = [
    exports2.BLOCKS.HR,
    exports2.BLOCKS.EMBEDDED_ENTRY,
    exports2.BLOCKS.EMBEDDED_ASSET,
    exports2.BLOCKS.EMBEDDED_RESOURCE
  ];
  var CONTAINERS = (_a$1 = {}, _a$1[exports2.BLOCKS.OL_LIST] = [exports2.BLOCKS.LIST_ITEM], _a$1[exports2.BLOCKS.UL_LIST] = [exports2.BLOCKS.LIST_ITEM], _a$1[exports2.BLOCKS.LIST_ITEM] = LIST_ITEM_BLOCKS, _a$1[exports2.BLOCKS.QUOTE] = [exports2.BLOCKS.PARAGRAPH], _a$1[exports2.BLOCKS.TABLE] = [exports2.BLOCKS.TABLE_ROW], _a$1[exports2.BLOCKS.TABLE_ROW] = [exports2.BLOCKS.TABLE_CELL, exports2.BLOCKS.TABLE_HEADER_CELL], _a$1[exports2.BLOCKS.TABLE_CELL] = [exports2.BLOCKS.PARAGRAPH, exports2.BLOCKS.UL_LIST, exports2.BLOCKS.OL_LIST], _a$1[exports2.BLOCKS.TABLE_HEADER_CELL] = [exports2.BLOCKS.PARAGRAPH], _a$1);
  var HEADINGS = [
    exports2.BLOCKS.HEADING_1,
    exports2.BLOCKS.HEADING_2,
    exports2.BLOCKS.HEADING_3,
    exports2.BLOCKS.HEADING_4,
    exports2.BLOCKS.HEADING_5,
    exports2.BLOCKS.HEADING_6
  ];
  var TEXT_CONTAINERS = __spreadArray2([exports2.BLOCKS.PARAGRAPH], HEADINGS, true);
  var V1_NODE_TYPES = [
    exports2.BLOCKS.DOCUMENT,
    exports2.BLOCKS.PARAGRAPH,
    exports2.BLOCKS.HEADING_1,
    exports2.BLOCKS.HEADING_2,
    exports2.BLOCKS.HEADING_3,
    exports2.BLOCKS.HEADING_4,
    exports2.BLOCKS.HEADING_5,
    exports2.BLOCKS.HEADING_6,
    exports2.BLOCKS.OL_LIST,
    exports2.BLOCKS.UL_LIST,
    exports2.BLOCKS.LIST_ITEM,
    exports2.BLOCKS.HR,
    exports2.BLOCKS.QUOTE,
    exports2.BLOCKS.EMBEDDED_ENTRY,
    exports2.BLOCKS.EMBEDDED_ASSET,
    exports2.INLINES.HYPERLINK,
    exports2.INLINES.ENTRY_HYPERLINK,
    exports2.INLINES.ASSET_HYPERLINK,
    exports2.INLINES.EMBEDDED_ENTRY,
    "text"
  ];
  var V1_MARKS = [exports2.MARKS.BOLD, exports2.MARKS.CODE, exports2.MARKS.ITALIC, exports2.MARKS.UNDERLINE];
  var EMPTY_DOCUMENT = {
    nodeType: exports2.BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType: exports2.BLOCKS.PARAGRAPH,
        data: {},
        content: [
          {
            nodeType: "text",
            value: "",
            marks: [],
            data: {}
          }
        ]
      }
    ]
  };
  function hasValue(obj, value) {
    for (var _i = 0, _a3 = Object.keys(obj); _i < _a3.length; _i++) {
      var key = _a3[_i];
      if (value === obj[key]) {
        return true;
      }
    }
    return false;
  }
  function isInline2(node) {
    return hasValue(exports2.INLINES, node.nodeType);
  }
  function isBlock2(node) {
    return hasValue(exports2.BLOCKS, node.nodeType);
  }
  function isText2(node) {
    return node.nodeType === "text";
  }
  var helpers = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    isBlock: isBlock2,
    isInline: isInline2,
    isText: isText2
  });
  var typeMismatchError = function(_a3) {
    var path2 = _a3.path, property2 = _a3.property, typeName = _a3.typeName, value = _a3.value;
    return {
      details: 'The type of "'.concat(property2, '" is incorrect, expected type: ').concat(typeName),
      name: "type",
      path: path2.toArray(),
      type: typeName,
      value
    };
  };
  var minSizeError = function(_a3) {
    var min2 = _a3.min, value = _a3.value, path2 = _a3.path;
    return {
      name: "size",
      min: min2,
      path: path2.toArray(),
      details: "Size must be at least ".concat(min2),
      value
    };
  };
  var maxSizeError = function(_a3) {
    var max2 = _a3.max, value = _a3.value, path2 = _a3.path;
    return {
      name: "size",
      max: max2,
      path: path2.toArray(),
      details: "Size must be at most ".concat(max2),
      value
    };
  };
  var enumError = function(_a3) {
    var expected = _a3.expected, value = _a3.value, path2 = _a3.path;
    return {
      details: "Value must be one of expected values",
      name: "in",
      expected: __spreadArray2([], expected, true).sort(),
      path: path2.toArray(),
      value
    };
  };
  var unknownPropertyError = function(_a3) {
    var property2 = _a3.property, path2 = _a3.path;
    return {
      details: 'The property "'.concat(property2, '" is not expected'),
      name: "unexpected",
      path: path2.toArray()
    };
  };
  var requiredPropertyError = function(_a3) {
    var property2 = _a3.property, path2 = _a3.path;
    return {
      details: 'The property "'.concat(property2, '" is required here'),
      name: "required",
      path: path2.toArray()
    };
  };
  var ObjectAssertion = (
    /** @class */
    function() {
      function ObjectAssertion2(obj, path2) {
        var _this = this;
        this.obj = obj;
        this.path = path2;
        this._errors = [];
        this.catch = function() {
          var _a3;
          var errors2 = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            errors2[_i] = arguments[_i];
          }
          (_a3 = _this._errors).push.apply(_a3, errors2);
        };
        this.exists = function(key) {
          if (key in _this.obj) {
            return true;
          }
          _this.catch(requiredPropertyError({
            property: key,
            path: _this.path.of(key)
          }));
          return false;
        };
        this.object = function(key) {
          var _a3;
          var value = key ? _this.obj[key] : _this.obj;
          if (key) {
            if (!_this.exists(key)) {
              return false;
            }
          }
          if (isPlainObject3(value)) {
            return true;
          }
          var path3 = key ? _this.path.of(key) : _this.path;
          var property2 = (_a3 = key !== null && key !== void 0 ? key : _this.path.last()) !== null && _a3 !== void 0 ? _a3 : "value";
          _this.catch(typeMismatchError({
            typeName: "Object",
            property: property2,
            path: path3,
            value
          }));
          return false;
        };
        this.string = function(key) {
          var value = _this.obj[key];
          if (key && !_this.exists(key)) {
            return false;
          }
          if (typeof value === "string") {
            return true;
          }
          _this.catch(typeMismatchError({
            typeName: "String",
            property: key,
            path: _this.path.of(key),
            value
          }));
          return false;
        };
        this.number = function(key, optional) {
          var value = _this.obj[key];
          if (optional && !(key in _this.obj)) {
            return true;
          }
          if (!_this.exists(key)) {
            return false;
          }
          if (typeof value === "number" && !Number.isNaN(value)) {
            return true;
          }
          _this.catch(typeMismatchError({
            typeName: "Number",
            property: key,
            path: _this.path.of(key),
            value
          }));
          return false;
        };
        this.array = function(key) {
          var value = _this.obj[key];
          if (key && !_this.exists(key)) {
            return false;
          }
          if (Array.isArray(value)) {
            return true;
          }
          _this.catch(typeMismatchError({
            typeName: "Array",
            property: key,
            path: _this.path.of(key),
            value
          }));
          return false;
        };
        this.enum = function(key, expected) {
          var value = _this.obj[key];
          if (typeof value === "string" && expected.includes(value)) {
            return true;
          }
          _this.catch(enumError({
            expected,
            value,
            path: _this.path.of(key)
          }));
          return false;
        };
        this.empty = function(key) {
          if (!_this.array(key)) {
            return false;
          }
          var value = _this.obj[key];
          if (value.length === 0) {
            return true;
          }
          _this.catch(maxSizeError({
            max: 0,
            value,
            path: _this.path.of(key)
          }));
          return false;
        };
        this.minLength = function(key, min2) {
          if (!_this.array(key)) {
            return false;
          }
          var value = _this.obj[key];
          if (value.length >= min2) {
            return true;
          }
          _this.catch(minSizeError({
            min: min2,
            value,
            path: _this.path.of(key)
          }));
          return false;
        };
        this.noAdditionalProperties = function(properties) {
          var unknowns = Object.keys(_this.obj).sort().filter(function(key) {
            return !properties.includes(key);
          });
          unknowns.forEach(function(property2) {
            return _this.catch(unknownPropertyError({
              property: property2,
              path: _this.path.of(property2)
            }));
          });
          return unknowns.length === 0;
        };
        this.each = function(key, assert2) {
          if (!_this.array(key)) {
            return;
          }
          var value = _this.obj[key];
          var foundErrors = false;
          value.forEach(function(item, index2) {
            if (foundErrors) {
              return;
            }
            var errors2 = assert2(item, _this.path.of(key).of(index2));
            if (errors2.length > 0) {
              foundErrors = true;
            }
            _this.catch.apply(_this, errors2);
          });
        };
      }
      Object.defineProperty(ObjectAssertion2.prototype, "errors", {
        get: function() {
          var _this = this;
          var serializeError = function(error2) {
            return JSON.stringify({
              details: error2.details,
              path: error2.path
            });
          };
          return this._errors.filter(function(error2, index2) {
            return _this._errors.findIndex(function(step) {
              return serializeError(error2) === serializeError(step);
            }) === index2;
          });
        },
        enumerable: false,
        configurable: true
      });
      return ObjectAssertion2;
    }()
  );
  var VOID_CONTENT = [];
  var NodeAssertion = (
    /** @class */
    function() {
      function NodeAssertion2(contentRule, validateData) {
        this.contentRule = contentRule;
        this.validateData = validateData;
      }
      NodeAssertion2.prototype.assert = function(node, path2) {
        var _a3, _b2;
        var $2 = new ObjectAssertion(node, path2);
        if (!$2.object()) {
          return $2.errors;
        }
        $2.noAdditionalProperties(["nodeType", "data", "content"]);
        var _c = Array.isArray(this.contentRule) ? {
          nodeTypes: this.contentRule
        } : this.contentRule(node, path2), nodeTypes = _c.nodeTypes, _d = _c.min, min2 = _d === void 0 ? 0 : _d;
        if (nodeTypes.length === 0 && min2 > 0) {
          throw new Error("Invalid content rule. Cannot have enforce a 'min' of ".concat(min2, " with no nodeTypes"));
        }
        $2.minLength("content", min2);
        if (nodeTypes.length === 0) {
          $2.empty("content");
        } else {
          $2.each("content", function(item, path3) {
            var item$ = new ObjectAssertion(item, path3);
            if (!item$.object()) {
              return item$.errors;
            }
            item$.enum("nodeType", nodeTypes);
            return item$.errors;
          });
        }
        if ($2.object("data")) {
          var dataErrors = (_b2 = (_a3 = this.validateData) === null || _a3 === void 0 ? void 0 : _a3.call(this, node.data, path2.of("data"))) !== null && _b2 !== void 0 ? _b2 : [];
          $2.catch.apply($2, dataErrors);
        }
        return $2.errors;
      };
      return NodeAssertion2;
    }()
  );
  var EntityLinkAssertion = (
    /** @class */
    function(_super) {
      __extends2(EntityLinkAssertion2, _super);
      function EntityLinkAssertion2(linkType, contentNodeTypes) {
        var _this = _super.call(this, contentNodeTypes, function(data, path2) {
          return _this.assertLink(data, path2);
        }) || this;
        _this.linkType = linkType;
        _this.assertLink = function(data, path2) {
          var $2 = new ObjectAssertion(data, path2);
          if ($2.object("target")) {
            var sys$ = new ObjectAssertion(data.target.sys, path2.of("target").of("sys"));
            if (sys$.object()) {
              sys$.enum("type", [_this.type]);
              sys$.enum("linkType", [_this.linkType]);
              if (_this.type === "Link") {
                sys$.string("id");
                sys$.noAdditionalProperties(["type", "linkType", "id"]);
              } else if (_this.type === "ResourceLink") {
                sys$.string("urn");
                sys$.noAdditionalProperties(["type", "linkType", "urn"]);
              }
            }
            $2.catch.apply($2, sys$.errors);
          }
          $2.noAdditionalProperties(["target"]);
          return $2.errors;
        };
        _this.type = _this.linkType.startsWith("Contentful:") ? "ResourceLink" : "Link";
        return _this;
      }
      return EntityLinkAssertion2;
    }(NodeAssertion)
  );
  var HyperLinkAssertion = (
    /** @class */
    function(_super) {
      __extends2(HyperLinkAssertion2, _super);
      function HyperLinkAssertion2() {
        var _this = _super.call(this, ["text"], function(data, path2) {
          return _this.assertLink(data, path2);
        }) || this;
        _this.assertLink = function(data, path2) {
          var $2 = new ObjectAssertion(data, path2);
          $2.string("uri");
          $2.noAdditionalProperties(["uri"]);
          return $2.errors;
        };
        return _this;
      }
      return HyperLinkAssertion2;
    }(NodeAssertion)
  );
  var assert = function(contentRule, validateData) {
    return new NodeAssertion(contentRule, validateData);
  };
  var assertLink = function(linkType, contentRule) {
    return new EntityLinkAssertion(linkType, contentRule);
  };
  var Path = (
    /** @class */
    /* @__PURE__ */ function() {
      function Path2(path2) {
        if (path2 === void 0) {
          path2 = [];
        }
        var _this = this;
        this.path = path2;
        this.of = function(element) {
          return new Path2(__spreadArray2(__spreadArray2([], _this.path, true), [element], false));
        };
        this.isRoot = function() {
          return _this.path.length === 0;
        };
        this.last = function() {
          return _this.path[_this.path.length - 1];
        };
        this.toArray = function() {
          return _this.path;
        };
      }
      return Path2;
    }()
  );
  function assertText(text2, path2) {
    var $2 = new ObjectAssertion(text2, path2);
    if (!$2.object()) {
      return $2.errors;
    }
    $2.noAdditionalProperties(["nodeType", "data", "value", "marks"]);
    $2.object("data");
    $2.each("marks", function(mark, path3) {
      var mark$ = new ObjectAssertion(mark, path3);
      if (!mark$.object()) {
        return mark$.errors;
      }
      mark$.string("type");
      return mark$.errors;
    });
    $2.string("value");
    return $2.errors;
  }
  var _a2;
  var assertInlineOrText = assert(__spreadArray2(__spreadArray2([], Object.values(exports2.INLINES), true), ["text"], false).sort());
  var assertList = assert([exports2.BLOCKS.LIST_ITEM]);
  var assertVoidEntryLink = assertLink("Entry", VOID_CONTENT);
  var assertTableCell = assert(function() {
    return {
      nodeTypes: [exports2.BLOCKS.PARAGRAPH],
      min: 1
    };
  }, function(data, path2) {
    var $2 = new ObjectAssertion(data, path2);
    $2.noAdditionalProperties(["colspan", "rowspan"]);
    $2.number("colspan", true);
    $2.number("rowspan", true);
    return $2.errors;
  });
  var nodeValidator = (_a2 = {}, _a2[exports2.BLOCKS.DOCUMENT] = assert(TOP_LEVEL_BLOCKS), _a2[exports2.BLOCKS.PARAGRAPH] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_1] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_2] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_3] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_4] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_5] = assertInlineOrText, _a2[exports2.BLOCKS.HEADING_6] = assertInlineOrText, _a2[exports2.BLOCKS.QUOTE] = assert(CONTAINERS[exports2.BLOCKS.QUOTE]), _a2[exports2.BLOCKS.EMBEDDED_ENTRY] = assertVoidEntryLink, _a2[exports2.BLOCKS.EMBEDDED_ASSET] = assertLink("Asset", VOID_CONTENT), _a2[exports2.BLOCKS.EMBEDDED_RESOURCE] = assertLink("Contentful:Entry", VOID_CONTENT), _a2[exports2.BLOCKS.HR] = assert(VOID_CONTENT), _a2[exports2.BLOCKS.OL_LIST] = assertList, _a2[exports2.BLOCKS.UL_LIST] = assertList, _a2[exports2.BLOCKS.LIST_ITEM] = assert(__spreadArray2([], LIST_ITEM_BLOCKS, true).sort()), _a2[exports2.BLOCKS.TABLE] = assert(function() {
    return {
      nodeTypes: [exports2.BLOCKS.TABLE_ROW],
      min: 1
    };
  }), _a2[exports2.BLOCKS.TABLE_ROW] = assert(function() {
    return {
      nodeTypes: [exports2.BLOCKS.TABLE_CELL, exports2.BLOCKS.TABLE_HEADER_CELL],
      min: 1
    };
  }), _a2[exports2.BLOCKS.TABLE_CELL] = assertTableCell, _a2[exports2.BLOCKS.TABLE_HEADER_CELL] = assertTableCell, _a2[exports2.INLINES.HYPERLINK] = new HyperLinkAssertion(), _a2[exports2.INLINES.EMBEDDED_ENTRY] = assertVoidEntryLink, _a2[exports2.INLINES.EMBEDDED_RESOURCE] = assertLink("Contentful:Entry", VOID_CONTENT), _a2[exports2.INLINES.ENTRY_HYPERLINK] = assertLink("Entry", ["text"]), _a2[exports2.INLINES.ASSET_HYPERLINK] = assertLink("Asset", ["text"]), _a2[exports2.INLINES.RESOURCE_HYPERLINK] = assertLink("Contentful:Entry", ["text"]), _a2);
  function validateNode(node, path2) {
    if (node.nodeType === "text") {
      return assertText(node, path2);
    }
    var errors2 = nodeValidator[node.nodeType].assert(node, path2);
    if (errors2.length > 0) {
      return errors2;
    }
    var $2 = new ObjectAssertion(node, path2);
    $2.each("content", function(item, path3) {
      return validateNode(item, path3);
    });
    return $2.errors;
  }
  var validateRichTextDocument = function(document2) {
    var path2 = new Path();
    var $2 = new ObjectAssertion(document2, path2);
    if ($2.object()) {
      $2.enum("nodeType", [exports2.BLOCKS.DOCUMENT]);
    }
    if ($2.errors.length > 0) {
      return $2.errors;
    }
    return validateNode(document2, path2);
  };
  exports2.CONTAINERS = CONTAINERS;
  exports2.EMPTY_DOCUMENT = EMPTY_DOCUMENT;
  exports2.HEADINGS = HEADINGS;
  exports2.LIST_ITEM_BLOCKS = LIST_ITEM_BLOCKS;
  exports2.TABLE_BLOCKS = TABLE_BLOCKS;
  exports2.TEXT_CONTAINERS = TEXT_CONTAINERS;
  exports2.TOP_LEVEL_BLOCKS = TOP_LEVEL_BLOCKS;
  exports2.V1_MARKS = V1_MARKS;
  exports2.V1_NODE_TYPES = V1_NODE_TYPES;
  exports2.VOID_BLOCKS = VOID_BLOCKS;
  exports2.helpers = helpers;
  exports2.validateRichTextDocument = validateRichTextDocument;
})(dist$1);
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(module2, exports2) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE2 = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE2 = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG2 = 1, CLONE_FLAT_FLAG2 = 2, CLONE_SYMBOLS_FLAG2 = 4;
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT2 = 800, HOT_SPAN2 = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", domExcTag = "[object DOMException]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp2 = /^\w*$/, rePropName2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar2 = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags2 = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var reLatin2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange2 = "\\ud800-\\udfff", rsComboMarksRange2 = "\\u0300-\\u036f", reComboHalfMarksRange2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange2 = "\\u20d0-\\u20ff", rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2, rsDingbatRange2 = "\\u2700-\\u27bf", rsLowerRange2 = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange2 = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange2 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange2 = "\\u2000-\\u206f", rsSpaceRange2 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange2 = "\\ufe0e\\ufe0f", rsBreakRange2 = rsMathOpRange2 + rsNonCharRange2 + rsPunctuationRange2 + rsSpaceRange2;
    var rsApos2 = "['’]", rsAstral = "[" + rsAstralRange2 + "]", rsBreak2 = "[" + rsBreakRange2 + "]", rsCombo2 = "[" + rsComboRange2 + "]", rsDigits2 = "\\d+", rsDingbat2 = "[" + rsDingbatRange2 + "]", rsLower2 = "[" + rsLowerRange2 + "]", rsMisc2 = "[^" + rsAstralRange2 + rsBreakRange2 + rsDigits2 + rsDingbatRange2 + rsLowerRange2 + rsUpperRange2 + "]", rsFitz2 = "\\ud83c[\\udffb-\\udfff]", rsModifier2 = "(?:" + rsCombo2 + "|" + rsFitz2 + ")", rsNonAstral2 = "[^" + rsAstralRange2 + "]", rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper2 = "[" + rsUpperRange2 + "]", rsZWJ2 = "\\u200d";
    var rsMiscLower2 = "(?:" + rsLower2 + "|" + rsMisc2 + ")", rsMiscUpper2 = "(?:" + rsUpper2 + "|" + rsMisc2 + ")", rsOptContrLower2 = "(?:" + rsApos2 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper2 = "(?:" + rsApos2 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod2 = rsModifier2 + "?", rsOptVar2 = "[" + rsVarRange2 + "]?", rsOptJoin2 = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*", rsOrdLower2 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper2 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2, rsEmoji2 = "(?:" + [rsDingbat2, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2, rsSymbol = "(?:" + [rsNonAstral2 + rsCombo2 + "?", rsCombo2, rsRegional2, rsSurrPair2, rsAstral].join("|") + ")";
    var reApos2 = RegExp(rsApos2, "g");
    var reComboMark2 = RegExp(rsCombo2, "g");
    var reUnicode = RegExp(rsFitz2 + "(?=" + rsFitz2 + ")|" + rsSymbol + rsSeq2, "g");
    var reUnicodeWord2 = RegExp([
      rsUpper2 + "?" + rsLower2 + "+" + rsOptContrLower2 + "(?=" + [rsBreak2, rsUpper2, "$"].join("|") + ")",
      rsMiscUpper2 + "+" + rsOptContrUpper2 + "(?=" + [rsBreak2, rsUpper2 + rsMiscLower2, "$"].join("|") + ")",
      rsUpper2 + "?" + rsMiscLower2 + "+" + rsOptContrLower2,
      rsUpper2 + "+" + rsOptContrUpper2,
      rsOrdUpper2,
      rsOrdLower2,
      rsDigits2,
      rsEmoji2
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ2 + rsAstralRange2 + rsComboRange2 + rsVarRange2 + "]");
    var reHasUnicodeWord2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var cloneableTags2 = {};
    cloneableTags2[argsTag2] = cloneableTags2[arrayTag2] = cloneableTags2[arrayBufferTag2] = cloneableTags2[dataViewTag2] = cloneableTags2[boolTag2] = cloneableTags2[dateTag2] = cloneableTags2[float32Tag2] = cloneableTags2[float64Tag2] = cloneableTags2[int8Tag2] = cloneableTags2[int16Tag2] = cloneableTags2[int32Tag2] = cloneableTags2[mapTag2] = cloneableTags2[numberTag2] = cloneableTags2[objectTag2] = cloneableTags2[regexpTag2] = cloneableTags2[setTag2] = cloneableTags2[stringTag2] = cloneableTags2[symbolTag2] = cloneableTags2[uint8Tag2] = cloneableTags2[uint8ClampedTag2] = cloneableTags2[uint16Tag2] = cloneableTags2[uint32Tag2] = true;
    cloneableTags2[errorTag2] = cloneableTags2[funcTag2] = cloneableTags2[weakMapTag2] = false;
    var deburredLetters2 = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = function() {
      try {
        var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
      } catch (e3) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil2 && nodeUtil2.isArrayBuffer, nodeIsDate = nodeUtil2 && nodeUtil2.isDate, nodeIsMap2 = nodeUtil2 && nodeUtil2.isMap, nodeIsRegExp = nodeUtil2 && nodeUtil2.isRegExp, nodeIsSet2 = nodeUtil2 && nodeUtil2.isSet, nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array2, setter, iteratee, accumulator) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        var value = array2[index2];
        setter(accumulator, value, iteratee(value), array2);
      }
      return accumulator;
    }
    function arrayEach2(array2, iteratee) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (iteratee(array2[index2], index2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEachRight(array2, iteratee) {
      var length = array2 == null ? 0 : array2.length;
      while (length--) {
        if (iteratee(array2[length], length, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEvery(array2, predicate) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (!predicate(array2[index2], index2, array2)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter2(array2, predicate) {
      var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array2[index2];
        if (predicate(value, index2, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array2, value) {
      var length = array2 == null ? 0 : array2.length;
      return !!length && baseIndexOf(array2, value, 0) > -1;
    }
    function arrayIncludesWith(array2, value, comparator) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (comparator(value, array2[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap2(array2, iteratee) {
      var index2 = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array2[index2], index2, array2);
      }
      return result;
    }
    function arrayPush2(array2, values) {
      var index2 = -1, length = values.length, offset2 = array2.length;
      while (++index2 < length) {
        array2[offset2 + index2] = values[index2];
      }
      return array2;
    }
    function arrayReduce2(array2, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      if (initAccum && length) {
        accumulator = array2[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array2[index2], index2, array2);
      }
      return accumulator;
    }
    function arrayReduceRight(array2, iteratee, accumulator, initAccum) {
      var length = array2 == null ? 0 : array2.length;
      if (initAccum && length) {
        accumulator = array2[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array2[length], length, array2);
      }
      return accumulator;
    }
    function arraySome2(array2, predicate) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (predicate(array2[index2], index2, array2)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty2("length");
    function asciiToArray(string2) {
      return string2.split("");
    }
    function asciiWords2(string2) {
      return string2.match(reAsciiWord2) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array2, predicate, fromIndex, fromRight) {
      var length = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array2[index2], index2, array2)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array2, value, fromIndex) {
      return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array2, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array2.length;
      while (++index2 < length) {
        if (comparator(array2[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array2, iteratee) {
      var length = array2 == null ? 0 : array2.length;
      return length ? baseSum(array2, iteratee) / length : NAN;
    }
    function baseProperty2(key) {
      return function(object2) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function basePropertyOf2(object2) {
      return function(key) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array2, comparer) {
      var length = array2.length;
      array2.sort(comparer);
      while (length--) {
        array2[length] = array2[length].value;
      }
      return array2;
    }
    function baseSum(array2, iteratee) {
      var result, index2 = -1, length = array2.length;
      while (++index2 < length) {
        var current2 = iteratee(array2[index2]);
        if (current2 !== undefined$1) {
          result = result === undefined$1 ? current2 : result + current2;
        }
      }
      return result;
    }
    function baseTimes2(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object2, props) {
      return arrayMap2(props, function(key) {
        return [key, object2[key]];
      });
    }
    function baseTrim(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
    }
    function baseUnary2(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object2, props) {
      return arrayMap2(props, function(key) {
        return object2[key];
      });
    }
    function cacheHas2(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array2, placeholder) {
      var length = array2.length, result = 0;
      while (length--) {
        if (array2[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter2 = basePropertyOf2(deburredLetters2);
    var escapeHtmlChar = basePropertyOf2(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object2, key) {
      return object2 == null ? undefined$1 : object2[key];
    }
    function hasUnicode(string2) {
      return reHasUnicode.test(string2);
    }
    function hasUnicodeWord2(string2) {
      return reHasUnicodeWord2.test(string2);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray2(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg2(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array2, placeholder) {
      var index2 = -1, length = array2.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array2[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array2[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray2(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array2, value, fromIndex) {
      var index2 = fromIndex - 1, length = array2.length;
      while (++index2 < length) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array2, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string2) {
      return hasUnicode(string2) ? unicodeSize(string2) : asciiSize(string2);
    }
    function stringToArray(string2) {
      return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
    }
    function trimmedEndIndex(string2) {
      var index2 = string2.length;
      while (index2-- && reWhitespace.test(string2.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf2(htmlUnescapes);
    function unicodeSize(string2) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string2)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string2) {
      return string2.match(reUnicode) || [];
    }
    function unicodeWords2(string2) {
      return string2.match(reUnicodeWord2) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _2.defaults(root2.Object(), context, _2.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto2 = Array2.prototype, funcProto2 = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData2 = context["__core-js_shared__"];
      var funcToString2 = funcProto2.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey2 = function() {
        var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString2 = objectProto2.toString;
      var objectCtorString2 = funcToString2.call(Object2);
      var oldDash = root2._;
      var reIsNative2 = RegExp2(
        "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer2 = moduleExports2 ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe2 = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype2 = overArg2(Object2.getPrototypeOf, Object2), objectCreate2 = Object2.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, spreadableSymbol2 = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty2 = function() {
        try {
          var func = getNative2(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e3) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols2 = Object2.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto2.join, nativeKeys2 = overArg2(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin = Math2.min, nativeNow2 = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
      var DataView2 = getNative2(context, "DataView"), Map2 = getNative2(context, "Map"), Promise2 = getNative2(context, "Promise"), Set2 = getNative2(context, "Set"), WeakMap2 = getNative2(context, "WeakMap"), nativeCreate2 = getNative2(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
      var symbolProto2 = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : undefined$1, symbolToString2 = symbolProto2 ? symbolProto2.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray3(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate2 = /* @__PURE__ */ function() {
        function object2() {
        }
        return function(proto2) {
          if (!isObject2(proto2)) {
            return {};
          }
          if (objectCreate2) {
            return objectCreate2(proto2);
          }
          object2.prototype = proto2;
          var result2 = new object2();
          object2.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate2(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray2(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray2(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray2(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array2 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray3(array2), isRight = dir < 0, arrLength = isArr ? array2.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array2, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array2[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate2(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
      }
      function hashDelete2(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet2(key) {
        var data = this.__data__;
        if (nativeCreate2) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED2 ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas2(key) {
        var data = this.__data__;
        return nativeCreate2 ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet2(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate2 && value === undefined$1 ? HASH_UNDEFINED2 : value;
        return this;
      }
      Hash2.prototype.clear = hashClear2;
      Hash2.prototype["delete"] = hashDelete2;
      Hash2.prototype.get = hashGet2;
      Hash2.prototype.has = hashHas2;
      Hash2.prototype.set = hashSet2;
      function ListCache2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice2.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
      }
      function listCacheSet2(key, value) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache2.prototype.clear = listCacheClear2;
      ListCache2.prototype["delete"] = listCacheDelete2;
      ListCache2.prototype.get = listCacheGet2;
      ListCache2.prototype.has = listCacheHas2;
      ListCache2.prototype.set = listCacheSet2;
      function MapCache2(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map2 || ListCache2)(),
          "string": new Hash2()
        };
      }
      function mapCacheDelete2(key) {
        var result2 = getMapData2(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
      }
      function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
      }
      function mapCacheSet2(key, value) {
        var data = getMapData2(this, key), size3 = data.size;
        data.set(key, value);
        this.size += data.size == size3 ? 0 : 1;
        return this;
      }
      MapCache2.prototype.clear = mapCacheClear2;
      MapCache2.prototype["delete"] = mapCacheDelete2;
      MapCache2.prototype.get = mapCacheGet2;
      MapCache2.prototype.has = mapCacheHas2;
      MapCache2.prototype.set = mapCacheSet2;
      function SetCache2(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache2();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd2(value) {
        this.__data__.set(value, HASH_UNDEFINED2);
        return this;
      }
      function setCacheHas2(value) {
        return this.__data__.has(value);
      }
      SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
      SetCache2.prototype.has = setCacheHas2;
      function Stack2(entries) {
        var data = this.__data__ = new ListCache2(entries);
        this.size = data.size;
      }
      function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
      }
      function stackDelete2(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet2(key) {
        return this.__data__.get(key);
      }
      function stackHas2(key) {
        return this.__data__.has(key);
      }
      function stackSet2(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache2) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache2(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack2.prototype.clear = stackClear2;
      Stack2.prototype["delete"] = stackDelete2;
      Stack2.prototype.get = stackGet2;
      Stack2.prototype.has = stackHas2;
      Stack2.prototype.set = stackSet2;
      function arrayLikeKeys2(value, inherited) {
        var isArr = isArray3(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer3(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes2(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex2(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array2) {
        var length = array2.length;
        return length ? array2[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array2, n2) {
        return shuffleSelf(copyArray2(array2), baseClamp(n2, 0, array2.length));
      }
      function arrayShuffle(array2) {
        return shuffleSelf(copyArray2(array2));
      }
      function assignMergeValue2(object2, key, value) {
        if (value !== undefined$1 && !eq2(object2[key], value) || value === undefined$1 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assignValue2(object2, key, value) {
        var objValue = object2[key];
        if (!(hasOwnProperty2.call(object2, key) && eq2(objValue, value)) || value === undefined$1 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assocIndexOf2(array2, key) {
        var length = array2.length;
        while (length--) {
          if (eq2(array2[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object2, source) {
        return object2 && copyObject2(source, keys2(source), object2);
      }
      function baseAssignIn(object2, source) {
        return object2 && copyObject2(source, keysIn2(source), object2);
      }
      function baseAssignValue2(object2, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object2, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object2[key] = value;
        }
      }
      function baseAt(object2, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object2 == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get2(object2, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone2(value, bitmask, customizer, key, object2, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG2, isFlat = bitmask & CLONE_FLAT_FLAG2, isFull = bitmask & CLONE_SYMBOLS_FLAG2;
        if (customizer) {
          result2 = object2 ? customizer(value, key, object2, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray3(value);
        if (isArr) {
          result2 = initCloneArray2(value);
          if (!isDeep) {
            return copyArray2(value, result2);
          }
        } else {
          var tag = getTag2(value), isFunc = tag == funcTag2 || tag == genTag2;
          if (isBuffer3(value)) {
            return cloneBuffer2(value, isDeep);
          }
          if (tag == objectTag2 || tag == argsTag2 || isFunc && !object2) {
            result2 = isFlat || isFunc ? {} : initCloneObject2(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags2[tag]) {
              return object2 ? value : {};
            }
            result2 = initCloneByTag2(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack2());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet2(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone2(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap2(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn2 : getAllKeys2 : isFlat ? keysIn2 : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach2(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue2(result2, key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object2) {
          return baseConformsTo(object2, source, props);
        };
      }
      function baseConformsTo(object2, source, props) {
        var length = props.length;
        if (object2 == null) {
          return !length;
        }
        object2 = Object2(object2);
        while (length--) {
          var key = props[length], predicate = source[key], value = object2[key];
          if (value === undefined$1 && !(key in object2) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array2, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array2.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap2(values2, baseUnary2(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE2) {
          includes2 = cacheHas2;
          isCommon = false;
          values2 = new SetCache2(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array2[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn2);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array2, iteratee2, comparator) {
        var index2 = -1, length = array2.length;
        while (++index2 < length) {
          var value = array2[index2], current2 = iteratee2(value);
          if (current2 != null && (computed === undefined$1 ? current2 === current2 && !isSymbol2(current2) : comparator(current2, computed))) {
            var computed = current2, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array2, value, start, end) {
        var length = array2.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array2[start++] = value;
        }
        return array2;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten2(array2, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array2.length;
        predicate || (predicate = isFlattenable2);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array2[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten2(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush2(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor2 = createBaseFor2();
      var baseForRight = createBaseFor2(true);
      function baseForOwn2(object2, iteratee2) {
        return object2 && baseFor2(object2, iteratee2, keys2);
      }
      function baseForOwnRight(object2, iteratee2) {
        return object2 && baseForRight(object2, iteratee2, keys2);
      }
      function baseFunctions(object2, props) {
        return arrayFilter2(props, function(key) {
          return isFunction2(object2[key]);
        });
      }
      function baseGet2(object2, path2) {
        path2 = castPath2(path2, object2);
        var index2 = 0, length = path2.length;
        while (object2 != null && index2 < length) {
          object2 = object2[toKey2(path2[index2++])];
        }
        return index2 && index2 == length ? object2 : undefined$1;
      }
      function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object2);
        return isArray3(object2) ? result2 : arrayPush2(result2, symbolsFunc(object2));
      }
      function baseGetTag2(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag2 : nullTag2;
        }
        return symToStringTag2 && symToStringTag2 in Object2(value) ? getRawTag2(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object2, key) {
        return object2 != null && hasOwnProperty2.call(object2, key);
      }
      function baseHasIn2(object2, key) {
        return object2 != null && key in Object2(object2);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax2(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array2 = arrays[othIndex];
          if (othIndex && iteratee2) {
            array2 = arrayMap2(array2, baseUnary2(iteratee2));
          }
          maxLength = nativeMin(array2.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array2.length >= 120) ? new SetCache2(othIndex && array2) : undefined$1;
        }
        array2 = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas2(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas2(cache2, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object2, setter, iteratee2, accumulator) {
        baseForOwn2(object2, function(value, key, object3) {
          setter(accumulator, iteratee2(value), key, object3);
        });
        return accumulator;
      }
      function baseInvoke(object2, path2, args) {
        path2 = castPath2(path2, object2);
        object2 = parent2(object2, path2);
        var func = object2 == null ? object2 : object2[toKey2(last2(path2))];
        return func == null ? undefined$1 : apply2(func, object2, args);
      }
      function baseIsArguments2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike2(value) && baseGetTag2(value) == arrayBufferTag2;
      }
      function baseIsDate(value) {
        return isObjectLike2(value) && baseGetTag2(value) == dateTag2;
      }
      function baseIsEqual2(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack);
      }
      function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray3(object2), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
        objTag = objTag == argsTag2 ? objectTag2 : objTag;
        othTag = othTag == argsTag2 ? objectTag2 : othTag;
        var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer3(object2)) {
          if (!isBuffer3(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack2());
          return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack2());
        return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap2(value) {
        return isObjectLike2(value) && getTag2(value) == mapTag2;
      }
      function baseIsMatch2(object2, source, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object2 == null) {
          return !length;
        }
        object2 = Object2(object2);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object2[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object2)) {
              return false;
            }
          } else {
            var stack = new Stack2();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object2, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative2(value) {
        if (!isObject2(value) || isMasked2(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
        return pattern.test(toSource2(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike2(value) && baseGetTag2(value) == regexpTag2;
      }
      function baseIsSet2(value) {
        return isObjectLike2(value) && getTag2(value) == setTag2;
      }
      function baseIsTypedArray2(value) {
        return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
      }
      function baseIteratee2(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity2;
        }
        if (typeof value == "object") {
          return isArray3(value) ? baseMatchesProperty2(value[0], value[1]) : baseMatches2(value);
        }
        return property2(value);
      }
      function baseKeys2(object2) {
        if (!isPrototype2(object2)) {
          return nativeKeys2(object2);
        }
        var result2 = [];
        for (var key in Object2(object2)) {
          if (hasOwnProperty2.call(object2, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn2(object2) {
        if (!isObject2(object2)) {
          return nativeKeysIn2(object2);
        }
        var isProto = isPrototype2(object2), result2 = [];
        for (var key in object2) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches2(source) {
        var matchData = getMatchData2(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable2(matchData[0][0], matchData[0][1]);
        }
        return function(object2) {
          return object2 === source || baseIsMatch2(object2, source, matchData);
        };
      }
      function baseMatchesProperty2(path2, srcValue) {
        if (isKey2(path2) && isStrictComparable2(srcValue)) {
          return matchesStrictComparable2(toKey2(path2), srcValue);
        }
        return function(object2) {
          var objValue = get2(object2, path2);
          return objValue === undefined$1 && objValue === srcValue ? hasIn2(object2, path2) : baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2);
        };
      }
      function baseMerge2(object2, source, srcIndex, customizer, stack) {
        if (object2 === source) {
          return;
        }
        baseFor2(source, function(srcValue, key) {
          stack || (stack = new Stack2());
          if (isObject2(srcValue)) {
            baseMergeDeep2(object2, source, key, srcIndex, baseMerge2, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet2(object2, key), srcValue, key + "", object2, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue2(object2, key, newValue);
          }
        }, keysIn2);
      }
      function baseMergeDeep2(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet2(object2, key), srcValue = safeGet2(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue2(object2, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray3(srcValue), isBuff = !isArr && isBuffer3(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray3(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject2(objValue)) {
              newValue = copyArray2(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer2(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray2(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject3(srcValue) || isArguments2(srcValue)) {
            newValue = objValue;
            if (isArguments2(objValue)) {
              newValue = toPlainObject2(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject2(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue2(object2, key, newValue);
      }
      function baseNth(array2, n2) {
        var length = array2.length;
        if (!length) {
          return;
        }
        n2 += n2 < 0 ? length : 0;
        return isIndex2(n2, length) ? array2[n2] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap2(iteratees, function(iteratee2) {
            if (isArray3(iteratee2)) {
              return function(value) {
                return baseGet2(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity2];
        }
        var index2 = -1;
        iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap2(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object2, other) {
          return compareMultiple(object2, other, orders);
        });
      }
      function basePick2(object2, paths) {
        return basePickBy2(object2, paths, function(value, path2) {
          return hasIn2(object2, path2);
        });
      }
      function basePickBy2(object2, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path2 = paths[index2], value = baseGet2(object2, path2);
          if (predicate(value, path2)) {
            baseSet2(result2, castPath2(path2, object2), value);
          }
        }
        return result2;
      }
      function basePropertyDeep2(path2) {
        return function(object2) {
          return baseGet2(object2, path2);
        };
      }
      function basePullAll(array2, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array2;
        if (array2 === values2) {
          values2 = copyArray2(values2);
        }
        if (iteratee2) {
          seen = arrayMap2(array2, baseUnary2(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array2) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array2, fromIndex, 1);
          }
        }
        return array2;
      }
      function basePullAt(array2, indexes) {
        var length = array2 ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous2) {
            var previous2 = index2;
            if (isIndex2(index2)) {
              splice2.call(array2, index2, 1);
            } else {
              baseUnset2(array2, index2);
            }
          }
        }
        return array2;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax2(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string2, n2) {
        var result2 = "";
        if (!string2 || n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string2;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string2 += string2;
          }
        } while (n2);
        return result2;
      }
      function baseRest2(func, start) {
        return setToString2(overRest2(func, start, identity2), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n2) {
        var array2 = values(collection);
        return shuffleSelf(array2, baseClamp(n2, 0, array2.length));
      }
      function baseSet2(object2, path2, value, customizer) {
        if (!isObject2(object2)) {
          return object2;
        }
        path2 = castPath2(path2, object2);
        var index2 = -1, length = path2.length, lastIndex = length - 1, nested = object2;
        while (nested != null && ++index2 < length) {
          var key = toKey2(path2[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object2;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex2(path2[index2 + 1]) ? [] : {};
            }
          }
          assignValue2(nested, key, newValue);
          nested = nested[key];
        }
        return object2;
      }
      var baseSetData = !metaMap ? identity2 : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString2 = !defineProperty2 ? identity2 : function(func, string2) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant2(string2),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice2(array2, start, end) {
        var index2 = -1, length = array2.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array2[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array2, value, retHighest) {
        var low = 0, high = array2 == null ? low : array2.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array2[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array2, value, identity2, retHighest);
      }
      function baseSortedIndexBy(array2, value, iteratee2, retHighest) {
        var low = 0, high = array2 == null ? 0 : array2.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array2[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array2, iteratee2) {
        var index2 = -1, length = array2.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq2(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString2(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray3(value)) {
          return arrayMap2(value, baseToString2) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString2 ? symbolToString2.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
      }
      function baseUniq(array2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array2.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE2) {
          var set3 = iteratee2 ? null : createSet(array2);
          if (set3) {
            return setToArray2(set3);
          }
          isCommon = false;
          includes2 = cacheHas2;
          seen = new SetCache2();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset2(object2, path2) {
        path2 = castPath2(path2, object2);
        object2 = parent2(object2, path2);
        return object2 == null || delete object2[toKey2(last2(path2))];
      }
      function baseUpdate(object2, path2, updater, customizer) {
        return baseSet2(object2, path2, updater(baseGet2(object2, path2)), customizer);
      }
      function baseWhile(array2, predicate, isDrop, fromRight) {
        var length = array2.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array2[index2], index2, array2)) {
        }
        return isDrop ? baseSlice2(array2, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice2(array2, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce2(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush2([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array2 = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array2, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten2(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject2(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity2;
      }
      function castPath2(value, object2) {
        if (isArray3(value)) {
          return value;
        }
        return isKey2(value, object2) ? [value] : stringToPath2(toString2(value));
      }
      var castRest = baseRest2;
      function castSlice(array2, start, end) {
        var length = array2.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array2 : baseSlice2(array2, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root2.clearTimeout(id);
      };
      function cloneBuffer2(buffer2, isDeep) {
        if (isDeep) {
          return buffer2.slice();
        }
        var length = buffer2.length, result2 = allocUnsafe2 ? allocUnsafe2(length) : new buffer2.constructor(length);
        buffer2.copy(result2);
        return result2;
      }
      function cloneArrayBuffer2(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView2(dataView, isDeep) {
        var buffer2 = isDeep ? cloneArrayBuffer2(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp2(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags2.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol2(symbol) {
        return symbolValueOf2 ? Object2(symbolValueOf2.call(symbol)) : {};
      }
      function cloneTypedArray2(typedArray, isDeep) {
        var buffer2 = isDeep ? cloneArrayBuffer2(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object2, other, orders) {
        var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order2 = orders[index2];
            return result2 * (order2 == "desc" ? -1 : 1);
          }
        }
        return object2.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray2(source, array2) {
        var index2 = -1, length = source.length;
        array2 || (array2 = Array2(length));
        while (++index2 < length) {
          array2[index2] = source[index2];
        }
        return array2;
      }
      function copyObject2(source, props, object2, customizer) {
        var isNew = !object2;
        object2 || (object2 = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue2(object2, key, newValue);
          } else {
            assignValue2(object2, key, newValue);
          }
        }
        return object2;
      }
      function copySymbols(source, object2) {
        return copyObject2(source, getSymbols2(source), object2);
      }
      function copySymbolsIn(source, object2) {
        return copyObject2(source, getSymbolsIn2(source), object2);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray3(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner2(assigner) {
        return baseRest2(function(object2, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object2 = Object2(object2);
          while (++index2 < length) {
            var source = sources[index2];
            if (source) {
              assigner(object2, source, index2, customizer);
            }
          }
          return object2;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike2(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor2(fromRight) {
        return function(object2, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object2), props = keysFunc(object2), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object2;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string2) {
          string2 = toString2(string2);
          var strSymbols = hasUnicode(string2) ? stringToArray(string2) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder2(callback) {
        return function(string2) {
          return arrayReduce2(words2(deburr2(string2).replace(reApos2, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate2(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply2(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike2(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest2(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray3(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object2, iteratee2) {
          return baseInverter(object2, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString2(value);
              other = baseToString2(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest2(function(iteratees) {
          iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
          return baseRest2(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString2(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall2(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= -4;
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString2(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString2(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set2 && 1 / setToArray2(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object2) {
          var tag = getTag2(object2);
          if (tag == mapTag2) {
            return mapToArray2(object2);
          }
          if (tag == setTag2) {
            return setToPairs(object2);
          }
          return baseToPairs(object2, keysFunc(object2));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= -97;
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax2(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= -25;
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object2) {
        if (objValue === undefined$1 || eq2(objValue, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object2, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge2(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone2(value) {
        return isPlainObject3(value) ? undefined$1 : value;
      }
      function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array2);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array2;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : undefined$1;
        stack.set(array2, other);
        stack.set(other, array2);
        while (++index2 < arrLength) {
          var arrValue = array2[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome2(other, function(othValue2, othIndex) {
              if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array2);
        stack["delete"](other);
        return result2;
      }
      function equalByTag2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag2:
            if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
              return false;
            }
            object2 = object2.buffer;
            other = other.buffer;
          case arrayBufferTag2:
            if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag2:
          case dateTag2:
          case numberTag2:
            return eq2(+object2, +other);
          case errorTag2:
            return object2.name == other.name && object2.message == other.message;
          case regexpTag2:
          case stringTag2:
            return object2 == other + "";
          case mapTag2:
            var convert2 = mapToArray2;
          case setTag2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
            convert2 || (convert2 = setToArray2);
            if (object2.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object2);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG2;
            stack.set(object2, other);
            var result2 = equalArrays2(convert2(object2), convert2(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object2);
            return result2;
          case symbolTag2:
            if (symbolValueOf2) {
              return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
            }
        }
        return false;
      }
      function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object2);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object2;
        }
        var result2 = true;
        stack.set(object2, other);
        stack.set(other, object2);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object2[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object2.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object2);
        stack["delete"](other);
        return result2;
      }
      function flatRest2(func) {
        return setToString2(overRest2(func, undefined$1, flatten2), func + "");
      }
      function getAllKeys2(object2) {
        return baseGetAllKeys2(object2, keys2, getSymbols2);
      }
      function getAllKeysIn2(object2) {
        return baseGetAllKeys2(object2, keysIn2, getSymbolsIn2);
      }
      var getData = !metaMap ? noop2 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array2 = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array2.length : 0;
        while (length--) {
          var data = array2[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object2 = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object2.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee2 : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData2(map2, key) {
        var data = map2.__data__;
        return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData2(object2) {
        var result2 = keys2(object2), length = result2.length;
        while (length--) {
          var key = result2[length], value = object2[key];
          result2[length] = [key, value, isStrictComparable2(value)];
        }
        return result2;
      }
      function getNative2(object2, key) {
        var value = getValue2(object2, key);
        return baseIsNative2(value) ? value : undefined$1;
      }
      function getRawTag2(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
        try {
          value[symToStringTag2] = undefined$1;
          var unmasked = true;
        } catch (e3) {
        }
        var result2 = nativeObjectToString2.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag2] = tag;
          } else {
            delete value[symToStringTag2];
          }
        }
        return result2;
      }
      var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        if (object2 == null) {
          return [];
        }
        object2 = Object2(object2);
        return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
          return propertyIsEnumerable2.call(object2, symbol);
        });
      };
      var getSymbolsIn2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        var result2 = [];
        while (object2) {
          arrayPush2(result2, getSymbols2(object2));
          object2 = getPrototype2(object2);
        }
        return result2;
      };
      var getTag2 = baseGetTag2;
      if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
        getTag2 = function(value) {
          var result2 = baseGetTag2(value), Ctor = result2 == objectTag2 ? value.constructor : undefined$1, ctorString = Ctor ? toSource2(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString2:
                return dataViewTag2;
              case mapCtorString2:
                return mapTag2;
              case promiseCtorString2:
                return promiseTag2;
              case setCtorString2:
                return setTag2;
              case weakMapCtorString2:
                return weakMapTag2;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size3 = data.size;
          switch (data.type) {
            case "drop":
              start += size3;
              break;
            case "dropRight":
              end -= size3;
              break;
            case "take":
              end = nativeMin(end, start + size3);
              break;
            case "takeRight":
              start = nativeMax2(start, end - size3);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match2 = source.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath2(object2, path2, hasFunc) {
        path2 = castPath2(path2, object2);
        var index2 = -1, length = path2.length, result2 = false;
        while (++index2 < length) {
          var key = toKey2(path2[index2]);
          if (!(result2 = object2 != null && hasFunc(object2, key))) {
            break;
          }
          object2 = object2[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object2 == null ? 0 : object2.length;
        return !!length && isLength2(length) && isIndex2(key, length) && (isArray3(object2) || isArguments2(object2));
      }
      function initCloneArray2(array2) {
        var length = array2.length, result2 = new array2.constructor(length);
        if (length && typeof array2[0] == "string" && hasOwnProperty2.call(array2, "index")) {
          result2.index = array2.index;
          result2.input = array2.input;
        }
        return result2;
      }
      function initCloneObject2(object2) {
        return typeof object2.constructor == "function" && !isPrototype2(object2) ? baseCreate2(getPrototype2(object2)) : {};
      }
      function initCloneByTag2(object2, tag, isDeep) {
        var Ctor = object2.constructor;
        switch (tag) {
          case arrayBufferTag2:
            return cloneArrayBuffer2(object2);
          case boolTag2:
          case dateTag2:
            return new Ctor(+object2);
          case dataViewTag2:
            return cloneDataView2(object2, isDeep);
          case float32Tag2:
          case float64Tag2:
          case int8Tag2:
          case int16Tag2:
          case int32Tag2:
          case uint8Tag2:
          case uint8ClampedTag2:
          case uint16Tag2:
          case uint32Tag2:
            return cloneTypedArray2(object2, isDeep);
          case mapTag2:
            return new Ctor();
          case numberTag2:
          case stringTag2:
            return new Ctor(object2);
          case regexpTag2:
            return cloneRegExp2(object2);
          case setTag2:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol2(object2);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable2(value) {
        return isArray3(value) || isArguments2(value) || !!(spreadableSymbol2 && value && value[spreadableSymbol2]);
      }
      function isIndex2(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER2 : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall2(value, index2, object2) {
        if (!isObject2(object2)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike2(object2) && isIndex2(index2, object2.length) : type == "string" && index2 in object2) {
          return eq2(object2[index2], value);
        }
        return false;
      }
      function isKey2(value, object2) {
        if (isArray3(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp2.test(value) || !reIsDeepProp2.test(value) || object2 != null && value in Object2(object2);
      }
      function isKeyable2(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked2(func) {
        return !!maskSrcKey2 && maskSrcKey2 in func;
      }
      var isMaskable = coreJsData2 ? isFunction2 : stubFalse2;
      function isPrototype2(value) {
        var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto2;
      }
      function isStrictComparable2(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable2(key, srcValue) {
        return function(object2) {
          if (object2 == null) {
            return false;
          }
          return object2[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object2));
        };
      }
      function memoizeCapped2(func) {
        var result2 = memoize2(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE2) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn2(object2) {
        var result2 = [];
        if (object2 != null) {
          for (var key in Object2(object2)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString2.call(value);
      }
      function overRest2(func, start, transform2) {
        start = nativeMax2(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax2(args.length - start, 0), array2 = Array2(length);
          while (++index2 < length) {
            array2[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array2);
          return apply2(func, this, otherArgs);
        };
      }
      function parent2(object2, path2) {
        return path2.length < 2 ? object2 : baseGet2(object2, baseSlice2(path2, 0, -1));
      }
      function reorder(array2, indexes) {
        var arrLength = array2.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray2(array2);
        while (length--) {
          var index2 = indexes[length];
          array2[length] = isIndex2(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array2;
      }
      function safeGet2(object2, key) {
        if (key === "constructor" && typeof object2[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object2[key];
      }
      var setData = shortOut2(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString2 = shortOut2(baseSetToString2);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString2(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut2(func) {
        var count2 = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow2(), remaining = HOT_SPAN2 - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count2 >= HOT_COUNT2) {
              return arguments[0];
            }
          } else {
            count2 = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array2, size3) {
        var index2 = -1, length = array2.length, lastIndex = length - 1;
        size3 = size3 === undefined$1 ? length : size3;
        while (++index2 < size3) {
          var rand = baseRandom(index2, lastIndex), value = array2[rand];
          array2[rand] = array2[index2];
          array2[index2] = value;
        }
        array2.length = size3;
        return array2;
      }
      var stringToPath2 = memoizeCapped2(function(string2) {
        var result2 = [];
        if (string2.charCodeAt(0) === 46) {
          result2.push("");
        }
        string2.replace(rePropName2, function(match2, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar2, "$1") : number || match2);
        });
        return result2;
      });
      function toKey2(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
      }
      function toSource2(func) {
        if (func != null) {
          try {
            return funcToString2.call(func);
          } catch (e3) {
          }
          try {
            return func + "";
          } catch (e3) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach2(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray2(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array2, size3, guard) {
        if (guard ? isIterateeCall2(array2, size3, guard) : size3 === undefined$1) {
          size3 = 1;
        } else {
          size3 = nativeMax2(toInteger(size3), 0);
        }
        var length = array2 == null ? 0 : array2.length;
        if (!length || size3 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size3));
        while (index2 < length) {
          result2[resIndex++] = baseSlice2(array2, index2, index2 += size3);
        }
        return result2;
      }
      function compact(array2) {
        var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array2[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array2 = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush2(isArray3(array2) ? copyArray2(array2) : [array2], baseFlatten2(args, 1));
      }
      var difference = baseRest2(function(array2, values2) {
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject2, true)) : [];
      });
      var differenceBy = baseRest2(function(array2, values2) {
        var iteratee2 = last2(values2);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest2(function(array2, values2) {
        var comparator = last2(values2);
        if (isArrayLikeObject2(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject2, true), undefined$1, comparator) : [];
      });
      function drop(array2, n2, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice2(array2, n2 < 0 ? 0 : n2, length);
      }
      function dropRight(array2, n2, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length - n2;
        return baseSlice2(array2, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true) : [];
      }
      function fill(array2, value, start, end) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall2(array2, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array2, value, start, end);
      }
      function findIndex(array2, predicate, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length + index2, 0);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array2, predicate, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index2, true);
      }
      function flatten2(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseFlatten2(array2, 1) : [];
      }
      function flattenDeep(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseFlatten2(array2, INFINITY) : [];
      }
      function flattenDepth(array2, depth) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten2(array2, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array2) {
        return array2 && array2.length ? array2[0] : undefined$1;
      }
      function indexOf(array2, value, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length + index2, 0);
        }
        return baseIndexOf(array2, value, index2);
      }
      function initial(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseSlice2(array2, 0, -1) : [];
      }
      var intersection = baseRest2(function(arrays) {
        var mapped = arrayMap2(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest2(function(arrays) {
        var iteratee2 = last2(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        if (iteratee2 === last2(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest2(function(arrays) {
        var comparator = last2(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join2(array2, separator) {
        return array2 == null ? "" : nativeJoin.call(array2, separator);
      }
      function last2(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? array2[length - 1] : undefined$1;
      }
      function lastIndexOf(array2, value, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array2, value, index2) : baseFindIndex(array2, baseIsNaN, index2, true);
      }
      function nth(array2, n2) {
        return array2 && array2.length ? baseNth(array2, toInteger(n2)) : undefined$1;
      }
      var pull = baseRest2(pullAll);
      function pullAll(array2, values2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2) : array2;
      }
      function pullAllBy(array2, values2, iteratee2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, getIteratee(iteratee2, 2)) : array2;
      }
      function pullAllWith(array2, values2, comparator) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, undefined$1, comparator) : array2;
      }
      var pullAt = flatRest2(function(array2, indexes) {
        var length = array2 == null ? 0 : array2.length, result2 = baseAt(array2, indexes);
        basePullAt(array2, arrayMap2(indexes, function(index2) {
          return isIndex2(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array2, predicate) {
        var result2 = [];
        if (!(array2 && array2.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array2.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array2[index2];
          if (predicate(value, index2, array2)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array2, indexes);
        return result2;
      }
      function reverse3(array2) {
        return array2 == null ? array2 : nativeReverse.call(array2);
      }
      function slice2(array2, start, end) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall2(array2, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice2(array2, start, end);
      }
      function sortedIndex(array2, value) {
        return baseSortedIndex(array2, value);
      }
      function sortedIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array2, value) {
        var length = array2 == null ? 0 : array2.length;
        if (length) {
          var index2 = baseSortedIndex(array2, value);
          if (index2 < length && eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array2, value) {
        return baseSortedIndex(array2, value, true);
      }
      function sortedLastIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array2, value) {
        var length = array2 == null ? 0 : array2.length;
        if (length) {
          var index2 = baseSortedIndex(array2, value, true) - 1;
          if (eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array2) {
        return array2 && array2.length ? baseSortedUniq(array2) : [];
      }
      function sortedUniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseSortedUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseSlice2(array2, 1, length) : [];
      }
      function take(array2, n2, guard) {
        if (!(array2 && array2.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice2(array2, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array2, n2, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length - n2;
        return baseSlice2(array2, n2 < 0 ? 0 : n2, length);
      }
      function takeRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest2(function(arrays) {
        return baseUniq(baseFlatten2(arrays, 1, isArrayLikeObject2, true));
      });
      var unionBy = baseRest2(function(arrays) {
        var iteratee2 = last2(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten2(arrays, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest2(function(arrays) {
        var comparator = last2(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten2(arrays, 1, isArrayLikeObject2, true), undefined$1, comparator);
      });
      function uniq(array2) {
        return array2 && array2.length ? baseUniq(array2) : [];
      }
      function uniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array2, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array2 && array2.length ? baseUniq(array2, undefined$1, comparator) : [];
      }
      function unzip(array2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var length = 0;
        array2 = arrayFilter2(array2, function(group) {
          if (isArrayLikeObject2(group)) {
            length = nativeMax2(group.length, length);
            return true;
          }
        });
        return baseTimes2(length, function(index2) {
          return arrayMap2(array2, baseProperty2(index2));
        });
      }
      function unzipWith(array2, iteratee2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var result2 = unzip(array2);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap2(result2, function(group) {
          return apply2(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest2(function(array2, values2) {
        return isArrayLikeObject2(array2) ? baseDifference(array2, values2) : [];
      });
      var xor = baseRest2(function(arrays) {
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2));
      });
      var xorBy = baseRest2(function(arrays) {
        var iteratee2 = last2(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest2(function(arrays) {
        var comparator = last2(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), undefined$1, comparator);
      });
      var zip = baseRest2(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue2);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet2);
      }
      var zipWith = baseRest2(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest2(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object2) {
          return baseAt(object2, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex2(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array2) {
          if (length && !array2.length) {
            array2.push(undefined$1);
          }
          return array2;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent3 = this;
        while (parent3 instanceof baseLodash) {
          var clone2 = wrapperClone(parent3);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$1;
          if (result2) {
            previous2.__wrapped__ = clone2;
          } else {
            result2 = clone2;
          }
          var previous2 = clone2;
          parent3 = parent3.__wrapped__;
        }
        previous2.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse3],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse3);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue2(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray3(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray3(collection) ? arrayFilter2 : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten2(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten2(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten2(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray3(collection) ? arrayEach2 : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray3(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue2(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike2(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest2(function(collection, path2, args) {
        var index2 = -1, isFunc = typeof path2 == "function", result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply2(path2, value, args) : baseInvoke(value, path2, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue2(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray3(collection) ? arrayMap2 : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray3(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray3(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray3(collection) ? arrayReduce2 : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray3(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray3(collection) ? arrayFilter2 : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray3(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall2(collection, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        var func = isArray3(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray3(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size2(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike2(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag2(collection);
        if (tag == mapTag2 || tag == setTag2) {
          return collection.size;
        }
        return baseKeys2(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray3(collection) ? arraySome2 : baseSome;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest2(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall2(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall2(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten2(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$1 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
      }
      function before(n2, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest2(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest2(function(object2, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object2, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax2(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest2(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest2(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip2(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver2) {
        if (typeof func != "function" || resolver2 != null && typeof resolver2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache2.set(key, result2) || cache2;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache2)();
        return memoized;
      }
      memoize2.Cache = MapCache2;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray3(transforms[0]) ? arrayMap2(transforms[0], baseUnary2(getIteratee())) : arrayMap2(baseFlatten2(transforms, 1), baseUnary2(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest2(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply2(func, this, args);
        });
      });
      var partial = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest2(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest2(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start == null ? 0 : nativeMax2(toInteger(start), 0);
        return baseRest2(function(args) {
          var array2 = args[start], otherArgs = castSlice(args, 0, start);
          if (array2) {
            arrayPush2(otherArgs, array2);
          }
          return apply2(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap2(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray3(value) ? value : [value];
      }
      function clone(value) {
        return baseClone2(value, CLONE_SYMBOLS_FLAG2);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_SYMBOLS_FLAG2, customizer);
      }
      function cloneDeep(value) {
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2, customizer);
      }
      function conformsTo(object2, source) {
        return source == null || baseConformsTo(object2, source, keys2(source));
      }
      function eq2(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments2 = baseIsArguments2(/* @__PURE__ */ function() {
        return arguments;
      }()) ? baseIsArguments2 : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
      };
      var isArray3 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary2(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike2(value) {
        return value != null && isLength2(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject2(value) {
        return isObjectLike2(value) && isArrayLike2(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag2(value) == boolTag2;
      }
      var isBuffer3 = nativeIsBuffer2 || stubFalse2;
      var isDate = nodeIsDate ? baseUnary2(nodeIsDate) : baseIsDate;
      function isElement2(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject3(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike2(value) && (isArray3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer3(value) || isTypedArray2(value) || isArguments2(value))) {
          return !value.length;
        }
        var tag = getTag2(value);
        if (tag == mapTag2 || tag == setTag2) {
          return !value.size;
        }
        if (isPrototype2(value)) {
          return !baseKeys2(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual2(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual2(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject3(value);
      }
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
      }
      function isInteger2(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength2(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap2 = nodeIsMap2 ? baseUnary2(nodeIsMap2) : baseIsMap2;
      function isMatch(object2, source) {
        return object2 === source || baseIsMatch2(object2, source, getMatchData2(source));
      }
      function isMatchWith(object2, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch2(object2, source, getMatchData2(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative2(value);
      }
      function isNull2(value) {
        return value === null;
      }
      function isNil2(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag2(value) == numberTag2;
      }
      function isPlainObject3(value) {
        if (!isObjectLike2(value) || baseGetTag2(value) != objectTag2) {
          return false;
        }
        var proto2 = getPrototype2(value);
        if (proto2 === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto2, "constructor") && proto2.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString2;
      }
      var isRegExp = nodeIsRegExp ? baseUnary2(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger2(value) && value >= -9007199254740991 && value <= MAX_SAFE_INTEGER2;
      }
      var isSet2 = nodeIsSet2 ? baseUnary2(nodeIsSet2) : baseIsSet2;
      function isString2(value) {
        return typeof value == "string" || !isArray3(value) && isObjectLike2(value) && baseGetTag2(value) == stringTag2;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
      }
      var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike2(value) && getTag2(value) == weakMapTag2;
      }
      function isWeakSet(value) {
        return isObjectLike2(value) && baseGetTag2(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike2(value)) {
          return isString2(value) ? stringToArray(value) : copyArray2(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag2(value), func = tag == mapTag2 ? mapToArray2 : tag == setTag2 ? setToArray2 : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -Infinity) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject2(value) {
        return copyObject2(value, keysIn2(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -9007199254740991, MAX_SAFE_INTEGER2) : value === 0 ? value : 0;
      }
      function toString2(value) {
        return value == null ? "" : baseToString2(value);
      }
      var assign2 = createAssigner2(function(object2, source) {
        if (isPrototype2(source) || isArrayLike2(source)) {
          copyObject2(source, keys2(source), object2);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue2(object2, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner2(function(object2, source) {
        copyObject2(source, keysIn2(source), object2);
      });
      var assignInWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        copyObject2(source, keysIn2(source), object2, customizer);
      });
      var assignWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        copyObject2(source, keys2(source), object2, customizer);
      });
      var at = flatRest2(baseAt);
      function create2(prototype, properties) {
        var result2 = baseCreate2(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults = baseRest2(function(object2, sources) {
        object2 = Object2(object2);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source = sources[index2];
          var props = keysIn2(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object2[key];
            if (value === undefined$1 || eq2(value, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
              object2[key] = source[key];
            }
          }
        }
        return object2;
      });
      var defaultsDeep = baseRest2(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply2(mergeWith, undefined$1, args);
      });
      function findKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwn2);
      }
      function findLastKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object2, iteratee2) {
        return object2 == null ? object2 : baseFor2(object2, getIteratee(iteratee2, 3), keysIn2);
      }
      function forInRight(object2, iteratee2) {
        return object2 == null ? object2 : baseForRight(object2, getIteratee(iteratee2, 3), keysIn2);
      }
      function forOwn(object2, iteratee2) {
        return object2 && baseForOwn2(object2, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object2, iteratee2) {
        return object2 && baseForOwnRight(object2, getIteratee(iteratee2, 3));
      }
      function functions(object2) {
        return object2 == null ? [] : baseFunctions(object2, keys2(object2));
      }
      function functionsIn(object2) {
        return object2 == null ? [] : baseFunctions(object2, keysIn2(object2));
      }
      function get2(object2, path2, defaultValue) {
        var result2 = object2 == null ? undefined$1 : baseGet2(object2, path2);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has2(object2, path2) {
        return object2 != null && hasPath2(object2, path2, baseHas);
      }
      function hasIn2(object2, path2) {
        return object2 != null && hasPath2(object2, path2, baseHasIn2);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        result2[value] = key;
      }, constant2(identity2));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest2(baseInvoke);
      function keys2(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
      }
      function keysIn2(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2, true) : baseKeysIn2(object2);
      }
      function mapKeys(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, iteratee2(value, key, object3), value);
        });
        return result2;
      }
      function mapValues2(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, key, iteratee2(value, key, object3));
        });
        return result2;
      }
      var merge2 = createAssigner2(function(object2, source, srcIndex) {
        baseMerge2(object2, source, srcIndex);
      });
      var mergeWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        baseMerge2(object2, source, srcIndex, customizer);
      });
      var omit2 = flatRest2(function(object2, paths) {
        var result2 = {};
        if (object2 == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap2(paths, function(path2) {
          path2 = castPath2(path2, object2);
          isDeep || (isDeep = path2.length > 1);
          return path2;
        });
        copyObject2(object2, getAllKeysIn2(object2), result2);
        if (isDeep) {
          result2 = baseClone2(result2, CLONE_DEEP_FLAG2 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG2, customOmitClone2);
        }
        var length = paths.length;
        while (length--) {
          baseUnset2(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object2, predicate) {
        return pickBy(object2, negate(getIteratee(predicate)));
      }
      var pick2 = flatRest2(function(object2, paths) {
        return object2 == null ? {} : basePick2(object2, paths);
      });
      function pickBy(object2, predicate) {
        if (object2 == null) {
          return {};
        }
        var props = arrayMap2(getAllKeysIn2(object2), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy2(object2, props, function(value, path2) {
          return predicate(value, path2[0]);
        });
      }
      function result(object2, path2, defaultValue) {
        path2 = castPath2(path2, object2);
        var index2 = -1, length = path2.length;
        if (!length) {
          length = 1;
          object2 = undefined$1;
        }
        while (++index2 < length) {
          var value = object2 == null ? undefined$1 : object2[toKey2(path2[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object2 = isFunction2(value) ? value.call(object2) : value;
        }
        return object2;
      }
      function set2(object2, path2, value) {
        return object2 == null ? object2 : baseSet2(object2, path2, value);
      }
      function setWith(object2, path2, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseSet2(object2, path2, value, customizer);
      }
      var toPairs2 = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn2);
      function transform(object2, iteratee2, accumulator) {
        var isArr = isArray3(object2), isArrLike = isArr || isBuffer3(object2) || isTypedArray2(object2);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object2 && object2.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object2)) {
            accumulator = isFunction2(Ctor) ? baseCreate2(getPrototype2(object2)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach2 : baseForOwn2)(object2, function(value, index2, object3) {
          return iteratee2(accumulator, value, index2, object3);
        });
        return accumulator;
      }
      function unset(object2, path2) {
        return object2 == null ? true : baseUnset2(object2, path2);
      }
      function update(object2, path2, updater) {
        return object2 == null ? object2 : baseUpdate(object2, path2, castFunction(updater));
      }
      function updateWith(object2, path2, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseUpdate(object2, path2, castFunction(updater), customizer);
      }
      function values(object2) {
        return object2 == null ? [] : baseValues(object2, keys2(object2));
      }
      function valuesIn(object2) {
        return object2 == null ? [] : baseValues(object2, keysIn2(object2));
      }
      function clamp2(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall2(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder2(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string2) {
        return upperFirst(toString2(string2).toLowerCase());
      }
      function deburr2(string2) {
        string2 = toString2(string2);
        return string2 && string2.replace(reLatin2, deburrLetter2).replace(reComboMark2, "");
      }
      function endsWith(string2, target, position2) {
        string2 = toString2(string2);
        target = baseToString2(target);
        var length = string2.length;
        position2 = position2 === undefined$1 ? length : baseClamp(toInteger(position2), 0, length);
        var end = position2;
        position2 -= target.length;
        return position2 >= 0 && string2.slice(position2, end) == target;
      }
      function escape2(string2) {
        string2 = toString2(string2);
        return string2 && reHasUnescapedHtml.test(string2) ? string2.replace(reUnescapedHtml, escapeHtmlChar) : string2;
      }
      function escapeRegExp(string2) {
        string2 = toString2(string2);
        return string2 && reHasRegExpChar.test(string2) ? string2.replace(reRegExpChar2, "\\$&") : string2;
      }
      var kebabCase2 = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string2, length, chars) {
        string2 = toString2(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        if (!length || strLength >= length) {
          return string2;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string2 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string2, length, chars) {
        string2 = toString2(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? string2 + createPadding(length - strLength, chars) : string2;
      }
      function padStart(string2, length, chars) {
        string2 = toString2(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string2 : string2;
      }
      function parseInt2(string2, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString2(string2).replace(reTrimStart, ""), radix || 0);
      }
      function repeat2(string2, n2, guard) {
        if (guard ? isIterateeCall2(string2, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        return baseRepeat(toString2(string2), n2);
      }
      function replace2() {
        var args = arguments, string2 = toString2(args[0]);
        return args.length < 3 ? string2 : string2.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string2, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall2(string2, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string2 = toString2(string2);
        if (string2 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString2(separator);
          if (!separator && hasUnicode(string2)) {
            return castSlice(stringToArray(string2), 0, limit);
          }
        }
        return string2.split(separator, limit);
      }
      var startCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string2, target, position2) {
        string2 = toString2(string2);
        position2 = position2 == null ? 0 : baseClamp(toInteger(position2), 0, string2.length);
        target = baseToString2(target);
        return string2.slice(position2, position2 + target.length) == target;
      }
      function template(string2, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall2(string2, options, guard)) {
          options = undefined$1;
        }
        string2 = toString2(string2);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string2.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string2.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset2 + match2.length;
          return match2;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString2(value).toLowerCase();
      }
      function toUpper(value) {
        return toString2(value).toUpperCase();
      }
      function trim(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return baseTrim(string2);
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.slice(0, trimmedEndIndex(string2) + 1);
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.replace(reTrimStart, "");
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string2, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString2(options.omission) : omission;
        }
        string2 = toString2(string2);
        var strLength = string2.length;
        if (hasUnicode(string2)) {
          var strSymbols = stringToArray(string2);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string2;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string2.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string2.slice(end).search(separator)) {
            var match2, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString2(reFlags2.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring)) {
              var newEnd = match2.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string2.indexOf(baseToString2(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape(string2) {
        string2 = toString2(string2);
        return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
      }
      var upperCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words2(string2, pattern, guard) {
        string2 = toString2(string2);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord2(string2) ? unicodeWords2(string2) : asciiWords2(string2);
        }
        return string2.match(pattern) || [];
      }
      var attempt = baseRest2(function(func, args) {
        try {
          return apply2(func, undefined$1, args);
        } catch (e3) {
          return isError(e3) ? e3 : new Error2(e3);
        }
      });
      var bindAll = flatRest2(function(object2, methodNames) {
        arrayEach2(methodNames, function(key) {
          key = toKey2(key);
          baseAssignValue2(object2, key, bind(object2[key], object2));
        });
        return object2;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap2(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest2(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply2(pair[0], this, args)) {
              return apply2(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function constant2(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow2 = createFlow();
      var flowRight = createFlow(true);
      function identity2(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee2(typeof func == "function" ? func : baseClone2(func, CLONE_DEEP_FLAG2));
      }
      function matches2(source) {
        return baseMatches2(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function matchesProperty(path2, srcValue) {
        return baseMatchesProperty2(path2, baseClone2(srcValue, CLONE_DEEP_FLAG2));
      }
      var method = baseRest2(function(path2, args) {
        return function(object2) {
          return baseInvoke(object2, path2, args);
        };
      });
      var methodOf = baseRest2(function(object2, args) {
        return function(path2) {
          return baseInvoke(object2, path2, args);
        };
      });
      function mixin(object2, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object2;
          object2 = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object2);
        arrayEach2(methodNames, function(methodName) {
          var func = source[methodName];
          object2[methodName] = func;
          if (isFunc) {
            object2.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object2(this.__wrapped__), actions = result2.__actions__ = copyArray2(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object2 });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object2, arrayPush2([this.value()], arguments));
            };
          }
        });
        return object2;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop2() {
      }
      function nthArg(n2) {
        n2 = toInteger(n2);
        return baseRest2(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap2);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome2);
      function property2(path2) {
        return isKey2(path2) ? baseProperty2(toKey2(path2)) : basePropertyDeep2(path2);
      }
      function propertyOf(object2) {
        return function(path2) {
          return object2 == null ? undefined$1 : baseGet2(object2, path2);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray2() {
        return [];
      }
      function stubFalse2() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes2(length, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray3(value)) {
          return arrayMap2(value, toKey2);
        }
        return isSymbol2(value) ? [value] : copyArray2(stringToPath2(toString2(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString2(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor2 = createRound("floor");
      function max2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseGt) : undefined$1;
      }
      function maxBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array2) {
        return baseMean(array2, identity2);
      }
      function meanBy(array2, iteratee2) {
        return baseMean(array2, getIteratee(iteratee2, 2));
      }
      function min2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseLt) : undefined$1;
      }
      function minBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array2) {
        return array2 && array2.length ? baseSum(array2, identity2) : 0;
      }
      function sumBy(array2, iteratee2) {
        return array2 && array2.length ? baseSum(array2, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant2;
      lodash2.countBy = countBy;
      lodash2.create = create2;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten2;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip2;
      lodash2.flow = flow2;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn2;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues2;
      lodash2.matches = matches2;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit2;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick2;
      lodash2.pickBy = pickBy;
      lodash2.property = property2;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse3;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray;
      lodash2.toPairs = toPairs2;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject2;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words2;
      lodash2.wrap = wrap2;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs2;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp2;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr2;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq2;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor2;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn2;
      lodash2.head = head;
      lodash2.identity = identity2;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments2;
      lodash2.isArray = isArray3;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike2;
      lodash2.isArrayLikeObject = isArrayLikeObject2;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer3;
      lodash2.isDate = isDate;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger2;
      lodash2.isLength = isLength2;
      lodash2.isMap = isMap2;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil2;
      lodash2.isNull = isNull2;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject3;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet2;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join2;
      lodash2.kebabCase = kebabCase2;
      lodash2.last = last2;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray2;
      lodash2.stubFalse = stubFalse2;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop2;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat2;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size2;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString2;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn2(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach2(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$1 ? 1 : nativeMax2(toInteger(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach2(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach2(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach2(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity2);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest2(function(path2, args) {
        if (typeof path2 == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path2, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray3(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush2([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach2(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray3(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray3(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule2) {
      (freeModule2.exports = _2)._ = _2;
      freeExports2._ = _2;
    } else {
      root2._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
var own$5 = {}.hasOwnProperty;
var hasOwnProperty$1 = own$5;
var splice$2 = [].splice;
var splice_1 = splice$2;
var splice$1 = splice_1;
function chunkedSplice$9(list2, start, remove, items) {
  var end = list2.length;
  var chunkStart = 0;
  var parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    splice$1.apply(list2, parameters);
  } else {
    if (remove) splice$1.apply(list2, [start, remove]);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      splice$1.apply(list2, parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
var chunkedSplice_1 = chunkedSplice$9;
function miniflat$3(value) {
  return value === null || value === void 0 ? [] : "length" in value ? value : [value];
}
var miniflat_1 = miniflat$3;
var hasOwnProperty = hasOwnProperty$1;
var chunkedSplice$8 = chunkedSplice_1;
var miniflat$2 = miniflat_1;
function combineExtensions$1(extensions) {
  var all2 = {};
  var index2 = -1;
  while (++index2 < extensions.length) {
    extension$2(all2, extensions[index2]);
  }
  return all2;
}
function extension$2(all2, extension2) {
  var hook;
  var left;
  var right;
  var code2;
  for (hook in extension2) {
    left = hasOwnProperty.call(all2, hook) ? all2[hook] : all2[hook] = {};
    right = extension2[hook];
    for (code2 in right) {
      left[code2] = constructs$2(
        miniflat$2(right[code2]),
        hasOwnProperty.call(left, code2) ? left[code2] : []
      );
    }
  }
}
function constructs$2(list2, existing) {
  var index2 = -1;
  var before = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before).push(list2[index2]);
  }
  chunkedSplice$8(existing, 0, 0, before);
  return existing;
}
var combineExtensions_1 = combineExtensions$1;
var syntax$4 = {};
var fromCharCode$4 = String.fromCharCode;
var fromCharCode_1 = fromCharCode$4;
var fromCharCode$3 = fromCharCode_1;
function regexCheck$8(regex) {
  return check;
  function check(code2) {
    return regex.test(fromCharCode$3(code2));
  }
}
var regexCheck_1 = regexCheck$8;
var regexCheck$7 = regexCheck_1;
var asciiAlpha$4 = regexCheck$7(/[A-Za-z]/);
var asciiAlpha_1 = asciiAlpha$4;
var regexCheck$6 = regexCheck_1;
var asciiAlphanumeric$5 = regexCheck$6(/[\dA-Za-z]/);
var asciiAlphanumeric_1 = asciiAlphanumeric$5;
function asciiControl$3(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 < 32 || code2 === 127
  );
}
var asciiControl_1 = asciiControl$3;
function markdownLineEnding$k(code2) {
  return code2 < -2;
}
var markdownLineEnding_1 = markdownLineEnding$k;
var unicodePunctuation$4 = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var unicodePunctuationRegex$1 = unicodePunctuation$4;
var unicodePunctuationRegex = unicodePunctuationRegex$1;
var regexCheck$5 = regexCheck_1;
var unicodePunctuation$3 = regexCheck$5(unicodePunctuationRegex);
var unicodePunctuation_1 = unicodePunctuation$3;
var regexCheck$4 = regexCheck_1;
var unicodeWhitespace$3 = regexCheck$4(/\s/);
var unicodeWhitespace_1 = unicodeWhitespace$3;
var asciiAlpha$3 = asciiAlpha_1;
var asciiAlphanumeric$4 = asciiAlphanumeric_1;
var asciiControl$2 = asciiControl_1;
var markdownLineEnding$j = markdownLineEnding_1;
var unicodePunctuation$2 = unicodePunctuation_1;
var unicodeWhitespace$2 = unicodeWhitespace_1;
var www = { tokenize: tokenizeWww, partial: true };
var domain = { tokenize: tokenizeDomain, partial: true };
var path = { tokenize: tokenizePath, partial: true };
var punctuation = { tokenize: tokenizePunctuation, partial: true };
var namedCharacterReference = {
  tokenize: tokenizeNamedCharacterReference,
  partial: true
};
var wwwAutolink = { tokenize: tokenizeWwwAutolink, previous: previousWww };
var httpAutolink = { tokenize: tokenizeHttpAutolink, previous: previousHttp };
var emailAutolink = { tokenize: tokenizeEmailAutolink, previous: previousEmail };
var text$5 = {};
syntax$4.text = text$5;
var code = 48;
while (code < 123) {
  text$5[code] = emailAutolink;
  code++;
  if (code === 58) code = 65;
  else if (code === 91) code = 97;
}
text$5[43] = emailAutolink;
text$5[45] = emailAutolink;
text$5[46] = emailAutolink;
text$5[95] = emailAutolink;
text$5[72] = [emailAutolink, httpAutolink];
text$5[104] = [emailAutolink, httpAutolink];
text$5[87] = [emailAutolink, wwwAutolink];
text$5[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok2, nok) {
  var self2 = this;
  var hasDot;
  return start;
  function start(code2) {
    if (!gfmAtext(code2) || !previousEmail(self2.previous) || previous$2(self2.events)) {
      return nok(code2);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkEmail");
    return atext(code2);
  }
  function atext(code2) {
    if (gfmAtext(code2)) {
      effects.consume(code2);
      return atext;
    }
    if (code2 === 64) {
      effects.consume(code2);
      return label;
    }
    return nok(code2);
  }
  function label(code2) {
    if (code2 === 46) {
      return effects.check(punctuation, done, dotContinuation)(code2);
    }
    if (
      // `-`
      code2 === 45 || // `_`
      code2 === 95
    ) {
      return effects.check(punctuation, nok, dashOrUnderscoreContinuation)(code2);
    }
    if (asciiAlphanumeric$4(code2)) {
      effects.consume(code2);
      return label;
    }
    return done(code2);
  }
  function dotContinuation(code2) {
    effects.consume(code2);
    hasDot = true;
    return label;
  }
  function dashOrUnderscoreContinuation(code2) {
    effects.consume(code2);
    return afterDashOrUnderscore;
  }
  function afterDashOrUnderscore(code2) {
    if (code2 === 46) {
      return effects.check(punctuation, nok, dotContinuation)(code2);
    }
    return label(code2);
  }
  function done(code2) {
    if (hasDot) {
      effects.exit("literalAutolinkEmail");
      effects.exit("literalAutolink");
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeWwwAutolink(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    if (code2 !== 87 && code2 - 32 !== 87 || !previousWww(self2.previous) || previous$2(self2.events)) {
      return nok(code2);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkWww");
    return effects.check(
      www,
      effects.attempt(domain, effects.attempt(path, done), nok),
      nok
    )(code2);
  }
  function done(code2) {
    effects.exit("literalAutolinkWww");
    effects.exit("literalAutolink");
    return ok2(code2);
  }
}
function tokenizeHttpAutolink(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    if (code2 !== 72 && code2 - 32 !== 72 || !previousHttp(self2.previous) || previous$2(self2.events)) {
      return nok(code2);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkHttp");
    effects.consume(code2);
    return t1;
  }
  function t1(code2) {
    if (code2 === 84 || code2 - 32 === 84) {
      effects.consume(code2);
      return t2;
    }
    return nok(code2);
  }
  function t2(code2) {
    if (code2 === 84 || code2 - 32 === 84) {
      effects.consume(code2);
      return p2;
    }
    return nok(code2);
  }
  function p2(code2) {
    if (code2 === 80 || code2 - 32 === 80) {
      effects.consume(code2);
      return s2;
    }
    return nok(code2);
  }
  function s2(code2) {
    if (code2 === 83 || code2 - 32 === 83) {
      effects.consume(code2);
      return colon2;
    }
    return colon2(code2);
  }
  function colon2(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      return slash1;
    }
    return nok(code2);
  }
  function slash1(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return slash2;
    }
    return nok(code2);
  }
  function slash2(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return asciiControl$2(code2) || unicodeWhitespace$2(code2) || unicodePunctuation$2(code2) ? nok(code2) : effects.attempt(domain, effects.attempt(path, done), nok)(code2);
  }
  function done(code2) {
    effects.exit("literalAutolinkHttp");
    effects.exit("literalAutolink");
    return ok2(code2);
  }
}
function tokenizeWww(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.consume(code2);
    return w2;
  }
  function w2(code2) {
    if (code2 === 87 || code2 - 32 === 87) {
      effects.consume(code2);
      return w3;
    }
    return nok(code2);
  }
  function w3(code2) {
    if (code2 === 87 || code2 - 32 === 87) {
      effects.consume(code2);
      return dot;
    }
    return nok(code2);
  }
  function dot(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return code2 === null || markdownLineEnding$j(code2) ? nok(code2) : ok2(code2);
  }
}
function tokenizeDomain(effects, ok2, nok) {
  var hasUnderscoreInLastSegment;
  var hasUnderscoreInLastLastSegment;
  return domain2;
  function domain2(code2) {
    if (code2 === 38) {
      return effects.check(
        namedCharacterReference,
        done,
        punctuationContinuation
      )(code2);
    }
    if (code2 === 46 || code2 === 95) {
      return effects.check(punctuation, done, punctuationContinuation)(code2);
    }
    if (asciiControl$2(code2) || unicodeWhitespace$2(code2) || code2 !== 45 && unicodePunctuation$2(code2)) {
      return done(code2);
    }
    effects.consume(code2);
    return domain2;
  }
  function punctuationContinuation(code2) {
    if (code2 === 46) {
      hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
      hasUnderscoreInLastSegment = void 0;
      effects.consume(code2);
      return domain2;
    }
    if (code2 === 95) hasUnderscoreInLastSegment = true;
    effects.consume(code2);
    return domain2;
  }
  function done(code2) {
    if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) {
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizePath(effects, ok2) {
  var balance = 0;
  return inPath;
  function inPath(code2) {
    if (code2 === 38) {
      return effects.check(
        namedCharacterReference,
        ok2,
        continuedPunctuation
      )(code2);
    }
    if (code2 === 40) {
      balance++;
    }
    if (code2 === 41) {
      return effects.check(
        punctuation,
        parenAtPathEnd,
        continuedPunctuation
      )(code2);
    }
    if (pathEnd(code2)) {
      return ok2(code2);
    }
    if (trailingPunctuation(code2)) {
      return effects.check(punctuation, ok2, continuedPunctuation)(code2);
    }
    effects.consume(code2);
    return inPath;
  }
  function continuedPunctuation(code2) {
    effects.consume(code2);
    return inPath;
  }
  function parenAtPathEnd(code2) {
    balance--;
    return balance < 0 ? ok2(code2) : continuedPunctuation(code2);
  }
}
function tokenizeNamedCharacterReference(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.consume(code2);
    return inside;
  }
  function inside(code2) {
    if (asciiAlpha$3(code2)) {
      effects.consume(code2);
      return inside;
    }
    if (code2 === 59) {
      effects.consume(code2);
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return pathEnd(code2) ? ok2(code2) : nok(code2);
  }
}
function tokenizePunctuation(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.consume(code2);
    return after;
  }
  function after(code2) {
    if (trailingPunctuation(code2)) {
      effects.consume(code2);
      return after;
    }
    return pathEnd(code2) ? ok2(code2) : nok(code2);
  }
}
function trailingPunctuation(code2) {
  return (
    // `!`
    code2 === 33 || // `"`
    code2 === 34 || // `'`
    code2 === 39 || // `)`
    code2 === 41 || // `*`
    code2 === 42 || // `,`
    code2 === 44 || // `.`
    code2 === 46 || // `:`
    code2 === 58 || // `;`
    code2 === 59 || // `<`
    code2 === 60 || // `?`
    code2 === 63 || // `_`.
    code2 === 95 || // `~`
    code2 === 126
  );
}
function pathEnd(code2) {
  return (
    // EOF.
    code2 === null || // CR, LF, CRLF, HT, VS.
    code2 < 0 || // Space.
    code2 === 32 || // `<`
    code2 === 60
  );
}
function gfmAtext(code2) {
  return code2 === 43 || code2 === 45 || code2 === 46 || code2 === 95 || asciiAlphanumeric$4(code2);
}
function previousWww(code2) {
  return code2 === null || code2 < 0 || code2 === 32 || code2 === 40 || code2 === 42 || code2 === 95 || code2 === 126;
}
function previousHttp(code2) {
  return code2 === null || !asciiAlpha$3(code2);
}
function previousEmail(code2) {
  return code2 !== 47 && previousHttp(code2);
}
function previous$2(events) {
  var index2 = events.length;
  while (index2--) {
    if ((events[index2][1].type === "labelLink" || events[index2][1].type === "labelImage") && !events[index2][1]._balanced) {
      return true;
    }
  }
}
var micromarkExtensionGfmAutolinkLiteral = syntax$4;
function markdownLineEndingOrSpace$9(code2) {
  return code2 < 0 || code2 === 32;
}
var markdownLineEndingOrSpace_1 = markdownLineEndingOrSpace$9;
var markdownLineEndingOrSpace$8 = markdownLineEndingOrSpace_1;
var unicodePunctuation$1 = unicodePunctuation_1;
var unicodeWhitespace$1 = unicodeWhitespace_1;
function classifyCharacter$2(code2) {
  if (code2 === null || markdownLineEndingOrSpace$8(code2) || unicodeWhitespace$1(code2)) {
    return 1;
  }
  if (unicodePunctuation$1(code2)) {
    return 2;
  }
}
var classifyCharacter_1 = classifyCharacter$2;
function resolveAll$4(constructs2, events, context) {
  var called = [];
  var index2 = -1;
  var resolve;
  while (++index2 < constructs2.length) {
    resolve = constructs2[index2].resolveAll;
    if (resolve && called.indexOf(resolve) < 0) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }
  return events;
}
var resolveAll_1 = resolveAll$4;
var assign$5 = Object.assign;
var assign_1 = assign$5;
var assign$4 = assign_1;
function shallow$7(object2) {
  return assign$4({}, object2);
}
var shallow_1 = shallow$7;
var micromarkExtensionGfmStrikethrough = create$1;
var classifyCharacter$1 = classifyCharacter_1;
var chunkedSplice$7 = chunkedSplice_1;
var resolveAll$3 = resolveAll_1;
var shallow$6 = shallow_1;
function create$1(options) {
  var settings = options || {};
  var single = settings.singleTilde;
  var tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === void 0) {
    single = true;
  }
  return { text: { 126: tokenizer }, insideSpan: { null: tokenizer } };
  function resolveAllStrikethrough(events, context) {
    var index2 = -1;
    var strikethrough2;
    var text2;
    var open;
    var nextEvents;
    while (++index2 < events.length) {
      if (events[index2][0] === "enter" && events[index2][1].type === "strikethroughSequenceTemporary" && events[index2][1]._close) {
        open = index2;
        while (open--) {
          if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
          events[index2][1].end.offset - events[index2][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
            events[index2][1].type = "strikethroughSequence";
            events[open][1].type = "strikethroughSequence";
            strikethrough2 = {
              type: "strikethrough",
              start: shallow$6(events[open][1].start),
              end: shallow$6(events[index2][1].end)
            };
            text2 = {
              type: "strikethroughText",
              start: shallow$6(events[open][1].end),
              end: shallow$6(events[index2][1].start)
            };
            nextEvents = [
              ["enter", strikethrough2, context],
              ["enter", events[open][1], context],
              ["exit", events[open][1], context],
              ["enter", text2, context]
            ];
            chunkedSplice$7(
              nextEvents,
              nextEvents.length,
              0,
              resolveAll$3(
                context.parser.constructs.insideSpan.null,
                events.slice(open + 1, index2),
                context
              )
            );
            chunkedSplice$7(nextEvents, nextEvents.length, 0, [
              ["exit", text2, context],
              ["enter", events[index2][1], context],
              ["exit", events[index2][1], context],
              ["exit", strikethrough2, context]
            ]);
            chunkedSplice$7(events, open - 1, index2 - open + 3, nextEvents);
            index2 = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    return removeRemainingSequences(events);
  }
  function removeRemainingSequences(events) {
    var index2 = -1;
    var length = events.length;
    while (++index2 < length) {
      if (events[index2][1].type === "strikethroughSequenceTemporary") {
        events[index2][1].type = "data";
      }
    }
    return events;
  }
  function tokenizeStrikethrough(effects, ok2, nok) {
    var previous2 = this.previous;
    var events = this.events;
    var size2 = 0;
    return start;
    function start(code2) {
      if (code2 !== 126 || previous2 === 126 && events[events.length - 1][1].type !== "characterEscape") {
        return nok(code2);
      }
      effects.enter("strikethroughSequenceTemporary");
      return more(code2);
    }
    function more(code2) {
      var before = classifyCharacter$1(previous2);
      var token;
      var after;
      if (code2 === 126) {
        if (size2 > 1) return nok(code2);
        effects.consume(code2);
        size2++;
        return more;
      }
      if (size2 < 2 && !single) return nok(code2);
      token = effects.exit("strikethroughSequenceTemporary");
      after = classifyCharacter$1(code2);
      token._open = !after || after === 2 && before;
      token._close = !before || before === 2 && after;
      return ok2(code2);
    }
  }
}
var syntax$3 = {};
function markdownSpace$9(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
var markdownSpace_1 = markdownSpace$9;
var markdownSpace$8 = markdownSpace_1;
function spaceFactory$1(effects, ok2, type, max2) {
  var limit = max2 ? max2 - 1 : Infinity;
  var size2 = 0;
  return start;
  function start(code2) {
    if (markdownSpace$8(code2)) {
      effects.enter(type);
      return prefix(code2);
    }
    return ok2(code2);
  }
  function prefix(code2) {
    if (markdownSpace$8(code2) && size2++ < limit) {
      effects.consume(code2);
      return prefix;
    }
    effects.exit(type);
    return ok2(code2);
  }
}
var factorySpace$h = spaceFactory$1;
syntax$3.flow = {
  null: { tokenize: tokenizeTable, resolve: resolveTable, interruptible: true }
};
var createSpace = factorySpace$h;
var setextUnderlineMini = { tokenize: tokenizeSetextUnderlineMini, partial: true };
var nextPrefixedOrBlank = { tokenize: tokenizeNextPrefixedOrBlank, partial: true };
function resolveTable(events, context) {
  var length = events.length;
  var index2 = -1;
  var token;
  var inHead;
  var inDelimiterRow;
  var inRow;
  var cell;
  var content2;
  var text2;
  var contentStart;
  var contentEnd;
  var cellStart;
  while (++index2 < length) {
    token = events[index2][1];
    if (inRow) {
      if (token.type === "temporaryTableCellContent") {
        contentStart = contentStart || index2;
        contentEnd = index2;
      }
      if (
        // Combine separate content parts into one.
        (token.type === "tableCellDivider" || token.type === "tableRow") && contentEnd
      ) {
        content2 = {
          type: "tableContent",
          start: events[contentStart][1].start,
          end: events[contentEnd][1].end
        };
        text2 = {
          type: "chunkText",
          start: content2.start,
          end: content2.end,
          contentType: "text"
        };
        events.splice(
          contentStart,
          contentEnd - contentStart + 1,
          ["enter", content2, context],
          ["enter", text2, context],
          ["exit", text2, context],
          ["exit", content2, context]
        );
        index2 -= contentEnd - contentStart - 3;
        length = events.length;
        contentStart = void 0;
        contentEnd = void 0;
      }
    }
    if (events[index2][0] === "exit" && cellStart && cellStart + 1 < index2 && (token.type === "tableCellDivider" || token.type === "tableRow" && (cellStart + 3 < index2 || events[cellStart][1].type !== "whitespace"))) {
      cell = {
        type: inDelimiterRow ? "tableDelimiter" : inHead ? "tableHeader" : "tableData",
        start: events[cellStart][1].start,
        end: events[index2][1].end
      };
      events.splice(index2 + (token.type === "tableCellDivider" ? 1 : 0), 0, [
        "exit",
        cell,
        context
      ]);
      events.splice(cellStart, 0, ["enter", cell, context]);
      index2 += 2;
      length = events.length;
      cellStart = index2 + 1;
    }
    if (token.type === "tableRow") {
      inRow = events[index2][0] === "enter";
      if (inRow) {
        cellStart = index2 + 1;
      }
    }
    if (token.type === "tableDelimiterRow") {
      inDelimiterRow = events[index2][0] === "enter";
      if (inDelimiterRow) {
        cellStart = index2 + 1;
      }
    }
    if (token.type === "tableHead") {
      inHead = events[index2][0] === "enter";
    }
  }
  return events;
}
function tokenizeTable(effects, ok2, nok) {
  var align = [];
  var tableHeaderCount = 0;
  var seenDelimiter;
  var hasDash;
  return start;
  function start(code2) {
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return nok(code2);
    }
    effects.enter("table")._align = align;
    effects.enter("tableHead");
    effects.enter("tableRow");
    if (code2 === 124) {
      return cellDividerHead(code2);
    }
    tableHeaderCount++;
    effects.enter("temporaryTableCellContent");
    return inCellContentHead(code2);
  }
  function cellDividerHead(code2) {
    effects.enter("tableCellDivider");
    effects.consume(code2);
    effects.exit("tableCellDivider");
    seenDelimiter = true;
    return cellBreakHead;
  }
  function cellBreakHead(code2) {
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return atRowEndHead(code2);
    }
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.enter("whitespace");
      effects.consume(code2);
      return inWhitespaceHead;
    }
    if (seenDelimiter) {
      seenDelimiter = void 0;
      tableHeaderCount++;
    }
    if (code2 === 124) {
      return cellDividerHead(code2);
    }
    effects.enter("temporaryTableCellContent");
    return inCellContentHead(code2);
  }
  function inWhitespaceHead(code2) {
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.consume(code2);
      return inWhitespaceHead;
    }
    effects.exit("whitespace");
    return cellBreakHead(code2);
  }
  function inCellContentHead(code2) {
    if (code2 === null || code2 < 0 || code2 === 32 || code2 === 124) {
      effects.exit("temporaryTableCellContent");
      return cellBreakHead(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? inCellContentEscapeHead : inCellContentHead;
  }
  function inCellContentEscapeHead(code2) {
    if (code2 === 92 || code2 === 124) {
      effects.consume(code2);
      return inCellContentHead;
    }
    return inCellContentHead(code2);
  }
  function atRowEndHead(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.exit("tableRow");
    effects.exit("tableHead");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.check(
      setextUnderlineMini,
      nok,
      // Support an indent before the delimiter row.
      createSpace(effects, rowStartDelimiter, "linePrefix", 4)
    );
  }
  function rowStartDelimiter(code2) {
    if (code2 === null || code2 < 0 || code2 === 32) {
      return nok(code2);
    }
    effects.enter("tableDelimiterRow");
    return atDelimiterRowBreak(code2);
  }
  function atDelimiterRowBreak(code2) {
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return rowEndDelimiter(code2);
    }
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.enter("whitespace");
      effects.consume(code2);
      return inWhitespaceDelimiter;
    }
    if (code2 === 45) {
      effects.enter("tableDelimiterFiller");
      effects.consume(code2);
      hasDash = true;
      align.push(null);
      return inFillerDelimiter;
    }
    if (code2 === 58) {
      effects.enter("tableDelimiterAlignment");
      effects.consume(code2);
      effects.exit("tableDelimiterAlignment");
      align.push("left");
      return afterLeftAlignment;
    }
    if (code2 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code2);
      effects.exit("tableCellDivider");
      return atDelimiterRowBreak;
    }
    return nok(code2);
  }
  function inWhitespaceDelimiter(code2) {
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.consume(code2);
      return inWhitespaceDelimiter;
    }
    effects.exit("whitespace");
    return atDelimiterRowBreak(code2);
  }
  function inFillerDelimiter(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return inFillerDelimiter;
    }
    effects.exit("tableDelimiterFiller");
    if (code2 === 58) {
      effects.enter("tableDelimiterAlignment");
      effects.consume(code2);
      effects.exit("tableDelimiterAlignment");
      align[align.length - 1] = align[align.length - 1] === "left" ? "center" : "right";
      return afterRightAlignment;
    }
    return atDelimiterRowBreak(code2);
  }
  function afterLeftAlignment(code2) {
    if (code2 === 45) {
      effects.enter("tableDelimiterFiller");
      effects.consume(code2);
      hasDash = true;
      return inFillerDelimiter;
    }
    return nok(code2);
  }
  function afterRightAlignment(code2) {
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return rowEndDelimiter(code2);
    }
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.enter("whitespace");
      effects.consume(code2);
      return inWhitespaceDelimiter;
    }
    if (code2 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code2);
      effects.exit("tableCellDivider");
      return atDelimiterRowBreak;
    }
    return nok(code2);
  }
  function rowEndDelimiter(code2) {
    effects.exit("tableDelimiterRow");
    if (!hasDash || tableHeaderCount !== align.length) {
      return nok(code2);
    }
    if (code2 === null) {
      return tableClose(code2);
    }
    return effects.check(nextPrefixedOrBlank, tableClose, tableContinue)(code2);
  }
  function tableClose(code2) {
    effects.exit("table");
    return ok2(code2);
  }
  function tableContinue(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return createSpace(effects, bodyStart, "linePrefix", 4);
  }
  function bodyStart(code2) {
    effects.enter("tableBody");
    return rowStartBody(code2);
  }
  function rowStartBody(code2) {
    effects.enter("tableRow");
    if (code2 === 124) {
      return cellDividerBody(code2);
    }
    effects.enter("temporaryTableCellContent");
    return inCellContentBody(code2);
  }
  function cellDividerBody(code2) {
    effects.enter("tableCellDivider");
    effects.consume(code2);
    effects.exit("tableCellDivider");
    return cellBreakBody;
  }
  function cellBreakBody(code2) {
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return atRowEndBody(code2);
    }
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.enter("whitespace");
      effects.consume(code2);
      return inWhitespaceBody;
    }
    if (code2 === 124) {
      return cellDividerBody(code2);
    }
    effects.enter("temporaryTableCellContent");
    return inCellContentBody(code2);
  }
  function inWhitespaceBody(code2) {
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.consume(code2);
      return inWhitespaceBody;
    }
    effects.exit("whitespace");
    return cellBreakBody(code2);
  }
  function inCellContentBody(code2) {
    if (code2 === null || code2 < 0 || code2 === 32 || code2 === 124) {
      effects.exit("temporaryTableCellContent");
      return cellBreakBody(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? inCellContentEscapeBody : inCellContentBody;
  }
  function inCellContentEscapeBody(code2) {
    if (code2 === 92 || code2 === 124) {
      effects.consume(code2);
      return inCellContentBody;
    }
    return inCellContentBody(code2);
  }
  function atRowEndBody(code2) {
    effects.exit("tableRow");
    if (code2 === null) {
      return tableBodyClose(code2);
    }
    return effects.check(
      nextPrefixedOrBlank,
      tableBodyClose,
      tableBodyContinue
    )(code2);
  }
  function tableBodyClose(code2) {
    effects.exit("tableBody");
    return tableClose(code2);
  }
  function tableBodyContinue(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return createSpace(effects, rowStartBody, "linePrefix", 4);
  }
}
function tokenizeSetextUnderlineMini(effects, ok2, nok) {
  return start;
  function start(code2) {
    if (code2 !== 45) {
      return nok(code2);
    }
    effects.enter("setextUnderline");
    return sequence(code2);
  }
  function sequence(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return sequence;
    }
    return whitespace(code2);
  }
  function whitespace(code2) {
    if (code2 === -2 || code2 === -1 || code2 === 32) {
      effects.consume(code2);
      return whitespace;
    }
    if (code2 === null || code2 === -5 || code2 === -4 || code2 === -3) {
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeNextPrefixedOrBlank(effects, ok2, nok) {
  var size2 = 0;
  return start;
  function start(code2) {
    effects.enter("check");
    effects.consume(code2);
    return whitespace;
  }
  function whitespace(code2) {
    if (code2 === -1 || code2 === 32) {
      effects.consume(code2);
      size2++;
      return size2 === 4 ? ok2 : whitespace;
    }
    if (code2 === null || code2 < 0) {
      return ok2(code2);
    }
    return nok(code2);
  }
}
var micromarkExtensionGfmTable = syntax$3;
var syntax$2 = {};
function sizeChunks$2(chunks) {
  var index2 = -1;
  var size2 = 0;
  while (++index2 < chunks.length) {
    size2 += typeof chunks[index2] === "string" ? chunks[index2].length : 1;
  }
  return size2;
}
var sizeChunks_1 = sizeChunks$2;
var sizeChunks$1 = sizeChunks_1;
function prefixSize$5(events, type) {
  var tail = events[events.length - 1];
  if (!tail || tail[1].type !== type) return 0;
  return sizeChunks$1(tail[2].sliceStream(tail[1]));
}
var prefixSize_1 = prefixSize$5;
var markdownLineEndingOrSpace$7 = markdownLineEndingOrSpace_1;
var spaceFactory = factorySpace$h;
var prefixSize$4 = prefixSize_1;
var tasklistCheck = { tokenize: tokenizeTasklistCheck };
syntax$2.text = { 91: tasklistCheck };
function tokenizeTasklistCheck(effects, ok2, nok) {
  var self2 = this;
  return open;
  function open(code2) {
    if (
      // Exit if not `[`.
      code2 !== 91 || // Exit if there’s stuff before.
      self2.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !self2._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code2);
    }
    effects.enter("taskListCheck");
    effects.enter("taskListCheckMarker");
    effects.consume(code2);
    effects.exit("taskListCheckMarker");
    return inside;
  }
  function inside(code2) {
    if (code2 === -2 || code2 === 32) {
      effects.enter("taskListCheckValueUnchecked");
      effects.consume(code2);
      effects.exit("taskListCheckValueUnchecked");
      return close;
    }
    if (code2 === 88 || code2 === 120) {
      effects.enter("taskListCheckValueChecked");
      effects.consume(code2);
      effects.exit("taskListCheckValueChecked");
      return close;
    }
    return nok(code2);
  }
  function close(code2) {
    if (code2 === 93) {
      effects.enter("taskListCheckMarker");
      effects.consume(code2);
      effects.exit("taskListCheckMarker");
      effects.exit("taskListCheck");
      return effects.check({ tokenize: spaceThenNonSpace }, ok2, nok);
    }
    return nok(code2);
  }
}
function spaceThenNonSpace(effects, ok2, nok) {
  var self2 = this;
  return spaceFactory(effects, after, "whitespace");
  function after(code2) {
    return prefixSize$4(self2.events, "whitespace") && code2 !== null && !markdownLineEndingOrSpace$7(code2) ? ok2(code2) : nok(code2);
  }
}
var micromarkExtensionGfmTaskListItem = syntax$2;
var combine = combineExtensions_1;
var autolink$2 = micromarkExtensionGfmAutolinkLiteral;
var strikethrough$2 = micromarkExtensionGfmStrikethrough;
var table$2 = micromarkExtensionGfmTable;
var tasklist = micromarkExtensionGfmTaskListItem;
var syntax$1 = create;
function create(options) {
  return combine([autolink$2, strikethrough$2(options), table$2, tasklist]);
}
var micromarkExtensionGfm = syntax$1;
var fromMarkdown$7 = {};
var ccount_1 = ccount$1;
function ccount$1(source, character) {
  var value = String(source);
  var count2 = 0;
  var index2;
  if (typeof character !== "string") {
    throw new Error("Expected character");
  }
  index2 = value.indexOf(character);
  while (index2 !== -1) {
    count2++;
    index2 = value.indexOf(character, index2 + character.length);
  }
  return count2;
}
var convert_1 = convert$2;
function convert$2(test) {
  if (test == null) {
    return ok;
  }
  if (typeof test === "string") {
    return typeFactory(test);
  }
  if (typeof test === "object") {
    return "length" in test ? anyFactory(test) : allFactory(test);
  }
  if (typeof test === "function") {
    return test;
  }
  throw new Error("Expected function, string, or object as test");
}
function allFactory(test) {
  return all2;
  function all2(node) {
    var key;
    for (key in test) {
      if (node[key] !== test[key]) return false;
    }
    return true;
  }
}
function anyFactory(tests) {
  var checks = [];
  var index2 = -1;
  while (++index2 < tests.length) {
    checks[index2] = convert$2(tests[index2]);
  }
  return any;
  function any() {
    var index3 = -1;
    while (++index3 < checks.length) {
      if (checks[index3].apply(this, arguments)) {
        return true;
      }
    }
    return false;
  }
}
function typeFactory(test) {
  return type;
  function type(node) {
    return Boolean(node && node.type === test);
  }
}
function ok() {
  return true;
}
var color_browser = identity;
function identity(d2) {
  return d2;
}
var unistUtilVisitParents = visitParents;
var convert$1 = convert_1;
var color = color_browser;
var CONTINUE = true;
var SKIP = "skip";
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse3) {
  var step;
  var is2;
  if (typeof test === "function" && typeof visitor !== "function") {
    reverse3 = visitor;
    visitor = test;
    test = null;
  }
  is2 = convert$1(test);
  step = reverse3 ? -1 : 1;
  factory(tree, null, [])();
  function factory(node, index2, parents) {
    var value = typeof node === "object" && node !== null ? node : {};
    var name;
    if (typeof value.type === "string") {
      name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : void 0;
      visit2.displayName = "node (" + color(value.type + (name ? "<" + name + ">" : "")) + ")";
    }
    return visit2;
    function visit2() {
      var grandparents = parents.concat(node);
      var result = [];
      var subresult;
      var offset2;
      if (!test || is2(node, index2, parents[parents.length - 1] || null)) {
        result = toResult(visitor(node, parents));
        if (result[0] === EXIT) {
          return result;
        }
      }
      if (node.children && result[0] !== SKIP) {
        offset2 = (reverse3 ? node.children.length : -1) + step;
        while (offset2 > -1 && offset2 < node.children.length) {
          subresult = factory(node.children[offset2], offset2, grandparents)();
          if (subresult[0] === EXIT) {
            return subresult;
          }
          offset2 = typeof subresult[1] === "number" ? subresult[1] : offset2 + step;
        }
      }
      return result;
    }
  }
}
function toResult(value) {
  if (value !== null && typeof value === "object" && "length" in value) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return [value];
}
var escapeStringRegexp = (string2) => {
  if (typeof string2 !== "string") {
    throw new TypeError("Expected a string");
  }
  return string2.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
var mdastUtilFindAndReplace = findAndReplace$1;
var visit = unistUtilVisitParents;
var convert = convert_1;
var escape = escapeStringRegexp;
var splice = [].splice;
function findAndReplace$1(tree, find, replace2, options) {
  var settings;
  var schema;
  if (typeof find === "string" || find && typeof find.exec === "function") {
    schema = [[find, replace2]];
  } else {
    schema = find;
    options = replace2;
  }
  settings = options || {};
  search$1(tree, settings, handlerFactory(toPairs(schema)));
  return tree;
  function handlerFactory(pairs) {
    var pair = pairs[0];
    return handler;
    function handler(node, parent2) {
      var find2 = pair[0];
      var replace3 = pair[1];
      var nodes = [];
      var start = 0;
      var index2 = parent2.children.indexOf(node);
      var position2;
      var match2;
      var subhandler;
      var value;
      find2.lastIndex = 0;
      match2 = find2.exec(node.value);
      while (match2) {
        position2 = match2.index;
        value = replace3.apply(
          null,
          [].concat(match2, { index: match2.index, input: match2.input })
        );
        if (value !== false) {
          if (start !== position2) {
            nodes.push({ type: "text", value: node.value.slice(start, position2) });
          }
          if (typeof value === "string" && value.length > 0) {
            value = { type: "text", value };
          }
          if (value) {
            nodes = [].concat(nodes, value);
          }
          start = position2 + match2[0].length;
        }
        if (!find2.global) {
          break;
        }
        match2 = find2.exec(node.value);
      }
      if (position2 === void 0) {
        nodes = [node];
        index2--;
      } else {
        if (start < node.value.length) {
          nodes.push({ type: "text", value: node.value.slice(start) });
        }
        nodes.unshift(index2, 1);
        splice.apply(parent2.children, nodes);
      }
      if (pairs.length > 1) {
        subhandler = handlerFactory(pairs.slice(1));
        position2 = -1;
        while (++position2 < nodes.length) {
          node = nodes[position2];
          if (node.type === "text") {
            subhandler(node, parent2);
          } else {
            search$1(node, settings, subhandler);
          }
        }
      }
      return index2 + nodes.length + 1;
    }
  }
}
function search$1(tree, settings, handler) {
  var ignored = convert(settings.ignore || []);
  var result = [];
  visit(tree, "text", visitor);
  return result;
  function visitor(node, parents) {
    var index2 = -1;
    var parent2;
    var grandparent;
    while (++index2 < parents.length) {
      parent2 = parents[index2];
      if (ignored(
        parent2,
        grandparent ? grandparent.children.indexOf(parent2) : void 0,
        grandparent
      )) {
        return;
      }
      grandparent = parent2;
    }
    return handler(node, grandparent);
  }
}
function toPairs(schema) {
  var result = [];
  var key;
  var index2;
  if (typeof schema !== "object") {
    throw new Error("Expected array or object as schema");
  }
  if ("length" in schema) {
    index2 = -1;
    while (++index2 < schema.length) {
      result.push([
        toExpression(schema[index2][0]),
        toFunction(schema[index2][1])
      ]);
    }
  } else {
    for (key in schema) {
      result.push([toExpression(key), toFunction(schema[key])]);
    }
  }
  return result;
}
function toExpression(find) {
  return typeof find === "string" ? new RegExp(escape(find), "g") : find;
}
function toFunction(replace2) {
  return typeof replace2 === "function" ? replace2 : returner;
  function returner() {
    return replace2;
  }
}
var ccount = ccount_1;
var findAndReplace = mdastUtilFindAndReplace;
var unicodePunctuation = unicodePunctuation_1;
var unicodeWhitespace = unicodeWhitespace_1;
fromMarkdown$7.transforms = [transformGfmAutolinkLiterals];
fromMarkdown$7.enter = {
  literalAutolink: enterLiteralAutolink,
  literalAutolinkEmail: enterLiteralAutolinkValue,
  literalAutolinkHttp: enterLiteralAutolinkValue,
  literalAutolinkWww: enterLiteralAutolinkValue
};
fromMarkdown$7.exit = {
  literalAutolink: exitLiteralAutolink,
  literalAutolinkEmail: exitLiteralAutolinkEmail,
  literalAutolinkHttp: exitLiteralAutolinkHttp,
  literalAutolinkWww: exitLiteralAutolinkWww
};
function enterLiteralAutolink(token) {
  this.enter({ type: "link", title: null, url: "", children: [] }, token);
}
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  this.stack[this.stack.length - 1].url = "http://" + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
  this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/, findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl($0, protocol, domain2, path2, match2) {
  var prefix = "";
  var parts;
  var result;
  if (!previous$1(match2)) {
    return false;
  }
  if (/^w/i.test(protocol)) {
    domain2 = protocol + domain2;
    protocol = "";
    prefix = "http://";
  }
  if (!isCorrectDomain(domain2)) {
    return false;
  }
  parts = splitUrl(domain2 + path2);
  if (!parts[0]) return false;
  result = {
    type: "link",
    title: null,
    url: prefix + protocol + parts[0],
    children: [{ type: "text", value: protocol + parts[0] }]
  };
  if (parts[1]) {
    result = [result, { type: "text", value: parts[1] }];
  }
  return result;
}
function findEmail($0, atext, label, match2) {
  if (!previous$1(match2, true) || /[_-]$/.test(label)) {
    return false;
  }
  return {
    type: "link",
    title: null,
    url: "mailto:" + atext + "@" + label,
    children: [{ type: "text", value: atext + "@" + label }]
  };
}
function isCorrectDomain(domain2) {
  var parts = domain2.split(".");
  if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) {
    return false;
  }
  return true;
}
function splitUrl(url) {
  var trail = /[!"&'),.:;<>?\]}]+$/.exec(url);
  var closingParenIndex;
  var openingParens;
  var closingParens;
  if (trail) {
    url = url.slice(0, trail.index);
    trail = trail[0];
    closingParenIndex = trail.indexOf(")");
    openingParens = ccount(url, "(");
    closingParens = ccount(url, ")");
    while (closingParenIndex !== -1 && openingParens > closingParens) {
      url += trail.slice(0, closingParenIndex + 1);
      trail = trail.slice(closingParenIndex + 1);
      closingParenIndex = trail.indexOf(")");
      closingParens++;
    }
  }
  return [url, trail];
}
function previous$1(match2, email) {
  var code2 = match2.input.charCodeAt(match2.index - 1);
  return (code2 !== code2 || unicodeWhitespace(code2) || unicodePunctuation(code2)) && (!email || code2 !== 47);
}
var fromMarkdown$6 = {};
fromMarkdown$6.canContainEols = ["delete"];
fromMarkdown$6.enter = { strikethrough: enterStrikethrough };
fromMarkdown$6.exit = { strikethrough: exitStrikethrough };
function enterStrikethrough(token) {
  this.enter({ type: "delete", children: [] }, token);
}
function exitStrikethrough(token) {
  this.exit(token);
}
var fromMarkdown$5 = {};
fromMarkdown$5.enter = {
  table: enterTable,
  tableData: enterCell,
  tableHeader: enterCell,
  tableRow: enterRow
};
fromMarkdown$5.exit = {
  codeText: exitCodeText,
  table: exitTable,
  tableData: exit$1,
  tableHeader: exit$1,
  tableRow: exit$1
};
function enterTable(token) {
  this.enter({ type: "table", align: token._align, children: [] }, token);
  this.setData("inTable", true);
}
function exitTable(token) {
  this.exit(token);
  this.setData("inTable");
}
function enterRow(token) {
  this.enter({ type: "tableRow", children: [] }, token);
}
function exit$1(token) {
  this.exit(token);
}
function enterCell(token) {
  this.enter({ type: "tableCell", children: [] }, token);
}
function exitCodeText(token) {
  var value = this.resume();
  if (this.getData("inTable")) {
    value = value.replace(/\\([\\|])/g, replace);
  }
  this.stack[this.stack.length - 1].value = value;
  this.exit(token);
}
function replace($0, $1) {
  return $1 === "|" ? $1 : $0;
}
var fromMarkdown$4 = {};
fromMarkdown$4.exit = {
  taskListCheckValueChecked: exitCheck,
  taskListCheckValueUnchecked: exitCheck,
  paragraph: exitParagraphWithTaskListItem
};
function exitCheck(token) {
  this.stack[this.stack.length - 2].checked = token.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(token) {
  var parent2 = this.stack[this.stack.length - 2];
  var node = this.stack[this.stack.length - 1];
  var siblings = parent2.children;
  var head = node.children[0];
  var index2 = -1;
  var firstParaghraph;
  if (parent2 && parent2.type === "listItem" && typeof parent2.checked === "boolean" && head && head.type === "text") {
    while (++index2 < siblings.length) {
      if (siblings[index2].type === "paragraph") {
        firstParaghraph = siblings[index2];
        break;
      }
    }
    if (firstParaghraph === node) {
      head.value = head.value.slice(1);
      if (head.value.length === 0) {
        node.children.shift();
      } else {
        head.position.start.column++;
        head.position.start.offset++;
        node.position.start = Object.assign({}, head.position.start);
      }
    }
  }
  this.exit(token);
}
var autolinkLiteral$1 = fromMarkdown$7;
var strikethrough$1 = fromMarkdown$6;
var table$1 = fromMarkdown$5;
var taskListItem$1 = fromMarkdown$4;
var own$4 = {}.hasOwnProperty;
var fromMarkdown$3 = configure$3([
  autolinkLiteral$1,
  strikethrough$1,
  table$1,
  taskListItem$1
]);
function configure$3(extensions) {
  var config2 = { transforms: [], canContainEols: [] };
  var length = extensions.length;
  var index2 = -1;
  while (++index2 < length) {
    extension$1(config2, extensions[index2]);
  }
  return config2;
}
function extension$1(config2, extension2) {
  var key;
  var left;
  var right;
  for (key in extension2) {
    left = own$4.call(config2, key) ? config2[key] : config2[key] = {};
    right = extension2[key];
    if (key === "canContainEols" || key === "transforms") {
      config2[key] = [].concat(left, right);
    } else {
      Object.assign(left, right);
    }
  }
}
var toMarkdown$5 = {};
var inConstruct = "phrasing";
var notInConstruct = ["autolink", "link", "image", "label"];
toMarkdown$5.unsafe = [
  {
    character: "@",
    before: "[+\\-.\\w]",
    after: "[\\-.\\w]",
    inConstruct,
    notInConstruct
  },
  {
    character: ".",
    before: "[Ww]",
    after: "[\\-.\\w]",
    inConstruct,
    notInConstruct
  },
  {
    character: ":",
    before: "[ps]",
    after: "\\/",
    inConstruct,
    notInConstruct
  }
];
var toMarkdown$4 = {};
var containerPhrasing = phrasing$2;
function phrasing$2(parent2, context, safeOptions) {
  var children = parent2.children || [];
  var results = [];
  var index2 = -1;
  var before = safeOptions.before;
  var after;
  var handle;
  var child;
  while (++index2 < children.length) {
    child = children[index2];
    if (index2 + 1 < children.length) {
      handle = context.handle.handlers[children[index2 + 1].type];
      if (handle && handle.peek) handle = handle.peek;
      after = handle ? handle(children[index2 + 1], parent2, context, {
        before: "",
        after: ""
      }).charAt(0) : "";
    } else {
      after = safeOptions.after;
    }
    if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        " "
      );
      before = " ";
    }
    results.push(
      context.handle(child, parent2, context, {
        before,
        after
      })
    );
    before = results[results.length - 1].slice(-1);
  }
  return results.join("");
}
var phrasing$1 = containerPhrasing;
toMarkdown$4.unsafe = [{ character: "~", inConstruct: "phrasing" }];
toMarkdown$4.handlers = { delete: handleDelete };
handleDelete.peek = peekDelete;
function handleDelete(node, _2, context) {
  var exit2 = context.enter("emphasis");
  var value = phrasing$1(node, context, { before: "~", after: "~" });
  exit2();
  return "~~" + value + "~~";
}
function peekDelete() {
  return "~";
}
var patternCompile_1 = patternCompile$1;
function patternCompile$1(pattern) {
  var before;
  var after;
  if (!pattern._compiled) {
    before = pattern.before ? "(?:" + pattern.before + ")" : "";
    after = pattern.after ? "(?:" + pattern.after + ")" : "";
    if (pattern.atBreak) {
      before = "[\\r\\n][\\t ]*" + before;
    }
    pattern._compiled = new RegExp(
      (before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (after || ""),
      "g"
    );
  }
  return pattern._compiled;
}
var inlineCode_1 = inlineCode;
inlineCode.peek = inlineCodePeek;
var patternCompile = patternCompile_1;
function inlineCode(node, parent2, context) {
  var value = node.value || "";
  var sequence = "`";
  var index2 = -1;
  var pattern;
  var expression;
  var match2;
  var position2;
  while (new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value)) {
    sequence += "`";
  }
  if (/[^ \r\n]/.test(value) && (/[ \r\n`]/.test(value.charAt(0)) || /[ \r\n`]/.test(value.charAt(value.length - 1)))) {
    value = " " + value + " ";
  }
  while (++index2 < context.unsafe.length) {
    pattern = context.unsafe[index2];
    if (!pattern.atBreak) continue;
    expression = patternCompile(pattern);
    while (match2 = expression.exec(value)) {
      position2 = match2.index;
      if (value.charCodeAt(position2) === 10 && value.charCodeAt(position2 - 1) === 13) {
        position2--;
      }
      value = value.slice(0, position2) + " " + value.slice(match2.index + 1);
    }
  }
  return sequence + value + sequence;
}
function inlineCodePeek() {
  return "`";
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
var res = "";
var cache;
var repeatString = repeat$3;
function repeat$3(str, num) {
  if (typeof str !== "string") {
    throw new TypeError("expected a string");
  }
  if (num === 1) return str;
  if (num === 2) return str + str;
  var max2 = str.length * num;
  if (cache !== str || typeof cache === "undefined") {
    cache = str;
    res = "";
  } else if (res.length >= max2) {
    return res.substr(0, max2);
  }
  while (max2 > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }
    num >>= 1;
    str += str;
  }
  res += str;
  res = res.substr(0, max2);
  return res;
}
var repeat$2 = repeatString;
var markdownTable_1 = markdownTable$1;
var trailingWhitespace = / +$/;
var space = " ";
var lineFeed = "\n";
var dash = "-";
var colon = ":";
var verticalBar = "|";
var x = 0;
var C = 67;
var L = 76;
var R = 82;
var c = 99;
var l = 108;
var r = 114;
function markdownTable$1(table2, options) {
  var settings = options || {};
  var padding = settings.padding !== false;
  var start = settings.delimiterStart !== false;
  var end = settings.delimiterEnd !== false;
  var align = (settings.align || []).concat();
  var alignDelimiters = settings.alignDelimiters !== false;
  var alignments = [];
  var stringLength = settings.stringLength || defaultStringLength;
  var rowIndex = -1;
  var rowLength = table2.length;
  var cellMatrix = [];
  var sizeMatrix = [];
  var row = [];
  var sizes = [];
  var longestCellByColumn = [];
  var mostCellsPerRow = 0;
  var cells;
  var columnIndex;
  var columnLength;
  var largest;
  var size2;
  var cell;
  var lines;
  var line;
  var before;
  var after;
  var code2;
  while (++rowIndex < rowLength) {
    cells = table2[rowIndex];
    columnIndex = -1;
    columnLength = cells.length;
    row = [];
    sizes = [];
    if (columnLength > mostCellsPerRow) {
      mostCellsPerRow = columnLength;
    }
    while (++columnIndex < columnLength) {
      cell = serialize(cells[columnIndex]);
      if (alignDelimiters === true) {
        size2 = stringLength(cell);
        sizes[columnIndex] = size2;
        largest = longestCellByColumn[columnIndex];
        if (largest === void 0 || size2 > largest) {
          longestCellByColumn[columnIndex] = size2;
        }
      }
      row.push(cell);
    }
    cellMatrix[rowIndex] = row;
    sizeMatrix[rowIndex] = sizes;
  }
  columnIndex = -1;
  columnLength = mostCellsPerRow;
  if (typeof align === "object" && "length" in align) {
    while (++columnIndex < columnLength) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    code2 = toAlignment(align);
    while (++columnIndex < columnLength) {
      alignments[columnIndex] = code2;
    }
  }
  columnIndex = -1;
  columnLength = mostCellsPerRow;
  row = [];
  sizes = [];
  while (++columnIndex < columnLength) {
    code2 = alignments[columnIndex];
    before = "";
    after = "";
    if (code2 === l) {
      before = colon;
    } else if (code2 === r) {
      after = colon;
    } else if (code2 === c) {
      before = colon;
      after = colon;
    }
    size2 = alignDelimiters ? Math.max(
      1,
      longestCellByColumn[columnIndex] - before.length - after.length
    ) : 1;
    cell = before + repeat$2(dash, size2) + after;
    if (alignDelimiters === true) {
      size2 = before.length + size2 + after.length;
      if (size2 > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size2;
      }
      sizes[columnIndex] = size2;
    }
    row[columnIndex] = cell;
  }
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes);
  rowIndex = -1;
  rowLength = cellMatrix.length;
  lines = [];
  while (++rowIndex < rowLength) {
    row = cellMatrix[rowIndex];
    sizes = sizeMatrix[rowIndex];
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    line = [];
    while (++columnIndex < columnLength) {
      cell = row[columnIndex] || "";
      before = "";
      after = "";
      if (alignDelimiters === true) {
        size2 = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
        code2 = alignments[columnIndex];
        if (code2 === r) {
          before = repeat$2(space, size2);
        } else if (code2 === c) {
          if (size2 % 2 === 0) {
            before = repeat$2(space, size2 / 2);
            after = before;
          } else {
            before = repeat$2(space, size2 / 2 + 0.5);
            after = repeat$2(space, size2 / 2 - 0.5);
          }
        } else {
          after = repeat$2(space, size2);
        }
      }
      if (start === true && columnIndex === 0) {
        line.push(verticalBar);
      }
      if (padding === true && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(alignDelimiters === false && cell === "") && (start === true || columnIndex !== 0)) {
        line.push(space);
      }
      if (alignDelimiters === true) {
        line.push(before);
      }
      line.push(cell);
      if (alignDelimiters === true) {
        line.push(after);
      }
      if (padding === true) {
        line.push(space);
      }
      if (end === true || columnIndex !== columnLength - 1) {
        line.push(verticalBar);
      }
    }
    line = line.join("");
    if (end === false) {
      line = line.replace(trailingWhitespace, "");
    }
    lines.push(line);
  }
  return lines.join(lineFeed);
}
function serialize(value) {
  return value === null || value === void 0 ? "" : String(value);
}
function defaultStringLength(value) {
  return value.length;
}
function toAlignment(value) {
  var code2 = typeof value === "string" ? value.charCodeAt(0) : x;
  return code2 === L || code2 === l ? l : code2 === R || code2 === r ? r : code2 === C || code2 === c ? c : x;
}
var phrasing = containerPhrasing;
var defaultInlineCode = inlineCode_1;
var markdownTable = markdownTable_1;
var toMarkdown_1$1 = toMarkdown$3;
function toMarkdown$3(options) {
  var settings = options || {};
  var padding = settings.tableCellPadding;
  var alignDelimiters = settings.tablePipeAlign;
  var stringLength = settings.stringLength;
  var around = padding ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: "\n", inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: true, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: true, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: true, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  };
  function handleTable(node, _2, context) {
    return serializeData(handleTableAsData(node, context), node.align);
  }
  function handleTableRow(node, _2, context) {
    var row = handleTableRowAsData(node, context);
    var value = serializeData([row]);
    return value.slice(0, value.indexOf("\n"));
  }
  function handleTableCell(node, _2, context) {
    var exit2 = context.enter("tableCell");
    var value = phrasing(node, context, { before: around, after: around });
    exit2();
    return value;
  }
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      alignDelimiters,
      padding,
      stringLength
    });
  }
  function handleTableAsData(node, context) {
    var children = node.children;
    var index2 = -1;
    var length = children.length;
    var result = [];
    var subexit = context.enter("table");
    while (++index2 < length) {
      result[index2] = handleTableRowAsData(children[index2], context);
    }
    subexit();
    return result;
  }
  function handleTableRowAsData(node, context) {
    var children = node.children;
    var index2 = -1;
    var length = children.length;
    var result = [];
    var subexit = context.enter("tableRow");
    while (++index2 < length) {
      result[index2] = handleTableCell(children[index2], node, context);
    }
    subexit();
    return result;
  }
  function inlineCodeWithTable(node, parent2, context) {
    var value = defaultInlineCode(node, parent2, context);
    if (context.stack.indexOf("tableCell") !== -1) {
      value = value.replace(/\|/g, "\\$&");
    }
    return value;
  }
}
var toMarkdown$2 = {};
var checkBullet_1 = checkBullet$1;
function checkBullet$1(context) {
  var marker = context.options.bullet || "*";
  if (marker !== "*" && marker !== "+" && marker !== "-") {
    throw new Error(
      "Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  }
  return marker;
}
var checkListItemIndent_1 = checkListItemIndent$1;
function checkListItemIndent$1(context) {
  var style = context.options.listItemIndent || "tab";
  if (style === 1 || style === "1") {
    return "one";
  }
  if (style !== "tab" && style !== "one" && style !== "mixed") {
    throw new Error(
      "Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  }
  return style;
}
var containerFlow = flow$4;
var repeat$1 = repeatString;
function flow$4(parent2, context) {
  var children = parent2.children || [];
  var results = [];
  var index2 = -1;
  var child;
  while (++index2 < children.length) {
    child = children[index2];
    results.push(
      context.handle(child, parent2, context, { before: "\n", after: "\n" })
    );
    if (index2 + 1 < children.length) {
      results.push(between(child, children[index2 + 1]));
    }
  }
  return results.join("");
  function between(left, right) {
    var index3 = -1;
    var result;
    while (++index3 < context.join.length) {
      result = context.join[index3](left, right, parent2, context);
      if (result === true || result === 1) {
        break;
      }
      if (typeof result === "number") {
        return repeat$1("\n", 1 + Number(result));
      }
      if (result === false) {
        return "\n\n<!---->\n\n";
      }
    }
    return "\n\n";
  }
}
var indentLines_1 = indentLines$1;
var eol = /\r?\n|\r/g;
function indentLines$1(value, map) {
  var result = [];
  var start = 0;
  var line = 0;
  var match2;
  while (match2 = eol.exec(value)) {
    one(value.slice(start, match2.index));
    result.push(match2[0]);
    start = match2.index + match2[0].length;
    line++;
  }
  one(value.slice(start));
  return result.join("");
  function one(value2) {
    result.push(map(value2, line, !value2));
  }
}
var listItem_1 = listItem;
var repeat = repeatString;
var checkBullet = checkBullet_1;
var checkListItemIndent = checkListItemIndent_1;
var flow$3 = containerFlow;
var indentLines = indentLines_1;
function listItem(node, parent2, context) {
  var bullet = checkBullet(context);
  var listItemIndent = checkListItemIndent(context);
  var size2;
  var value;
  var exit2;
  if (parent2 && parent2.ordered) {
    bullet = (parent2.start > -1 ? parent2.start : 1) + (context.options.incrementListMarker === false ? 0 : parent2.children.indexOf(node)) + ".";
  }
  size2 = bullet.length + 1;
  if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent2 && parent2.spread || node.spread)) {
    size2 = Math.ceil(size2 / 4) * 4;
  }
  exit2 = context.enter("listItem");
  value = indentLines(flow$3(node, context), map);
  exit2();
  return value;
  function map(line, index2, blank) {
    if (index2) {
      return (blank ? "" : repeat(" ", size2)) + line;
    }
    return (blank ? bullet : bullet + repeat(" ", size2 - bullet.length)) + line;
  }
}
var defaultListItem = listItem_1;
toMarkdown$2.unsafe = [{ atBreak: true, character: "-", after: "[:|-]" }];
toMarkdown$2.handlers = {
  listItem: listItemWithTaskListItem
};
function listItemWithTaskListItem(node, parent2, context) {
  var value = defaultListItem(node, parent2, context);
  var head = node.children[0];
  if (typeof node.checked === "boolean" && head && head.type === "paragraph") {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }
  return value;
  function check($0) {
    return $0 + "[" + (node.checked ? "x" : " ") + "] ";
  }
}
var configure_1 = configure$2;
function configure$2(base, extension2) {
  var index2 = -1;
  var key;
  if (extension2.extensions) {
    while (++index2 < extension2.extensions.length) {
      configure$2(base, extension2.extensions[index2]);
    }
  }
  for (key in extension2) {
    if (key === "extensions") ;
    else if (key === "unsafe" || key === "join") {
      base[key] = base[key].concat(extension2[key] || []);
    } else if (key === "handlers") {
      base[key] = Object.assign(base[key], extension2[key] || {});
    } else {
      base.options[key] = extension2[key];
    }
  }
  return base;
}
var autolinkLiteral = toMarkdown$5;
var strikethrough = toMarkdown$4;
var table = toMarkdown_1$1;
var taskListItem = toMarkdown$2;
var configure$1 = configure_1;
var toMarkdown_1 = toMarkdown$1;
function toMarkdown$1(options) {
  var config2 = configure$1(
    { handlers: {}, join: [], unsafe: [], options: {} },
    {
      extensions: [autolinkLiteral, strikethrough, table(options), taskListItem]
    }
  );
  return Object.assign(config2.options, {
    handlers: config2.handlers,
    join: config2.join,
    unsafe: config2.unsafe
  });
}
var syntax = micromarkExtensionGfm;
var fromMarkdown$2 = fromMarkdown$3;
var toMarkdown = toMarkdown_1;
var warningIssued;
var remarkGfm = gfm$1;
function gfm$1(options) {
  var data = this.data();
  if (!warningIssued && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors)) {
    warningIssued = true;
    console.warn(
      "[remark-gfm] Warning: please upgrade to remark 13 to use this plugin"
    );
  }
  add("micromarkExtensions", syntax(options));
  add("fromMarkdownExtensions", fromMarkdown$2);
  add("toMarkdownExtensions", toMarkdown(options));
  function add(field, value) {
    if (data[field]) data[field].push(value);
    else data[field] = [value];
  }
}
var mdastUtilToString = toString$2;
function toString$2(node) {
  return node && (node.value || node.alt || node.title || "children" in node && all(node.children) || "length" in node && all(node)) || "";
}
function all(values) {
  var result = [];
  var index2 = -1;
  while (++index2 < values.length) {
    result[index2] = toString$2(values[index2]);
  }
  return result.join("");
}
function normalizeIdentifier$3(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
var normalizeIdentifier_1 = normalizeIdentifier$3;
var fromCharCode$2 = fromCharCode_1;
function safeFromInt$1(value, base) {
  var code2 = parseInt(value, base);
  if (
    // C0 except for HT, LF, FF, CR, space
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of the basic block and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || // Out of range
    code2 > 1114111
  ) {
    return "�";
  }
  return fromCharCode$2(code2);
}
var safeFromInt_1 = safeFromInt$1;
var content$3 = {};
Object.defineProperty(content$3, "__esModule", { value: true });
var markdownLineEnding$i = markdownLineEnding_1;
var factorySpace$g = factorySpace$h;
var tokenize$2 = initializeContent;
function initializeContent(effects) {
  var contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  );
  var previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$g(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    var token = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token;
    }
    previous2 = token;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding$i(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
content$3.tokenize = tokenize$2;
var document$3 = {};
var markdownLineEnding$h = markdownLineEnding_1;
var factorySpace$f = factorySpace$h;
var partialBlankLine$4 = {
  tokenize: tokenizePartialBlankLine,
  partial: true
};
function tokenizePartialBlankLine(effects, ok2, nok) {
  return factorySpace$f(effects, afterWhitespace, "linePrefix");
  function afterWhitespace(code2) {
    return code2 === null || markdownLineEnding$h(code2) ? ok2(code2) : nok(code2);
  }
}
var partialBlankLine_1 = partialBlankLine$4;
Object.defineProperty(document$3, "__esModule", { value: true });
var markdownLineEnding$g = markdownLineEnding_1;
var factorySpace$e = factorySpace$h;
var partialBlankLine$3 = partialBlankLine_1;
var tokenize$1 = initializeDocument;
var containerConstruct = {
  tokenize: tokenizeContainer
};
var lazyFlowConstruct = {
  tokenize: tokenizeLazyFlow
};
function initializeDocument(effects) {
  var self2 = this;
  var stack = [];
  var continued = 0;
  var inspectConstruct = {
    tokenize: tokenizeInspect,
    partial: true
  };
  var inspectResult;
  var childFlow;
  var childToken;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      self2.containerState = stack[continued][1];
      return effects.attempt(
        stack[continued][0].continuation,
        documentContinue,
        documentContinued
      )(code2);
    }
    return documentContinued(code2);
  }
  function documentContinue(code2) {
    continued++;
    return start(code2);
  }
  function documentContinued(code2) {
    if (inspectResult && inspectResult.flowContinue) {
      return flowStart(code2);
    }
    self2.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
    self2.containerState = {};
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code2);
  }
  function containerContinue(code2) {
    stack.push([self2.currentConstruct, self2.containerState]);
    self2.containerState = void 0;
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      exitContainers(0, true);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      contentType: "flow",
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      continueFlow(effects.exit("chunkFlow"));
      return flowStart(code2);
    }
    if (markdownLineEnding$g(code2)) {
      effects.consume(code2);
      continueFlow(effects.exit("chunkFlow"));
      return effects.check(inspectConstruct, documentAfterPeek);
    }
    effects.consume(code2);
    return flowContinue;
  }
  function documentAfterPeek(code2) {
    exitContainers(
      inspectResult.continued,
      inspectResult && inspectResult.flowEnd
    );
    continued = 0;
    return start(code2);
  }
  function continueFlow(token) {
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.lazy = inspectResult && inspectResult.lazy;
    childFlow.defineSkip(token.start);
    childFlow.write(self2.sliceStream(token));
  }
  function exitContainers(size2, end) {
    var index2 = stack.length;
    if (childFlow && end) {
      childFlow.write([null]);
      childToken = childFlow = void 0;
    }
    while (index2-- > size2) {
      self2.containerState = stack[index2][1];
      stack[index2][0].exit.call(self2, effects);
    }
    stack.length = size2;
  }
  function tokenizeInspect(effects2, ok2) {
    var subcontinued = 0;
    inspectResult = {};
    return inspectStart;
    function inspectStart(code2) {
      if (subcontinued < stack.length) {
        self2.containerState = stack[subcontinued][1];
        return effects2.attempt(
          stack[subcontinued][0].continuation,
          inspectContinue,
          inspectLess
        )(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        inspectResult.flowContinue = true;
        return inspectDone(code2);
      }
      self2.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
      self2.containerState = {};
      return effects2.attempt(
        containerConstruct,
        inspectFlowEnd,
        inspectDone
      )(code2);
    }
    function inspectContinue(code2) {
      subcontinued++;
      return self2.containerState._closeFlow ? inspectFlowEnd(code2) : inspectStart(code2);
    }
    function inspectLess(code2) {
      if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
        self2.containerState = {};
        return effects2.attempt(
          containerConstruct,
          inspectFlowEnd,
          // Maybe flow, or a blank line?
          effects2.attempt(
            lazyFlowConstruct,
            inspectFlowEnd,
            effects2.check(partialBlankLine$3, inspectFlowEnd, inspectLazy)
          )
        )(code2);
      }
      return inspectFlowEnd(code2);
    }
    function inspectLazy(code2) {
      subcontinued = stack.length;
      inspectResult.lazy = true;
      inspectResult.flowContinue = true;
      return inspectDone(code2);
    }
    function inspectFlowEnd(code2) {
      inspectResult.flowEnd = true;
      return inspectDone(code2);
    }
    function inspectDone(code2) {
      inspectResult.continued = subcontinued;
      self2.interrupt = self2.containerState = void 0;
      return ok2(code2);
    }
  }
}
function tokenizeContainer(effects, ok2, nok) {
  return factorySpace$e(
    effects,
    effects.attempt(this.parser.constructs.document, ok2, nok),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
function tokenizeLazyFlow(effects, ok2, nok) {
  return factorySpace$e(
    effects,
    effects.lazy(this.parser.constructs.flow, ok2, nok),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
document$3.tokenize = tokenize$1;
var flow$2 = {};
var assign$3 = assign_1;
var chunkedSplice$6 = chunkedSplice_1;
var shallow$5 = shallow_1;
function subtokenize$2(events) {
  var jumps = {};
  var index2 = -1;
  var event;
  var lineIndex;
  var otherIndex;
  var otherEvent;
  var parameters;
  var subevents;
  var more;
  while (++index2 < events.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events[index2];
    if (index2 && event[1].type === "chunkFlow" && events[index2 - 1][1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1].isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        assign$3(jumps, subcontent(events, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container || event[1]._movePreviousLineEndings) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events[otherIndex];
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events[lineIndex][1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = shallow$5(events[lineIndex][1].start);
        parameters = events.slice(lineIndex, index2);
        parameters.unshift(event);
        chunkedSplice$6(events, lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  return !more;
}
function subcontent(events, eventIndex) {
  var token = events[eventIndex][1];
  var context = events[eventIndex][2];
  var startPosition = eventIndex - 1;
  var startPositions = [];
  var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
  var childEvents = tokenizer.events;
  var jumps = [];
  var gaps = {};
  var stream;
  var previous2;
  var index2;
  var entered;
  var end;
  var adjust;
  while (token) {
    while (events[++startPosition][1] !== token) {
    }
    startPositions.push(startPosition);
    if (!token._tokenizer) {
      stream = context.sliceStream(token);
      if (!token.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(token.start);
      }
      if (token.isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (token.isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = token;
    token = token.next;
  }
  token = previous2;
  index2 = childEvents.length;
  while (index2--) {
    if (childEvents[index2][0] === "enter") {
      entered = true;
    } else if (
      // Find a void token that includes a break.
      entered && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      add(childEvents.slice(index2 + 1, end));
      token._tokenizer = token.next = void 0;
      token = token.previous;
      end = index2 + 1;
    }
  }
  tokenizer.events = token._tokenizer = token.next = void 0;
  add(childEvents.slice(0, end));
  index2 = -1;
  adjust = 0;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
  function add(slice2) {
    var start = startPositions.pop();
    jumps.unshift([start, start + slice2.length - 1]);
    chunkedSplice$6(events, start, 2, slice2);
  }
}
var subtokenize_1 = subtokenize$2;
var markdownLineEnding$f = markdownLineEnding_1;
var prefixSize$3 = prefixSize_1;
var subtokenize$1 = subtokenize_1;
var factorySpace$d = factorySpace$h;
var content$2 = {
  tokenize: tokenizeContent,
  resolve: resolveContent,
  interruptible: true,
  lazy: true
};
var continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
};
function resolveContent(events) {
  subtokenize$1(events);
  return events;
}
function tokenizeContent(effects, ok2) {
  var previous2;
  return start;
  function start(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding$f(code2)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code2);
    }
    effects.consume(code2);
    return data;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok2(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2 = previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    return data;
  }
}
function tokenizeContinuation(effects, ok2, nok) {
  var self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$d(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding$f(code2)) {
      return nok(code2);
    }
    if (self2.parser.constructs.disable.null.indexOf("codeIndented") > -1 || prefixSize$3(self2.events, "linePrefix") < 4) {
      return effects.interrupt(self2.parser.constructs.flow, nok, ok2)(code2);
    }
    return ok2(code2);
  }
}
var content_1 = content$2;
Object.defineProperty(flow$2, "__esModule", { value: true });
var content$1 = content_1;
var factorySpace$c = factorySpace$h;
var partialBlankLine$2 = partialBlankLine_1;
var tokenize = initializeFlow;
function initializeFlow(effects) {
  var self2 = this;
  var initial = effects.attempt(
    // Try to parse a blank line.
    partialBlankLine$2,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace$c(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content$1, afterConstruct)
        ),
        "linePrefix"
      )
    )
  );
  return initial;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial;
  }
}
flow$2.tokenize = tokenize;
var text$4 = {};
Object.defineProperty(text$4, "__esModule", { value: true });
var assign$2 = assign_1;
var shallow$4 = shallow_1;
var text$3 = initializeFactory("text");
var string$1 = initializeFactory("string");
var resolver = {
  resolveAll: createResolver()
};
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === "text" ? resolveAllLineSuffixes : void 0
    )
  };
  function initializeText(effects) {
    var self2 = this;
    var constructs2 = this.parser.constructs[field];
    var text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      var list2 = constructs2[code2];
      var index2 = -1;
      if (code2 === null) {
        return true;
      }
      if (list2) {
        while (++index2 < list2.length) {
          if (!list2[index2].previous || list2[index2].previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events, context) {
    var index2 = -1;
    var enter;
    while (++index2 <= events.length) {
      if (enter === void 0) {
        if (events[index2] && events[index2][1].type === "data") {
          enter = index2;
          index2++;
        }
      } else if (!events[index2] || events[index2][1].type !== "data") {
        if (index2 !== enter + 2) {
          events[enter][1].end = events[index2 - 1][1].end;
          events.splice(enter + 2, index2 - enter - 2);
          index2 = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events, context) : events;
  }
}
function resolveAllLineSuffixes(events, context) {
  var eventIndex = -1;
  var chunks;
  var data;
  var chunk;
  var index2;
  var bufferIndex;
  var size2;
  var tabs;
  var token;
  while (++eventIndex <= events.length) {
    if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
      data = events[eventIndex - 1][1];
      chunks = context.sliceStream(data);
      index2 = chunks.length;
      bufferIndex = -1;
      size2 = 0;
      tabs = void 0;
      while (index2--) {
        chunk = chunks[index2];
        if (typeof chunk === "string") {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size2++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } else if (chunk === -2) {
          tabs = true;
          size2++;
        } else if (chunk === -1) ;
        else {
          index2++;
          break;
        }
      }
      if (size2) {
        token = {
          type: eventIndex === events.length || tabs || size2 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: data.end.line,
            column: data.end.column - size2,
            offset: data.end.offset - size2,
            _index: data.start._index + index2,
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex
          },
          end: shallow$4(data.end)
        };
        data.end = shallow$4(token.start);
        if (data.start.offset === data.end.offset) {
          assign$2(data, token);
        } else {
          events.splice(
            eventIndex,
            0,
            ["enter", token, context],
            ["exit", token, context]
          );
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events;
}
text$4.resolver = resolver;
text$4.string = string$1;
text$4.text = text$3;
var chunkedSplice$5 = chunkedSplice_1;
function chunkedPush$3(list2, items) {
  if (list2.length) {
    chunkedSplice$5(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
var chunkedPush_1 = chunkedPush$3;
var fromCharCode$1 = fromCharCode_1;
function serializeChunks$1(chunks) {
  var index2 = -1;
  var result = [];
  var chunk;
  var value;
  var atTab;
  while (++index2 < chunks.length) {
    chunk = chunks[index2];
    if (typeof chunk === "string") {
      value = chunk;
    } else if (chunk === -5) {
      value = "\r";
    } else if (chunk === -4) {
      value = "\n";
    } else if (chunk === -3) {
      value = "\r\n";
    } else if (chunk === -2) {
      value = "	";
    } else if (chunk === -1) {
      if (atTab) continue;
      value = " ";
    } else {
      value = fromCharCode$1(chunk);
    }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join("");
}
var serializeChunks_1 = serializeChunks$1;
function sliceChunks$1(chunks, token) {
  var startIndex = token.start._index;
  var startBufferIndex = token.start._bufferIndex;
  var endIndex = token.end._index;
  var endBufferIndex = token.end._bufferIndex;
  var view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      view[0] = view[0].slice(startBufferIndex);
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
var sliceChunks_1 = sliceChunks$1;
var assign$1 = assign_1;
var markdownLineEnding$e = markdownLineEnding_1;
var chunkedPush$2 = chunkedPush_1;
var chunkedSplice$4 = chunkedSplice_1;
var miniflat$1 = miniflat_1;
var resolveAll$2 = resolveAll_1;
var serializeChunks = serializeChunks_1;
var shallow$3 = shallow_1;
var sliceChunks = sliceChunks_1;
function createTokenizer$1(parser2, initialize, from) {
  var point2 = from ? shallow$3(from) : {
    line: 1,
    column: 1,
    offset: 0
  };
  var columnStart = {};
  var resolveAllConstructs = [];
  var chunks = [];
  var stack = [];
  var effects = {
    consume,
    enter,
    exit: exit2,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    }),
    lazy: constructFactory(onsuccessfulcheck, {
      lazy: true
    })
  };
  var context = {
    previous: null,
    events: [],
    parser: parser2,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip: skip,
    write
  };
  var state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  point2._index = 0;
  point2._bufferIndex = -1;
  return context;
  function write(slice2) {
    chunks = chunkedPush$2(chunks, slice2);
    main();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll$2(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token) {
    return serializeChunks(sliceStream(token));
  }
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  function now() {
    return shallow$3(point2);
  }
  function skip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main() {
    var chunkIndex;
    var chunk;
    while (point2._index < chunks.length) {
      chunk = chunks[point2._index];
      if (typeof chunk === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point2._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }
  function go(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding$e(code2)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    var token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(["enter", token, context]);
    stack.push(token);
    return token;
  }
  function exit2(type) {
    var token = stack.pop();
    token.end = now();
    context.events.push(["exit", token, context]);
    return token;
  }
  function onsuccessfulconstruct(construct, info2) {
    addResult(construct, info2.from);
  }
  function onsuccessfulcheck(construct, info2) {
    info2.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      var listOfConstructs;
      var constructIndex;
      var currentConstruct;
      var info2;
      return constructs2.tokenize || "length" in constructs2 ? handleListOfConstructs(miniflat$1(constructs2)) : handleMapOfConstructs;
      function handleMapOfConstructs(code2) {
        if (code2 in constructs2 || null in constructs2) {
          return handleListOfConstructs(
            constructs2.null ? (
              /* c8 ignore next */
              miniflat$1(constructs2[code2]).concat(miniflat$1(constructs2.null))
            ) : constructs2[code2]
          )(code2);
        }
        return bogusState(code2);
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info2 = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) {
            return nok();
          }
          return construct.tokenize.call(
            fields ? assign$1({}, context, fields) : context,
            effects,
            ok2,
            nok
          )(code2);
        }
      }
      function ok2(code2) {
        onreturn(currentConstruct, info2);
        return returnState;
      }
      function nok(code2) {
        info2.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from2) {
    if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      chunkedSplice$4(
        context.events,
        from2,
        context.events.length - from2,
        construct.resolve(context.events.slice(from2), context)
      );
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store() {
    var startPoint = now();
    var startPrevious = context.previous;
    var startCurrentConstruct = context.currentConstruct;
    var startEventsIndex = context.events.length;
    var startStack = Array.from(stack);
    return {
      restore,
      from: startEventsIndex
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
var createTokenizer_1 = createTokenizer$1;
var constructs$1 = {};
function movePoint$1(point2, offset2) {
  point2.column += offset2;
  point2.offset += offset2;
  point2._bufferIndex += offset2;
  return point2;
}
var movePoint_1 = movePoint$1;
var chunkedPush$1 = chunkedPush_1;
var chunkedSplice$3 = chunkedSplice_1;
var classifyCharacter = classifyCharacter_1;
var movePoint = movePoint_1;
var resolveAll$1 = resolveAll_1;
var shallow$2 = shallow_1;
var attention$1 = {
  name: "attention",
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
function resolveAllAttention(events, context) {
  var index2 = -1;
  var open;
  var group;
  var text2;
  var openingSequence;
  var closingSequence;
  var use;
  var nextEvents;
  var offset2;
  while (++index2 < events.length) {
    if (events[index2][0] === "enter" && events[index2][1].type === "attentionSequence" && events[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index2][1]).charCodeAt(0)) {
          if ((events[open][1]._close || events[index2][1]._open) && (events[index2][1].end.offset - events[index2][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index2][1].end.offset - events[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index2][1].end.offset - events[index2][1].start.offset > 1 ? 2 : 1;
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: movePoint(shallow$2(events[open][1].end), -use),
            end: shallow$2(events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: shallow$2(events[index2][1].start),
            end: movePoint(shallow$2(events[index2][1].start), use)
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: shallow$2(events[open][1].end),
            end: shallow$2(events[index2][1].start)
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: shallow$2(openingSequence.start),
            end: shallow$2(closingSequence.end)
          };
          events[open][1].end = shallow$2(openingSequence.start);
          events[index2][1].start = shallow$2(closingSequence.end);
          nextEvents = [];
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = chunkedPush$1(nextEvents, [
              ["enter", events[open][1], context],
              ["exit", events[open][1], context]
            ]);
          }
          nextEvents = chunkedPush$1(nextEvents, [
            ["enter", group, context],
            ["enter", openingSequence, context],
            ["exit", openingSequence, context],
            ["enter", text2, context]
          ]);
          nextEvents = chunkedPush$1(
            nextEvents,
            resolveAll$1(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index2),
              context
            )
          );
          nextEvents = chunkedPush$1(nextEvents, [
            ["exit", text2, context],
            ["enter", closingSequence, context],
            ["exit", closingSequence, context],
            ["exit", group, context]
          ]);
          if (events[index2][1].end.offset - events[index2][1].start.offset) {
            offset2 = 2;
            nextEvents = chunkedPush$1(nextEvents, [
              ["enter", events[index2][1], context],
              ["exit", events[index2][1], context]
            ]);
          } else {
            offset2 = 0;
          }
          chunkedSplice$3(events, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset2 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events.length) {
    if (events[index2][1].type === "attentionSequence") {
      events[index2][1].type = "data";
    }
  }
  return events;
}
function tokenizeAttention(effects, ok2) {
  var before = classifyCharacter(this.previous);
  var marker;
  return start;
  function start(code2) {
    effects.enter("attentionSequence");
    marker = code2;
    return sequence(code2);
  }
  function sequence(code2) {
    var token;
    var after;
    var open;
    var close;
    if (code2 === marker) {
      effects.consume(code2);
      return sequence;
    }
    token = effects.exit("attentionSequence");
    after = classifyCharacter(code2);
    open = !after || after === 2 && before;
    close = !before || before === 2 && after;
    token._open = marker === 42 ? open : open && (before || !close);
    token._close = marker === 42 ? close : close && (after || !open);
    return ok2(code2);
  }
}
var attention_1 = attention$1;
var regexCheck$3 = regexCheck_1;
var asciiAtext$1 = regexCheck$3(/[#-'*+\--9=?A-Z^-~]/);
var asciiAtext_1 = asciiAtext$1;
var asciiAlpha$2 = asciiAlpha_1;
var asciiAlphanumeric$3 = asciiAlphanumeric_1;
var asciiAtext = asciiAtext_1;
var asciiControl$1 = asciiControl_1;
var autolink$1 = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok2, nok) {
  var size2 = 1;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha$2(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    return asciiAtext(code2) ? emailAtext(code2) : nok(code2);
  }
  function schemeOrEmailAtext(code2) {
    return code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric$3(code2) ? schemeInsideOrEmailAtext(code2) : emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric$3(code2)) && size2++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      return end(code2);
    }
    if (code2 === 32 || code2 === 60 || asciiControl$1(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (asciiAtext(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric$3(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      return end(code2);
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric$3(code2)) && size2++ < 63) {
      effects.consume(code2);
      return code2 === 45 ? emailValue : emailLabel;
    }
    return nok(code2);
  }
  function end(code2) {
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.exit("autolink");
    return ok2;
  }
}
var autolink_1 = autolink$1;
var markdownSpace$7 = markdownSpace_1;
var factorySpace$b = factorySpace$h;
var blockQuote$1 = {
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
};
function tokenizeBlockQuoteStart(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      if (!self2.containerState.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        self2.containerState.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    if (markdownSpace$7(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok2;
    }
    effects.exit("blockQuotePrefix");
    return ok2(code2);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok2, nok) {
  return factorySpace$b(
    effects,
    effects.attempt(blockQuote$1, ok2, nok),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
function exit(effects) {
  effects.exit("blockQuote");
}
var blockQuote_1 = blockQuote$1;
var regexCheck$2 = regexCheck_1;
var asciiPunctuation$1 = regexCheck$2(/[!-/:-@[-`{-~]/);
var asciiPunctuation_1 = asciiPunctuation$1;
var asciiPunctuation = asciiPunctuation_1;
var characterEscape$1 = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return open;
  }
  function open(code2) {
    if (asciiPunctuation(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok2;
    }
    return nok(code2);
  }
}
var characterEscape_1 = characterEscape$1;
var el;
var semicolon = 59;
var decodeEntity_browser = decodeEntity$1;
function decodeEntity$1(characters) {
  var entity = "&" + characters + ";";
  var char;
  el = el || document.createElement("i");
  el.innerHTML = entity;
  char = el.textContent;
  if (char.charCodeAt(char.length - 1) === semicolon && characters !== "semi") {
    return false;
  }
  return char === entity ? false : char;
}
var regexCheck$1 = regexCheck_1;
var asciiDigit$2 = regexCheck$1(/\d/);
var asciiDigit_1 = asciiDigit$2;
var regexCheck = regexCheck_1;
var asciiHexDigit$1 = regexCheck(/[\dA-Fa-f]/);
var asciiHexDigit_1 = asciiHexDigit$1;
var decodeEntity = decodeEntity_browser;
var asciiAlphanumeric$2 = asciiAlphanumeric_1;
var asciiDigit$1 = asciiDigit_1;
var asciiHexDigit = asciiHexDigit_1;
function _interopDefaultLegacy(e3) {
  return e3 && typeof e3 === "object" && "default" in e3 ? e3 : { default: e3 };
}
var decodeEntity__default = /* @__PURE__ */ _interopDefaultLegacy(decodeEntity);
var characterReference$1 = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok2, nok) {
  var self2 = this;
  var size2 = 0;
  var max2;
  var test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric$2;
    return value(code2);
  }
  function numeric(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit$1;
    return value(code2);
  }
  function value(code2) {
    var token;
    if (code2 === 59 && size2) {
      token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric$2 && !decodeEntity__default["default"](self2.sliceSerialize(token))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok2;
    }
    if (test(code2) && size2++ < max2) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
var characterReference_1 = characterReference$1;
var markdownLineEnding$d = markdownLineEnding_1;
var markdownLineEndingOrSpace$6 = markdownLineEndingOrSpace_1;
var prefixSize$2 = prefixSize_1;
var factorySpace$a = factorySpace$h;
var codeFenced$1 = {
  name: "codeFenced",
  tokenize: tokenizeCodeFenced,
  concrete: true
};
function tokenizeCodeFenced(effects, ok2, nok) {
  var self2 = this;
  var closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  };
  var initialPrefix = prefixSize$2(this.events, "linePrefix");
  var sizeOpen = 0;
  var marker;
  return start;
  function start(code2) {
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    marker = code2;
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeFencedFenceSequence");
    return sizeOpen < 3 ? nok(code2) : factorySpace$a(effects, infoOpen, "whitespace")(code2);
  }
  function infoOpen(code2) {
    if (code2 === null || markdownLineEnding$d(code2)) {
      return openAfter(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info2(code2);
  }
  function info2(code2) {
    if (code2 === null || markdownLineEndingOrSpace$6(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace$a(effects, infoAfter, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) return nok(code2);
    effects.consume(code2);
    return info2;
  }
  function infoAfter(code2) {
    if (code2 === null || markdownLineEnding$d(code2)) {
      return openAfter(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code2);
  }
  function meta(code2) {
    if (code2 === null || markdownLineEnding$d(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return openAfter(code2);
    }
    if (code2 === 96 && code2 === marker) return nok(code2);
    effects.consume(code2);
    return meta;
  }
  function openAfter(code2) {
    effects.exit("codeFencedFence");
    return self2.interrupt ? ok2(code2) : content2(code2);
  }
  function content2(code2) {
    if (code2 === null) {
      return after(code2);
    }
    if (markdownLineEnding$d(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return effects.attempt(
        closingFenceConstruct,
        after,
        initialPrefix ? factorySpace$a(effects, content2, "linePrefix", initialPrefix + 1) : content2
      );
    }
    effects.enter("codeFlowValue");
    return contentContinue(code2);
  }
  function contentContinue(code2) {
    if (code2 === null || markdownLineEnding$d(code2)) {
      effects.exit("codeFlowValue");
      return content2(code2);
    }
    effects.consume(code2);
    return contentContinue;
  }
  function after(code2) {
    effects.exit("codeFenced");
    return ok2(code2);
  }
  function tokenizeClosingFence(effects2, ok3, nok2) {
    var size2 = 0;
    return factorySpace$a(
      effects2,
      closingSequenceStart,
      "linePrefix",
      this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    );
    function closingSequenceStart(code2) {
      effects2.enter("codeFencedFence");
      effects2.enter("codeFencedFenceSequence");
      return closingSequence(code2);
    }
    function closingSequence(code2) {
      if (code2 === marker) {
        effects2.consume(code2);
        size2++;
        return closingSequence;
      }
      if (size2 < sizeOpen) return nok2(code2);
      effects2.exit("codeFencedFenceSequence");
      return factorySpace$a(effects2, closingSequenceEnd, "whitespace")(code2);
    }
    function closingSequenceEnd(code2) {
      if (code2 === null || markdownLineEnding$d(code2)) {
        effects2.exit("codeFencedFence");
        return ok3(code2);
      }
      return nok2(code2);
    }
  }
}
var codeFenced_1 = codeFenced$1;
var markdownLineEnding$c = markdownLineEnding_1;
var chunkedSplice$2 = chunkedSplice_1;
var prefixSize$1 = prefixSize_1;
var factorySpace$9 = factorySpace$h;
var codeIndented$1 = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented,
  resolve: resolveCodeIndented
};
var indentedContentConstruct = {
  tokenize: tokenizeIndentedContent,
  partial: true
};
function resolveCodeIndented(events, context) {
  var code2 = {
    type: "codeIndented",
    start: events[0][1].start,
    end: events[events.length - 1][1].end
  };
  chunkedSplice$2(events, 0, 0, [["enter", code2, context]]);
  chunkedSplice$2(events, events.length, 0, [["exit", code2, context]]);
  return events;
}
function tokenizeCodeIndented(effects, ok2, nok) {
  return effects.attempt(indentedContentConstruct, afterPrefix, nok);
  function afterPrefix(code2) {
    if (code2 === null) {
      return ok2(code2);
    }
    if (markdownLineEnding$c(code2)) {
      return effects.attempt(indentedContentConstruct, afterPrefix, ok2)(code2);
    }
    effects.enter("codeFlowValue");
    return content2(code2);
  }
  function content2(code2) {
    if (code2 === null || markdownLineEnding$c(code2)) {
      effects.exit("codeFlowValue");
      return afterPrefix(code2);
    }
    effects.consume(code2);
    return content2;
  }
}
function tokenizeIndentedContent(effects, ok2, nok) {
  var self2 = this;
  return factorySpace$9(effects, afterPrefix, "linePrefix", 4 + 1);
  function afterPrefix(code2) {
    if (markdownLineEnding$c(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace$9(effects, afterPrefix, "linePrefix", 4 + 1);
    }
    return prefixSize$1(self2.events, "linePrefix") < 4 ? nok(code2) : ok2(code2);
  }
}
var codeIndented_1 = codeIndented$1;
var markdownLineEnding$b = markdownLineEnding_1;
var codeText$1 = {
  name: "codeText",
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
};
function resolveCodeText(events) {
  var tailExitIndex = events.length - 4;
  var headEnterIndex = 3;
  var index2;
  var enter;
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events[index2][1].type === "codeTextData") {
        events[tailExitIndex][1].type = events[headEnterIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter === void 0) {
      if (index2 !== tailExitIndex && events[index2][1].type !== "lineEnding") {
        enter = index2;
      }
    } else if (index2 === tailExitIndex || events[index2][1].type === "lineEnding") {
      events[enter][1].type = "codeTextData";
      if (index2 !== enter + 2) {
        events[enter][1].end = events[index2 - 1][1].end;
        events.splice(enter + 2, index2 - enter - 2);
        tailExitIndex -= index2 - enter - 2;
        index2 = enter + 2;
      }
      enter = void 0;
    }
  }
  return events;
}
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok2, nok) {
  var sizeOpen = 0;
  var size2;
  var token;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return openingSequence(code2);
  }
  function openingSequence(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return openingSequence;
    }
    effects.exit("codeTextSequence");
    return gap(code2);
  }
  function gap(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 96) {
      token = effects.enter("codeTextSequence");
      size2 = 0;
      return closingSequence(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return gap;
    }
    if (markdownLineEnding$b(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return gap;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding$b(code2)) {
      effects.exit("codeTextData");
      return gap(code2);
    }
    effects.consume(code2);
    return data;
  }
  function closingSequence(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size2++;
      return closingSequence;
    }
    if (size2 === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok2(code2);
    }
    token.type = "codeTextData";
    return data(code2);
  }
}
var codeText_1 = codeText$1;
var asciiControl = asciiControl_1;
var markdownLineEndingOrSpace$5 = markdownLineEndingOrSpace_1;
var markdownLineEnding$a = markdownLineEnding_1;
function destinationFactory(effects, ok2, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  var limit = max2 || Infinity;
  var balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return destinationEnclosedBefore;
    }
    if (asciiControl(code2) || code2 === 41) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return destinationRaw(code2);
  }
  function destinationEnclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return destinationEnclosed(code2);
  }
  function destinationEnclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return destinationEnclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding$a(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? destinationEnclosedEscape : destinationEnclosed;
  }
  function destinationEnclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return destinationEnclosed;
    }
    return destinationEnclosed(code2);
  }
  function destinationRaw(code2) {
    if (code2 === 40) {
      if (++balance > limit) return nok(code2);
      effects.consume(code2);
      return destinationRaw;
    }
    if (code2 === 41) {
      if (!balance--) {
        effects.exit("chunkString");
        effects.exit(stringType);
        effects.exit(rawType);
        effects.exit(type);
        return ok2(code2);
      }
      effects.consume(code2);
      return destinationRaw;
    }
    if (code2 === null || markdownLineEndingOrSpace$5(code2)) {
      if (balance) return nok(code2);
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok2(code2);
    }
    if (asciiControl(code2)) return nok(code2);
    effects.consume(code2);
    return code2 === 92 ? destinationRawEscape : destinationRaw;
  }
  function destinationRawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return destinationRaw;
    }
    return destinationRaw(code2);
  }
}
var factoryDestination$2 = destinationFactory;
var markdownLineEnding$9 = markdownLineEnding_1;
var markdownSpace$6 = markdownSpace_1;
function labelFactory(effects, ok2, nok, type, markerType, stringType) {
  var self2 = this;
  var size2 = 0;
  var data;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 && !data || /* c8 ignore next */
    code2 === 94 && /* c8 ignore next */
    !size2 && /* c8 ignore next */
    "_hiddenFootnoteSupport" in self2.parser.constructs || size2 > 999) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    if (markdownLineEnding$9(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return label(code2);
  }
  function label(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding$9(code2) || size2++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    data = data || !markdownSpace$6(code2);
    return code2 === 92 ? labelEscape : label;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size2++;
      return label;
    }
    return label(code2);
  }
}
var factoryLabel$2 = labelFactory;
var markdownLineEnding$8 = markdownLineEnding_1;
var markdownSpace$5 = markdownSpace_1;
var factorySpace$8 = factorySpace$h;
function whitespaceFactory(effects, ok2) {
  var seen;
  return start;
  function start(code2) {
    if (markdownLineEnding$8(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace$5(code2)) {
      return factorySpace$8(
        effects,
        start,
        seen ? "linePrefix" : "lineSuffix"
      )(code2);
    }
    return ok2(code2);
  }
}
var factoryWhitespace$2 = whitespaceFactory;
var markdownLineEnding$7 = markdownLineEnding_1;
var factorySpace$7 = factorySpace$h;
function titleFactory(effects, ok2, nok, type, markerType, stringType) {
  var marker;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    marker = code2 === 40 ? 41 : code2;
    return atFirstTitleBreak;
  }
  function atFirstTitleBreak(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    return atTitleBreak(code2);
  }
  function atTitleBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return atFirstTitleBreak(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding$7(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace$7(effects, atTitleBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return title(code2);
  }
  function title(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding$7(code2)) {
      effects.exit("chunkString");
      return atTitleBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? titleEscape : title;
  }
  function titleEscape(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return title;
    }
    return title(code2);
  }
}
var factoryTitle$2 = titleFactory;
var markdownLineEnding$6 = markdownLineEnding_1;
var markdownLineEndingOrSpace$4 = markdownLineEndingOrSpace_1;
var normalizeIdentifier$2 = normalizeIdentifier_1;
var factoryDestination$1 = factoryDestination$2;
var factoryLabel$1 = factoryLabel$2;
var factorySpace$6 = factorySpace$h;
var factoryWhitespace$1 = factoryWhitespace$2;
var factoryTitle$1 = factoryTitle$2;
var definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition
};
var titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
};
function tokenizeDefinition(effects, ok2, nok) {
  var self2 = this;
  var identifier;
  return start;
  function start(code2) {
    effects.enter("definition");
    return factoryLabel$1.call(
      self2,
      effects,
      labelAfter,
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier = normalizeIdentifier$2(
      self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
    );
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return factoryWhitespace$1(
        effects,
        factoryDestination$1(
          effects,
          effects.attempt(
            titleConstruct,
            factorySpace$6(effects, after, "whitespace"),
            factorySpace$6(effects, after, "whitespace")
          ),
          nok,
          "definitionDestination",
          "definitionDestinationLiteral",
          "definitionDestinationLiteralMarker",
          "definitionDestinationRaw",
          "definitionDestinationString"
        )
      );
    }
    return nok(code2);
  }
  function after(code2) {
    if (code2 === null || markdownLineEnding$6(code2)) {
      effects.exit("definition");
      if (self2.parser.defined.indexOf(identifier) < 0) {
        self2.parser.defined.push(identifier);
      }
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitle(effects, ok2, nok) {
  return start;
  function start(code2) {
    return markdownLineEndingOrSpace$4(code2) ? factoryWhitespace$1(effects, before)(code2) : nok(code2);
  }
  function before(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle$1(
        effects,
        factorySpace$6(effects, after, "whitespace"),
        nok,
        "definitionTitle",
        "definitionTitleMarker",
        "definitionTitleString"
      )(code2);
    }
    return nok(code2);
  }
  function after(code2) {
    return code2 === null || markdownLineEnding$6(code2) ? ok2(code2) : nok(code2);
  }
}
var definition_1 = definition$1;
var markdownLineEnding$5 = markdownLineEnding_1;
var hardBreakEscape$1 = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (markdownLineEnding$5(code2)) {
      effects.exit("escapeMarker");
      effects.exit("hardBreakEscape");
      return ok2(code2);
    }
    return nok(code2);
  }
}
var hardBreakEscape_1 = hardBreakEscape$1;
var markdownLineEnding$4 = markdownLineEnding_1;
var markdownLineEndingOrSpace$3 = markdownLineEndingOrSpace_1;
var markdownSpace$4 = markdownSpace_1;
var chunkedSplice$1 = chunkedSplice_1;
var factorySpace$5 = factorySpace$h;
var headingAtx$1 = {
  name: "headingAtx",
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
function resolveHeadingAtx(events, context) {
  var contentEnd = events.length - 2;
  var contentStart = 3;
  var content2;
  var text2;
  if (events[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: "text"
    };
    chunkedSplice$1(events, contentStart, contentEnd - contentStart + 1, [
      ["enter", content2, context],
      ["enter", text2, context],
      ["exit", text2, context],
      ["exit", content2, context]
    ]);
  }
  return events;
}
function tokenizeHeadingAtx(effects, ok2, nok) {
  var self2 = this;
  var size2 = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    effects.enter("atxHeadingSequence");
    return fenceOpenInside(code2);
  }
  function fenceOpenInside(code2) {
    if (code2 === 35 && size2++ < 6) {
      effects.consume(code2);
      return fenceOpenInside;
    }
    if (code2 === null || markdownLineEndingOrSpace$3(code2)) {
      effects.exit("atxHeadingSequence");
      return self2.interrupt ? ok2(code2) : headingBreak(code2);
    }
    return nok(code2);
  }
  function headingBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequence(code2);
    }
    if (code2 === null || markdownLineEnding$4(code2)) {
      effects.exit("atxHeading");
      return ok2(code2);
    }
    if (markdownSpace$4(code2)) {
      return factorySpace$5(effects, headingBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequence(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequence;
    }
    effects.exit("atxHeadingSequence");
    return headingBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace$3(code2)) {
      effects.exit("atxHeadingText");
      return headingBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
var headingAtx_1 = headingAtx$1;
var basics = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
var htmlBlockNames$1 = basics;
var raws = ["pre", "script", "style", "textarea"];
var htmlRawNames$1 = raws;
var asciiAlpha$1 = asciiAlpha_1;
var asciiAlphanumeric$1 = asciiAlphanumeric_1;
var markdownLineEnding$3 = markdownLineEnding_1;
var markdownLineEndingOrSpace$2 = markdownLineEndingOrSpace_1;
var markdownSpace$3 = markdownSpace_1;
var fromCharCode = fromCharCode_1;
var htmlBlockNames = htmlBlockNames$1;
var htmlRawNames = htmlRawNames$1;
var partialBlankLine$1 = partialBlankLine_1;
var htmlFlow$1 = {
  name: "htmlFlow",
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};
var nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
};
function resolveToHtmlFlow(events) {
  var index2 = events.length;
  while (index2--) {
    if (events[index2][0] === "enter" && events[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events[index2 - 2][1].type === "linePrefix") {
    events[index2][1].start = events[index2 - 2][1].start;
    events[index2 + 1][1].start = events[index2 - 2][1].start;
    events.splice(index2 - 2, 2);
  }
  return events;
}
function tokenizeHtmlFlow(effects, ok2, nok) {
  var self2 = this;
  var kind;
  var startTag;
  var buffer2;
  var index2;
  var marker;
  return start;
  function start(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationStart;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      kind = 3;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      buffer2 = fromCharCode(code2);
      startTag = true;
      return tagName;
    }
    return nok(code2);
  }
  function declarationStart(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      kind = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      kind = 5;
      buffer2 = "CDATA[";
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      kind = 4;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    if (code2 === buffer2.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === buffer2.length ? self2.interrupt ? ok2 : continuation : cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      buffer2 = fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$2(code2)) {
      if (code2 !== 47 && startTag && htmlRawNames.indexOf(buffer2.toLowerCase()) > -1) {
        kind = 1;
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      if (htmlBlockNames.indexOf(buffer2.toLowerCase()) > -1) {
        kind = 6;
        if (code2 === 47) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      kind = 7;
      return self2.interrupt ? nok(code2) : startTag ? completeAttributeNameBefore(code2) : completeClosingTagAfter(code2);
    }
    if (code2 === 45 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      buffer2 += fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace$3(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha$1(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace$3(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace$3(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace$3(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    marker = void 0;
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding$3(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace$2(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace$3(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (markdownSpace$3(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return code2 === null || markdownLineEnding$3(code2) ? continuation(code2) : nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && kind === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && kind === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && kind === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && kind === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && kind === 5) {
      effects.consume(code2);
      return continuationCharacterDataInside;
    }
    if (markdownLineEnding$3(code2) && (kind === 6 || kind === 7)) {
      return effects.check(
        nextBlankConstruct,
        continuationClose,
        continuationAtLineEnding
      )(code2);
    }
    if (code2 === null || markdownLineEnding$3(code2)) {
      return continuationAtLineEnding(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationAtLineEnding(code2) {
    effects.exit("htmlFlowData");
    return htmlContinueStart(code2);
  }
  function htmlContinueStart(code2) {
    if (code2 === null) {
      return done(code2);
    }
    if (markdownLineEnding$3(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return htmlContinueStart;
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer2 = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62 && htmlRawNames.indexOf(buffer2.toLowerCase()) > -1) {
      effects.consume(code2);
      return continuationClose;
    }
    if (asciiAlpha$1(code2) && buffer2.length < 8) {
      effects.consume(code2);
      buffer2 += fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCharacterDataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding$3(code2)) {
      effects.exit("htmlFlowData");
      return done(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function done(code2) {
    effects.exit("htmlFlow");
    return ok2(code2);
  }
}
function tokenizeNextBlank(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.exit("htmlFlowData");
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    return effects.attempt(partialBlankLine$1, ok2, nok);
  }
}
var htmlFlow_1 = htmlFlow$1;
var asciiAlpha = asciiAlpha_1;
var asciiAlphanumeric = asciiAlphanumeric_1;
var markdownLineEnding$2 = markdownLineEnding_1;
var markdownLineEndingOrSpace$1 = markdownLineEndingOrSpace_1;
var markdownSpace$2 = markdownSpace_1;
var factorySpace$4 = factorySpace$h;
var htmlText$1 = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok2, nok) {
  var self2 = this;
  var marker;
  var buffer2;
  var index2;
  var returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpen;
    }
    if (code2 === 91) {
      effects.consume(code2);
      buffer2 = "CDATA[";
      index2 = 0;
      return cdataOpen;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return declaration;
    }
    return nok(code2);
  }
  function commentOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentStart;
    }
    return nok(code2);
  }
  function commentStart(code2) {
    if (code2 === null || code2 === 62) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentStartDash;
    }
    return comment(code2);
  }
  function commentStartDash(code2) {
    if (code2 === null || code2 === 62) {
      return nok(code2);
    }
    return comment(code2);
  }
  function comment(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = comment;
      return atLineEnding(code2);
    }
    effects.consume(code2);
    return comment;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return end;
    }
    return comment(code2);
  }
  function cdataOpen(code2) {
    if (code2 === buffer2.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === buffer2.length ? cdata : cdataOpen;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = cdata;
      return atLineEnding(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding$2(code2)) {
      returnState = declaration;
      return atLineEnding(code2);
    }
    effects.consume(code2);
    return declaration;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = instruction;
      return atLineEnding(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding$2(code2)) {
      returnState = tagCloseBetween;
      return atLineEnding(code2);
    }
    if (markdownSpace$2(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = tagOpenBetween;
      return atLineEnding(code2);
    }
    if (markdownSpace$2(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return atLineEnding(code2);
    }
    if (markdownSpace$2(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding$2(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return atLineEnding(code2);
    }
    if (markdownSpace$2(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    marker = void 0;
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding$2(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return atLineEnding(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 62 || code2 === 47 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function atLineEnding(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$4(
      effects,
      afterPrefix,
      "linePrefix",
      self2.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    );
  }
  function afterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok2;
    }
    return nok(code2);
  }
}
var htmlText_1 = htmlText$1;
var markdownLineEndingOrSpace = markdownLineEndingOrSpace_1;
var chunkedPush = chunkedPush_1;
var chunkedSplice = chunkedSplice_1;
var normalizeIdentifier$1 = normalizeIdentifier_1;
var resolveAll = resolveAll_1;
var shallow$1 = shallow_1;
var factoryDestination = factoryDestination$2;
var factoryLabel = factoryLabel$2;
var factoryTitle = factoryTitle$2;
var factoryWhitespace = factoryWhitespace$2;
var labelEnd$3 = {
  name: "labelEnd",
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};
var resourceConstruct = {
  tokenize: tokenizeResource
};
var fullReferenceConstruct = {
  tokenize: tokenizeFullReference
};
var collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
};
function resolveAllLabelEnd(events) {
  var index2 = -1;
  var token;
  while (++index2 < events.length) {
    token = events[index2][1];
    if (!token._used && (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd")) {
      events.splice(index2 + 1, token.type === "labelImage" ? 4 : 2);
      token.type = "data";
      index2++;
    }
  }
  return events;
}
function resolveToLabelEnd(events, context) {
  var index2 = events.length;
  var offset2 = 0;
  var group;
  var label;
  var text2;
  var token;
  var open;
  var close;
  var media;
  while (index2--) {
    token = events[index2][1];
    if (open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }
      if (events[index2][0] === "enter" && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events[index2][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index2;
        if (token.type !== "labelLink") {
          offset2 = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index2;
    }
  }
  group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: shallow$1(events[open][1].start),
    end: shallow$1(events[events.length - 1][1].end)
  };
  label = {
    type: "label",
    start: shallow$1(events[open][1].start),
    end: shallow$1(events[close][1].end)
  };
  text2 = {
    type: "labelText",
    start: shallow$1(events[open + offset2 + 2][1].end),
    end: shallow$1(events[close - 2][1].start)
  };
  media = [
    ["enter", group, context],
    ["enter", label, context]
  ];
  media = chunkedPush(media, events.slice(open + 1, open + offset2 + 3));
  media = chunkedPush(media, [["enter", text2, context]]);
  media = chunkedPush(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset2 + 4, close - 3),
      context
    )
  );
  media = chunkedPush(media, [
    ["exit", text2, context],
    events[close - 2],
    events[close - 1],
    ["exit", label, context]
  ]);
  media = chunkedPush(media, events.slice(close + 1));
  media = chunkedPush(media, [["exit", group, context]]);
  chunkedSplice(events, open, events.length, media);
  return events;
}
function tokenizeLabelEnd(effects, ok2, nok) {
  var self2 = this;
  var index2 = self2.events.length;
  var labelStart;
  var defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) return balanced(code2);
    defined = self2.parser.defined.indexOf(
      normalizeIdentifier$1(
        self2.sliceSerialize({
          start: labelStart.end,
          end: self2.now()
        })
      )
    ) > -1;
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return afterLabelEnd;
  }
  function afterLabelEnd(code2) {
    if (code2 === 40) {
      return effects.attempt(
        resourceConstruct,
        ok2,
        defined ? ok2 : balanced
      )(code2);
    }
    if (code2 === 91) {
      return effects.attempt(
        fullReferenceConstruct,
        ok2,
        defined ? effects.attempt(collapsedReferenceConstruct, ok2, balanced) : balanced
      )(code2);
    }
    return defined ? ok2(code2) : balanced(code2);
  }
  function balanced(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return factoryWhitespace(effects, open);
  }
  function open(code2) {
    if (code2 === 41) {
      return end(code2);
    }
    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      3
    )(code2);
  }
  function destinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, between)(code2) : end(code2);
  }
  function between(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle(
        effects,
        factoryWhitespace(effects, end),
        nok,
        "resourceTitle",
        "resourceTitleMarker",
        "resourceTitleString"
      )(code2);
    }
    return end(code2);
  }
  function end(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok2;
    }
    return nok(code2);
  }
}
function tokenizeFullReference(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    return factoryLabel.call(
      self2,
      effects,
      afterLabel,
      nok,
      "reference",
      "referenceMarker",
      "referenceString"
    )(code2);
  }
  function afterLabel(code2) {
    return self2.parser.defined.indexOf(
      normalizeIdentifier$1(
        self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
      )
    ) < 0 ? nok(code2) : ok2(code2);
  }
}
function tokenizeCollapsedReference(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok2;
    }
    return nok(code2);
  }
}
var labelEnd_1 = labelEnd$3;
var labelEnd$2 = labelEnd_1;
var labelStartImage$1 = {
  name: "labelStartImage",
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd$2.resolveAll
};
function tokenizeLabelStartImage(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return code2 === 94 && /* c8 ignore next */
    "_hiddenFootnoteSupport" in self2.parser.constructs ? (
      /* c8 ignore next */
      nok(code2)
    ) : ok2(code2);
  }
}
var labelStartImage_1 = labelStartImage$1;
var labelEnd$1 = labelEnd_1;
var labelStartLink$1 = {
  name: "labelStartLink",
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd$1.resolveAll
};
function tokenizeLabelStartLink(effects, ok2, nok) {
  var self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }
  function after(code2) {
    return code2 === 94 && /* c8 ignore next */
    "_hiddenFootnoteSupport" in self2.parser.constructs ? (
      /* c8 ignore next */
      nok(code2)
    ) : ok2(code2);
  }
}
var labelStartLink_1 = labelStartLink$1;
var factorySpace$3 = factorySpace$h;
var lineEnding$1 = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok2) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$3(effects, ok2, "linePrefix");
  }
}
var lineEnding_1 = lineEnding$1;
var markdownLineEnding$1 = markdownLineEnding_1;
var markdownSpace$1 = markdownSpace_1;
var factorySpace$2 = factorySpace$h;
var thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok2, nok) {
  var size2 = 0;
  var marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (markdownSpace$1(code2)) {
      return factorySpace$2(effects, atBreak, "whitespace")(code2);
    }
    if (size2 < 3 || code2 !== null && !markdownLineEnding$1(code2)) {
      return nok(code2);
    }
    effects.exit("thematicBreak");
    return ok2(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size2++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return atBreak(code2);
  }
}
var thematicBreak_1 = thematicBreak$2;
var asciiDigit = asciiDigit_1;
var markdownSpace = markdownSpace_1;
var prefixSize = prefixSize_1;
var sizeChunks = sizeChunks_1;
var factorySpace$1 = factorySpace$h;
var partialBlankLine = partialBlankLine_1;
var thematicBreak$1 = thematicBreak_1;
var list$1 = {
  name: "list",
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};
var listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};
var indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
};
function tokenizeListStart(effects, ok2, nok) {
  var self2 = this;
  var initialSize = prefixSize(self2.events, "linePrefix");
  var size2 = 0;
  return start;
  function start(code2) {
    var kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak$1, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code2);
      }
    }
    return nok(code2);
  }
  function inside(code2) {
    if (asciiDigit(code2) && ++size2 < 10) {
      effects.consume(code2);
      return inside;
    }
    if ((!self2.interrupt || size2 < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      partialBlankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + sizeChunks(self2.sliceStream(effects.exit("listItemPrefix")));
    return ok2(code2);
  }
}
function tokenizeListContinuation(effects, ok2, nok) {
  var self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(partialBlankLine, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace$1(
      effects,
      ok2,
      "listItemIndent",
      self2.containerState.size + 1
    )(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code2)) {
      self2.containerState.furtherBlankLines = self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok2, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace$1(
      effects,
      effects.attempt(list$1, ok2, nok),
      "linePrefix",
      self2.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    )(code2);
  }
}
function tokenizeIndent(effects, ok2, nok) {
  var self2 = this;
  return factorySpace$1(
    effects,
    afterPrefix,
    "listItemIndent",
    self2.containerState.size + 1
  );
  function afterPrefix(code2) {
    return prefixSize(self2.events, "listItemIndent") === self2.containerState.size ? ok2(code2) : nok(code2);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok2, nok) {
  var self2 = this;
  return factorySpace$1(
    effects,
    afterPrefix,
    "listItemPrefixWhitespace",
    self2.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4 + 1
  );
  function afterPrefix(code2) {
    return markdownSpace(code2) || !prefixSize(self2.events, "listItemPrefixWhitespace") ? nok(code2) : ok2(code2);
  }
}
var list_1 = list$1;
var markdownLineEnding = markdownLineEnding_1;
var shallow = shallow_1;
var factorySpace = factorySpace$h;
var setextUnderline$1 = {
  name: "setextUnderline",
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(events, context) {
  var index2 = events.length;
  var content2;
  var text2;
  var definition2;
  var heading;
  while (index2--) {
    if (events[index2][0] === "enter") {
      if (events[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events[index2][1].type === "content") {
        events.splice(index2, 1);
      }
      if (!definition2 && events[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  heading = {
    type: "setextHeading",
    start: shallow(events[text2][1].start),
    end: shallow(events[events.length - 1][1].end)
  };
  events[text2][1].type = "setextHeadingText";
  if (definition2) {
    events.splice(text2, 0, ["enter", heading, context]);
    events.splice(definition2 + 1, 0, ["exit", events[content2][1], context]);
    events[content2][1].end = shallow(events[definition2][1].end);
  } else {
    events[content2][1] = heading;
  }
  events.push(["exit", heading, context]);
  return events;
}
function tokenizeSetextUnderline(effects, ok2, nok) {
  var self2 = this;
  var index2 = self2.events.length;
  var marker;
  var paragraph;
  while (index2--) {
    if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
      paragraph = self2.events[index2][1].type === "paragraph";
      break;
    }
  }
  return start;
  function start(code2) {
    if (!self2.lazy && (self2.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      effects.enter("setextHeadingLineSequence");
      marker = code2;
      return closingSequence(code2);
    }
    return nok(code2);
  }
  function closingSequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return closingSequence;
    }
    effects.exit("setextHeadingLineSequence");
    return factorySpace(effects, closingSequenceEnd, "lineSuffix")(code2);
  }
  function closingSequenceEnd(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("setextHeadingLine");
      return ok2(code2);
    }
    return nok(code2);
  }
}
var setextUnderline_1 = setextUnderline$1;
Object.defineProperty(constructs$1, "__esModule", { value: true });
var text$1 = text$4;
var attention = attention_1;
var autolink = autolink_1;
var blockQuote = blockQuote_1;
var characterEscape = characterEscape_1;
var characterReference = characterReference_1;
var codeFenced = codeFenced_1;
var codeIndented = codeIndented_1;
var codeText = codeText_1;
var definition = definition_1;
var hardBreakEscape = hardBreakEscape_1;
var headingAtx = headingAtx_1;
var htmlFlow = htmlFlow_1;
var htmlText = htmlText_1;
var labelEnd = labelEnd_1;
var labelStartImage = labelStartImage_1;
var labelStartLink = labelStartLink_1;
var lineEnding = lineEnding_1;
var list = list_1;
var setextUnderline = setextUnderline_1;
var thematicBreak = thematicBreak_1;
var document$2 = {
  42: list,
  // Asterisk
  43: list,
  // Plus sign
  45: list,
  // Dash
  48: list,
  // 0
  49: list,
  // 1
  50: list,
  // 2
  51: list,
  // 3
  52: list,
  // 4
  53: list,
  // 5
  54: list,
  // 6
  55: list,
  // 7
  56: list,
  // 8
  57: list,
  // 9
  62: blockQuote
  // Greater than
};
var contentInitial = {
  91: definition
  // Left square bracket
};
var flowInitial = {
  "-2": codeIndented,
  // Horizontal tab
  "-1": codeIndented,
  // Virtual space
  32: codeIndented
  // Space
};
var flow$1 = {
  35: headingAtx,
  // Number sign
  42: thematicBreak,
  // Asterisk
  45: [setextUnderline, thematicBreak],
  // Dash
  60: htmlFlow,
  // Less than
  61: setextUnderline,
  // Equals to
  95: thematicBreak,
  // Underscore
  96: codeFenced,
  // Grave accent
  126: codeFenced
  // Tilde
};
var string = {
  38: characterReference,
  // Ampersand
  92: characterEscape
  // Backslash
};
var text$2 = {
  "-5": lineEnding,
  // Carriage return
  "-4": lineEnding,
  // Line feed
  "-3": lineEnding,
  // Carriage return + line feed
  33: labelStartImage,
  // Exclamation mark
  38: characterReference,
  // Ampersand
  42: attention,
  // Asterisk
  60: [autolink, htmlText],
  // Less than
  91: labelStartLink,
  // Left square bracket
  92: [hardBreakEscape, characterEscape],
  // Backslash
  93: labelEnd,
  // Right square bracket
  95: attention,
  // Underscore
  96: codeText
  // Grave accent
};
var insideSpan = {
  null: [attention, text$1.resolver]
};
var disable = {
  null: []
};
constructs$1.contentInitial = contentInitial;
constructs$1.disable = disable;
constructs$1.document = document$2;
constructs$1.flow = flow$1;
constructs$1.flowInitial = flowInitial;
constructs$1.insideSpan = insideSpan;
constructs$1.string = string;
constructs$1.text = text$2;
var content = content$3;
var document$1 = document$3;
var flow = flow$2;
var text = text$4;
var combineExtensions = combineExtensions_1;
var createTokenizer = createTokenizer_1;
var miniflat = miniflat_1;
var constructs = constructs$1;
function parse$1(options) {
  var settings = options || {};
  var parser2 = {
    defined: [],
    constructs: combineExtensions(
      [constructs].concat(miniflat(settings.extensions))
    ),
    content: create2(content),
    document: create2(document$1),
    flow: create2(flow),
    string: create2(text.string),
    text: create2(text.text)
  };
  return parser2;
  function create2(initializer) {
    return creator;
    function creator(from) {
      return createTokenizer(parser2, initializer, from);
    }
  }
}
var parse_1 = parse$1;
var search = /[\0\t\n\r]/g;
function preprocess() {
  var start = true;
  var column = 1;
  var buffer2 = "";
  var atCarriageReturn;
  return preprocessor2;
  function preprocessor2(value, encoding, end) {
    var chunks = [];
    var match2;
    var next;
    var startPosition;
    var endPosition;
    var code2;
    value = buffer2 + value.toString(encoding);
    startPosition = 0;
    buffer2 = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match2 = search.exec(value);
      endPosition = match2 ? match2.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match2) {
        buffer2 = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        if (code2 === 0) {
          chunks.push(65533);
          column++;
        } else if (code2 === 9) {
          next = Math.ceil(column / 4) * 4;
          chunks.push(-2);
          while (column++ < next) chunks.push(-1);
        } else if (code2 === 10) {
          chunks.push(-4);
          column = 1;
        } else {
          atCarriageReturn = true;
          column = 1;
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer2) chunks.push(buffer2);
      chunks.push(null);
    }
    return chunks;
  }
}
var preprocess_1 = preprocess;
var subtokenize = subtokenize_1;
function postprocess$1(events) {
  while (!subtokenize(events)) {
  }
  return events;
}
var postprocess_1 = postprocess$1;
var own$3 = {}.hasOwnProperty;
var unistUtilStringifyPosition = stringify$1;
function stringify$1(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if (own$3.call(value, "position") || own$3.call(value, "type")) {
    return position(value.position);
  }
  if (own$3.call(value, "start") || own$3.call(value, "end")) {
    return position(value);
  }
  if (own$3.call(value, "line") || own$3.call(value, "column")) {
    return point(value);
  }
  return "";
}
function point(point2) {
  if (!point2 || typeof point2 !== "object") {
    point2 = {};
  }
  return index(point2.line) + ":" + index(point2.column);
}
function position(pos) {
  if (!pos || typeof pos !== "object") {
    pos = {};
  }
  return point(pos.start) + "-" + point(pos.end);
}
function index(value) {
  return value && typeof value === "number" ? value : 1;
}
var dist = fromMarkdown$1;
var toString$1 = mdastUtilToString;
var assign = assign_1;
var own$2 = hasOwnProperty$1;
var normalizeIdentifier = normalizeIdentifier_1;
var safeFromInt = safeFromInt_1;
var parser = parse_1;
var preprocessor = preprocess_1;
var postprocess = postprocess_1;
var decode = decodeEntity_browser;
var stringifyPosition = unistUtilStringifyPosition;
function fromMarkdown$1(value, encoding, options) {
  if (typeof encoding !== "string") {
    options = encoding;
    encoding = void 0;
  }
  return compiler(options)(
    postprocess(
      parser(options).document().write(preprocessor()(value, encoding, true))
    )
  );
}
function compiler(options) {
  var settings = options || {};
  var config2 = configure(
    {
      transforms: [],
      canContainEols: [
        "emphasis",
        "fragment",
        "heading",
        "paragraph",
        "strong"
      ],
      enter: {
        autolink: opener(link),
        autolinkProtocol: onenterdata,
        autolinkEmail: onenterdata,
        atxHeading: opener(heading),
        blockQuote: opener(blockQuote2),
        characterEscape: onenterdata,
        characterReference: onenterdata,
        codeFenced: opener(codeFlow),
        codeFencedFenceInfo: buffer2,
        codeFencedFenceMeta: buffer2,
        codeIndented: opener(codeFlow, buffer2),
        codeText: opener(codeText2, buffer2),
        codeTextData: onenterdata,
        data: onenterdata,
        codeFlowValue: onenterdata,
        definition: opener(definition2),
        definitionDestinationString: buffer2,
        definitionLabelString: buffer2,
        definitionTitleString: buffer2,
        emphasis: opener(emphasis),
        hardBreakEscape: opener(hardBreak),
        hardBreakTrailing: opener(hardBreak),
        htmlFlow: opener(html, buffer2),
        htmlFlowData: onenterdata,
        htmlText: opener(html, buffer2),
        htmlTextData: onenterdata,
        image: opener(image),
        label: buffer2,
        link: opener(link),
        listItem: opener(listItem2),
        listItemValue: onenterlistitemvalue,
        listOrdered: opener(list2, onenterlistordered),
        listUnordered: opener(list2),
        paragraph: opener(paragraph),
        reference: onenterreference,
        referenceString: buffer2,
        resourceDestinationString: buffer2,
        resourceTitleString: buffer2,
        setextHeading: opener(heading),
        strong: opener(strong),
        thematicBreak: opener(thematicBreak2)
      },
      exit: {
        atxHeading: closer(),
        atxHeadingSequence: onexitatxheadingsequence,
        autolink: closer(),
        autolinkEmail: onexitautolinkemail,
        autolinkProtocol: onexitautolinkprotocol,
        blockQuote: closer(),
        characterEscapeValue: onexitdata,
        characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
        characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
        characterReferenceValue: onexitcharacterreferencevalue,
        codeFenced: closer(onexitcodefenced),
        codeFencedFence: onexitcodefencedfence,
        codeFencedFenceInfo: onexitcodefencedfenceinfo,
        codeFencedFenceMeta: onexitcodefencedfencemeta,
        codeFlowValue: onexitdata,
        codeIndented: closer(onexitcodeindented),
        codeText: closer(onexitcodetext),
        codeTextData: onexitdata,
        data: onexitdata,
        definition: closer(),
        definitionDestinationString: onexitdefinitiondestinationstring,
        definitionLabelString: onexitdefinitionlabelstring,
        definitionTitleString: onexitdefinitiontitlestring,
        emphasis: closer(),
        hardBreakEscape: closer(onexithardbreak),
        hardBreakTrailing: closer(onexithardbreak),
        htmlFlow: closer(onexithtmlflow),
        htmlFlowData: onexitdata,
        htmlText: closer(onexithtmltext),
        htmlTextData: onexitdata,
        image: closer(onexitimage),
        label: onexitlabel,
        labelText: onexitlabeltext,
        lineEnding: onexitlineending,
        link: closer(onexitlink),
        listItem: closer(),
        listOrdered: closer(),
        listUnordered: closer(),
        paragraph: closer(),
        referenceString: onexitreferencestring,
        resourceDestinationString: onexitresourcedestinationstring,
        resourceTitleString: onexitresourcetitlestring,
        resource: onexitresource,
        setextHeading: closer(onexitsetextheading),
        setextHeadingLineSequence: onexitsetextheadinglinesequence,
        setextHeadingText: onexitsetextheadingtext,
        strong: closer(),
        thematicBreak: closer()
      }
    },
    settings.mdastExtensions || []
  );
  var data = {};
  return compile2;
  function compile2(events) {
    var tree = { type: "root", children: [] };
    var stack = [tree];
    var tokenStack = [];
    var listStack = [];
    var index2 = -1;
    var handler;
    var listStart;
    var context = {
      stack,
      tokenStack,
      config: config2,
      enter,
      exit: exit2,
      buffer: buffer2,
      resume,
      setData,
      getData
    };
    while (++index2 < events.length) {
      if (events[index2][1].type === "listOrdered" || events[index2][1].type === "listUnordered") {
        if (events[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          listStart = listStack.pop(index2);
          index2 = prepareList(events, listStart, index2);
        }
      }
    }
    index2 = -1;
    while (++index2 < events.length) {
      handler = config2[events[index2][0]];
      if (own$2.call(handler, events[index2][1].type)) {
        handler[events[index2][1].type].call(
          assign({ sliceSerialize: events[index2][2].sliceSerialize }, context),
          events[index2][1]
        );
      }
    }
    if (tokenStack.length) {
      throw new Error(
        "Cannot close document, a token (`" + tokenStack[tokenStack.length - 1].type + "`, " + stringifyPosition({
          start: tokenStack[tokenStack.length - 1].start,
          end: tokenStack[tokenStack.length - 1].end
        }) + ") is still open"
      );
    }
    tree.position = {
      start: point2(
        events.length ? events[0][1].start : { line: 1, column: 1, offset: 0 }
      ),
      end: point2(
        events.length ? events[events.length - 2][1].end : { line: 1, column: 1, offset: 0 }
      )
    };
    index2 = -1;
    while (++index2 < config2.transforms.length) {
      tree = config2.transforms[index2](tree) || tree;
    }
    return tree;
  }
  function prepareList(events, start, length) {
    var index2 = start - 1;
    var containerBalance = -1;
    var listSpread = false;
    var listItem3;
    var tailIndex;
    var lineIndex;
    var tailEvent;
    var event;
    var firstBlankLineIndex;
    var atMarker;
    while (++index2 <= length) {
      event = events[index2];
      if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
        atMarker = void 0;
      } else if (event[1].type === "lineEndingBlank") {
        if (event[0] === "enter") {
          if (listItem3 && !atMarker && !containerBalance && !firstBlankLineIndex) {
            firstBlankLineIndex = index2;
          }
          atMarker = void 0;
        }
      } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
      else {
        atMarker = void 0;
      }
      if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem3) {
          tailIndex = index2;
          lineIndex = void 0;
          while (tailIndex--) {
            tailEvent = events[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === "exit") continue;
              if (lineIndex) {
                events[lineIndex][1].type = "lineEndingBlank";
                listSpread = true;
              }
              tailEvent[1].type = "lineEnding";
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
            else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem3._spread = true;
          }
          listItem3.end = point2(
            lineIndex ? events[lineIndex][1].start : event[1].end
          );
          events.splice(lineIndex || index2, 0, ["exit", listItem3, event[2]]);
          index2++;
          length++;
        }
        if (event[1].type === "listItemPrefix") {
          listItem3 = {
            type: "listItem",
            _spread: false,
            start: point2(event[1].start)
          };
          events.splice(index2, 0, ["enter", listItem3, event[2]]);
          index2++;
          length++;
          firstBlankLineIndex = void 0;
          atMarker = true;
        }
      }
    }
    events[start][1]._spread = listSpread;
    return length;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function point2(d2) {
    return { line: d2.line, column: d2.column, offset: d2.offset };
  }
  function opener(create2, and) {
    return open;
    function open(token) {
      enter.call(this, create2(token), token);
      if (and) and.call(this, token);
    }
  }
  function buffer2() {
    this.stack.push({ type: "fragment", children: [] });
  }
  function enter(node, token) {
    this.stack[this.stack.length - 1].children.push(node);
    this.stack.push(node);
    this.tokenStack.push(token);
    node.position = { start: point2(token.start) };
    return node;
  }
  function closer(and) {
    return close;
    function close(token) {
      if (and) and.call(this, token);
      exit2.call(this, token);
    }
  }
  function exit2(token) {
    var node = this.stack.pop();
    var open = this.tokenStack.pop();
    if (!open) {
      throw new Error(
        "Cannot close `" + token.type + "` (" + stringifyPosition({ start: token.start, end: token.end }) + "): it’s not open"
      );
    } else if (open.type !== token.type) {
      throw new Error(
        "Cannot close `" + token.type + "` (" + stringifyPosition({ start: token.start, end: token.end }) + "): a different token (`" + open.type + "`, " + stringifyPosition({ start: open.start, end: open.end }) + ") is open"
      );
    }
    node.position.end = point2(token.end);
    return node;
  }
  function resume() {
    return toString$1(this.stack.pop());
  }
  function onenterlistordered() {
    setData("expectingFirstListItemValue", true);
  }
  function onenterlistitemvalue(token) {
    if (getData("expectingFirstListItemValue")) {
      this.stack[this.stack.length - 2].start = parseInt(
        this.sliceSerialize(token),
        10
      );
      setData("expectingFirstListItemValue");
    }
  }
  function onexitcodefencedfenceinfo() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].lang = data2;
  }
  function onexitcodefencedfencemeta() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].meta = data2;
  }
  function onexitcodefencedfence() {
    if (getData("flowCodeInside")) return;
    this.buffer();
    setData("flowCodeInside", true);
  }
  function onexitcodefenced() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].value = data2.replace(
      /^(\r?\n|\r)|(\r?\n|\r)$/g,
      ""
    );
    setData("flowCodeInside");
  }
  function onexitcodeindented() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].value = data2;
  }
  function onexitdefinitionlabelstring(token) {
    var label = this.resume();
    this.stack[this.stack.length - 1].label = label;
    this.stack[this.stack.length - 1].identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
  }
  function onexitdefinitiontitlestring() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].title = data2;
  }
  function onexitdefinitiondestinationstring() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].url = data2;
  }
  function onexitatxheadingsequence(token) {
    if (!this.stack[this.stack.length - 1].depth) {
      this.stack[this.stack.length - 1].depth = this.sliceSerialize(
        token
      ).length;
    }
  }
  function onexitsetextheadingtext() {
    setData("setextHeadingSlurpLineEnding", true);
  }
  function onexitsetextheadinglinesequence(token) {
    this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
  }
  function onexitsetextheading() {
    setData("setextHeadingSlurpLineEnding");
  }
  function onenterdata(token) {
    var siblings = this.stack[this.stack.length - 1].children;
    var tail = siblings[siblings.length - 1];
    if (!tail || tail.type !== "text") {
      tail = text2();
      tail.position = { start: point2(token.start) };
      this.stack[this.stack.length - 1].children.push(tail);
    }
    this.stack.push(tail);
  }
  function onexitdata(token) {
    var tail = this.stack.pop();
    tail.value += this.sliceSerialize(token);
    tail.position.end = point2(token.end);
  }
  function onexitlineending(token) {
    var context = this.stack[this.stack.length - 1];
    if (getData("atHardBreak")) {
      context.children[context.children.length - 1].position.end = point2(
        token.end
      );
      setData("atHardBreak");
      return;
    }
    if (!getData("setextHeadingSlurpLineEnding") && config2.canContainEols.indexOf(context.type) > -1) {
      onenterdata.call(this, token);
      onexitdata.call(this, token);
    }
  }
  function onexithardbreak() {
    setData("atHardBreak", true);
  }
  function onexithtmlflow() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].value = data2;
  }
  function onexithtmltext() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].value = data2;
  }
  function onexitcodetext() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].value = data2;
  }
  function onexitlink() {
    var context = this.stack[this.stack.length - 1];
    if (getData("inReference")) {
      context.type += "Reference";
      context.referenceType = getData("referenceType") || "shortcut";
      delete context.url;
      delete context.title;
    } else {
      delete context.identifier;
      delete context.label;
      delete context.referenceType;
    }
    setData("referenceType");
  }
  function onexitimage() {
    var context = this.stack[this.stack.length - 1];
    if (getData("inReference")) {
      context.type += "Reference";
      context.referenceType = getData("referenceType") || "shortcut";
      delete context.url;
      delete context.title;
    } else {
      delete context.identifier;
      delete context.label;
      delete context.referenceType;
    }
    setData("referenceType");
  }
  function onexitlabeltext(token) {
    this.stack[this.stack.length - 2].identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
  }
  function onexitlabel() {
    var fragment = this.stack[this.stack.length - 1];
    var value = this.resume();
    this.stack[this.stack.length - 1].label = value;
    setData("inReference", true);
    if (this.stack[this.stack.length - 1].type === "link") {
      this.stack[this.stack.length - 1].children = fragment.children;
    } else {
      this.stack[this.stack.length - 1].alt = value;
    }
  }
  function onexitresourcedestinationstring() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].url = data2;
  }
  function onexitresourcetitlestring() {
    var data2 = this.resume();
    this.stack[this.stack.length - 1].title = data2;
  }
  function onexitresource() {
    setData("inReference");
  }
  function onenterreference() {
    setData("referenceType", "collapsed");
  }
  function onexitreferencestring(token) {
    var label = this.resume();
    this.stack[this.stack.length - 1].label = label;
    this.stack[this.stack.length - 1].identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
    setData("referenceType", "full");
  }
  function onexitcharacterreferencemarker(token) {
    setData("characterReferenceType", token.type);
  }
  function onexitcharacterreferencevalue(token) {
    var data2 = this.sliceSerialize(token);
    var type = getData("characterReferenceType");
    var value;
    var tail;
    if (type) {
      value = safeFromInt(
        data2,
        type === "characterReferenceMarkerNumeric" ? 10 : 16
      );
      setData("characterReferenceType");
    } else {
      value = decode(data2);
    }
    tail = this.stack.pop();
    tail.value += value;
    tail.position.end = point2(token.end);
  }
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
  }
  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(token);
  }
  function blockQuote2() {
    return { type: "blockquote", children: [] };
  }
  function codeFlow() {
    return { type: "code", lang: null, meta: null, value: "" };
  }
  function codeText2() {
    return { type: "inlineCode", value: "" };
  }
  function definition2() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function emphasis() {
    return { type: "emphasis", children: [] };
  }
  function heading() {
    return { type: "heading", depth: void 0, children: [] };
  }
  function hardBreak() {
    return { type: "break" };
  }
  function html() {
    return { type: "html", value: "" };
  }
  function image() {
    return { type: "image", title: null, url: "", alt: null };
  }
  function link() {
    return { type: "link", title: null, url: "", children: [] };
  }
  function list2(token) {
    return {
      type: "list",
      ordered: token.type === "listOrdered",
      start: null,
      spread: token._spread,
      children: []
    };
  }
  function listItem2(token) {
    return {
      type: "listItem",
      spread: token._spread,
      checked: null,
      children: []
    };
  }
  function paragraph() {
    return { type: "paragraph", children: [] };
  }
  function strong() {
    return { type: "strong", children: [] };
  }
  function text2() {
    return { type: "text", value: "" };
  }
  function thematicBreak2() {
    return { type: "thematicBreak" };
  }
}
function configure(config2, extensions) {
  var index2 = -1;
  while (++index2 < extensions.length) {
    extension(config2, extensions[index2]);
  }
  return config2;
}
function extension(config2, extension2) {
  var key;
  var left;
  for (key in extension2) {
    left = own$2.call(config2, key) ? config2[key] : config2[key] = {};
    if (key === "canContainEols" || key === "transforms") {
      config2[key] = [].concat(left, extension2[key]);
    } else {
      Object.assign(left, extension2[key]);
    }
  }
}
var mdastUtilFromMarkdown = dist;
var remarkParse = parse;
var fromMarkdown = mdastUtilFromMarkdown;
function parse(options) {
  var self2 = this;
  this.Parser = parse2;
  function parse2(doc) {
    return fromMarkdown(
      doc,
      Object.assign({}, self2.data("settings"), options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: self2.data("micromarkExtensions") || [],
        mdastExtensions: self2.data("fromMarkdownExtensions") || []
      })
    );
  }
}
var bail_1 = bail$1;
function bail$1(err) {
  if (err) {
    throw err;
  }
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer = function isBuffer2(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray2(arr) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(arr);
  }
  return toStr.call(arr) === "[object Array]";
};
var isPlainObject = function isPlainObject2(obj) {
  if (!obj || toStr.call(obj) !== "[object Object]") {
    return false;
  }
  var hasOwnConstructor = hasOwn.call(obj, "constructor");
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }
  var key;
  for (key in obj) {
  }
  return typeof key === "undefined" || hasOwn.call(obj, key);
};
var setProperty = function setProperty2(target, options) {
  if (defineProperty && options.name === "__proto__") {
    defineProperty(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
};
var getProperty = function getProperty2(obj, name) {
  if (name === "__proto__") {
    if (!hasOwn.call(obj, name)) {
      return void 0;
    } else if (gOPD) {
      return gOPD(obj, name).value;
    }
  }
  return obj[name];
};
var extend$1 = function extend() {
  var options, name, src, copy, copyIsArray, clone;
  var target = arguments[0];
  var i2 = 1;
  var length = arguments.length;
  var deep = false;
  if (typeof target === "boolean") {
    deep = target;
    target = arguments[1] || {};
    i2 = 2;
  }
  if (target == null || typeof target !== "object" && typeof target !== "function") {
    target = {};
  }
  for (; i2 < length; ++i2) {
    options = arguments[i2];
    if (options != null) {
      for (name in options) {
        src = getProperty(target, name);
        copy = getProperty(options, name);
        if (target !== copy) {
          if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray(src) ? src : [];
            } else {
              clone = src && isPlainObject(src) ? src : {};
            }
            setProperty(target, { name, newValue: extend(deep, clone, copy) });
          } else if (typeof copy !== "undefined") {
            setProperty(target, { name, newValue: copy });
          }
        }
      }
    }
  }
  return target;
};
var isPlainObj = (value) => {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};
var slice$2 = [].slice;
var wrap_1 = wrap$1;
function wrap$1(fn, callback) {
  var invoked;
  return wrapped;
  function wrapped() {
    var params = slice$2.call(arguments, 0);
    var callback2 = fn.length > params.length;
    var result;
    if (callback2) {
      params.push(done);
    }
    try {
      result = fn.apply(null, params);
    } catch (error2) {
      if (callback2 && invoked) {
        throw error2;
      }
      return done(error2);
    }
    if (!callback2) {
      if (result && typeof result.then === "function") {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }
  function done() {
    if (!invoked) {
      invoked = true;
      callback.apply(null, arguments);
    }
  }
  function then(value) {
    done(null, value);
  }
}
var wrap = wrap_1;
var trough_1 = trough$1;
trough$1.wrap = wrap;
var slice$1 = [].slice;
function trough$1() {
  var fns = [];
  var middleware = {};
  middleware.run = run;
  middleware.use = use;
  return middleware;
  function run() {
    var index2 = -1;
    var input = slice$1.call(arguments, 0, -1);
    var done = arguments[arguments.length - 1];
    if (typeof done !== "function") {
      throw new Error("Expected function as last argument, not " + done);
    }
    next.apply(null, [null].concat(input));
    function next(err) {
      var fn = fns[++index2];
      var params = slice$1.call(arguments, 0);
      var values = params.slice(1);
      var length = input.length;
      var pos = -1;
      if (err) {
        done(err);
        return;
      }
      while (++pos < length) {
        if (values[pos] === null || values[pos] === void 0) {
          values[pos] = input[pos];
        }
      }
      input = values;
      if (fn) {
        wrap(fn, next).apply(null, input);
      } else {
        done.apply(null, [null].concat(input));
      }
    }
  }
  function use(fn) {
    if (typeof fn !== "function") {
      throw new Error("Expected `fn` to be a function, not " + fn);
    }
    fns.push(fn);
    return middleware;
  }
}
var stringify = unistUtilStringifyPosition;
var vfileMessage = VMessage$1;
function VMessagePrototype() {
}
VMessagePrototype.prototype = Error.prototype;
VMessage$1.prototype = new VMessagePrototype();
var proto = VMessage$1.prototype;
proto.file = "";
proto.name = "";
proto.reason = "";
proto.message = "";
proto.stack = "";
proto.fatal = null;
proto.column = null;
proto.line = null;
function VMessage$1(reason, position2, origin) {
  var parts;
  var range;
  var location;
  if (typeof position2 === "string") {
    origin = position2;
    position2 = null;
  }
  parts = parseOrigin(origin);
  range = stringify(position2) || "1:1";
  location = {
    start: { line: null, column: null },
    end: { line: null, column: null }
  };
  if (position2 && position2.position) {
    position2 = position2.position;
  }
  if (position2) {
    if (position2.start) {
      location = position2;
      position2 = position2.start;
    } else {
      location.start = position2;
    }
  }
  if (reason.stack) {
    this.stack = reason.stack;
    reason = reason.message;
  }
  this.message = reason;
  this.name = range;
  this.reason = reason;
  this.line = position2 ? position2.line : null;
  this.column = position2 ? position2.column : null;
  this.location = location;
  this.source = parts[0];
  this.ruleId = parts[1];
}
function parseOrigin(origin) {
  var result = [null, null];
  var index2;
  if (typeof origin === "string") {
    index2 = origin.indexOf(":");
    if (index2 === -1) {
      result[1] = origin;
    } else {
      result[0] = origin.slice(0, index2);
      result[1] = origin.slice(index2 + 1);
    }
  }
  return result;
}
var minpath_browser = {};
minpath_browser.basename = basename;
minpath_browser.dirname = dirname;
minpath_browser.extname = extname;
minpath_browser.join = join;
minpath_browser.sep = "/";
function basename(path2, ext) {
  var start = 0;
  var end = -1;
  var index2;
  var firstNonSlashEnd;
  var seenNonSlash;
  var extIndex;
  if (ext !== void 0 && typeof ext !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1(path2);
  index2 = path2.length;
  if (ext === void 0 || !ext.length || ext.length > path2.length) {
    while (index2--) {
      if (path2.charCodeAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path2.slice(start, end);
  }
  if (ext === path2) {
    return "";
  }
  firstNonSlashEnd = -1;
  extIndex = ext.length - 1;
  while (index2--) {
    if (path2.charCodeAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extIndex > -1) {
        if (path2.charCodeAt(index2) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            end = index2;
          }
        } else {
          extIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path2.length;
  }
  return path2.slice(start, end);
}
function dirname(path2) {
  var end;
  var unmatchedSlash;
  var index2;
  assertPath$1(path2);
  if (!path2.length) {
    return ".";
  }
  end = -1;
  index2 = path2.length;
  while (--index2) {
    if (path2.charCodeAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path2.charCodeAt(0) === 47 ? "/" : "." : end === 1 && path2.charCodeAt(0) === 47 ? "//" : path2.slice(0, end);
}
function extname(path2) {
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var preDotState = 0;
  var unmatchedSlash;
  var code2;
  var index2;
  assertPath$1(path2);
  index2 = path2.length;
  while (index2--) {
    code2 = path2.charCodeAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path2.slice(startDot, end);
}
function join() {
  var index2 = -1;
  var joined;
  while (++index2 < arguments.length) {
    assertPath$1(arguments[index2]);
    if (arguments[index2]) {
      joined = joined === void 0 ? arguments[index2] : joined + "/" + arguments[index2];
    }
  }
  return joined === void 0 ? "." : normalize(joined);
}
function normalize(path2) {
  var absolute;
  var value;
  assertPath$1(path2);
  absolute = path2.charCodeAt(0) === 47;
  value = normalizeString(path2, !absolute);
  if (!value.length && !absolute) {
    value = ".";
  }
  if (value.length && path2.charCodeAt(path2.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString(path2, allowAboveRoot) {
  var result = "";
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var index2 = -1;
  var code2;
  var lastSlashIndex;
  while (++index2 <= path2.length) {
    if (index2 < path2.length) {
      code2 = path2.charCodeAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 || result.charCodeAt(result.length - 2) !== 46) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf("/");
            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = "";
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result.length) {
            result = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result = result.length ? result + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result.length) {
          result += "/" + path2.slice(lastSlash + 1, index2);
        } else {
          result = path2.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result;
}
function assertPath$1(path2) {
  if (typeof path2 !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path2)
    );
  }
}
var minproc_browser = {};
minproc_browser.cwd = cwd;
function cwd() {
  return "/";
}
var p = minpath_browser;
var proc = minproc_browser;
var buffer$1 = isBuffer;
var core = VFile$1;
var own$1 = {}.hasOwnProperty;
var order = ["history", "path", "basename", "stem", "extname", "dirname"];
VFile$1.prototype.toString = toString;
Object.defineProperty(VFile$1.prototype, "path", { get: getPath, set: setPath });
Object.defineProperty(VFile$1.prototype, "dirname", {
  get: getDirname,
  set: setDirname
});
Object.defineProperty(VFile$1.prototype, "basename", {
  get: getBasename,
  set: setBasename
});
Object.defineProperty(VFile$1.prototype, "extname", {
  get: getExtname,
  set: setExtname
});
Object.defineProperty(VFile$1.prototype, "stem", { get: getStem, set: setStem });
function VFile$1(options) {
  var prop;
  var index2;
  if (!options) {
    options = {};
  } else if (typeof options === "string" || buffer$1(options)) {
    options = { contents: options };
  } else if ("message" in options && "messages" in options) {
    return options;
  }
  if (!(this instanceof VFile$1)) {
    return new VFile$1(options);
  }
  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = proc.cwd();
  index2 = -1;
  while (++index2 < order.length) {
    prop = order[index2];
    if (own$1.call(options, prop)) {
      this[prop] = options[prop];
    }
  }
  for (prop in options) {
    if (order.indexOf(prop) < 0) {
      this[prop] = options[prop];
    }
  }
}
function getPath() {
  return this.history[this.history.length - 1];
}
function setPath(path2) {
  assertNonEmpty(path2, "path");
  if (this.path !== path2) {
    this.history.push(path2);
  }
}
function getDirname() {
  return typeof this.path === "string" ? p.dirname(this.path) : void 0;
}
function setDirname(dirname2) {
  assertPath(this.path, "dirname");
  this.path = p.join(dirname2 || "", this.basename);
}
function getBasename() {
  return typeof this.path === "string" ? p.basename(this.path) : void 0;
}
function setBasename(basename2) {
  assertNonEmpty(basename2, "basename");
  assertPart(basename2, "basename");
  this.path = p.join(this.dirname || "", basename2);
}
function getExtname() {
  return typeof this.path === "string" ? p.extname(this.path) : void 0;
}
function setExtname(extname2) {
  assertPart(extname2, "extname");
  assertPath(this.path, "extname");
  if (extname2) {
    if (extname2.charCodeAt(0) !== 46) {
      throw new Error("`extname` must start with `.`");
    }
    if (extname2.indexOf(".", 1) > -1) {
      throw new Error("`extname` cannot contain multiple dots");
    }
  }
  this.path = p.join(this.dirname, this.stem + (extname2 || ""));
}
function getStem() {
  return typeof this.path === "string" ? p.basename(this.path, this.extname) : void 0;
}
function setStem(stem) {
  assertNonEmpty(stem, "stem");
  assertPart(stem, "stem");
  this.path = p.join(this.dirname || "", stem + (this.extname || ""));
}
function toString(encoding) {
  return (this.contents || "").toString(encoding);
}
function assertPart(part, name) {
  if (part && part.indexOf(p.sep) > -1) {
    throw new Error(
      "`" + name + "` cannot be a path: did not expect `" + p.sep + "`"
    );
  }
}
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error("`" + name + "` cannot be empty");
  }
}
function assertPath(path2, name) {
  if (!path2) {
    throw new Error("Setting `" + name + "` requires `path` to be set too");
  }
}
var VMessage = vfileMessage;
var VFile = core;
var lib = VFile;
VFile.prototype.message = message;
VFile.prototype.info = info;
VFile.prototype.fail = fail;
function message(reason, position2, origin) {
  var message2 = new VMessage(reason, position2, origin);
  if (this.path) {
    message2.name = this.path + ":" + message2.name;
    message2.file = this.path;
  }
  message2.fatal = false;
  this.messages.push(message2);
  return message2;
}
function fail() {
  var message2 = this.message.apply(this, arguments);
  message2.fatal = true;
  throw message2;
}
function info() {
  var message2 = this.message.apply(this, arguments);
  message2.fatal = null;
  return message2;
}
var vfile$1 = lib;
var bail = bail_1;
var buffer = isBuffer;
var extend2 = extend$1;
var plain = isPlainObj;
var trough = trough_1;
var vfile = vfile$1;
var unified_1 = unified$1().freeze();
var slice = [].slice;
var own = {}.hasOwnProperty;
var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
function pipelineParse(p2, ctx) {
  ctx.tree = p2.parse(ctx.file);
}
function pipelineRun(p2, ctx, next) {
  p2.run(ctx.tree, ctx.file, done);
  function done(error2, tree, file) {
    if (error2) {
      next(error2);
    } else {
      ctx.tree = tree;
      ctx.file = file;
      next();
    }
  }
}
function pipelineStringify(p2, ctx) {
  var result = p2.stringify(ctx.tree, ctx.file);
  if (result === void 0 || result === null) ;
  else if (typeof result === "string" || buffer(result)) {
    if ("value" in ctx.file) {
      ctx.file.value = result;
    }
    ctx.file.contents = result;
  } else {
    ctx.file.result = result;
  }
}
function unified$1() {
  var attachers = [];
  var transformers = trough();
  var namespace = {};
  var freezeIndex = -1;
  var frozen;
  processor.data = data;
  processor.freeze = freeze2;
  processor.attachers = attachers;
  processor.use = use;
  processor.parse = parse2;
  processor.stringify = stringify2;
  processor.run = run;
  processor.runSync = runSync;
  processor.process = process2;
  processor.processSync = processSync;
  return processor;
  function processor() {
    var destination = unified$1();
    var index2 = -1;
    while (++index2 < attachers.length) {
      destination.use.apply(null, attachers[index2]);
    }
    destination.data(extend2(true, {}, namespace));
    return destination;
  }
  function freeze2() {
    var values;
    var transformer;
    if (frozen) {
      return processor;
    }
    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex];
      if (values[1] === false) {
        continue;
      }
      if (values[1] === true) {
        values[1] = void 0;
      }
      transformer = values[0].apply(processor, values.slice(1));
      if (typeof transformer === "function") {
        transformers.use(transformer);
      }
    }
    frozen = true;
    freezeIndex = Infinity;
    return processor;
  }
  function data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", frozen);
        namespace[key] = value;
        return processor;
      }
      return own.call(namespace, key) && namespace[key] || null;
    }
    if (key) {
      assertUnfrozen("data", frozen);
      namespace = key;
      return processor;
    }
    return namespace;
  }
  function use(value) {
    var settings;
    assertUnfrozen("use", frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin.apply(null, arguments);
    } else if (typeof value === "object") {
      if ("length" in value) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new Error("Expected usable value, not `" + value + "`");
    }
    if (settings) {
      namespace.settings = extend2(namespace.settings || {}, settings);
    }
    return processor;
    function addPreset(result) {
      addList(result.plugins);
      if (result.settings) {
        settings = extend2(settings || {}, result.settings);
      }
    }
    function add(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2);
      } else if (typeof value2 === "object") {
        if ("length" in value2) {
          addPlugin.apply(null, value2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new Error("Expected usable value, not `" + value2 + "`");
      }
    }
    function addList(plugins2) {
      var index2 = -1;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (typeof plugins2 === "object" && "length" in plugins2) {
        while (++index2 < plugins2.length) {
          add(plugins2[index2]);
        }
      } else {
        throw new Error("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin2, value2) {
      var entry = find(plugin2);
      if (entry) {
        if (plain(entry[1]) && plain(value2)) {
          value2 = extend2(true, entry[1], value2);
        }
        entry[1] = value2;
      } else {
        attachers.push(slice.call(arguments));
      }
    }
  }
  function find(plugin2) {
    var index2 = -1;
    while (++index2 < attachers.length) {
      if (attachers[index2][0] === plugin2) {
        return attachers[index2];
      }
    }
  }
  function parse2(doc) {
    var file = vfile(doc);
    var Parser;
    freeze2();
    Parser = processor.Parser;
    assertParser("parse", Parser);
    if (newable(Parser, "parse")) {
      return new Parser(String(file), file).parse();
    }
    return Parser(String(file), file);
  }
  function run(node, file, cb) {
    assertNode(node);
    freeze2();
    if (!cb && typeof file === "function") {
      cb = file;
      file = null;
    }
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve, reject) {
      transformers.run(node, vfile(file), done);
      function done(error2, tree, file2) {
        tree = tree || node;
        if (error2) {
          reject(error2);
        } else if (resolve) {
          resolve(tree);
        } else {
          cb(null, tree, file2);
        }
      }
    }
  }
  function runSync(node, file) {
    var result;
    var complete;
    run(node, file, done);
    assertDone("runSync", "run", complete);
    return result;
    function done(error2, tree) {
      complete = true;
      result = tree;
      bail(error2);
    }
  }
  function stringify2(node, doc) {
    var file = vfile(doc);
    var Compiler;
    freeze2();
    Compiler = processor.Compiler;
    assertCompiler("stringify", Compiler);
    assertNode(node);
    if (newable(Compiler, "compile")) {
      return new Compiler(node, file).compile();
    }
    return Compiler(node, file);
  }
  function process2(doc, cb) {
    freeze2();
    assertParser("process", processor.Parser);
    assertCompiler("process", processor.Compiler);
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve, reject) {
      var file = vfile(doc);
      pipeline.run(processor, { file }, done);
      function done(error2) {
        if (error2) {
          reject(error2);
        } else if (resolve) {
          resolve(file);
        } else {
          cb(null, file);
        }
      }
    }
  }
  function processSync(doc) {
    var file;
    var complete;
    freeze2();
    assertParser("processSync", processor.Parser);
    assertCompiler("processSync", processor.Compiler);
    file = vfile(doc);
    process2(file, done);
    assertDone("processSync", "process", complete);
    return file;
    function done(error2) {
      complete = true;
      bail(error2);
    }
  }
}
function newable(value, name) {
  return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  (keys(value.prototype) || name in value.prototype);
}
function keys(value) {
  var key;
  for (key in value) {
    return true;
  }
  return false;
}
function assertParser(name, Parser) {
  if (typeof Parser !== "function") {
    throw new Error("Cannot `" + name + "` without `Parser`");
  }
}
function assertCompiler(name, Compiler) {
  if (typeof Compiler !== "function") {
    throw new Error("Cannot `" + name + "` without `Compiler`");
  }
}
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node) {
  if (!node || typeof node.type !== "string") {
    throw new Error("Expected node, got `" + node + "`");
  }
}
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
var richTextTypes$1 = dist$1;
var _ = lodashExports;
var gfm = remarkGfm;
var markdown = remarkParse;
var unified = unified_1;
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1) throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2) throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2) try {
      if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done) return t2;
      if (y2 = 0, t2) op = [op[0] & 2, t2.value];
      switch (op[0]) {
        case 0:
        case 1:
          t2 = op;
          break;
        case 4:
          _2.label++;
          return { value: op[1], done: false };
        case 5:
          _2.label++;
          y2 = op[1];
          op = [0];
          continue;
        case 7:
          op = _2.ops.pop();
          _2.trys.pop();
          continue;
        default:
          if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _2 = 0;
            continue;
          }
          if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
            _2.label = op[1];
            break;
          }
          if (op[0] === 6 && _2.label < t2[1]) {
            _2.label = t2[1];
            t2 = op;
            break;
          }
          if (t2 && _2.label < t2[2]) {
            _2.label = t2[2];
            _2.ops.push(op);
            break;
          }
          if (t2[2]) _2.ops.pop();
          _2.trys.pop();
          continue;
      }
      op = body.call(thisArg, _2);
    } catch (e3) {
      op = [6, e3];
      y2 = 0;
    } finally {
      f2 = t2 = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
var markdownNodeTypes = /* @__PURE__ */ new Map([
  ["paragraph", richTextTypes$1.BLOCKS.PARAGRAPH],
  ["heading", "heading"],
  ["text", "text"],
  ["emphasis", "text"],
  ["strong", "text"],
  ["delete", "text"],
  ["inlineCode", "text"],
  ["link", richTextTypes$1.INLINES.HYPERLINK],
  ["thematicBreak", richTextTypes$1.BLOCKS.HR],
  ["blockquote", richTextTypes$1.BLOCKS.QUOTE],
  ["list", "list"],
  ["listItem", richTextTypes$1.BLOCKS.LIST_ITEM],
  ["table", richTextTypes$1.BLOCKS.TABLE],
  ["tableRow", richTextTypes$1.BLOCKS.TABLE_ROW],
  ["tableCell", richTextTypes$1.BLOCKS.TABLE_CELL]
]);
var nodeTypeFor = function(node) {
  var nodeType = markdownNodeTypes.get(node.type);
  switch (nodeType) {
    case "heading":
      return "".concat(nodeType, "-").concat(node.depth);
    case "list":
      return "".concat(node.ordered ? "ordered" : "unordered", "-list");
    default:
      return nodeType;
  }
};
var markTypes = /* @__PURE__ */ new Map([
  ["emphasis", "italic"],
  ["strong", "bold"],
  ["inlineCode", "code"]
]);
var markTypeFor = function(node) {
  return markTypes.get(node.type);
};
var isLink = function(node) {
  return node.type === "link";
};
var nodeContainerTypes = /* @__PURE__ */ new Map([
  ["delete", "block"],
  [richTextTypes$1.BLOCKS.HEADING_1, "block"],
  [richTextTypes$1.BLOCKS.HEADING_2, "block"],
  [richTextTypes$1.BLOCKS.HEADING_3, "block"],
  [richTextTypes$1.BLOCKS.HEADING_4, "block"],
  [richTextTypes$1.BLOCKS.HEADING_5, "block"],
  [richTextTypes$1.BLOCKS.HEADING_6, "block"],
  [richTextTypes$1.BLOCKS.LIST_ITEM, "block"],
  [richTextTypes$1.BLOCKS.UL_LIST, "block"],
  [richTextTypes$1.BLOCKS.OL_LIST, "block"],
  [richTextTypes$1.BLOCKS.QUOTE, "block"],
  [richTextTypes$1.BLOCKS.HR, "block"],
  [richTextTypes$1.BLOCKS.PARAGRAPH, "block"],
  [richTextTypes$1.BLOCKS.TABLE, "block"],
  [richTextTypes$1.BLOCKS.TABLE_CELL, "block"],
  [richTextTypes$1.BLOCKS.TABLE_HEADER_CELL, "block"],
  [richTextTypes$1.BLOCKS.TABLE_ROW, "block"],
  [richTextTypes$1.INLINES.HYPERLINK, "inline"],
  ["text", "text"],
  ["emphasis", "text"],
  ["strong", "text"],
  ["inlineCode", "text"]
]);
var isBlock = function(nodeType) {
  return nodeContainerTypes.get(nodeType) === "block";
};
var isText = function(nodeType) {
  return nodeContainerTypes.get(nodeType) === "text";
};
var isInline = function(nodeType) {
  return nodeContainerTypes.get(nodeType) === "inline";
};
var isTableCell = function(nodeType) {
  return nodeType === richTextTypes$1.BLOCKS.TABLE_CELL;
};
var buildHyperlink = function(node, fallback, appliedMarksTypes) {
  return __awaiter(void 0, void 0, void 0, function() {
    var content2, hyperlink;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, mdToRichTextNodes(node.children, fallback, appliedMarksTypes)];
        case 1:
          content2 = _a2.sent();
          hyperlink = {
            nodeType: richTextTypes$1.INLINES.HYPERLINK,
            data: { uri: node.url },
            content: content2
          };
          return [2, [hyperlink]];
      }
    });
  });
};
var buildGenericBlockOrInline = function(node, fallback, appliedMarksTypes) {
  return __awaiter(void 0, void 0, void 0, function() {
    var nodeType, content2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          nodeType = nodeTypeFor(node);
          return [4, mdToRichTextNodes(node.children, fallback, appliedMarksTypes)];
        case 1:
          content2 = _a2.sent();
          return [2, [
            {
              nodeType,
              content: content2,
              data: {}
            }
          ]];
      }
    });
  });
};
var buildTableCell = function(node, fallback, appliedMarksTypes) {
  return __awaiter(void 0, void 0, void 0, function() {
    var nodeChildren, content2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, mdToRichTextNodes(node.children, fallback, appliedMarksTypes)];
        case 1:
          nodeChildren = _a2.sent();
          content2 = nodeChildren.reduce(function(result, contentNode) {
            if (isText(contentNode.nodeType) || isInline(contentNode.nodeType)) {
              var lastNode = result[result.length - 1];
              if (lastNode && lastNode.nodeType === richTextTypes$1.BLOCKS.PARAGRAPH) {
                lastNode.content.push(contentNode);
              } else {
                result.push({ nodeType: richTextTypes$1.BLOCKS.PARAGRAPH, data: {}, content: [contentNode] });
              }
            } else {
              result.push(contentNode);
            }
            return result;
          }, []);
          if (content2.length === 0) {
            content2.push({
              nodeType: richTextTypes$1.BLOCKS.PARAGRAPH,
              data: {},
              content: [
                {
                  nodeType: "text",
                  data: {},
                  marks: [],
                  value: ""
                }
              ]
            });
          }
          return [2, [
            {
              nodeType: richTextTypes$1.BLOCKS.TABLE_CELL,
              content: content2,
              data: {}
            }
          ]];
      }
    });
  });
};
var buildText = function(node, fallback, appliedMarksTypes) {
  return __awaiter(void 0, void 0, void 0, function() {
    var nodeType, markType, marks;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          nodeType = nodeTypeFor(node);
          markType = markTypeFor(node);
          marks = Array.from(appliedMarksTypes);
          if (markType) {
            marks.push(markType);
          }
          if (!(node.type !== "text" && node.children)) return [3, 2];
          return [4, mdToRichTextNodes(node.children, fallback, marks)];
        case 1:
          return [2, _a2.sent()];
        case 2:
          if (node.value) {
            return [2, [
              {
                nodeType,
                value: node.value,
                marks: marks.map(function(type) {
                  return { type };
                }),
                data: {}
              }
            ]];
          }
          return [
            2
            /*return*/
          ];
      }
    });
  });
};
var buildFallbackNode = function(node, fallback) {
  return __awaiter(void 0, void 0, void 0, function() {
    var fallbackResult;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, fallback(node)];
        case 1:
          fallbackResult = _a2.sent();
          if (_.isArray(fallbackResult)) {
            return [2, fallbackResult];
          }
          return [2, [fallbackResult]];
      }
    });
  });
};
function mdToRichTextNode(node_1, fallback_1) {
  return __awaiter(this, arguments, void 0, function(node, fallback, appliedMarksTypes) {
    var nodeType;
    if (appliedMarksTypes === void 0) {
      appliedMarksTypes = [];
    }
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (node.type === "html" && /<br\s?\/?>/gi.test(node.value)) {
            node.value = "\n";
            node.type = "text";
          }
          nodeType = nodeTypeFor(node);
          if (!isLink(node)) return [3, 2];
          return [4, buildHyperlink(node, fallback, appliedMarksTypes)];
        case 1:
          return [2, _a2.sent()];
        case 2:
          if (!isTableCell(nodeType)) return [3, 4];
          return [4, buildTableCell(node, fallback, appliedMarksTypes)];
        case 3:
          return [2, _a2.sent()];
        case 4:
          if (!(isBlock(nodeType) || isInline(nodeType))) return [3, 6];
          return [4, buildGenericBlockOrInline(node, fallback, appliedMarksTypes)];
        case 5:
          return [2, _a2.sent()];
        case 6:
          if (!isText(nodeType)) return [3, 8];
          return [4, buildText(node, fallback, appliedMarksTypes)];
        case 7:
          return [2, _a2.sent()];
        case 8:
          return [4, buildFallbackNode(node, fallback)];
        case 9:
          return [2, _a2.sent()];
      }
    });
  });
}
function mdToRichTextNodes(nodes_1, fallback_1) {
  return __awaiter(this, arguments, void 0, function(nodes, fallback, appliedMarksTypes) {
    var rtNodes;
    if (appliedMarksTypes === void 0) {
      appliedMarksTypes = [];
    }
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!nodes) {
            return [2, Promise.resolve([])];
          }
          return [4, Promise.all(nodes.map(function(node) {
            return mdToRichTextNode(node, fallback, appliedMarksTypes);
          }))];
        case 1:
          rtNodes = _a2.sent();
          return [2, _.flatten(rtNodes).filter(Boolean)];
      }
    });
  });
}
var astToRichTextDocument = function(tree, fallback) {
  return __awaiter(void 0, void 0, void 0, function() {
    var content2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, mdToRichTextNodes(tree.children, fallback)];
        case 1:
          content2 = _a2.sent();
          return [2, {
            nodeType: richTextTypes$1.BLOCKS.DOCUMENT,
            data: {},
            content: content2
          }];
      }
    });
  });
};
function expandParagraphWithInlineImages(node) {
  if (node.type !== "paragraph") {
    return [node];
  }
  var imageNodeIndices = [];
  for (var i2 = 0; i2 < node.children.length; i2++) {
    if (node.children[i2].type === "image") {
      imageNodeIndices.push(i2);
    }
  }
  if (imageNodeIndices.length === 0) {
    return [node];
  }
  var allNodes = [];
  var lastIndex = -1;
  for (var j2 = 0; j2 < imageNodeIndices.length; j2++) {
    var index2 = imageNodeIndices[j2];
    if (index2 !== 0) {
      var nodesBefore = node.children.slice(lastIndex + 1, index2);
      if (nodesBefore.length > 0) {
        allNodes.push(__assign$1(__assign$1({}, node), { children: nodesBefore }));
      }
    }
    var imageNode = node.children[index2];
    allNodes.push(imageNode);
    var nodesAfter = [];
    var rangeEnd = j2 + 1 < imageNodeIndices.length ? imageNodeIndices[j2 + 1] : node.children.length;
    if (index2 + 1 < rangeEnd && index2 === imageNodeIndices.slice(-1)[0]) {
      nodesAfter = node.children.slice(index2 + 1, rangeEnd);
      if (nodesAfter.length > 0) {
        allNodes.push(__assign$1(__assign$1({}, node), { children: nodesAfter }));
      }
    }
    lastIndex = index2;
  }
  return allNodes;
}
function prepareMdAST(ast) {
  function prepareASTNodeChildren(node) {
    if (!node.children) {
      return node;
    }
    var children = _.flatMap(node.children, function(n2) {
      return expandParagraphWithInlineImages(n2);
    }).map(function(n2) {
      return prepareASTNodeChildren(n2);
    });
    return __assign$1(__assign$1({}, node), { children });
  }
  return prepareASTNodeChildren({
    depth: "0",
    type: "root",
    value: "",
    ordered: true,
    children: ast.children
  });
}
function richTextFromMarkdown(md_1) {
  return __awaiter(this, arguments, void 0, function(md, fallback) {
    var processor, tree, ast;
    if (fallback === void 0) {
      fallback = function() {
        return Promise.resolve(null);
      };
    }
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          processor = unified().use(markdown).use(gfm);
          tree = processor.parse(md);
          ast = prepareMdAST(tree);
          return [4, astToRichTextDocument(ast, fallback)];
        case 1:
          return [2, _a2.sent()];
      }
    });
  });
}
var richTextFromMarkdown_1 = richTextFromMarkdown;
var React = a__default;
var richTextTypes = dist$1;
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
function appendKeyToValidElement(element, key) {
  if (React.isValidElement(element) && element.key === null) {
    return React.cloneElement(element, { key });
  }
  return element;
}
function nodeListToReactComponents(nodes, options) {
  return nodes.map(function(node, index2) {
    return appendKeyToValidElement(nodeToReactComponent(node, options), index2);
  });
}
function nodeToReactComponent(node, options) {
  var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
  if (richTextTypes.helpers.isText(node)) {
    var nodeValue = renderText ? renderText(node.value) : node.value;
    if (preserveWhitespace && !renderText) {
      nodeValue = nodeValue.replace(/ {2,}/g, function(match2) {
        return " ".repeat(match2.length);
      });
      var lines_1 = nodeValue.split("\n");
      var jsxLines_1 = [];
      lines_1.forEach(function(line, index2) {
        jsxLines_1.push(line);
        if (index2 !== lines_1.length - 1) {
          jsxLines_1.push(React.createElement("br", null));
        }
      });
      nodeValue = jsxLines_1;
    }
    return node.marks.reduce(function(value, mark) {
      if (!renderMark[mark.type]) {
        return value;
      }
      return renderMark[mark.type](value);
    }, nodeValue);
  } else {
    var children = nodeListToReactComponents(node.content, options);
    if (!node.nodeType || !renderNode[node.nodeType]) {
      return React.createElement(React.Fragment, null, children);
    }
    return renderNode[node.nodeType](node, children);
  }
}
var _a, _b;
var defaultNodeRenderers = (_a = {}, _a[richTextTypes.BLOCKS.DOCUMENT] = function(node, children) {
  return children;
}, _a[richTextTypes.BLOCKS.PARAGRAPH] = function(node, children) {
  return React.createElement("p", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_1] = function(node, children) {
  return React.createElement("h1", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_2] = function(node, children) {
  return React.createElement("h2", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_3] = function(node, children) {
  return React.createElement("h3", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_4] = function(node, children) {
  return React.createElement("h4", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_5] = function(node, children) {
  return React.createElement("h5", null, children);
}, _a[richTextTypes.BLOCKS.HEADING_6] = function(node, children) {
  return React.createElement("h6", null, children);
}, _a[richTextTypes.BLOCKS.EMBEDDED_ENTRY] = function(node, children) {
  return React.createElement("div", null, children);
}, _a[richTextTypes.BLOCKS.EMBEDDED_RESOURCE] = function(node, children) {
  return React.createElement("div", null, children);
}, _a[richTextTypes.BLOCKS.UL_LIST] = function(node, children) {
  return React.createElement("ul", null, children);
}, _a[richTextTypes.BLOCKS.OL_LIST] = function(node, children) {
  return React.createElement("ol", null, children);
}, _a[richTextTypes.BLOCKS.LIST_ITEM] = function(node, children) {
  return React.createElement("li", null, children);
}, _a[richTextTypes.BLOCKS.QUOTE] = function(node, children) {
  return React.createElement("blockquote", null, children);
}, _a[richTextTypes.BLOCKS.HR] = function() {
  return React.createElement("hr", null);
}, _a[richTextTypes.BLOCKS.TABLE] = function(node, children) {
  return React.createElement(
    "table",
    null,
    React.createElement("tbody", null, children)
  );
}, _a[richTextTypes.BLOCKS.TABLE_ROW] = function(node, children) {
  return React.createElement("tr", null, children);
}, _a[richTextTypes.BLOCKS.TABLE_HEADER_CELL] = function(node, children) {
  return React.createElement("th", null, children);
}, _a[richTextTypes.BLOCKS.TABLE_CELL] = function(node, children) {
  return React.createElement("td", null, children);
}, _a[richTextTypes.INLINES.ASSET_HYPERLINK] = function(node) {
  return defaultInline(richTextTypes.INLINES.ASSET_HYPERLINK, node);
}, _a[richTextTypes.INLINES.ENTRY_HYPERLINK] = function(node) {
  return defaultInline(richTextTypes.INLINES.ENTRY_HYPERLINK, node);
}, _a[richTextTypes.INLINES.RESOURCE_HYPERLINK] = function(node) {
  return defaultInlineResource(richTextTypes.INLINES.RESOURCE_HYPERLINK, node);
}, _a[richTextTypes.INLINES.EMBEDDED_ENTRY] = function(node) {
  return defaultInline(richTextTypes.INLINES.EMBEDDED_ENTRY, node);
}, _a[richTextTypes.INLINES.EMBEDDED_RESOURCE] = function(node, _children) {
  return defaultInlineResource(richTextTypes.INLINES.EMBEDDED_RESOURCE, node);
}, _a[richTextTypes.INLINES.HYPERLINK] = function(node, children) {
  return React.createElement("a", { href: node.data.uri }, children);
}, _a);
var defaultMarkRenderers = (_b = {}, _b[richTextTypes.MARKS.BOLD] = function(text2) {
  return React.createElement("b", null, text2);
}, _b[richTextTypes.MARKS.ITALIC] = function(text2) {
  return React.createElement("i", null, text2);
}, _b[richTextTypes.MARKS.UNDERLINE] = function(text2) {
  return React.createElement("u", null, text2);
}, _b[richTextTypes.MARKS.CODE] = function(text2) {
  return React.createElement("code", null, text2);
}, _b[richTextTypes.MARKS.SUPERSCRIPT] = function(text2) {
  return React.createElement("sup", null, text2);
}, _b[richTextTypes.MARKS.SUBSCRIPT] = function(text2) {
  return React.createElement("sub", null, text2);
}, _b[richTextTypes.MARKS.STRIKETHROUGH] = function(text2) {
  return React.createElement("s", null, text2);
}, _b);
function defaultInline(type, node) {
  return React.createElement(
    "span",
    { key: node.data.target.sys.id },
    "type: ",
    node.nodeType,
    " id: ",
    node.data.target.sys.id
  );
}
function defaultInlineResource(type, node) {
  return React.createElement(
    "span",
    { key: node.data.target.sys.urn },
    "type: ",
    node.nodeType,
    " urn: ",
    node.data.target.sys.urn
  );
}
function documentToReactComponents(richTextDocument, options) {
  if (options === void 0) {
    options = {};
  }
  if (!richTextDocument) {
    return null;
  }
  return nodeToReactComponent(richTextDocument, {
    renderNode: __assign(__assign({}, defaultNodeRenderers), options.renderNode),
    renderMark: __assign(__assign({}, defaultMarkRenderers), options.renderMark),
    renderText: options.renderText,
    preserveWhitespace: options.preserveWhitespace
  });
}
var documentToReactComponents_1 = documentToReactComponents;
const ListItem = ({ children, number, className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: twMerge("flex items-start gap-e16", className), children: [
    isNumber$2(number) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-e32 w-e32 shrink-0 items-center justify-center rounded-full bg-orange-300", children: number }),
    isUndefined(number) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-e24 w-e24 shrink-0 items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SyntaxIcon,
      {
        icon: "CirclesTarget",
        className: "size-e8"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children })
  ] });
};
const UnorderedList = ({
  children,
  as = "ul",
  className,
  noDefaultMargins,
  ...rest
}) => {
  return a__default.createElement(
    as,
    {
      className: twMerge(
        clsx("sm-d:gap-e24 flex flex-col gap-e40", {
          "mb-e24 last:mb-0": !noDefaultMargins
        }),
        className
      ),
      ...rest
    },
    children
  );
};
const OrderedList = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  UnorderedList,
  {
    as: "ol",
    ...props
  }
);
UnorderedList.Item = ListItem;
OrderedList.Item = ListItem;
const RichText = ({ children: richTextDocument }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: documentToReactComponents_1(richTextDocument, {
    renderNode: {
      [dist$1.BLOCKS.UL_LIST]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(UnorderedList, { className: "gap-e8", children });
      },
      [dist$1.BLOCKS.OL_LIST]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(OrderedList, { className: "gap-e8", children });
      },
      [dist$1.BLOCKS.LIST_ITEM]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(UnorderedList.Item, { children });
      },
      [dist$1.BLOCKS.PARAGRAPH]: (_2, children) => {
        if (isArray$1(children) && children.every(isEmpty)) {
          return "";
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { children });
      },
      [dist$1.INLINES.HYPERLINK]: ({ data }, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            external: true,
            to: data.uri,
            children
          }
        );
      },
      [dist$1.BLOCKS.HEADING_1]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h1", children });
      },
      [dist$1.BLOCKS.HEADING_2]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h2", children });
      },
      [dist$1.BLOCKS.HEADING_3]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h3", children });
      },
      [dist$1.BLOCKS.HEADING_4]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h4", children });
      },
      [dist$1.BLOCKS.HEADING_5]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h5", children });
      },
      [dist$1.BLOCKS.HEADING_6]: (_2, children) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h6", children });
      }
    },
    renderMark: {
      [dist$1.MARKS.BOLD]: (text2) => /* @__PURE__ */ jsxRuntimeExports.jsx("b", { className: "font-bold", children: text2 }),
      [dist$1.MARKS.ITALIC]: (text2) => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "italic", children: text2 })
    },
    renderText: (text2) => {
      return text2;
    }
  }) });
};
const MarkdownText = ({
  children,
  noDefaultMargins,
  className,
  ...props
}) => {
  if (!isString(children)) {
    throw new Error(
      `Error in ${MarkdownText}. Expected children to by a string but instead of ${typeof children}`
    );
  }
  const [document2, setDocument] = useState();
  useEffect(() => {
    richTextFromMarkdown_1(children).then((d2) => setDocument(d2)).catch((e3) => {
      throw new Error(e3);
    });
  }, [children]);
  if (!document2) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ...props,
      className: twMerge$2(
        clsx({
          "mb-e40": !noDefaultMargins
        }),
        className
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RichText, { children: document2 })
    }
  );
};
const ProgressBar = ({ progress, className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(
        "relative h-e6 overflow-hidden rounded-lg bg-black-200 text-green-800",
        className
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "left-0 h-full bg-current transition-all",
          style: { width: `${progress}%` }
        }
      )
    }
  );
};
const cardClassName = clsx(
  // Layout
  "flex flex-col gap-e32",
  // Spacing
  "p-e32",
  // Borders
  "border border-warm-gray-200",
  // Text
  "text-warm-gray-900"
);
const contentClassName = clsx("flex flex-col gap-e32", "divide-y divide-warm-gray-200");
const containerClassName$1 = clsx("flex items-center justify-between gap-e24", "pt-e32");
const TEST_IDS_CONFIG$4 = {
  LABEL: "label",
  PRICE: "price"
};
const ReservationPricing = ({ price, ...rest }) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$4,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: containerClassName$1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paragraph,
      {
        size: "lg",
        className: "text-warm-gray-600",
        noDefaultMargins: true,
        ...testIds.LABEL,
        children: "Amount Due"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text,
      {
        variant: "display",
        ...testIds.PRICE,
        children: price
      }
    )
  ] });
};
const TEST_IDS_CONFIG$3 = {
  TITLE: "title",
  CONTENT: "content",
  PRICING: "pricing"
};
const ReservationCard = ({
  title,
  price,
  className,
  children,
  ...rest
}) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$3,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Card,
    {
      className: twMerge(cardClassName, className),
      ...rest,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text,
          {
            variant: "overline",
            ...testIds.TITLE,
            children: title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: contentClassName,
            ...testIds.CONTENT,
            children: [
              children,
              price && /* @__PURE__ */ jsxRuntimeExports.jsx(
                ReservationPricing,
                {
                  price,
                  ...testIds.PRICING
                }
              )
            ]
          }
        )
      ]
    }
  );
};
const containerClassName = clsx("flex flex-col gap-e10", "not-first:pt-e32");
const titleContainerClassName = clsx(
  "flex items-center justify-between gap-e24",
  "min-h-es36"
);
const ctaButtonClassName = clsx("mobile-d:self-start");
const detailsContainerClassName = clsx("flex flex-col gap-e8");
const detailLineClassName = clsx("flex items-center gap-e12", "text-warm-gray-600");
const TEST_IDS_CONFIG$2 = {
  TEXT: "text"
};
const ReservationDetailLine = ({ icon, children, ...rest }) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$2,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: detailLineClassName, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SyntaxIcon,
      {
        icon,
        size: "lg",
        className: "shrink-0"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paragraph,
      {
        size: "md",
        noDefaultMargins: true,
        ...testIds.TEXT,
        children
      }
    )
  ] });
};
const TEST_IDS_CONFIG$1 = {
  TITLE: "title",
  CTA_BUTTON: "cta-button",
  DATE_LINE: "date",
  TIME_LINE: "time"
};
const Reservation = ({
  title,
  dateLabel,
  timeLabel,
  ctaLabel,
  className,
  onCtaClick,
  ...rest
}) => {
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG$1,
    ids: rest
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: twMerge(containerClassName, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: titleContainerClassName, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Heading,
        {
          level: "h4",
          noDefaultMargins: true,
          ...testIds.TITLE,
          children: title
        }
      ),
      ctaLabel && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          variant: "link",
          size: "sm",
          className: ctaButtonClassName,
          onClick: onCtaClick,
          ...testIds.CTA_BUTTON,
          children: ctaLabel
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: detailsContainerClassName, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReservationDetailLine,
        {
          icon: w$5,
          ...testIds.DATE_LINE,
          children: dateLabel
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReservationDetailLine,
        {
          icon: C$1,
          ...testIds.TIME_LINE,
          children: timeLabel
        }
      )
    ] })
  ] });
};
const variantClasses = {
  base: clsx(
    "flex h-es360 max-h-full flex-col items-stretch mobile-d:h-es330",
    "transition-all",
    "group"
  ),
  orchid: "bg-orchid-100",
  yellow: "bg-yellow-300",
  orange: "bg-orange-300",
  purple: "bg-purple-200"
};
const ResourceCard = ({
  variant = "orange",
  title,
  subtitle,
  content: content2,
  icon,
  className,
  contentClassName: contentClassName2,
  loading,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    loading && /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSpinner, { overlay: true }),
    !loading && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Card,
      {
        as: "button",
        disabled: loading,
        className: twMerge(
          clsx(variantClasses.base, variantClasses[variant], {
            "bg-gray-200": loading,
            "hover:rounded-30": !loading
          }),
          className
        ),
        ...props,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-e24 flex items-center gap-e16", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: clsx("rounded-lg p-e16", "mobile-d:hidden", {
                  "bg-orchid-200": variant === "orchid",
                  "bg-yellow-500": variant === "yellow",
                  "bg-orange-500": variant === "orange",
                  "bg-purple-300": variant === "purple"
                }),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SyntaxIcon,
                  {
                    icon,
                    weight: "fill"
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Heading,
              {
                level: "h6",
                noDefaultMargins: true,
                children: title
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grow overflow-hidden text-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Heading,
            {
              level: "h4",
              className: twMerge(
                "line-clamp-5 tablet-d:line-clamp-6 mobile-d:line-clamp-7",
                contentClassName2
              ),
              noDefaultMargins: true,
              children: content2
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-end", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Heading,
              {
                level: "h6",
                className: "grow text-left font-semibold mobile-d:hidden",
                noDefaultMargins: true,
                children: subtitle
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button,
              {
                size: "lg",
                as: "div",
                iconOnly: true,
                title: "",
                variant: "ghost",
                className: "shrink-0 group-hover:bg-black-8%",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(d$2, { className: "size-e24" })
              }
            )
          ] })
        ] })
      }
    )
  ] });
};
const ScrollableContainer = ({
  children,
  className,
  "data-testid": dataTestId,
  ...props
}) => {
  const scrollableRef = useRef(null);
  const { scrollInfo } = useIsScrollable(scrollableRef);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: scrollableRef,
      className: twMerge(
        "w-full overflow-x-auto overflow-y-hidden scrollbar-medium hover:overflow-y-auto",
        scrollInfo.isScrollableX && "pb-e32",
        scrollInfo.isScrollableY && "pr-e32",
        className
      ),
      "data-testid": dataTestId || "scrollable-container",
      ...props,
      children
    }
  );
};
const splitButtonContainerClasses = clsx(
  // Layout
  "flex"
);
const SplitButtonContext = createContext(null);
const useSplitButtonContext = () => {
  const context = useContext(SplitButtonContext);
  if (!context) {
    throw new Error("SplitButton.Button must be used within a SplitButton");
  }
  return context;
};
const SplitButtonProvider = ({ variant, size: size2, children }) => {
  const value = useMemo(() => ({ variant, size: size2 }), [variant, size2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SplitButtonContext.Provider, { value, children });
};
const buttonItemVariantClasses = {
  base: clsx(
    // Border (override)
    "rounded-none",
    // Border
    "first-of-type:rounded-l-full",
    "last-of-type:rounded-r-full",
    // Focus styles
    "focus:ring-0 focus:ring-offset-0"
  ),
  primary: "",
  secondary: clsx(
    "border-r-0",
    "border-warm-gray-700 not-first:border-l",
    "last-of-type:border-l-0 last-of-type:border-r"
  )
};
const getButtonItemActiveClasses = ({ active }) => ({
  primary: clsx({ "bg-purple-300 hover:bg-purple-300": active }),
  secondary: clsx({ "bg-warm-gray-16% hover:bg-warm-gray-16%": active })
});
const SplitButtonItem = forwardRef(
  ({ className, active, ...rest }, ref) => {
    const { variant, size: size2 } = useSplitButtonContext();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        ...rest,
        variant,
        size: size2,
        buttonRef: ref,
        className: twMerge(
          buttonItemVariantClasses.base,
          buttonItemVariantClasses[variant],
          getButtonItemActiveClasses({ active: !!active })[variant],
          className
        )
      }
    );
  }
);
const DotsMenuButton = forwardRef(
  ({ ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      SplitButtonItem,
      {
        ...props,
        ref,
        iconOnly: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SyntaxIcon,
          {
            icon: w$3,
            weight: "fill"
          }
        )
      }
    );
  }
);
const SplitButtonBase = ({
  children,
  variant = "primary",
  size: size2 = "lg",
  className
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SplitButtonProvider,
    {
      variant,
      size: size2,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: twMerge(clsx(splitButtonContainerClasses), className), children })
    }
  );
};
const SplitButton = SplitButtonBase;
SplitButton.displayName = "SplitButton";
SplitButton.Button = SplitButtonItem;
SplitButton.DotsMenuButton = DotsMenuButton;
const SubmitButton = ({
  disableBehavior = "never",
  disabled: disabledProp,
  ...props
}) => {
  const { disabled: disabledFormState, isValid: isValid2, isSubmitting } = useFormState();
  const isDisabled = useMemo(() => {
    if (isSubmitting) return true;
    if (disabledProp) return true;
    if (disabledFormState) return true;
    switch (disableBehavior) {
      case "onValid":
        return !isValid2;
      case "never":
        return false;
    }
    return false;
  }, [disabledFormState, isValid2, isSubmitting, disabledProp, disableBehavior]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Button,
    {
      ...props,
      disabled: isDisabled,
      type: "submit",
      children: [
        props.children,
        isSubmitting && /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSpinner, {})
      ]
    }
  );
};
const Table = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollableContainer, { className: "max-h-[400px]", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "table",
    {
      className: twMerge(clsx("w-full min-w-max border-collapse", className)),
      ...props,
      children
    }
  ) });
};
const TableCard = ({ title, cta, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { variant: "default", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-baseline justify-between pb-e16", children: [
      title && /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { level: "h3", children: title }),
      cta
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { ...props })
  ] });
};
const TableHeader = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "thead",
    {
      className: twMerge(clsx("border-b border-warm-gray-200", className)),
      ...props,
      children
    }
  );
};
const TableBody = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "tbody",
    {
      className: twMerge(
        clsx("divide-y divide-warm-gray-200 border-b border-warm-gray-200", className)
      ),
      ...props,
      children
    }
  );
};
const TableRow = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "tr",
    {
      className: twMerge(clsx(className)),
      ...props,
      children
    }
  );
};
const TableHeaderCell = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "th",
    {
      className: twMerge(
        clsx(
          "whitespace-nowrap py-e16 text-left",
          "text-body-sm font-medium text-warm-gray-600",
          "mobile-d:py-e8 mobile-d:pr-e24",
          className
        )
      ),
      ...props,
      children
    }
  );
};
const TableCell = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "td",
    {
      className: twMerge(
        clsx(
          "whitespace-nowrap text-left",
          "py-e8 mobile-d:pr-e24",
          "text-body-md font-normal text-warm-gray-900",
          "max-w-[200px] overflow-hidden text-ellipsis",
          className
        )
      ),
      ...props,
      children
    }
  );
};
const useTabPanelOpenState = (tabs, currentTabId, keepMounted) => {
  const [openedTabs, setOpenedTabs] = useState([]);
  useEffect(() => {
    setOpenedTabs((prev) => prev.includes(currentTabId) ? prev : [...prev, currentTabId]);
  }, [currentTabId]);
  const openedTabsMap = useMemo(() => {
    return tabs.reduce(
      (acc, { id }) => {
        acc[id] = (openedTabs.includes(id) && keepMounted) ?? false;
        return acc;
      },
      {}
    );
  }, [openedTabs, tabs, keepMounted]);
  const getUnmountedProp = useCallback(
    (tabId, unmountedProp) => {
      const keepMounted2 = openedTabsMap[tabId] || unmountedProp === false;
      return {
        unmount: !keepMounted2
      };
    },
    [openedTabsMap]
  );
  return {
    openedTabs: openedTabsMap,
    getUnmountProp: getUnmountedProp
  };
};
const TABS_TEST_IDS_CONFIG = {
  BASE: "tabs",
  TAB: "tab",
  TAB_LIST: "list",
  DROPDOWN_BUTTON: "list-dropdown-button",
  DROPDOWN_BUTTON_LABEL: "list-dropdown-button-label",
  PANELS_CONTAINER: "panels-container"
};
const TabsContext = createContext(null);
const useTabsContext = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("useTabsContext must be used within a TabsProvider");
  }
  return context;
};
const tabsClassNames = clsx(
  // Layout
  "flex flex-col gap-e40",
  // Width
  "w-full"
);
const buttonClassNames = clsx(
  "flex w-full max-w-es330 items-center justify-between gap-e8",
  "text-left",
  "mobile-d:max-w-full",
  "py-e6",
  "border-b border-b-warm-gray-200"
);
const DropdownButton = forwardRef(
  ({ active, children, className, ...props }, ref) => {
    const {
      testIds: { DROPDOWN_BUTTON_LABEL }
    } = useTabsContext();
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        ...props,
        ref,
        className: twMerge(buttonClassNames, className),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Text,
            {
              variant: "h6",
              ...DROPDOWN_BUTTON_LABEL,
              children
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              iconOnly: true,
              as: "div",
              variant: "ghost",
              size: "sm",
              className: clsx("transition-bg", { "bg-warm-gray-16%": active }),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                SyntaxIcon,
                {
                  icon: D,
                  className: clsx("transition-transform", { "-rotate-180": active })
                }
              )
            }
          )
        ]
      }
    );
  }
);
const tabClassNames = clsx(
  // Group
  "group",
  // Layout
  "flex shrink-0 items-center",
  // Spacing
  "py-e10 focus:pb-e8 hui-selected:pb-e8",
  // Focus
  "focus:outline-none",
  // Border
  "hui-selected:border-b-2 hui-selected:border-b-purple-300",
  // Text
  "hover:font-medium active:font-medium hui-selected:font-medium",
  // Text color
  "text-warm-gray-700 hover:text-purple-900 active:text-purple-900 hui-selected:text-warm-gray-900",
  // Disabled
  "hui-disabled:pointer-events-none hui-disabled:cursor-not-allowed hui-disabled:text-warm-gray-400",
  // Transitions
  "transition-colors",
  // Cursor
  "cursor-pointer select-none"
);
const tabLabelClassNames = clsx(
  // Spacing
  "px-e8 py-e2",
  // Border radius
  "rounded-100",
  // Background
  "group-focus-visible:bg-warm-gray-8% group-active:bg-warm-gray-8%",
  // Transitions
  "transition-all"
);
const tabBadgeClassNames = clsx(
  // Spacing
  "px-e6",
  // Border radius
  "rounded-40"
);
const tabBadgeTextClassNames = clsx(
  // Text
  "font-normal text-warm-gray-800"
);
const TabItem = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    $e,
    {
      ...props,
      className: twMerge(tabClassNames, className),
      children
    }
  );
};
TabItem.displayName = "Tabs.Tab";
const TabTitle = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StableSizeText,
    {
      ...props,
      variant: "body-md",
      className: twMerge(tabLabelClassNames, className),
      children
    }
  );
};
TabTitle.displayName = "Tabs.TabTitle";
const TabBadge = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Badge,
    {
      ...props,
      className: twMerge(tabBadgeClassNames, className),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Badge.Label, { className: tabBadgeTextClassNames, children })
    }
  );
};
const TabNotificationBadge = ({
  notificationCount,
  ...props
}) => {
  if (isNil(notificationCount)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabBadge, { ...props, children: notificationCount });
};
const useTabItemTestIds = ({ id }) => {
  const {
    testIds: { TAB }
  } = useTabsContext();
  const { BASE, TITLE, BADGE } = useDataTestIds({
    componentConfig: {
      BASE: String(id),
      TITLE: "title",
      BADGE: "badge"
    },
    ids: { ...TAB }
  });
  return {
    BASE,
    TITLE,
    BADGE
  };
};
const DropdownTabItem = ({
  id,
  title,
  notificationCount,
  disabled,
  onClick
}) => {
  const { BASE, BADGE } = useTabItemTestIds({ id });
  return /* @__PURE__ */ jsxRuntimeExports.jsx($e, { as: jsxRuntimeExports.Fragment, children: ({ selected: active }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    DropdownMenu.Item,
    {
      ...BASE,
      disabled,
      className: clsx({ "bg-orchid-50": active }),
      onClick,
      children: [
        title,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TabNotificationBadge,
          {
            ...BADGE,
            notificationCount
          }
        )
      ]
    }
  ) });
};
const dropdownTabListVariants = tv({
  slots: {
    button: "mobile-sm-d:w-full w-clamp-es330"
  }
});
const DropdownTabList = ({ ...props }) => {
  const {
    selectedTab,
    onChangeTab: setSelectedTab,
    tabs,
    testIds: { TAB_LIST, DROPDOWN_BUTTON }
  } = useTabsContext();
  const { button } = dropdownTabListVariants();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DropdownMenu,
    {
      as: "div",
      displayMode: "mobile-fullscreen",
      fullscreenBreakpoint: "mobile-sm",
      matchButtonWidth: true,
      children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          DropdownMenu.Button,
          {
            component: DropdownButton,
            className: button(),
            ...DROPDOWN_BUTTON,
            children: selectedTab?.title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          $e.List,
          {
            ...props,
            as: jsxRuntimeExports.Fragment,
            ...TAB_LIST,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              DropdownMenu.Items,
              {
                static: true,
                className: clsx({ hidden: !open }),
                children: tabs.map(({ ...tabItemProps }) => /* @__PURE__ */ createElement(
                  DropdownTabItem,
                  {
                    ...tabItemProps,
                    key: tabItemProps.id,
                    onClick: () => setSelectedTab(tabItemProps.id)
                  }
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
const tabListClassNames = clsx(
  // Layout
  "flex",
  // Spacing
  "gap-e8",
  // Border
  "border-b border-b-warm-gray-200"
);
const HorizontalTabItem = ({ id, title, notificationCount, disabled }) => {
  const { BASE, TITLE, BADGE } = useTabItemTestIds({ id });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    TabItem,
    {
      ...BASE,
      disabled,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TabTitle, { ...TITLE, children: title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TabNotificationBadge,
          {
            ...BADGE,
            notificationCount
          }
        )
      ]
    }
  );
};
const HorizontalTabList = ({ className, ...props }) => {
  const {
    tabs,
    testIds: { TAB_LIST }
  } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    $e.List,
    {
      ...props,
      ...TAB_LIST,
      className: twMerge(tabListClassNames, className),
      children: tabs.map(({ ...tabItemProps }) => /* @__PURE__ */ createElement(
        HorizontalTabItem,
        {
          ...tabItemProps,
          key: tabItemProps.id
        }
      ))
    }
  );
};
const useCompactModeDetection = (ref, breakpoint = "mobile") => {
  const [cutOffWidth, setCutOffWidth] = useState(void 0);
  const [isCompactMode, setIsCompactMode] = useState(void 0);
  const { smallerOrEqual } = useViewport();
  const matchesBreakpoint = smallerOrEqual(breakpoint);
  useResizeObserver({
    ref,
    onResize: () => {
      if (!ref.current) return;
      const element = ref.current;
      const isScrollable = element.scrollWidth > element.clientWidth;
      if (!cutOffWidth && isScrollable) {
        setCutOffWidth(element.scrollWidth);
        setIsCompactMode(true);
      } else if (cutOffWidth) {
        const fitsRegularVersion = element.clientWidth > cutOffWidth;
        setIsCompactMode(!fitsRegularVersion);
      } else {
        setIsCompactMode(false);
      }
    }
  });
  if (matchesBreakpoint) {
    return {
      isCompactMode: true
    };
  }
  return {
    isCompactMode
  };
};
const TabList = ({ ...props }) => {
  const containerRef = useRef(null);
  const { isCompactMode } = useCompactModeDetection(containerRef);
  const TabListComponent = useMemo(
    () => isCompactMode ? DropdownTabList : HorizontalTabList,
    [isCompactMode]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: containerRef,
      className: "overflow-hidden",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TabListComponent,
        {
          ...props,
          className: clsx({ invisible: isCompactMode === void 0 })
        }
      )
    }
  );
};
TabList.displayName = "Tabs.List";
const tabPanelClassNames = clsx(
  // Focus
  "focus:outline-none"
);
const TabPanel = ({
  className,
  children,
  unmount,
  tabId,
  ...props
}) => {
  const { getUnmountProp: getUnmountedProp } = useTabsContext();
  const unmountProps = useMemo(() => {
    return getUnmountedProp(tabId, unmount);
  }, [getUnmountedProp, tabId, unmount]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    $e.Panel,
    {
      ...props,
      ...unmountProps,
      tabIndex: -1,
      className: twMerge(tabPanelClassNames, className),
      children
    }
  );
};
TabPanel.displayName = "Tabs.Panel";
const TabPanels = ({ children, ...props }) => {
  const {
    testIds: { PANELS_CONTAINER }
  } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    $e.Panels,
    {
      ...props,
      ...PANELS_CONTAINER,
      children
    }
  );
};
TabPanels.displayName = "Tabs.Panels";
const TabsBase = ({
  tabs,
  manual,
  className,
  children,
  selectedTabId: selectedTabIdProp,
  onChange,
  defaultSelectedTabId,
  keepTabsMounted,
  "data-testid": dataTestId,
  ...props
}) => {
  const [_selectedTabId, setSelectedTab] = useState(defaultSelectedTabId ?? tabs[0]?.id ?? 0);
  const selectedTabId = selectedTabIdProp ?? _selectedTabId;
  const selectedTabIndex = useMemo(() => {
    return tabs.findIndex((t2) => t2.id === selectedTabId);
  }, [selectedTabId, tabs]);
  const onChangeTab = useCallback(
    (tabId) => {
      setSelectedTab(tabId);
      onChange?.(tabId);
    },
    [onChange]
  );
  const onChangeInternal = useCallback(
    (index2) => {
      const tabId = tabs[index2]?.id;
      if (!tabId) throw new Error(`<Tabs/> Tab with index ${index2} not found`);
      onChangeTab(tabId);
    },
    [onChangeTab, tabs]
  );
  const selectedTab = useMemo(() => {
    return tabs.find((t2) => t2.id === selectedTabId);
  }, [selectedTabId, tabs]);
  const { getUnmountProp: getUnmountedProp } = useTabPanelOpenState(
    tabs,
    selectedTabId,
    keepTabsMounted
  );
  const testIds = useDataTestIds({
    componentConfig: TABS_TEST_IDS_CONFIG,
    ids: {
      "data-testid": dataTestId
    }
  });
  const contextValue = useMemo(
    () => ({
      selectedTabId,
      onChangeTab,
      tabs,
      selectedTab,
      testIds,
      getUnmountProp: getUnmountedProp
    }),
    [selectedTabId, onChangeTab, tabs, selectedTab, testIds, getUnmountedProp]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    $e.Group,
    {
      ...props,
      ...testIds.BASE,
      as: "div",
      manual: manual ?? true,
      className: twMerge(tabsClassNames, className),
      selectedIndex: selectedTabIndex,
      onChange: onChangeInternal,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TabsContext.Provider, { value: contextValue, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TabList, {}),
        children
      ] })
    }
  );
};
TabsBase.displayName = "Tabs";
const Tabs = Object.assign(TabsBase, {
  Panels: TabPanels,
  Panel: TabPanel
});
const toastContainerClassName = clsx(
  // Positioning
  "fixed bottom-e24 z-50",
  // Layout
  "flex flex-col gap-e8",
  // Spacing
  "px-e32 mobile-d:px-e24",
  // Size
  "w-full"
);
const baseToastClassName = twMerge(
  // Layout
  "flex items-center justify-between gap-e24 mobile-d:gap-e12",
  // Spacing
  "p-e16",
  // Borders
  "border border-warm-gray-300",
  "rounded-md",
  // Size
  // 'min-w-[240px] max-w-[400px]',
  "max-w-fit",
  // Responsive
  "mobile-d:max-w-full",
  // Animation
  "animate-slide-in-left"
);
const variantClassNameMap = {
  success: "bg-utility-success",
  error: "bg-orange-50"
};
const toastContentClassName = "flex gap-e12";
const toastActionsClassName = "flex items-center gap-e24 shrink-0 mobile-d:gap-e12";
const iconClassName = "shrink-0";
const iconColorClassNameMap = {
  success: "text-utility-success-dark",
  error: "text-utility-error"
};
const actionButtonClassName = "shrink-0 last:mr-e12";
const dismissButtonClassName = "shrink-0";
const ToastIconMap = {
  success: k$2,
  error: I
};
const useAutoDismiss = ({ duration, persistent, onDismiss }) => {
  const timerRef = useRef(null);
  const handleDismiss = useCallback(() => {
    onDismiss();
  }, [onDismiss]);
  useEffect(() => {
    if (!persistent) {
      timerRef.current = setTimeout(() => {
        handleDismiss();
      }, duration);
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [duration, handleDismiss, persistent]);
  return { handleDismiss };
};
const TEST_IDS_CONFIG = {
  BASE: "",
  MESSAGE: "message",
  ACTION_BUTTON: "action-button",
  DISMISS_BUTTON: "dismiss-button"
};
const Toast = ({ toast, className, onDismiss }) => {
  const { uid, options } = toast;
  const {
    variant,
    message: message2,
    action,
    duration = 5e3,
    persistent = false,
    dismissable = true,
    onClose
  } = options;
  const testIds = useDataTestIds({
    componentConfig: TEST_IDS_CONFIG,
    ids: { id: options.id }
  });
  const handleDismissWithCallback = useCallback(() => {
    onClose?.();
    onDismiss(uid);
  }, [uid, onClose, onDismiss]);
  const { handleDismiss } = useAutoDismiss({
    duration,
    persistent,
    onDismiss: handleDismissWithCallback
  });
  const handleActionClick = () => {
    action?.onClick?.();
    handleDismiss();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: twMerge(baseToastClassName, variantClassNameMap[variant], className),
      ...testIds.BASE,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: toastContentClassName, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            SyntaxIcon,
            {
              icon: ToastIconMap[variant],
              size: "lg",
              weight: "fill",
              className: clsx(iconColorClassNameMap[variant], iconClassName)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Heading,
            {
              level: "h6",
              noDefaultMargins: true,
              ...testIds.MESSAGE,
              children: message2
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: toastActionsClassName, children: [
          action && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              variant: "secondary",
              size: "xs",
              onClick: handleActionClick,
              className: actionButtonClassName,
              ...testIds.ACTION_BUTTON,
              children: action.label
            }
          ),
          (dismissable || persistent) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              iconOnly: true,
              variant: "ghost",
              size: "xs",
              className: dismissButtonClassName,
              onClick: handleDismiss,
              ...testIds.DISMISS_BUTTON,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: R$1 })
            }
          )
        ] })
      ]
    }
  );
};
const ToastContainer = ({ toasts, dismissToast }) => {
  if (toasts.length === 0) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: toastContainerClassName, children: toasts.map((toast) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Toast,
    {
      toast,
      onDismiss: dismissToast
    },
    toast.uid
  )) });
};
const ToastContext = createContext({
  toasts: [],
  showToast: () => "",
  dismissToast: () => {
  },
  dismissAllToasts: () => {
  }
});
const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const showToast = useCallback((options) => {
    const uid = Date.now().toString();
    setToasts((prevToasts) => [...prevToasts, { uid, options }]);
    return uid;
  }, []);
  const dismissToast = useCallback((uid) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.uid !== uid));
  }, []);
  const dismissAllToasts = useCallback(() => {
    setToasts([]);
  }, []);
  const contextValue = useMemo(
    () => ({
      toasts,
      showToast,
      dismissToast,
      dismissAllToasts
    }),
    [toasts, showToast, dismissToast, dismissAllToasts]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ToastContext.Provider, { value: contextValue, children: [
    children,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToastContainer,
      {
        toasts,
        dismissToast
      }
    )
  ] });
};
const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
var AddressFieldType = /* @__PURE__ */ ((AddressFieldType2) => {
  AddressFieldType2["AddressLine1"] = "address-line-1";
  AddressFieldType2["AddressLine2"] = "address-line-2";
  AddressFieldType2["City"] = "city";
  AddressFieldType2["State"] = "state";
  AddressFieldType2["ZipCode"] = "zipCode";
  return AddressFieldType2;
})(AddressFieldType || {});
const AddressSectionContext = createContext(void 0);
const AddressSectionProvider = ({ children }) => {
  const [fieldNames, setFieldNames] = useState({
    [AddressFieldType.AddressLine1]: "",
    [AddressFieldType.AddressLine2]: "",
    [AddressFieldType.City]: "",
    [AddressFieldType.State]: "",
    [AddressFieldType.ZipCode]: ""
  });
  const registerField = (type, name) => {
    setFieldNames((prev) => ({
      ...prev,
      [type]: name || ""
    }));
  };
  const contextValue = useMemo(
    () => ({
      fieldNames,
      registerField
    }),
    [fieldNames]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AddressSectionContext.Provider, { value: contextValue, children });
};
const useAddressSectionContext = () => {
  const context = useContext(AddressSectionContext);
  if (context === void 0) {
    throw new Error("useAddressSectionContext must be used within an AddressSectionProvider");
  }
  return context;
};
const AddressViewModeText = () => {
  const { getValues } = useFormContext();
  const { fieldNames } = useAddressSectionContext();
  const addressLine1 = getValues(fieldNames[AddressFieldType.AddressLine1]) || "";
  const addressLine2 = getValues(fieldNames[AddressFieldType.AddressLine2]) || "";
  const city = getValues(fieldNames[AddressFieldType.City]) || "";
  const state = getValues(fieldNames[AddressFieldType.State]) || "";
  const zipCode = getValues(fieldNames[AddressFieldType.ZipCode]) || "";
  const cityStateZip = [city, state.toUpperCase(), zipCode].filter(Boolean).join(", ");
  const address = [addressLine1, addressLine2, cityStateZip].filter(Boolean).join("");
  if (!address) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { children: DEFAULT_VIEW_MODE_TEXT });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    addressLine1 && /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { children: addressLine1 }),
    addressLine2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { children: addressLine2 }),
    cityStateZip && /* @__PURE__ */ jsxRuntimeExports.jsx(ViewModeText, { children: cityStateZip })
  ] });
};
const AddressField = ({ type, name, children }) => {
  const { registerField } = useAddressSectionContext();
  useEffect(() => {
    registerField(type, name);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
const Component$4 = forwardRef(({ ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddressField,
    {
      type: AddressFieldType.AddressLine1,
      name: props.name,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput,
        {
          standalone: true,
          ...props,
          ref
        }
      )
    }
  );
});
const AddressLine1 = withFormField(Component$4);
const Component$3 = forwardRef(({ ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddressField,
    {
      type: AddressFieldType.AddressLine2,
      name: props.name,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput,
        {
          standalone: true,
          ...props,
          ref
        }
      )
    }
  );
});
const AddressLine2 = withFormField(Component$3);
const Component$2 = forwardRef(({ ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddressField,
    {
      type: AddressFieldType.City,
      name: props.name,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput,
        {
          standalone: true,
          ...props,
          ref
        }
      )
    }
  );
});
const City = withFormField(Component$2);
const Component$1 = forwardRef(({ ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddressField,
    {
      type: AddressFieldType.State,
      name: props.name,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Select,
        {
          standalone: true,
          ...props,
          ref
        }
      )
    }
  );
});
const State = withFormField(Component$1);
const Component = forwardRef(({ ...props }, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddressField,
    {
      type: AddressFieldType.ZipCode,
      name: props.name,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput,
        {
          standalone: true,
          ...props,
          ref
        }
      )
    }
  );
});
const ZipCode = withFormField(Component);
const AddressSectionViewMode = ({ label }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormField,
    {
      label,
      viewMode: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddressViewModeText, {})
    }
  );
};
const ComponentWithViewMode = ({ label, children, viewMode }) => {
  if (viewMode) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(AddressSectionViewMode, { label });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
const AddressSection = ({ ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AddressSectionProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentWithViewMode, { ...props }) });
};
AddressSection.AddressLine1 = AddressLine1;
AddressSection.AddressLine2 = AddressLine2;
AddressSection.City = City;
AddressSection.State = State;
AddressSection.ZipCode = ZipCode;
const navBarVariants = tv({
  base: "flex w-full items-center gap-e32 justify-between",
  slots: {
    links: ["flex grow-0 shrink-0 content-start gap-e16 justify-self-center"],
    user: ["flex items-center gap-e12 justify-self-end"],
    logo: ["justify-self-start"]
  }
});
const MenuButton = forwardRef(
  ({ active, ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      ...props,
      variant: "ghost",
      iconOnly: true,
      buttonRef: ref,
      size: "md",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(SyntaxIcon, { icon: active ? R$1 : L$1 })
    }
  )
);
const CompactNavBarLinks = ({
  links,
  activeLinkIndex,
  includeSubRoutes,
  logoClassName,
  slotLogo,
  className
}) => {
  const { logo } = navBarVariants();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DropdownMenu, { className, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownMenu.Button, { component: MenuButton }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownMenu.Items, { className: "w-es500", children: links.map((link, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        DropdownMenu.LinkItem,
        {
          ...link,
          active: index2 === activeLinkIndex,
          includeSubRoutes,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownMenu.ItemLabel, { children: link.title })
        },
        link.title
      )) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: logo({ className: logoClassName }), children: slotLogo })
  ] });
};
const navButtonVariants = tv({
  base: ["block", "size-unset h-unset", "relative", "rounded-full", "px-e8 py-e2", "text-h6"],
  variants: {
    active: {
      true: "font-medium text-gray-900",
      false: "font-normal text-gray-700"
    },
    disabled: {
      true: "cursor-not-allowed opacity-50",
      false: ["cursor-pointer", "hover:text-purple-900", "active:bg-warm-gray-8%"]
    }
  }
});
const NavButton = ({
  className,
  children,
  disabled,
  active,
  includeSubRoutes,
  detectActive,
  ...props
}) => {
  const isActive = useIsLinkActive({
    to: props.to,
    includeSubRoutes,
    detectActive,
    isActiveProp: active
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link,
    {
      ...props,
      disabled,
      className: twMerge(
        navButtonVariants({
          active: isActive,
          disabled
        }),
        className
      ),
      unstyled: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StableSizeText, { variant: "body-md", children: [
        " ",
        children
      ] })
    }
  );
};
const HorizontalNavBarLinks = ({
  links,
  activeLinkIndex,
  includeSubRoutes,
  logoClassName,
  slotLogo,
  className
}) => {
  const { links: linksClsx, logo } = navBarVariants();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: logo({ className: logoClassName }), children: slotLogo }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: linksClsx({ className }), children: links.map((link, index2) => /* @__PURE__ */ createElement(
      NavButton,
      {
        ...link,
        active: index2 === activeLinkIndex,
        disabled: link.disabled,
        key: link.title,
        className: "shrink-0",
        includeSubRoutes
      },
      link.title
    )) })
  ] });
};
const NavBar = ({
  slotUser,
  userClassName,
  className,
  compactModeBreakpoint = "tablet",
  ...props
}) => {
  const containerRef = useRef(null);
  const { isCompactMode } = useCompactModeDetection(containerRef, compactModeBreakpoint);
  const NavBarLinksComponent = useMemo(
    () => isCompactMode ? CompactNavBarLinks : HorizontalNavBarLinks,
    [isCompactMode]
  );
  const { base, user } = navBarVariants();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: containerRef,
      className: base({ className }),
      ...props,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          NavBarLinksComponent,
          {
            ...props,
            className: clsx({ invisible: isCompactMode === void 0 })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: user({ className: userClassName }), children: slotUser })
      ]
    }
  );
};
const _Header = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(
        clsx(
          "flex flex-shrink-0 flex-grow-0 items-center px-e24 py-e16 tablet-d:py-e12",
          "border-b border-b-black-12%",
          "transition-padding duration-100",
          className
        )
      ),
      ...rest,
      children
    }
  );
};
const _Body = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(clsx("flex flex-grow flex-col items-center", className)),
      ...rest,
      children
    }
  );
};
const _Footer = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(clsx("flex-shrink-0 flex-grow-0", className)),
      ...rest,
      children
    }
  );
};
const AppLayout = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: twMerge(clsx("flex size-full flex-col", className)),
      ...rest,
      children
    }
  );
};
AppLayout.Header = _Header;
AppLayout.Body = _Body;
AppLayout.Footer = _Footer;
const abbreviationButtonVariants = tv({
  base: "aspect-square rounded-full border border-warm-gray-4% bg-orchid-100 px-e8 py-e10 uppercase hover:bg-orchid-200"
});
const AbbreviationButton = forwardRef(
  ({ as, ...props }, ref) => {
    const childrenElement = isString(props.children) ? getInitials(props.children, 2) : props.children;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        ...props,
        as,
        buttonRef: ref,
        variant: "primary",
        className: abbreviationButtonVariants({ className: props.className }),
        children: childrenElement
      }
    );
  }
);
AbbreviationButton.displayName = "AbbreviationButton";
const zipCodePattern = /^(\d{5}|\d{5}\s?-?\d{4})$/;
const today = /* @__PURE__ */ new Date();
const minDob = subYears(today, 150);
const dobField = (t2) => yup.date().typeError(t2("form.validation.fieldIsInvalid")).min(minDob, t2("form.validation.fieldIsInvalid")).max(today, t2("form.validation.fieldIsInvalid")).required(t2("form.validation.dobRequired"));
const sexField = (t2) => yup.string().ensure().oneOf(["M", "F"], t2("form.validation.fieldIsInvalid")).required(t2("form.validation.fieldIsRequired"));
const zipCodeField = (t2) => yup.string().ensure().required(t2("form.validation.zipCodeRequired")).matches(zipCodePattern, t2("form.validation.zipCodeInvalid"));
const uploadToFileIO = async (client, file, options = {}) => {
  const { progressSubject, abortSignal } = options || {};
  const onUploadProgress = !isUndefined(progressSubject) ? (progressEvent) => {
    const percentCompleted = Math.round(
      progressEvent.loaded * 100 / (progressEvent.total ?? 100)
    );
    progressSubject.next(percentCompleted);
  } : void 0;
  const formData = new FormData();
  formData.append("file", file);
  const response = await client.post("https://file.io", formData, {
    headers: {
      "Content-Type": file.type
    },
    signal: abortSignal,
    onUploadProgress
  });
  return response.data.link;
};
const getFileExtension = (fileName) => {
  return last(fileName.split("."));
};
const generatePreSignedURL = (client, endpoint, data) => {
  return client.put(endpoint, data);
};
const handleFileUploadToURL = async (client, file, presignedUrl, options = {}) => {
  const { abortSignal, progressSubject } = options;
  const onUploadProgress = !isUndefined(progressSubject) ? (progressEvent) => {
    const percentCompleted = Math.round(
      progressEvent.loaded * 100 / (progressEvent.total ?? 100)
    );
    progressSubject.next(percentCompleted);
  } : void 0;
  await client.put(presignedUrl, file, {
    headers: {
      "Content-Type": file.type
    },
    signal: abortSignal,
    onUploadProgress
  });
  return presignedUrl;
};
const createPresignedUploadService = ({
  uploadClient,
  urlGenerationClient,
  urlGenerationEndpoint
}) => {
  return async (file, options) => {
    const urls = await generatePreSignedURL(urlGenerationClient, urlGenerationEndpoint, {
      files: [
        {
          fileExtension: getFileExtension(file.name) ?? "",
          fileName: file.name,
          mime: file.type
        }
      ]
    });
    const uploadURL = urls[0];
    if (!uploadURL) throw new Error("Unexpected error");
    await handleFileUploadToURL(uploadClient, file, uploadURL.url, options);
    return uploadURL.id;
  };
};
export {
  AbbreviationButton,
  AccentedHeading,
  Accordion,
  AccordionItem,
  AddressSection,
  AppLayout,
  BaseChipGroup,
  BaseRadioChip,
  Button,
  Callout,
  Card,
  Checkbox,
  CheckboxGroup,
  Chip$1 as Chip,
  ChipIcon,
  ChipLabel,
  ChipMultiSelect,
  CueLogo,
  DateInput,
  DateRadioChipGroup,
  Dialog,
  DropdownMenu,
  ExpressableLogo,
  FieldErrors,
  FieldHints,
  FieldLabel,
  FileLink,
  FilePicker,
  FileStatus,
  FileUploader,
  FileViewer,
  FilterableSelect,
  FormCard,
  FormEditButton,
  FormField,
  FormLayout,
  FormLayoutProvider,
  FormPageLayout,
  FullTailwindConfig,
  GridFieldGroup,
  Heading,
  Link,
  LoadingDots,
  LoadingSpinner,
  MarkdownText,
  MaskedInput,
  MultiFormProvider,
  MultiSelect,
  NavBar,
  NavButton,
  PageContainer,
  PageSidebarLayout,
  Paragraph,
  PasswordInput,
  PhoneNumberInput,
  ProgressBar,
  RadioChip,
  RadioChipGroup,
  RadioCircle,
  RadioGroup,
  Reservation,
  ReservationCard,
  ResourceCard,
  RichText,
  ScrollableContainer,
  Select,
  SplitButton,
  StableSizeText,
  SubmitButton,
  SyntaxIcon,
  TEST_IDS_CONFIG$i as TEST_IDS_CONFIG,
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Tabs,
  Text,
  TextArea,
  TextInput,
  Toast,
  ToastProvider,
  TwoPanelsPageLayout,
  ViewModeText,
  _twoPanelPageLayoutVariants,
  createPresignedUploadService,
  dobField,
  fileUploaderValidationSchema,
  formPageLayoutVariants,
  generatePreSignedURL,
  handleFileUploadToURL,
  iconSizeClasses,
  isUploadComplete,
  navBarVariants,
  navButtonVariants,
  sexField,
  uploadToFileIO,
  uploadedFileSchema,
  useDialog,
  useFileUploads,
  useFormLayoutContext,
  useMultiFormContext,
  useMultiFormState,
  useToast,
  useTypeAhead,
  useViewport,
  zipCodeField
};
